const mainBanners = [
  {
    id: 9006,
    name: '믹스앤매치 x 벨리곰\n최대 78% 특가',
    firstImageUrl: 'https://st.kakaocdn.net/thumb/C750x300/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fhome%2Fmain_top_banner%2F20230421113256_d650ff4f03344f2f8f62362879523e7c.png',
    landingType: 'URL',
    landingUrl: 'https://store.kakao.com/promotion/1545?ad=0424_sales&area=br',
    remainSeconds: 106693,
    mainCopy: '믹스앤매치 x 벨리곰\n최대 78% 특가',
    subCopy: '침구/발매트/패브릭포스터 외',
    copyExpose: true,
    subCopyColor: '#6C3841',
    mainCopyColor: '#FFFFFF',
    pcImageUrl: 'https://st.kakaocdn.net/thumb/C1920x300/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fhome%2Fmain_top_banner_pc%2F20230421113300_edc47df947c14ce093090ae1bf14d713.png',
    displayPeriod: { from: '20230424170000', to: '20230427235959' },
  },
  {
    id: 9081,
    name: '삼성전자 베스트만!\n브랜드세일 ~54%',
    firstImageUrl: 'https://st.kakaocdn.net/thumb/C750x300/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fhome%2Fmain_top_banner%2F20230426112257_138215b4a9de4c3e845e66c2744eabdb.png',
    landingType: 'URL',
    landingUrl: 'https://store.kakao.com/promotion/1553?ad=0426_samsung_dealbanner&area=br',
    remainSeconds: 279493,
    mainCopy: '삼성전자 베스트만!\n브랜드세일 ~54%',
    subCopy: '카카오페이 카드 7% 할인',
    copyExpose: true,
    subCopyColor: '#2B3F59',
    mainCopyColor: '#FFFFFF',
    pcImageUrl: 'https://st.kakaocdn.net/thumb/C1920x300/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fhome%2Fmain_top_banner_pc%2F20230426112300_9bf5a1a2d7834af0a8b9fd124bbcbe56.png',
    displayPeriod: { from: '20230426170000', to: '20230429235959' },
  },
  {
    id: 9027,
    name: '동남아부터 일본까지!\n인터파크투어 특가',
    firstImageUrl: 'https://st.kakaocdn.net/thumb/C750x300/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fhome%2Fmain_top_banner%2F20230424133007_a576055fe2a94441baa8908c6b9b4b02.png',
    landingType: 'URL',
    landingUrl: 'https://store.kakao.com/home/brand?ad=0426_brd&area=br',
    remainSeconds: 81493,
    mainCopy: '동남아부터 일본까지!\n인터파크투어 특가',
    subCopy: '홋카이도/보라카이/다낭 외',
    copyExpose: true,
    subCopyColor: '#353258',
    mainCopyColor: '#FFFFFF',
    pcImageUrl: 'https://st.kakaocdn.net/thumb/C1920x300/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fhome%2Fmain_top_banner_pc%2F20230424133011_270c12f188284aa6a2c9c25d749dd407.png',
    displayPeriod: { from: '20230426170000', to: '20230427165959' },
  },
  {
    id: 8947,
    name: '알뜰 장바구니\n오늘출발 상품 특집!',
    firstImageUrl: 'https://st.kakaocdn.net/thumb/C750x300/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fhome%2Fmain_top_banner%2F20230418164831_f0cd231ccf6a4029b39c40d8ebc79fdc.png',
    landingType: 'URL',
    landingUrl: 'https://store.kakao.com/promotion/1547?area=br',
    remainSeconds: 193093,
    mainCopy: '알뜰 장바구니\n오늘출발 상품 특집!',
    subCopy: '10% 할인 쿠폰까지!',
    copyExpose: true,
    subCopyColor: '#683C2F',
    mainCopyColor: '#FFFFFF',
    pcImageUrl: 'https://st.kakaocdn.net/thumb/C1920x300/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fhome%2Fmain_top_banner_pc%2F20230418164837_9d69a029157043ccac82ac9e5a7465f8.png',
    displayPeriod: { from: '20230425170000', to: '20230428235959' },
  },
  {
    id: 9028,
    name: '조명으로 분위기 변신!\n무드등 특가전',
    firstImageUrl: 'https://st.kakaocdn.net/thumb/C750x300/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fhome%2Fmain_top_banner%2F20230424134042_d8b47103df9441e18056040080f6ac11.png',
    landingType: 'URL',
    landingUrl: 'https://store.kakao.com/promotion/1552?ad=0425_sales&area=br',
    remainSeconds: 193093,
    mainCopy: '조명으로 분위기 변신!\n무드등 특가전',
    subCopy: '스탠드/센서등 외 ~80%',
    copyExpose: true,
    subCopyColor: '#2D5243',
    mainCopyColor: '#FFFFFF',
    pcImageUrl: 'https://st.kakaocdn.net/thumb/C1920x300/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fhome%2Fmain_top_banner_pc%2F20230424134044_eb50dc3edd4b4ed4855e0edad9c143bb.png',
    displayPeriod: { from: '20230425170000', to: '20230428235959' },
  },
];

const categoryGroups = {
  data: [
    {
      groupId: 10,
      name: '패션',
      sortOrder: 1,
      icon: 'ico_fashion',
      categories: [
        { categoryId: '101102', name: '여성의류', level: 1, sortOrder: 1 },
        { categoryId: '101104', name: '남성의류', level: 1, sortOrder: 2 },
        { categoryId: '101111', name: '언더웨어', level: 1, sortOrder: 3 },
        { categoryId: '101100', name: '신발/수제화', level: 1, sortOrder: 4 },
        { categoryId: '101109', name: '가방/지갑/잡화', level: 1, sortOrder: 5 },
        { categoryId: '101101', name: '쥬얼리/시계/액세서리', level: 1, sortOrder: 6 },
        { categoryId: '101114', name: '테마의류/잡화', level: 1, sortOrder: 7 },
      ],
    },
    {
      groupId: 2,
      name: '뷰티',
      sortOrder: 2,
      icon: 'ico_beauty',
      categories: [
        { categoryId: '101107', name: '스킨케어/메이크업', level: 1, sortOrder: 1 },
        { categoryId: '101103', name: '향수/바디/헤어', level: 1, sortOrder: 2 },
      ],
    },
    {
      groupId: 3,
      name: '식품',
      sortOrder: 3,
      icon: 'ico_food',
      categories: [
        { categoryId: '102104', name: '쌀/과일/농축수산물', level: 1, sortOrder: 1 },
        { categoryId: '102100', name: '가공식품', level: 1, sortOrder: 2 },
        { categoryId: '102109', name: '과자/빵/떡', level: 1, sortOrder: 3 },
        { categoryId: '102101', name: '음료/생수/커피', level: 1, sortOrder: 4 },
        { categoryId: '102105', name: '홍삼/건강/다이어트식품', level: 1, sortOrder: 5 },
      ],
    },
    {
      groupId: 8,
      name: '스포츠/레저',
      sortOrder: 4,
      icon: 'ico_sports',
      categories: [
        { categoryId: '101108', name: '스포츠의류/운동화/잡화', level: 1, sortOrder: 1 },
        { categoryId: '103103', name: '등산/캠핑/낚시', level: 1, sortOrder: 2 },
        { categoryId: '103102', name: '구기/헬스/수영/스키', level: 1, sortOrder: 3 },
        { categoryId: '103105', name: '골프클럽/의류/용품', level: 1, sortOrder: 4 },
        { categoryId: '103106', name: '자전거/인라인/모터사이클', level: 1, sortOrder: 5 },
      ],
    },
    {
      groupId: 9,
      name: '생활',
      sortOrder: 5,
      icon: 'ico_life',
      categories: [
        { categoryId: '104106', name: '생활/제지/잡화', level: 1, sortOrder: 1 },
        { categoryId: '104103', name: '욕실/청소/세제', level: 1, sortOrder: 2 },
        { categoryId: '104109', name: '주방/식기/용기', level: 1, sortOrder: 3 },
        { categoryId: '104111', name: '건강관리/실버용품', level: 1, sortOrder: 4 },
        { categoryId: '104113', name: '반려동물/애완용품', level: 1, sortOrder: 5 },
        { categoryId: '104105', name: '악기/취미/만들기', level: 1, sortOrder: 6 },
        { categoryId: '104110', name: '문구/사무/용지', level: 1, sortOrder: 7 },
        { categoryId: '104100', name: '산업/공구/안전용품', level: 1, sortOrder: 8 },
        { categoryId: '103101', name: '자동차용품', level: 1, sortOrder: 9 },
        { categoryId: '103111', name: '도서/음반/DVD', level: 1, sortOrder: 10 },
      ],
    },
    {
      groupId: 5,
      name: '디지털/가전',
      sortOrder: 6,
      icon: 'ico_digital',
      categories: [
        { categoryId: '100107', name: '휴대폰/액세서리', level: 1, sortOrder: 1 },
        { categoryId: '100106', name: '영상가전/TV/홈시어터', level: 1, sortOrder: 2 },
        { categoryId: '100108', name: '카메라/캠코더/주변기기', level: 1, sortOrder: 3 },
        { categoryId: '100111', name: '게임/주변기기', level: 1, sortOrder: 4 },
        { categoryId: '100102', name: '음향가전/스피커/학습기기', level: 1, sortOrder: 5 },
        { categoryId: '100105', name: '노트북/태블릿PC', level: 1, sortOrder: 6 },
        { categoryId: '100101', name: '데스크탑/모니터/PC부품', level: 1, sortOrder: 7 },
        { categoryId: '100100', name: '프린터/PC주변/사무기기', level: 1, sortOrder: 8 },
        { categoryId: '100109', name: '계절가전/에어컨/온열기기', level: 1, sortOrder: 9 },
        { categoryId: '100110', name: '주방가전/냉장고/전기밥솥', level: 1, sortOrder: 10 },
        { categoryId: '100103', name: '생활가전/세탁기/청소기', level: 1, sortOrder: 11 },
        { categoryId: '100104', name: '이미용/건강/욕실가전', level: 1, sortOrder: 12 },
        { categoryId: '103100', name: '내비/블랙박스/하이패스', level: 1, sortOrder: 13 },
      ],
    },
    {
      groupId: 4,
      name: '인테리어',
      sortOrder: 7,
      icon: 'ico_interior',
      categories: [
        { categoryId: '104101', name: '수납/정리/선반', level: 1, sortOrder: 1 },
        { categoryId: '104102', name: '홈/인테리어/가드닝', level: 1, sortOrder: 2 },
        { categoryId: '104104', name: '거실/주방가구', level: 1, sortOrder: 3 },
        { categoryId: '104108', name: '침구/커튼/카페트', level: 1, sortOrder: 4 },
        { categoryId: '104112', name: '침실가구', level: 1, sortOrder: 5 },
        { categoryId: '104107', name: '홈오피스/키즈가구', level: 1, sortOrder: 6 },
      ],
    },
    {
      groupId: 6,
      name: '출산/유아동',
      sortOrder: 8,
      icon: 'ico_kids',
      categories: [
        { categoryId: '102108', name: '유아동의류/신발/가방', level: 1, sortOrder: 1 },
        { categoryId: '102107', name: '분유/기저귀', level: 1, sortOrder: 2 },
        { categoryId: '102102', name: '출산/유아용품/임부복', level: 1, sortOrder: 3 },
        { categoryId: '102106', name: '완구/교육/교구', level: 1, sortOrder: 4 },
      ],
    },
    {
      groupId: 12,
      name: '여행/e쿠폰',
      sortOrder: 9,
      icon: 'ico_trip',
      categories: [
        { categoryId: '103113', name: '국내여행', level: 1, sortOrder: 1 },
        { categoryId: '103114', name: '해외여행', level: 1, sortOrder: 2 },
        { categoryId: '103107', name: '상품권/e쿠폰/서비스', level: 1, sortOrder: 3 },
        { categoryId: '103108', name: '공연/전시/티켓', level: 1, sortOrder: 4 },
      ],
    },
  ],
};

const productOptions = {
  237319333: {
    type: 'COMBINATION',
    names: ['옵션'],
    options: [{ id: 578169991, name: '옵션', value: '청국장 150g x 4팩', stock: 98000, addPrice: 0, level: 0, images: [], options: [] }],
    customs: [],
  },
  67210447: {
    type: 'COMBINATION',
    names: ['선택'],
    options: [
      { id: 432491101, name: '선택', value: '01.허닭추천 혼합 패키지 21팩', stock: 8845, addPrice: 0, level: 0, images: [], options: [] },
      { id: 432491102, name: '선택', value: '02.스테이크+함박 혼합 18팩', stock: 9787, addPrice: 0, level: 0, images: [], options: [] },
      { id: 432491103, name: '선택', value: '03.스팀 닭가슴살 혼합 16팩', stock: 9655, addPrice: 0, level: 0, images: [], options: [] },
      { id: 432491104, name: '선택', value: '04.간식 소시지+핫바 혼합 24팩', stock: 9809, addPrice: 0, level: 0, images: [], options: [] },
      { id: 432491105, name: '선택', value: '05.구운 주먹밥 혼합 20팩', stock: 9936, addPrice: 0, level: 0, images: [], options: [] },
      { id: 516264031, name: '선택', value: '06.속보이는 닭가슴살 만두 혼합 12팩', stock: 9971, addPrice: 0, level: 0, images: [], options: [] },
    ],
    customs: [],
  },
  240879562: {
    type: 'COMBINATION',
    names: ['수량선택'],
    options: [
      { id: 586933133, name: '수량선택', value: '1. 통삼겹 김치찜 X 2팩', stock: 5130, addPrice: 0, level: 0, images: [], options: [] },
      { id: 586933134, name: '수량선택', value: '2. 통삼겹 김치찜 X 4팩', stock: 7869, addPrice: 10000, level: 0, images: [], options: [] },
    ],
    customs: [],
  },
  119114007: {
    type: 'COMBINATION',
    names: ['옵션선택'],
    options: [
      { id: 286601300, name: '옵션선택', value: '01_맑고진한 하동관곰탕 600g 5팩', stock: 1953, addPrice: 0, level: 0, images: [], options: [] },
      { id: 529893903, name: '옵션선택', value: '02_맑고진한 하동관곰탕 600g 8팩', stock: 854, addPrice: 16000, level: 0, images: [], options: [] },
      { id: 537302586, name: '옵션선택', value: '03_맑고진한 하동관곰탕 600g 3팩', stock: 338, addPrice: -9000, level: 0, images: [], options: [] },
      { id: 593566810, name: '옵션선택', value: '04_하동관 한우암소곰탕 600g 3팩', stock: 244, addPrice: -8000, level: 0, images: [], options: [] },
      { id: 593566811, name: '옵션선택', value: '05_하동관 한우암소곰탕 600g 5팩', stock: 98, addPrice: 2000, level: 0, images: [], options: [] },
      { id: 595645591, name: '옵션선택', value: '06_하동관 한우암소곰탕 600g 8팩', stock: 383, addPrice: 18000, level: 0, images: [], options: [] },
    ],
    customs: [],
  },
  177036828: {
    type: 'COMBINATION',
    names: ['선택'],
    options: [
      {
        id: 593826436,
        name: '선택',
        value: '01.안먹은걸로 1박스(5gX30포(15일)',
        stock: 4641,
        addPrice: 0,
        level: 0,
        images: ['https://st.kakaocdn.net/shoppingstore/option/20230601164456_4141b7f320d94c15a761c029e7917369.jpg'],
        options: [],
      },
      {
        id: 593826437,
        name: '선택',
        value: '02.안먹은걸로 4박스(5gX120포(60일)',
        stock: 3469,
        addPrice: 24800,
        level: 0,
        images: ['https://st.kakaocdn.net/shoppingstore/option/20230601164508_dc64d9907ba443c394cb908097cd2732.jpg'],
        options: [],
      },
      {
        id: 593826438,
        name: '선택',
        value: '03.쓱 1박스(10gX15포/15일)',
        stock: 4922,
        addPrice: -5900,
        level: 0,
        images: ['https://st.kakaocdn.net/shoppingstore/option/20230601164525_3146fb2bd85b46b2beb53d30eb7d023d.jpg'],
        options: [],
      },
      {
        id: 593826439,
        name: '선택',
        value: '04. 쓱 4박스(10gX15포/60일)',
        stock: 4823,
        addPrice: 13600,
        level: 0,
        images: ['https://st.kakaocdn.net/shoppingstore/option/20230601170423_f345bd919c14458c8bad28be566119ea.jpg'],
        options: [],
      },
      {
        id: 593826440,
        name: '선택',
        value: '05.안먹은걸로1박스(15일+쓱1박스(15일)',
        stock: 4812,
        addPrice: 5100,
        level: 0,
        images: ['https://st.kakaocdn.net/shoppingstore/option/20230601164807_ada13945343c4420b45e1d4f546eda45.jpg'],
        options: [],
      },
      {
        id: 593826441,
        name: '선택',
        value: '06.안먹은걸로4박스(75일)+쓱4박스(75일',
        stock: 4709,
        addPrice: 51800,
        level: 0,
        images: ['https://st.kakaocdn.net/shoppingstore/option/20230601164748_648d37d9beaa4be2a3333cccdac2ecdc.jpg'],
        options: [],
      },
    ],
    customs: [],
  },
  58175263: {
    type: 'COMBINATION',
    names: ['CJ'],
    options: [
      {
        id: 121702087,
        name: 'CJ',
        value: '고등어 60Gx3개+삼치 60Gx2개',
        stock: 4756,
        addPrice: 0,
        level: 0,
        images: ['https://st.kakaocdn.net/shoppingstore/option/20221205151415_8238d254839e4965a554e743dffca825.jpg'],
        options: [],
      },
      {
        id: 121702088,
        name: 'CJ',
        value: '고등어 60Gx3개+임연수 60Gx2개',
        stock: 4872,
        addPrice: 0,
        level: 0,
        images: ['https://st.kakaocdn.net/shoppingstore/option/20221205151419_36daf451e88c494d9cc725e9ffb0b40e.jpg'],
        options: [],
      },
      {
        id: 433964341,
        name: 'CJ',
        value: '고등어 60Gx3개+가자미 70Gx2개',
        stock: 4817,
        addPrice: 0,
        level: 0,
        images: ['https://st.kakaocdn.net/shoppingstore/option/20221205151424_b33950d204ec46ed947e10dfe537c27c.jpg'],
        options: [],
      },
      {
        id: 433964342,
        name: 'CJ',
        value: '삼치 60Gx3개+임연수 60Gx2개',
        stock: 4879,
        addPrice: 0,
        level: 0,
        images: ['https://st.kakaocdn.net/shoppingstore/option/20221205151428_5aec52cc4b6f49759d2bb3dae03f8579.jpg'],
        options: [],
      },
      {
        id: 433964343,
        name: 'CJ',
        value: '삼치 60Gx3개+가자미 70Gx2개',
        stock: 4909,
        addPrice: 0,
        level: 0,
        images: ['https://st.kakaocdn.net/shoppingstore/option/20221205151433_24443753e8044463bddf8a1c5bf13d8d.jpg'],
        options: [],
      },
      {
        id: 121702091,
        name: 'CJ',
        value: '고등어 60Gx3개+갈치 70Gx2개',
        stock: 333,
        addPrice: 1600,
        level: 0,
        images: ['https://st.kakaocdn.net/shoppingstore/option/20221205151438_3f5792557a1b41f6b202649f06c5054b.jpg'],
        options: [],
      },
      {
        id: 121702090,
        name: 'CJ',
        value: '삼치 60Gx3개+갈치 70Gx2개',
        stock: 453,
        addPrice: 1600,
        level: 0,
        images: ['https://st.kakaocdn.net/shoppingstore/option/20221205151444_bda9edd82058484db246ffc8e45278d7.jpg'],
        options: [],
      },
      {
        id: 189111589,
        name: 'CJ',
        value: '(순살)고등어구이 60Gx5개',
        stock: 84,
        addPrice: 600,
        level: 0,
        images: ['https://st.kakaocdn.net/shoppingstore/option/20221205151449_54553eb389ec4cb9a887235f4a490bcb.jpg'],
        options: [],
      },
      {
        id: 393259534,
        name: 'CJ',
        value: '(순살)삼치구이 60Gx5개',
        stock: 403,
        addPrice: 600,
        level: 0,
        images: ['https://st.kakaocdn.net/shoppingstore/option/20221205151453_4367be591c134b6aa82d8348865fafe6.jpg'],
        options: [],
      },
      {
        id: 393259535,
        name: 'CJ',
        value: '(순살)고등어 60Gx2개+삼치 60Gx3개',
        stock: 356,
        addPrice: 600,
        level: 0,
        images: ['https://st.kakaocdn.net/shoppingstore/option/20221205151457_8d01978b161f44468144dd51184c9837.jpg'],
        options: [],
      },
      {
        id: 393259536,
        name: 'CJ',
        value: '고등어구이 60Gx5개',
        stock: 426,
        addPrice: 0,
        level: 0,
        images: ['https://st.kakaocdn.net/shoppingstore/option/20221205151501_75f9e3b82e1f4b72887b2d316e657bb9.jpg'],
        options: [],
      },
      {
        id: 393259537,
        name: 'CJ',
        value: '삼치구이 60Gx5개',
        stock: 478,
        addPrice: 0,
        level: 0,
        images: ['https://st.kakaocdn.net/shoppingstore/option/20221205151504_26bff83d1dc2456a99107bb8474c923f.jpg'],
        options: [],
      },
      {
        id: 393259538,
        name: 'CJ',
        value: '임연수구이 60Gx5개',
        stock: 455,
        addPrice: 0,
        level: 0,
        images: ['https://st.kakaocdn.net/shoppingstore/option/20221205151509_7f869078ff9f42a3a598a91c8d8ffc99.jpg'],
        options: [],
      },
      {
        id: 433964344,
        name: 'CJ',
        value: '가자미구이 70Gx5개',
        stock: 420,
        addPrice: 0,
        level: 0,
        images: ['https://st.kakaocdn.net/shoppingstore/option/20221205151512_5156eaebd19049048bc2e6e19e891b68.jpg'],
        options: [],
      },
      {
        id: 393259540,
        name: 'CJ',
        value: '갈치구이 70Gx5개',
        stock: 416,
        addPrice: 4100,
        level: 0,
        images: ['https://st.kakaocdn.net/shoppingstore/option/20230425100111_3f4151d6185c4c2ea25ad058efb3af32.jpg'],
        options: [],
      },
      {
        id: 393259541,
        name: 'CJ',
        value: '한마리고등어140Gx2개+삼치3',
        stock: 486,
        addPrice: 5200,
        level: 0,
        images: ['https://st.kakaocdn.net/shoppingstore/option/20230425100117_821a6bc60fc345bf86e8760cf0c5e6d7.jpg'],
        options: [],
      },
      {
        id: 452652458,
        name: 'CJ',
        value: '한마리고등어140Gx2개+임연수3',
        stock: 482,
        addPrice: 5200,
        level: 0,
        images: ['https://st.kakaocdn.net/shoppingstore/option/20230425100124_c5c6526e17854632adef9a846e3ab58a.jpg'],
        options: [],
      },
      {
        id: 452652459,
        name: 'CJ',
        value: '한마리고등어140Gx2개+가자미3',
        stock: 478,
        addPrice: 5200,
        level: 0,
        images: ['https://st.kakaocdn.net/shoppingstore/option/20230425100130_5a9a1c5f16b04ee8a015ae1daf83681f.jpg'],
        options: [],
      },
      {
        id: 452652460,
        name: 'CJ',
        value: '한마리고등어140Gx2개+갈치3',
        stock: 471,
        addPrice: 8200,
        level: 0,
        images: ['https://st.kakaocdn.net/shoppingstore/option/20230425100138_ab613e7c542a40ae918dc52a9d5c7991.jpg'],
        options: [],
      },
      {
        id: 452652461,
        name: 'CJ',
        value: '한마리고등어1+가자미1+삼치1+임연수1+갈치1',
        stock: 371,
        addPrice: 3000,
        level: 0,
        images: ['https://st.kakaocdn.net/shoppingstore/option/20221205151538_085c1b2eb3054ffeb65fd26e90cfd8a6.jpg'],
        options: [],
      },
      {
        id: 452652462,
        name: 'CJ',
        value: '(임박특가-6/15까지)순살삼치60Gx6개',
        stock: 180,
        addPrice: 100,
        level: 0,
        images: ['https://st.kakaocdn.net/shoppingstore/option/20230601113610_e252b0cc2baa488c9489b37b37acedaa.jpg'],
        options: [],
      },
    ],
    customs: [],
  },
  213097302: {
    type: 'COMBINATION',
    names: ['선택'],
    options: [
      { id: 515208751, name: '선택', value: '(냉장) FreshUP 닭볶음용 600g*4', stock: 3986, addPrice: 0, level: 0, images: [], options: [] },
      { id: 515208752, name: '선택', value: '(냉장) FreshUP 닭근위 500g*4', stock: 4791, addPrice: -2400, level: 0, images: [], options: [] },
      { id: 515208753, name: '선택', value: '(냉장) FreshUP 닭가슴살 500g*3', stock: 4960, addPrice: 1600, level: 0, images: [], options: [] },
      { id: 515208754, name: '선택', value: '(냉장) FreshUP 닭다리살 500g*3', stock: 4870, addPrice: 6600, level: 0, images: [], options: [] },
      { id: 592502714, name: '선택', value: '(냉동) IFF 닭다리(북채) 1kg*2', stock: 4911, addPrice: 1000, level: 0, images: [], options: [] },
      { id: 592502715, name: '선택', value: '(냉동) 무항생제 IFF 닭가슴살 1kg*2', stock: 4965, addPrice: 4100, level: 0, images: [], options: [] },
      { id: 592502716, name: '선택', value: '(냉동) IFF 닭 윙 1kg*2', stock: 83, addPrice: 6100, level: 0, images: [], options: [] },
      { id: 592502717, name: '선택', value: '(냉동) IFF 닭 봉 1kg*2', stock: 4963, addPrice: 4100, level: 0, images: [], options: [] },
      { id: 592502718, name: '선택', value: '(냉동) IFF 닭 안심 1kg*2', stock: 4978, addPrice: 2000, level: 0, images: [], options: [] },
      { id: 624077384, name: '선택', value: '(냉동) IFF 핑크솔트한입닭가슴살 1.1kg', stock: 4996, addPrice: -1000, level: 0, images: [], options: [] },
    ],
    customs: [],
  },
  219911677: {
    type: 'COMBINATION',
    names: ['옵션'],
    options: [{ id: 533018516, name: '옵션', value: '베트남쌀국수 30팩', stock: 97877, addPrice: 0, level: 0, images: [], options: [] }],
    customs: [],
  },
  135379379: {
    type: 'COMBINATION',
    names: ['구성'],
    options: [
      {
        id: 445512485,
        name: '구성',
        value: '스팀청소기 BSM-800WH',
        stock: 1909,
        addPrice: 0,
        level: 0,
        images: ['https://st.kakaocdn.net/shoppingstore/option/20220923121702_1d5ca20203cf4963ad100e96214cbe12.jpeg'],
        options: [],
      },
    ],
    customs: [],
  },
  227445595: {
    type: 'COMBINATION',
    names: ['선택'],
    options: [
      { id: 635109379, name: '선택', value: 'L10s Ultra', stock: 500, addPrice: 0, level: 0, images: [], options: [] },
      { id: 635109380, name: '선택', value: 'W10 Pro', stock: 500, addPrice: -400000, level: 0, images: [], options: [] },
    ],
    customs: [],
  },
  224152000: {
    type: 'COMBINATION',
    names: ['선택'],
    options: [
      { id: 584364307, name: '선택', value: '홈채움 양념LA갈비500g*2팩(1kg)', stock: 1847, addPrice: 0, level: 0, images: [], options: [] },
      { id: 584364308, name: '선택', value: '홈채움 양념LA갈비500g*3팩(1.5kg)', stock: 749, addPrice: 11000, level: 0, images: [], options: [] },
    ],
    customs: [],
  },
  65276142: {
    type: 'COMBINATION',
    names: ['옵션선택'],
    options: [
      {
        id: 353552957,
        name: '옵션선택',
        value: '00. 구운주먹밥 5종 3봉씩 15개',
        stock: 8270,
        addPrice: 0,
        level: 0,
        images: [
          'https://st.kakaocdn.net/shoppingstore/option/20230412094508_ac4ff6bb6d024fa38d46170db469aa8b.jpg',
          'https://st.kakaocdn.net/shoppingstore/option_detail/20230412095759_33e5c082b32c4f79a3660556580ad822.jpg',
          'https://st.kakaocdn.net/shoppingstore/option_detail/20230412095918_92a0de991370463cac7341f333bac044.jpg',
        ],
        options: [],
      },
      {
        id: 353552958,
        name: '옵션선택',
        value: '01. 참치마요 주먹밥 15개',
        stock: 9027,
        addPrice: 0,
        level: 0,
        images: [
          'https://st.kakaocdn.net/shoppingstore/option/20221107134744_28cd92ef297845e18ece30a92b53cfb1.jpg',
          'https://st.kakaocdn.net/shoppingstore/option_detail/20221107142150_19849ced20814ab3b4e5175fbad18b00.jpg',
          'https://st.kakaocdn.net/shoppingstore/option_detail/20221107142157_9b9891fc3a804c488168e6ecc82ab56d.jpg',
          'https://st.kakaocdn.net/shoppingstore/option_detail/20221107142919_12de551741dd43f0907e3ea3b791649a.jpg',
        ],
        options: [],
      },
      {
        id: 353552959,
        name: '옵션선택',
        value: '02. 소불고기 주먹밥 15개',
        stock: 9084,
        addPrice: 0,
        level: 0,
        images: [
          'https://st.kakaocdn.net/shoppingstore/option/20221107134751_55ff360dade24375b3d64a86a96204f2.jpg',
          'https://st.kakaocdn.net/shoppingstore/option_detail/20221107142226_c1e3ef20db7f487bbe0de3923c0ae0b8.jpg',
          'https://st.kakaocdn.net/shoppingstore/option_detail/20221107142213_094026b2284e4e468b1a0d26ba359475.jpg',
          'https://st.kakaocdn.net/shoppingstore/option_detail/20221107142927_08a6b2c5ff0c4ddbb10517d2f8fcb6ff.jpg',
        ],
        options: [],
      },
      {
        id: 353552960,
        name: '옵션선택',
        value: '03. 치즈닭갈비 주먹밥 15개',
        stock: 9299,
        addPrice: 0,
        level: 0,
        images: [
          'https://st.kakaocdn.net/shoppingstore/option/20221107134756_1fceb08eac504b89b1a8e34d6c9a0d34.jpg',
          'https://st.kakaocdn.net/shoppingstore/option_detail/20221107142824_6b7f4980bec7463583db095565e0e29b.jpg',
          'https://st.kakaocdn.net/shoppingstore/option_detail/20221107142839_67fbd21d8a5d464fb6ec71d9d40bcf06.jpg',
          'https://st.kakaocdn.net/shoppingstore/option_detail/20221107142952_277783beeb4545d4800f6af0e716828d.jpg',
        ],
        options: [],
      },
      {
        id: 353552961,
        name: '옵션선택',
        value: '04. 참치김치 주먹밥 15개',
        stock: 9249,
        addPrice: 0,
        level: 0,
        images: [
          'https://st.kakaocdn.net/shoppingstore/option/20221107134801_25147be1b4f34cdba1cdc3029eac0dd3.jpg',
          'https://st.kakaocdn.net/shoppingstore/option_detail/20221107142851_dda708351a6f43f98ef1cd51afff10d3.jpg',
          'https://st.kakaocdn.net/shoppingstore/option_detail/20221107142907_380b543842ff4045830ba544d04b3a3c.jpg',
          'https://st.kakaocdn.net/shoppingstore/option_detail/20221107143001_cd6611b84a464f2aa0e2b9d2dcbf7267.jpg',
        ],
        options: [],
      },
      {
        id: 353552962,
        name: '옵션선택',
        value: '05. 김치치즈 주먹밥 15개',
        stock: 8739,
        addPrice: 0,
        level: 0,
        images: [
          'https://st.kakaocdn.net/shoppingstore/option/20221107134808_e7c09a8bc36d4253a155ee28609c6077.jpg',
          'https://st.kakaocdn.net/shoppingstore/option_detail/20221107143008_74fdd7fda5b94c229e1336b1fed9e927.jpg',
          'https://st.kakaocdn.net/shoppingstore/option_detail/20221107143015_a92bb4b4b581407ca8503d3eae0cb43c.jpg',
          'https://st.kakaocdn.net/shoppingstore/option_detail/20221107143020_9218e60455a24b87a89adf8e908f38e8.jpg',
        ],
        options: [],
      },
      {
        id: 471072928,
        name: '옵션선택',
        value: '06 한돈 통목살 김치찜 (800g 2인분)',
        stock: 9994,
        addPrice: -4000,
        level: 0,
        images: [
          'https://st.kakaocdn.net/shoppingstore/option/20230510114815_9d166bce0a584259b8349f7e4898c11d.jpg',
          'https://st.kakaocdn.net/shoppingstore/option_detail/20230510114854_956140500d9b4b95b539a8d920a721a8.jpg',
          'https://st.kakaocdn.net/shoppingstore/option_detail/20230510114917_17512d0253064e559e9f2bf01ef02084.jpg',
          'https://st.kakaocdn.net/shoppingstore/option_detail/20230510114924_a8e5fb27457c4d0282be1f9649b06a49.jpg',
        ],
        options: [],
      },
      {
        id: 471072929,
        name: '옵션선택',
        value: '07 깊고진한 황태진국 (800g 2인분)',
        stock: 9995,
        addPrice: -6000,
        level: 0,
        images: [
          'https://st.kakaocdn.net/shoppingstore/option/20230510114958_92850a78ad01496ca4a9d2fab965b6c8.jpg',
          'https://st.kakaocdn.net/shoppingstore/option_detail/20230510115031_e8c26e8e57024013992d32d83fd68218.jpg',
          'https://st.kakaocdn.net/shoppingstore/option_detail/20230510115039_7a98ce417f87402582b5f595607bfe23.jpg',
          'https://st.kakaocdn.net/shoppingstore/option_detail/20230510115044_b8e2176665904fee9f99abf00db45c54.jpg',
        ],
        options: [],
      },
      {
        id: 471072931,
        name: '옵션선택',
        value: '08 마시땅 수제핫도그 1팩',
        stock: 763,
        addPrice: -5400,
        level: 0,
        images: [
          'https://st.kakaocdn.net/shoppingstore/option/20221107135249_db7d15fd80c245a28048636958c17dbd.jpg',
          'https://st.kakaocdn.net/shoppingstore/option_detail/20230510113729_24a4c9fed4534d54b45e7f656311eaad.jpg',
          'https://st.kakaocdn.net/shoppingstore/option_detail/20230510114004_d67bf3f7e7d2495dae35d821861d3615.jpg',
          'https://st.kakaocdn.net/shoppingstore/option_detail/20230510113844_c954d81cfdf44a21a92ca6c3480f36bc.jpg',
        ],
        options: [],
      },
      {
        id: 541803633,
        name: '옵션선택',
        value: '09 원조연탄불고기 300g 2팩',
        stock: 9915,
        addPrice: -7000,
        level: 0,
        images: [
          'https://st.kakaocdn.net/shoppingstore/option/20221107135310_5ddc8f9e926c47e1a2f3b2ec9e9a122f.jpg',
          'https://st.kakaocdn.net/shoppingstore/option_detail/20221107155223_04f6a8b90bd041979e052ef3a51da8af.jpg',
          'https://st.kakaocdn.net/shoppingstore/option_detail/20221107155227_330a4e4e887e43bf85c82a56c5a5a7dc.jpg',
          'https://st.kakaocdn.net/shoppingstore/option_detail/20221107155246_6da83a896e8d4533916b73d9d72f2247.jpg',
        ],
        options: [],
      },
      {
        id: 541803634,
        name: '옵션선택',
        value: '10 매운연탄불고기 300g 2팩',
        stock: 9975,
        addPrice: -7000,
        level: 0,
        images: [
          'https://st.kakaocdn.net/shoppingstore/option/20221107135318_58b3f291151941cd9ddeca2bf0f96a8d.jpg',
          'https://st.kakaocdn.net/shoppingstore/option_detail/20221107155232_2b820ae2e6b546fabe597a71c0bd643c.jpg',
          'https://st.kakaocdn.net/shoppingstore/option_detail/20221107155235_de57365cde334307811c1f8f7c27a708.jpg',
          'https://st.kakaocdn.net/shoppingstore/option_detail/20221107155526_0bd7fce023a6403baafba9beea02bd69.jpg',
        ],
        options: [],
      },
      {
        id: 541803635,
        name: '옵션선택',
        value: '11 햄잔뜩들어간 부대찌게 1kg(육수포함)',
        stock: 978,
        addPrice: -5000,
        level: 0,
        images: [
          'https://st.kakaocdn.net/shoppingstore/option/20221107135415_1bd45e9985e346718d3a5c229898810b.jpg',
          'https://st.kakaocdn.net/shoppingstore/option_detail/20221107155550_84c156af7cad4967a303aa3f7d228582.jpg',
          'https://st.kakaocdn.net/shoppingstore/option_detail/20221107155553_1d44fd3ad12e464f9e390570c4075502.jpg',
          'https://st.kakaocdn.net/shoppingstore/option_detail/20221107155558_16ddd28bb35146099cf1836a1bbb9a5e.jpg',
        ],
        options: [],
      },
      {
        id: 541803637,
        name: '옵션선택',
        value: '12 한돈제육덮밥 2팩',
        stock: 9986,
        addPrice: -6400,
        level: 0,
        images: [
          'https://st.kakaocdn.net/shoppingstore/option/20230213141714_73a0c1144a3942c19af1bcfcd36446b5.jpg',
          'https://st.kakaocdn.net/shoppingstore/option_detail/20230213142451_445957efba1b4e08b9a2405b4f2a8b40.jpg',
          'https://st.kakaocdn.net/shoppingstore/option_detail/20230213142703_51df5d6d34f84317b67bdefc61338dda.jpg',
          'https://st.kakaocdn.net/shoppingstore/option_detail/20230213142957_56a4346b15c84af0a440ed504c8cdce3.jpg',
        ],
        options: [],
      },
      {
        id: 541803638,
        name: '옵션선택',
        value: '13 한돈김치볶음덮밥 2팩',
        stock: 9992,
        addPrice: -6400,
        level: 0,
        images: [
          'https://st.kakaocdn.net/shoppingstore/option/20230213141721_aa8824191ac94d49a5201402ea5df731.jpg',
          'https://st.kakaocdn.net/shoppingstore/option_detail/20230213142455_97191ba262aa40e6b3fb509c34550aea.jpg',
          'https://st.kakaocdn.net/shoppingstore/option_detail/20230213142751_07cf649bfb464e8b8f7377f8cd4c840b.jpg',
          'https://st.kakaocdn.net/shoppingstore/option_detail/20230213143000_d017e1dceded4355b08fa68e9a445952.jpg',
        ],
        options: [],
      },
      {
        id: 616129653,
        name: '옵션선택',
        value: '14 안동식 찜닭 덮밥 2팩',
        stock: 9996,
        addPrice: -6400,
        level: 0,
        images: [
          'https://st.kakaocdn.net/shoppingstore/option/20230213142058_599590d0505b41d9a7f0557f3f72ae6f.jpg',
          'https://st.kakaocdn.net/shoppingstore/option_detail/20230213142504_2ad3f3a2efac4f5c8c56db1e88561ea8.jpg',
          'https://st.kakaocdn.net/shoppingstore/option_detail/20230213142827_cebd612c7f774b32ba46071d96ed8dc2.jpg',
          'https://st.kakaocdn.net/shoppingstore/option_detail/20230213143007_ac65b72a04454932888bcbe0a268e60c.jpg',
        ],
        options: [],
      },
      {
        id: 616129654,
        name: '옵션선택',
        value: '15 춘천닭갈비 덮밥 2팩',
        stock: 9995,
        addPrice: -6400,
        level: 0,
        images: [
          'https://st.kakaocdn.net/shoppingstore/option/20230213142101_12e4657a204f4fc3838e8189753d43b5.jpg',
          'https://st.kakaocdn.net/shoppingstore/option_detail/20230213142507_59980edf1f98407892c0bf9208df79b4.jpg',
          'https://st.kakaocdn.net/shoppingstore/option_detail/20230213142839_0a15b440646b42ccb1e6a52929c4a934.jpg',
          'https://st.kakaocdn.net/shoppingstore/option_detail/20230213143010_7215568302754aa29e15e8005a352bc8.jpg',
        ],
        options: [],
      },
    ],
    customs: [],
  },
  247087647: {
    type: 'COMBINATION',
    names: ['색상', '사이즈'],
    options: [
      {
        name: '색상',
        value: '1. 어센틱 UA_VN0A5KRD8DB1',
        level: 0,
        images: [],
        options: [
          { id: 602036432, name: '사이즈', value: '040(220)', stock: 55, addPrice: 0, level: 1, options: [] },
          { id: 602036433, name: '사이즈', value: '045(225)', stock: 47, addPrice: 0, level: 1, options: [] },
          { id: 602036434, name: '사이즈', value: '050(230)', stock: 66, addPrice: 0, level: 1, options: [] },
          { id: 602036435, name: '사이즈', value: '055(235)', stock: 16, addPrice: 0, level: 1, options: [] },
          { id: 602036436, name: '사이즈', value: '060(240)', stock: 7, addPrice: 0, level: 1, options: [] },
          { id: 602036437, name: '사이즈', value: '065(245)', stock: 6, addPrice: 0, level: 1, options: [] },
          { id: 602036438, name: '사이즈', value: '070(250)', stock: 5, addPrice: 0, level: 1, options: [] },
          { id: 602036439, name: '사이즈', value: '075(255)', stock: 17, addPrice: 0, level: 1, options: [] },
          { id: 602036440, name: '사이즈', value: '080(260)', stock: 26, addPrice: 0, level: 1, options: [] },
          { id: 602036441, name: '사이즈', value: '085(265)', stock: 2, addPrice: 0, level: 1, options: [] },
          { id: 602036442, name: '사이즈', value: '090(270)', stock: 1, addPrice: 0, level: 1, options: [] },
          { id: 602036443, name: '사이즈', value: '095(275)', stock: 0, addPrice: 0, level: 1, options: [] },
          { id: 602036444, name: '사이즈', value: '100(280)', stock: 0, addPrice: 0, level: 1, options: [] },
        ],
        minAddPrice: 0,
        maxAddPrice: 0,
        hasSoldOut: true,
        soldOut: false,
      },
      {
        name: '색상',
        value: '2. 에라_VN0A54F14FV1',
        level: 0,
        images: [],
        options: [
          { id: 602036445, name: '사이즈', value: '040(220)', stock: 1, addPrice: -10000, level: 1, options: [] },
          { id: 602036446, name: '사이즈', value: '045(225)', stock: 2, addPrice: -10000, level: 1, options: [] },
          { id: 602036447, name: '사이즈', value: '050(230)', stock: 0, addPrice: -10000, level: 1, options: [] },
          { id: 602036448, name: '사이즈', value: '055(235)', stock: 0, addPrice: -10000, level: 1, options: [] },
          { id: 602036449, name: '사이즈', value: '075(255)', stock: 1, addPrice: -10000, level: 1, options: [] },
          { id: 602036450, name: '사이즈', value: '080(260)', stock: 23, addPrice: -10000, level: 1, options: [] },
          { id: 602036451, name: '사이즈', value: '085(265)', stock: 14, addPrice: -10000, level: 1, options: [] },
          { id: 602036452, name: '사이즈', value: '090(270)', stock: 12, addPrice: -10000, level: 1, options: [] },
          { id: 602036453, name: '사이즈', value: '095(275)', stock: 1, addPrice: -10000, level: 1, options: [] },
          { id: 602036454, name: '사이즈', value: '010(280)', stock: 1, addPrice: -10000, level: 1, options: [] },
        ],
        minAddPrice: -10000,
        maxAddPrice: -10000,
        hasSoldOut: true,
        soldOut: false,
      },
      {
        name: '색상',
        value: '3. 에라_VN0A54F14FW1',
        level: 0,
        images: [],
        options: [
          { id: 602036455, name: '사이즈', value: '040(220)', stock: 0, addPrice: -10000, level: 1, options: [] },
          { id: 602036456, name: '사이즈', value: '045(225)', stock: 0, addPrice: -10000, level: 1, options: [] },
          { id: 602036457, name: '사이즈', value: '050(230)', stock: 0, addPrice: -10000, level: 1, options: [] },
          { id: 602036458, name: '사이즈', value: '070(250)', stock: 0, addPrice: -10000, level: 1, options: [] },
        ],
        hasSoldOut: true,
        soldOut: true,
      },
      {
        name: '색상',
        value: '4. 에라_VN0A54F144B1',
        level: 0,
        images: [],
        options: [
          { id: 602036459, name: '사이즈', value: '040(220)', stock: 0, addPrice: -10000, level: 1, options: [] },
          { id: 602036460, name: '사이즈', value: '045(225)', stock: 0, addPrice: -10000, level: 1, options: [] },
          { id: 602036461, name: '사이즈', value: '080(260)', stock: 0, addPrice: -10000, level: 1, options: [] },
          { id: 602036462, name: '사이즈', value: '085(265)', stock: 8, addPrice: -10000, level: 1, options: [] },
          { id: 602036463, name: '사이즈', value: '090(270)', stock: 12, addPrice: -10000, level: 1, options: [] },
          { id: 602036464, name: '사이즈', value: '095(275)', stock: 0, addPrice: -10000, level: 1, options: [] },
          { id: 602036465, name: '사이즈', value: '010(280)', stock: 0, addPrice: -10000, level: 1, options: [] },
        ],
        minAddPrice: -10000,
        maxAddPrice: -10000,
        hasSoldOut: true,
        soldOut: false,
      },
      {
        name: '색상',
        value: '5. 클래식 슬립온_VN0A33TB44B1',
        level: 0,
        images: [],
        options: [
          { id: 602036466, name: '사이즈', value: '010(280)', stock: 17, addPrice: -7000, level: 1, options: [] },
          { id: 602036467, name: '사이즈', value: '080(260)', stock: 0, addPrice: -7000, level: 1, options: [] },
          { id: 602036468, name: '사이즈', value: '085(265)', stock: 31, addPrice: -7000, level: 1, options: [] },
          { id: 602036469, name: '사이즈', value: '090(270)', stock: 37, addPrice: -7000, level: 1, options: [] },
          { id: 602036470, name: '사이즈', value: '095(275)', stock: 18, addPrice: -7000, level: 1, options: [] },
        ],
        minAddPrice: -7000,
        maxAddPrice: -7000,
        hasSoldOut: true,
        soldOut: false,
      },
      {
        name: '색상',
        value: '6. 클래식 슬립온_VN0A33TB3WJ1',
        level: 0,
        images: [],
        options: [
          { id: 602036471, name: '사이즈', value: '080(260)', stock: 0, addPrice: -7000, level: 1, options: [] },
          { id: 602036472, name: '사이즈', value: '085(265)', stock: 0, addPrice: -7000, level: 1, options: [] },
          { id: 602036473, name: '사이즈', value: '090(270)', stock: 0, addPrice: -7000, level: 1, options: [] },
          { id: 602036474, name: '사이즈', value: '095(275)', stock: 0, addPrice: -7000, level: 1, options: [] },
          { id: 602036475, name: '사이즈', value: '010(280)', stock: 0, addPrice: -7000, level: 1, options: [] },
        ],
        hasSoldOut: true,
        soldOut: true,
      },
      {
        name: '색상',
        value: '7. 클래식 슬립온_VN000XG88MZ1',
        level: 0,
        images: [],
        options: [
          { id: 602036476, name: '사이즈', value: '045(225)', stock: 14, addPrice: 0, level: 1, options: [] },
          { id: 602036477, name: '사이즈', value: '050(230)', stock: 16, addPrice: 0, level: 1, options: [] },
          { id: 602036478, name: '사이즈', value: '055(235)', stock: 15, addPrice: 0, level: 1, options: [] },
          { id: 602036479, name: '사이즈', value: '060(240)', stock: 13, addPrice: 0, level: 1, options: [] },
          { id: 602036480, name: '사이즈', value: '065(245)', stock: 2, addPrice: 0, level: 1, options: [] },
          { id: 602036481, name: '사이즈', value: '070(250)', stock: 16, addPrice: 0, level: 1, options: [] },
          { id: 602036482, name: '사이즈', value: '075(255)', stock: 2, addPrice: 0, level: 1, options: [] },
          { id: 602036483, name: '사이즈', value: '080(260)', stock: 15, addPrice: 0, level: 1, options: [] },
          { id: 602036484, name: '사이즈', value: '085(265)', stock: 15, addPrice: 0, level: 1, options: [] },
          { id: 602036485, name: '사이즈', value: '090(270)', stock: 24, addPrice: 0, level: 1, options: [] },
          { id: 602036486, name: '사이즈', value: '095(275)', stock: 2, addPrice: 0, level: 1, options: [] },
          { id: 602036487, name: '사이즈', value: '100(280)', stock: 16, addPrice: 0, level: 1, options: [] },
          { id: 602036488, name: '사이즈', value: '110(290)', stock: 2, addPrice: 0, level: 1, options: [] },
        ],
        minAddPrice: 0,
        maxAddPrice: 0,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '색상',
        value: '8. 어센틱 믹스_VN0A5KRD8D8',
        level: 0,
        images: [],
        options: [
          { id: 602036489, name: '사이즈', value: '045(225)', stock: 66, addPrice: 0, level: 1, options: [] },
          { id: 602036490, name: '사이즈', value: '050(230)', stock: 69, addPrice: 0, level: 1, options: [] },
          { id: 602036491, name: '사이즈', value: '055(235)', stock: 84, addPrice: 0, level: 1, options: [] },
          { id: 602036492, name: '사이즈', value: '060(240)', stock: 75, addPrice: 0, level: 1, options: [] },
          { id: 602036493, name: '사이즈', value: '065(245)', stock: 59, addPrice: 0, level: 1, options: [] },
          { id: 602036494, name: '사이즈', value: '070(250)', stock: 33, addPrice: 0, level: 1, options: [] },
          { id: 602036495, name: '사이즈', value: '075(255)', stock: 21, addPrice: 0, level: 1, options: [] },
          { id: 602036496, name: '사이즈', value: '080(260)', stock: 66, addPrice: 0, level: 1, options: [] },
          { id: 602036497, name: '사이즈', value: '085(265)', stock: 0, addPrice: 0, level: 1, options: [] },
          { id: 602036498, name: '사이즈', value: '095(275)', stock: 0, addPrice: 0, level: 1, options: [] },
        ],
        minAddPrice: 0,
        maxAddPrice: 0,
        hasSoldOut: true,
        soldOut: false,
      },
      {
        name: '색상',
        value: '9. 어센틱 우븐_VN0A5KXA9GY1',
        level: 0,
        images: [],
        options: [
          { id: 602036499, name: '사이즈', value: '040(220)', stock: 58, addPrice: 2000, level: 1, options: [] },
          { id: 602036500, name: '사이즈', value: '045(225)', stock: 60, addPrice: 2000, level: 1, options: [] },
          { id: 602036501, name: '사이즈', value: '050(230)', stock: 5, addPrice: 2000, level: 1, options: [] },
          { id: 602036502, name: '사이즈', value: '055(235)', stock: 3, addPrice: 2000, level: 1, options: [] },
          { id: 602036503, name: '사이즈', value: '060(240)', stock: 0, addPrice: 2000, level: 1, options: [] },
        ],
        minAddPrice: 2000,
        maxAddPrice: 2000,
        hasSoldOut: true,
        soldOut: false,
      },
      {
        name: '색상',
        value: '10. 올드스쿨_VN0A7Q2JBCK1',
        level: 0,
        images: [],
        options: [
          { id: 602036504, name: '사이즈', value: '040(220)', stock: 30, addPrice: 2000, level: 1, options: [] },
          { id: 602036505, name: '사이즈', value: '045(225)', stock: 55, addPrice: 2000, level: 1, options: [] },
          { id: 602036506, name: '사이즈', value: '050(230)', stock: 121, addPrice: 2000, level: 1, options: [] },
          { id: 602036507, name: '사이즈', value: '055(235)', stock: 173, addPrice: 2000, level: 1, options: [] },
          { id: 602036508, name: '사이즈', value: '060(240)', stock: 150, addPrice: 2000, level: 1, options: [] },
          { id: 602036509, name: '사이즈', value: '065(245)', stock: 108, addPrice: 2000, level: 1, options: [] },
          { id: 602036510, name: '사이즈', value: '070(250)', stock: 69, addPrice: 2000, level: 1, options: [] },
          { id: 602036511, name: '사이즈', value: '075(255)', stock: 44, addPrice: 2000, level: 1, options: [] },
          { id: 602036512, name: '사이즈', value: '080(260)', stock: 78, addPrice: 2000, level: 1, options: [] },
          { id: 602036513, name: '사이즈', value: '085(265)', stock: 131, addPrice: 2000, level: 1, options: [] },
          { id: 602036514, name: '사이즈', value: '090(270)', stock: 87, addPrice: 2000, level: 1, options: [] },
          { id: 602036515, name: '사이즈', value: '095(275)', stock: 59, addPrice: 2000, level: 1, options: [] },
          { id: 602036516, name: '사이즈', value: '100(280)', stock: 55, addPrice: 2000, level: 1, options: [] },
        ],
        minAddPrice: 2000,
        maxAddPrice: 2000,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '색상',
        value: '11. 레더 팝_VN0A54F6A6A1',
        level: 0,
        images: [],
        options: [
          { id: 602036517, name: '사이즈', value: '040(220)', stock: 28, addPrice: 5000, level: 1, options: [] },
          { id: 602036518, name: '사이즈', value: '045(225)', stock: 58, addPrice: 5000, level: 1, options: [] },
          { id: 602036519, name: '사이즈', value: '050(230)', stock: 0, addPrice: 5000, level: 1, options: [] },
          { id: 602036520, name: '사이즈', value: '055(235)', stock: 5, addPrice: 5000, level: 1, options: [] },
          { id: 602036521, name: '사이즈', value: '060(240)', stock: 3, addPrice: 5000, level: 1, options: [] },
          { id: 602036522, name: '사이즈', value: '065(245)', stock: 3, addPrice: 5000, level: 1, options: [] },
          { id: 602036523, name: '사이즈', value: '070(250)', stock: 10, addPrice: 5000, level: 1, options: [] },
        ],
        minAddPrice: 5000,
        maxAddPrice: 5000,
        hasSoldOut: true,
        soldOut: false,
      },
      {
        name: '색상',
        value: '12. 레더 팝_VN0A54F6A6B1',
        level: 0,
        images: [],
        options: [
          { id: 602036524, name: '사이즈', value: '040(220)', stock: 146, addPrice: 5000, level: 1, options: [] },
          { id: 602036525, name: '사이즈', value: '045(225)', stock: 143, addPrice: 5000, level: 1, options: [] },
          { id: 602036526, name: '사이즈', value: '050(230)', stock: 201, addPrice: 5000, level: 1, options: [] },
          { id: 602036527, name: '사이즈', value: '055(235)', stock: 192, addPrice: 5000, level: 1, options: [] },
          { id: 602036528, name: '사이즈', value: '060(240)', stock: 107, addPrice: 5000, level: 1, options: [] },
          { id: 602036529, name: '사이즈', value: '065(245)', stock: 79, addPrice: 5000, level: 1, options: [] },
          { id: 602036530, name: '사이즈', value: '070(250)', stock: 89, addPrice: 5000, level: 1, options: [] },
          { id: 602036531, name: '사이즈', value: '075(255)', stock: 53, addPrice: 5000, level: 1, options: [] },
          { id: 602036532, name: '사이즈', value: '080(260)', stock: 36, addPrice: 5000, level: 1, options: [] },
          { id: 602036533, name: '사이즈', value: '085(265)', stock: 30, addPrice: 5000, level: 1, options: [] },
          { id: 602036534, name: '사이즈', value: '090(270)', stock: 38, addPrice: 5000, level: 1, options: [] },
        ],
        minAddPrice: 5000,
        maxAddPrice: 5000,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '색상',
        value: '13. 레더 팝_VN0A54F6A6C1',
        level: 0,
        images: [],
        options: [
          { id: 602036535, name: '사이즈', value: '040(220)', stock: 73, addPrice: 5000, level: 1, options: [] },
          { id: 602036536, name: '사이즈', value: '045(225)', stock: 87, addPrice: 5000, level: 1, options: [] },
          { id: 602036537, name: '사이즈', value: '050(230)', stock: 48, addPrice: 5000, level: 1, options: [] },
          { id: 602036538, name: '사이즈', value: '055(235)', stock: 12, addPrice: 5000, level: 1, options: [] },
          { id: 602036539, name: '사이즈', value: '060(240)', stock: 3, addPrice: 5000, level: 1, options: [] },
          { id: 602036540, name: '사이즈', value: '065(245)', stock: 2, addPrice: 5000, level: 1, options: [] },
          { id: 602036541, name: '사이즈', value: '070(250)', stock: 33, addPrice: 5000, level: 1, options: [] },
          { id: 602036542, name: '사이즈', value: '075(255)', stock: 53, addPrice: 5000, level: 1, options: [] },
          { id: 602036543, name: '사이즈', value: '080(260)', stock: 20, addPrice: 5000, level: 1, options: [] },
          { id: 602036544, name: '사이즈', value: '085(265)', stock: 38, addPrice: 5000, level: 1, options: [] },
          { id: 602036545, name: '사이즈', value: '090(270)', stock: 14, addPrice: 5000, level: 1, options: [] },
          { id: 602036546, name: '사이즈', value: '095(275)', stock: 40, addPrice: 5000, level: 1, options: [] },
          { id: 602036547, name: '사이즈', value: '100(280)', stock: 23, addPrice: 5000, level: 1, options: [] },
        ],
        minAddPrice: 5000,
        maxAddPrice: 5000,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '색상',
        value: '14. 올드스쿨_VN0A5JMI8DB1',
        level: 0,
        images: [],
        options: [
          { id: 602036548, name: '사이즈', value: '040(220)', stock: 25, addPrice: 5000, level: 1, options: [] },
          { id: 602036549, name: '사이즈', value: '045(225)', stock: 61, addPrice: 5000, level: 1, options: [] },
          { id: 602036550, name: '사이즈', value: '050(230)', stock: 60, addPrice: 5000, level: 1, options: [] },
          { id: 602036551, name: '사이즈', value: '055(235)', stock: 28, addPrice: 5000, level: 1, options: [] },
          { id: 602036552, name: '사이즈', value: '060(240)', stock: 8, addPrice: 5000, level: 1, options: [] },
          { id: 602036553, name: '사이즈', value: '065(245)', stock: 7, addPrice: 5000, level: 1, options: [] },
          { id: 602036554, name: '사이즈', value: '070(250)', stock: 5, addPrice: 5000, level: 1, options: [] },
          { id: 602036555, name: '사이즈', value: '075(255)', stock: 51, addPrice: 5000, level: 1, options: [] },
          { id: 602036556, name: '사이즈', value: '080(260)', stock: 76, addPrice: 5000, level: 1, options: [] },
          { id: 602036557, name: '사이즈', value: '085(265)', stock: 68, addPrice: 5000, level: 1, options: [] },
          { id: 602036558, name: '사이즈', value: '090(270)', stock: 16, addPrice: 5000, level: 1, options: [] },
          { id: 602036559, name: '사이즈', value: '095(275)', stock: 22, addPrice: 5000, level: 1, options: [] },
        ],
        minAddPrice: 5000,
        maxAddPrice: 5000,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '색상',
        value: '15. 어센틱_VN0A54F98F91',
        level: 0,
        images: [],
        options: [
          { id: 602036560, name: '사이즈', value: '040(220)', stock: 132, addPrice: 7000, level: 1, options: [] },
          { id: 602036561, name: '사이즈', value: '045(225)', stock: 171, addPrice: 7000, level: 1, options: [] },
          { id: 602036562, name: '사이즈', value: '050(230)', stock: 183, addPrice: 7000, level: 1, options: [] },
          { id: 602036563, name: '사이즈', value: '055(235)', stock: 159, addPrice: 7000, level: 1, options: [] },
          { id: 602036564, name: '사이즈', value: '060(240)', stock: 91, addPrice: 7000, level: 1, options: [] },
          { id: 602036565, name: '사이즈', value: '065(245)', stock: 107, addPrice: 7000, level: 1, options: [] },
          { id: 602036567, name: '사이즈', value: '070(250)', stock: 53, addPrice: 7000, level: 1, options: [] },
          { id: 602036569, name: '사이즈', value: '075(255)', stock: 113, addPrice: 7000, level: 1, options: [] },
          { id: 602036571, name: '사이즈', value: '080(260)', stock: 119, addPrice: 7000, level: 1, options: [] },
          { id: 602036573, name: '사이즈', value: '085(265)', stock: 97, addPrice: 7000, level: 1, options: [] },
          { id: 602036575, name: '사이즈', value: '090(270)', stock: 65, addPrice: 7000, level: 1, options: [] },
          { id: 602036577, name: '사이즈', value: '095(275)', stock: 68, addPrice: 7000, level: 1, options: [] },
          { id: 602036579, name: '사이즈', value: '100(280)', stock: 40, addPrice: 7000, level: 1, options: [] },
        ],
        minAddPrice: 7000,
        maxAddPrice: 7000,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '색상',
        value: '16. 어센틱_VN0A54F98FK1',
        level: 0,
        images: [],
        options: [
          { id: 602036581, name: '사이즈', value: '040(220)', stock: 46, addPrice: 7000, level: 1, options: [] },
          { id: 602036583, name: '사이즈', value: '045(225)', stock: 58, addPrice: 7000, level: 1, options: [] },
          { id: 602036585, name: '사이즈', value: '050(230)', stock: 66, addPrice: 7000, level: 1, options: [] },
          { id: 602036587, name: '사이즈', value: '055(235)', stock: 35, addPrice: 7000, level: 1, options: [] },
          { id: 602036589, name: '사이즈', value: '060(240)', stock: 2, addPrice: 7000, level: 1, options: [] },
          { id: 602036591, name: '사이즈', value: '065(245)', stock: 33, addPrice: 7000, level: 1, options: [] },
          { id: 602036593, name: '사이즈', value: '070(250)', stock: 1, addPrice: 7000, level: 1, options: [] },
          { id: 602036595, name: '사이즈', value: '075(255)', stock: 54, addPrice: 7000, level: 1, options: [] },
          { id: 602036597, name: '사이즈', value: '080(260)', stock: 59, addPrice: 7000, level: 1, options: [] },
          { id: 602036599, name: '사이즈', value: '085(265)', stock: 68, addPrice: 7000, level: 1, options: [] },
          { id: 602036601, name: '사이즈', value: '090(270)', stock: 42, addPrice: 7000, level: 1, options: [] },
          { id: 602036602, name: '사이즈', value: '095(275)', stock: 43, addPrice: 7000, level: 1, options: [] },
          { id: 602036603, name: '사이즈', value: '100(280)', stock: 21, addPrice: 7000, level: 1, options: [] },
        ],
        minAddPrice: 7000,
        maxAddPrice: 7000,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '색상',
        value: '17. 올드스쿨_VN0A5KX99GY1',
        level: 0,
        images: [],
        options: [
          { id: 602036604, name: '사이즈', value: '040(220)', stock: 70, addPrice: 7000, level: 1, options: [] },
          { id: 602036605, name: '사이즈', value: '045(225)', stock: 111, addPrice: 7000, level: 1, options: [] },
          { id: 602036606, name: '사이즈', value: '050(230)', stock: 179, addPrice: 7000, level: 1, options: [] },
          { id: 602036607, name: '사이즈', value: '055(235)', stock: 188, addPrice: 7000, level: 1, options: [] },
          { id: 602036608, name: '사이즈', value: '060(240)', stock: 85, addPrice: 7000, level: 1, options: [] },
          { id: 602036609, name: '사이즈', value: '065(245)', stock: 18, addPrice: 7000, level: 1, options: [] },
          { id: 602036610, name: '사이즈', value: '070(250)', stock: 16, addPrice: 7000, level: 1, options: [] },
          { id: 602036611, name: '사이즈', value: '075(255)', stock: 0, addPrice: 7000, level: 1, options: [] },
          { id: 602036612, name: '사이즈', value: '080(260)', stock: 0, addPrice: 7000, level: 1, options: [] },
          { id: 602036613, name: '사이즈', value: '085(265)', stock: 0, addPrice: 7000, level: 1, options: [] },
          { id: 602036614, name: '사이즈', value: '090(270)', stock: 2, addPrice: 7000, level: 1, options: [] },
        ],
        minAddPrice: 7000,
        maxAddPrice: 7000,
        hasSoldOut: true,
        soldOut: false,
      },
      {
        name: '색상',
        value: '18. 어센틱_VN0A5KX48EK1',
        level: 0,
        images: [],
        options: [
          { id: 602036615, name: '사이즈', value: '075(255)', stock: 0, addPrice: 7000, level: 1, options: [] },
          { id: 602036616, name: '사이즈', value: '080(260)', stock: 1, addPrice: 7000, level: 1, options: [] },
          { id: 602036617, name: '사이즈', value: '085(265)', stock: 1, addPrice: 7000, level: 1, options: [] },
          { id: 602036618, name: '사이즈', value: '090(270)', stock: 4, addPrice: 7000, level: 1, options: [] },
          { id: 602036619, name: '사이즈', value: '095(275)', stock: 6, addPrice: 7000, level: 1, options: [] },
          { id: 602036620, name: '사이즈', value: '100(280)', stock: 1, addPrice: 7000, level: 1, options: [] },
          { id: 602036621, name: '사이즈', value: '105(285)', stock: 3, addPrice: 7000, level: 1, options: [] },
          { id: 602036622, name: '사이즈', value: '110(290)', stock: 0, addPrice: 7000, level: 1, options: [] },
        ],
        minAddPrice: 7000,
        maxAddPrice: 7000,
        hasSoldOut: true,
        soldOut: false,
      },
      {
        name: '색상',
        value: '19. 올드스쿨_VN0A5I12A041',
        level: 0,
        images: [],
        options: [
          { id: 602036623, name: '사이즈', value: '080(260)', stock: 0, addPrice: 7000, level: 1, options: [] },
          { id: 602036624, name: '사이즈', value: '090(270)', stock: 0, addPrice: 7000, level: 1, options: [] },
        ],
        hasSoldOut: true,
        soldOut: true,
      },
      {
        name: '색상',
        value: '20. 하이 38DX_VN0A54FBA5J1',
        level: 0,
        images: [],
        options: [
          { id: 602036625, name: '사이즈', value: '070(250)', stock: 64, addPrice: 13000, level: 1, options: [] },
          { id: 602036626, name: '사이즈', value: '075(255)', stock: 49, addPrice: 13000, level: 1, options: [] },
          { id: 602036627, name: '사이즈', value: '080(260)', stock: 68, addPrice: 13000, level: 1, options: [] },
          { id: 602036628, name: '사이즈', value: '085(265)', stock: 75, addPrice: 13000, level: 1, options: [] },
          { id: 602036629, name: '사이즈', value: '090(270)', stock: 71, addPrice: 13000, level: 1, options: [] },
          { id: 602036630, name: '사이즈', value: '095(275)', stock: 66, addPrice: 13000, level: 1, options: [] },
          { id: 602036631, name: '사이즈', value: '100(280)', stock: 88, addPrice: 13000, level: 1, options: [] },
        ],
        minAddPrice: 13000,
        maxAddPrice: 13000,
        hasSoldOut: false,
        soldOut: false,
      },
    ],
    customs: [],
  },
  247868049: {
    type: 'COMBINATION',
    names: ['옵션'],
    options: [
      {
        id: 604226677,
        name: '옵션',
        value: '1.한우 인삼갈비탕 700gX4개',
        stock: 747,
        addPrice: 0,
        level: 0,
        images: [],
        options: [],
      },
      {
        id: 604226678,
        name: '옵션',
        value: '2.주부9단 한우 도가니탕 450gX4개',
        stock: 300,
        addPrice: -7000,
        level: 0,
        images: [],
        options: [],
      },
      {
        id: 604226679,
        name: '옵션',
        value: '3.주부9단 한우 사골곰탕 450gX4개',
        stock: 486,
        addPrice: -15000,
        level: 0,
        images: [],
        options: [],
      },
      {
        id: 604226680,
        name: '옵션',
        value: '4.주부9단 한우 육개장 450gX4개',
        stock: 388,
        addPrice: -9000,
        level: 0,
        images: [],
        options: [],
      },
      {
        id: 604226681,
        name: '옵션',
        value: '5.주부9단 한우 미역국 450gX4개',
        stock: 472,
        addPrice: -10000,
        level: 0,
        images: [],
        options: [],
      },
    ],
    customs: [],
  },
  90836953: {
    type: 'COMBINATION',
    names: ['색상'],
    options: [
      {
        id: 326101532,
        name: '색상',
        value: '[best] 블랙 (품절임박)',
        stock: 180,
        addPrice: 0,
        level: 0,
        images: [],
        options: [],
      },
      { id: 326101533, name: '색상', value: '화이트', stock: 0, addPrice: 30000, level: 0, images: [], options: [] },
    ],
    customs: [],
  },
  204308361: {
    type: 'COMBINATION',
    names: ['귀리뻥 선택'],
    options: [
      {
        id: 531106696,
        name: '귀리뻥 선택',
        value: '150g*2봉',
        stock: 5091,
        addPrice: 0,
        level: 0,
        images: [],
        options: [],
      },
      {
        id: 531106697,
        name: '귀리뻥 선택',
        value: '150g*4봉',
        stock: 2169,
        addPrice: 7000,
        level: 0,
        images: [],
        options: [],
      },
    ],
    customs: [],
  },
  246324459: {
    type: 'COMBINATION',
    names: ['대용량 바디로션 1+1+증정'],
    options: [
      {
        id: 600385635,
        name: '대용량 바디로션 1+1+증정',
        value: '센시티브+센시티브',
        stock: 235,
        addPrice: 0,
        level: 0,
        images: [],
        options: [],
      },
      {
        id: 600385636,
        name: '대용량 바디로션 1+1+증정',
        value: '프레쉬+프레쉬',
        stock: 382,
        addPrice: 0,
        level: 0,
        images: [],
        options: [],
      },
      {
        id: 600385637,
        name: '대용량 바디로션 1+1+증정',
        value: '센시티브+프레쉬',
        stock: 393,
        addPrice: 0,
        level: 0,
        images: [],
        options: [],
      },
    ],
    customs: [],
  },
  197627921: {
    type: 'COMBINATION',
    names: ['운전석', '조수석'],
    options: [
      {
        name: '운전석',
        value: '350mm(2개)',
        level: 0,
        images: [],
        options: [
          { id: 506729812, name: '조수석', value: '350mm(2개)', stock: 9988, addPrice: 0, level: 1, options: [] },
          { id: 506729813, name: '조수석', value: '400mm(2개)', stock: 9999, addPrice: 0, level: 1, options: [] },
          { id: 506729814, name: '조수석', value: '450mm(2개)', stock: 9999, addPrice: 0, level: 1, options: [] },
          { id: 506729815, name: '조수석', value: '500mm(2개)', stock: 9999, addPrice: 0, level: 1, options: [] },
          { id: 506729816, name: '조수석', value: '550mm(2개)', stock: 9999, addPrice: 0, level: 1, options: [] },
          { id: 506729817, name: '조수석', value: '600mm(2개)', stock: 9986, addPrice: 0, level: 1, options: [] },
          { id: 506729818, name: '조수석', value: '650mm(2개)', stock: 9974, addPrice: 0, level: 1, options: [] },
        ],
        minAddPrice: 0,
        maxAddPrice: 0,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '운전석',
        value: '400mm(2개)',
        level: 0,
        images: [],
        options: [
          { id: 506729819, name: '조수석', value: '350mm(2개)', stock: 9997, addPrice: 0, level: 1, options: [] },
          { id: 506729820, name: '조수석', value: '400mm(2개)', stock: 9981, addPrice: 0, level: 1, options: [] },
          { id: 506729821, name: '조수석', value: '450mm(2개)', stock: 9997, addPrice: 0, level: 1, options: [] },
          { id: 506729822, name: '조수석', value: '500mm(2개)', stock: 9997, addPrice: 0, level: 1, options: [] },
          { id: 506729823, name: '조수석', value: '550mm(2개)', stock: 9988, addPrice: 0, level: 1, options: [] },
          { id: 506729824, name: '조수석', value: '600mm(2개)', stock: 9973, addPrice: 0, level: 1, options: [] },
          { id: 506729825, name: '조수석', value: '650mm(2개)', stock: 9955, addPrice: 0, level: 1, options: [] },
        ],
        minAddPrice: 0,
        maxAddPrice: 0,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '운전석',
        value: '450mm(2개)',
        level: 0,
        images: [],
        options: [
          { id: 506729826, name: '조수석', value: '350mm(2개)', stock: 9999, addPrice: 0, level: 1, options: [] },
          { id: 506729827, name: '조수석', value: '400mm(2개)', stock: 9994, addPrice: 0, level: 1, options: [] },
          { id: 506729828, name: '조수석', value: '450mm(2개)', stock: 9976, addPrice: 0, level: 1, options: [] },
          { id: 506729829, name: '조수석', value: '500mm(2개)', stock: 9991, addPrice: 0, level: 1, options: [] },
          { id: 506729830, name: '조수석', value: '550mm(2개)', stock: 9996, addPrice: 0, level: 1, options: [] },
          { id: 506729831, name: '조수석', value: '600mm(2개)', stock: 9958, addPrice: 0, level: 1, options: [] },
          { id: 506729832, name: '조수석', value: '650mm(2개)', stock: 9921, addPrice: 0, level: 1, options: [] },
        ],
        minAddPrice: 0,
        maxAddPrice: 0,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '운전석',
        value: '500mm(2개)',
        level: 0,
        images: [],
        options: [
          { id: 506729833, name: '조수석', value: '350mm(2개)', stock: 9998, addPrice: 0, level: 1, options: [] },
          { id: 506729834, name: '조수석', value: '400mm(2개)', stock: 9996, addPrice: 0, level: 1, options: [] },
          { id: 506729835, name: '조수석', value: '450mm(2개)', stock: 9957, addPrice: 0, level: 1, options: [] },
          { id: 506729836, name: '조수석', value: '500mm(2개)', stock: 9972, addPrice: 0, level: 1, options: [] },
          { id: 506729837, name: '조수석', value: '550mm(2개)', stock: 9993, addPrice: 0, level: 1, options: [] },
          { id: 506729838, name: '조수석', value: '600mm(2개)', stock: 9982, addPrice: 0, level: 1, options: [] },
          { id: 506729839, name: '조수석', value: '650mm(2개)', stock: 9993, addPrice: 0, level: 1, options: [] },
        ],
        minAddPrice: 0,
        maxAddPrice: 0,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '운전석',
        value: '550mm(2개)',
        level: 0,
        images: [],
        options: [
          { id: 506729840, name: '조수석', value: '350mm(2개)', stock: 9995, addPrice: 0, level: 1, options: [] },
          { id: 506729841, name: '조수석', value: '400mm(2개)', stock: 9824, addPrice: 0, level: 1, options: [] },
          { id: 506729842, name: '조수석', value: '450mm(2개)', stock: 9957, addPrice: 0, level: 1, options: [] },
          { id: 506729843, name: '조수석', value: '500mm(2개)', stock: 9976, addPrice: 0, level: 1, options: [] },
          { id: 506729844, name: '조수석', value: '550mm(2개)', stock: 9986, addPrice: 0, level: 1, options: [] },
          { id: 506729845, name: '조수석', value: '600mm(2개)', stock: 9999, addPrice: 0, level: 1, options: [] },
          { id: 506729846, name: '조수석', value: '650mm(2개)', stock: 9997, addPrice: 0, level: 1, options: [] },
        ],
        minAddPrice: 0,
        maxAddPrice: 0,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '운전석',
        value: '600mm(2개)',
        level: 0,
        images: [],
        options: [
          { id: 506729847, name: '조수석', value: '350mm(2개)', stock: 9886, addPrice: 0, level: 1, options: [] },
          { id: 506729848, name: '조수석', value: '400mm(2개)', stock: 9689, addPrice: 0, level: 1, options: [] },
          { id: 506729849, name: '조수석', value: '450mm(2개)', stock: 9578, addPrice: 0, level: 1, options: [] },
          { id: 506729850, name: '조수석', value: '500mm(2개)', stock: 9795, addPrice: 0, level: 1, options: [] },
          { id: 506729851, name: '조수석', value: '550mm(2개)', stock: 9997, addPrice: 0, level: 1, options: [] },
          { id: 506729852, name: '조수석', value: '600mm(2개)', stock: 9968, addPrice: 0, level: 1, options: [] },
          { id: 506729853, name: '조수석', value: '650mm(2개)', stock: 9996, addPrice: 0, level: 1, options: [] },
        ],
        minAddPrice: 0,
        maxAddPrice: 0,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '운전석',
        value: '650mm(2개)',
        level: 0,
        images: [],
        options: [
          { id: 506729854, name: '조수석', value: '350mm(2개)', stock: 9789, addPrice: 0, level: 1, options: [] },
          { id: 506729855, name: '조수석', value: '400mm(2개)', stock: 9477, addPrice: 0, level: 1, options: [] },
          { id: 506729856, name: '조수석', value: '450mm(2개)', stock: 9304, addPrice: 0, level: 1, options: [] },
          { id: 506729857, name: '조수석', value: '500mm(2개)', stock: 9943, addPrice: 0, level: 1, options: [] },
          { id: 506729858, name: '조수석', value: '550mm(2개)', stock: 9992, addPrice: 0, level: 1, options: [] },
          { id: 506729859, name: '조수석', value: '600mm(2개)', stock: 9993, addPrice: 0, level: 1, options: [] },
          { id: 506729860, name: '조수석', value: '650mm(2개)', stock: 9941, addPrice: 0, level: 1, options: [] },
        ],
        minAddPrice: 0,
        maxAddPrice: 0,
        hasSoldOut: false,
        soldOut: false,
      },
    ],
    customs: [],
  },
  139319258: {
    type: 'COMBINATION',
    names: ['옵션'],
    options: [
      {
        id: 424531616,
        name: '옵션',
        value: '1.자스민 80g 8개+오이라임 80g 4개',
        stock: 7583,
        addPrice: 0,
        level: 0,
        images: [],
        options: [],
      },
      {
        id: 424531617,
        name: '옵션',
        value: '2.오이라임 80g 8개+자스민 80g 4개',
        stock: 9328,
        addPrice: 0,
        level: 0,
        images: [],
        options: [],
      },
      {
        id: 424531618,
        name: '옵션',
        value: '3.슈퍼보타닉 쟈스민 비누 80g 12개',
        stock: 8630,
        addPrice: 0,
        level: 0,
        images: [],
        options: [],
      },
      {
        id: 424531619,
        name: '옵션',
        value: '4.슈퍼보타닉 오이라임 비누 80g 12개',
        stock: 9738,
        addPrice: 0,
        level: 0,
        images: [],
        options: [],
      },
      {
        id: 424531620,
        name: '옵션',
        value: '5.아이리스90g 4개+체리블러썸90g 4개',
        stock: 9404,
        addPrice: -400,
        level: 0,
        images: [],
        options: [],
      },
      {
        id: 424531621,
        name: '옵션',
        value: '6.아이리스 휘핑비누 90g 8개',
        stock: 9913,
        addPrice: -400,
        level: 0,
        images: [],
        options: [],
      },
      {
        id: 424531622,
        name: '옵션',
        value: '7.체리블러썸 휘핑비누 90g 8개',
        stock: 9872,
        addPrice: -400,
        level: 0,
        images: [],
        options: [],
      },
      {
        id: 424531623,
        name: '옵션',
        value: '8.올리브비누90g 4개+코코넛비누90g 4개',
        stock: 0,
        addPrice: -400,
        level: 0,
        images: [],
        options: [],
      },
      {
        id: 424531624,
        name: '옵션',
        value: '9.더내추럴 올리브 비누 90g 8개',
        stock: 0,
        addPrice: -400,
        level: 0,
        images: [],
        options: [],
      },
      {
        id: 424531625,
        name: '옵션',
        value: '10.더내추럴 코코넛 비누 90g 8개',
        stock: 9923,
        addPrice: -400,
        level: 0,
        images: [],
        options: [],
      },
    ],
    customs: [],
  },
  68626964: {
    type: 'COMBINATION',
    names: ['선택'],
    options: [
      { id: 564052602, name: '선택', value: '라벤더6개', stock: 821, addPrice: 0, level: 0, images: [], options: [] },
      { id: 564052603, name: '선택', value: '와일드6개', stock: 895, addPrice: 0, level: 0, images: [], options: [] },
      { id: 564052604, name: '선택', value: '프레쉬6개', stock: 765, addPrice: 0, level: 0, images: [], options: [] },
      {
        id: 564052605,
        name: '선택',
        value: '라벤더2개+와일드2개+프레쉬2개',
        stock: 356,
        addPrice: 0,
        level: 0,
        images: [],
        options: [],
      },
      {
        id: 564052606,
        name: '선택',
        value: '버넬 그린 베티버6개',
        stock: 981,
        addPrice: 2000,
        level: 0,
        images: [],
        options: [],
      },
      {
        id: 564052607,
        name: '선택',
        value: '버넬 그린 화이트티6개',
        stock: 980,
        addPrice: 2000,
        level: 0,
        images: [],
        options: [],
      },
      {
        id: 564052608,
        name: '선택',
        value: '버넬 그린 베티버3개+화이트티3개',
        stock: 832,
        addPrice: 2000,
        level: 0,
        images: [],
        options: [],
      },
    ],
    customs: [],
  },
  56992838: {
    type: 'COMBINATION',
    names: ['옵션'],
    options: [
      {
        id: 539711766,
        name: '옵션',
        value: '1_이탈리아 저분자 피쉬콜라겐 90포 1통',
        stock: 783,
        addPrice: 0,
        level: 0,
        images: ['https://st.kakaocdn.net/shoppingstore/option/20230210170505_f87f3c9435b24ac3b6c3447c8887194e.jpg'],
        options: [],
      },
      {
        id: 539711767,
        name: '옵션',
        value: '2_종근당 여성영양제 황후의봄 1박스',
        stock: 1988,
        addPrice: 13100,
        level: 0,
        images: ['https://st.kakaocdn.net/shoppingstore/option/20230210170507_a8043b4883944d4c993fa1e124ca6c31.jpg'],
        options: [],
      },
      {
        id: 539711769,
        name: '옵션',
        value: '3_종근당 에너지업 마시는침향 1박스',
        stock: 1998,
        addPrice: 25000,
        level: 0,
        images: ['https://st.kakaocdn.net/shoppingstore/option/20230503150909_d32c4ff79b7541d0a8f021f91175ab48.jpg'],
        options: [],
      },
      {
        id: 539711770,
        name: '옵션',
        value: '4_종근당건강 가르시니아 HCA 1박스',
        stock: 1980,
        addPrice: -4400,
        level: 0,
        images: ['https://st.kakaocdn.net/shoppingstore/option/20230503150935_622379a1aea540438cd77296cf1649f8.jpg'],
        options: [],
      },
      {
        id: 539711771,
        name: '옵션',
        value: '5_코큐텐 코엔자임 Q10 11 1박스',
        stock: 1984,
        addPrice: -9900,
        level: 0,
        images: ['https://st.kakaocdn.net/shoppingstore/option/20230503150939_8d1fd0da07e549478ee19a31df6c4578.jpg'],
        options: [],
      },
      {
        id: 539711772,
        name: '옵션',
        value: '6_전통발효연구원 38발효효소 2박스',
        stock: 992,
        addPrice: 1600,
        level: 0,
        images: ['https://st.kakaocdn.net/shoppingstore/option/20230503151105_788d1ead59fc411bb54d079ee1240c66.jpg'],
        options: [],
      },
      {
        id: 539711773,
        name: '옵션',
        value: '7_프리미엄 트리플 비타민C 1000 1박스',
        stock: 1991,
        addPrice: -11900,
        level: 0,
        images: ['https://st.kakaocdn.net/shoppingstore/option/20230503151005_c1e340b2696246a4b8d98f0ca7dbd562.jpg'],
        options: [],
      },
      {
        id: 539711774,
        name: '옵션',
        value: '8_메디트리 보스웰리아 비타민D 1병',
        stock: 1996,
        addPrice: -11000,
        level: 0,
        images: ['https://st.kakaocdn.net/shoppingstore/option/20230503151009_96d4956d04ed410187d34acc4dcff9dc.jpg'],
        options: [],
      },
      {
        id: 539711775,
        name: '옵션',
        value: '9_메디트리 오메가3 1100 비타민D 1병',
        stock: 1996,
        addPrice: 8000,
        level: 0,
        images: ['https://st.kakaocdn.net/shoppingstore/option/20230503160201_7a974e10518841969e5f2adbd289f00f.jpg'],
        options: [],
      },
      {
        id: 539711776,
        name: '옵션',
        value: '10_락토 프로바이오 생유산균17 60포 1통',
        stock: 961,
        addPrice: -9600,
        level: 0,
        images: ['https://st.kakaocdn.net/shoppingstore/option/20230503151041_4d9a3107ffb44fe7b49379434b83225d.jpg'],
        options: [],
      },
      {
        id: 539711777,
        name: '옵션',
        value: '11_광동 기력진액골드 30포 1세트',
        stock: 1994,
        addPrice: 1400,
        level: 0,
        images: ['https://st.kakaocdn.net/shoppingstore/option/20230503151048_b87220d5258d48a88a3285f3f6dee9cb.jpg'],
        options: [],
      },
      {
        id: 608386774,
        name: '옵션',
        value: '12_광동 차가상황기혈환 60환 1세트',
        stock: 1000,
        addPrice: 37000,
        level: 0,
        images: ['https://st.kakaocdn.net/shoppingstore/option/20230503151056_34d1acf6a14d434ab5c8653fd54a1db6.jpg'],
        options: [],
      },
    ],
    customs: [],
  },
  53209039: {
    type: 'COMBINATION',
    names: ['선택'],
    options: [
      {
        id: 261433040,
        name: '선택',
        value: '1. rTG알티지오메가3 2박스',
        stock: 98127,
        addPrice: 0,
        level: 0,
        images: ['https://st.kakaocdn.net/shoppingstore/option/20220124160216_3ffa6d5b78a64b48b23fab964712ac8c.jpg'],
        options: [],
      },
      {
        id: 261433041,
        name: '선택',
        value: '2. rTG알티지오메가3 4박스',
        stock: 97803,
        addPrice: 22000,
        level: 0,
        images: ['https://st.kakaocdn.net/shoppingstore/option/20230202154327_b5495b6318b04b03a9332b661262df6e.jpg'],
        options: [],
      },
    ],
    customs: [],
  },
  247834660: {
    type: 'COMBINATION',
    names: ['품목'],
    options: [
      {
        id: 604117582,
        name: '품목',
        value: '못난이 꿀참외 5kg',
        stock: 6045,
        addPrice: 0,
        level: 0,
        images: [],
        options: [],
      },
      {
        id: 604117583,
        name: '품목',
        value: '못난이 꿀참외 3kg',
        stock: 9366,
        addPrice: -5000,
        level: 0,
        images: [],
        options: [],
      },
      {
        id: 604117584,
        name: '품목',
        value: '못난이 꿀참외 10kg',
        stock: 9147,
        addPrice: 12000,
        level: 0,
        images: [],
        options: [],
      },
      {
        id: 604117585,
        name: '품목',
        value: '정품 로얄 꿀참외 5kg',
        stock: 9876,
        addPrice: 12000,
        level: 0,
        images: [],
        options: [],
      },
      {
        id: 612688901,
        name: '품목',
        value: '정품 로얄 꿀참외 3kg',
        stock: 9916,
        addPrice: 2000,
        level: 0,
        images: [],
        options: [],
      },
    ],
    customs: [],
  },
  64498390: {
    type: 'COMBINATION',
    names: ['색상', '사이즈'],
    options: [
      {
        name: '색상',
        value: '선택1)블랙',
        level: 0,
        images: [],
        options: [
          { id: 434677996, name: '사이즈', value: 'S(90)', stock: 285, addPrice: 0, level: 1, options: [] },
          { id: 509760284, name: '사이즈', value: 'M(95)', stock: 309, addPrice: 0, level: 1, options: [] },
          { id: 509760285, name: '사이즈', value: 'L(100)', stock: 370, addPrice: 0, level: 1, options: [] },
          { id: 509760286, name: '사이즈', value: 'XL(105)', stock: 262, addPrice: 0, level: 1, options: [] },
          { id: 593100008, name: '사이즈', value: '2XL(110)', stock: 165, addPrice: 0, level: 1, options: [] },
        ],
        minAddPrice: 0,
        maxAddPrice: 0,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '색상',
        value: '선택1)다크그레이',
        level: 0,
        images: [],
        options: [
          { id: 607854266, name: '사이즈', value: 'S(90)', stock: 193, addPrice: 0, level: 1, options: [] },
          { id: 607854267, name: '사이즈', value: 'M(95)', stock: 289, addPrice: 0, level: 1, options: [] },
          { id: 607854268, name: '사이즈', value: 'L(100)', stock: 286, addPrice: 0, level: 1, options: [] },
          { id: 607854269, name: '사이즈', value: 'XL(105)', stock: 188, addPrice: 0, level: 1, options: [] },
          { id: 607854270, name: '사이즈', value: '2XL(110)', stock: 139, addPrice: 0, level: 1, options: [] },
        ],
        minAddPrice: 0,
        maxAddPrice: 0,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '색상',
        value: '선택1)멜란지화이트',
        level: 0,
        images: [],
        options: [
          { id: 568345439, name: '사이즈', value: 'S(90)', stock: 350, addPrice: 0, level: 1, options: [] },
          { id: 568345440, name: '사이즈', value: 'M(95)', stock: 479, addPrice: 0, level: 1, options: [] },
          { id: 568345441, name: '사이즈', value: 'L(100)', stock: 314, addPrice: 0, level: 1, options: [] },
          { id: 568345442, name: '사이즈', value: 'XL(105)', stock: 216, addPrice: 0, level: 1, options: [] },
          { id: 593100020, name: '사이즈', value: '2XL(110)', stock: 119, addPrice: 0, level: 1, options: [] },
        ],
        minAddPrice: 0,
        maxAddPrice: 0,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '색상',
        value: '선택1)네이비',
        level: 0,
        images: [],
        options: [
          { id: 593100021, name: '사이즈', value: 'S(90)', stock: 252, addPrice: 0, level: 1, options: [] },
          { id: 593100022, name: '사이즈', value: 'M(95)', stock: 292, addPrice: 0, level: 1, options: [] },
          { id: 593100023, name: '사이즈', value: 'L(100)', stock: 270, addPrice: 0, level: 1, options: [] },
          { id: 593100024, name: '사이즈', value: 'XL(105)', stock: 241, addPrice: 0, level: 1, options: [] },
          { id: 593100025, name: '사이즈', value: '2XL(110)', stock: 165, addPrice: 0, level: 1, options: [] },
        ],
        minAddPrice: 0,
        maxAddPrice: 0,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '색상',
        value: '선택1)화이트',
        level: 0,
        images: [],
        options: [
          { id: 593100027, name: '사이즈', value: 'S(90)', stock: 266, addPrice: 0, level: 1, options: [] },
          { id: 593100028, name: '사이즈', value: 'M(95)', stock: 342, addPrice: 0, level: 1, options: [] },
          { id: 593100029, name: '사이즈', value: 'L(100)', stock: 242, addPrice: 0, level: 1, options: [] },
          { id: 593100030, name: '사이즈', value: 'XL(105)', stock: 177, addPrice: 0, level: 1, options: [] },
          { id: 593100031, name: '사이즈', value: '2XL(110)', stock: 87, addPrice: 0, level: 1, options: [] },
        ],
        minAddPrice: 0,
        maxAddPrice: 0,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '색상',
        value: '선택2)블랙',
        level: 0,
        images: [],
        options: [
          { id: 509760303, name: '사이즈', value: 'S(90)', stock: 187, addPrice: 0, level: 1, options: [] },
          { id: 509760304, name: '사이즈', value: 'M(95)', stock: 308, addPrice: 0, level: 1, options: [] },
          { id: 509760305, name: '사이즈', value: 'L(100)', stock: 270, addPrice: 0, level: 1, options: [] },
          { id: 509760306, name: '사이즈', value: 'XL(105)', stock: 198, addPrice: 0, level: 1, options: [] },
          { id: 509760307, name: '사이즈', value: '2XL(110)', stock: 150, addPrice: 0, level: 1, options: [] },
        ],
        minAddPrice: 0,
        maxAddPrice: 0,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '색상',
        value: '선택2)블루',
        level: 0,
        images: [],
        options: [
          { id: 607854276, name: '사이즈', value: 'S(90)', stock: 164, addPrice: 0, level: 1, options: [] },
          { id: 607854277, name: '사이즈', value: 'M(95)', stock: 193, addPrice: 0, level: 1, options: [] },
          { id: 607854278, name: '사이즈', value: 'L(100)', stock: 144, addPrice: 0, level: 1, options: [] },
          { id: 607854279, name: '사이즈', value: 'XL(105)', stock: 102, addPrice: 0, level: 1, options: [] },
          { id: 607854280, name: '사이즈', value: '2XL(110)', stock: 40, addPrice: 0, level: 1, options: [] },
        ],
        minAddPrice: 0,
        maxAddPrice: 0,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '색상',
        value: '선택2)라이트바이올렛',
        level: 0,
        images: [],
        options: [
          { id: 607854271, name: '사이즈', value: 'S(90)', stock: 140, addPrice: 0, level: 1, options: [] },
          { id: 607854272, name: '사이즈', value: 'M(95)', stock: 113, addPrice: 0, level: 1, options: [] },
          { id: 607854273, name: '사이즈', value: 'L(100)', stock: 78, addPrice: 0, level: 1, options: [] },
          { id: 607854274, name: '사이즈', value: 'XL(105)', stock: 44, addPrice: 0, level: 1, options: [] },
        ],
        minAddPrice: 0,
        maxAddPrice: 0,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '색상',
        value: '선택2)멜란지화이트',
        level: 0,
        images: [],
        options: [
          { id: 593100051, name: '사이즈', value: 'S(90)', stock: 341, addPrice: 0, level: 1, options: [] },
          { id: 593100052, name: '사이즈', value: 'M(95)', stock: 394, addPrice: 0, level: 1, options: [] },
          { id: 593100053, name: '사이즈', value: 'L(100)', stock: 276, addPrice: 0, level: 1, options: [] },
          { id: 593100054, name: '사이즈', value: 'XL(105)', stock: 156, addPrice: 0, level: 1, options: [] },
          { id: 608086676, name: '사이즈', value: '2XL(110)', stock: 79, addPrice: 0, level: 1, options: [] },
        ],
        minAddPrice: 0,
        maxAddPrice: 0,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '색상',
        value: '선택2)화이트',
        level: 0,
        images: [],
        options: [
          { id: 568345456, name: '사이즈', value: 'S(90)', stock: 289, addPrice: 0, level: 1, options: [] },
          { id: 568345457, name: '사이즈', value: 'M(95)', stock: 353, addPrice: 0, level: 1, options: [] },
          { id: 568345458, name: '사이즈', value: 'L(100)', stock: 248, addPrice: 0, level: 1, options: [] },
          { id: 568345459, name: '사이즈', value: 'XL(105)', stock: 129, addPrice: 0, level: 1, options: [] },
          { id: 568345460, name: '사이즈', value: '2XL(110)', stock: 52, addPrice: 0, level: 1, options: [] },
        ],
        minAddPrice: 0,
        maxAddPrice: 0,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '색상',
        value: '선택3)블랙',
        level: 0,
        images: [],
        options: [
          { id: 509760323, name: '사이즈', value: 'S(90)', stock: 218, addPrice: 0, level: 1, options: [] },
          { id: 509760324, name: '사이즈', value: 'M(95)', stock: 334, addPrice: 0, level: 1, options: [] },
          { id: 509760325, name: '사이즈', value: 'L(100)', stock: 380, addPrice: 0, level: 1, options: [] },
          { id: 509760326, name: '사이즈', value: 'XL(105)', stock: 249, addPrice: 0, level: 1, options: [] },
          { id: 509760327, name: '사이즈', value: '2XL(110)', stock: 184, addPrice: 0, level: 1, options: [] },
        ],
        minAddPrice: 0,
        maxAddPrice: 0,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '색상',
        value: '선택3)멜란지화이트',
        level: 0,
        images: [],
        options: [
          { id: 509760333, name: '사이즈', value: 'S(90)', stock: 242, addPrice: 0, level: 1, options: [] },
          { id: 509760334, name: '사이즈', value: 'M(95)', stock: 204, addPrice: 0, level: 1, options: [] },
          { id: 509760335, name: '사이즈', value: 'L(100)', stock: 193, addPrice: 0, level: 1, options: [] },
          { id: 509760336, name: '사이즈', value: 'XL(105)', stock: 114, addPrice: 0, level: 1, options: [] },
          { id: 509760337, name: '사이즈', value: '2XL(110)', stock: 55, addPrice: 0, level: 1, options: [] },
        ],
        minAddPrice: 0,
        maxAddPrice: 0,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '색상',
        value: '선택3)오렌지',
        level: 0,
        images: [],
        options: [
          { id: 593100061, name: '사이즈', value: 'S(90)', stock: 166, addPrice: 0, level: 1, options: [] },
          { id: 593100062, name: '사이즈', value: 'M(95)', stock: 137, addPrice: 0, level: 1, options: [] },
          { id: 593100063, name: '사이즈', value: 'L(100)', stock: 75, addPrice: 0, level: 1, options: [] },
          { id: 593100064, name: '사이즈', value: 'XL(105)', stock: 57, addPrice: 0, level: 1, options: [] },
          { id: 593100065, name: '사이즈', value: '2XL(110)', stock: 24, addPrice: 0, level: 1, options: [] },
        ],
        minAddPrice: 0,
        maxAddPrice: 0,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '색상',
        value: '선택3)화이트',
        level: 0,
        images: [],
        options: [
          { id: 593100066, name: '사이즈', value: 'S(90)', stock: 321, addPrice: 0, level: 1, options: [] },
          { id: 593100067, name: '사이즈', value: 'M(95)', stock: 386, addPrice: 0, level: 1, options: [] },
          { id: 593100068, name: '사이즈', value: 'L(100)', stock: 292, addPrice: 0, level: 1, options: [] },
          { id: 593100069, name: '사이즈', value: 'XL(105)', stock: 218, addPrice: 0, level: 1, options: [] },
          { id: 593100070, name: '사이즈', value: '2XL(110)', stock: 104, addPrice: 0, level: 1, options: [] },
        ],
        minAddPrice: 0,
        maxAddPrice: 0,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '색상',
        value: '선택4)블랙',
        level: 0,
        images: [],
        options: [
          { id: 509760343, name: '사이즈', value: 'S(90)', stock: 258, addPrice: 0, level: 1, options: [] },
          { id: 509760344, name: '사이즈', value: 'M(95)', stock: 377, addPrice: 0, level: 1, options: [] },
          { id: 509760345, name: '사이즈', value: 'L(100)', stock: 348, addPrice: 0, level: 1, options: [] },
          { id: 509760346, name: '사이즈', value: 'XL(105)', stock: 249, addPrice: 0, level: 1, options: [] },
          { id: 568345466, name: '사이즈', value: '2XL(110)', stock: 198, addPrice: 0, level: 1, options: [] },
        ],
        minAddPrice: 0,
        maxAddPrice: 0,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '색상',
        value: '선택4)그린',
        level: 0,
        images: [],
        options: [
          { id: 607854286, name: '사이즈', value: 'S(90)', stock: 277, addPrice: 0, level: 1, options: [] },
          { id: 607854287, name: '사이즈', value: 'M(95)', stock: 338, addPrice: 0, level: 1, options: [] },
          { id: 607854288, name: '사이즈', value: 'L(100)', stock: 292, addPrice: 0, level: 1, options: [] },
          { id: 607854289, name: '사이즈', value: 'XL(105)', stock: 197, addPrice: 0, level: 1, options: [] },
          { id: 607854290, name: '사이즈', value: '2XL(110)', stock: 140, addPrice: 0, level: 1, options: [] },
        ],
        minAddPrice: 0,
        maxAddPrice: 0,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '색상',
        value: '선택4)멜란지화이트',
        level: 0,
        images: [],
        options: [
          { id: 607854291, name: '사이즈', value: 'S(90)', stock: 319, addPrice: 0, level: 1, options: [] },
          { id: 607854292, name: '사이즈', value: 'M(95)', stock: 410, addPrice: 0, level: 1, options: [] },
          { id: 607854293, name: '사이즈', value: 'L(100)', stock: 299, addPrice: 0, level: 1, options: [] },
          { id: 607854294, name: '사이즈', value: 'XL(105)', stock: 209, addPrice: 0, level: 1, options: [] },
          { id: 607854295, name: '사이즈', value: '2XL(110)', stock: 120, addPrice: 0, level: 1, options: [] },
        ],
        minAddPrice: 0,
        maxAddPrice: 0,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '색상',
        value: '선택4)오렌지',
        level: 0,
        images: [],
        options: [
          { id: 607854296, name: '사이즈', value: 'S(90)', stock: 180, addPrice: 0, level: 1, options: [] },
          { id: 607854297, name: '사이즈', value: 'M(95)', stock: 150, addPrice: 0, level: 1, options: [] },
          { id: 607854298, name: '사이즈', value: 'L(100)', stock: 99, addPrice: 0, level: 1, options: [] },
          { id: 607854299, name: '사이즈', value: 'XL(105)', stock: 80, addPrice: 0, level: 1, options: [] },
          { id: 607854300, name: '사이즈', value: '2XL(110)', stock: 49, addPrice: 0, level: 1, options: [] },
        ],
        minAddPrice: 0,
        maxAddPrice: 0,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '색상',
        value: '선택4)화이트',
        level: 0,
        images: [],
        options: [
          { id: 607854281, name: '사이즈', value: 'S(90)', stock: 299, addPrice: 0, level: 1, options: [] },
          { id: 607854282, name: '사이즈', value: 'M(95)', stock: 227, addPrice: 0, level: 1, options: [] },
          { id: 607854283, name: '사이즈', value: 'L(100)', stock: 197, addPrice: 0, level: 1, options: [] },
          { id: 607854284, name: '사이즈', value: 'XL(105)', stock: 137, addPrice: 0, level: 1, options: [] },
          { id: 607854285, name: '사이즈', value: '2XL(110)', stock: 59, addPrice: 0, level: 1, options: [] },
        ],
        minAddPrice: 0,
        maxAddPrice: 0,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '색상',
        value: '선택5)블랙',
        level: 0,
        images: [],
        options: [
          { id: 509760358, name: '사이즈', value: 'S(90)', stock: 260, addPrice: 0, level: 1, options: [] },
          { id: 509760359, name: '사이즈', value: 'M(95)', stock: 361, addPrice: 0, level: 1, options: [] },
          { id: 509760360, name: '사이즈', value: 'L(100)', stock: 411, addPrice: 0, level: 1, options: [] },
          { id: 509760361, name: '사이즈', value: 'XL(105)', stock: 261, addPrice: 0, level: 1, options: [] },
          { id: 509760362, name: '사이즈', value: '2XL(110)', stock: 200, addPrice: 0, level: 1, options: [] },
        ],
        minAddPrice: 0,
        maxAddPrice: 0,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '색상',
        value: '선택5)카키',
        level: 0,
        images: [],
        options: [
          { id: 608086677, name: '사이즈', value: 'S(90)', stock: 227, addPrice: 0, level: 1, options: [] },
          { id: 608086678, name: '사이즈', value: 'M(95)', stock: 363, addPrice: 0, level: 1, options: [] },
          { id: 608086679, name: '사이즈', value: 'L(100)', stock: 338, addPrice: 0, level: 1, options: [] },
          { id: 608086680, name: '사이즈', value: 'XL(105)', stock: 247, addPrice: 0, level: 1, options: [] },
          { id: 608086681, name: '사이즈', value: '2XL(110)', stock: 192, addPrice: 0, level: 1, options: [] },
        ],
        minAddPrice: 0,
        maxAddPrice: 0,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '색상',
        value: '선택5)라이트옐로우',
        level: 0,
        images: [],
        options: [
          { id: 608086682, name: '사이즈', value: 'S(90)', stock: 146, addPrice: 0, level: 1, options: [] },
          { id: 608086683, name: '사이즈', value: 'M(95)', stock: 104, addPrice: 0, level: 1, options: [] },
          { id: 608086684, name: '사이즈', value: 'L(100)', stock: 69, addPrice: 0, level: 1, options: [] },
          { id: 608086685, name: '사이즈', value: 'XL(105)', stock: 30, addPrice: 0, level: 1, options: [] },
          { id: 608086686, name: '사이즈', value: '2XL(110)', stock: 20, addPrice: 0, level: 1, options: [] },
        ],
        minAddPrice: 0,
        maxAddPrice: 0,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '색상',
        value: '선택5)그레이',
        level: 0,
        images: [],
        options: [
          { id: 608086687, name: '사이즈', value: 'S(90)', stock: 130, addPrice: 0, level: 1, options: [] },
          { id: 608086688, name: '사이즈', value: 'M(95)', stock: 149, addPrice: 0, level: 1, options: [] },
          { id: 608086689, name: '사이즈', value: 'L(100)', stock: 117, addPrice: 0, level: 1, options: [] },
          { id: 608086690, name: '사이즈', value: 'XL(105)', stock: 106, addPrice: 0, level: 1, options: [] },
          { id: 608086691, name: '사이즈', value: '2XL(110)', stock: 59, addPrice: 0, level: 1, options: [] },
        ],
        minAddPrice: 0,
        maxAddPrice: 0,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '색상',
        value: '선택5)화이트',
        level: 0,
        images: [],
        options: [
          { id: 593100092, name: '사이즈', value: 'S(90)', stock: 299, addPrice: 0, level: 1, options: [] },
          { id: 593100093, name: '사이즈', value: 'M(95)', stock: 328, addPrice: 0, level: 1, options: [] },
          { id: 593100094, name: '사이즈', value: 'L(100)', stock: 260, addPrice: 0, level: 1, options: [] },
          { id: 593100095, name: '사이즈', value: 'XL(105)', stock: 177, addPrice: 0, level: 1, options: [] },
          { id: 593100096, name: '사이즈', value: '2XL(110)', stock: 76, addPrice: 0, level: 1, options: [] },
        ],
        minAddPrice: 0,
        maxAddPrice: 0,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '색상',
        value: '선택6)블랙',
        level: 0,
        images: [],
        options: [
          { id: 538647951, name: '사이즈', value: 'S(90)', stock: 216, addPrice: 0, level: 1, options: [] },
          { id: 538647952, name: '사이즈', value: 'M(95)', stock: 325, addPrice: 0, level: 1, options: [] },
          { id: 538647953, name: '사이즈', value: 'L(100)', stock: 297, addPrice: 0, level: 1, options: [] },
          { id: 538647954, name: '사이즈', value: 'XL(105)', stock: 203, addPrice: 0, level: 1, options: [] },
          { id: 568345493, name: '사이즈', value: '2XL(110)', stock: 165, addPrice: 0, level: 1, options: [] },
        ],
        minAddPrice: 0,
        maxAddPrice: 0,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '색상',
        value: '선택6)그린',
        level: 0,
        images: [],
        options: [
          { id: 608086692, name: '사이즈', value: 'S(90)', stock: 223, addPrice: 0, level: 1, options: [] },
          { id: 608086693, name: '사이즈', value: 'M(95)', stock: 264, addPrice: 0, level: 1, options: [] },
          { id: 608086694, name: '사이즈', value: 'L(100)', stock: 294, addPrice: 0, level: 1, options: [] },
          { id: 608086695, name: '사이즈', value: 'XL(105)', stock: 135, addPrice: 0, level: 1, options: [] },
          { id: 608086696, name: '사이즈', value: '2XL(110)', stock: 106, addPrice: 0, level: 1, options: [] },
        ],
        minAddPrice: 0,
        maxAddPrice: 0,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '색상',
        value: '선택6)멜란지화이트',
        level: 0,
        images: [],
        options: [
          { id: 608086697, name: '사이즈', value: 'S(90)', stock: 297, addPrice: 0, level: 1, options: [] },
          { id: 608086698, name: '사이즈', value: 'M(95)', stock: 360, addPrice: 0, level: 1, options: [] },
          { id: 608086699, name: '사이즈', value: 'L(100)', stock: 268, addPrice: 0, level: 1, options: [] },
          { id: 608086700, name: '사이즈', value: 'XL(105)', stock: 198, addPrice: 0, level: 1, options: [] },
          { id: 608086701, name: '사이즈', value: '2XL(110)', stock: 120, addPrice: 0, level: 1, options: [] },
        ],
        minAddPrice: 0,
        maxAddPrice: 0,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '색상',
        value: '선택6)화이트',
        level: 0,
        images: [],
        options: [
          { id: 593100107, name: '사이즈', value: 'S(90)', stock: 338, addPrice: 0, level: 1, options: [] },
          { id: 593100108, name: '사이즈', value: 'M(95)', stock: 308, addPrice: 0, level: 1, options: [] },
          { id: 593100109, name: '사이즈', value: 'L(100)', stock: 197, addPrice: 0, level: 1, options: [] },
          { id: 593100110, name: '사이즈', value: 'XL(105)', stock: 130, addPrice: 0, level: 1, options: [] },
          { id: 593100111, name: '사이즈', value: '2XL(110)', stock: 59, addPrice: 0, level: 1, options: [] },
        ],
        minAddPrice: 0,
        maxAddPrice: 0,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '색상',
        value: '선택7)블랙',
        level: 0,
        images: [],
        options: [
          { id: 608086702, name: '사이즈', value: 'S(26~27)', stock: 186, addPrice: 9100, level: 1, options: [] },
          { id: 608086703, name: '사이즈', value: 'M(28~30)', stock: 283, addPrice: 9100, level: 1, options: [] },
          { id: 608086704, name: '사이즈', value: 'L(31~32)', stock: 242, addPrice: 9100, level: 1, options: [] },
          { id: 608086705, name: '사이즈', value: 'XL(33~34)', stock: 214, addPrice: 9100, level: 1, options: [] },
        ],
        minAddPrice: 9100,
        maxAddPrice: 9100,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '색상',
        value: '선택7)그린',
        level: 0,
        images: [],
        options: [
          { id: 608086706, name: '사이즈', value: 'S(26~27)', stock: 118, addPrice: 9100, level: 1, options: [] },
          { id: 608086707, name: '사이즈', value: 'M(28~30)', stock: 163, addPrice: 9100, level: 1, options: [] },
          { id: 608086708, name: '사이즈', value: 'L(31~32)', stock: 201, addPrice: 9100, level: 1, options: [] },
          { id: 608086709, name: '사이즈', value: 'XL(33~34)', stock: 198, addPrice: 9100, level: 1, options: [] },
        ],
        minAddPrice: 9100,
        maxAddPrice: 9100,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '색상',
        value: '선택8)블랙',
        level: 0,
        images: [],
        options: [
          { id: 608086710, name: '사이즈', value: 'S(26~27)', stock: 201, addPrice: 9100, level: 1, options: [] },
          { id: 608086711, name: '사이즈', value: 'M(28~30)', stock: 340, addPrice: 9100, level: 1, options: [] },
          { id: 608086712, name: '사이즈', value: 'L(31~32)', stock: 285, addPrice: 9100, level: 1, options: [] },
          { id: 608086713, name: '사이즈', value: 'XL(33~34)', stock: 309, addPrice: 9100, level: 1, options: [] },
        ],
        minAddPrice: 9100,
        maxAddPrice: 9100,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '색상',
        value: '선택8)다크그레이',
        level: 0,
        images: [],
        options: [
          { id: 608086714, name: '사이즈', value: 'S(26~27)', stock: 138, addPrice: 9100, level: 1, options: [] },
          { id: 608086715, name: '사이즈', value: 'M(28~30)', stock: 254, addPrice: 9100, level: 1, options: [] },
          { id: 608086716, name: '사이즈', value: 'L(31~32)', stock: 245, addPrice: 9100, level: 1, options: [] },
          { id: 608086717, name: '사이즈', value: 'XL(33~34)', stock: 225, addPrice: 9100, level: 1, options: [] },
        ],
        minAddPrice: 9100,
        maxAddPrice: 9100,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '색상',
        value: '선택8)네이비',
        level: 0,
        images: [],
        options: [
          { id: 608086718, name: '사이즈', value: 'S(26~27)', stock: 200, addPrice: 9100, level: 1, options: [] },
          { id: 608086719, name: '사이즈', value: 'M(28~30)', stock: 255, addPrice: 9100, level: 1, options: [] },
          { id: 608086720, name: '사이즈', value: 'L(31~32)', stock: 215, addPrice: 9100, level: 1, options: [] },
          { id: 608086721, name: '사이즈', value: 'XL(33~34)', stock: 208, addPrice: 9100, level: 1, options: [] },
        ],
        minAddPrice: 9100,
        maxAddPrice: 9100,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '색상',
        value: '선택9)블랙',
        level: 0,
        images: [],
        options: [
          { id: 608086722, name: '사이즈', value: 'S(90)', stock: 494, addPrice: 2200, level: 1, options: [] },
          { id: 608086723, name: '사이즈', value: 'M(95)', stock: 688, addPrice: 2200, level: 1, options: [] },
          { id: 608086724, name: '사이즈', value: 'L(100)', stock: 685, addPrice: 2200, level: 1, options: [] },
          { id: 608086725, name: '사이즈', value: 'XL(105)', stock: 392, addPrice: 2200, level: 1, options: [] },
          { id: 608086726, name: '사이즈', value: '2XL(110)', stock: 258, addPrice: 2200, level: 1, options: [] },
        ],
        minAddPrice: 2200,
        maxAddPrice: 2200,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '색상',
        value: '선택9)카키',
        level: 0,
        images: [],
        options: [
          { id: 608086727, name: '사이즈', value: 'S(90)', stock: 98, addPrice: 2200, level: 1, options: [] },
          { id: 608086728, name: '사이즈', value: 'M(95)', stock: 129, addPrice: 2200, level: 1, options: [] },
          { id: 608086729, name: '사이즈', value: 'L(100)', stock: 114, addPrice: 2200, level: 1, options: [] },
          { id: 608086730, name: '사이즈', value: 'XL(105)', stock: 96, addPrice: 2200, level: 1, options: [] },
          { id: 608086731, name: '사이즈', value: '2XL(110)', stock: 48, addPrice: 2200, level: 1, options: [] },
        ],
        minAddPrice: 2200,
        maxAddPrice: 2200,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '색상',
        value: '선택9)라이트오렌지',
        level: 0,
        images: [],
        options: [
          { id: 608086732, name: '사이즈', value: 'S(90)', stock: 134, addPrice: 2200, level: 1, options: [] },
          { id: 608086733, name: '사이즈', value: 'M(95)', stock: 98, addPrice: 2200, level: 1, options: [] },
          { id: 608086734, name: '사이즈', value: 'L(100)', stock: 66, addPrice: 2200, level: 1, options: [] },
          { id: 608086735, name: '사이즈', value: 'XL(105)', stock: 59, addPrice: 2200, level: 1, options: [] },
          { id: 608086736, name: '사이즈', value: '2XL(110)', stock: 26, addPrice: 2200, level: 1, options: [] },
        ],
        minAddPrice: 2200,
        maxAddPrice: 2200,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '색상',
        value: '선택9)그레이',
        level: 0,
        images: [],
        options: [
          { id: 608086737, name: '사이즈', value: 'S(90)', stock: 99, addPrice: 2200, level: 1, options: [] },
          { id: 608086738, name: '사이즈', value: 'M(95)', stock: 99, addPrice: 2200, level: 1, options: [] },
          { id: 608086739, name: '사이즈', value: 'L(100)', stock: 95, addPrice: 2200, level: 1, options: [] },
          { id: 608086740, name: '사이즈', value: 'XL(105)', stock: 100, addPrice: 2200, level: 1, options: [] },
          { id: 608086741, name: '사이즈', value: '2XL(110)', stock: 42, addPrice: 2200, level: 1, options: [] },
        ],
        minAddPrice: 2200,
        maxAddPrice: 2200,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '색상',
        value: '선택9)멜란지화이트',
        level: 0,
        images: [],
        options: [
          { id: 608086742, name: '사이즈', value: 'S(90)', stock: 515, addPrice: 2200, level: 1, options: [] },
          { id: 608086743, name: '사이즈', value: 'M(95)', stock: 657, addPrice: 2200, level: 1, options: [] },
          { id: 608086744, name: '사이즈', value: 'L(100)', stock: 495, addPrice: 2200, level: 1, options: [] },
          { id: 608086745, name: '사이즈', value: 'XL(105)', stock: 349, addPrice: 2200, level: 1, options: [] },
          { id: 608086746, name: '사이즈', value: '2XL(110)', stock: 178, addPrice: 2200, level: 1, options: [] },
        ],
        minAddPrice: 2200,
        maxAddPrice: 2200,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '색상',
        value: '선택9)네이비',
        level: 0,
        images: [],
        options: [
          { id: 568345536, name: '사이즈', value: 'S(90)', stock: 196, addPrice: 2200, level: 1, options: [] },
          { id: 568345537, name: '사이즈', value: 'M(95)', stock: 226, addPrice: 2200, level: 1, options: [] },
          { id: 568345538, name: '사이즈', value: 'L(100)', stock: 260, addPrice: 2200, level: 1, options: [] },
          { id: 568345539, name: '사이즈', value: 'XL(105)', stock: 192, addPrice: 2200, level: 1, options: [] },
          { id: 608086747, name: '사이즈', value: '2XL(110)', stock: 125, addPrice: 2200, level: 1, options: [] },
        ],
        minAddPrice: 2200,
        maxAddPrice: 2200,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '색상',
        value: '선택9)스카이블루',
        level: 0,
        images: [],
        options: [
          { id: 608086748, name: '사이즈', value: 'S(90)', stock: 128, addPrice: 2200, level: 1, options: [] },
          { id: 608086749, name: '사이즈', value: 'M(95)', stock: 207, addPrice: 2200, level: 1, options: [] },
          { id: 608086750, name: '사이즈', value: 'L(100)', stock: 67, addPrice: 2200, level: 1, options: [] },
          { id: 608086751, name: '사이즈', value: 'XL(105)', stock: 66, addPrice: 2200, level: 1, options: [] },
          { id: 608086752, name: '사이즈', value: '2XL(110)', stock: 28, addPrice: 2200, level: 1, options: [] },
        ],
        minAddPrice: 2200,
        maxAddPrice: 2200,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '색상',
        value: '선택9)화이트',
        level: 0,
        images: [],
        options: [
          { id: 608086753, name: '사이즈', value: 'S(90)', stock: 783, addPrice: 2200, level: 1, options: [] },
          { id: 608086754, name: '사이즈', value: 'M(95)', stock: 784, addPrice: 2200, level: 1, options: [] },
          { id: 608086755, name: '사이즈', value: 'L(100)', stock: 388, addPrice: 2200, level: 1, options: [] },
          { id: 608086756, name: '사이즈', value: 'XL(105)', stock: 238, addPrice: 2200, level: 1, options: [] },
          { id: 608086757, name: '사이즈', value: '2XL(110)', stock: 88, addPrice: 2200, level: 1, options: [] },
        ],
        minAddPrice: 2200,
        maxAddPrice: 2200,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '색상',
        value: '선택10)블랙',
        level: 0,
        images: [],
        options: [
          { id: 593100130, name: '사이즈', value: 'S(90)', stock: 58, addPrice: 11200, level: 1, options: [] },
          { id: 593100131, name: '사이즈', value: 'M(95)', stock: 99, addPrice: 11200, level: 1, options: [] },
          { id: 593100132, name: '사이즈', value: 'L(100)', stock: 99, addPrice: 11200, level: 1, options: [] },
          { id: 593100133, name: '사이즈', value: 'XL(105)', stock: 75, addPrice: 11200, level: 1, options: [] },
        ],
        minAddPrice: 11200,
        maxAddPrice: 11200,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '색상',
        value: '선택10)그린',
        level: 0,
        images: [],
        options: [
          { id: 608086758, name: '사이즈', value: 'S(90)', stock: 70, addPrice: 11200, level: 1, options: [] },
          { id: 608086759, name: '사이즈', value: 'M(95)', stock: 70, addPrice: 11200, level: 1, options: [] },
          { id: 608086760, name: '사이즈', value: 'L(100)', stock: 79, addPrice: 11200, level: 1, options: [] },
          { id: 608086761, name: '사이즈', value: 'XL(105)', stock: 22, addPrice: 11200, level: 1, options: [] },
        ],
        minAddPrice: 11200,
        maxAddPrice: 11200,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '색상',
        value: '선택10)화이트',
        level: 0,
        images: [],
        options: [
          { id: 608086762, name: '사이즈', value: 'S(90)', stock: 96, addPrice: 11200, level: 1, options: [] },
          { id: 608086763, name: '사이즈', value: 'M(95)', stock: 78, addPrice: 11200, level: 1, options: [] },
          { id: 608086764, name: '사이즈', value: 'L(100)', stock: 79, addPrice: 11200, level: 1, options: [] },
          { id: 608086765, name: '사이즈', value: 'XL(105)', stock: 60, addPrice: 11200, level: 1, options: [] },
        ],
        minAddPrice: 11200,
        maxAddPrice: 11200,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '색상',
        value: '선택11)블랙',
        level: 0,
        images: [],
        options: [
          { id: 608086766, name: '사이즈', value: 'S(90)', stock: 56, addPrice: 13100, level: 1, options: [] },
          { id: 608086767, name: '사이즈', value: 'M(95)', stock: 43, addPrice: 13100, level: 1, options: [] },
          { id: 608086768, name: '사이즈', value: 'L(100)', stock: 55, addPrice: 13100, level: 1, options: [] },
          { id: 608086769, name: '사이즈', value: 'XL(105)', stock: 86, addPrice: 13100, level: 1, options: [] },
        ],
        minAddPrice: 13100,
        maxAddPrice: 13100,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '색상',
        value: '선택11)화이트',
        level: 0,
        images: [],
        options: [
          { id: 608086770, name: '사이즈', value: 'S(90)', stock: 97, addPrice: 13100, level: 1, options: [] },
          { id: 608086771, name: '사이즈', value: 'M(95)', stock: 79, addPrice: 13100, level: 1, options: [] },
          { id: 608086772, name: '사이즈', value: 'L(100)', stock: 96, addPrice: 13100, level: 1, options: [] },
          { id: 608086773, name: '사이즈', value: 'XL(105)', stock: 37, addPrice: 13100, level: 1, options: [] },
        ],
        minAddPrice: 13100,
        maxAddPrice: 13100,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '색상',
        value: '선택12)다크그린',
        level: 0,
        images: [],
        options: [
          { id: 608086774, name: '사이즈', value: 'S(90)', stock: 47, addPrice: 19100, level: 1, options: [] },
          { id: 608086775, name: '사이즈', value: 'M(95)', stock: 23, addPrice: 19100, level: 1, options: [] },
          { id: 608086776, name: '사이즈', value: 'L(100)', stock: 30, addPrice: 19100, level: 1, options: [] },
          { id: 608086777, name: '사이즈', value: 'XL(105)', stock: 22, addPrice: 19100, level: 1, options: [] },
        ],
        minAddPrice: 19100,
        maxAddPrice: 19100,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '색상',
        value: '선택12)아이보리',
        level: 0,
        images: [],
        options: [
          { id: 608086778, name: '사이즈', value: 'S(90)', stock: 38, addPrice: 19100, level: 1, options: [] },
          { id: 608086779, name: '사이즈', value: 'M(95)', stock: 34, addPrice: 19100, level: 1, options: [] },
          { id: 608086780, name: '사이즈', value: 'L(100)', stock: 40, addPrice: 19100, level: 1, options: [] },
          { id: 608086781, name: '사이즈', value: 'XL(105)', stock: 9, addPrice: 19100, level: 1, options: [] },
        ],
        minAddPrice: 19100,
        maxAddPrice: 19100,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '색상',
        value: '선택13)민트',
        level: 0,
        images: [],
        options: [
          { id: 608086782, name: '사이즈', value: 'S(90)', stock: 145, addPrice: 13100, level: 1, options: [] },
          { id: 608086783, name: '사이즈', value: 'M(95)', stock: 62, addPrice: 13100, level: 1, options: [] },
          { id: 608086784, name: '사이즈', value: 'L(100)', stock: 50, addPrice: 13100, level: 1, options: [] },
          { id: 608086785, name: '사이즈', value: 'XL(105)', stock: 27, addPrice: 13100, level: 1, options: [] },
        ],
        minAddPrice: 13100,
        maxAddPrice: 13100,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '색상',
        value: '선택13)화이트',
        level: 0,
        images: [],
        options: [
          { id: 608086786, name: '사이즈', value: 'S(90)', stock: 121, addPrice: 13100, level: 1, options: [] },
          { id: 608086787, name: '사이즈', value: 'M(95)', stock: 137, addPrice: 13100, level: 1, options: [] },
          { id: 608086788, name: '사이즈', value: 'L(100)', stock: 92, addPrice: 13100, level: 1, options: [] },
          { id: 608086789, name: '사이즈', value: 'XL(105)', stock: 63, addPrice: 13100, level: 1, options: [] },
        ],
        minAddPrice: 13100,
        maxAddPrice: 13100,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '색상',
        value: '선택14)블랙',
        level: 0,
        images: [],
        options: [
          { id: 608086790, name: '사이즈', value: 'S(90)', stock: 97, addPrice: 7200, level: 1, options: [] },
          { id: 608086791, name: '사이즈', value: 'M(95)', stock: 241, addPrice: 7200, level: 1, options: [] },
          { id: 608086792, name: '사이즈', value: 'L(100)', stock: 189, addPrice: 7200, level: 1, options: [] },
          { id: 608086793, name: '사이즈', value: 'XL(105)', stock: 130, addPrice: 7200, level: 1, options: [] },
          { id: 608086794, name: '사이즈', value: '2XL(110)', stock: 40, addPrice: 7200, level: 1, options: [] },
        ],
        minAddPrice: 7200,
        maxAddPrice: 7200,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '색상',
        value: '선택14)네이비',
        level: 0,
        images: [],
        options: [
          { id: 608086795, name: '사이즈', value: 'S(90)', stock: 96, addPrice: 7200, level: 1, options: [] },
          { id: 608086796, name: '사이즈', value: 'M(95)', stock: 147, addPrice: 7200, level: 1, options: [] },
          { id: 608086797, name: '사이즈', value: 'L(100)', stock: 97, addPrice: 7200, level: 1, options: [] },
          { id: 608086798, name: '사이즈', value: 'XL(105)', stock: 54, addPrice: 7200, level: 1, options: [] },
          { id: 608086799, name: '사이즈', value: '2XL(110)', stock: 26, addPrice: 7200, level: 1, options: [] },
        ],
        minAddPrice: 7200,
        maxAddPrice: 7200,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '색상',
        value: '선택15)블랙',
        level: 0,
        images: [],
        options: [
          { id: 608086800, name: '사이즈', value: 'S(26~27)', stock: 51, addPrice: 17000, level: 1, options: [] },
          { id: 608086801, name: '사이즈', value: 'M(28~30)', stock: 177, addPrice: 17000, level: 1, options: [] },
          { id: 608086802, name: '사이즈', value: 'L(31~32)', stock: 139, addPrice: 17000, level: 1, options: [] },
          { id: 608086803, name: '사이즈', value: 'XL(33~34)', stock: 126, addPrice: 17000, level: 1, options: [] },
        ],
        minAddPrice: 17000,
        maxAddPrice: 17000,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '색상',
        value: '선택15)네이비',
        level: 0,
        images: [],
        options: [
          { id: 608086804, name: '사이즈', value: 'S(26~27)', stock: 69, addPrice: 17000, level: 1, options: [] },
          { id: 608086805, name: '사이즈', value: 'M(28~30)', stock: 99, addPrice: 17000, level: 1, options: [] },
          { id: 608086806, name: '사이즈', value: 'L(31~32)', stock: 97, addPrice: 17000, level: 1, options: [] },
          { id: 608086807, name: '사이즈', value: 'XL(33~34)', stock: 99, addPrice: 17000, level: 1, options: [] },
        ],
        minAddPrice: 17000,
        maxAddPrice: 17000,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '색상',
        value: '선택16)베이지',
        level: 0,
        images: [],
        options: [
          { id: 608086808, name: '사이즈', value: '26', stock: 99, addPrice: 24100, level: 1, options: [] },
          { id: 608086809, name: '사이즈', value: '28', stock: 69, addPrice: 24100, level: 1, options: [] },
          { id: 608086810, name: '사이즈', value: '30', stock: 95, addPrice: 24100, level: 1, options: [] },
          { id: 608086811, name: '사이즈', value: '32', stock: 95, addPrice: 24100, level: 1, options: [] },
          { id: 608086812, name: '사이즈', value: '34', stock: 75, addPrice: 24100, level: 1, options: [] },
        ],
        minAddPrice: 24100,
        maxAddPrice: 24100,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '색상',
        value: '선택16)블랙',
        level: 0,
        images: [],
        options: [
          { id: 608086813, name: '사이즈', value: '26', stock: 119, addPrice: 24100, level: 1, options: [] },
          { id: 608086814, name: '사이즈', value: '28', stock: 74, addPrice: 24100, level: 1, options: [] },
          { id: 608086815, name: '사이즈', value: '30', stock: 167, addPrice: 24100, level: 1, options: [] },
          { id: 608086816, name: '사이즈', value: '32', stock: 103, addPrice: 24100, level: 1, options: [] },
          { id: 608086817, name: '사이즈', value: '34', stock: 117, addPrice: 24100, level: 1, options: [] },
        ],
        minAddPrice: 24100,
        maxAddPrice: 24100,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '색상',
        value: '선택16)카키',
        level: 0,
        images: [],
        options: [
          { id: 608086818, name: '사이즈', value: '26', stock: 169, addPrice: 24100, level: 1, options: [] },
          { id: 608086819, name: '사이즈', value: '28', stock: 127, addPrice: 24100, level: 1, options: [] },
          { id: 608086820, name: '사이즈', value: '30', stock: 137, addPrice: 24100, level: 1, options: [] },
          { id: 608086821, name: '사이즈', value: '32', stock: 113, addPrice: 24100, level: 1, options: [] },
          { id: 608086822, name: '사이즈', value: '34', stock: 98, addPrice: 24100, level: 1, options: [] },
        ],
        minAddPrice: 24100,
        maxAddPrice: 24100,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '색상',
        value: '선택16)오프화이트',
        level: 0,
        images: [],
        options: [
          { id: 608086823, name: '사이즈', value: '26', stock: 96, addPrice: 24100, level: 1, options: [] },
          { id: 608086824, name: '사이즈', value: '28', stock: 78, addPrice: 24100, level: 1, options: [] },
          { id: 608086825, name: '사이즈', value: '30', stock: 99, addPrice: 24100, level: 1, options: [] },
          { id: 608086826, name: '사이즈', value: '32', stock: 99, addPrice: 24100, level: 1, options: [] },
          { id: 608086827, name: '사이즈', value: '34', stock: 44, addPrice: 24100, level: 1, options: [] },
        ],
        minAddPrice: 24100,
        maxAddPrice: 24100,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '색상',
        value: '선택17)블랙',
        level: 0,
        images: [],
        options: [
          { id: 608086828, name: '사이즈', value: 'S(26~27)', stock: 112, addPrice: 15300, level: 1, options: [] },
          { id: 608086829, name: '사이즈', value: 'M(28~30)', stock: 140, addPrice: 15300, level: 1, options: [] },
          { id: 608086830, name: '사이즈', value: 'L(31~32)', stock: 96, addPrice: 15300, level: 1, options: [] },
          { id: 608086831, name: '사이즈', value: 'XL(33~34)', stock: 90, addPrice: 15300, level: 1, options: [] },
        ],
        minAddPrice: 15300,
        maxAddPrice: 15300,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '색상',
        value: '선택17)블루',
        level: 0,
        images: [],
        options: [
          { id: 608086832, name: '사이즈', value: 'S(26~27)', stock: 119, addPrice: 15300, level: 1, options: [] },
          { id: 608086833, name: '사이즈', value: 'M(28~30)', stock: 150, addPrice: 15300, level: 1, options: [] },
          { id: 608086834, name: '사이즈', value: 'L(31~32)', stock: 109, addPrice: 15300, level: 1, options: [] },
          { id: 608086835, name: '사이즈', value: 'XL(33~34)', stock: 40, addPrice: 15300, level: 1, options: [] },
        ],
        minAddPrice: 15300,
        maxAddPrice: 15300,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '색상',
        value: '선택17)그레이',
        level: 0,
        images: [],
        options: [
          { id: 608086836, name: '사이즈', value: 'S(26~27)', stock: 135, addPrice: 15300, level: 1, options: [] },
          { id: 608086837, name: '사이즈', value: 'M(28~30)', stock: 191, addPrice: 15300, level: 1, options: [] },
          { id: 608086838, name: '사이즈', value: 'L(31~32)', stock: 154, addPrice: 15300, level: 1, options: [] },
          { id: 608086839, name: '사이즈', value: 'XL(33~34)', stock: 104, addPrice: 15300, level: 1, options: [] },
        ],
        minAddPrice: 15300,
        maxAddPrice: 15300,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '색상',
        value: '선택18)블랙',
        level: 0,
        images: [],
        options: [
          { id: 607854306, name: '사이즈', value: 'S(90)', stock: 29, addPrice: 33000, level: 1, options: [] },
          { id: 607854307, name: '사이즈', value: 'M(95)', stock: 127, addPrice: 33000, level: 1, options: [] },
          { id: 607854308, name: '사이즈', value: 'L(100)', stock: 82, addPrice: 33000, level: 1, options: [] },
          { id: 607854309, name: '사이즈', value: 'XL(105)', stock: 37, addPrice: 33000, level: 1, options: [] },
          { id: 607854310, name: '사이즈', value: '2XL(110)', stock: 31, addPrice: 33000, level: 1, options: [] },
        ],
        minAddPrice: 33000,
        maxAddPrice: 33000,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '색상',
        value: '선택18)그레이',
        level: 0,
        images: [],
        options: [
          { id: 607854301, name: '사이즈', value: 'S(90)', stock: 32, addPrice: 33000, level: 1, options: [] },
          { id: 607854302, name: '사이즈', value: 'M(95)', stock: 41, addPrice: 33000, level: 1, options: [] },
          { id: 607854303, name: '사이즈', value: 'L(100)', stock: 32, addPrice: 33000, level: 1, options: [] },
          { id: 607854304, name: '사이즈', value: 'XL(105)', stock: 31, addPrice: 33000, level: 1, options: [] },
          { id: 607854305, name: '사이즈', value: '2XL(110)', stock: 17, addPrice: 33000, level: 1, options: [] },
        ],
        minAddPrice: 33000,
        maxAddPrice: 33000,
        hasSoldOut: false,
        soldOut: false,
      },
    ],
    customs: [],
  },
  24832184: {
    type: 'COMBINATION',
    names: ['옵션'],
    options: [
      {
        id: 603724818,
        name: '옵션',
        value: '1.인튜이션 혼합(제모기1+날4)+눈썹칼 4입',
        stock: 9679,
        addPrice: 0,
        level: 0,
        images: [],
        options: [],
      },
      {
        id: 603724819,
        name: '옵션',
        value: '2.인튜이션 그린(제모기1+날4)+눈썹칼 4입',
        stock: 9904,
        addPrice: 0,
        level: 0,
        images: [],
        options: [],
      },
      {
        id: 603724820,
        name: '옵션',
        value: '3.인튜이션 보라(제모기1+날4)+눈썹칼 4입',
        stock: 9839,
        addPrice: 0,
        level: 0,
        images: [],
        options: [],
      },
      {
        id: 603724821,
        name: '옵션',
        value: '4.인튜이션클럽(제모기1+날7)+포켓몬여행세트',
        stock: 9884,
        addPrice: 6000,
        level: 0,
        images: [],
        options: [],
      },
      {
        id: 603724822,
        name: '옵션',
        value: '5.인튜이션 퍼펙트터치 (제모기1+날2)',
        stock: 9894,
        addPrice: -5000,
        level: 0,
        images: [],
        options: [],
      },
      {
        id: 603724823,
        name: '옵션',
        value: '6.인튜이션 퍼펙트터치 리필 (날4)',
        stock: 9969,
        addPrice: -5000,
        level: 0,
        images: [],
        options: [],
      },
      {
        id: 603724824,
        name: '옵션',
        value: '7.인튜이션퍼펙트(제모기1+날2)+리필(날4)',
        stock: 9825,
        addPrice: 0,
        level: 0,
        images: [],
        options: [],
      },
      {
        id: 603724825,
        name: '옵션',
        value: '8.퓨어시카 아크네케어 바디워시 1L 2개',
        stock: 9980,
        addPrice: -3000,
        level: 0,
        images: [],
        options: [],
      },
      {
        id: 603724826,
        name: '옵션',
        value: '9.포켓몬 핸드크림 푸린 50ml 2개',
        stock: 9995,
        addPrice: -6900,
        level: 0,
        images: [],
        options: [],
      },
      {
        id: 603724827,
        name: '옵션',
        value: '10.퓨어시카바디로션 730ml 머스크+파우더',
        stock: 9988,
        addPrice: -1000,
        level: 0,
        images: [],
        options: [],
      },
      {
        id: 603724828,
        name: '옵션',
        value: '11.퓨어시카 바디로션 730ml 파우더 2개',
        stock: 9997,
        addPrice: -1000,
        level: 0,
        images: [],
        options: [],
      },
      {
        id: 603724829,
        name: '옵션',
        value: '12.퓨어시카 바디로션 730ml 머스크 2개',
        stock: 9999,
        addPrice: -1000,
        level: 0,
        images: [],
        options: [],
      },
    ],
    customs: [],
  },
  164308681: {
    type: 'COMBINATION',
    names: ['선택1'],
    options: [
      {
        id: 548255453,
        name: '선택1',
        value: '포카칩 오리지널4+오징어땅콩3+치킨팝닭강정 3',
        stock: 239,
        addPrice: 0,
        level: 0,
        images: [],
        options: [],
      },
      {
        id: 548255454,
        name: '선택1',
        value: '스윙칩 볶음고추장4+스윙칩 갈릭디핑3+고소미3',
        stock: 443,
        addPrice: 0,
        level: 0,
        images: [],
        options: [],
      },
      {
        id: 548255455,
        name: '선택1',
        value: '와클 4 +무뚝뚝감자칩 3+고래밥 볶음 3',
        stock: 518,
        addPrice: 0,
        level: 0,
        images: [],
        options: [],
      },
      {
        id: 548255456,
        name: '선택1',
        value: '꼬북칩 초코츄러스4+대왕오감자 3+초코송이3',
        stock: 603,
        addPrice: 0,
        level: 0,
        images: [],
        options: [],
      },
      {
        id: 548255457,
        name: '선택1',
        value: '썬핫스파이시4+ 썬 갈릭바게트3+ 통크3',
        stock: 541,
        addPrice: 0,
        level: 0,
        images: [],
        options: [],
      },
      {
        id: 548255458,
        name: '선택1',
        value: '꼬북칩 초코츄러스 5 +예감 오리지널 5',
        stock: 724,
        addPrice: 0,
        level: 0,
        images: [],
        options: [],
      },
      {
        id: 548255459,
        name: '선택1',
        value: '마켓오 오징어톡 5 + 예감 치즈그라탕 5',
        stock: 645,
        addPrice: 0,
        level: 0,
        images: [],
        options: [],
      },
      {
        id: 548255460,
        name: '선택1',
        value: '나 치즈샌드 5 + 다이제 샌드5',
        stock: 567,
        addPrice: 0,
        level: 0,
        images: [],
        options: [],
      },
      {
        id: 548255461,
        name: '선택1',
        value: '모두의 통크(통크 12입)',
        stock: 575,
        addPrice: 0,
        level: 0,
        images: [],
        options: [],
      },
      {
        id: 548255462,
        name: '선택1',
        value: '설렘유발하트박스(초콜릿젤리선물박스)',
        stock: 154,
        addPrice: 1900,
        level: 0,
        images: [],
        options: [],
      },
      {
        id: 548255463,
        name: '선택1',
        value: '송이대장(사파리친구들/과자8종선물세트)',
        stock: 478,
        addPrice: 6500,
        level: 0,
        images: [],
        options: [],
      },
      {
        id: 548255464,
        name: '선택1',
        value: '라두대장(바다친구들/과자8종선물세트)',
        stock: 488,
        addPrice: 6500,
        level: 0,
        images: [],
        options: [],
      },
      {
        id: 548255465,
        name: '선택1',
        value: '놀이간식(과자로만드는캠핑월드)',
        stock: 0,
        addPrice: 6500,
        level: 0,
        images: [],
        options: [],
      },
      {
        id: 607277727,
        name: '선택1',
        value: '달콤서랍(초콜릿젤리선물박스)',
        stock: 486,
        addPrice: 6500,
        level: 0,
        images: [],
        options: [],
      },
    ],
    customs: [],
  },
  227497376: {
    type: 'COMBINATION',
    names: ['000_상품명', '색상', '사이즈'],
    options: [
      {
        name: '000_상품명',
        value: '001_아이비 V넥 반팔니트',
        level: 0,
        images: [],
        options: [
          {
            name: '색상',
            value: '화이트',
            level: 1,
            options: [{ id: 604113988, name: '사이즈', value: 'one size', stock: 465, addPrice: 0, level: 2, options: [] }],
            minAddPrice: 0,
            maxAddPrice: 0,
            soldOut: false,
          },
          {
            name: '색상',
            value: '연베이지',
            level: 1,
            options: [{ id: 604113984, name: '사이즈', value: 'one size', stock: 470, addPrice: 0, level: 2, options: [] }],
            minAddPrice: 0,
            maxAddPrice: 0,
            soldOut: false,
          },
          {
            name: '색상',
            value: '진베이지',
            level: 1,
            options: [{ id: 604113986, name: '사이즈', value: 'one size', stock: 461, addPrice: 0, level: 2, options: [] }],
            minAddPrice: 0,
            maxAddPrice: 0,
            soldOut: false,
          },
          {
            name: '색상',
            value: '올리브',
            level: 1,
            options: [{ id: 604113985, name: '사이즈', value: 'one size', stock: 474, addPrice: 0, level: 2, options: [] }],
            minAddPrice: 0,
            maxAddPrice: 0,
            soldOut: false,
          },
          {
            name: '색상',
            value: '핑크',
            level: 1,
            options: [{ id: 604113987, name: '사이즈', value: 'one size', stock: 0, addPrice: 0, level: 2, options: [] }],
            soldOut: true,
          },
          {
            name: '색상',
            value: '딥핑크',
            level: 1,
            options: [{ id: 604113981, name: '사이즈', value: 'one size', stock: 431, addPrice: 0, level: 2, options: [] }],
            minAddPrice: 0,
            maxAddPrice: 0,
            soldOut: false,
          },
          {
            name: '색상',
            value: '스카이블루',
            level: 1,
            options: [{ id: 604113983, name: '사이즈', value: 'one size', stock: 0, addPrice: 0, level: 2, options: [] }],
            soldOut: true,
          },
          {
            name: '색상',
            value: '블랙',
            level: 1,
            options: [{ id: 604113982, name: '사이즈', value: 'one size', stock: 449, addPrice: 0, level: 2, options: [] }],
            minAddPrice: 0,
            maxAddPrice: 0,
            soldOut: false,
          },
        ],
        minAddPrice: 0,
        maxAddPrice: 0,
        hasSoldOut: true,
        soldOut: false,
      },
      {
        name: '000_상품명',
        value: '002_데이밍 퍼프 트위드자켓',
        level: 0,
        images: [],
        options: [
          {
            name: '색상',
            value: '퍼플',
            level: 1,
            options: [{ id: 608389280, name: '사이즈', value: 'one size', stock: 495, addPrice: 14000, level: 2, options: [] }],
            minAddPrice: 14000,
            maxAddPrice: 14000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '핑크',
            level: 1,
            options: [{ id: 608389281, name: '사이즈', value: 'one size', stock: 497, addPrice: 14000, level: 2, options: [] }],
            minAddPrice: 14000,
            maxAddPrice: 14000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '아이보리',
            level: 1,
            options: [{ id: 608389282, name: '사이즈', value: 'one size', stock: 485, addPrice: 14000, level: 2, options: [] }],
            minAddPrice: 14000,
            maxAddPrice: 14000,
            soldOut: false,
          },
        ],
        minAddPrice: 14000,
        maxAddPrice: 14000,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '000_상품명',
        value: '003_썸머링 린넨 데님팬츠(길이선택)',
        level: 0,
        images: [],
        options: [
          {
            name: '색상',
            value: '진청(숏)',
            level: 1,
            options: [
              { id: 608389283, name: '사이즈', value: 'S', stock: 494, addPrice: 14000, level: 2, options: [] },
              { id: 608389284, name: '사이즈', value: 'M', stock: 493, addPrice: 14000, level: 2, options: [] },
              { id: 608389285, name: '사이즈', value: 'L', stock: 496, addPrice: 14000, level: 2, options: [] },
              { id: 608389286, name: '사이즈', value: 'XL', stock: 500, addPrice: 14000, level: 2, options: [] },
              { id: 608389287, name: '사이즈', value: '2XL', stock: 498, addPrice: 14000, level: 2, options: [] },
            ],
            minAddPrice: 14000,
            maxAddPrice: 14000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '진청(미들)',
            level: 1,
            options: [
              { id: 608389288, name: '사이즈', value: 'S', stock: 499, addPrice: 14000, level: 2, options: [] },
              { id: 608389289, name: '사이즈', value: 'M', stock: 491, addPrice: 14000, level: 2, options: [] },
              { id: 608389290, name: '사이즈', value: 'L', stock: 493, addPrice: 14000, level: 2, options: [] },
              { id: 608389291, name: '사이즈', value: 'XL', stock: 498, addPrice: 14000, level: 2, options: [] },
              { id: 608389292, name: '사이즈', value: '2XL', stock: 499, addPrice: 14000, level: 2, options: [] },
            ],
            minAddPrice: 14000,
            maxAddPrice: 14000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '진청(롱)',
            level: 1,
            options: [
              { id: 608389293, name: '사이즈', value: 'S', stock: 499, addPrice: 14000, level: 2, options: [] },
              { id: 608389294, name: '사이즈', value: 'M', stock: 497, addPrice: 14000, level: 2, options: [] },
              { id: 608389295, name: '사이즈', value: 'L', stock: 499, addPrice: 14000, level: 2, options: [] },
              { id: 608389296, name: '사이즈', value: 'XL', stock: 498, addPrice: 14000, level: 2, options: [] },
              { id: 608389297, name: '사이즈', value: '2XL', stock: 497, addPrice: 14000, level: 2, options: [] },
            ],
            minAddPrice: 14000,
            maxAddPrice: 14000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '연청(숏)',
            level: 1,
            options: [
              { id: 608389298, name: '사이즈', value: 'S', stock: 495, addPrice: 14000, level: 2, options: [] },
              { id: 608389299, name: '사이즈', value: 'M', stock: 491, addPrice: 14000, level: 2, options: [] },
              { id: 608389300, name: '사이즈', value: 'L', stock: 493, addPrice: 14000, level: 2, options: [] },
              { id: 608389301, name: '사이즈', value: 'XL', stock: 498, addPrice: 14000, level: 2, options: [] },
              { id: 608389302, name: '사이즈', value: '2XL', stock: 499, addPrice: 14000, level: 2, options: [] },
            ],
            minAddPrice: 14000,
            maxAddPrice: 14000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '연청(미들)',
            level: 1,
            options: [
              { id: 608389303, name: '사이즈', value: 'S', stock: 496, addPrice: 14000, level: 2, options: [] },
              { id: 608389304, name: '사이즈', value: 'M', stock: 496, addPrice: 14000, level: 2, options: [] },
              { id: 608389305, name: '사이즈', value: 'L', stock: 490, addPrice: 14000, level: 2, options: [] },
              { id: 608389306, name: '사이즈', value: 'XL', stock: 498, addPrice: 14000, level: 2, options: [] },
              { id: 608389307, name: '사이즈', value: '2XL', stock: 500, addPrice: 14000, level: 2, options: [] },
            ],
            minAddPrice: 14000,
            maxAddPrice: 14000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '연청(롱)',
            level: 1,
            options: [
              { id: 608389308, name: '사이즈', value: 'S', stock: 500, addPrice: 14000, level: 2, options: [] },
              { id: 608389309, name: '사이즈', value: 'M', stock: 495, addPrice: 14000, level: 2, options: [] },
              { id: 608389310, name: '사이즈', value: 'L', stock: 497, addPrice: 14000, level: 2, options: [] },
              { id: 608389311, name: '사이즈', value: 'XL', stock: 498, addPrice: 14000, level: 2, options: [] },
              { id: 608389312, name: '사이즈', value: '2XL', stock: 500, addPrice: 14000, level: 2, options: [] },
            ],
            minAddPrice: 14000,
            maxAddPrice: 14000,
            soldOut: false,
          },
        ],
        minAddPrice: 14000,
        maxAddPrice: 14000,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '000_상품명',
        value: '004_리온 버튼 트위드자켓',
        level: 0,
        images: [],
        options: [
          {
            name: '색상',
            value: '스카이블루',
            level: 1,
            options: [{ id: 608389313, name: '사이즈', value: 'one size', stock: 481, addPrice: 18000, level: 2, options: [] }],
            minAddPrice: 18000,
            maxAddPrice: 18000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '크림',
            level: 1,
            options: [{ id: 608389314, name: '사이즈', value: 'one size', stock: 468, addPrice: 18000, level: 2, options: [] }],
            minAddPrice: 18000,
            maxAddPrice: 18000,
            soldOut: false,
          },
        ],
        minAddPrice: 18000,
        maxAddPrice: 18000,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '000_상품명',
        value: '005_[코코메이드] 데일리 모달 반팔티셔츠',
        level: 0,
        images: [],
        options: [
          {
            name: '색상',
            value: '(U넥)베이지',
            level: 1,
            options: [{ id: 608389315, name: '사이즈', value: 'one size', stock: 480, addPrice: 0, level: 2, options: [] }],
            minAddPrice: 0,
            maxAddPrice: 0,
            soldOut: false,
          },
          {
            name: '색상',
            value: '(U넥)블랙',
            level: 1,
            options: [{ id: 608389316, name: '사이즈', value: 'one size', stock: 449, addPrice: 0, level: 2, options: [] }],
            minAddPrice: 0,
            maxAddPrice: 0,
            soldOut: false,
          },
          {
            name: '색상',
            value: '(U넥)스카이블루',
            level: 1,
            options: [{ id: 608389317, name: '사이즈', value: 'one size', stock: 484, addPrice: 0, level: 2, options: [] }],
            minAddPrice: 0,
            maxAddPrice: 0,
            soldOut: false,
          },
          {
            name: '색상',
            value: '(U넥)아이보리',
            level: 1,
            options: [{ id: 608389318, name: '사이즈', value: 'one size', stock: 403, addPrice: 0, level: 2, options: [] }],
            minAddPrice: 0,
            maxAddPrice: 0,
            soldOut: false,
          },
          {
            name: '색상',
            value: '(U넥)옐로우',
            level: 1,
            options: [{ id: 608389319, name: '사이즈', value: 'one size', stock: 486, addPrice: 0, level: 2, options: [] }],
            minAddPrice: 0,
            maxAddPrice: 0,
            soldOut: false,
          },
          {
            name: '색상',
            value: '(라운드)베이지',
            level: 1,
            options: [{ id: 608389320, name: '사이즈', value: 'one size', stock: 486, addPrice: 0, level: 2, options: [] }],
            minAddPrice: 0,
            maxAddPrice: 0,
            soldOut: false,
          },
          {
            name: '색상',
            value: '(라운드)블랙',
            level: 1,
            options: [{ id: 608389321, name: '사이즈', value: 'one size', stock: 472, addPrice: 0, level: 2, options: [] }],
            minAddPrice: 0,
            maxAddPrice: 0,
            soldOut: false,
          },
          {
            name: '색상',
            value: '(라운드)스카이블루',
            level: 1,
            options: [{ id: 608389322, name: '사이즈', value: 'one size', stock: 493, addPrice: 0, level: 2, options: [] }],
            minAddPrice: 0,
            maxAddPrice: 0,
            soldOut: false,
          },
          {
            name: '색상',
            value: '(라운드)아이보리',
            level: 1,
            options: [{ id: 608389323, name: '사이즈', value: 'one size', stock: 482, addPrice: 0, level: 2, options: [] }],
            minAddPrice: 0,
            maxAddPrice: 0,
            soldOut: false,
          },
          {
            name: '색상',
            value: '(라운드)옐로우',
            level: 1,
            options: [{ id: 608389324, name: '사이즈', value: 'one size', stock: 495, addPrice: 0, level: 2, options: [] }],
            minAddPrice: 0,
            maxAddPrice: 0,
            soldOut: false,
          },
        ],
        minAddPrice: 0,
        maxAddPrice: 0,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '000_상품명',
        value: '006_쿨썸머 투데이 와이드 슬랙스(길이선택)',
        level: 0,
        images: [],
        options: [
          {
            name: '색상',
            value: '블랙(숏)',
            level: 1,
            options: [
              { id: 608389325, name: '사이즈', value: 'S', stock: 492, addPrice: 10000, level: 2, options: [] },
              { id: 608389326, name: '사이즈', value: 'M', stock: 490, addPrice: 10000, level: 2, options: [] },
              { id: 608389327, name: '사이즈', value: 'L', stock: 496, addPrice: 10000, level: 2, options: [] },
              { id: 608389328, name: '사이즈', value: 'XL', stock: 499, addPrice: 10000, level: 2, options: [] },
              { id: 608389329, name: '사이즈', value: '2XL', stock: 498, addPrice: 10000, level: 2, options: [] },
            ],
            minAddPrice: 10000,
            maxAddPrice: 10000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '블랙(미들)',
            level: 1,
            options: [
              { id: 608389330, name: '사이즈', value: 'S', stock: 496, addPrice: 10000, level: 2, options: [] },
              { id: 608389331, name: '사이즈', value: 'M', stock: 495, addPrice: 10000, level: 2, options: [] },
              { id: 608389332, name: '사이즈', value: 'L', stock: 495, addPrice: 10000, level: 2, options: [] },
              { id: 608389333, name: '사이즈', value: 'XL', stock: 499, addPrice: 10000, level: 2, options: [] },
              { id: 608389334, name: '사이즈', value: '2XL', stock: 497, addPrice: 10000, level: 2, options: [] },
            ],
            minAddPrice: 10000,
            maxAddPrice: 10000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '블랙(롱)',
            level: 1,
            options: [
              { id: 608389335, name: '사이즈', value: 'S', stock: 498, addPrice: 10000, level: 2, options: [] },
              { id: 608389336, name: '사이즈', value: 'M', stock: 498, addPrice: 10000, level: 2, options: [] },
              { id: 608389337, name: '사이즈', value: 'L', stock: 496, addPrice: 10000, level: 2, options: [] },
              { id: 608389338, name: '사이즈', value: 'XL', stock: 498, addPrice: 10000, level: 2, options: [] },
              { id: 608389339, name: '사이즈', value: '2XL', stock: 499, addPrice: 10000, level: 2, options: [] },
            ],
            minAddPrice: 10000,
            maxAddPrice: 10000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '그레이(숏)',
            level: 1,
            options: [
              { id: 608389340, name: '사이즈', value: 'S', stock: 497, addPrice: 10000, level: 2, options: [] },
              { id: 608389341, name: '사이즈', value: 'M', stock: 488, addPrice: 10000, level: 2, options: [] },
              { id: 608389342, name: '사이즈', value: 'L', stock: 499, addPrice: 10000, level: 2, options: [] },
              { id: 608389343, name: '사이즈', value: 'XL', stock: 500, addPrice: 10000, level: 2, options: [] },
              { id: 608389344, name: '사이즈', value: '2XL', stock: 500, addPrice: 10000, level: 2, options: [] },
            ],
            minAddPrice: 10000,
            maxAddPrice: 10000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '그레이(미들)',
            level: 1,
            options: [
              { id: 608389345, name: '사이즈', value: 'S', stock: 497, addPrice: 10000, level: 2, options: [] },
              { id: 608389346, name: '사이즈', value: 'M', stock: 496, addPrice: 10000, level: 2, options: [] },
              { id: 608389347, name: '사이즈', value: 'L', stock: 499, addPrice: 10000, level: 2, options: [] },
              { id: 608389348, name: '사이즈', value: 'XL', stock: 498, addPrice: 10000, level: 2, options: [] },
              { id: 608389349, name: '사이즈', value: '2XL', stock: 500, addPrice: 10000, level: 2, options: [] },
            ],
            minAddPrice: 10000,
            maxAddPrice: 10000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '그레이(롱)',
            level: 1,
            options: [
              { id: 608389350, name: '사이즈', value: 'S', stock: 498, addPrice: 10000, level: 2, options: [] },
              { id: 608389351, name: '사이즈', value: 'M', stock: 497, addPrice: 10000, level: 2, options: [] },
              { id: 608389352, name: '사이즈', value: 'L', stock: 495, addPrice: 10000, level: 2, options: [] },
              { id: 608389353, name: '사이즈', value: 'XL', stock: 499, addPrice: 10000, level: 2, options: [] },
              { id: 608389354, name: '사이즈', value: '2XL', stock: 500, addPrice: 10000, level: 2, options: [] },
            ],
            minAddPrice: 10000,
            maxAddPrice: 10000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '베이지(숏)',
            level: 1,
            options: [
              { id: 608389355, name: '사이즈', value: 'S', stock: 493, addPrice: 10000, level: 2, options: [] },
              { id: 608389356, name: '사이즈', value: 'M', stock: 487, addPrice: 10000, level: 2, options: [] },
              { id: 608389357, name: '사이즈', value: 'L', stock: 498, addPrice: 10000, level: 2, options: [] },
              { id: 608389358, name: '사이즈', value: 'XL', stock: 498, addPrice: 10000, level: 2, options: [] },
              { id: 608389359, name: '사이즈', value: '2XL', stock: 499, addPrice: 10000, level: 2, options: [] },
            ],
            minAddPrice: 10000,
            maxAddPrice: 10000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '베이지(미들)',
            level: 1,
            options: [
              { id: 608389360, name: '사이즈', value: 'S', stock: 495, addPrice: 10000, level: 2, options: [] },
              { id: 608389361, name: '사이즈', value: 'M', stock: 490, addPrice: 10000, level: 2, options: [] },
              { id: 608389362, name: '사이즈', value: 'L', stock: 494, addPrice: 10000, level: 2, options: [] },
              { id: 608389363, name: '사이즈', value: 'XL', stock: 496, addPrice: 10000, level: 2, options: [] },
              { id: 608389364, name: '사이즈', value: '2XL', stock: 498, addPrice: 10000, level: 2, options: [] },
            ],
            minAddPrice: 10000,
            maxAddPrice: 10000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '베이지(롱)',
            level: 1,
            options: [
              { id: 608389365, name: '사이즈', value: 'S', stock: 499, addPrice: 10000, level: 2, options: [] },
              { id: 608389366, name: '사이즈', value: 'M', stock: 498, addPrice: 10000, level: 2, options: [] },
              { id: 608389367, name: '사이즈', value: 'L', stock: 496, addPrice: 10000, level: 2, options: [] },
              { id: 608389368, name: '사이즈', value: 'XL', stock: 499, addPrice: 10000, level: 2, options: [] },
              { id: 608389369, name: '사이즈', value: '2XL', stock: 499, addPrice: 10000, level: 2, options: [] },
            ],
            minAddPrice: 10000,
            maxAddPrice: 10000,
            soldOut: false,
          },
        ],
        minAddPrice: 10000,
        maxAddPrice: 10000,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '000_상품명',
        value: '007_클래식 썸머 반팔자켓',
        level: 0,
        images: [],
        options: [
          {
            name: '색상',
            value: '핑크',
            level: 1,
            options: [{ id: 608389370, name: '사이즈', value: 'one size', stock: 496, addPrice: 17000, level: 2, options: [] }],
            minAddPrice: 17000,
            maxAddPrice: 17000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '네이비',
            level: 1,
            options: [{ id: 608389371, name: '사이즈', value: 'one size', stock: 470, addPrice: 17000, level: 2, options: [] }],
            minAddPrice: 17000,
            maxAddPrice: 17000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '아이보리',
            level: 1,
            options: [{ id: 608389372, name: '사이즈', value: 'one size', stock: 487, addPrice: 17000, level: 2, options: [] }],
            minAddPrice: 17000,
            maxAddPrice: 17000,
            soldOut: false,
          },
        ],
        minAddPrice: 17000,
        maxAddPrice: 17000,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '000_상품명',
        value: '008_코튼100 V넥 반팔니트',
        level: 0,
        images: [],
        options: [
          {
            name: '색상',
            value: '블랙',
            level: 1,
            options: [{ id: 608389373, name: '사이즈', value: 'one size', stock: 498, addPrice: 8000, level: 2, options: [] }],
            minAddPrice: 8000,
            maxAddPrice: 8000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '네이비',
            level: 1,
            options: [{ id: 608389374, name: '사이즈', value: 'one size', stock: 494, addPrice: 8000, level: 2, options: [] }],
            minAddPrice: 8000,
            maxAddPrice: 8000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '레드',
            level: 1,
            options: [{ id: 608389375, name: '사이즈', value: 'one size', stock: 487, addPrice: 8000, level: 2, options: [] }],
            minAddPrice: 8000,
            maxAddPrice: 8000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '민트',
            level: 1,
            options: [{ id: 608389376, name: '사이즈', value: 'one size', stock: 496, addPrice: 8000, level: 2, options: [] }],
            minAddPrice: 8000,
            maxAddPrice: 8000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '아이보리',
            level: 1,
            options: [{ id: 608389377, name: '사이즈', value: 'one size', stock: 490, addPrice: 8000, level: 2, options: [] }],
            minAddPrice: 8000,
            maxAddPrice: 8000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '베이지',
            level: 1,
            options: [{ id: 608389378, name: '사이즈', value: 'one size', stock: 498, addPrice: 8000, level: 2, options: [] }],
            minAddPrice: 8000,
            maxAddPrice: 8000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '퍼플',
            level: 1,
            options: [{ id: 608389379, name: '사이즈', value: 'one size', stock: 497, addPrice: 8000, level: 2, options: [] }],
            minAddPrice: 8000,
            maxAddPrice: 8000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '스카이블루',
            level: 1,
            options: [{ id: 608389380, name: '사이즈', value: 'one size', stock: 496, addPrice: 8000, level: 2, options: [] }],
            minAddPrice: 8000,
            maxAddPrice: 8000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '옐로우',
            level: 1,
            options: [{ id: 608389381, name: '사이즈', value: 'one size', stock: 468, addPrice: 8000, level: 2, options: [] }],
            minAddPrice: 8000,
            maxAddPrice: 8000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '핑크',
            level: 1,
            options: [{ id: 608389382, name: '사이즈', value: 'one size', stock: 498, addPrice: 8000, level: 2, options: [] }],
            minAddPrice: 8000,
            maxAddPrice: 8000,
            soldOut: false,
          },
        ],
        minAddPrice: 8000,
        maxAddPrice: 8000,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '000_상품명',
        value: '009_슬릿 롱스트레이트 데님팬츠',
        level: 0,
        images: [],
        options: [
          {
            name: '색상',
            value: '연청',
            level: 1,
            options: [
              { id: 608389383, name: '사이즈', value: 'S', stock: 495, addPrice: 22000, level: 2, options: [] },
              { id: 608389384, name: '사이즈', value: 'M', stock: 497, addPrice: 22000, level: 2, options: [] },
              { id: 608389385, name: '사이즈', value: 'L', stock: 500, addPrice: 22000, level: 2, options: [] },
            ],
            minAddPrice: 22000,
            maxAddPrice: 22000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '진청',
            level: 1,
            options: [
              { id: 608389386, name: '사이즈', value: 'S', stock: 499, addPrice: 22000, level: 2, options: [] },
              { id: 608389387, name: '사이즈', value: 'M', stock: 494, addPrice: 22000, level: 2, options: [] },
              { id: 608389388, name: '사이즈', value: 'L', stock: 497, addPrice: 22000, level: 2, options: [] },
            ],
            minAddPrice: 22000,
            maxAddPrice: 22000,
            soldOut: false,
          },
        ],
        minAddPrice: 22000,
        maxAddPrice: 22000,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '000_상품명',
        value: '010_로엔 자수 실키셔츠',
        level: 0,
        images: [],
        options: [
          {
            name: '색상',
            value: '퍼플',
            level: 1,
            options: [{ id: 608389389, name: '사이즈', value: 'one size', stock: 491, addPrice: 8000, level: 2, options: [] }],
            minAddPrice: 8000,
            maxAddPrice: 8000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '핑크',
            level: 1,
            options: [{ id: 608389390, name: '사이즈', value: 'one size', stock: 0, addPrice: 8000, level: 2, options: [] }],
            soldOut: true,
          },
          {
            name: '색상',
            value: '아이보리',
            level: 1,
            options: [{ id: 608389391, name: '사이즈', value: 'one size', stock: 491, addPrice: 8000, level: 2, options: [] }],
            minAddPrice: 8000,
            maxAddPrice: 8000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '스카이블루',
            level: 1,
            options: [{ id: 608389392, name: '사이즈', value: 'one size', stock: 0, addPrice: 8000, level: 2, options: [] }],
            soldOut: true,
          },
          {
            name: '색상',
            value: '크림',
            level: 1,
            options: [{ id: 608389393, name: '사이즈', value: 'one size', stock: 0, addPrice: 8000, level: 2, options: [] }],
            soldOut: true,
          },
        ],
        minAddPrice: 8000,
        maxAddPrice: 8000,
        hasSoldOut: true,
        soldOut: false,
      },
      {
        name: '000_상품명',
        value: '011_위켄 롱스트레이트 팬츠',
        level: 0,
        images: [],
        options: [
          {
            name: '색상',
            value: '핑크',
            level: 1,
            options: [
              { id: 608389394, name: '사이즈', value: 'S', stock: 499, addPrice: 13000, level: 2, options: [] },
              { id: 608389395, name: '사이즈', value: 'M', stock: 495, addPrice: 13000, level: 2, options: [] },
              { id: 608389396, name: '사이즈', value: 'L', stock: 496, addPrice: 13000, level: 2, options: [] },
              { id: 608389397, name: '사이즈', value: 'XL', stock: 498, addPrice: 13000, level: 2, options: [] },
            ],
            minAddPrice: 13000,
            maxAddPrice: 13000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '라이트베이지',
            level: 1,
            options: [
              { id: 608389398, name: '사이즈', value: 'S', stock: 488, addPrice: 13000, level: 2, options: [] },
              { id: 608389399, name: '사이즈', value: 'M', stock: 477, addPrice: 13000, level: 2, options: [] },
              { id: 608389400, name: '사이즈', value: 'L', stock: 488, addPrice: 13000, level: 2, options: [] },
              { id: 608389401, name: '사이즈', value: 'XL', stock: 496, addPrice: 13000, level: 2, options: [] },
            ],
            minAddPrice: 13000,
            maxAddPrice: 13000,
            soldOut: false,
          },
        ],
        minAddPrice: 13000,
        maxAddPrice: 13000,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '000_상품명',
        value: '012_린넨 오픈카라 반팔셔츠',
        level: 0,
        images: [],
        options: [
          {
            name: '색상',
            value: '네이비',
            level: 1,
            options: [{ id: 608389402, name: '사이즈', value: 'one size', stock: 495, addPrice: 4000, level: 2, options: [] }],
            minAddPrice: 4000,
            maxAddPrice: 4000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '스카이블루',
            level: 1,
            options: [{ id: 608389403, name: '사이즈', value: 'one size', stock: 485, addPrice: 4000, level: 2, options: [] }],
            minAddPrice: 4000,
            maxAddPrice: 4000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '라이트베이지',
            level: 1,
            options: [{ id: 608389404, name: '사이즈', value: 'one size', stock: 480, addPrice: 4000, level: 2, options: [] }],
            minAddPrice: 4000,
            maxAddPrice: 4000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '화이트',
            level: 1,
            options: [{ id: 608389405, name: '사이즈', value: 'one size', stock: 489, addPrice: 4000, level: 2, options: [] }],
            minAddPrice: 4000,
            maxAddPrice: 4000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '인디핑크',
            level: 1,
            options: [{ id: 608389406, name: '사이즈', value: 'one size', stock: 497, addPrice: 4000, level: 2, options: [] }],
            minAddPrice: 4000,
            maxAddPrice: 4000,
            soldOut: false,
          },
        ],
        minAddPrice: 4000,
        maxAddPrice: 4000,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '000_상품명',
        value: '013_러싱 투핀턱 와이드슬랙스(길이선택)',
        level: 0,
        images: [],
        options: [
          {
            name: '색상',
            value: '차콜(숏)',
            level: 1,
            options: [
              { id: 608389407, name: '사이즈', value: 'S', stock: 499, addPrice: 19000, level: 2, options: [] },
              { id: 608389408, name: '사이즈', value: 'M', stock: 498, addPrice: 19000, level: 2, options: [] },
              { id: 608389409, name: '사이즈', value: 'L', stock: 499, addPrice: 19000, level: 2, options: [] },
              { id: 608389410, name: '사이즈', value: 'XL', stock: 500, addPrice: 19000, level: 2, options: [] },
              { id: 608389411, name: '사이즈', value: '2XL', stock: 499, addPrice: 19000, level: 2, options: [] },
            ],
            minAddPrice: 19000,
            maxAddPrice: 19000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '블랙(숏)',
            level: 1,
            options: [
              { id: 608389412, name: '사이즈', value: 'S', stock: 499, addPrice: 19000, level: 2, options: [] },
              { id: 608389413, name: '사이즈', value: 'M', stock: 498, addPrice: 19000, level: 2, options: [] },
              { id: 608389414, name: '사이즈', value: 'L', stock: 498, addPrice: 19000, level: 2, options: [] },
              { id: 608389415, name: '사이즈', value: 'XL', stock: 500, addPrice: 19000, level: 2, options: [] },
              { id: 608389416, name: '사이즈', value: '2XL', stock: 500, addPrice: 19000, level: 2, options: [] },
            ],
            minAddPrice: 19000,
            maxAddPrice: 19000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '스카이블루(숏)',
            level: 1,
            options: [
              { id: 608389417, name: '사이즈', value: 'S', stock: 500, addPrice: 19000, level: 2, options: [] },
              { id: 608389418, name: '사이즈', value: 'M', stock: 499, addPrice: 19000, level: 2, options: [] },
              { id: 608389419, name: '사이즈', value: 'L', stock: 499, addPrice: 19000, level: 2, options: [] },
              { id: 608389420, name: '사이즈', value: 'XL', stock: 500, addPrice: 19000, level: 2, options: [] },
              { id: 608389421, name: '사이즈', value: '2XL', stock: 500, addPrice: 19000, level: 2, options: [] },
            ],
            minAddPrice: 19000,
            maxAddPrice: 19000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '크림(숏)',
            level: 1,
            options: [
              { id: 608389422, name: '사이즈', value: 'S', stock: 500, addPrice: 19000, level: 2, options: [] },
              { id: 608389423, name: '사이즈', value: 'M', stock: 499, addPrice: 19000, level: 2, options: [] },
              { id: 608389424, name: '사이즈', value: 'L', stock: 500, addPrice: 19000, level: 2, options: [] },
              { id: 608389425, name: '사이즈', value: 'XL', stock: 500, addPrice: 19000, level: 2, options: [] },
              { id: 608389426, name: '사이즈', value: '2XL', stock: 500, addPrice: 19000, level: 2, options: [] },
            ],
            minAddPrice: 19000,
            maxAddPrice: 19000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '차콜(미들)',
            level: 1,
            options: [
              { id: 608389427, name: '사이즈', value: 'S', stock: 500, addPrice: 19000, level: 2, options: [] },
              { id: 608389428, name: '사이즈', value: 'M', stock: 500, addPrice: 19000, level: 2, options: [] },
              { id: 608389429, name: '사이즈', value: 'L', stock: 499, addPrice: 19000, level: 2, options: [] },
              { id: 608389430, name: '사이즈', value: 'XL', stock: 499, addPrice: 19000, level: 2, options: [] },
              { id: 608389431, name: '사이즈', value: '2XL', stock: 500, addPrice: 19000, level: 2, options: [] },
            ],
            minAddPrice: 19000,
            maxAddPrice: 19000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '블랙(미들)',
            level: 1,
            options: [
              { id: 608389432, name: '사이즈', value: 'S', stock: 498, addPrice: 19000, level: 2, options: [] },
              { id: 608389433, name: '사이즈', value: 'M', stock: 499, addPrice: 19000, level: 2, options: [] },
              { id: 608389434, name: '사이즈', value: 'L', stock: 500, addPrice: 19000, level: 2, options: [] },
              { id: 608389435, name: '사이즈', value: 'XL', stock: 500, addPrice: 19000, level: 2, options: [] },
              { id: 608389436, name: '사이즈', value: '2XL', stock: 500, addPrice: 19000, level: 2, options: [] },
            ],
            minAddPrice: 19000,
            maxAddPrice: 19000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '스카이블루(미들)',
            level: 1,
            options: [
              { id: 608389437, name: '사이즈', value: 'S', stock: 500, addPrice: 19000, level: 2, options: [] },
              { id: 608389438, name: '사이즈', value: 'M', stock: 500, addPrice: 19000, level: 2, options: [] },
              { id: 608389439, name: '사이즈', value: 'L', stock: 500, addPrice: 19000, level: 2, options: [] },
              { id: 608389440, name: '사이즈', value: 'XL', stock: 500, addPrice: 19000, level: 2, options: [] },
              { id: 608389441, name: '사이즈', value: '2XL', stock: 500, addPrice: 19000, level: 2, options: [] },
            ],
            minAddPrice: 19000,
            maxAddPrice: 19000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '크림(미들)',
            level: 1,
            options: [
              { id: 608389442, name: '사이즈', value: 'S', stock: 500, addPrice: 19000, level: 2, options: [] },
              { id: 608389443, name: '사이즈', value: 'M', stock: 500, addPrice: 19000, level: 2, options: [] },
              { id: 608389444, name: '사이즈', value: 'L', stock: 500, addPrice: 19000, level: 2, options: [] },
              { id: 608389445, name: '사이즈', value: 'XL', stock: 499, addPrice: 19000, level: 2, options: [] },
              { id: 608389446, name: '사이즈', value: '2XL', stock: 500, addPrice: 19000, level: 2, options: [] },
            ],
            minAddPrice: 19000,
            maxAddPrice: 19000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '차콜(롱)',
            level: 1,
            options: [
              { id: 608389447, name: '사이즈', value: 'S', stock: 500, addPrice: 19000, level: 2, options: [] },
              { id: 608389448, name: '사이즈', value: 'M', stock: 498, addPrice: 19000, level: 2, options: [] },
              { id: 608389449, name: '사이즈', value: 'L', stock: 499, addPrice: 19000, level: 2, options: [] },
              { id: 608389450, name: '사이즈', value: 'XL', stock: 500, addPrice: 19000, level: 2, options: [] },
              { id: 608389451, name: '사이즈', value: '2XL', stock: 500, addPrice: 19000, level: 2, options: [] },
            ],
            minAddPrice: 19000,
            maxAddPrice: 19000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '블랙(롱)',
            level: 1,
            options: [
              { id: 608389452, name: '사이즈', value: 'S', stock: 500, addPrice: 19000, level: 2, options: [] },
              { id: 608389453, name: '사이즈', value: 'M', stock: 496, addPrice: 19000, level: 2, options: [] },
              { id: 608389454, name: '사이즈', value: 'L', stock: 498, addPrice: 19000, level: 2, options: [] },
              { id: 608389455, name: '사이즈', value: 'XL', stock: 499, addPrice: 19000, level: 2, options: [] },
              { id: 608389456, name: '사이즈', value: '2XL', stock: 500, addPrice: 19000, level: 2, options: [] },
            ],
            minAddPrice: 19000,
            maxAddPrice: 19000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '스카이블루(롱)',
            level: 1,
            options: [
              { id: 608389457, name: '사이즈', value: 'S', stock: 500, addPrice: 19000, level: 2, options: [] },
              { id: 608389458, name: '사이즈', value: 'M', stock: 500, addPrice: 19000, level: 2, options: [] },
              { id: 608389459, name: '사이즈', value: 'L', stock: 499, addPrice: 19000, level: 2, options: [] },
              { id: 608389460, name: '사이즈', value: 'XL', stock: 500, addPrice: 19000, level: 2, options: [] },
              { id: 608389461, name: '사이즈', value: '2XL', stock: 500, addPrice: 19000, level: 2, options: [] },
            ],
            minAddPrice: 19000,
            maxAddPrice: 19000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '크림(롱)',
            level: 1,
            options: [
              { id: 608389462, name: '사이즈', value: 'S', stock: 500, addPrice: 19000, level: 2, options: [] },
              { id: 608389463, name: '사이즈', value: 'M', stock: 499, addPrice: 19000, level: 2, options: [] },
              { id: 608389464, name: '사이즈', value: 'L', stock: 500, addPrice: 19000, level: 2, options: [] },
              { id: 608389465, name: '사이즈', value: 'XL', stock: 500, addPrice: 19000, level: 2, options: [] },
              { id: 608389466, name: '사이즈', value: '2XL', stock: 500, addPrice: 19000, level: 2, options: [] },
            ],
            minAddPrice: 19000,
            maxAddPrice: 19000,
            soldOut: false,
          },
        ],
        minAddPrice: 19000,
        maxAddPrice: 19000,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '000_상품명',
        value: '014_헌트 린넨 루즈핏셔츠',
        level: 0,
        images: [],
        options: [
          {
            name: '색상',
            value: '네이비',
            level: 1,
            options: [{ id: 604114151, name: '사이즈', value: 'one size', stock: 489, addPrice: 6000, level: 2, options: [] }],
            minAddPrice: 6000,
            maxAddPrice: 6000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '베이지',
            level: 1,
            options: [{ id: 604114152, name: '사이즈', value: 'one size', stock: 493, addPrice: 6000, level: 2, options: [] }],
            minAddPrice: 6000,
            maxAddPrice: 6000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '블루',
            level: 1,
            options: [{ id: 604114153, name: '사이즈', value: 'one size', stock: 469, addPrice: 6000, level: 2, options: [] }],
            minAddPrice: 6000,
            maxAddPrice: 6000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '아이보리',
            level: 1,
            options: [{ id: 604114154, name: '사이즈', value: 'one size', stock: 470, addPrice: 6000, level: 2, options: [] }],
            minAddPrice: 6000,
            maxAddPrice: 6000,
            soldOut: false,
          },
        ],
        minAddPrice: 6000,
        maxAddPrice: 6000,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '000_상품명',
        value: '015_베티 투버튼 숏슬랙스(뒷밴딩)',
        level: 0,
        images: [],
        options: [
          {
            name: '색상',
            value: '블랙',
            level: 1,
            options: [{ id: 604114155, name: '사이즈', value: 'one size', stock: 489, addPrice: 4000, level: 2, options: [] }],
            minAddPrice: 4000,
            maxAddPrice: 4000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '아이보리',
            level: 1,
            options: [{ id: 604114156, name: '사이즈', value: 'one size', stock: 485, addPrice: 4000, level: 2, options: [] }],
            minAddPrice: 4000,
            maxAddPrice: 4000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '카키',
            level: 1,
            options: [{ id: 604114157, name: '사이즈', value: 'one size', stock: 492, addPrice: 4000, level: 2, options: [] }],
            minAddPrice: 4000,
            maxAddPrice: 4000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '핑크',
            level: 1,
            options: [{ id: 604114158, name: '사이즈', value: 'one size', stock: 496, addPrice: 4000, level: 2, options: [] }],
            minAddPrice: 4000,
            maxAddPrice: 4000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '라이트베이지',
            level: 1,
            options: [{ id: 608389467, name: '사이즈', value: 'one size', stock: 478, addPrice: 4000, level: 2, options: [] }],
            minAddPrice: 4000,
            maxAddPrice: 4000,
            soldOut: false,
          },
        ],
        minAddPrice: 4000,
        maxAddPrice: 4000,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '000_상품명',
        value: '016_허밋 썸머 볼레로 가디건',
        level: 0,
        images: [],
        options: [
          {
            name: '색상',
            value: '모카',
            level: 1,
            options: [{ id: 608389468, name: '사이즈', value: 'one size', stock: 490, addPrice: 3000, level: 2, options: [] }],
            minAddPrice: 3000,
            maxAddPrice: 3000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '블랙',
            level: 1,
            options: [{ id: 608389469, name: '사이즈', value: 'one size', stock: 479, addPrice: 3000, level: 2, options: [] }],
            minAddPrice: 3000,
            maxAddPrice: 3000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '아이보리',
            level: 1,
            options: [{ id: 608389470, name: '사이즈', value: 'one size', stock: 493, addPrice: 3000, level: 2, options: [] }],
            minAddPrice: 3000,
            maxAddPrice: 3000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '오트밀',
            level: 1,
            options: [{ id: 608389471, name: '사이즈', value: 'one size', stock: 476, addPrice: 3000, level: 2, options: [] }],
            minAddPrice: 3000,
            maxAddPrice: 3000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '핑크',
            level: 1,
            options: [{ id: 608389472, name: '사이즈', value: 'one size', stock: 498, addPrice: 3000, level: 2, options: [] }],
            minAddPrice: 3000,
            maxAddPrice: 3000,
            soldOut: false,
          },
        ],
        minAddPrice: 3000,
        maxAddPrice: 3000,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '000_상품명',
        value: '017_옆셔링 캡내장 슬리브리스',
        level: 0,
        images: [],
        options: [
          {
            name: '색상',
            value: '아이보리',
            level: 1,
            options: [{ id: 608389473, name: '사이즈', value: 'one size', stock: 485, addPrice: 2000, level: 2, options: [] }],
            minAddPrice: 2000,
            maxAddPrice: 2000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '핑크',
            level: 1,
            options: [{ id: 608389474, name: '사이즈', value: 'one size', stock: 498, addPrice: 2000, level: 2, options: [] }],
            minAddPrice: 2000,
            maxAddPrice: 2000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '스카이블루',
            level: 1,
            options: [{ id: 608389475, name: '사이즈', value: 'one size', stock: 498, addPrice: 2000, level: 2, options: [] }],
            minAddPrice: 2000,
            maxAddPrice: 2000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '블랙',
            level: 1,
            options: [{ id: 608389476, name: '사이즈', value: 'one size', stock: 489, addPrice: 2000, level: 2, options: [] }],
            minAddPrice: 2000,
            maxAddPrice: 2000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '(롱ver)아이보리',
            level: 1,
            options: [{ id: 608389477, name: '사이즈', value: 'one size', stock: 468, addPrice: 3000, level: 2, options: [] }],
            minAddPrice: 3000,
            maxAddPrice: 3000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '(롱ver)핑크',
            level: 1,
            options: [{ id: 608389478, name: '사이즈', value: 'one size', stock: 499, addPrice: 3000, level: 2, options: [] }],
            minAddPrice: 3000,
            maxAddPrice: 3000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '(롱ver)스카이블루',
            level: 1,
            options: [{ id: 608389479, name: '사이즈', value: 'one size', stock: 496, addPrice: 3000, level: 2, options: [] }],
            minAddPrice: 3000,
            maxAddPrice: 3000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '(롱ver)블랙',
            level: 1,
            options: [{ id: 608389480, name: '사이즈', value: 'one size', stock: 482, addPrice: 3000, level: 2, options: [] }],
            minAddPrice: 3000,
            maxAddPrice: 3000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '그레이',
            level: 1,
            options: [{ id: 608389481, name: '사이즈', value: 'one size', stock: 499, addPrice: 2000, level: 2, options: [] }],
            minAddPrice: 2000,
            maxAddPrice: 2000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '(롱ver)그레이',
            level: 1,
            options: [{ id: 608389482, name: '사이즈', value: 'one size', stock: 496, addPrice: 3000, level: 2, options: [] }],
            minAddPrice: 3000,
            maxAddPrice: 3000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '크림',
            level: 1,
            options: [{ id: 608389483, name: '사이즈', value: 'one size', stock: 492, addPrice: 2000, level: 2, options: [] }],
            minAddPrice: 2000,
            maxAddPrice: 2000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '(롱ver)크림',
            level: 1,
            options: [{ id: 608389484, name: '사이즈', value: 'one size', stock: 479, addPrice: 3000, level: 2, options: [] }],
            minAddPrice: 3000,
            maxAddPrice: 3000,
            soldOut: false,
          },
        ],
        minAddPrice: 2000,
        maxAddPrice: 3000,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '000_상품명',
        value: '018_쫀득 슬림부츠컷 데님팬츠(길이선택)',
        level: 0,
        images: [],
        options: [
          {
            name: '색상',
            value: '중청(숏)',
            level: 1,
            options: [
              { id: 608389485, name: '사이즈', value: 'S', stock: 496, addPrice: 15000, level: 2, options: [] },
              { id: 608389486, name: '사이즈', value: 'M', stock: 489, addPrice: 15000, level: 2, options: [] },
              { id: 608389487, name: '사이즈', value: 'L', stock: 495, addPrice: 15000, level: 2, options: [] },
              { id: 608389488, name: '사이즈', value: 'XL', stock: 497, addPrice: 15000, level: 2, options: [] },
              { id: 608389489, name: '사이즈', value: '2XL', stock: 497, addPrice: 15000, level: 2, options: [] },
            ],
            minAddPrice: 15000,
            maxAddPrice: 15000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '진청(숏)',
            level: 1,
            options: [
              { id: 608389490, name: '사이즈', value: 'S', stock: 500, addPrice: 15000, level: 2, options: [] },
              { id: 608389491, name: '사이즈', value: 'M', stock: 498, addPrice: 15000, level: 2, options: [] },
              { id: 608389492, name: '사이즈', value: 'L', stock: 500, addPrice: 15000, level: 2, options: [] },
              { id: 608389493, name: '사이즈', value: 'XL', stock: 500, addPrice: 15000, level: 2, options: [] },
              { id: 608389494, name: '사이즈', value: '2XL', stock: 500, addPrice: 15000, level: 2, options: [] },
            ],
            minAddPrice: 15000,
            maxAddPrice: 15000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '중청(롱)',
            level: 1,
            options: [
              { id: 608389495, name: '사이즈', value: 'S', stock: 500, addPrice: 15000, level: 2, options: [] },
              { id: 608389496, name: '사이즈', value: 'M', stock: 498, addPrice: 15000, level: 2, options: [] },
              { id: 608389497, name: '사이즈', value: 'L', stock: 497, addPrice: 15000, level: 2, options: [] },
              { id: 608389498, name: '사이즈', value: 'XL', stock: 497, addPrice: 15000, level: 2, options: [] },
              { id: 608389499, name: '사이즈', value: '2XL', stock: 499, addPrice: 15000, level: 2, options: [] },
            ],
            minAddPrice: 15000,
            maxAddPrice: 15000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '진청(롱)',
            level: 1,
            options: [
              { id: 608389500, name: '사이즈', value: 'S', stock: 500, addPrice: 15000, level: 2, options: [] },
              { id: 608389501, name: '사이즈', value: 'M', stock: 498, addPrice: 15000, level: 2, options: [] },
              { id: 608389502, name: '사이즈', value: 'L', stock: 499, addPrice: 15000, level: 2, options: [] },
              { id: 608389503, name: '사이즈', value: 'XL', stock: 500, addPrice: 15000, level: 2, options: [] },
              { id: 608389504, name: '사이즈', value: '2XL', stock: 499, addPrice: 15000, level: 2, options: [] },
            ],
            minAddPrice: 15000,
            maxAddPrice: 15000,
            soldOut: false,
          },
        ],
        minAddPrice: 15000,
        maxAddPrice: 15000,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '000_상품명',
        value: '019_요루 5부 포켓 블라우스',
        level: 0,
        images: [],
        options: [
          {
            name: '색상',
            value: '베이지',
            level: 1,
            options: [{ id: 608389505, name: '사이즈', value: 'one size', stock: 463, addPrice: 7000, level: 2, options: [] }],
            minAddPrice: 7000,
            maxAddPrice: 7000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '블랙',
            level: 1,
            options: [{ id: 608389506, name: '사이즈', value: 'one size', stock: 447, addPrice: 7000, level: 2, options: [] }],
            minAddPrice: 7000,
            maxAddPrice: 7000,
            soldOut: false,
          },
        ],
        minAddPrice: 7000,
        maxAddPrice: 7000,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '000_상품명',
        value: '020_세리즈 핀턱 와이드슬랙스(뒷밴딩)',
        level: 0,
        images: [],
        options: [
          {
            name: '색상',
            value: '블랙',
            level: 1,
            options: [{ id: 608389507, name: '사이즈', value: 'one size', stock: 494, addPrice: 18000, level: 2, options: [] }],
            minAddPrice: 18000,
            maxAddPrice: 18000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '민트',
            level: 1,
            options: [{ id: 608389508, name: '사이즈', value: 'one size', stock: 499, addPrice: 18000, level: 2, options: [] }],
            minAddPrice: 18000,
            maxAddPrice: 18000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '아이보리',
            level: 1,
            options: [{ id: 608389509, name: '사이즈', value: 'one size', stock: 499, addPrice: 18000, level: 2, options: [] }],
            minAddPrice: 18000,
            maxAddPrice: 18000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '퍼플',
            level: 1,
            options: [{ id: 608389510, name: '사이즈', value: 'one size', stock: 497, addPrice: 18000, level: 2, options: [] }],
            minAddPrice: 18000,
            maxAddPrice: 18000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '핑크',
            level: 1,
            options: [{ id: 608389511, name: '사이즈', value: 'one size', stock: 499, addPrice: 18000, level: 2, options: [] }],
            minAddPrice: 18000,
            maxAddPrice: 18000,
            soldOut: false,
          },
        ],
        minAddPrice: 18000,
        maxAddPrice: 18000,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '000_상품명',
        value: '021_로던 내추럴 트위드자켓',
        level: 0,
        images: [],
        options: [
          {
            name: '색상',
            value: '라이트핑크',
            level: 1,
            options: [{ id: 608389512, name: '사이즈', value: 'one size', stock: 489, addPrice: 20000, level: 2, options: [] }],
            minAddPrice: 20000,
            maxAddPrice: 20000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '베이지',
            level: 1,
            options: [{ id: 608389513, name: '사이즈', value: 'one size', stock: 485, addPrice: 20000, level: 2, options: [] }],
            minAddPrice: 20000,
            maxAddPrice: 20000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '아이보리',
            level: 1,
            options: [{ id: 608389514, name: '사이즈', value: 'one size', stock: 495, addPrice: 20000, level: 2, options: [] }],
            minAddPrice: 20000,
            maxAddPrice: 20000,
            soldOut: false,
          },
        ],
        minAddPrice: 20000,
        maxAddPrice: 20000,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '000_상품명',
        value: '022_쫀득스판 세미부츠컷 슬랙스(길이선택)',
        level: 0,
        images: [],
        options: [
          {
            name: '색상',
            value: '화이트(숏)',
            level: 1,
            options: [
              { id: 608389515, name: '사이즈', value: 'S', stock: 500, addPrice: 8000, level: 2, options: [] },
              { id: 608389516, name: '사이즈', value: 'M', stock: 500, addPrice: 8000, level: 2, options: [] },
              { id: 608389517, name: '사이즈', value: 'L', stock: 500, addPrice: 8000, level: 2, options: [] },
              { id: 608389518, name: '사이즈', value: 'XL', stock: 500, addPrice: 8000, level: 2, options: [] },
              { id: 608389519, name: '사이즈', value: '2XL', stock: 500, addPrice: 8000, level: 2, options: [] },
            ],
            minAddPrice: 8000,
            maxAddPrice: 8000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '화이트(미들)',
            level: 1,
            options: [
              { id: 608389520, name: '사이즈', value: 'S', stock: 499, addPrice: 8000, level: 2, options: [] },
              { id: 608389521, name: '사이즈', value: 'M', stock: 500, addPrice: 8000, level: 2, options: [] },
              { id: 608389522, name: '사이즈', value: 'L', stock: 500, addPrice: 8000, level: 2, options: [] },
              { id: 608389523, name: '사이즈', value: 'XL', stock: 500, addPrice: 8000, level: 2, options: [] },
              { id: 608389524, name: '사이즈', value: '2XL', stock: 500, addPrice: 8000, level: 2, options: [] },
            ],
            minAddPrice: 8000,
            maxAddPrice: 8000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '화이트(롱)',
            level: 1,
            options: [
              { id: 608389525, name: '사이즈', value: 'S', stock: 500, addPrice: 8000, level: 2, options: [] },
              { id: 608389526, name: '사이즈', value: 'M', stock: 500, addPrice: 8000, level: 2, options: [] },
              { id: 608389527, name: '사이즈', value: 'L', stock: 499, addPrice: 8000, level: 2, options: [] },
              { id: 608389528, name: '사이즈', value: 'XL', stock: 500, addPrice: 8000, level: 2, options: [] },
              { id: 608389529, name: '사이즈', value: '2XL', stock: 499, addPrice: 8000, level: 2, options: [] },
            ],
            minAddPrice: 8000,
            maxAddPrice: 8000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '블랙(숏)',
            level: 1,
            options: [
              { id: 608389530, name: '사이즈', value: 'S', stock: 497, addPrice: 8000, level: 2, options: [] },
              { id: 608389531, name: '사이즈', value: 'M', stock: 496, addPrice: 8000, level: 2, options: [] },
              { id: 608389532, name: '사이즈', value: 'L', stock: 498, addPrice: 8000, level: 2, options: [] },
              { id: 608389533, name: '사이즈', value: 'XL', stock: 498, addPrice: 8000, level: 2, options: [] },
              { id: 608389534, name: '사이즈', value: '2XL', stock: 499, addPrice: 8000, level: 2, options: [] },
            ],
            minAddPrice: 8000,
            maxAddPrice: 8000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '블랙(미들)',
            level: 1,
            options: [
              { id: 608389535, name: '사이즈', value: 'S', stock: 499, addPrice: 8000, level: 2, options: [] },
              { id: 608389536, name: '사이즈', value: 'M', stock: 496, addPrice: 8000, level: 2, options: [] },
              { id: 608389537, name: '사이즈', value: 'L', stock: 500, addPrice: 8000, level: 2, options: [] },
              { id: 608389538, name: '사이즈', value: 'XL', stock: 499, addPrice: 8000, level: 2, options: [] },
              { id: 608389539, name: '사이즈', value: '2XL', stock: 500, addPrice: 8000, level: 2, options: [] },
            ],
            minAddPrice: 8000,
            maxAddPrice: 8000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '블랙(롱)',
            level: 1,
            options: [
              { id: 608389540, name: '사이즈', value: 'S', stock: 500, addPrice: 8000, level: 2, options: [] },
              { id: 608389541, name: '사이즈', value: 'M', stock: 498, addPrice: 8000, level: 2, options: [] },
              { id: 608389542, name: '사이즈', value: 'L', stock: 497, addPrice: 8000, level: 2, options: [] },
              { id: 608389543, name: '사이즈', value: 'XL', stock: 498, addPrice: 8000, level: 2, options: [] },
              { id: 608389544, name: '사이즈', value: '2XL', stock: 500, addPrice: 8000, level: 2, options: [] },
            ],
            minAddPrice: 8000,
            maxAddPrice: 8000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '베이지(숏)',
            level: 1,
            options: [
              { id: 608389545, name: '사이즈', value: 'S', stock: 500, addPrice: 8000, level: 2, options: [] },
              { id: 608389546, name: '사이즈', value: 'M', stock: 500, addPrice: 8000, level: 2, options: [] },
              { id: 608389547, name: '사이즈', value: 'L', stock: 499, addPrice: 8000, level: 2, options: [] },
              { id: 608389548, name: '사이즈', value: 'XL', stock: 500, addPrice: 8000, level: 2, options: [] },
              { id: 608389549, name: '사이즈', value: '2XL', stock: 500, addPrice: 8000, level: 2, options: [] },
            ],
            minAddPrice: 8000,
            maxAddPrice: 8000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '베이지(미들)',
            level: 1,
            options: [
              { id: 608389550, name: '사이즈', value: 'S', stock: 500, addPrice: 8000, level: 2, options: [] },
              { id: 608389551, name: '사이즈', value: 'M', stock: 500, addPrice: 8000, level: 2, options: [] },
              { id: 608389552, name: '사이즈', value: 'L', stock: 500, addPrice: 8000, level: 2, options: [] },
              { id: 608389553, name: '사이즈', value: 'XL', stock: 500, addPrice: 8000, level: 2, options: [] },
              { id: 608389554, name: '사이즈', value: '2XL', stock: 500, addPrice: 8000, level: 2, options: [] },
            ],
            minAddPrice: 8000,
            maxAddPrice: 8000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '베이지(롱)',
            level: 1,
            options: [
              { id: 608389555, name: '사이즈', value: 'S', stock: 500, addPrice: 8000, level: 2, options: [] },
              { id: 608389556, name: '사이즈', value: 'M', stock: 500, addPrice: 8000, level: 2, options: [] },
              { id: 608389557, name: '사이즈', value: 'L', stock: 500, addPrice: 8000, level: 2, options: [] },
              { id: 608389558, name: '사이즈', value: 'XL', stock: 500, addPrice: 8000, level: 2, options: [] },
              { id: 608389559, name: '사이즈', value: '2XL', stock: 499, addPrice: 8000, level: 2, options: [] },
            ],
            minAddPrice: 8000,
            maxAddPrice: 8000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '핑크(숏)',
            level: 1,
            options: [
              { id: 608389560, name: '사이즈', value: 'S', stock: 500, addPrice: 8000, level: 2, options: [] },
              { id: 608389561, name: '사이즈', value: 'M', stock: 500, addPrice: 8000, level: 2, options: [] },
              { id: 608389562, name: '사이즈', value: 'L', stock: 500, addPrice: 8000, level: 2, options: [] },
              { id: 608389563, name: '사이즈', value: 'XL', stock: 500, addPrice: 8000, level: 2, options: [] },
              { id: 608389564, name: '사이즈', value: '2XL', stock: 500, addPrice: 8000, level: 2, options: [] },
            ],
            minAddPrice: 8000,
            maxAddPrice: 8000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '핑크(미들)',
            level: 1,
            options: [
              { id: 608389565, name: '사이즈', value: 'S', stock: 499, addPrice: 8000, level: 2, options: [] },
              { id: 608389566, name: '사이즈', value: 'M', stock: 499, addPrice: 8000, level: 2, options: [] },
              { id: 608389567, name: '사이즈', value: 'L', stock: 500, addPrice: 8000, level: 2, options: [] },
              { id: 608389568, name: '사이즈', value: 'XL', stock: 500, addPrice: 8000, level: 2, options: [] },
              { id: 608389569, name: '사이즈', value: '2XL', stock: 500, addPrice: 8000, level: 2, options: [] },
            ],
            minAddPrice: 8000,
            maxAddPrice: 8000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '핑크(롱)',
            level: 1,
            options: [
              { id: 608389570, name: '사이즈', value: 'S', stock: 500, addPrice: 8000, level: 2, options: [] },
              { id: 608389571, name: '사이즈', value: 'M', stock: 499, addPrice: 8000, level: 2, options: [] },
              { id: 608389572, name: '사이즈', value: 'L', stock: 500, addPrice: 8000, level: 2, options: [] },
              { id: 608389573, name: '사이즈', value: 'XL', stock: 500, addPrice: 8000, level: 2, options: [] },
              { id: 608389574, name: '사이즈', value: '2XL', stock: 500, addPrice: 8000, level: 2, options: [] },
            ],
            minAddPrice: 8000,
            maxAddPrice: 8000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '스카이블루(숏)',
            level: 1,
            options: [
              { id: 608389575, name: '사이즈', value: 'S', stock: 500, addPrice: 8000, level: 2, options: [] },
              { id: 608389576, name: '사이즈', value: 'M', stock: 500, addPrice: 8000, level: 2, options: [] },
              { id: 608389577, name: '사이즈', value: 'L', stock: 500, addPrice: 8000, level: 2, options: [] },
              { id: 608389578, name: '사이즈', value: 'XL', stock: 500, addPrice: 8000, level: 2, options: [] },
              { id: 608389579, name: '사이즈', value: '2XL', stock: 499, addPrice: 8000, level: 2, options: [] },
            ],
            minAddPrice: 8000,
            maxAddPrice: 8000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '스카이블루(미들)',
            level: 1,
            options: [
              { id: 608389580, name: '사이즈', value: 'S', stock: 500, addPrice: 8000, level: 2, options: [] },
              { id: 608389581, name: '사이즈', value: 'M', stock: 500, addPrice: 8000, level: 2, options: [] },
              { id: 608389582, name: '사이즈', value: 'L', stock: 500, addPrice: 8000, level: 2, options: [] },
              { id: 608389583, name: '사이즈', value: 'XL', stock: 500, addPrice: 8000, level: 2, options: [] },
              { id: 608389584, name: '사이즈', value: '2XL', stock: 500, addPrice: 8000, level: 2, options: [] },
            ],
            minAddPrice: 8000,
            maxAddPrice: 8000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '스카이블루(롱)',
            level: 1,
            options: [
              { id: 608389585, name: '사이즈', value: 'S', stock: 500, addPrice: 8000, level: 2, options: [] },
              { id: 608389586, name: '사이즈', value: 'M', stock: 500, addPrice: 8000, level: 2, options: [] },
              { id: 608389587, name: '사이즈', value: 'L', stock: 500, addPrice: 8000, level: 2, options: [] },
              { id: 608389588, name: '사이즈', value: 'XL', stock: 500, addPrice: 8000, level: 2, options: [] },
              { id: 608389589, name: '사이즈', value: '2XL', stock: 499, addPrice: 8000, level: 2, options: [] },
            ],
            minAddPrice: 8000,
            maxAddPrice: 8000,
            soldOut: false,
          },
        ],
        minAddPrice: 8000,
        maxAddPrice: 8000,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '000_상품명',
        value: '023_소프트 플리츠 뷔스티에 롱 원피스',
        level: 0,
        images: [],
        options: [
          {
            name: '색상',
            value: '아이보리',
            level: 1,
            options: [{ id: 608389590, name: '사이즈', value: 'one size', stock: 496, addPrice: 3000, level: 2, options: [] }],
            minAddPrice: 3000,
            maxAddPrice: 3000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '베이지',
            level: 1,
            options: [{ id: 608389591, name: '사이즈', value: 'one size', stock: 492, addPrice: 3000, level: 2, options: [] }],
            minAddPrice: 3000,
            maxAddPrice: 3000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '민트',
            level: 1,
            options: [{ id: 608389592, name: '사이즈', value: 'one size', stock: 492, addPrice: 3000, level: 2, options: [] }],
            minAddPrice: 3000,
            maxAddPrice: 3000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '라일락',
            level: 1,
            options: [{ id: 608389593, name: '사이즈', value: 'one size', stock: 466, addPrice: 3000, level: 2, options: [] }],
            minAddPrice: 3000,
            maxAddPrice: 3000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '블랙',
            level: 1,
            options: [{ id: 608389594, name: '사이즈', value: 'one size', stock: 478, addPrice: 3000, level: 2, options: [] }],
            minAddPrice: 3000,
            maxAddPrice: 3000,
            soldOut: false,
          },
        ],
        minAddPrice: 3000,
        maxAddPrice: 3000,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '000_상품명',
        value: '024_모나코 핀턱 코튼팬츠(뒷밴딩)',
        level: 0,
        images: [],
        options: [
          {
            name: '색상',
            value: '블랙',
            level: 1,
            options: [{ id: 608389595, name: '사이즈', value: 'one size', stock: 496, addPrice: 8000, level: 2, options: [] }],
            minAddPrice: 8000,
            maxAddPrice: 8000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '연베이지',
            level: 1,
            options: [{ id: 608389596, name: '사이즈', value: 'one size', stock: 490, addPrice: 8000, level: 2, options: [] }],
            minAddPrice: 8000,
            maxAddPrice: 8000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '진베이지',
            level: 1,
            options: [{ id: 608389597, name: '사이즈', value: 'one size', stock: 481, addPrice: 8000, level: 2, options: [] }],
            minAddPrice: 8000,
            maxAddPrice: 8000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '화이트',
            level: 1,
            options: [{ id: 608389598, name: '사이즈', value: 'one size', stock: 480, addPrice: 8000, level: 2, options: [] }],
            minAddPrice: 8000,
            maxAddPrice: 8000,
            soldOut: false,
          },
        ],
        minAddPrice: 8000,
        maxAddPrice: 8000,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '000_상품명',
        value: '025_뮤티 스트라이프 골지티셔츠',
        level: 0,
        images: [],
        options: [
          {
            name: '색상',
            value: '블랙',
            level: 1,
            options: [{ id: 608389599, name: '사이즈', value: 'one size', stock: 478, addPrice: 0, level: 2, options: [] }],
            minAddPrice: 0,
            maxAddPrice: 0,
            soldOut: false,
          },
          {
            name: '색상',
            value: '그린',
            level: 1,
            options: [{ id: 608389600, name: '사이즈', value: 'one size', stock: 485, addPrice: 0, level: 2, options: [] }],
            minAddPrice: 0,
            maxAddPrice: 0,
            soldOut: false,
          },
          {
            name: '색상',
            value: '핑크',
            level: 1,
            options: [{ id: 608389601, name: '사이즈', value: 'one size', stock: 496, addPrice: 0, level: 2, options: [] }],
            minAddPrice: 0,
            maxAddPrice: 0,
            soldOut: false,
          },
        ],
        minAddPrice: 0,
        maxAddPrice: 0,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '000_상품명',
        value: '026_버칸 핀턱 코튼슬랙스(벨트set)',
        level: 0,
        images: [],
        options: [
          {
            name: '색상',
            value: '그린',
            level: 1,
            options: [
              { id: 608389602, name: '사이즈', value: 'S', stock: 498, addPrice: 13000, level: 2, options: [] },
              { id: 608389603, name: '사이즈', value: 'M', stock: 0, addPrice: 13000, level: 2, options: [] },
              { id: 608389604, name: '사이즈', value: 'L', stock: 0, addPrice: 13000, level: 2, options: [] },
            ],
            minAddPrice: 13000,
            maxAddPrice: 13000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '베이지',
            level: 1,
            options: [
              { id: 608389605, name: '사이즈', value: 'S', stock: 492, addPrice: 13000, level: 2, options: [] },
              { id: 608389606, name: '사이즈', value: 'M', stock: 494, addPrice: 13000, level: 2, options: [] },
              { id: 608389607, name: '사이즈', value: 'L', stock: 493, addPrice: 13000, level: 2, options: [] },
            ],
            minAddPrice: 13000,
            maxAddPrice: 13000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '크림',
            level: 1,
            options: [
              { id: 608389608, name: '사이즈', value: 'S', stock: 499, addPrice: 13000, level: 2, options: [] },
              { id: 608389609, name: '사이즈', value: 'M', stock: 494, addPrice: 13000, level: 2, options: [] },
              { id: 608389610, name: '사이즈', value: 'L', stock: 498, addPrice: 13000, level: 2, options: [] },
            ],
            minAddPrice: 13000,
            maxAddPrice: 13000,
            soldOut: false,
          },
        ],
        minAddPrice: 13000,
        maxAddPrice: 13000,
        hasSoldOut: true,
        soldOut: false,
      },
      {
        name: '000_상품명',
        value: '027_시어서커 반팔 스트라이프 셔츠',
        level: 0,
        images: [],
        options: [
          {
            name: '색상',
            value: '핑크',
            level: 1,
            options: [{ id: 608389611, name: '사이즈', value: 'one size', stock: 489, addPrice: 5000, level: 2, options: [] }],
            minAddPrice: 5000,
            maxAddPrice: 5000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '그린',
            level: 1,
            options: [{ id: 608389612, name: '사이즈', value: 'one size', stock: 454, addPrice: 5000, level: 2, options: [] }],
            minAddPrice: 5000,
            maxAddPrice: 5000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '옐로우',
            level: 1,
            options: [{ id: 608389613, name: '사이즈', value: 'one size', stock: 482, addPrice: 5000, level: 2, options: [] }],
            minAddPrice: 5000,
            maxAddPrice: 5000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '블루',
            level: 1,
            options: [{ id: 608389614, name: '사이즈', value: 'one size', stock: 465, addPrice: 5000, level: 2, options: [] }],
            minAddPrice: 5000,
            maxAddPrice: 5000,
            soldOut: false,
          },
        ],
        minAddPrice: 5000,
        maxAddPrice: 5000,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '000_상품명',
        value: '028_로앤 반팔 퍼프 가디건',
        level: 0,
        images: [],
        options: [
          {
            name: '색상',
            value: '화이트',
            level: 1,
            options: [{ id: 608389615, name: '사이즈', value: 'one size', stock: 443, addPrice: 1000, level: 2, options: [] }],
            minAddPrice: 1000,
            maxAddPrice: 1000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '블랙',
            level: 1,
            options: [{ id: 608389616, name: '사이즈', value: 'one size', stock: 435, addPrice: 1000, level: 2, options: [] }],
            minAddPrice: 1000,
            maxAddPrice: 1000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '그린',
            level: 1,
            options: [{ id: 608389617, name: '사이즈', value: 'one size', stock: 460, addPrice: 1000, level: 2, options: [] }],
            minAddPrice: 1000,
            maxAddPrice: 1000,
            soldOut: false,
          },
        ],
        minAddPrice: 1000,
        maxAddPrice: 1000,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '000_상품명',
        value: '029_애나 리본셔링 반팔 블라우스',
        level: 0,
        images: [],
        options: [
          {
            name: '색상',
            value: '퍼플',
            level: 1,
            options: [{ id: 608389618, name: '사이즈', value: 'one size', stock: 496, addPrice: 6000, level: 2, options: [] }],
            minAddPrice: 6000,
            maxAddPrice: 6000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '화이트',
            level: 1,
            options: [{ id: 608389619, name: '사이즈', value: 'one size', stock: 498, addPrice: 6000, level: 2, options: [] }],
            minAddPrice: 6000,
            maxAddPrice: 6000,
            soldOut: false,
          },
        ],
        minAddPrice: 6000,
        maxAddPrice: 6000,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '000_상품명',
        value: '030_스틸 반팔 트위드자켓',
        level: 0,
        images: [],
        options: [
          {
            name: '색상',
            value: '아이보리',
            level: 1,
            options: [{ id: 608389620, name: '사이즈', value: 'one size', stock: 494, addPrice: 18000, level: 2, options: [] }],
            minAddPrice: 18000,
            maxAddPrice: 18000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '그레이',
            level: 1,
            options: [{ id: 608389621, name: '사이즈', value: 'one size', stock: 480, addPrice: 18000, level: 2, options: [] }],
            minAddPrice: 18000,
            maxAddPrice: 18000,
            soldOut: false,
          },
        ],
        minAddPrice: 18000,
        maxAddPrice: 18000,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '000_상품명',
        value: '031_모브 콩단추 반팔 블라우스',
        level: 0,
        images: [],
        options: [
          {
            name: '색상',
            value: '나염',
            level: 1,
            options: [{ id: 608389622, name: '사이즈', value: 'one size', stock: 464, addPrice: 8000, level: 2, options: [] }],
            minAddPrice: 8000,
            maxAddPrice: 8000,
            soldOut: false,
          },
        ],
        minAddPrice: 8000,
        maxAddPrice: 8000,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '000_상품명',
        value: '032_오핀 일자핏 데님팬츠',
        level: 0,
        images: [],
        options: [
          {
            name: '색상',
            value: '연청',
            level: 1,
            options: [
              { id: 608389623, name: '사이즈', value: 'S', stock: 490, addPrice: 13000, level: 2, options: [] },
              { id: 608389624, name: '사이즈', value: 'M', stock: 487, addPrice: 13000, level: 2, options: [] },
              { id: 608389625, name: '사이즈', value: 'L', stock: 497, addPrice: 13000, level: 2, options: [] },
              { id: 608389626, name: '사이즈', value: 'XL', stock: 498, addPrice: 13000, level: 2, options: [] },
              { id: 608389627, name: '사이즈', value: '2XL', stock: 499, addPrice: 13000, level: 2, options: [] },
            ],
            minAddPrice: 13000,
            maxAddPrice: 13000,
            soldOut: false,
          },
        ],
        minAddPrice: 13000,
        maxAddPrice: 13000,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '000_상품명',
        value: '033_단가라 자수 반팔 카라니트',
        level: 0,
        images: [],
        options: [
          {
            name: '색상',
            value: '아이보리',
            level: 1,
            options: [{ id: 608389628, name: '사이즈', value: 'one size', stock: 446, addPrice: 5000, level: 2, options: [] }],
            minAddPrice: 5000,
            maxAddPrice: 5000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '블랙',
            level: 1,
            options: [{ id: 608389629, name: '사이즈', value: 'one size', stock: 475, addPrice: 5000, level: 2, options: [] }],
            minAddPrice: 5000,
            maxAddPrice: 5000,
            soldOut: false,
          },
        ],
        minAddPrice: 5000,
        maxAddPrice: 5000,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '000_상품명',
        value: '034_레일라 여리핏 블라우스',
        level: 0,
        images: [],
        options: [
          {
            name: '색상',
            value: '아이보리',
            level: 1,
            options: [{ id: 608389630, name: '사이즈', value: 'one size', stock: 474, addPrice: 10000, level: 2, options: [] }],
            minAddPrice: 10000,
            maxAddPrice: 10000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '블랙',
            level: 1,
            options: [{ id: 608389631, name: '사이즈', value: 'one size', stock: 0, addPrice: 10000, level: 2, options: [] }],
            soldOut: true,
          },
        ],
        minAddPrice: 10000,
        maxAddPrice: 10000,
        hasSoldOut: true,
        soldOut: false,
      },
      {
        name: '000_상품명',
        value: '035_밀리언 리보닝 반팔니트',
        level: 0,
        images: [],
        options: [
          {
            name: '색상',
            value: '스카이블루',
            level: 1,
            options: [{ id: 608389632, name: '사이즈', value: 'one size', stock: 497, addPrice: 8000, level: 2, options: [] }],
            minAddPrice: 8000,
            maxAddPrice: 8000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '핑크',
            level: 1,
            options: [{ id: 608389633, name: '사이즈', value: 'one size', stock: 497, addPrice: 8000, level: 2, options: [] }],
            minAddPrice: 8000,
            maxAddPrice: 8000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '베이지',
            level: 1,
            options: [{ id: 608389634, name: '사이즈', value: 'one size', stock: 499, addPrice: 8000, level: 2, options: [] }],
            minAddPrice: 8000,
            maxAddPrice: 8000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '아이보리',
            level: 1,
            options: [{ id: 608389635, name: '사이즈', value: 'one size', stock: 498, addPrice: 8000, level: 2, options: [] }],
            minAddPrice: 8000,
            maxAddPrice: 8000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '옐로우',
            level: 1,
            options: [{ id: 608389636, name: '사이즈', value: 'one size', stock: 498, addPrice: 8000, level: 2, options: [] }],
            minAddPrice: 8000,
            maxAddPrice: 8000,
            soldOut: false,
          },
        ],
        minAddPrice: 8000,
        maxAddPrice: 8000,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '000_상품명',
        value: '036_로타 스카시 퍼프니트',
        level: 0,
        images: [],
        options: [
          {
            name: '색상',
            value: '블랙',
            level: 1,
            options: [{ id: 608389637, name: '사이즈', value: 'one size', stock: 496, addPrice: 5000, level: 2, options: [] }],
            minAddPrice: 5000,
            maxAddPrice: 5000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '그린',
            level: 1,
            options: [{ id: 608389638, name: '사이즈', value: 'one size', stock: 494, addPrice: 5000, level: 2, options: [] }],
            minAddPrice: 5000,
            maxAddPrice: 5000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '아이보리',
            level: 1,
            options: [{ id: 608389639, name: '사이즈', value: 'one size', stock: 495, addPrice: 5000, level: 2, options: [] }],
            minAddPrice: 5000,
            maxAddPrice: 5000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '베이지',
            level: 1,
            options: [{ id: 608389640, name: '사이즈', value: 'one size', stock: 497, addPrice: 5000, level: 2, options: [] }],
            minAddPrice: 5000,
            maxAddPrice: 5000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '핑크',
            level: 1,
            options: [{ id: 608389641, name: '사이즈', value: 'one size', stock: 493, addPrice: 5000, level: 2, options: [] }],
            minAddPrice: 5000,
            maxAddPrice: 5000,
            soldOut: false,
          },
        ],
        minAddPrice: 5000,
        maxAddPrice: 5000,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '000_상품명',
        value: '037_브루클린 반팔 티셔츠',
        level: 0,
        images: [],
        options: [
          {
            name: '색상',
            value: '화이트',
            level: 1,
            options: [{ id: 608389642, name: '사이즈', value: 'one size', stock: 454, addPrice: -1000, level: 2, options: [] }],
            minAddPrice: -1000,
            maxAddPrice: -1000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '그레이',
            level: 1,
            options: [{ id: 608389643, name: '사이즈', value: 'one size', stock: 488, addPrice: -1000, level: 2, options: [] }],
            minAddPrice: -1000,
            maxAddPrice: -1000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '그린',
            level: 1,
            options: [{ id: 608389644, name: '사이즈', value: 'one size', stock: 496, addPrice: -1000, level: 2, options: [] }],
            minAddPrice: -1000,
            maxAddPrice: -1000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '네이비',
            level: 1,
            options: [{ id: 608389645, name: '사이즈', value: 'one size', stock: 469, addPrice: -1000, level: 2, options: [] }],
            minAddPrice: -1000,
            maxAddPrice: -1000,
            soldOut: false,
          },
        ],
        minAddPrice: -1000,
        maxAddPrice: -1000,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '000_상품명',
        value: '038_죠앤 퍼프슬리브니트',
        level: 0,
        images: [],
        options: [
          {
            name: '색상',
            value: '블랙',
            level: 1,
            options: [{ id: 608389646, name: '사이즈', value: 'FREE', stock: 455, addPrice: -2000, level: 2, options: [] }],
            minAddPrice: -2000,
            maxAddPrice: -2000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '블루',
            level: 1,
            options: [{ id: 608389647, name: '사이즈', value: 'FREE', stock: 489, addPrice: -2000, level: 2, options: [] }],
            minAddPrice: -2000,
            maxAddPrice: -2000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '아이보리',
            level: 1,
            options: [{ id: 608389648, name: '사이즈', value: 'FREE', stock: 469, addPrice: -2000, level: 2, options: [] }],
            minAddPrice: -2000,
            maxAddPrice: -2000,
            soldOut: false,
          },
        ],
        minAddPrice: -2000,
        maxAddPrice: -2000,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '000_상품명',
        value: '039_올리비아 코튼 뷔스티에 원피스',
        level: 0,
        images: [],
        options: [
          {
            name: '색상',
            value: '화이트',
            level: 1,
            options: [{ id: 608389649, name: '사이즈', value: 'one size', stock: 470, addPrice: 20000, level: 2, options: [] }],
            minAddPrice: 20000,
            maxAddPrice: 20000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '인디핑크',
            level: 1,
            options: [{ id: 608389650, name: '사이즈', value: 'one size', stock: 500, addPrice: 20000, level: 2, options: [] }],
            minAddPrice: 20000,
            maxAddPrice: 20000,
            soldOut: false,
          },
        ],
        minAddPrice: 20000,
        maxAddPrice: 20000,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '000_상품명',
        value: '040_린넨 루즈핏 V넥 반팔니트',
        level: 0,
        images: [],
        options: [
          {
            name: '색상',
            value: '다크그레이',
            level: 1,
            options: [{ id: 608389651, name: '사이즈', value: 'one size', stock: 493, addPrice: 8000, level: 2, options: [] }],
            minAddPrice: 8000,
            maxAddPrice: 8000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '베이지',
            level: 1,
            options: [{ id: 608389652, name: '사이즈', value: 'one size', stock: 490, addPrice: 8000, level: 2, options: [] }],
            minAddPrice: 8000,
            maxAddPrice: 8000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '블랙',
            level: 1,
            options: [{ id: 608389653, name: '사이즈', value: 'one size', stock: 491, addPrice: 8000, level: 2, options: [] }],
            minAddPrice: 8000,
            maxAddPrice: 8000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '스카이블루',
            level: 1,
            options: [{ id: 608389654, name: '사이즈', value: 'one size', stock: 479, addPrice: 8000, level: 2, options: [] }],
            minAddPrice: 8000,
            maxAddPrice: 8000,
            soldOut: false,
          },
        ],
        minAddPrice: 8000,
        maxAddPrice: 8000,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '000_상품명',
        value: '041_아그네스 셔링 블라우스',
        level: 0,
        images: [],
        options: [
          {
            name: '색상',
            value: '화이트',
            level: 1,
            options: [{ id: 608389655, name: '사이즈', value: 'one size', stock: 440, addPrice: 10000, level: 2, options: [] }],
            minAddPrice: 10000,
            maxAddPrice: 10000,
            soldOut: false,
          },
        ],
        minAddPrice: 10000,
        maxAddPrice: 10000,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '000_상품명',
        value: '042_로덴 라운드 반팔가디건',
        level: 0,
        images: [],
        options: [
          {
            name: '색상',
            value: '블랙',
            level: 1,
            options: [{ id: 608389656, name: '사이즈', value: 'one size', stock: 497, addPrice: 10000, level: 2, options: [] }],
            minAddPrice: 10000,
            maxAddPrice: 10000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '레드',
            level: 1,
            options: [{ id: 608389657, name: '사이즈', value: 'one size', stock: 496, addPrice: 10000, level: 2, options: [] }],
            minAddPrice: 10000,
            maxAddPrice: 10000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '블루',
            level: 1,
            options: [{ id: 608389658, name: '사이즈', value: 'one size', stock: 489, addPrice: 10000, level: 2, options: [] }],
            minAddPrice: 10000,
            maxAddPrice: 10000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '아이보리',
            level: 1,
            options: [{ id: 608389659, name: '사이즈', value: 'one size', stock: 499, addPrice: 10000, level: 2, options: [] }],
            minAddPrice: 10000,
            maxAddPrice: 10000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '올리브',
            level: 1,
            options: [{ id: 608389660, name: '사이즈', value: 'one size', stock: 500, addPrice: 10000, level: 2, options: [] }],
            minAddPrice: 10000,
            maxAddPrice: 10000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '핑크',
            level: 1,
            options: [{ id: 608389661, name: '사이즈', value: 'one size', stock: 491, addPrice: 10000, level: 2, options: [] }],
            minAddPrice: 10000,
            maxAddPrice: 10000,
            soldOut: false,
          },
        ],
        minAddPrice: 10000,
        maxAddPrice: 10000,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '000_상품명',
        value: '043_웨이브 원버튼 썸머가디건',
        level: 0,
        images: [],
        options: [
          {
            name: '색상',
            value: '아이보리',
            level: 1,
            options: [{ id: 608389662, name: '사이즈', value: 'one size', stock: 477, addPrice: -1000, level: 2, options: [] }],
            minAddPrice: -1000,
            maxAddPrice: -1000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '크림',
            level: 1,
            options: [{ id: 608389663, name: '사이즈', value: 'one size', stock: 492, addPrice: -1000, level: 2, options: [] }],
            minAddPrice: -1000,
            maxAddPrice: -1000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '퍼플',
            level: 1,
            options: [{ id: 608389664, name: '사이즈', value: 'one size', stock: 494, addPrice: -1000, level: 2, options: [] }],
            minAddPrice: -1000,
            maxAddPrice: -1000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '핑크',
            level: 1,
            options: [{ id: 608389665, name: '사이즈', value: 'one size', stock: 493, addPrice: -1000, level: 2, options: [] }],
            minAddPrice: -1000,
            maxAddPrice: -1000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '스카이블루',
            level: 1,
            options: [{ id: 608389666, name: '사이즈', value: 'one size', stock: 495, addPrice: -1000, level: 2, options: [] }],
            minAddPrice: -1000,
            maxAddPrice: -1000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '블랙',
            level: 1,
            options: [{ id: 608389667, name: '사이즈', value: 'one size', stock: 476, addPrice: -1000, level: 2, options: [] }],
            minAddPrice: -1000,
            maxAddPrice: -1000,
            soldOut: false,
          },
        ],
        minAddPrice: -1000,
        maxAddPrice: -1000,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '000_상품명',
        value: '044_링클프리 베이직 반팔셔츠',
        level: 0,
        images: [],
        options: [
          {
            name: '색상',
            value: '네이비',
            level: 1,
            options: [{ id: 608389668, name: '사이즈', value: 'one size', stock: 496, addPrice: 4000, level: 2, options: [] }],
            minAddPrice: 4000,
            maxAddPrice: 4000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '라이트민트',
            level: 1,
            options: [{ id: 608389669, name: '사이즈', value: 'one size', stock: 486, addPrice: 4000, level: 2, options: [] }],
            minAddPrice: 4000,
            maxAddPrice: 4000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '라이트스카이',
            level: 1,
            options: [{ id: 608389670, name: '사이즈', value: 'one size', stock: 495, addPrice: 4000, level: 2, options: [] }],
            minAddPrice: 4000,
            maxAddPrice: 4000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '스카이',
            level: 1,
            options: [{ id: 608389671, name: '사이즈', value: 'one size', stock: 494, addPrice: 4000, level: 2, options: [] }],
            minAddPrice: 4000,
            maxAddPrice: 4000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '베이지',
            level: 1,
            options: [{ id: 608389672, name: '사이즈', value: 'one size', stock: 496, addPrice: 4000, level: 2, options: [] }],
            minAddPrice: 4000,
            maxAddPrice: 4000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '화이트',
            level: 1,
            options: [{ id: 608389673, name: '사이즈', value: 'one size', stock: 482, addPrice: 4000, level: 2, options: [] }],
            minAddPrice: 4000,
            maxAddPrice: 4000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '핑크',
            level: 1,
            options: [{ id: 608389674, name: '사이즈', value: 'one size', stock: 499, addPrice: 4000, level: 2, options: [] }],
            minAddPrice: 4000,
            maxAddPrice: 4000,
            soldOut: false,
          },
        ],
        minAddPrice: 4000,
        maxAddPrice: 4000,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '000_상품명',
        value: '045_링클프리 오픈카라 반팔셔츠',
        level: 0,
        images: [],
        options: [
          {
            name: '색상',
            value: '화이트',
            level: 1,
            options: [{ id: 608389675, name: '사이즈', value: 'one size', stock: 493, addPrice: 4000, level: 2, options: [] }],
            minAddPrice: 4000,
            maxAddPrice: 4000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '연베이지',
            level: 1,
            options: [{ id: 608389676, name: '사이즈', value: 'one size', stock: 488, addPrice: 4000, level: 2, options: [] }],
            minAddPrice: 4000,
            maxAddPrice: 4000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '인디핑크',
            level: 1,
            options: [{ id: 608389677, name: '사이즈', value: 'one size', stock: 487, addPrice: 4000, level: 2, options: [] }],
            minAddPrice: 4000,
            maxAddPrice: 4000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '옐로우',
            level: 1,
            options: [{ id: 608389678, name: '사이즈', value: 'one size', stock: 492, addPrice: 4000, level: 2, options: [] }],
            minAddPrice: 4000,
            maxAddPrice: 4000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '민트',
            level: 1,
            options: [{ id: 608389679, name: '사이즈', value: 'one size', stock: 498, addPrice: 4000, level: 2, options: [] }],
            minAddPrice: 4000,
            maxAddPrice: 4000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '스카이',
            level: 1,
            options: [{ id: 608389680, name: '사이즈', value: 'one size', stock: 499, addPrice: 4000, level: 2, options: [] }],
            minAddPrice: 4000,
            maxAddPrice: 4000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '블랙',
            level: 1,
            options: [{ id: 608389681, name: '사이즈', value: 'one size', stock: 493, addPrice: 4000, level: 2, options: [] }],
            minAddPrice: 4000,
            maxAddPrice: 4000,
            soldOut: false,
          },
        ],
        minAddPrice: 4000,
        maxAddPrice: 4000,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '000_상품명',
        value: '046_[코코메이드] 이지밴딩 트레이닝 슬랙스',
        level: 0,
        images: [],
        options: [
          {
            name: '색상',
            value: '블랙(롱)',
            level: 1,
            options: [{ id: 608389682, name: '사이즈', value: 'one size', stock: 492, addPrice: 5000, level: 2, options: [] }],
            minAddPrice: 5000,
            maxAddPrice: 5000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '블랙(기본)',
            level: 1,
            options: [{ id: 608389683, name: '사이즈', value: 'one size', stock: 472, addPrice: 5000, level: 2, options: [] }],
            minAddPrice: 5000,
            maxAddPrice: 5000,
            soldOut: false,
          },
        ],
        minAddPrice: 5000,
        maxAddPrice: 5000,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '000_상품명',
        value: '047_에린 니트콤비 블라우스',
        level: 0,
        images: [],
        options: [
          {
            name: '색상',
            value: '베이지',
            level: 1,
            options: [{ id: 608389684, name: '사이즈', value: 'one size', stock: 466, addPrice: 3000, level: 2, options: [] }],
            minAddPrice: 3000,
            maxAddPrice: 3000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '블랙',
            level: 1,
            options: [{ id: 608389685, name: '사이즈', value: 'one size', stock: 489, addPrice: 3000, level: 2, options: [] }],
            minAddPrice: 3000,
            maxAddPrice: 3000,
            soldOut: false,
          },
        ],
        minAddPrice: 3000,
        maxAddPrice: 3000,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '000_상품명',
        value: '048_코니 데님뷔스티에원피스+블라우스set',
        level: 0,
        images: [],
        options: [
          {
            name: '색상',
            value: '진청',
            level: 1,
            options: [{ id: 608389686, name: '사이즈', value: 'FREE', stock: 457, addPrice: 10000, level: 2, options: [] }],
            minAddPrice: 10000,
            maxAddPrice: 10000,
            soldOut: false,
          },
        ],
        minAddPrice: 10000,
        maxAddPrice: 10000,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '000_상품명',
        value: '049_파크 루즈핏 반팔티셔츠',
        level: 0,
        images: [],
        options: [
          {
            name: '색상',
            value: '아이보리',
            level: 1,
            options: [{ id: 608389687, name: '사이즈', value: 'one size', stock: 483, addPrice: 2000, level: 2, options: [] }],
            minAddPrice: 2000,
            maxAddPrice: 2000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '베이지',
            level: 1,
            options: [{ id: 608389688, name: '사이즈', value: 'one size', stock: 490, addPrice: 2000, level: 2, options: [] }],
            minAddPrice: 2000,
            maxAddPrice: 2000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '네이비',
            level: 1,
            options: [{ id: 608389689, name: '사이즈', value: 'one size', stock: 499, addPrice: 2000, level: 2, options: [] }],
            minAddPrice: 2000,
            maxAddPrice: 2000,
            soldOut: false,
          },
        ],
        minAddPrice: 2000,
        maxAddPrice: 2000,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '000_상품명',
        value: '050_힙트 컬러 카고팬츠(투웨이)',
        level: 0,
        images: [],
        options: [
          {
            name: '색상',
            value: '그레이',
            level: 1,
            options: [{ id: 608389690, name: '사이즈', value: 'one size', stock: 498, addPrice: 16000, level: 2, options: [] }],
            minAddPrice: 16000,
            maxAddPrice: 16000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '백멜란지',
            level: 1,
            options: [{ id: 608389691, name: '사이즈', value: 'one size', stock: 498, addPrice: 16000, level: 2, options: [] }],
            minAddPrice: 16000,
            maxAddPrice: 16000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '블랙',
            level: 1,
            options: [{ id: 608389692, name: '사이즈', value: 'one size', stock: 498, addPrice: 16000, level: 2, options: [] }],
            minAddPrice: 16000,
            maxAddPrice: 16000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '아이보리',
            level: 1,
            options: [{ id: 608389693, name: '사이즈', value: 'one size', stock: 499, addPrice: 16000, level: 2, options: [] }],
            minAddPrice: 16000,
            maxAddPrice: 16000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '핑크',
            level: 1,
            options: [{ id: 608389694, name: '사이즈', value: 'one size', stock: 483, addPrice: 16000, level: 2, options: [] }],
            minAddPrice: 16000,
            maxAddPrice: 16000,
            soldOut: false,
          },
        ],
        minAddPrice: 16000,
        maxAddPrice: 16000,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '000_상품명',
        value: '051_-3kg 슬림핏 골지티셔츠',
        level: 0,
        images: [],
        options: [
          {
            name: '색상',
            value: '아이보리',
            level: 1,
            options: [{ id: 608389695, name: '사이즈', value: 'one size', stock: 476, addPrice: -2000, level: 2, options: [] }],
            minAddPrice: -2000,
            maxAddPrice: -2000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '그레이',
            level: 1,
            options: [{ id: 608389696, name: '사이즈', value: 'one size', stock: 499, addPrice: -2000, level: 2, options: [] }],
            minAddPrice: -2000,
            maxAddPrice: -2000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '스카이블루',
            level: 1,
            options: [{ id: 608389697, name: '사이즈', value: 'one size', stock: 497, addPrice: -2000, level: 2, options: [] }],
            minAddPrice: -2000,
            maxAddPrice: -2000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '핑크',
            level: 1,
            options: [{ id: 608389698, name: '사이즈', value: 'one size', stock: 491, addPrice: -2000, level: 2, options: [] }],
            minAddPrice: -2000,
            maxAddPrice: -2000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '블랙',
            level: 1,
            options: [{ id: 608389699, name: '사이즈', value: 'one size', stock: 458, addPrice: -2000, level: 2, options: [] }],
            minAddPrice: -2000,
            maxAddPrice: -2000,
            soldOut: false,
          },
        ],
        minAddPrice: -2000,
        maxAddPrice: -2000,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '000_상품명',
        value: '052_커밀 레터링반팔티셔츠',
        level: 0,
        images: [],
        options: [
          {
            name: '색상',
            value: '화이트',
            level: 1,
            options: [{ id: 608389700, name: '사이즈', value: 'FREE', stock: 460, addPrice: -3000, level: 2, options: [] }],
            minAddPrice: -3000,
            maxAddPrice: -3000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '스카이블루',
            level: 1,
            options: [{ id: 608389701, name: '사이즈', value: 'FREE', stock: 458, addPrice: -3000, level: 2, options: [] }],
            minAddPrice: -3000,
            maxAddPrice: -3000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '블랙',
            level: 1,
            options: [{ id: 608389702, name: '사이즈', value: 'FREE', stock: 484, addPrice: -3000, level: 2, options: [] }],
            minAddPrice: -3000,
            maxAddPrice: -3000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '크림',
            level: 1,
            options: [{ id: 608389703, name: '사이즈', value: 'FREE', stock: 468, addPrice: -3000, level: 2, options: [] }],
            minAddPrice: -3000,
            maxAddPrice: -3000,
            soldOut: false,
          },
        ],
        minAddPrice: -3000,
        maxAddPrice: -3000,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '000_상품명',
        value: '053_하트버튼 반팔 트위드 자켓',
        level: 0,
        images: [],
        options: [
          {
            name: '색상',
            value: '블랙',
            level: 1,
            options: [{ id: 608389704, name: '사이즈', value: 'one size', stock: 478, addPrice: 10000, level: 2, options: [] }],
            minAddPrice: 10000,
            maxAddPrice: 10000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '아이보리',
            level: 1,
            options: [{ id: 608389705, name: '사이즈', value: 'one size', stock: 474, addPrice: 10000, level: 2, options: [] }],
            minAddPrice: 10000,
            maxAddPrice: 10000,
            soldOut: false,
          },
        ],
        minAddPrice: 10000,
        maxAddPrice: 10000,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '000_상품명',
        value: '054_로웰 시스루 썸머가디건',
        level: 0,
        images: [],
        options: [
          {
            name: '색상',
            value: '스카이블루',
            level: 1,
            options: [{ id: 608389706, name: '사이즈', value: 'one size', stock: 496, addPrice: 3000, level: 2, options: [] }],
            minAddPrice: 3000,
            maxAddPrice: 3000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '핑크',
            level: 1,
            options: [{ id: 608389707, name: '사이즈', value: 'one size', stock: 499, addPrice: 3000, level: 2, options: [] }],
            minAddPrice: 3000,
            maxAddPrice: 3000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '그린',
            level: 1,
            options: [{ id: 608389708, name: '사이즈', value: 'one size', stock: 499, addPrice: 3000, level: 2, options: [] }],
            minAddPrice: 3000,
            maxAddPrice: 3000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '블랙',
            level: 1,
            options: [{ id: 608389709, name: '사이즈', value: 'one size', stock: 497, addPrice: 3000, level: 2, options: [] }],
            minAddPrice: 3000,
            maxAddPrice: 3000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '아이보리',
            level: 1,
            options: [{ id: 608389710, name: '사이즈', value: 'one size', stock: 498, addPrice: 3000, level: 2, options: [] }],
            minAddPrice: 3000,
            maxAddPrice: 3000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '화이트',
            level: 1,
            options: [{ id: 608389711, name: '사이즈', value: 'one size', stock: 498, addPrice: 3000, level: 2, options: [] }],
            minAddPrice: 3000,
            maxAddPrice: 3000,
            soldOut: false,
          },
        ],
        minAddPrice: 3000,
        maxAddPrice: 3000,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '000_상품명',
        value: '055_쿨썸머 와샤 와이드팬츠(밴딩)',
        level: 0,
        images: [],
        options: [
          {
            name: '색상',
            value: '베이지',
            level: 1,
            options: [{ id: 608389712, name: '사이즈', value: 'one size', stock: 493, addPrice: 7000, level: 2, options: [] }],
            minAddPrice: 7000,
            maxAddPrice: 7000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '핑크',
            level: 1,
            options: [{ id: 608389713, name: '사이즈', value: 'one size', stock: 499, addPrice: 7000, level: 2, options: [] }],
            minAddPrice: 7000,
            maxAddPrice: 7000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '라이트그레이',
            level: 1,
            options: [{ id: 608389714, name: '사이즈', value: 'one size', stock: 492, addPrice: 7000, level: 2, options: [] }],
            minAddPrice: 7000,
            maxAddPrice: 7000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '스카이블루',
            level: 1,
            options: [{ id: 608389715, name: '사이즈', value: 'one size', stock: 498, addPrice: 7000, level: 2, options: [] }],
            minAddPrice: 7000,
            maxAddPrice: 7000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '다크그레이',
            level: 1,
            options: [{ id: 608389716, name: '사이즈', value: 'one size', stock: 500, addPrice: 7000, level: 2, options: [] }],
            minAddPrice: 7000,
            maxAddPrice: 7000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '블랙',
            level: 1,
            options: [{ id: 608389717, name: '사이즈', value: 'one size', stock: 494, addPrice: 7000, level: 2, options: [] }],
            minAddPrice: 7000,
            maxAddPrice: 7000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '브라운',
            level: 1,
            options: [{ id: 608389718, name: '사이즈', value: 'one size', stock: 499, addPrice: 7000, level: 2, options: [] }],
            minAddPrice: 7000,
            maxAddPrice: 7000,
            soldOut: false,
          },
        ],
        minAddPrice: 7000,
        maxAddPrice: 7000,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '000_상품명',
        value: '056_롤린 리본 가디건 세트',
        level: 0,
        images: [],
        options: [
          {
            name: '색상',
            value: '스카이블루',
            level: 1,
            options: [{ id: 608389719, name: '사이즈', value: 'one size', stock: 495, addPrice: 7000, level: 2, options: [] }],
            minAddPrice: 7000,
            maxAddPrice: 7000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '민트',
            level: 1,
            options: [{ id: 608389720, name: '사이즈', value: 'one size', stock: 499, addPrice: 7000, level: 2, options: [] }],
            minAddPrice: 7000,
            maxAddPrice: 7000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '핑크',
            level: 1,
            options: [{ id: 608389721, name: '사이즈', value: 'one size', stock: 497, addPrice: 7000, level: 2, options: [] }],
            minAddPrice: 7000,
            maxAddPrice: 7000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '화이트',
            level: 1,
            options: [{ id: 608389722, name: '사이즈', value: 'one size', stock: 498, addPrice: 7000, level: 2, options: [] }],
            minAddPrice: 7000,
            maxAddPrice: 7000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '블랙',
            level: 1,
            options: [{ id: 608389723, name: '사이즈', value: 'one size', stock: 494, addPrice: 7000, level: 2, options: [] }],
            minAddPrice: 7000,
            maxAddPrice: 7000,
            soldOut: false,
          },
        ],
        minAddPrice: 7000,
        maxAddPrice: 7000,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '000_상품명',
        value: '057_빈즈 스트라이프 반팔 가디건',
        level: 0,
        images: [],
        options: [
          {
            name: '색상',
            value: '블랙스트라이프',
            level: 1,
            options: [{ id: 608389724, name: '사이즈', value: 'one size', stock: 451, addPrice: 4000, level: 2, options: [] }],
            minAddPrice: 4000,
            maxAddPrice: 4000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '블루스트라이프',
            level: 1,
            options: [{ id: 608389725, name: '사이즈', value: 'one size', stock: 462, addPrice: 4000, level: 2, options: [] }],
            minAddPrice: 4000,
            maxAddPrice: 4000,
            soldOut: false,
          },
        ],
        minAddPrice: 4000,
        maxAddPrice: 4000,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '000_상품명',
        value: '058_트레블 보이핏 데님팬츠(밴딩)',
        level: 0,
        images: [],
        options: [
          {
            name: '색상',
            value: '아이보리',
            level: 1,
            options: [
              { id: 608389726, name: '사이즈', value: 'S', stock: 496, addPrice: 4000, level: 2, options: [] },
              { id: 608389727, name: '사이즈', value: 'M', stock: 496, addPrice: 4000, level: 2, options: [] },
              { id: 608389728, name: '사이즈', value: 'L', stock: 495, addPrice: 4000, level: 2, options: [] },
            ],
            minAddPrice: 4000,
            maxAddPrice: 4000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '연청',
            level: 1,
            options: [
              { id: 608389729, name: '사이즈', value: 'S', stock: 499, addPrice: 4000, level: 2, options: [] },
              { id: 608389730, name: '사이즈', value: 'M', stock: 498, addPrice: 4000, level: 2, options: [] },
              { id: 608389731, name: '사이즈', value: 'L', stock: 497, addPrice: 4000, level: 2, options: [] },
            ],
            minAddPrice: 4000,
            maxAddPrice: 4000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '빈티지',
            level: 1,
            options: [
              { id: 608389732, name: '사이즈', value: 'S', stock: 498, addPrice: 4000, level: 2, options: [] },
              { id: 608389733, name: '사이즈', value: 'M', stock: 496, addPrice: 4000, level: 2, options: [] },
              { id: 608389734, name: '사이즈', value: 'L', stock: 499, addPrice: 4000, level: 2, options: [] },
            ],
            minAddPrice: 4000,
            maxAddPrice: 4000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '진청',
            level: 1,
            options: [
              { id: 608389735, name: '사이즈', value: 'S', stock: 499, addPrice: 4000, level: 2, options: [] },
              { id: 608389736, name: '사이즈', value: 'M', stock: 499, addPrice: 4000, level: 2, options: [] },
              { id: 608389737, name: '사이즈', value: 'L', stock: 496, addPrice: 4000, level: 2, options: [] },
            ],
            minAddPrice: 4000,
            maxAddPrice: 4000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '블랙',
            level: 1,
            options: [
              { id: 608389738, name: '사이즈', value: 'S', stock: 500, addPrice: 4000, level: 2, options: [] },
              { id: 608389739, name: '사이즈', value: 'M', stock: 500, addPrice: 4000, level: 2, options: [] },
              { id: 608389740, name: '사이즈', value: 'L', stock: 499, addPrice: 4000, level: 2, options: [] },
            ],
            minAddPrice: 4000,
            maxAddPrice: 4000,
            soldOut: false,
          },
        ],
        minAddPrice: 4000,
        maxAddPrice: 4000,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '000_상품명',
        value: '059_몰린 진주 퍼프 반팔 니트',
        level: 0,
        images: [],
        options: [
          {
            name: '색상',
            value: '아이보리',
            level: 1,
            options: [{ id: 608389741, name: '사이즈', value: 'one size', stock: 492, addPrice: 7000, level: 2, options: [] }],
            minAddPrice: 7000,
            maxAddPrice: 7000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '스카이블루',
            level: 1,
            options: [{ id: 608389742, name: '사이즈', value: 'one size', stock: 494, addPrice: 7000, level: 2, options: [] }],
            minAddPrice: 7000,
            maxAddPrice: 7000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '핑크',
            level: 1,
            options: [{ id: 608389743, name: '사이즈', value: 'one size', stock: 488, addPrice: 7000, level: 2, options: [] }],
            minAddPrice: 7000,
            maxAddPrice: 7000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '옐로우',
            level: 1,
            options: [{ id: 608389744, name: '사이즈', value: 'one size', stock: 493, addPrice: 7000, level: 2, options: [] }],
            minAddPrice: 7000,
            maxAddPrice: 7000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '블랙',
            level: 1,
            options: [{ id: 608389745, name: '사이즈', value: 'one size', stock: 492, addPrice: 7000, level: 2, options: [] }],
            minAddPrice: 7000,
            maxAddPrice: 7000,
            soldOut: false,
          },
        ],
        minAddPrice: 7000,
        maxAddPrice: 7000,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '000_상품명',
        value: '060_로이 퍼프 반팔 블라우스',
        level: 0,
        images: [],
        options: [
          {
            name: '색상',
            value: '베이지',
            level: 1,
            options: [{ id: 608389746, name: '사이즈', value: 'one size', stock: 496, addPrice: 8000, level: 2, options: [] }],
            minAddPrice: 8000,
            maxAddPrice: 8000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '화이트',
            level: 1,
            options: [{ id: 608389747, name: '사이즈', value: 'one size', stock: 493, addPrice: 8000, level: 2, options: [] }],
            minAddPrice: 8000,
            maxAddPrice: 8000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '블루',
            level: 1,
            options: [{ id: 608389748, name: '사이즈', value: 'one size', stock: 492, addPrice: 8000, level: 2, options: [] }],
            minAddPrice: 8000,
            maxAddPrice: 8000,
            soldOut: false,
          },
        ],
        minAddPrice: 8000,
        maxAddPrice: 8000,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '000_상품명',
        value: '061_베슬로 투버튼 와이드 슬랙스',
        level: 0,
        images: [],
        options: [
          {
            name: '색상',
            value: '베이지',
            level: 1,
            options: [
              { id: 608389749, name: '사이즈', value: 'S', stock: 498, addPrice: 4000, level: 2, options: [] },
              { id: 608389750, name: '사이즈', value: 'M', stock: 498, addPrice: 4000, level: 2, options: [] },
              { id: 608389751, name: '사이즈', value: 'L', stock: 499, addPrice: 4000, level: 2, options: [] },
            ],
            minAddPrice: 4000,
            maxAddPrice: 4000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '그레이',
            level: 1,
            options: [
              { id: 608389752, name: '사이즈', value: 'S', stock: 499, addPrice: 4000, level: 2, options: [] },
              { id: 608389753, name: '사이즈', value: 'M', stock: 497, addPrice: 4000, level: 2, options: [] },
              { id: 608389754, name: '사이즈', value: 'L', stock: 498, addPrice: 4000, level: 2, options: [] },
            ],
            minAddPrice: 4000,
            maxAddPrice: 4000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '블랙',
            level: 1,
            options: [
              { id: 608389755, name: '사이즈', value: 'S', stock: 498, addPrice: 4000, level: 2, options: [] },
              { id: 608389756, name: '사이즈', value: 'M', stock: 493, addPrice: 4000, level: 2, options: [] },
              { id: 608389757, name: '사이즈', value: 'L', stock: 492, addPrice: 4000, level: 2, options: [] },
            ],
            minAddPrice: 4000,
            maxAddPrice: 4000,
            soldOut: false,
          },
        ],
        minAddPrice: 4000,
        maxAddPrice: 4000,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '000_상품명',
        value: '062_딥슬릿 롱 데님 스커트',
        level: 0,
        images: [],
        options: [
          {
            name: '색상',
            value: '연청',
            level: 1,
            options: [
              { id: 608389758, name: '사이즈', value: 'S', stock: 496, addPrice: 19000, level: 2, options: [] },
              { id: 608389759, name: '사이즈', value: 'M', stock: 490, addPrice: 19000, level: 2, options: [] },
              { id: 608389760, name: '사이즈', value: 'L', stock: 497, addPrice: 19000, level: 2, options: [] },
            ],
            minAddPrice: 19000,
            maxAddPrice: 19000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '진청',
            level: 1,
            options: [
              { id: 608389761, name: '사이즈', value: 'S', stock: 500, addPrice: 19000, level: 2, options: [] },
              { id: 608389762, name: '사이즈', value: 'M', stock: 498, addPrice: 19000, level: 2, options: [] },
              { id: 608389763, name: '사이즈', value: 'L', stock: 500, addPrice: 19000, level: 2, options: [] },
            ],
            minAddPrice: 19000,
            maxAddPrice: 19000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '블랙',
            level: 1,
            options: [
              { id: 608389764, name: '사이즈', value: 'S', stock: 500, addPrice: 19000, level: 2, options: [] },
              { id: 608389765, name: '사이즈', value: 'M', stock: 497, addPrice: 19000, level: 2, options: [] },
              { id: 608389766, name: '사이즈', value: 'L', stock: 500, addPrice: 19000, level: 2, options: [] },
            ],
            minAddPrice: 19000,
            maxAddPrice: 19000,
            soldOut: false,
          },
        ],
        minAddPrice: 19000,
        maxAddPrice: 19000,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '000_상품명',
        value: '063_무드 반팔 트위드 자켓',
        level: 0,
        images: [],
        options: [
          {
            name: '색상',
            value: '아이보리',
            level: 1,
            options: [{ id: 608389767, name: '사이즈', value: 'one size', stock: 495, addPrice: 9000, level: 2, options: [] }],
            minAddPrice: 9000,
            maxAddPrice: 9000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '핑크',
            level: 1,
            options: [{ id: 608389768, name: '사이즈', value: 'one size', stock: 476, addPrice: 9000, level: 2, options: [] }],
            minAddPrice: 9000,
            maxAddPrice: 9000,
            soldOut: false,
          },
        ],
        minAddPrice: 9000,
        maxAddPrice: 9000,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '000_상품명',
        value: '064_제이시 생지 부츠컷팬츠(길이선택)',
        level: 0,
        images: [],
        options: [
          {
            name: '색상',
            value: '진청(숏)',
            level: 1,
            options: [
              { id: 608389769, name: '사이즈', value: 'S', stock: 493, addPrice: 19000, level: 2, options: [] },
              { id: 608389770, name: '사이즈', value: 'M', stock: 495, addPrice: 19000, level: 2, options: [] },
              { id: 608389771, name: '사이즈', value: 'L', stock: 499, addPrice: 19000, level: 2, options: [] },
              { id: 608389772, name: '사이즈', value: 'XL', stock: 499, addPrice: 20000, level: 2, options: [] },
              { id: 608389773, name: '사이즈', value: '2XL', stock: 500, addPrice: 20000, level: 2, options: [] },
            ],
            minAddPrice: 19000,
            maxAddPrice: 20000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '진청(롱)',
            level: 1,
            options: [
              { id: 608389774, name: '사이즈', value: 'S', stock: 498, addPrice: 19000, level: 2, options: [] },
              { id: 608389775, name: '사이즈', value: 'M', stock: 496, addPrice: 19000, level: 2, options: [] },
              { id: 608389776, name: '사이즈', value: 'L', stock: 496, addPrice: 19000, level: 2, options: [] },
              { id: 608389777, name: '사이즈', value: 'XL', stock: 498, addPrice: 20000, level: 2, options: [] },
              { id: 608389778, name: '사이즈', value: '2XL', stock: 500, addPrice: 20000, level: 2, options: [] },
            ],
            minAddPrice: 19000,
            maxAddPrice: 20000,
            soldOut: false,
          },
        ],
        minAddPrice: 19000,
        maxAddPrice: 20000,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '000_상품명',
        value: '065_토레스 보이핏 데님 팬츠(뒷밴딩)',
        level: 0,
        images: [],
        options: [
          {
            name: '색상',
            value: '진청',
            level: 1,
            options: [
              { id: 608389779, name: '사이즈', value: 'S', stock: 499, addPrice: 4000, level: 2, options: [] },
              { id: 608389780, name: '사이즈', value: 'M', stock: 494, addPrice: 4000, level: 2, options: [] },
              { id: 608389781, name: '사이즈', value: 'L', stock: 489, addPrice: 4000, level: 2, options: [] },
            ],
            minAddPrice: 4000,
            maxAddPrice: 4000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '블랙',
            level: 1,
            options: [
              { id: 608389782, name: '사이즈', value: 'S', stock: 498, addPrice: 4000, level: 2, options: [] },
              { id: 608389783, name: '사이즈', value: 'M', stock: 497, addPrice: 4000, level: 2, options: [] },
              { id: 608389784, name: '사이즈', value: 'L', stock: 492, addPrice: 4000, level: 2, options: [] },
            ],
            minAddPrice: 4000,
            maxAddPrice: 4000,
            soldOut: false,
          },
        ],
        minAddPrice: 4000,
        maxAddPrice: 4000,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '000_상품명',
        value: '066_[코코메이드] 스테이트 스프링 맨투맨',
        level: 0,
        images: [],
        options: [
          {
            name: '색상',
            value: '네이비',
            level: 1,
            options: [{ id: 608389785, name: '사이즈', value: 'one size', stock: 490, addPrice: 3000, level: 2, options: [] }],
            minAddPrice: 3000,
            maxAddPrice: 3000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '카키',
            level: 1,
            options: [{ id: 608389786, name: '사이즈', value: 'one size', stock: 485, addPrice: 3000, level: 2, options: [] }],
            minAddPrice: 3000,
            maxAddPrice: 3000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '오트밀',
            level: 1,
            options: [{ id: 608389787, name: '사이즈', value: 'one size', stock: 484, addPrice: 3000, level: 2, options: [] }],
            minAddPrice: 3000,
            maxAddPrice: 3000,
            soldOut: false,
          },
        ],
        minAddPrice: 3000,
        maxAddPrice: 3000,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '000_상품명',
        value: '067_웰메이드 일자 슬리브리스',
        level: 0,
        images: [],
        options: [
          {
            name: '색상',
            value: '블랙',
            level: 1,
            options: [{ id: 608389788, name: '사이즈', value: 'one size', stock: 453, addPrice: -3000, level: 2, options: [] }],
            minAddPrice: -3000,
            maxAddPrice: -3000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '스카이블루',
            level: 1,
            options: [{ id: 608389789, name: '사이즈', value: 'one size', stock: 484, addPrice: -3000, level: 2, options: [] }],
            minAddPrice: -3000,
            maxAddPrice: -3000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '아이보리',
            level: 1,
            options: [{ id: 608389790, name: '사이즈', value: 'one size', stock: 461, addPrice: -3000, level: 2, options: [] }],
            minAddPrice: -3000,
            maxAddPrice: -3000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '핑크',
            level: 1,
            options: [{ id: 608389791, name: '사이즈', value: 'one size', stock: 495, addPrice: -3000, level: 2, options: [] }],
            minAddPrice: -3000,
            maxAddPrice: -3000,
            soldOut: false,
          },
        ],
        minAddPrice: -3000,
        maxAddPrice: -3000,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '000_상품명',
        value: '068_러빙 핀턱 나시원피스',
        level: 0,
        images: [],
        options: [
          {
            name: '색상',
            value: '화이트',
            level: 1,
            options: [{ id: 608389792, name: '사이즈', value: 'one size', stock: 491, addPrice: 14000, level: 2, options: [] }],
            minAddPrice: 14000,
            maxAddPrice: 14000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '베이지',
            level: 1,
            options: [{ id: 608389793, name: '사이즈', value: 'one size', stock: 496, addPrice: 14000, level: 2, options: [] }],
            minAddPrice: 14000,
            maxAddPrice: 14000,
            soldOut: false,
          },
        ],
        minAddPrice: 14000,
        maxAddPrice: 14000,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '000_상품명',
        value: '069_모먼트 데님남방',
        level: 0,
        images: [],
        options: [
          {
            name: '색상',
            value: '중청',
            level: 1,
            options: [{ id: 608389794, name: '사이즈', value: 'one size', stock: 476, addPrice: 10000, level: 2, options: [] }],
            minAddPrice: 10000,
            maxAddPrice: 10000,
            soldOut: false,
          },
        ],
        minAddPrice: 10000,
        maxAddPrice: 10000,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '000_상품명',
        value: '070_매트 아노락+조거팬츠SET',
        level: 0,
        images: [],
        options: [
          {
            name: '색상',
            value: '블랙',
            level: 1,
            options: [{ id: 608389795, name: '사이즈', value: 'one size', stock: 471, addPrice: 5000, level: 2, options: [] }],
            minAddPrice: 5000,
            maxAddPrice: 5000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '차콜',
            level: 1,
            options: [{ id: 608389796, name: '사이즈', value: 'one size', stock: 487, addPrice: 5000, level: 2, options: [] }],
            minAddPrice: 5000,
            maxAddPrice: 5000,
            soldOut: false,
          },
        ],
        minAddPrice: 5000,
        maxAddPrice: 5000,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '000_상품명',
        value: '071_[코코메이드]엔느 노카라 트위드자켓',
        level: 0,
        images: [],
        options: [
          {
            name: '색상',
            value: '블랙',
            level: 1,
            options: [{ id: 608389797, name: '사이즈', value: 'one size', stock: 493, addPrice: 26000, level: 2, options: [] }],
            minAddPrice: 26000,
            maxAddPrice: 26000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '아이보리',
            level: 1,
            options: [{ id: 608389798, name: '사이즈', value: 'one size', stock: 495, addPrice: 26000, level: 2, options: [] }],
            minAddPrice: 26000,
            maxAddPrice: 26000,
            soldOut: false,
          },
        ],
        minAddPrice: 26000,
        maxAddPrice: 26000,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '000_상품명',
        value: '072_투버튼 하이 부츠컷 팬츠(길이선택)',
        level: 0,
        images: [],
        options: [
          {
            name: '색상',
            value: '연청(숏)',
            level: 1,
            options: [
              { id: 608389799, name: '사이즈', value: 'S', stock: 499, addPrice: 14000, level: 2, options: [] },
              { id: 608389800, name: '사이즈', value: 'M', stock: 498, addPrice: 14000, level: 2, options: [] },
              { id: 608389801, name: '사이즈', value: 'L', stock: 500, addPrice: 14000, level: 2, options: [] },
              { id: 608389802, name: '사이즈', value: 'XL', stock: 499, addPrice: 14000, level: 2, options: [] },
            ],
            minAddPrice: 14000,
            maxAddPrice: 14000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '연청(미들)',
            level: 1,
            options: [
              { id: 608389803, name: '사이즈', value: 'S', stock: 496, addPrice: 14000, level: 2, options: [] },
              { id: 608389804, name: '사이즈', value: 'M', stock: 496, addPrice: 14000, level: 2, options: [] },
              { id: 608389805, name: '사이즈', value: 'L', stock: 498, addPrice: 14000, level: 2, options: [] },
              { id: 608389806, name: '사이즈', value: 'XL', stock: 499, addPrice: 14000, level: 2, options: [] },
            ],
            minAddPrice: 14000,
            maxAddPrice: 14000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '연청(롱)',
            level: 1,
            options: [
              { id: 608389807, name: '사이즈', value: 'S', stock: 500, addPrice: 14000, level: 2, options: [] },
              { id: 608389808, name: '사이즈', value: 'M', stock: 499, addPrice: 14000, level: 2, options: [] },
              { id: 608389809, name: '사이즈', value: 'L', stock: 500, addPrice: 14000, level: 2, options: [] },
              { id: 608389810, name: '사이즈', value: 'XL', stock: 500, addPrice: 14000, level: 2, options: [] },
            ],
            minAddPrice: 14000,
            maxAddPrice: 14000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '진청(숏)',
            level: 1,
            options: [
              { id: 608389811, name: '사이즈', value: 'S', stock: 500, addPrice: 14000, level: 2, options: [] },
              { id: 608389812, name: '사이즈', value: 'M', stock: 498, addPrice: 14000, level: 2, options: [] },
              { id: 608389813, name: '사이즈', value: 'L', stock: 500, addPrice: 14000, level: 2, options: [] },
              { id: 608389814, name: '사이즈', value: 'XL', stock: 500, addPrice: 14000, level: 2, options: [] },
            ],
            minAddPrice: 14000,
            maxAddPrice: 14000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '진청(미들)',
            level: 1,
            options: [
              { id: 608389815, name: '사이즈', value: 'S', stock: 499, addPrice: 14000, level: 2, options: [] },
              { id: 608389816, name: '사이즈', value: 'M', stock: 500, addPrice: 14000, level: 2, options: [] },
              { id: 608389817, name: '사이즈', value: 'L', stock: 500, addPrice: 14000, level: 2, options: [] },
              { id: 608389818, name: '사이즈', value: 'XL', stock: 500, addPrice: 14000, level: 2, options: [] },
            ],
            minAddPrice: 14000,
            maxAddPrice: 14000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '진청(롱)',
            level: 1,
            options: [
              { id: 608389819, name: '사이즈', value: 'S', stock: 499, addPrice: 14000, level: 2, options: [] },
              { id: 608389820, name: '사이즈', value: 'M', stock: 499, addPrice: 14000, level: 2, options: [] },
              { id: 608389821, name: '사이즈', value: 'L', stock: 499, addPrice: 14000, level: 2, options: [] },
              { id: 608389822, name: '사이즈', value: 'XL', stock: 500, addPrice: 14000, level: 2, options: [] },
            ],
            minAddPrice: 14000,
            maxAddPrice: 14000,
            soldOut: false,
          },
        ],
        minAddPrice: 14000,
        maxAddPrice: 14000,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '000_상품명',
        value: '073_비바 여리핏 골지가디건',
        level: 0,
        images: [],
        options: [
          {
            name: '색상',
            value: '화이트',
            level: 1,
            options: [{ id: 608389823, name: '사이즈', value: 'one size', stock: 498, addPrice: 7000, level: 2, options: [] }],
            minAddPrice: 7000,
            maxAddPrice: 7000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '비바마젠타',
            level: 1,
            options: [{ id: 608389824, name: '사이즈', value: 'one size', stock: 491, addPrice: 7000, level: 2, options: [] }],
            minAddPrice: 7000,
            maxAddPrice: 7000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '그린',
            level: 1,
            options: [{ id: 608389825, name: '사이즈', value: 'one size', stock: 496, addPrice: 7000, level: 2, options: [] }],
            minAddPrice: 7000,
            maxAddPrice: 7000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '그레이',
            level: 1,
            options: [{ id: 608389826, name: '사이즈', value: 'one size', stock: 497, addPrice: 7000, level: 2, options: [] }],
            minAddPrice: 7000,
            maxAddPrice: 7000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '블랙',
            level: 1,
            options: [{ id: 608389827, name: '사이즈', value: 'one size', stock: 491, addPrice: 7000, level: 2, options: [] }],
            minAddPrice: 7000,
            maxAddPrice: 7000,
            soldOut: false,
          },
        ],
        minAddPrice: 7000,
        maxAddPrice: 7000,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '000_상품명',
        value: '074_로지 하트버튼 반팔가디건',
        level: 0,
        images: [],
        options: [
          {
            name: '색상',
            value: '아이보리',
            level: 1,
            options: [{ id: 608389828, name: '사이즈', value: 'one size', stock: 494, addPrice: 4000, level: 2, options: [] }],
            minAddPrice: 4000,
            maxAddPrice: 4000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '민트',
            level: 1,
            options: [{ id: 608389829, name: '사이즈', value: 'one size', stock: 492, addPrice: 4000, level: 2, options: [] }],
            minAddPrice: 4000,
            maxAddPrice: 4000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '스카이블루',
            level: 1,
            options: [{ id: 608389830, name: '사이즈', value: 'one size', stock: 495, addPrice: 4000, level: 2, options: [] }],
            minAddPrice: 4000,
            maxAddPrice: 4000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '핑크',
            level: 1,
            options: [{ id: 608389831, name: '사이즈', value: 'one size', stock: 484, addPrice: 4000, level: 2, options: [] }],
            minAddPrice: 4000,
            maxAddPrice: 4000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '퍼플',
            level: 1,
            options: [{ id: 608389832, name: '사이즈', value: 'one size', stock: 484, addPrice: 4000, level: 2, options: [] }],
            minAddPrice: 4000,
            maxAddPrice: 4000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '카키',
            level: 1,
            options: [{ id: 608389833, name: '사이즈', value: 'one size', stock: 491, addPrice: 4000, level: 2, options: [] }],
            minAddPrice: 4000,
            maxAddPrice: 4000,
            soldOut: false,
          },
        ],
        minAddPrice: 4000,
        maxAddPrice: 4000,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '000_상품명',
        value: '075_뉴베이직 일자핏 팬츠(길이선택)',
        level: 0,
        images: [],
        options: [
          {
            name: '색상',
            value: '블랙(숏)',
            level: 1,
            options: [
              { id: 608389834, name: '사이즈', value: 'S', stock: 499, addPrice: 10000, level: 2, options: [] },
              { id: 608389835, name: '사이즈', value: 'M', stock: 493, addPrice: 10000, level: 2, options: [] },
              { id: 608389836, name: '사이즈', value: 'L', stock: 497, addPrice: 10000, level: 2, options: [] },
              { id: 608389837, name: '사이즈', value: 'XL', stock: 500, addPrice: 10000, level: 2, options: [] },
              { id: 608389838, name: '사이즈', value: '2XL', stock: 498, addPrice: 10000, level: 2, options: [] },
            ],
            minAddPrice: 10000,
            maxAddPrice: 10000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '블랙(미들)',
            level: 1,
            options: [
              { id: 608389839, name: '사이즈', value: 'S', stock: 498, addPrice: 10000, level: 2, options: [] },
              { id: 608389840, name: '사이즈', value: 'M', stock: 497, addPrice: 10000, level: 2, options: [] },
              { id: 608389841, name: '사이즈', value: 'L', stock: 498, addPrice: 10000, level: 2, options: [] },
              { id: 608389842, name: '사이즈', value: 'XL', stock: 500, addPrice: 10000, level: 2, options: [] },
              { id: 608389843, name: '사이즈', value: '2XL', stock: 496, addPrice: 10000, level: 2, options: [] },
            ],
            minAddPrice: 10000,
            maxAddPrice: 10000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '블랙(롱)',
            level: 1,
            options: [
              { id: 608389844, name: '사이즈', value: 'S', stock: 499, addPrice: 10000, level: 2, options: [] },
              { id: 608389845, name: '사이즈', value: 'M', stock: 500, addPrice: 10000, level: 2, options: [] },
              { id: 608389846, name: '사이즈', value: 'L', stock: 499, addPrice: 10000, level: 2, options: [] },
              { id: 608389847, name: '사이즈', value: 'XL', stock: 499, addPrice: 10000, level: 2, options: [] },
              { id: 608389848, name: '사이즈', value: '2XL', stock: 500, addPrice: 10000, level: 2, options: [] },
            ],
            minAddPrice: 10000,
            maxAddPrice: 10000,
            soldOut: false,
          },
        ],
        minAddPrice: 10000,
        maxAddPrice: 10000,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '000_상품명',
        value: '076_뮤즈 브이넥 반팔 자켓',
        level: 0,
        images: [],
        options: [
          {
            name: '색상',
            value: '베이지',
            level: 1,
            options: [{ id: 608389849, name: '사이즈', value: 'one size', stock: 500, addPrice: 16000, level: 2, options: [] }],
            minAddPrice: 16000,
            maxAddPrice: 16000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '블랙',
            level: 1,
            options: [{ id: 608389850, name: '사이즈', value: 'one size', stock: 499, addPrice: 16000, level: 2, options: [] }],
            minAddPrice: 16000,
            maxAddPrice: 16000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '코코아',
            level: 1,
            options: [{ id: 608389851, name: '사이즈', value: 'one size', stock: 497, addPrice: 16000, level: 2, options: [] }],
            minAddPrice: 16000,
            maxAddPrice: 16000,
            soldOut: false,
          },
        ],
        minAddPrice: 16000,
        maxAddPrice: 16000,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '000_상품명',
        value: '077_린넨 핀턱 플레어 롱스커트',
        level: 0,
        images: [],
        options: [
          {
            name: '색상',
            value: '네이비',
            level: 1,
            options: [{ id: 608389852, name: '사이즈', value: 'one size', stock: 498, addPrice: 8000, level: 2, options: [] }],
            minAddPrice: 8000,
            maxAddPrice: 8000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '베이지',
            level: 1,
            options: [{ id: 608389853, name: '사이즈', value: 'one size', stock: 490, addPrice: 8000, level: 2, options: [] }],
            minAddPrice: 8000,
            maxAddPrice: 8000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '아이보리',
            level: 1,
            options: [{ id: 608389854, name: '사이즈', value: 'one size', stock: 479, addPrice: 8000, level: 2, options: [] }],
            minAddPrice: 8000,
            maxAddPrice: 8000,
            soldOut: false,
          },
        ],
        minAddPrice: 8000,
        maxAddPrice: 8000,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '000_상품명',
        value: '078_커넬 오픈카라 반팔 블라우스',
        level: 0,
        images: [],
        options: [
          {
            name: '색상',
            value: '아이보리',
            level: 1,
            options: [{ id: 608389855, name: '사이즈', value: 'one size', stock: 482, addPrice: 7000, level: 2, options: [] }],
            minAddPrice: 7000,
            maxAddPrice: 7000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '블루',
            level: 1,
            options: [{ id: 608389856, name: '사이즈', value: 'one size', stock: 0, addPrice: 7000, level: 2, options: [] }],
            soldOut: true,
          },
        ],
        minAddPrice: 7000,
        maxAddPrice: 7000,
        hasSoldOut: true,
        soldOut: false,
      },
      {
        name: '000_상품명',
        value: '079_앨던 라이트 데님남방',
        level: 0,
        images: [],
        options: [
          {
            name: '색상',
            value: '크림',
            level: 1,
            options: [{ id: 608389857, name: '사이즈', value: 'one size', stock: 0, addPrice: 10000, level: 2, options: [] }],
            soldOut: true,
          },
          {
            name: '색상',
            value: '민트',
            level: 1,
            options: [{ id: 608389858, name: '사이즈', value: 'one size', stock: 0, addPrice: 10000, level: 2, options: [] }],
            soldOut: true,
          },
        ],
        minAddPrice: 0,
        maxAddPrice: 0,
        hasSoldOut: true,
        soldOut: true,
      },
      {
        name: '000_상품명',
        value: '080_모노 와이드 일자 팬츠',
        level: 0,
        images: [],
        options: [
          {
            name: '색상',
            value: '화이트',
            level: 1,
            options: [
              { id: 608389859, name: '사이즈', value: 'S', stock: 491, addPrice: 5000, level: 2, options: [] },
              { id: 608389860, name: '사이즈', value: 'M', stock: 498, addPrice: 5000, level: 2, options: [] },
              { id: 608389861, name: '사이즈', value: 'L', stock: 496, addPrice: 5000, level: 2, options: [] },
            ],
            minAddPrice: 5000,
            maxAddPrice: 5000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '베이지',
            level: 1,
            options: [
              { id: 608389862, name: '사이즈', value: 'S', stock: 493, addPrice: 5000, level: 2, options: [] },
              { id: 608389863, name: '사이즈', value: 'M', stock: 492, addPrice: 5000, level: 2, options: [] },
              { id: 608389864, name: '사이즈', value: 'L', stock: 496, addPrice: 5000, level: 2, options: [] },
            ],
            minAddPrice: 5000,
            maxAddPrice: 5000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '블랙',
            level: 1,
            options: [
              { id: 608389865, name: '사이즈', value: 'S', stock: 495, addPrice: 5000, level: 2, options: [] },
              { id: 608389866, name: '사이즈', value: 'M', stock: 495, addPrice: 5000, level: 2, options: [] },
              { id: 608389867, name: '사이즈', value: 'L', stock: 499, addPrice: 5000, level: 2, options: [] },
            ],
            minAddPrice: 5000,
            maxAddPrice: 5000,
            soldOut: false,
          },
        ],
        minAddPrice: 5000,
        maxAddPrice: 5000,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '000_상품명',
        value: '081_뮤엘 나염 프릴 슬리브리스',
        level: 0,
        images: [],
        options: [
          {
            name: '색상',
            value: '블랙',
            level: 1,
            options: [{ id: 608389868, name: '사이즈', value: 'one size', stock: 482, addPrice: 4000, level: 2, options: [] }],
            minAddPrice: 4000,
            maxAddPrice: 4000,
            soldOut: false,
          },
        ],
        minAddPrice: 4000,
        maxAddPrice: 4000,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '000_상품명',
        value: '082_로즈썸 반팔 트위드 자켓',
        level: 0,
        images: [],
        options: [
          {
            name: '색상',
            value: '핑크',
            level: 1,
            options: [{ id: 608389869, name: '사이즈', value: 'one size', stock: 492, addPrice: 14000, level: 2, options: [] }],
            minAddPrice: 14000,
            maxAddPrice: 14000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '아이보리',
            level: 1,
            options: [{ id: 608389870, name: '사이즈', value: 'one size', stock: 495, addPrice: 14000, level: 2, options: [] }],
            minAddPrice: 14000,
            maxAddPrice: 14000,
            soldOut: false,
          },
        ],
        minAddPrice: 14000,
        maxAddPrice: 14000,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '000_상품명',
        value: '083_플레인 자켓&나시원피스SET',
        level: 0,
        images: [],
        options: [
          {
            name: '색상',
            value: '베이지',
            level: 1,
            options: [{ id: 608389871, name: '사이즈', value: 'one size', stock: 487, addPrice: 14000, level: 2, options: [] }],
            minAddPrice: 14000,
            maxAddPrice: 14000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '핑크',
            level: 1,
            options: [{ id: 608389872, name: '사이즈', value: 'one size', stock: 500, addPrice: 14000, level: 2, options: [] }],
            minAddPrice: 14000,
            maxAddPrice: 14000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '블랙',
            level: 1,
            options: [{ id: 608389873, name: '사이즈', value: 'one size', stock: 490, addPrice: 14000, level: 2, options: [] }],
            minAddPrice: 14000,
            maxAddPrice: 14000,
            soldOut: false,
          },
        ],
        minAddPrice: 14000,
        maxAddPrice: 14000,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '000_상품명',
        value: '084_[코코메이드]쫀쫀골지 투웨이 슬리브리스',
        level: 0,
        images: [],
        options: [
          {
            name: '색상',
            value: '화이트',
            level: 1,
            options: [{ id: 608389874, name: '사이즈', value: 'one size', stock: 465, addPrice: 0, level: 2, options: [] }],
            minAddPrice: 0,
            maxAddPrice: 0,
            soldOut: false,
          },
          {
            name: '색상',
            value: '블랙',
            level: 1,
            options: [{ id: 608389875, name: '사이즈', value: 'one size', stock: 457, addPrice: 0, level: 2, options: [] }],
            minAddPrice: 0,
            maxAddPrice: 0,
            soldOut: false,
          },
        ],
        minAddPrice: 0,
        maxAddPrice: 0,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '000_상품명',
        value: '085_워터리플라워 쉬폰 원피스',
        level: 0,
        images: [],
        options: [
          {
            name: '색상',
            value: '핑크',
            level: 1,
            options: [{ id: 608389876, name: '사이즈', value: 'one size', stock: 492, addPrice: 17000, level: 2, options: [] }],
            minAddPrice: 17000,
            maxAddPrice: 17000,
            soldOut: false,
          },
        ],
        minAddPrice: 17000,
        maxAddPrice: 17000,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '000_상품명',
        value: '086_링클프리 베이직 셔츠',
        level: 0,
        images: [],
        options: [
          {
            name: '색상',
            value: '화이트',
            level: 1,
            options: [
              { id: 608389877, name: '사이즈', value: 'FREE', stock: 494, addPrice: 5000, level: 2, options: [] },
              { id: 608389878, name: '사이즈', value: 'L', stock: 500, addPrice: 6000, level: 2, options: [] },
              { id: 608389879, name: '사이즈', value: 'XL', stock: 500, addPrice: 6000, level: 2, options: [] },
            ],
            minAddPrice: 5000,
            maxAddPrice: 6000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '연베이지',
            level: 1,
            options: [
              { id: 608389880, name: '사이즈', value: 'FREE', stock: 496, addPrice: 5000, level: 2, options: [] },
              { id: 608389881, name: '사이즈', value: 'L', stock: 498, addPrice: 6000, level: 2, options: [] },
              { id: 608389882, name: '사이즈', value: 'XL', stock: 500, addPrice: 6000, level: 2, options: [] },
            ],
            minAddPrice: 5000,
            maxAddPrice: 6000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '베이지',
            level: 1,
            options: [
              { id: 608389883, name: '사이즈', value: 'FREE', stock: 500, addPrice: 5000, level: 2, options: [] },
              { id: 608389884, name: '사이즈', value: 'L', stock: 500, addPrice: 6000, level: 2, options: [] },
              { id: 608389885, name: '사이즈', value: 'XL', stock: 500, addPrice: 6000, level: 2, options: [] },
            ],
            minAddPrice: 5000,
            maxAddPrice: 6000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '라이트핑크',
            level: 1,
            options: [
              { id: 608389886, name: '사이즈', value: 'FREE', stock: 500, addPrice: 5000, level: 2, options: [] },
              { id: 608389887, name: '사이즈', value: 'L', stock: 500, addPrice: 6000, level: 2, options: [] },
              { id: 608389888, name: '사이즈', value: 'XL', stock: 500, addPrice: 6000, level: 2, options: [] },
            ],
            minAddPrice: 5000,
            maxAddPrice: 6000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '피치',
            level: 1,
            options: [
              { id: 608389889, name: '사이즈', value: 'FREE', stock: 500, addPrice: 5000, level: 2, options: [] },
              { id: 608389890, name: '사이즈', value: 'L', stock: 500, addPrice: 6000, level: 2, options: [] },
              { id: 608389891, name: '사이즈', value: 'XL', stock: 499, addPrice: 6000, level: 2, options: [] },
            ],
            minAddPrice: 5000,
            maxAddPrice: 6000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '핑크',
            level: 1,
            options: [
              { id: 608389892, name: '사이즈', value: 'FREE', stock: 500, addPrice: 5000, level: 2, options: [] },
              { id: 608389893, name: '사이즈', value: 'L', stock: 500, addPrice: 6000, level: 2, options: [] },
              { id: 608389894, name: '사이즈', value: 'XL', stock: 500, addPrice: 6000, level: 2, options: [] },
            ],
            minAddPrice: 5000,
            maxAddPrice: 6000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '브라운',
            level: 1,
            options: [
              { id: 608389895, name: '사이즈', value: 'FREE', stock: 499, addPrice: 5000, level: 2, options: [] },
              { id: 608389896, name: '사이즈', value: 'L', stock: 500, addPrice: 6000, level: 2, options: [] },
              { id: 608389897, name: '사이즈', value: 'XL', stock: 500, addPrice: 6000, level: 2, options: [] },
            ],
            minAddPrice: 5000,
            maxAddPrice: 6000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '라이트스카이',
            level: 1,
            options: [
              { id: 608389898, name: '사이즈', value: 'FREE', stock: 497, addPrice: 5000, level: 2, options: [] },
              { id: 608389899, name: '사이즈', value: 'L', stock: 498, addPrice: 6000, level: 2, options: [] },
              { id: 608389900, name: '사이즈', value: 'XL', stock: 499, addPrice: 6000, level: 2, options: [] },
            ],
            minAddPrice: 5000,
            maxAddPrice: 6000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '인디블루',
            level: 1,
            options: [
              { id: 608389901, name: '사이즈', value: 'FREE', stock: 499, addPrice: 5000, level: 2, options: [] },
              { id: 608389902, name: '사이즈', value: 'L', stock: 499, addPrice: 6000, level: 2, options: [] },
              { id: 608389903, name: '사이즈', value: 'XL', stock: 500, addPrice: 6000, level: 2, options: [] },
            ],
            minAddPrice: 5000,
            maxAddPrice: 6000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '민트',
            level: 1,
            options: [
              { id: 608389904, name: '사이즈', value: 'FREE', stock: 499, addPrice: 5000, level: 2, options: [] },
              { id: 608389905, name: '사이즈', value: 'L', stock: 500, addPrice: 6000, level: 2, options: [] },
              { id: 608389906, name: '사이즈', value: 'XL', stock: 500, addPrice: 6000, level: 2, options: [] },
            ],
            minAddPrice: 5000,
            maxAddPrice: 6000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '카키',
            level: 1,
            options: [
              { id: 608389907, name: '사이즈', value: 'FREE', stock: 499, addPrice: 5000, level: 2, options: [] },
              { id: 608389908, name: '사이즈', value: 'L', stock: 500, addPrice: 6000, level: 2, options: [] },
              { id: 608389909, name: '사이즈', value: 'XL', stock: 499, addPrice: 6000, level: 2, options: [] },
            ],
            minAddPrice: 5000,
            maxAddPrice: 6000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '네이비',
            level: 1,
            options: [
              { id: 608389910, name: '사이즈', value: 'FREE', stock: 500, addPrice: 5000, level: 2, options: [] },
              { id: 608389911, name: '사이즈', value: 'L', stock: 500, addPrice: 6000, level: 2, options: [] },
              { id: 608389912, name: '사이즈', value: 'XL', stock: 500, addPrice: 6000, level: 2, options: [] },
            ],
            minAddPrice: 5000,
            maxAddPrice: 6000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '와인',
            level: 1,
            options: [
              { id: 608389913, name: '사이즈', value: 'FREE', stock: 500, addPrice: 5000, level: 2, options: [] },
              { id: 608389914, name: '사이즈', value: 'L', stock: 500, addPrice: 6000, level: 2, options: [] },
              { id: 608389915, name: '사이즈', value: 'XL', stock: 500, addPrice: 6000, level: 2, options: [] },
            ],
            minAddPrice: 5000,
            maxAddPrice: 6000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '블랙',
            level: 1,
            options: [
              { id: 608389916, name: '사이즈', value: 'FREE', stock: 496, addPrice: 5000, level: 2, options: [] },
              { id: 608389917, name: '사이즈', value: 'L', stock: 497, addPrice: 6000, level: 2, options: [] },
              { id: 608389918, name: '사이즈', value: 'XL', stock: 499, addPrice: 6000, level: 2, options: [] },
            ],
            minAddPrice: 5000,
            maxAddPrice: 6000,
            soldOut: false,
          },
        ],
        minAddPrice: 5000,
        maxAddPrice: 6000,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '000_상품명',
        value: '087_링클프리 히든버튼 긴팔셔츠',
        level: 0,
        images: [],
        options: [
          {
            name: '색상',
            value: '다크블루',
            level: 1,
            options: [
              { id: 608389919, name: '사이즈', value: 'FREE', stock: 500, addPrice: 5000, level: 2, options: [] },
              { id: 608389920, name: '사이즈', value: 'L', stock: 499, addPrice: 6000, level: 2, options: [] },
            ],
            minAddPrice: 5000,
            maxAddPrice: 6000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '화이트',
            level: 1,
            options: [
              { id: 608389921, name: '사이즈', value: 'FREE', stock: 496, addPrice: 5000, level: 2, options: [] },
              { id: 608389922, name: '사이즈', value: 'L', stock: 499, addPrice: 6000, level: 2, options: [] },
            ],
            minAddPrice: 5000,
            maxAddPrice: 6000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '라이트민트',
            level: 1,
            options: [
              { id: 608389923, name: '사이즈', value: 'FREE', stock: 498, addPrice: 5000, level: 2, options: [] },
              { id: 608389924, name: '사이즈', value: 'L', stock: 500, addPrice: 6000, level: 2, options: [] },
            ],
            minAddPrice: 5000,
            maxAddPrice: 6000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '스카이블루',
            level: 1,
            options: [
              { id: 608389925, name: '사이즈', value: 'FREE', stock: 498, addPrice: 5000, level: 2, options: [] },
              { id: 608389926, name: '사이즈', value: 'L', stock: 500, addPrice: 6000, level: 2, options: [] },
            ],
            minAddPrice: 5000,
            maxAddPrice: 6000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '베이지',
            level: 1,
            options: [
              { id: 608389927, name: '사이즈', value: 'FREE', stock: 499, addPrice: 5000, level: 2, options: [] },
              { id: 608389928, name: '사이즈', value: 'L', stock: 499, addPrice: 6000, level: 2, options: [] },
            ],
            minAddPrice: 5000,
            maxAddPrice: 6000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '브릭',
            level: 1,
            options: [
              { id: 608389929, name: '사이즈', value: 'FREE', stock: 500, addPrice: 5000, level: 2, options: [] },
              { id: 608389930, name: '사이즈', value: 'L', stock: 500, addPrice: 6000, level: 2, options: [] },
            ],
            minAddPrice: 5000,
            maxAddPrice: 6000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '블랙',
            level: 1,
            options: [
              { id: 608389931, name: '사이즈', value: 'FREE', stock: 497, addPrice: 5000, level: 2, options: [] },
              { id: 608389932, name: '사이즈', value: 'L', stock: 499, addPrice: 6000, level: 2, options: [] },
            ],
            minAddPrice: 5000,
            maxAddPrice: 6000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '카키',
            level: 1,
            options: [
              { id: 608389933, name: '사이즈', value: 'FREE', stock: 492, addPrice: 5000, level: 2, options: [] },
              { id: 608389934, name: '사이즈', value: 'L', stock: 497, addPrice: 6000, level: 2, options: [] },
            ],
            minAddPrice: 5000,
            maxAddPrice: 6000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '연베이지',
            level: 1,
            options: [
              { id: 608389935, name: '사이즈', value: 'FREE', stock: 498, addPrice: 5000, level: 2, options: [] },
              { id: 608389936, name: '사이즈', value: 'L', stock: 497, addPrice: 6000, level: 2, options: [] },
            ],
            minAddPrice: 5000,
            maxAddPrice: 6000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '인디핑크',
            level: 1,
            options: [
              { id: 608389937, name: '사이즈', value: 'FREE', stock: 499, addPrice: 5000, level: 2, options: [] },
              { id: 608389938, name: '사이즈', value: 'L', stock: 499, addPrice: 6000, level: 2, options: [] },
            ],
            minAddPrice: 5000,
            maxAddPrice: 6000,
            soldOut: false,
          },
        ],
        minAddPrice: 5000,
        maxAddPrice: 6000,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '000_상품명',
        value: '088_어티 핀턱 이지핏 팬츠(뒷밴딩)',
        level: 0,
        images: [],
        options: [
          {
            name: '색상',
            value: '블랙',
            level: 1,
            options: [{ id: 608389939, name: '사이즈', value: 'one size', stock: 498, addPrice: 8000, level: 2, options: [] }],
            minAddPrice: 8000,
            maxAddPrice: 8000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '아이보리',
            level: 1,
            options: [{ id: 608389940, name: '사이즈', value: 'one size', stock: 496, addPrice: 8000, level: 2, options: [] }],
            minAddPrice: 8000,
            maxAddPrice: 8000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '핑크',
            level: 1,
            options: [{ id: 608389941, name: '사이즈', value: 'one size', stock: 484, addPrice: 8000, level: 2, options: [] }],
            minAddPrice: 8000,
            maxAddPrice: 8000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '베이지',
            level: 1,
            options: [{ id: 608389942, name: '사이즈', value: 'one size', stock: 495, addPrice: 8000, level: 2, options: [] }],
            minAddPrice: 8000,
            maxAddPrice: 8000,
            soldOut: false,
          },
        ],
        minAddPrice: 8000,
        maxAddPrice: 8000,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '000_상품명',
        value: '089_모노톤 코튼 하프숏츠',
        level: 0,
        images: [],
        options: [
          {
            name: '색상',
            value: '블랙',
            level: 1,
            options: [
              { id: 608389943, name: '사이즈', value: 'S', stock: 497, addPrice: 13000, level: 2, options: [] },
              { id: 608389944, name: '사이즈', value: 'M', stock: 498, addPrice: 13000, level: 2, options: [] },
              { id: 608389945, name: '사이즈', value: 'L', stock: 497, addPrice: 13000, level: 2, options: [] },
              { id: 608389946, name: '사이즈', value: 'XL', stock: 499, addPrice: 13000, level: 2, options: [] },
            ],
            minAddPrice: 13000,
            maxAddPrice: 13000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '베이지',
            level: 1,
            options: [
              { id: 608389947, name: '사이즈', value: 'S', stock: 494, addPrice: 13000, level: 2, options: [] },
              { id: 608389948, name: '사이즈', value: 'M', stock: 493, addPrice: 13000, level: 2, options: [] },
              { id: 608389949, name: '사이즈', value: 'L', stock: 498, addPrice: 13000, level: 2, options: [] },
              { id: 608389950, name: '사이즈', value: 'XL', stock: 500, addPrice: 13000, level: 2, options: [] },
            ],
            minAddPrice: 13000,
            maxAddPrice: 13000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '화이트',
            level: 1,
            options: [
              { id: 608389951, name: '사이즈', value: 'S', stock: 499, addPrice: 13000, level: 2, options: [] },
              { id: 608389952, name: '사이즈', value: 'M', stock: 498, addPrice: 13000, level: 2, options: [] },
              { id: 608389953, name: '사이즈', value: 'L', stock: 498, addPrice: 13000, level: 2, options: [] },
              { id: 608389954, name: '사이즈', value: 'XL', stock: 499, addPrice: 13000, level: 2, options: [] },
            ],
            minAddPrice: 13000,
            maxAddPrice: 13000,
            soldOut: false,
          },
        ],
        minAddPrice: 13000,
        maxAddPrice: 13000,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '000_상품명',
        value: '090_골드버튼 퍼프 줄지 블라우스',
        level: 0,
        images: [],
        options: [
          {
            name: '색상',
            value: '베이지',
            level: 1,
            options: [{ id: 608389955, name: '사이즈', value: 'one size', stock: 486, addPrice: 5000, level: 2, options: [] }],
            minAddPrice: 5000,
            maxAddPrice: 5000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '블루',
            level: 1,
            options: [{ id: 608389956, name: '사이즈', value: 'one size', stock: 487, addPrice: 5000, level: 2, options: [] }],
            minAddPrice: 5000,
            maxAddPrice: 5000,
            soldOut: false,
          },
        ],
        minAddPrice: 5000,
        maxAddPrice: 5000,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '000_상품명',
        value: '091_죠셉 바인딩 포인트 가디건',
        level: 0,
        images: [],
        options: [
          {
            name: '색상',
            value: '아이보리',
            level: 1,
            options: [{ id: 608389957, name: '사이즈', value: 'one size', stock: 472, addPrice: 8000, level: 2, options: [] }],
            minAddPrice: 8000,
            maxAddPrice: 8000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '블랙',
            level: 1,
            options: [{ id: 608389958, name: '사이즈', value: 'one size', stock: 482, addPrice: 8000, level: 2, options: [] }],
            minAddPrice: 8000,
            maxAddPrice: 8000,
            soldOut: false,
          },
        ],
        minAddPrice: 8000,
        maxAddPrice: 8000,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '000_상품명',
        value: '092_루디 셔링 퍼프 가디건',
        level: 0,
        images: [],
        options: [
          {
            name: '색상',
            value: '아이보리',
            level: 1,
            options: [{ id: 608389959, name: '사이즈', value: 'one size', stock: 496, addPrice: 8000, level: 2, options: [] }],
            minAddPrice: 8000,
            maxAddPrice: 8000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '옐로우',
            level: 1,
            options: [{ id: 608389960, name: '사이즈', value: 'one size', stock: 495, addPrice: 8000, level: 2, options: [] }],
            minAddPrice: 8000,
            maxAddPrice: 8000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '딥핑크',
            level: 1,
            options: [{ id: 608389961, name: '사이즈', value: 'one size', stock: 494, addPrice: 8000, level: 2, options: [] }],
            minAddPrice: 8000,
            maxAddPrice: 8000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '퍼플',
            level: 1,
            options: [{ id: 608389962, name: '사이즈', value: 'one size', stock: 498, addPrice: 8000, level: 2, options: [] }],
            minAddPrice: 8000,
            maxAddPrice: 8000,
            soldOut: false,
          },
        ],
        minAddPrice: 8000,
        maxAddPrice: 8000,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '000_상품명',
        value: '093_리얼밤부 스퀘어 반팔니트',
        level: 0,
        images: [],
        options: [
          {
            name: '색상',
            value: '블랙',
            level: 1,
            options: [{ id: 608389963, name: '사이즈', value: 'one size', stock: 493, addPrice: 7000, level: 2, options: [] }],
            minAddPrice: 7000,
            maxAddPrice: 7000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '핑크',
            level: 1,
            options: [{ id: 608389964, name: '사이즈', value: 'one size', stock: 496, addPrice: 7000, level: 2, options: [] }],
            minAddPrice: 7000,
            maxAddPrice: 7000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '오트밀',
            level: 1,
            options: [{ id: 608389965, name: '사이즈', value: 'one size', stock: 480, addPrice: 7000, level: 2, options: [] }],
            minAddPrice: 7000,
            maxAddPrice: 7000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '블루',
            level: 1,
            options: [{ id: 608389966, name: '사이즈', value: 'one size', stock: 492, addPrice: 7000, level: 2, options: [] }],
            minAddPrice: 7000,
            maxAddPrice: 7000,
            soldOut: false,
          },
        ],
        minAddPrice: 7000,
        maxAddPrice: 7000,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '000_상품명',
        value: '094_네즈 반팔 트위드 자켓',
        level: 0,
        images: [],
        options: [
          {
            name: '색상',
            value: '아이보리',
            level: 1,
            options: [{ id: 608389967, name: '사이즈', value: 'one size', stock: 486, addPrice: 12000, level: 2, options: [] }],
            minAddPrice: 12000,
            maxAddPrice: 12000,
            soldOut: false,
          },
        ],
        minAddPrice: 12000,
        maxAddPrice: 12000,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '000_상품명',
        value: '095_랜디 벌룬 블라우스',
        level: 0,
        images: [],
        options: [
          {
            name: '색상',
            value: '핑크',
            level: 1,
            options: [{ id: 608389968, name: '사이즈', value: 'one size', stock: 488, addPrice: 3000, level: 2, options: [] }],
            minAddPrice: 3000,
            maxAddPrice: 3000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '네이비',
            level: 1,
            options: [{ id: 608389969, name: '사이즈', value: 'one size', stock: 469, addPrice: 3000, level: 2, options: [] }],
            minAddPrice: 3000,
            maxAddPrice: 3000,
            soldOut: false,
          },
        ],
        minAddPrice: 3000,
        maxAddPrice: 3000,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '000_상품명',
        value: '096_젤라 꼬임 퍼프 블라우스',
        level: 0,
        images: [],
        options: [
          {
            name: '색상',
            value: '화이트',
            level: 1,
            options: [{ id: 608389970, name: '사이즈', value: 'one size', stock: 493, addPrice: 10000, level: 2, options: [] }],
            minAddPrice: 10000,
            maxAddPrice: 10000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '핑크',
            level: 1,
            options: [{ id: 608389971, name: '사이즈', value: 'one size', stock: 496, addPrice: 10000, level: 2, options: [] }],
            minAddPrice: 10000,
            maxAddPrice: 10000,
            soldOut: false,
          },
        ],
        minAddPrice: 10000,
        maxAddPrice: 10000,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '000_상품명',
        value: '097_제이드 린넨 반팔자켓',
        level: 0,
        images: [],
        options: [
          {
            name: '색상',
            value: '아이보리',
            level: 1,
            options: [{ id: 608389972, name: '사이즈', value: 'one size', stock: 499, addPrice: 20000, level: 2, options: [] }],
            minAddPrice: 20000,
            maxAddPrice: 20000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '그린',
            level: 1,
            options: [{ id: 608389973, name: '사이즈', value: 'one size', stock: 499, addPrice: 20000, level: 2, options: [] }],
            minAddPrice: 20000,
            maxAddPrice: 20000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '오트밀',
            level: 1,
            options: [{ id: 608389974, name: '사이즈', value: 'one size', stock: 479, addPrice: 20000, level: 2, options: [] }],
            minAddPrice: 20000,
            maxAddPrice: 20000,
            soldOut: false,
          },
        ],
        minAddPrice: 20000,
        maxAddPrice: 20000,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '000_상품명',
        value: '098_피드 반팔 트위드자켓',
        level: 0,
        images: [],
        options: [
          {
            name: '색상',
            value: '크림',
            level: 1,
            options: [{ id: 608389975, name: '사이즈', value: 'one size', stock: 489, addPrice: 17000, level: 2, options: [] }],
            minAddPrice: 17000,
            maxAddPrice: 17000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '블랙',
            level: 1,
            options: [{ id: 608389976, name: '사이즈', value: 'one size', stock: 496, addPrice: 17000, level: 2, options: [] }],
            minAddPrice: 17000,
            maxAddPrice: 17000,
            soldOut: false,
          },
        ],
        minAddPrice: 17000,
        maxAddPrice: 17000,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '000_상품명',
        value: '099_그리너리 크롭 자켓',
        level: 0,
        images: [],
        options: [
          {
            name: '색상',
            value: '아이보리',
            level: 1,
            options: [{ id: 608389977, name: '사이즈', value: 'one size', stock: 497, addPrice: 17000, level: 2, options: [] }],
            minAddPrice: 17000,
            maxAddPrice: 17000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '옐로우',
            level: 1,
            options: [{ id: 608389978, name: '사이즈', value: 'one size', stock: 499, addPrice: 17000, level: 2, options: [] }],
            minAddPrice: 17000,
            maxAddPrice: 17000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '그린',
            level: 1,
            options: [{ id: 608389979, name: '사이즈', value: 'one size', stock: 498, addPrice: 17000, level: 2, options: [] }],
            minAddPrice: 17000,
            maxAddPrice: 17000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '핑크',
            level: 1,
            options: [{ id: 608389980, name: '사이즈', value: 'one size', stock: 496, addPrice: 17000, level: 2, options: [] }],
            minAddPrice: 17000,
            maxAddPrice: 17000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '블랙',
            level: 1,
            options: [{ id: 608389981, name: '사이즈', value: 'one size', stock: 496, addPrice: 17000, level: 2, options: [] }],
            minAddPrice: 17000,
            maxAddPrice: 17000,
            soldOut: false,
          },
        ],
        minAddPrice: 17000,
        maxAddPrice: 17000,
        hasSoldOut: false,
        soldOut: false,
      },
      {
        name: '000_상품명',
        value: '100_애나 리본 셔링 블라우스',
        level: 0,
        images: [],
        options: [
          {
            name: '색상',
            value: '아이보리',
            level: 1,
            options: [{ id: 608389982, name: '사이즈', value: 'one size', stock: 489, addPrice: 5000, level: 2, options: [] }],
            minAddPrice: 5000,
            maxAddPrice: 5000,
            soldOut: false,
          },
          {
            name: '색상',
            value: '퍼플',
            level: 1,
            options: [{ id: 608389983, name: '사이즈', value: 'one size', stock: 484, addPrice: 5000, level: 2, options: [] }],
            minAddPrice: 5000,
            maxAddPrice: 5000,
            soldOut: false,
          },
        ],
        minAddPrice: 5000,
        maxAddPrice: 5000,
        hasSoldOut: false,
        soldOut: false,
      },
    ],
    customs: [],
  },
};

const productDetail = {
  67210447: {
    name: '[허닭] 허닭추천 닭가슴살 21종 세트 외 패키지 모음',
    image: {
      imageRatio: 'SQUARE',
      images: [
        'https://st.kakaocdn.net/thumb/P750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230530154436_489ee0528b2d4817a264c0f136ebd1ea.jpg',
        'https://st.kakaocdn.net/thumb/P750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20211108162344_6efc10e93b424f45a2a8ff98d73e2aee.jpg',
      ],
      sharingImageUrl:
        'https://st.kakaocdn.net/thumb/C750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230530154436_489ee0528b2d4817a264c0f136ebd1ea.jpg&mode=watermark&wm_param1=image&wm_id=talkdeal',
    },
    status: 'ON_SALE',
    description:
      '<html>\n <head></head>\n <body>\n  <p align="center"><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230601150947_4664d9bf6b404a1f89357679d55082b5.jpg" data-origin-url="https://img.heodak.com/heodak/homepage/new/AK/detail_page_top_banner.jpg"><br> <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230601150948_7e5434c5519b4ade935e742259be43a4.jpg" data-origin-url="https://img.heodak.com/heodak/homepage/new/kakao/67210447/intro_0512.jpg"><br> <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230601150948_247098ff3bdf4f41867a52df5b444898.jpg" data-origin-url="https://img.heodak.com/heodak/homepage/new/kakao/67210447/summary21900_0531-1.jpg"></p> \n  <hr> \n  <p align="center"><span style="color:#e67e22"><strong>선택01</strong></span><br> <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230601150949_425e29c6b4b74788a16d29d793dcc49b.jpg" data-origin-url="https://img.heodak.com/heodak/homepage/new/AK/st_g.jpg"><br> <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230601150950_166d58a734ae460ca8630264e4c102bb.jpg" data-origin-url="https://img.heodak.com/heodak/homepage/new/AK/st_h.jpg"><br> <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230601150950_e6ed388b1a1a442d801fa166288fc1aa.jpg" data-origin-url="https://img.heodak.com/heodak/homepage/new/AK/cube_ltm_gg.jpg"><br> <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230601150951_0f6f243882d049789bdac6080bfb6f62.jpg" data-origin-url="https://img.heodak.com/heodak/homepage/new/AK/cube_ltm_dd.jpg"><br> <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230601150952_624e2837eb1d40dcb89ddf800cc8b132.jpg" data-origin-url="https://img.heodak.com/heodak/homepage/new/AK/cube_ltm_ch.jpg"><br> <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230601150952_3b748d26c06243f9a4aa16339fef463f.jpg" data-origin-url="https://img.heodak.com/heodak/homepage/new/AK/ipst/ipst_og.jpg"><br> <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230601150953_56a6442efec24b92bb91cf6f89353501.jpg" data-origin-url="https://img.heodak.com/heodak/homepage/new/AK/ipst/ipst_bg.jpg"><br> <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230601150954_282d13fa8f8947e195b9010329e8941f.jpg" data-origin-url="https://img.heodak.com/heodak/homepage/new/AK/ipst/ipst_gl.jpg"><br> <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230601150955_3fa242f369a54f96b36094ee2bd58ab2.jpg" data-origin-url="https://img.heodak.com/heodak/homepage/new/h/oven_galbi.jpg"><br> <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230601150955_0e98327d56f048dbb99b4baba82dd0e1.jpg" data-origin-url="https://img.heodak.com/heodak/homepage/new/h/oven_cy.jpg"><br> <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230601150956_58ae5a4635f64d56a957a0470647608c.jpg" data-origin-url="https://img.heodak.com/heodak/homepage/new/AK/h_o.jpg"><br> <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230601150957_173593567a6b4a55bf75cab1a06bd5f3.jpg" data-origin-url="https://img.heodak.com/heodak/homepage/new/AK/spc_vienna_original_new.jpg"><br> <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230601150957_1063b1516f1f4a24ae86083cd65eaee4.jpg" data-origin-url="https://img.heodak.com/heodak/homepage/new/AK/spc_vienna_red_pepper_new.jpg"><br> <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230601150958_c70cced114ca4f5cba6ee7201117019c.jpg" data-origin-url="https://img.heodak.com/heodak/homepage/new/SSG/gg_detail_02.jpg"><br> <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230601150958_edef3b84a6fe4aeea1bcc6994b563edf.jpg" data-origin-url="https://img.heodak.com/heodak/homepage/new/SSG/gg_detail_06.jpg"><br> <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230601150959_8b412ee8dec4470e882916f60e18ce31.jpg" data-origin-url="https://img.heodak.com/heodak/homepage/new/AK/oven_bar_original.jpg"><br> <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230601150959_16cc3e81272248b7aad1ec7d96d7a299.jpg" data-origin-url="https://img.heodak.com/heodak/homepage/new/AK/oven_bar_mecom.jpg"><br> <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230601151000_e65de734e2274afe8a026651dd09e4c0.jpg" data-origin-url="https://img.heodak.com/heodak/homepage/new/AK/b_ori.jpg"><br> <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230601151001_924094d357c542f49437bbe83f6dcaaa.jpg" data-origin-url="https://img.heodak.com/heodak/homepage/new/AK/b_hot.jpg"><br> <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230601151002_db5028f0f72541a18f474f26e21c09ce.jpg" data-origin-url="https://img.heodak.com/heodak/homepage/new/AK/ball_b100.jpg"><br> <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230601151003_d78e4faaac2146a5a4386d553eeab4a9.jpg" data-origin-url="https://img.heodak.com/heodak/homepage/new/AK/ball_s100.jpg"></p> \n  <hr> \n  <p align="center"><span style="color:#e67e22"><strong>선택02</strong></span><br> <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230601151003_dae11048509d4645871e52283251566b.jpg" data-origin-url="https://img.heodak.com/heodak/homepage/new/AK/ipst/ipst_og.jpg"><br> <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230601151004_2a4b60bb16eb46dcb4828e6b92e286a7.jpg" data-origin-url="https://img.heodak.com/heodak/homepage/new/AK/ipst/ipst_bg.jpg"><br> <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230601151005_cfe9e057960d4525811539480d128038.jpg" data-origin-url="https://img.heodak.com/heodak/homepage/new/AK/ipst/ipst_gl.jpg"><br> <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230601151006_3dfb11ce97ea4e2797b1d379a48cbaad.jpg" data-origin-url="https://img.heodak.com/heodak/homepage/new/AK/ipst/ipst_ch.jpg"><br> <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230601151006_d0dc9c06ec694bc791bad3486274a45b.jpg" data-origin-url="https://img.heodak.com/heodak/homepage/new/AK/ipst/ipst_7v.jpg"><br> <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230601151007_7ba44c5c34dc4ba49dd7ef7b6c66d640.jpg" data-origin-url="https://img.heodak.com/heodak/homepage/new/AK/ipst/ipst_sp.jpg"><br> <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230601151008_8c32b868a4b24c268e7ac8dc10aeb234.jpg" data-origin-url="https://img.heodak.com/heodak/homepage/new/AK/ipst/ipst_corn.jpg"><br> <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230601151009_d5701c2b853b4ce687587cc3402d2787.jpg" data-origin-url="https://img.heodak.com/heodak/homepage/new/h/oven_galbi.jpg"><br> <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230601151010_1927101b220744b7aac245b1186e7c4c.jpg" data-origin-url="https://img.heodak.com/heodak/homepage/new/h/oven_cy.jpg"><br> <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230601151013_6eb317ecb92b470c9ce3d41e417751c6.jpg" data-origin-url="https://img.heodak.com/heodak/homepage/new/h/oven_sb.jpg"><br> <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230601151014_d2582461d6ff4b02a105dc6a44a3d066.jpg" data-origin-url="https://img.heodak.com/heodak/homepage/new/h/oven_hb.jpg"><br> <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230601151014_669fd75f66264b8db17c5e5208377197.jpg" data-origin-url="https://img.heodak.com/heodak/homepage/new/h/oven_hc.jpg"><br> <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230601151015_4f60d0002bba425782d57afdf65bb7b5.jpg" data-origin-url="https://img.heodak.com/heodak/homepage/new/AK/h_o.jpg"><br> <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230601151017_b488fe3929ab4ea5bb775a6d554ad5c4.jpg" data-origin-url="https://img.heodak.com/heodak/homepage/new/AK/h_c.jpg"><br> <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230601151017_8b6750760bb64228a3e99c03f3c2a3ae.jpg" data-origin-url="https://img.heodak.com/heodak/homepage/new/AK/h_s.jpg"><br> <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230601151018_2b0e3197a5174562ab443c3b1c99de26.jpg" data-origin-url="https://img.heodak.com/heodak/homepage/new/AK/h_b.jpg"></p> \n  <hr> \n  <p align="center"><span style="color:#e67e22"><strong>선택03</strong></span><br> <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230601151018_0bc4f0bf6d5447538fa0a56610531be6.jpg" data-origin-url="https://img.heodak.com/heodak/homepage/new/AK/st_g.jpg"><br> <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230601151019_9adb16e25864433fbc360e3220145c9f.jpg" data-origin-url="https://img.heodak.com/heodak/homepage/new/AK/st_h.jpg"><br> <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230601151019_6534442a513f41dcaec3f0a5b8c1e0a2.jpg" data-origin-url="https://img.heodak.com/heodak/homepage/new/AK/st_p.jpg"><br> <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230601151020_b031c10bb8e546948076f298db62c266.jpg" data-origin-url="https://img.heodak.com/heodak/homepage/new/AK/st_t.jpg"></p> \n  <hr> \n  <p align="center"><span style="color:#e67e22"><strong>선택04</strong></span><br> <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230601151021_0d4056a915cd4ca7b95ce56b8ff6607a.jpg" data-origin-url="https://img.heodak.com/heodak/homepage/new/AK/oven_bar_original.jpg"><br> <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230601151021_7019aefe5d444394a3206e9a099caf40.jpg" data-origin-url="https://img.heodak.com/heodak/homepage/new/AK/oven_bar_mecom.jpg"><br> <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230601151022_14824fca10784329b5bdc36ec5c9cccd.jpg" data-origin-url="https://img.heodak.com/heodak/homepage/new/AK/b_ori.jpg"><br> <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230601151022_f573096980d64d9cb1408708530db17a.jpg" data-origin-url="https://img.heodak.com/heodak/homepage/new/AK/b_hot.jpg"><br> <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230601151023_63e68c9b91b74cc28dfe581b78e8bbdf.jpg" data-origin-url="https://img.heodak.com/heodak/homepage/new/AK/spc_vienna_original_new.jpg"><br> <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230601151024_7cb4033252cb4036bdcde3dc104e669b.jpg" data-origin-url="https://img.heodak.com/heodak/homepage/new/AK/spc_vienna_red_pepper_new.jpg"><br> <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230601151024_dec6fb7db4f94b5393addfcf28067742.jpg" data-origin-url="https://img.heodak.com/heodak/homepage/new/AK/spc_vienna_trich_new.jpg"><br> <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230601151025_f3fc4cd53cb24a17964ec31c87178327.jpg" data-origin-url="https://img.heodak.com/heodak/homepage/new/SSG/gg_detail_01.jpg"><br> <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230601151025_36a96d50b9974b4280f59657b30b0a3d.jpg" data-origin-url="https://img.heodak.com/heodak/homepage/new/SSG/gg_detail_02.jpg"><br> <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230601151026_e5c1b554a0ae41729e00e605690d28ee.jpg" data-origin-url="https://img.heodak.com/heodak/homepage/new/SSG/gg_detail_03.jpg"><br> <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230601151026_5b284d09478648f2ba7890da1f9f28dd.jpg" data-origin-url="https://img.heodak.com/heodak/homepage/new/SSG/gg_detail_04.jpg"><br> <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230601151027_5b2f6ba193e04fd1a3021dc36c3beebf.jpg" data-origin-url="https://img.heodak.com/heodak/homepage/new/SSG/gg_detail_06.jpg"></p> \n  <hr> \n  <p align="center"><span style="color:#e67e22"><strong>선택05</strong></span><br> <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230601151028_018d436ded604815851db9123a1ba88f.jpg" data-origin-url="https://img.heodak.com/heodak/homepage/new/AK/ball_b100.jpg"><br> <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230601151028_cc77e55dfac4472cbbdcce60497801d9.jpg" data-origin-url="https://img.heodak.com/heodak/homepage/new/AK/ball_s100.jpg"><br> <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230601151029_368116fae524472196d6a10a051c706f.jpg" data-origin-url="https://img.heodak.com/heodak/homepage/new/AK/ball_k100.jpg"><br> <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230601151029_dd7eb336d63d402f8d6e880b109328c0.jpg" data-origin-url="https://img.heodak.com/heodak/homepage/new/AK/ball_c100.jpg"></p> \n  <hr> \n  <p align="center"><span style="color:#e67e22"><strong>선택06</strong></span><br> <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230601151030_e045b5b536ff4e93b1cdefd56871fd21.jpg" data-origin-url="https://img.heodak.com/heodak/homepage/new/AK/md_o.jpg"><br> <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230601151030_ae6abf4412204402a362f857a5ee211d.jpg" data-origin-url="https://img.heodak.com/heodak/homepage/new/AK/md_k.jpg"><br> <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230601151031_aade95f058454e39957ea9b0d9d8b20a.jpg" data-origin-url="https://img.heodak.com/heodak/homepage/new/AK/detail_page_button.jpg"></p>\n </body>\n</html>',
    instantOrder: false,
    talkDeal: { id: 3375287, status: 'ON_SALE', groupSize: 1, period: { from: '20230531170000', to: '20230603235959' }, ongoingRoomCount: 0, discountPrice: 21900, discountRate: 50.0 },
    benefits: [],
    delivery: {
      deliveryMethodType: 'DELIVERY',
      optionalDeliveries: [],
      deliveryFeeType: 'FREE',
      deliveryFeePaymentType: 'PREPAID',
      deliveryFee: 0,
      bundleGroupAvailable: true,
      isolatedAreaAdditionalFee: 5000,
      jejuAreaAdditionalFee: 5000,
      availableIsolatedArea: true,
    },
    originArea: { type: '혼합/기타', content: '상세설명에 표시', others: false },
    taxDeduction: false,
    gift: { gift: '' },
    quantity: { minPurchase: 1, maxPurchase: 0, maxPurchaseOfBuyer: 0 },
    adultOnly: false,
    isLiquor: false,
    minorPurchasable: true,
    booked: { booked: false },
    notices: [],
    reviewUnexposed: false,
    favorite: false,
    reviewCreatable: false,
    store: {
      id: 16834,
      name: '허닭',
      domain: 'heodak',
      farmer: false,
      coverImage: 'https://st.kakaocdn.net/shoppingstore/store/20190520142926_ef848ab0ccb345b6b28c18b01fb6a264.jpg',
      profileImage: 'https://st.kakaocdn.net/shoppingstore/store/20190520142859_7ac35e5ed6284fa798d57326434aac2a.jpg',
      channelName: '허닭',
      channelUrl: 'http://pf.kakao.com/_xhxoHFd',
      subscribed: false,
      fresh: false,
      trackId: '8781058393990513192',
    },
    category: { id: '102100110110', name: '간편/즉석요리' },
    price: { standardPrice: 43800, discountedPrice: 43800, discountRate: 0.0, minDiscountedPrice: 43800, maxDiscountedPrice: 43800, totalDiscountedPrice: 21900 },
    events: [],
    review: {
      topReviews: [
        {
          id: '6437f5a14ce81249fed89c73',
          content:
            '생각보다 배송이 빨라서 놀랐네요~ 후기에 갯수가 안맞다고 해서 걱정했는데 잘 왔어요! 점심이랑 간식으로 두개 먹어봤는데 맛있네요! 조금 짭짤해서 다이어트식이 맞는진 잘 모르겠어요ㅋㅋㅋㅋㅋ',
          productRating: 4,
          deliveryRating: 4,
          productStarRating: 4,
          deliveryStarRating: 4,
          best: true,
          writer: '이세*',
          imageUrl: 'https://st.kakaocdn.net/thumb/S70x70/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fdefault%2Ffriends%2Fv2%2F8.png&scode=shoppingstore',
          backgroundColor: '#cbb7c3',
        },
        {
          id: '643612bd9f003c132209f371',
          content: '바쁠때 아이들이 간편하게 챙겨먹을수 있는 간식으로 주문했는데 아이들이 좋아했으면 좋겠네요~',
          productRating: 4,
          deliveryRating: 4,
          productStarRating: 4,
          deliveryStarRating: 4,
          best: true,
          writer: '코딩**********',
          imageUrl: 'https://st.kakaocdn.net/thumb/S70x70/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fdefault%2Ffriends%2Fv2%2F8.png&scode=shoppingstore',
          backgroundColor: '#e7eded',
        },
        {
          id: '640be83c57e8c028bf4cb543',
          content: '알찬 구성이에요.아이들 간식이나 엄마들 간단한 식사대용으로 너무좋네요.',
          productRating: 4,
          deliveryRating: 4,
          productStarRating: 4,
          deliveryStarRating: 4,
          best: true,
          writer: '백승*',
          imageUrl: 'https://st.kakaocdn.net/thumb/S70x70/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fdefault%2Ffriends%2Fv2%2F2.png&scode=shoppingstore',
          backgroundColor: '#cbb7c3',
        },
      ],
      qnaCount: 2167,
      reviewCount: 9300,
      averageRating: 4,
      totalProductStarRating: 4.0,
      totalDeliveryStarRating: 4.0,
      productPositivePercentage: 98,
      deliveryPositivePercentage: 97,
      productStar1Percentage: 1,
      productStar2Percentage: 1,
      productStar3Percentage: 7,
      productStar4Percentage: 91,
    },
    banners: [
      {
        id: 9521,
        name: '6/1 베이비위크 2탄',
        firstImageUrl: 'https://st.kakaocdn.net/shoppingstore/home/product_detail_banner/20230525141223_d110f92222634f1ab8f280a0f9e7391f.png',
        landingType: 'URL',
        landingUrl: 'https://pcms.kakao.com/pcms/documents/d1cd80af-bd5b-48b4-be95-56f217a3c993?ad=0601_befe_2_detailbanner',
        ad: false,
        remainSeconds: 199880,
      },
    ],
    sellerProductPoint: {},
  },
  240879562: {
    name: '집밥연구소 100% 수제 통삼겹 김치찜 600g X 2팩',
    image: {
      imageRatio: 'SQUARE',
      images: ['https://st.kakaocdn.net/thumb/P750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230405155221_417a659fc90d4daa9a15eaf44dd44747.jpg'],
      sharingImageUrl: 'https://st.kakaocdn.net/shoppingstore/product/20230405155221_417a659fc90d4daa9a15eaf44dd44747.jpg',
    },
    status: 'ON_SALE',
    description:
      '<html>\n <head></head>\n <body>\n  <div style="margin: 0px; padding: 0px; color: rgb(57, 57, 57); font-family: HelveticaNeue, AppleSDGothicNeo-Regular, tahoma, &quot;Malgun Gothic&quot;, &quot;맑은 고딕&quot;, dotum, 돋움, sans-serif; font-size: 14px; font-style: normal; font-variant-ligatures: normal; font-variant-caps: normal; font-weight: 400; letter-spacing: -0.8px; orphans: 2; text-indent: 0px; text-transform: none; white-space: normal; widows: 2; word-spacing: 0px; -webkit-text-stroke-width: 0px; text-decoration-thickness: initial; text-decoration-style: initial; text-decoration-color: initial; background-color: rgb(255, 255, 255); text-align: center;"> \n   <div style="margin: 0px; padding: 0px; color: rgb(57, 57, 57); font-family: HelveticaNeue, AppleSDGothicNeo-Regular, tahoma, &quot;Malgun Gothic&quot;, &quot;맑은 고딕&quot;, dotum, 돋움, sans-serif; font-size: 14px; font-style: normal; font-variant-ligatures: normal; font-variant-caps: normal; font-weight: 400; letter-spacing: -0.8px; orphans: 2; text-indent: 0px; text-transform: none; white-space: normal; widows: 2; word-spacing: 0px; -webkit-text-stroke-width: 0px; background-color: rgb(255, 255, 255); text-decoration-thickness: initial; text-decoration-style: initial; text-decoration-color: initial; text-align: center;"> <strong><span style="font-size: 18px;">\uD83D\uDCE2 NEW 신제품!⚠️<span style="color:#ffffff;"><span style="background-color:#000000;"> 맛있음 주의&nbsp;</span></span>⚠️</span></strong> \n   </div> \n  </div> \n  <div style="margin: 0px; padding: 0px; color: rgb(57, 57, 57); font-family: HelveticaNeue, AppleSDGothicNeo-Regular, tahoma, &quot;Malgun Gothic&quot;, &quot;맑은 고딕&quot;, dotum, 돋움, sans-serif; font-style: normal; font-variant-ligatures: normal; font-variant-caps: normal; letter-spacing: -0.8px; orphans: 2; text-indent: 0px; text-transform: none; white-space: normal; widows: 2; word-spacing: 0px; -webkit-text-stroke-width: 0px; text-decoration-thickness: initial; text-decoration-style: initial; text-decoration-color: initial; text-align: center;"> \n   <div style="font-size: 14px; font-weight: 400; background-color: rgb(255, 255, 255); margin: 0px; padding: 0px; color: rgb(57, 57, 57); font-family: HelveticaNeue, AppleSDGothicNeo-Regular, tahoma, &quot;Malgun Gothic&quot;, &quot;맑은 고딕&quot;, dotum, 돋움, sans-serif; font-style: normal; font-variant-ligatures: normal; font-variant-caps: normal; letter-spacing: -0.8px; orphans: 2; text-indent: 0px; text-transform: none; white-space: normal; widows: 2; word-spacing: 0px; -webkit-text-stroke-width: 0px; text-decoration-thickness: initial; text-decoration-style: initial; text-decoration-color: initial; text-align: center;"> <span style="font-size:24px;"><strong>\uD83D\uDD25<span style="color: rgb(255, 255, 255);"><span style="background-color: rgb(231, 76, 60);">&nbsp;수제&nbsp; 통삼겹 김치찜&nbsp;</span></span>\uD83D\uDD25</strong></span> \n   </div> \n   <div style="font-size: 14px; font-weight: 400; background-color: rgb(255, 255, 255); margin: 0px; padding: 0px; color: rgb(57, 57, 57); font-family: HelveticaNeue, AppleSDGothicNeo-Regular, tahoma, &quot;Malgun Gothic&quot;, &quot;맑은 고딕&quot;, dotum, 돋움, sans-serif; font-style: normal; font-variant-ligatures: normal; font-variant-caps: normal; letter-spacing: -0.8px; orphans: 2; text-indent: 0px; text-transform: none; white-space: normal; widows: 2; word-spacing: 0px; -webkit-text-stroke-width: 0px; text-decoration-thickness: initial; text-decoration-style: initial; text-decoration-color: initial; text-align: center;"> <span style="font-size: 24px;"><strong>\uD83D\uDD25<span style="color: rgb(255, 255, 255);"><span style="background-color: rgb(231, 76, 60);">&nbsp;무려 X 2팩&nbsp;</span></span>\uD83D\uDD25</strong></span> \n   </div> \n   <div style="margin: 0px; padding: 0px; color: rgb(57, 57, 57); font-family: HelveticaNeue, AppleSDGothicNeo-Regular, tahoma, &quot;Malgun Gothic&quot;, &quot;맑은 고딕&quot;, dotum, 돋움, sans-serif; font-style: normal; font-variant-ligatures: normal; font-variant-caps: normal; letter-spacing: -0.8px; orphans: 2; text-indent: 0px; text-transform: none; white-space: normal; widows: 2; word-spacing: 0px; -webkit-text-stroke-width: 0px; text-decoration-thickness: initial; text-decoration-style: initial; text-decoration-color: initial; text-align: center;"> <span style="font-size: 18px; font-weight: 400;"><strong style=""><span style="background-color: rgb(255, 255, 255);">\uD83E\uDD53&nbsp;</span><span style="background-color: rgb(243, 156, 18);">&nbsp;한팩당 조리"후" 중량이 무려 600g</span><br> <span style="background-color: rgb(255, 255, 255);">\uD83E\uDD53 통삼겹살 가득한 100% 수제 김치찜</span></strong></span> \n   </div> \n  </div> \n  <div style="margin: 0px; padding: 0px; color: rgb(57, 57, 57); font-family: HelveticaNeue, AppleSDGothicNeo-Regular, tahoma, &quot;Malgun Gothic&quot;, &quot;맑은 고딕&quot;, dotum, 돋움, sans-serif; font-style: normal; font-variant-ligatures: normal; font-variant-caps: normal; letter-spacing: -0.8px; orphans: 2; text-indent: 0px; text-transform: none; white-space: normal; widows: 2; word-spacing: 0px; -webkit-text-stroke-width: 0px; text-decoration-thickness: initial; text-decoration-style: initial; text-decoration-color: initial; text-align: center;"> \n   <div style="margin: 0px; padding: 0px; color: rgb(57, 57, 57); font-family: HelveticaNeue, AppleSDGothicNeo-Regular, tahoma, &quot;Malgun Gothic&quot;, &quot;맑은 고딕&quot;, dotum, 돋움, sans-serif; font-style: normal; font-variant-ligatures: normal; font-variant-caps: normal; letter-spacing: -0.8px; orphans: 2; text-indent: 0px; text-transform: none; white-space: normal; widows: 2; word-spacing: 0px; -webkit-text-stroke-width: 0px; text-decoration-thickness: initial; text-decoration-style: initial; text-decoration-color: initial; text-align: center;"> \n    <br> <span style="font-size: 18px; font-weight: 400;"><strong style="">\uD83D\uDE04 YOLO COMMENT \uD83D\uDE04</strong></span> \n    <div style="font-size: 14px; font-weight: 400; margin: 0px; padding: 0px; color: rgb(57, 57, 57); font-family: HelveticaNeue, AppleSDGothicNeo-Regular, tahoma, &quot;Malgun Gothic&quot;, &quot;맑은 고딕&quot;, dotum, 돋움, sans-serif; font-style: normal; font-variant-ligatures: normal; font-variant-caps: normal; letter-spacing: -0.8px; orphans: 2; text-indent: 0px; text-transform: none; white-space: normal; widows: 2; word-spacing: 0px; -webkit-text-stroke-width: 0px; background-color: rgb(255, 255, 255); text-decoration-thickness: initial; text-decoration-style: initial; text-decoration-color: initial; text-align: center;"> <span style="font-size: 18px;"><strong><span style="background-color:#f39c12;">잠깐! 완전조리 후 발송 되는 중량이 600g!</span></strong></span> \n    </div> \n    <div style="font-size: 14px; font-weight: 400; margin: 0px; padding: 0px; color: rgb(57, 57, 57); font-family: HelveticaNeue, AppleSDGothicNeo-Regular, tahoma, &quot;Malgun Gothic&quot;, &quot;맑은 고딕&quot;, dotum, 돋움, sans-serif; font-style: normal; font-variant-ligatures: normal; font-variant-caps: normal; letter-spacing: -0.8px; orphans: 2; text-indent: 0px; text-transform: none; white-space: normal; widows: 2; word-spacing: 0px; -webkit-text-stroke-width: 0px; background-color: rgb(255, 255, 255); text-decoration-thickness: initial; text-decoration-style: initial; text-decoration-color: initial; text-align: center;"> <span style="font-size: 18px;"><strong><span style="background-color:#ffffff;">간편하게 데워드시기만 하면 김치찜 완성</span></strong></span> \n    </div> \n    <div style="font-size: 14px; font-weight: 400; margin: 0px; padding: 0px; color: rgb(57, 57, 57); font-family: HelveticaNeue, AppleSDGothicNeo-Regular, tahoma, &quot;Malgun Gothic&quot;, &quot;맑은 고딕&quot;, dotum, 돋움, sans-serif; font-style: normal; font-variant-ligatures: normal; font-variant-caps: normal; letter-spacing: -0.8px; orphans: 2; text-indent: 0px; text-transform: none; white-space: normal; widows: 2; word-spacing: 0px; -webkit-text-stroke-width: 0px; background-color: rgb(255, 255, 255); text-decoration-thickness: initial; text-decoration-style: initial; text-decoration-color: initial; text-align: center;"> <span style="font-size: 18px;"><strong><span style="background-color:#ffffff;">100% 수제 방식 그대로 고온의 압력에서</span></strong></span> \n    </div> \n    <div style="font-size: 14px; font-weight: 400; margin: 0px; padding: 0px; color: rgb(57, 57, 57); font-family: HelveticaNeue, AppleSDGothicNeo-Regular, tahoma, &quot;Malgun Gothic&quot;, &quot;맑은 고딕&quot;, dotum, 돋움, sans-serif; font-style: normal; font-variant-ligatures: normal; font-variant-caps: normal; letter-spacing: -0.8px; orphans: 2; text-indent: 0px; text-transform: none; white-space: normal; widows: 2; word-spacing: 0px; -webkit-text-stroke-width: 0px; background-color: rgb(255, 255, 255); text-decoration-thickness: initial; text-decoration-style: initial; text-decoration-color: initial; text-align: center;"> <span style="font-size: 18px;"><strong><span style="background-color:#ffffff;">푹 제대로 쪄낸 밥도둑 집밥연구소 김치찜</span></strong></span> \n    </div> \n    <div style="margin: 0px; padding: 0px; color: rgb(57, 57, 57); font-family: HelveticaNeue, AppleSDGothicNeo-Regular, tahoma, &quot;Malgun Gothic&quot;, &quot;맑은 고딕&quot;, dotum, 돋움, sans-serif; font-style: normal; font-variant-ligatures: normal; font-variant-caps: normal; letter-spacing: -0.8px; orphans: 2; text-indent: 0px; text-transform: none; white-space: normal; widows: 2; word-spacing: 0px; -webkit-text-stroke-width: 0px; background-color: rgb(255, 255, 255); text-decoration-thickness: initial; text-decoration-style: initial; text-decoration-color: initial; text-align: center;"> <span style="font-size: 18px;"><b><span style="background-color:#f39c12;">무려 2팩 푸짐한 용량으로 더욱 간편하게!</span></b></span> \n    </div> \n    <br> <!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_1080_1480") -->\n    <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230512164812_5e5cd2d8d66e4ae5a00fb0aa7c33971a.jpg"> <!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_1080_1480") -->\n    <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230512164813_3d1be0f775c84e7ea320cdee920f8f39.jpg"> <!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_860_860") -->\n    <img src="https://st.kakaocdn.net/shoppingstore/editor/20230405155306_2e02ecde6d7c4d62a64e90bdbc5bcae3.jpeg"> <!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_1080_1480") -->\n    <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230512164849_53e13883f0eb4425a3f249f8f4682836.jpg"> <!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_1080_1480") -->\n    <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230512164849_ab8ec9fc2b814566b5e37651a17185b3.jpg"> <!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_1080_1480") -->\n    <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230512164850_c5a6ded8e1a94bd58f553f3d7118cd7c.jpg"> <!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_1080_1480") -->\n    <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230512164850_0d44891274e248bb8a392aa591b7e123.jpg"> <!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_1080_1480") -->\n    <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230512164853_b04aab495447494b831d32c9f18aa87e.jpg"> <!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_860_645") -->\n    <img src="https://st.kakaocdn.net/shoppingstore/editor/20230405155316_7640fab96a4e42658cddf06e6c117ada.jpeg"> <!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_1080_1480") -->\n    <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230512164930_32a17452c90345b3b723ac8b25d22c2a.jpg"> <!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_1080_1480") -->\n    <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230512164930_4d3b1b9958514d169861cfcedf316e4e.jpg"> <!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_1080_1480") -->\n    <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230512164931_3dbcb0fbc07a4fd99b14223de1fbb64c.jpg"> <!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_1080_1480") -->\n    <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230512164931_246415c2c4fa49c8a63db1da6007db37.jpg"> <!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_1080_1480") -->\n    <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230512164932_a7c708ed61624bd5843ebaba0a099f23.jpg"> <!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_1080_1480") -->\n    <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230512164932_ed0a12e79f1d43d88ebbfec3211c73fe.jpg"> <!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_1080_1480") -->\n    <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230512164932_948edbdfc37c4803a95e1685291f342f.jpg"> <!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_1080_1480") -->\n    <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230512164933_c4c631ab2f43404aa05f576a0b879d92.jpg"> <!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_1080_1480") -->\n    <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230512164933_160c0e4e5bfb40bba7359e04c3c4d4f8.jpg"> \n    <p>&nbsp;</p> &nbsp; \n    <p>&nbsp;</p> \n   </div> \n  </div>\n </body>\n</html>',
    instantOrder: false,
    benefits: [],
    delivery: {
      deliveryMethodType: 'DELIVERY',
      optionalDeliveries: [],
      deliveryFeeType: 'FREE',
      deliveryFeePaymentType: 'PREPAID',
      deliveryFee: 0,
      bundleGroupAvailable: true,
      availableIsolatedArea: false,
    },
    originArea: { type: '혼합/기타', content: '상세설명에 표시', others: false },
    taxDeduction: false,
    gift: { gift: '' },
    quantity: { minPurchase: 1, maxPurchase: 0, maxPurchaseOfBuyer: 0 },
    adultOnly: false,
    isLiquor: false,
    minorPurchasable: true,
    booked: { booked: false },
    notices: [],
    reviewUnexposed: false,
    favorite: false,
    reviewCreatable: false,
    store: {
      id: 53256,
      name: '욜로부로',
      domain: 'yoloburo',
      farmer: false,
      coverImage: 'https://st.kakaocdn.net/shoppingstore/default/cover/07.png',
      profileImage: 'https://st.kakaocdn.net/shoppingstore/store/20201106105314_d0d309354033405498343cfcc8f00a25.jpeg',
      channelName: '욜로부로',
      channelUrl: 'http://pf.kakao.com/_txlZwK',
      subscribed: false,
      fresh: false,
      trackId: '',
    },
    category: { id: '102100100112', name: '국/탕/찌개' },
    price: { standardPrice: 20900, discountedPrice: 20900, discountRate: 0.0, minDiscountedPrice: 20900, maxDiscountedPrice: 30900, totalDiscountedPrice: 20900 },
    events: [],
    review: {
      topReviews: [
        {
          id: '6435fd6caab209656f6f54cf',
          content:
            '톡딜 구경하다가 구매했는데 진짜 완전 맛있어요!\n포장도 꼼꼼하게 되어있었고, 저희가족 다들 남들보다 많이 먹는 편인데도 4명에서 든든하게 먹었습니다~ 집에 우동사리 있길래 한번 넣어봤더니 밖에서 가족끼리 외식하는줄 알았습니다ㅜㅜ 존맛탱.. 진짜 우동사리 넣는것도 강추! 고기도 크고 맛있지만 저희 아빠께서 특히 국물을 엄청 좋아하세요ㅎㅎ 김치도 드릅게 맛있다고 하시네요 너무 만족스럽게 한끼 해결해서 다시 또 재주문 합니다~',
          productRating: 4,
          deliveryRating: 4,
          productStarRating: 4,
          deliveryStarRating: 4,
          best: true,
          writer: '김정*',
          imageUrl: 'https://st.kakaocdn.net/thumb/S70x70/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fdefault%2Ffriends%2Fv2%2F2.png&scode=shoppingstore',
          backgroundColor: '#cbb7c3',
        },
        {
          id: '6435f8ef9da4fb298473951c',
          content:
            '인기 많아서 배송늦을까바 걱정했는데 진~~짜 빨리 왔어요~~^^ 아이스팩도 친환경이네요^^ \n요리하기도 귀찮고 그릇씻을 기분도 않나고해서 그냥 전자레인지에 돌려먹었어요~ 전자레인지에 5분정도 돌리니 딱맞네요~\n왠일?? 고기가 진짜 너무 부드러워서 놀랐어요!!!\n나가서 사먹으면 진짜 비싼데 나가서 사먹는 것보다 훨씬 맛있네요!! 진짜 몇개 더 쟁여놔야겠어요~^^ 톡딜계속해주세요~~~^^',
          productRating: 4,
          deliveryRating: 4,
          productStarRating: 4,
          deliveryStarRating: 4,
          best: true,
          writer: '이성*',
          imageUrl: 'https://st.kakaocdn.net/thumb/S70x70/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fdefault%2Ffriends%2Fv2%2F9.png&scode=shoppingstore',
          backgroundColor: '#d6d6d6',
        },
        {
          id: '6437526d7ccad56a7ea3c17c',
          content:
            '배달로 김치찜 자주 시켜먹는데 평도 좋고 주문이 많길래 호기심에 주문해봤어요 결론은 맛있네요! 김치찜 맛은 김치가 결정하는데 김치가 확실히 맛있는 것 같아요 냉동이다보니 해동하면 냄새 날까봐 걱정했지만 냄새도 안나고 괜찮아요 고기도 부드러운 편이고여 제 기준 한 팩 양이 한끼로는 좀 많아서 배터지는 줄 알았어요ㅋㅋ배달 시켜먹으면 비싼데 이 가격이면 훌륭합니다 담에 톡딜 뜨면 또 구매할게요!!\uD83E\uDEF6',
          productRating: 4,
          deliveryRating: 4,
          productStarRating: 4,
          deliveryStarRating: 4,
          best: true,
          writer: '엄*',
          imageUrl: 'https://st.kakaocdn.net/thumb/S70x70/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fdefault%2Ffriends%2Fv2%2F6.png&scode=shoppingstore',
          backgroundColor: '#d6d6d6',
        },
      ],
      qnaCount: 194,
      reviewCount: 831,
      averageRating: 4,
      totalProductStarRating: 4.0,
      totalDeliveryStarRating: 4.0,
      productPositivePercentage: 93,
      deliveryPositivePercentage: 96,
      productStar1Percentage: 3,
      productStar2Percentage: 4,
      productStar3Percentage: 11,
      productStar4Percentage: 82,
    },
    banners: [
      {
        id: 9521,
        name: '6/1 베이비위크 2탄',
        firstImageUrl: 'https://st.kakaocdn.net/shoppingstore/home/product_detail_banner/20230525141223_d110f92222634f1ab8f280a0f9e7391f.png',
        landingType: 'URL',
        landingUrl: 'https://pcms.kakao.com/pcms/documents/d1cd80af-bd5b-48b4-be95-56f217a3c993?ad=0601_befe_2_detailbanner',
        ad: false,
        remainSeconds: 201127,
      },
    ],
    sellerProductPoint: {},
  },
  119114007: {
    name: '[하동관] 84년 전통 서울맛집 한우 암소 곰탕 / 맑고 진한 하동가곰탕 골라담기',
    image: {
      imageRatio: 'SQUARE',
      images: [
        'https://st.kakaocdn.net/thumb/P750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230414105700_e03617e5108a4248aa0a2bcf751d2888.jpg',
        'https://st.kakaocdn.net/thumb/P750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230414105733_0a6f6cef735b40878c77188e73f82802.jpg',
        'https://st.kakaocdn.net/thumb/P750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230414105739_c597bca0ef05416c916244420c942312.jpg',
        'https://st.kakaocdn.net/thumb/P750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230414105744_e558345f5aaf4838a07d4edeb3ee99e4.jpg',
        'https://st.kakaocdn.net/thumb/P750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230414105749_48b9f20eb8e249e0b5a2a8f5bc229055.jpg',
        'https://st.kakaocdn.net/thumb/P750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230414105753_5e8b99f5b77d47478055584a696bef73.jpg',
      ],
      sharingImageUrl:
        'https://st.kakaocdn.net/thumb/C750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230414105700_e03617e5108a4248aa0a2bcf751d2888.jpg&mode=watermark&wm_param1=image&wm_id=talkdeal',
    },
    status: 'ON_SALE',
    description:
      '<html>\n <head></head>\n <body>\n  <p><img data-origin-url="http://link.webhard.co.kr/img/HDQ_IDUWELL_FD2008090210051421295979B" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230414151413_c254b7ef3d784d3fa8ddb52a96005fd7"><br> <br> <img data-origin-url="http://link.webhard.co.kr/img/HDQ_IDUWELL_FD202304051018298312327CA" src="https://st.kakaocdn.net/shoppingstore/editor/20230530100319_b304cfccd9ab496ebb600200564c83bb"><br> <img data-origin-url="http://link.webhard.co.kr/img/HDQ_IDUWELL_FD2008090210051421295979B" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230414151413_c254b7ef3d784d3fa8ddb52a96005fd7"><br> <img data-origin-url="http://link.webhard.co.kr/img/HDQ_IDUWELL_FD202305301018311436B7C22" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230530100321_8bcec2b657ed4461911ba76bc6a17e06"><br> <img data-origin-url="http://link.webhard.co.kr/img/HDQ_IDUWELL_FD2008090210051421295979B" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230414151413_c254b7ef3d784d3fa8ddb52a96005fd7"><br> <img data-origin-url="http://link.webhard.co.kr/img/HDQ_IDUWELL_FD202301311018273235DE3B8" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230530100323_cba199440f8c4a42ace845360671c1c1"><br> <img data-origin-url="http://link.webhard.co.kr/img/HDQ_IDUWELL_FD202304051018298306BA261" src="https://st.kakaocdn.net/shoppingstore/editor/20230530100323_5d084ed4808e44b3b6b0248ddc38dab3"><br> <img data-origin-url="http://link.webhard.co.kr/img/HDQ_IDUWELL_FD20230405101829830707EB2" src="https://st.kakaocdn.net/shoppingstore/editor/20230530100326_01ebf48762de4c6c89fb7160ca1e4b53"><br> <img data-origin-url="http://link.webhard.co.kr/img/HDQ_IDUWELL_FD2008090210051421295979B" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230414151413_c254b7ef3d784d3fa8ddb52a96005fd7"><br> <img data-origin-url="http://link.webhard.co.kr/img/HDQ_IDUWELL_FD202301311018273236B63A8" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230530100329_14c1a0dfb06c4f62b1d21a924eda9964"><br> <img data-origin-url="http://link.webhard.co.kr/img/HDQ_IDUWELL_FD202301311018273237133BF" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230530100330_582b9335b9184d03857bf49df2ae3810"><br> <img data-origin-url="http://link.webhard.co.kr/img/HDQ_IDUWELL_FD202304051018298314CC9B7" src="https://st.kakaocdn.net/shoppingstore/editor/20230530100331_dca671fef1ee4ef0bd112c5eb245e427"><br> <img data-origin-url="http://link.webhard.co.kr/img/HDQ_IDUWELL_FD2008090210051421295979B" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230414151413_c254b7ef3d784d3fa8ddb52a96005fd7"><br> <img data-origin-url="http://link.webhard.co.kr/img/HDQ_IDUWELL_FD202301311018273238E508C" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230530100335_404a70c14fe0494f9ed0c5979cf5abb7"></p>\n </body>\n</html>',
    instantOrder: false,
    talkDeal: { id: 3374594, status: 'ON_SALE', groupSize: 1, period: { from: '20230531170000', to: '20230603235959' }, ongoingRoomCount: 0, discountPrice: 16000, discountRate: 36.0 },
    benefits: [],
    delivery: {
      deliveryMethodType: 'DELIVERY',
      optionalDeliveries: [],
      deliveryFeeType: 'FREE',
      deliveryFeePaymentType: 'PREPAID',
      deliveryFee: 0,
      bundleGroupAvailable: true,
      availableIsolatedArea: false,
    },
    originArea: { type: '혼합/기타', content: '상세페이지 참조', others: false },
    taxDeduction: false,
    gift: { gift: '' },
    quantity: { minPurchase: 0, maxPurchase: 999, maxPurchaseOfBuyer: 999 },
    adultOnly: false,
    isLiquor: false,
    minorPurchasable: true,
    booked: { booked: false },
    notices: [
      {
        id: 74334,
        title: '6월 현충일 배송 공지안내',
        wholeNotice: true,
        content: '<p><img class="__cu_imgsize_750_1196" data-animated="false" src="https://st.kakaocdn.net/shoppingstore/editor/20230530145345_eb18b022f944400e8cd70efe24aa2fe5.jpg" /></p>\n',
        createdAt: '20230530145411',
      },
    ],
    reviewUnexposed: false,
    favorite: false,
    reviewCreatable: false,
    store: {
      id: 27254,
      name: '마더킴',
      domain: 'motherkim',
      farmer: false,
      coverImage: 'https://st.kakaocdn.net/shoppingstore/default/cover/01.png',
      profileImage: 'https://st.kakaocdn.net/shoppingstore/store/20210603171403_5baf345f719e4ee9aa59e2a3a86de125.jpg',
      consultId: '@uwelldeco',
      channelName: '마더킴',
      channelUrl: 'http://pf.kakao.com/_yyqTs',
      subscribed: false,
      fresh: false,
      trackId: '',
    },
    category: { id: '102100110102', name: '즉석국' },
    price: { standardPrice: 43900, discountedPrice: 43900, discountRate: 0.0, minDiscountedPrice: 34900, maxDiscountedPrice: 61900, totalDiscountedPrice: 27900 },
    events: [],
    review: {
      topReviews: [
        {
          id: '641799508b4ef9133e99c123',
          content: '맑은 곰탕. 떡국을 넣어 봄. 간이 되어 있는지 싱겁지는 않음. 국물이 많이 들어 있고 깔끔한 맛 임.',
          productRating: 4,
          deliveryRating: 4,
          productStarRating: 4,
          deliveryStarRating: 4,
          best: true,
          writer: '甘節****',
          imageUrl: 'https://st.kakaocdn.net/thumb/S70x70/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fdefault%2Ffriends%2Fv2%2F8.png&scode=shoppingstore',
          backgroundColor: '#f5e7d9',
        },
        {
          id: '6443048a61a18d1f6f9af7d7',
          content: '실온보관이라괜찮네요브랜드보구주문했는데급할때먹으려고구매해 놓았네요',
          productRating: 4,
          deliveryRating: 4,
          productStarRating: 4,
          deliveryStarRating: 4,
          best: true,
          writer: '로즈**',
          imageUrl: 'https://st.kakaocdn.net/thumb/S70x70/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fdefault%2Ffriends%2Fv2%2F4.png&scode=shoppingstore',
          backgroundColor: '#f5e7d9',
        },
        {
          id: '641168233784fb3424a83434',
          content: '좋아요 맛있네요. 물론 직접 하동관을 가보진 않았지만',
          productRating: 4,
          deliveryRating: 4,
          productStarRating: 4,
          deliveryStarRating: 4,
          best: true,
          writer: '김진*',
          imageUrl: 'https://st.kakaocdn.net/thumb/S70x70/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fdefault%2Ffriends%2Fv2%2F4.png&scode=shoppingstore',
          backgroundColor: '#f5e7d9',
        },
      ],
      qnaCount: 341,
      reviewCount: 1561,
      averageRating: 4,
      totalProductStarRating: 4.0,
      totalDeliveryStarRating: 4.0,
      productPositivePercentage: 95,
      deliveryPositivePercentage: 96,
      productStar1Percentage: 2,
      productStar2Percentage: 3,
      productStar3Percentage: 10,
      productStar4Percentage: 85,
    },
    banners: [
      {
        id: 9521,
        name: '6/1 베이비위크 2탄',
        firstImageUrl: 'https://st.kakaocdn.net/shoppingstore/home/product_detail_banner/20230525141223_d110f92222634f1ab8f280a0f9e7391f.png',
        landingType: 'URL',
        landingUrl: 'https://pcms.kakao.com/pcms/documents/d1cd80af-bd5b-48b4-be95-56f217a3c993?ad=0601_befe_2_detailbanner',
        ad: false,
        remainSeconds: 201255,
      },
    ],
    sellerProductPoint: { sellerProductPurchasePointView: { unit: 'POINT', value: 300, point: 300 }, sellerProductReviewPointView: { value: 200, photoValue: 200, point: 400 } },
  },
  177036828: {
    name: '[85%할인]다이어트 성공엔 안먹은걸로&쓱 가볍고 강력하게 식약처 인정 체지방감소+쾌변',
    image: {
      imageRatio: 'SQUARE',
      images: [
        'https://st.kakaocdn.net/thumb/P750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230308144935_94a7aaea7a8c4609a2ccc306ecbc947c.jpg',
        'https://st.kakaocdn.net/thumb/P750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230412155029_1cfcda701e8b488aa02337c1e90949c9.jpg',
      ],
      sharingImageUrl: 'https://st.kakaocdn.net/shoppingstore/product/20230308144935_94a7aaea7a8c4609a2ccc306ecbc947c.jpg',
    },
    status: 'ON_SALE',
    description:
      '<html>\n <head></head>\n <body>\n  <p><!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_1000_2204") --><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230602101945_fabb08702adb4a0eb643cbb64790147e.jpg"><!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_1000_621") --><img src="https://st.kakaocdn.net/shoppingstore/editor/20230602102000_c21620d6321042e798843ccfb826c398.jpeg"><!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_1000_814") --><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230602102557_21ab08e099854f7381107bec3111e61f.jpg"><!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_1000_102") --><img src="https://st.kakaocdn.net/shoppingstore/editor/20230602102607_8f9b6da83ae94f90a07136c937d649fd.jpeg"><!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_1000_528") --><img src="https://st.kakaocdn.net/shoppingstore/editor/20230602102611_8d5e43a4cecd44848bb3ee1cd44edbae.jpeg"><!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_1000_4492") --><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230602102615_fba36be2b87c49f4991e2deb237f93d2.jpg"><!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_1000_1578") --><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230412165504_084061f3c40a4db99503ef6bfb551179.jpg"> <!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_1000_1642") --><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230412165011_72e319dbd4ca4efdba7dd3c9dd1021d5.jpg">&nbsp;<img data-origin-url="https://ai.esmplus.com/hbe1502/%EC%95%88%EB%A8%B9%EC%9D%80%EA%B1%B8%EB%A1%9C/%EC%98%A4%EB%A6%AC%EC%A7%80%EB%84%90/%EB%A6%AC%EB%89%B4%EC%96%BC/2-2.jpg" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230412153650_6fe167e7e397496ca0dc37d7f10b0d9c.jpg"><img data-origin-url="https://ai.esmplus.com/hbe1502/%EC%95%88%EB%A8%B9%EC%9D%80%EA%B1%B8%EB%A1%9C/%EC%98%A4%EB%A6%AC%EC%A7%80%EB%84%90/%EB%A6%AC%EB%89%B4%EC%96%BC/3.jpg" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230412153650_37150d40df2a459bab9bd40bc0074203.jpg"> <img data-origin-url="https://ai.esmplus.com/hbe1502/%EC%95%88%EB%A8%B9%EC%9D%80%EA%B1%B8%EB%A1%9C/%EC%98%A4%EB%A6%AC%EC%A7%80%EB%84%90/%EB%A6%AC%EB%89%B4%EC%96%BC/4.jpg" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230412153651_ade57f20f87046b589fb586764a85988.jpg"> <img data-origin-url="https://ai.esmplus.com/hbe1502/%EC%95%88%EB%A8%B9%EC%9D%80%EA%B1%B8%EB%A1%9C/%EC%98%A4%EB%A6%AC%EC%A7%80%EB%84%90/%EB%A6%AC%EB%89%B4%EC%96%BC/5.jpg" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230412153651_51140ea0a1354abea487578d3ceab854.jpg"> <img data-origin-url="https://ai.esmplus.com/hbe1502/%EC%95%88%EB%A8%B9%EC%9D%80%EA%B1%B8%EB%A1%9C/%EC%98%A4%EB%A6%AC%EC%A7%80%EB%84%90/%EB%A6%AC%EB%89%B4%EC%96%BC/6.jpg" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230412153652_3b1502fcff414586920db1ff712cafcb.jpg"> <img data-origin-url="https://ai.esmplus.com/hbe1502/%EC%95%88%EB%A8%B9%EC%9D%80%EA%B1%B8%EB%A1%9C/%EC%98%A4%EB%A6%AC%EC%A7%80%EB%84%90/%EB%A6%AC%EB%89%B4%EC%96%BC/7.jpg" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230412153652_1bb4cd360b0b4f7b8589f6c38e5f3785.jpg"> <img data-origin-url="https://ai.esmplus.com/hbe1502/%EC%95%88%EB%A8%B9%EC%9D%80%EA%B1%B8%EB%A1%9C/%EC%98%A4%EB%A6%AC%EC%A7%80%EB%84%90/%EB%A6%AC%EB%89%B4%EC%96%BC/8.jpg" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230412153652_2ee2a8d2e1964bfa96c96b075bb17b9a.jpg"> <img data-origin-url="https://ai.esmplus.com/hbe1502/%EC%95%88%EB%A8%B9%EC%9D%80%EA%B1%B8%EB%A1%9C/%EC%98%A4%EB%A6%AC%EC%A7%80%EB%84%90/%EB%A6%AC%EB%89%B4%EC%96%BC/9.jpg" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230412153653_75d2dbb6b8eb4f9c9129850d70cee129.jpg"> <img data-origin-url="https://ai.esmplus.com/hbe1502/%EC%95%88%EB%A8%B9%EC%9D%80%EA%B1%B8%EB%A1%9C/%EC%98%A4%EB%A6%AC%EC%A7%80%EB%84%90/%EB%A6%AC%EB%89%B4%EC%96%BC/10.gif" src="https://st.kakaocdn.net/shoppingstore/editor/20230412153654_32f999a2b186453bb071677d965b7845.jpeg"> <img data-origin-url="https://ai.esmplus.com/hbe1502/%EC%95%88%EB%A8%B9%EC%9D%80%EA%B1%B8%EB%A1%9C/%EC%98%A4%EB%A6%AC%EC%A7%80%EB%84%90/%EB%A6%AC%EB%89%B4%EC%96%BC/11.jpg" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230412153654_a63ef6807fc94f089963a88d5b80ed47.jpg"> <img data-origin-url="https://ai.esmplus.com/hbe1502/%EC%95%88%EB%A8%B9%EC%9D%80%EA%B1%B8%EB%A1%9C/%EC%98%A4%EB%A6%AC%EC%A7%80%EB%84%90/%EB%A6%AC%EB%89%B4%EC%96%BC/11-2.gif" src="https://st.kakaocdn.net/shoppingstore/editor/20230412153654_8f491fc0efef42da9cc1d93749fe58a6.jpeg"> <img data-origin-url="https://ai.esmplus.com/hbe1502/%EC%95%88%EB%A8%B9%EC%9D%80%EA%B1%B8%EB%A1%9C/%EC%98%A4%EB%A6%AC%EC%A7%80%EB%84%90/%EB%A6%AC%EB%89%B4%EC%96%BC/12.jpg" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230412153655_db591a494bde4f83a13dd89e61d93a5d.jpg"> <img data-origin-url="https://ai.esmplus.com/hbe1502/%EC%95%88%EB%A8%B9%EC%9D%80%EA%B1%B8%EB%A1%9C/%EC%98%A4%EB%A6%AC%EC%A7%80%EB%84%90/%EB%A6%AC%EB%89%B4%EC%96%BC/13.gif" src="https://st.kakaocdn.net/shoppingstore/editor/20230412153656_465a2c0cda9b45d2826bdf1523f5bd00.jpeg"> <img data-origin-url="https://ai.esmplus.com/hbe1502/%EC%95%88%EB%A8%B9%EC%9D%80%EA%B1%B8%EB%A1%9C/%EC%98%A4%EB%A6%AC%EC%A7%80%EB%84%90/%EB%A6%AC%EB%89%B4%EC%96%BC/14.jpg" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230412153656_5ae7a880b10144d397e38a8891e830ee.jpg"> <img data-origin-url="https://ai.esmplus.com/hbe1502/%EC%95%88%EB%A8%B9%EC%9D%80%EA%B1%B8%EB%A1%9C/%EC%98%A4%EB%A6%AC%EC%A7%80%EB%84%90/%EB%A6%AC%EB%89%B4%EC%96%BC/15.jpg" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230412153657_5ea39a236d5a458c906b8a57e058bfbe.jpg"> <img data-origin-url="https://ai.esmplus.com/hbe1502/%EC%95%88%EB%A8%B9%EC%9D%80%EA%B1%B8%EB%A1%9C/%EC%98%A4%EB%A6%AC%EC%A7%80%EB%84%90/%EB%A6%AC%EB%89%B4%EC%96%BC/16.jpg" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230412153657_e424ad04395f41abae33cf1f7f3363fd.jpg"> <img data-origin-url="https://ai.esmplus.com/hbe1502/%EC%95%88%EB%A8%B9%EC%9D%80%EA%B1%B8%EB%A1%9C/%EC%98%A4%EB%A6%AC%EC%A7%80%EB%84%90/%EB%A6%AC%EB%89%B4%EC%96%BC/17.jpg" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230412153657_16ca8975ba424ed68317067793c51265.jpg"> <img data-origin-url="https://ai.esmplus.com/hbe1502/%EC%95%88%EB%A8%B9%EC%9D%80%EA%B1%B8%EB%A1%9C/%EC%98%A4%EB%A6%AC%EC%A7%80%EB%84%90/%EB%A6%AC%EB%89%B4%EC%96%BC/18.jpg" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230412153658_16d678eb68254d9dac555ab93511ab57.jpg"> <img data-origin-url="https://ai.esmplus.com/hbe1502/%EC%95%88%EB%A8%B9%EC%9D%80%EA%B1%B8%EB%A1%9C/%EC%98%A4%EB%A6%AC%EC%A7%80%EB%84%90/%EB%A6%AC%EB%89%B4%EC%96%BC/19.jpg" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230412153658_157e5320d2434d6ba2505b46130e0005.jpg"> <img data-origin-url="https://ai.esmplus.com/hbe1502/%EC%95%88%EB%A8%B9%EC%9D%80%EA%B1%B8%EB%A1%9C/%EC%98%A4%EB%A6%AC%EC%A7%80%EB%84%90/%EB%A6%AC%EB%89%B4%EC%96%BC/20.jpg" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230412153659_01aa8058382b4171a6d9774eb1f41ec6.jpg"> <img data-origin-url="https://ai.esmplus.com/hbe1502/%EC%95%88%EB%A8%B9%EC%9D%80%EA%B1%B8%EB%A1%9C/%EC%98%A4%EB%A6%AC%EC%A7%80%EB%84%90/%EB%A6%AC%EB%89%B4%EC%96%BC/22.jpg" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230412153659_f5249eccd41b466b8341f58f859b8f1d.jpg"> <img data-origin-url="https://ai.esmplus.com/hbe1502/%EC%95%88%EB%A8%B9%EC%9D%80%EA%B1%B8%EB%A1%9C/%EC%98%A4%EB%A6%AC%EC%A7%80%EB%84%90/%EB%A6%AC%EB%89%B4%EC%96%BC/23.jpg" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230412153700_aa1ee23a21134c12b41b848f758b4d95.jpg"> <img data-origin-url="https://ai.esmplus.com/hbe1502/%EC%95%88%EB%A8%B9%EC%9D%80%EA%B1%B8%EB%A1%9C/%EC%98%A4%EB%A6%AC%EC%A7%80%EB%84%90/%EB%A6%AC%EB%89%B4%EC%96%BC/24.jpg" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230412153700_70b08ba6134e48a7a9f3f98f7c89889b.jpg"> <img data-origin-url="https://ai.esmplus.com/hbe1502/%EC%95%88%EB%A8%B9%EC%9D%80%EA%B1%B8%EB%A1%9C/%EC%98%A4%EB%A6%AC%EC%A7%80%EB%84%90/%EB%A6%AC%EB%89%B4%EC%96%BC/25.jpg" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230412153701_358b086b984941579334e399d9a1327a.jpg"> &nbsp;&nbsp; &nbsp; </p> \n  <p>&nbsp;</p> \n  <p><!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_1000_6793") --><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230412165759_1b61c08efeae42e4a7dce4d7482f4996.jpg"></p> \n  <p>&nbsp;<!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_1000_5736") --><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230412165839_49fbdfe2ed104df5859d364ddf7e989c.jpg"></p> \n  <p>&nbsp;</p> \n  <p><!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_1000_386") --><img src="https://st.kakaocdn.net/shoppingstore/editor/20230102173843_97659c7bf88e4c3897d16573ce0eafa3.jpeg">&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;<img data-origin-url="https://ai.esmplus.com/hbe1502/%EC%95%88%EB%A8%B9%EC%9D%80%EA%B1%B8%EB%A1%9C/%EC%93%B1/1.jpg" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20221208120540_6fe549d00d1a4ed697423b01ffb1e23b.jpg"> <img data-origin-url="https://ai.esmplus.com/hbe1502/%EC%95%88%EB%A8%B9%EC%9D%80%EA%B1%B8%EB%A1%9C/%EC%93%B1/2.jpg" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20221208120540_59974860b7c440e791a86a5b62119257.jpg"> <img data-origin-url="https://ai.esmplus.com/hbe1502/%EC%95%88%EB%A8%B9%EC%9D%80%EA%B1%B8%EB%A1%9C/%EC%93%B1/3.jpg" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20221208120541_52a87206c412458a96c1da7c0f48b5fd.jpg"> <img data-origin-url="https://ai.esmplus.com/hbe1502/%EC%95%88%EB%A8%B9%EC%9D%80%EA%B1%B8%EB%A1%9C/%EC%93%B1/4.jpg" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20221208120542_bbe43e95ed8148a7871d16fca8ebe88d.jpg"> <!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_1000_8329") --><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230102180124_967a1a0ef7e44c7dad6779180571d34c.jpg">&nbsp;<img data-origin-url="https://ai.esmplus.com/hbe1502/%EC%95%88%EB%A8%B9%EC%9D%80%EA%B1%B8%EB%A1%9C/%EC%93%B1/6.jpg" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20221208120542_2dc2e55c0b6046bd9716250e5eb0af25.jpg"></p> \n  <p>&nbsp;</p>\n </body>\n</html>',
    instantOrder: false,
    benefits: [],
    delivery: {
      deliveryMethodType: 'DELIVERY',
      optionalDeliveries: [],
      deliveryFeeType: 'FREE',
      deliveryFeePaymentType: 'PREPAID',
      deliveryFee: 0,
      freeConditionalAmount: 50000,
      bundleGroupAvailable: true,
      isolatedAreaAdditionalFee: 5000,
      jejuAreaAdditionalFee: 3000,
      availableIsolatedArea: true,
    },
    originArea: { type: '수입산', content: '인도', others: true },
    taxDeduction: false,
    gift: { gift: '' },
    quantity: { minPurchase: 1, maxPurchase: 0, maxPurchaseOfBuyer: 0 },
    adultOnly: false,
    isLiquor: false,
    minorPurchasable: true,
    booked: { booked: false },
    notices: [],
    reviewUnexposed: false,
    favorite: false,
    reviewCreatable: false,
    store: {
      id: 2542,
      name: 'TCG헬스케어',
      domain: 'sichimidduk',
      farmer: false,
      coverImage: 'https://st.kakaocdn.net/shoppingstore/store/20181017174223_256eca468b3041a5a3255543306d2935.jpg',
      profileImage: 'https://st.kakaocdn.net/shoppingstore/store/20230203173744_6678291cff7444ccace5c302c6cefe70.png',
      consultId: '@tcg헬스케어',
      channelName: 'TCG헬스케어',
      channelUrl: 'http://pf.kakao.com/_xfvmYxj',
      subscribed: false,
      fresh: false,
      trackId: '',
    },
    category: { id: '102105105107', name: '기타 건강기능식품' },
    price: { standardPrice: 149600, discountedPrice: 149600, discountRate: 0.0, minDiscountedPrice: 143700, maxDiscountedPrice: 201400, totalDiscountedPrice: 149600 },
    events: [],
    review: {
      topReviews: [
        {
          id: '643ce872fe1fd65bf1238609',
          content:
            '첫째 놓을때만해도 4kg쪘을때 출산하고 바로 굶고 운동하고해서 뺐어요 그래서 이번에 둘째 놓을때 첫째때보다 2배인 8kg 이나 쪘었지만 저는 쉽게 뺄수있다고 생각했어요\n사람이 나이가 들수록 살찌기 쉽게 변하고 빠지는건 점점 어려워진다던데 진짜 그말이 맞는지 아무리해도 안빠지는거예요 \n그렇게 4개월간 온몸이 부은상태로 있는중에 안먹은걸로 먹으면서 처음에는 몸속 노폐물이나 빼자는 생각으로 했었는데 단순히 노폐물만 빠지는게 아니라 붓기가 가라앉기 시작하는거예요\n진짜 그동안 별의별짓을해도 안되던게 이거먹고 붓기빠지기 시작하면서 다이어트 되니까 진짜 허탈하면서도 좋더라구요\n그래서 그동안 포기하고 있던 다이어트를 본격적으로 했죠 저녁늦게 먹는것만 좀 줄이고 일부러 2,3층정도는 걷고 그렇게 하면서 꾸준히 먹었더니 69kg에서 계속 빠져서 둘째임신전 몸무게인 61kg 보다 더 내려가서 지금 딱 59kg찍으면서 앞자리가 바꼈어요\n진짜 대박이예요 다이어트 입으로 달고사는 분들은 정말 이번이 진짜마지막이다 생각하고 꾸준히 먹어보면 좋을거같아요',
          productRating: 4,
          deliveryRating: 4,
          productStarRating: 4,
          deliveryStarRating: 4,
          best: true,
          writer: '해보*',
          imageUrl: 'https://st.kakaocdn.net/thumb/S70x70/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fdefault%2Ffriends%2Fv2%2F8.png&scode=shoppingstore',
          backgroundColor: '#eec4c5',
        },
        {
          id: '6439f859eb3b382692095453',
          content:
            '안먹은걸로보다 상대적으로 싸다 생각되서 초o이 \n오늘?다 먹었어봤는데 저랑은 잘 안맞고 안먹은걸로는 옛날부터 그렇게 유명하기도했으니까 또 한번 속아보자하고 먹어봤는데 진짜 효과가 빨라서 놀람\n확실한건 지금 3일 먹었는데 장내 찌꺼기가 빠져서 \n그런건지 2키로 빠졌어요\n이게 배에서 불어나니까 밤에 뭘 안먹게되서 자연스럽게 전체적으로 붓기가 빠지고 얼굴 붓기도 좀 빠져서 그런지 헬쓱해져서 진짜 만족^^\n얼굴 갸름해지고 배랑 허리라인 다 생겨서 넘 만족',
          productRating: 4,
          deliveryRating: 4,
          productStarRating: 4,
          deliveryStarRating: 4,
          best: true,
          writer: '영*',
          imageUrl: 'https://st.kakaocdn.net/thumb/S70x70/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fdefault%2Ffriends%2Fv2%2F5.png&scode=shoppingstore',
          backgroundColor: '#d6d6d6',
        },
        {
          id: '643d10ddfc71172c674089ff',
          content:
            '10일만에 2kg 감량하고 후기남깁니다\n하루에 2번 식사전 꼬박꼬박 안먹은걸로 챙겨먹고 운동은 따로 병행안했어요 이거 먹어서 그런지 야식생각은 별로 없었어서 야식은 안먹었습니다 화장실 진짜 잘갑니다\n원래 귀찮아서 후기 잘 안쓰는데 이건 진짜 눈에 띄는 효과를 본게 너무 신기해서 후기 씁니다',
          productRating: 4,
          deliveryRating: 4,
          productStarRating: 4,
          deliveryStarRating: 4,
          best: true,
          writer: '다*',
          imageUrl: 'https://st.kakaocdn.net/thumb/S70x70/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fdefault%2Ffriends%2Fv2%2F1.png&scode=shoppingstore',
          backgroundColor: '#e7eded',
        },
      ],
      qnaCount: 87,
      reviewCount: 280,
      averageRating: 4,
      totalProductStarRating: 4.0,
      totalDeliveryStarRating: 4.0,
      productPositivePercentage: 95,
      deliveryPositivePercentage: 98,
      productStar1Percentage: 1,
      productStar2Percentage: 4,
      productStar3Percentage: 9,
      productStar4Percentage: 86,
    },
    banners: [
      {
        id: 9521,
        name: '6/1 베이비위크 2탄',
        firstImageUrl: 'https://st.kakaocdn.net/shoppingstore/home/product_detail_banner/20230525141223_d110f92222634f1ab8f280a0f9e7391f.png',
        landingType: 'URL',
        landingUrl: 'https://pcms.kakao.com/pcms/documents/d1cd80af-bd5b-48b4-be95-56f217a3c993?ad=0601_befe_2_detailbanner',
        ad: false,
        remainSeconds: 201347,
      },
    ],
    sellerProductPoint: {},
  },
  58175263: {
    name: 'CJ 비비고 냉장생선구이 5팩 골라담기 (삼치/고등어/임연수/갈치)',
    image: {
      imageRatio: 'SQUARE',
      images: ['https://st.kakaocdn.net/thumb/P750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230414090517_d2ef1cf3b85e44898be52545cb93e70e.png'],
      sharingImageUrl:
        'https://st.kakaocdn.net/thumb/C750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230414090517_d2ef1cf3b85e44898be52545cb93e70e.png&mode=watermark&wm_param1=image&wm_id=talkdeal',
    },
    status: 'ON_SALE',
    description:
      '<html>\n <head></head>\n <body>\n  <p><!-- Not Allowed Attribute Filtered ( alt="") --><img data-origin-url="https://www.cjthemarket.com/cjom/design/detail/copyright_img_a.gif" src="https://st.kakaocdn.net/shoppingstore/editor/20220207163222_aca33d6e3e8f44d2aac56d0c0f4f9e02.jpeg"><!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_745_522") --><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230321144935_a3083072a86b43d986c49db008bcb360.jpg"></p> \n  <p><!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_750_3943") --><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230530084634_ec4862b34ecc4682a70746c328ec232c.jpg"></p> \n  <p><!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_820_16494") --><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230406094834_d374b3c4ce164212b6fe4841a9742633.jpg"><!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_820_16555") --><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230406094840_0d112bcf287840e58e059e3b2ee3a23c.jpg"><!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_820_16605") --><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230406094845_ec01e15454b74bb6af05f1dcda2ae5e6.jpg"><!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_820_16555") --><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230406094850_40465cc418b3418fbb0763875e939cd2.jpg"><!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_820_14554") --><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230406094854_14ebc4fbb73b4cc8a9076d61461e0f6d.jpg"><!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_820_17386") --><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230406095239_6cd17afa556947188d297c7e695f3368.jpg"><!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_820_18271") --><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230406095251_143b6cb394984d1b8c60c85732a36e38.jpg"><!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_820_15991") --><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230406094859_0e3299514cb241b8b837861b410df8a1.jpg"></p>\n </body>\n</html>',
    instantOrder: false,
    talkDeal: { id: 3374825, status: 'ON_SALE', groupSize: 1, period: { from: '20230531170000', to: '20230603235959' }, ongoingRoomCount: 0, discountPrice: 6500, discountRate: 29.0 },
    benefits: [],
    delivery: {
      deliveryMethodType: 'DELIVERY',
      optionalDeliveries: [],
      deliveryFeeType: 'FREE',
      deliveryFeePaymentType: 'PREPAID',
      deliveryFee: 0,
      freeConditionalAmount: 20000,
      bundleGroupAvailable: false,
      availableIsolatedArea: true,
    },
    originArea: { type: '혼합/기타', content: '상세설명에 표시', others: false },
    taxDeduction: false,
    gift: { gift: '' },
    quantity: { minPurchase: 1, maxPurchase: 0, maxPurchaseOfBuyer: 0 },
    adultOnly: false,
    isLiquor: false,
    minorPurchasable: true,
    booked: { booked: false },
    notices: [],
    reviewUnexposed: false,
    favorite: false,
    reviewCreatable: false,
    store: {
      id: 1110,
      name: 'CJ제일제당 공식 스토어',
      domain: 'cheiljedang',
      farmer: false,
      coverImage: 'https://st.kakaocdn.net/shoppingstore/default/cover/01.png',
      profileImage: 'https://st.kakaocdn.net/shoppingstore/store/20180430113102_b1c0a1a51b2c456191aa759e781d0f9f.png',
      channelName: 'CJ제일제당',
      channelUrl: 'http://pf.kakao.com/_FeCaC',
      subscribed: false,
      fresh: false,
      trackId: '3472729087454890410',
    },
    category: { id: '102100100100', name: '냉장조리식품' },
    price: { standardPrice: 22400, discountedPrice: 22400, discountRate: 0.0, minDiscountedPrice: 22400, maxDiscountedPrice: 30600, totalDiscountedPrice: 15900 },
    events: [],
    review: {
      topReviews: [
        {
          id: '6448db13779db31e30dacc6a',
          content:
            '편리해서 자주 애용하는 상품이라 이번에 삼치,고등어,갈치,가자미,임연수 요롷게 구매했어요...근데 다 개별포장되어서 왔네요...생선 잔뜩은 좋은데 박스랑 아이스팩 잔뜩은.......너무 아깝다요ㅠㅠ',
          productRating: 4,
          deliveryRating: 4,
          productStarRating: 4,
          deliveryStarRating: 4,
          best: true,
          writer: '공문*',
          imageUrl: 'https://st.kakaocdn.net/thumb/S70x70/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fdefault%2Ffriends%2Fv2%2F6.png&scode=shoppingstore',
          backgroundColor: '#cbb7c3',
        },
        {
          id: '6443426a04780e72bf7a9784',
          content: '와~ 포장 신경 써달라고 했는데 아이스 팩이 터져서 물이...글고 저렇게 작은 줄은...',
          productRating: 4,
          deliveryRating: 4,
          productStarRating: 4,
          deliveryStarRating: 4,
          best: true,
          writer: '☆·******',
          imageUrl: 'https://st.kakaocdn.net/thumb/S70x70/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fdefault%2Ffriends%2Fv2%2F7.png&scode=shoppingstore',
          backgroundColor: '#cbb7c3',
        },
        {
          id: '641da0dafc3eba1b519677fb',
          content: '생각보다 상품에 비해 가격이 좀 비싸 보여요 맛은 어떨련지~',
          productRating: 4,
          deliveryRating: 4,
          productStarRating: 4,
          deliveryStarRating: 4,
          best: true,
          writer: '명민*',
          imageUrl: 'https://st.kakaocdn.net/thumb/S70x70/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fdefault%2Ffriends%2Fv2%2F6.png&scode=shoppingstore',
          backgroundColor: '#eec4c5',
        },
      ],
      qnaCount: 619,
      reviewCount: 2809,
      averageRating: 4,
      totalProductStarRating: 4.0,
      totalDeliveryStarRating: 4.0,
      productPositivePercentage: 95,
      deliveryPositivePercentage: 96,
      productStar1Percentage: 3,
      productStar2Percentage: 2,
      productStar3Percentage: 19,
      productStar4Percentage: 77,
    },
    banners: [
      {
        id: 9521,
        name: '6/1 베이비위크 2탄',
        firstImageUrl: 'https://st.kakaocdn.net/shoppingstore/home/product_detail_banner/20230525141223_d110f92222634f1ab8f280a0f9e7391f.png',
        landingType: 'URL',
        landingUrl: 'https://pcms.kakao.com/pcms/documents/d1cd80af-bd5b-48b4-be95-56f217a3c993?ad=0601_befe_2_detailbanner',
        ad: false,
        remainSeconds: 201609,
      },
    ],
    sellerProductPoint: {},
  },
  213097302: {
    name: '하림 FreshUP 닭볶음용 600g 4팩 외 닭가슴살.근위.닭다리살',
    image: {
      imageRatio: 'SQUARE',
      images: [
        'https://st.kakaocdn.net/thumb/P750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230519114402_06ee4b7641c747b58d1d8da8c85b05be.jpg',
        'https://st.kakaocdn.net/thumb/P750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230411150428_b9fe4bd68ef34411b95e82b046ffb083.jpg',
      ],
      sharingImageUrl: 'https://st.kakaocdn.net/shoppingstore/product/20230519114402_06ee4b7641c747b58d1d8da8c85b05be.jpg',
    },
    status: 'ON_SALE',
    description:
      '<html>\n <head></head>\n <body>\n  <p><!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_890_2851") --><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230524090502_514b801569d94ea59830c9f27d9307a7.jpg"></p> \n  <p><strong><span style="background-color:#f1c40f;">(냉장) FreshUP 닭볶음용 600g*4</span></strong><img data-origin-url="http://harim2022.godohosting.com/web/C019.jpg" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230420090057_b6b9f9a1247241abaec7b75852f106b9.jpg"></p> \n  <p><strong><span style="background-color:#f1c40f;">(냉장) FreshUP 닭근위 500g*4</span></strong> <img data-origin-url="http://harim2022.godohosting.com/web/C020.jpg" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230420090058_c3eaf1934c0b4ddfa626e8720fab186c.jpg"></p> \n  <p><strong><span style="background-color:#f1c40f;">(냉장) FreshUP 닭가슴살 500g*3</span></strong><img data-origin-url="http://harim2022.godohosting.com/web/C013.jpg" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230420090058_19b8b9b1ba0e46ffb966869274b18179.jpg"></p> \n  <p><strong><span style="background-color:#f1c40f;">(냉장) FreshUP 닭다리살 500g*3</span></strong><img data-origin-url="http://harim2022.godohosting.com/web/C018.jpg" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230420090059_a2dde3d8a03d4bb4bd64edb9fcc92b98.jpg"></p> \n  <p><strong><span style="background-color:#f1c40f;">(냉동) IFF 닭다리(북채) 1kg*2</span></strong><img data-origin-url="http://harim2022.godohosting.com/web/B005.jpg" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230410215902_11be2e8a1d134cb9bafa905604d126f4.jpg"></p> \n  <p><strong><span style="background-color:#f1c40f;">(냉동) 무항생제 IFF 닭가슴살 1kg*2</span></strong> <img data-origin-url="http://harim2022.godohosting.com/web/B001.jpg" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230410215903_c3bb371b03ba4f1cb78747e4b5e1a014.jpg"></p> \n  <p><strong><span style="background-color:#f1c40f;">(냉동) IFF 닭 윙 1kg*2</span></strong> <img data-origin-url="http://harim2022.godohosting.com/web/B003.jpg" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230410215904_36d84804179d4f5aabb2adbb26bf4b40.jpg">(냉동) IFF 닭 봉 1kg*2</p> \n  <p><img data-origin-url="http://harim2022.godohosting.com/web/B004.jpg" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230519115534_0f493e9fe41d4413aa931d529fe39756.jpg"></p> \n  <p><strong><span style="background-color:#f1c40f;">(냉동) IFF 닭 안심 1kg*2</span></strong><img data-origin-url="http://harim2022.godohosting.com/web/B002.jpg" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230410215908_8c554564f2b44614a0fc4616531277c5.jpg">&nbsp;<strong><span style="background-color:#f1c40f;">&nbsp;(냉동) IFF 핑크솔트한입닭가슴살 1.1kg</span> <img data-origin-url="http://harim2022.godohosting.com/web/B023.jpg" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230519115535_6e7b2946a8124fc4a4d1911ff9a26bb6.jpg"> </strong><img data-origin-url="http://harim2022.godohosting.com/web/A088.jpg" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230410215922_c062034110f5428ea474d7c880d427c0.jpg"></p> \n  <p>&nbsp;</p> \n  <p>&nbsp;</p>\n </body>\n</html>',
    instantOrder: false,
    benefits: [],
    delivery: {
      deliveryMethodType: 'DELIVERY',
      optionalDeliveries: [],
      deliveryFeeType: 'FREE',
      deliveryFeePaymentType: 'PREPAID',
      deliveryFee: 0,
      freeConditionalAmount: 10000,
      bundleGroupAvailable: true,
      availableIsolatedArea: false,
    },
    originArea: { type: '국내산', content: '', others: false },
    taxDeduction: false,
    gift: { gift: '' },
    quantity: { minPurchase: 1, maxPurchase: 0, maxPurchaseOfBuyer: 0 },
    adultOnly: false,
    isLiquor: false,
    minorPurchasable: true,
    booked: { booked: false },
    notices: [],
    reviewUnexposed: false,
    favorite: false,
    reviewCreatable: false,
    store: {
      id: 35173,
      name: '주식회사 하림',
      domain: 'halimall',
      farmer: false,
      coverImage: 'https://st.kakaocdn.net/shoppingstore/store/20210127093249_b32799f4c04a401b856bb2ce7683dc71.jpg',
      profileImage: 'https://st.kakaocdn.net/shoppingstore/store/20210127100010_bfd50fe46f59495f965d1b3468164fac.jpg',
      channelName: '신선한 하림',
      channelUrl: 'http://pf.kakao.com/_xeQpxixb',
      subscribed: false,
      fresh: false,
      trackId: '',
    },
    category: { id: '102104106103', name: '생닭/부분육' },
    price: { standardPrice: 26000, discountedPrice: 26000, discountRate: 0.0, minDiscountedPrice: 23600, maxDiscountedPrice: 32600, totalDiscountedPrice: 26000 },
    events: [],
    review: {
      topReviews: [
        {
          id: '6415232fc7d6fc16603e5dae',
          content: '3.16 받았고 3.23.유통기한입니다. 하나는 먹고있고 하나는 냉동실입니다. 포장박스가 스티로폼이었습니다. 돈 조금 더 주고 동네마트에서 사먹어야겠습니다.',
          productRating: 4,
          deliveryRating: 3,
          productStarRating: 4,
          deliveryStarRating: 3,
          best: true,
          writer: '유지*',
          imageUrl: 'https://st.kakaocdn.net/thumb/S70x70/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fdefault%2Ffriends%2Fv2%2F10.png&scode=shoppingstore',
          backgroundColor: '#e7eded',
        },
        {
          id: '64119b61593fd84b100cb67d',
          content: '꼼꼼하게 포장되어 왔어요\n가성비 갑입니다\n제일 좋은건 싱싱하고 깨끗합니다!!!',
          productRating: 4,
          deliveryRating: 4,
          productStarRating: 4,
          deliveryStarRating: 4,
          best: true,
          writer: '소*',
          imageUrl: 'https://st.kakaocdn.net/thumb/S70x70/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fdefault%2Ffriends%2Fv2%2F8.png&scode=shoppingstore',
          backgroundColor: '#eec4c5',
        },
        {
          id: '64407bcab2451847923fb3bc',
          content: '육안으로 신선해 보여요 아직 요리해서 먹지는 않았는데 잘 산것 같아요',
          productRating: 4,
          deliveryRating: 4,
          productStarRating: 4,
          deliveryStarRating: 4,
          best: true,
          writer: '김현*',
          imageUrl: 'https://st.kakaocdn.net/thumb/S70x70/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fdefault%2Ffriends%2Fv2%2F9.png&scode=shoppingstore',
          backgroundColor: '#e7eded',
        },
      ],
      qnaCount: 118,
      reviewCount: 486,
      averageRating: 4,
      totalProductStarRating: 4.0,
      totalDeliveryStarRating: 4.0,
      productPositivePercentage: 96,
      deliveryPositivePercentage: 97,
      productStar1Percentage: 1,
      productStar2Percentage: 3,
      productStar3Percentage: 8,
      productStar4Percentage: 88,
    },
    banners: [
      {
        id: 9521,
        name: '6/1 베이비위크 2탄',
        firstImageUrl: 'https://st.kakaocdn.net/shoppingstore/home/product_detail_banner/20230525141223_d110f92222634f1ab8f280a0f9e7391f.png',
        landingType: 'URL',
        landingUrl: 'https://pcms.kakao.com/pcms/documents/d1cd80af-bd5b-48b4-be95-56f217a3c993?ad=0601_befe_2_detailbanner',
        ad: false,
        remainSeconds: 201734,
      },
    ],
    sellerProductPoint: {},
  },
  219911677: {
    name: '60년 전통 빈타이포타 베트남 쌀국수 30팩 무료배송 /DQ',
    image: {
      imageRatio: 'SQUARE',
      images: [
        'https://st.kakaocdn.net/thumb/P750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230416120036_47474e55d8354b099d42130d8721d689.jpg',
        'https://st.kakaocdn.net/thumb/P750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230215114813_2c3e4bc98b8946d781ad9adaa93e9e40.jpg',
        'https://st.kakaocdn.net/thumb/P750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230416120049_a8b0c8f597584c3688eb26d97d6caa7c.jpg',
      ],
      sharingImageUrl: 'https://st.kakaocdn.net/shoppingstore/product/20230416120036_47474e55d8354b099d42130d8721d689.jpg',
    },
    status: 'ON_SALE',
    description:
      '<html>\n <head></head>\n <body>\n  <p><img data-origin-url="https://ai.esmplus.com/thesingsing/IMAGE/DQ/M_DQ001_01_M.gif" src="https://st.kakaocdn.net/shoppingstore/editor/20230227130642_62fd2f7f41494387a6113d82e7b76d5b.jpeg"></p> \n  <p><img data-origin-url="https://ai.esmplus.com/thesingsing/IMAGE/DQ/M_DQ001_02.jpg" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230227130643_772f15a2510046cbbf03d48c1e892109.jpg"><br> <img data-origin-url="https://ai.esmplus.com/thesingsing/IMAGE/DQ/M_DQ001_03_M.gif" src="https://st.kakaocdn.net/shoppingstore/editor/20230227130643_cd8e9ed1a4a64781b7da849ff3816d43.jpeg"><br> <img data-origin-url="https://ai.esmplus.com/thesingsing/IMAGE/DQ/M_DQ001_04.jpg" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230227130645_bb3baea5ae9844d2ad20906008394c03.jpg"><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230227142145_5620876883f445c2870e524d3b070b98.jpg"><br> <br> <img data-origin-url="https://ai.esmplus.com/thesingsing/IMAGE/DQ/M_DQ001_06_M.gif" src="https://st.kakaocdn.net/shoppingstore/editor/20230227130646_637596a0419e41b0ae7614ad22ace34e.jpeg"><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230315140807_79a887b805a640fdbb9ba65b47d792fd.jpg"><br> &nbsp;<img data-origin-url="http://ai.esmplus.com/thesingsing/AS/AS.jpg" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230227130648_479ae428c5e04144bf5d69336811e60e.jpg"></p> \n  <p>&nbsp;</p>\n </body>\n</html>',
    instantOrder: false,
    benefits: [],
    delivery: {
      deliveryMethodType: 'DELIVERY',
      optionalDeliveries: [],
      deliveryFeeType: 'FREE',
      deliveryFeePaymentType: 'PREPAID',
      deliveryFee: 0,
      bundleGroupAvailable: false,
      availableIsolatedArea: false,
    },
    originArea: { type: '수입산', content: '베트남', others: false },
    taxDeduction: false,
    gift: { gift: '' },
    quantity: { minPurchase: 1, maxPurchase: 0, maxPurchaseOfBuyer: 0 },
    adultOnly: false,
    isLiquor: false,
    minorPurchasable: true,
    booked: { booked: false },
    notices: [
      {
        id: 42350,
        title: '베스트 리뷰 이벤트',
        wholeNotice: true,
        content:
          '<p><img class="__cu_imgsize_667_853" data-animated="false" src="https://st.kakaocdn.net/shoppingstore/editor/20230531115919_764df1c3a0c94e28be59fb8e3aca8d78.jpg" /><img data-animated="false" src="https://st.kakaocdn.net/shoppingstore/editor/20220106142134_18f02160bd454787bba9b053b664f153.jpg" /></p>\n',
        createdAt: '20211222160621',
      },
    ],
    reviewUnexposed: false,
    favorite: false,
    reviewCreatable: false,
    store: {
      id: 41936,
      name: '더싱싱',
      domain: 'thesingsing',
      farmer: false,
      coverImage: 'https://st.kakaocdn.net/shoppingstore/store/20210804214423_cd7b83706e54492583fedee425165174.jpg',
      profileImage: 'https://st.kakaocdn.net/shoppingstore/store/20221220110011_d87c77b652b94a4fa5ba25ea621c54e2.png',
      consultId: '@더싱싱',
      channelName: '더싱싱',
      channelUrl: 'http://pf.kakao.com/_xfGtdC',
      subscribed: false,
      fresh: false,
      trackId: '',
    },
    category: { id: '102100110110', name: '간편/즉석요리' },
    price: { standardPrice: 33900, discountedPrice: 33900, discountRate: 0.0, minDiscountedPrice: 33900, maxDiscountedPrice: 33900, totalDiscountedPrice: 33900 },
    events: [],
    review: {
      topReviews: [
        {
          id: '6415a24ffcc0a319b0503704',
          content:
            '제법 맛있어요. 가족 4명이 6개 끓여서 먹었는데, 사서 먹는 것과 비습하다고 모두 좋아했습니다. 숙주와 양파, 쑥을 준비했고, 이미 소스가 매콤한데 그걸 모르고 청양고추를 많이 넣어서 위가 약한 분은 염두하셔야 합니다.',
          productRating: 4,
          deliveryRating: 4,
          productStarRating: 4,
          deliveryStarRating: 4,
          best: true,
          writer: '정상*',
          imageUrl: 'https://st.kakaocdn.net/thumb/S70x70/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fdefault%2Ffriends%2Fv2%2F2.png&scode=shoppingstore',
          backgroundColor: '#f5e7d9',
        },
        {
          id: '640d0c730aae331a069551c2',
          content:
            '전에 할인할때 사먹어보고 맛나서 다먹고 사려는데 가격이 많이올라서 못샀는데이번에 톡딜에서 저번만큼은 아니지만, 저렴하게 잘샀어요\n \n아이가 참 잘먹어요, 어른들은 청양고추, 숙주넣어먹으면 더 맛있지만,,  아직 초저학년이라\n기본만해서 먹는걸 좋아하네요~^^',
          productRating: 4,
          deliveryRating: 4,
          productStarRating: 4,
          deliveryStarRating: 4,
          best: true,
          writer: '김옥******',
          imageUrl: 'https://st.kakaocdn.net/thumb/S70x70/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fdefault%2Ffriends%2Fv2%2F1.png&scode=shoppingstore',
          backgroundColor: '#e7eded',
        },
        {
          id: '6416fd6379822e43ee9f14b8',
          content: '유명한 쌀국수 딜까지 하길래 구매해봤어요~\n만들기도 간편하고 찐으로 쌀국수느낌 납니다.\n간편쌀국수~ 맛있어요~',
          productRating: 4,
          deliveryRating: 4,
          productStarRating: 4,
          deliveryStarRating: 4,
          best: true,
          writer: '김은*',
          imageUrl: 'https://st.kakaocdn.net/thumb/S70x70/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fdefault%2Ffriends%2Fv2%2F9.png&scode=shoppingstore',
          backgroundColor: '#cbb7c3',
        },
      ],
      qnaCount: 94,
      reviewCount: 757,
      averageRating: 4,
      totalProductStarRating: 4.0,
      totalDeliveryStarRating: 4.0,
      productPositivePercentage: 99,
      deliveryPositivePercentage: 99,
      productStar1Percentage: 1,
      productStar2Percentage: 1,
      productStar3Percentage: 6,
      productStar4Percentage: 93,
    },
    banners: [
      {
        id: 9521,
        name: '6/1 베이비위크 2탄',
        firstImageUrl: 'https://st.kakaocdn.net/shoppingstore/home/product_detail_banner/20230525141223_d110f92222634f1ab8f280a0f9e7391f.png',
        landingType: 'URL',
        landingUrl: 'https://pcms.kakao.com/pcms/documents/d1cd80af-bd5b-48b4-be95-56f217a3c993?ad=0601_befe_2_detailbanner',
        ad: false,
        remainSeconds: 201869,
      },
    ],
    sellerProductPoint: {},
  },
  135379379: {
    name: '벤하임 올클린 스탠드형 스팀청소기 BSM-800WH 화이트',
    image: {
      imageRatio: 'SQUARE',
      images: [
        'https://st.kakaocdn.net/thumb/P750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20220715153105_9cb4ce67ca594d5f8dcdda1cb4745121.jpg',
        'https://st.kakaocdn.net/thumb/P750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20220715153115_ae4e3548368147fd8980d1ad587dc12f.jpg',
        'https://st.kakaocdn.net/thumb/P750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20211221161758_ff8f578fc08348caba2c6545440193d1.jpg',
        'https://st.kakaocdn.net/thumb/P750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20211221155859_5d4d14aa7e2c428cac724456c4f84536.jpg',
        'https://st.kakaocdn.net/thumb/P750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20211221155902_f85b6c09ef9e442aab18d4130cb758b2.jpg',
        'https://st.kakaocdn.net/thumb/P750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20211221154438_e05e6205f9964c1d93a793489572f7f9.jpg',
      ],
      sharingImageUrl: 'https://st.kakaocdn.net/shoppingstore/product/20220715153105_9cb4ce67ca594d5f8dcdda1cb4745121.jpg',
    },
    status: 'ON_SALE',
    description:
      '<html>\n <head></head>\n <body>\n  <p><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20211221153921_edeff46ab4bc449e9d039a39a04c2362.jpg"><!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_890_3614") --><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230308102433_d68e5d56d60746f1bdec00eead658054.jpg"><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20211221153921_a6a159d51c5040c7b379b18ae1179202.jpg"><img src="https://st.kakaocdn.net/shoppingstore/editor/20211221153923_d2f185222d37436c9948e5dcd52fcba0.jpeg"><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20211221153927_0b1122c076af475daf280eb1d1bca6cd.jpg"><img src="https://st.kakaocdn.net/shoppingstore/editor/20211221153927_fcb872cefcfd495287f1f0a185b13bf6.jpeg"><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20211221153930_8a4e8d36c4e446f5b6b2e361c66c0cbc.jpg"><img src="https://st.kakaocdn.net/shoppingstore/editor/20211221153933_64b76888ceea4674965a789057bc568a.jpeg"><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20211221153946_27349d699a514fcab74d75118d9aca47.jpg"><img src="https://st.kakaocdn.net/shoppingstore/editor/20211221153947_83008bd16e724f739ff2c6198ec593d0.jpeg"></p> \n  <p><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20211221154129_3808f8705c094ee39b0f8248178a6e69.jpg"></p> \n  <p><img src="https://st.kakaocdn.net/shoppingstore/editor/20211221154014_4ffa43de4ac34cc58c256c8e4989522b.jpeg"><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20211221154017_3a838efbc57c473ab238c7b060505e04.jpg"><img src="https://st.kakaocdn.net/shoppingstore/editor/20211221154021_53c40145f947493f8a33e3d850104393.jpeg"><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20211221154028_552f981c9b484858a556d971aceb70b8.jpg"><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20211221154028_9c23c03fae044315a23fae583398bc56.jpg"><img src="https://st.kakaocdn.net/shoppingstore/editor/20211221154028_0e72c8f09bad49d58d5271e2b22846b0.jpeg"><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20211221154032_618e8a56de6e4f10babc87ddc41fd6e7.jpg"><!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_890_6326") --><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230330111352_4ef1c389994a451cbad12ec0b023a3fa.jpg"></p>\n </body>\n</html>',
    instantOrder: false,
    benefits: [],
    delivery: {
      deliveryMethodType: 'DELIVERY',
      optionalDeliveries: [],
      deliveryFeeType: 'FREE',
      deliveryFeePaymentType: 'PREPAID',
      deliveryFee: 0,
      bundleGroupAvailable: false,
      isolatedAreaAdditionalFee: 5000,
      jejuAreaAdditionalFee: 4000,
      availableIsolatedArea: true,
    },
    taxDeduction: false,
    gift: { gift: '' },
    quantity: { minPurchase: 1, maxPurchase: 0, maxPurchaseOfBuyer: 0 },
    adultOnly: false,
    isLiquor: false,
    minorPurchasable: true,
    booked: { booked: false },
    notices: [],
    reviewUnexposed: false,
    favorite: false,
    reviewCreatable: false,
    store: {
      id: 27814,
      name: '유니크시티',
      domain: 'uniquecity',
      farmer: false,
      coverImage: 'https://st.kakaocdn.net/shoppingstore/default/cover/02.png',
      profileImage: 'https://st.kakaocdn.net/shoppingstore/store/20191024142804_145f3c8b0e2647158e7584086dc6b15e.png',
      channelName: '유니크시티',
      channelUrl: 'http://pf.kakao.com/_xlNFpT',
      subscribed: false,
      fresh: false,
      trackId: '',
    },
    category: { id: '100103102100', name: '스팀청소기' },
    price: { standardPrice: 99000, discountedPrice: 99000, discountRate: 0.0, minDiscountedPrice: 99000, maxDiscountedPrice: 99000, totalDiscountedPrice: 99000 },
    events: [],
    review: {
      topReviews: [
        {
          id: '640c3d85906b96235bc91030',
          content:
            '현명한 소비하세요!!\n리뷰가 도움 되길..\n\n장점\n1. 가격 - 4만원 대에서 같은 성능을 찾아보긴 쉽지 않다. \n2. 예열시간 - 동봉 된 계량컵 으로 2컵 넣을 시 30초 예열로 충분\n- 타사 스팀청소기 예열 10분 이상\n3 작동방법 - 간단해서 누구나 설치 및 작동 할 수 있다.\n\n단점\n1. 물을 데워서 증발 시키는 수증기라 압력 유지 부분이 아쉽다.\n2. 구조상 손잡이와 봉등 컬리티가 아쉽다. \n3. 전원선 부분을 위에 고정해주는 클립등이 없다. 물걸래 청소시 전기선과 걸래부분이 마찰이 잦다. \n\n- --------\n\n이상 느껴본 장 단점입니다.\n가격 대비 가성비 라고 쓰기엔 좋지만 \n\n개인적으론 위험 할 수도 있다는 생각을 했습니다.\n\n일단 온도 조절 딜레이 기능이 없어서 물을 넣고 동작 스위치를 누르면 계속 가동이 됩니다. \n일정 온도 도달시 스위치가 꺼졌다 켜젔다 하는 센서가 없는 것 같은데\n\n이는 자기도 모르게 눌러 놓고 잠깐 자리를 비울 시 계속 가동 된다는 이야기 입니다. \n\n제가 5분 이상 돌려 본 결과 텀 없이 \n계속 가동되더군요.. \n\n물 부족 관련 알림도 없고요.\n\n머 작동시키면서 청소기를 놓고 다른 일보러 가시는 분들은 없겠지만 \n\n이렇게 금방 예열 되는 고열 관련 \n전기 가전제품은 그만큼 과전력을 쓰기 마련인데 에너지 효율을 떠나 안전 만큼은 최소한으로 보장되었으면 하는 바램에 글 적어 보았습니다.',
          productRating: 4,
          deliveryRating: 4,
          productStarRating: 4,
          deliveryStarRating: 4,
          best: true,
          writer: '임현*',
          imageUrl: 'https://st.kakaocdn.net/thumb/S70x70/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fdefault%2Ffriends%2Fv2%2F3.png&scode=shoppingstore',
          backgroundColor: '#f5e7d9',
        },
        {
          id: '6445d2bb034bf24176a493a7',
          content:
            '가격대비 좋아요~ \n기존사용하던건 무선이라 몇년안썼는데 밧데리가 달아서 바꿔야 할무렵 \n핫딜이 떴는데 리뷰가 좋고. 유선이라서 맘에들었습니다.\n싸이즈 도적당하고 미니미 해서 구석 구석 잘 딱이고 좋아요.\n선이 길어서 거실 전체하고도 충분합니다.\n물붓고 전원켜고 대기 많이없이  바로 스팀되니  대기없이 바로 사용하구요. 물부족시 경고음이 울리더라구요. \n걸레 빨려고 보니 많이 뜨거운게 아니라서 화상걱정은 없을듯하지만 조심해야죠.\n보관시 줄 돌돌 감을수 있게 고리가 있어서 간편합니다.\n바닥이 반질반질 해졌어요.',
          productRating: 4,
          deliveryRating: 4,
          productStarRating: 4,
          deliveryStarRating: 4,
          best: true,
          writer: 'hy~',
          imageUrl: 'https://st.kakaocdn.net/thumb/S70x70/?fname=https%3A%2F%2Fp.kakaocdn.net%2Fth%2Ftalkp%2FwnOd6ACW28%2FNHJnZQHnjeD1zbwHdvMRo0%2Fjm1oor_110x110_c.jpg&scode=shoppingstore',
        },
        {
          id: '64101ad6ee44205989180880',
          content:
            '평들이 좋고 톡딜가 금액도 좋고 그래서 반신반의하며 구매해 봤어요~\n조립하는 방법도 간편하고 청소할시 무게도 무겁지 않아 손목이 아프지 않네요~~☆\n전원키를 작동하고 20초뒤에 스팀이 발동~~~!!\n뜨끈뜨끈~ㅎㅎㅎ 묶은 때까지 깔끔히 청소가 되었어요~~ 요거 물건이네요~~ 집안에 먼지를 말끔히  없애주었어요~^^☆☆ 잘 사용하겠습니다~~~☆',
          productRating: 4,
          deliveryRating: 4,
          productStarRating: 4,
          deliveryStarRating: 4,
          best: true,
          writer: '*',
          imageUrl: 'https://st.kakaocdn.net/thumb/S70x70/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fdefault%2Ffriends%2Fv2%2F5.png&scode=shoppingstore',
          backgroundColor: '#eec4c5',
        },
      ],
      qnaCount: 1763,
      reviewCount: 2258,
      averageRating: 4,
      totalProductStarRating: 4.0,
      totalDeliveryStarRating: 4.0,
      productPositivePercentage: 95,
      deliveryPositivePercentage: 98,
      productStar1Percentage: 1,
      productStar2Percentage: 4,
      productStar3Percentage: 12,
      productStar4Percentage: 83,
    },
    banners: [
      {
        id: 9521,
        name: '6/1 베이비위크 2탄',
        firstImageUrl: 'https://st.kakaocdn.net/shoppingstore/home/product_detail_banner/20230525141223_d110f92222634f1ab8f280a0f9e7391f.png',
        landingType: 'URL',
        landingUrl: 'https://pcms.kakao.com/pcms/documents/d1cd80af-bd5b-48b4-be95-56f217a3c993?ad=0601_befe_2_detailbanner',
        ad: false,
        remainSeconds: 202089,
      },
    ],
    sellerProductPoint: {},
  },
  227445595: {
    name: '드리미 L10s Ultra / W10 Pro 로봇청소기',
    image: {
      imageRatio: 'SQUARE',
      images: [
        'https://st.kakaocdn.net/thumb/P750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230419132002_fe7e0c322fe94293ae3a8a321cfd0f05.png',
        'https://st.kakaocdn.net/thumb/P750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230227111607_d478498d87dd4da7bbb9a81f1e457260.jpg',
        'https://st.kakaocdn.net/thumb/P750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230227111618_048b86a70b294b988fb4363f9301bad9.jpg',
        'https://st.kakaocdn.net/thumb/P750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230227111629_6128205808e64f60b5b94771c8cdb6f5.jpg',
        'https://st.kakaocdn.net/thumb/P750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230227111637_8541196a538e4a9f8d1781c9d046e291.jpg',
        'https://st.kakaocdn.net/thumb/P750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230227111649_faf08a85cabe44c9b1604e42126b75f3.jpg',
      ],
      sharingImageUrl: 'https://st.kakaocdn.net/shoppingstore/product/20230419132002_fe7e0c322fe94293ae3a8a321cfd0f05.png',
    },
    status: 'ON_SALE',
    description:
      '<html>\n <head></head>\n <body>\n  <p><!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_860_8154") --><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230602111124_fdebed6389ae4be38bada0e32029c657.png"><!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_860_5369") --><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230601133057_7c32a84b268e4a0e9abffdb9258f6b1d.png"><img data-origin-url="https://ai.esmplus.com/bebenkids1/1_NOTICE/Notice_dreame_1.jpg" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230327165923_36f22d6c782a4d97a436a5f32cb2810e.jpg"> <img data-origin-url="https://gi.esmplus.com/bebenkids/Dreame/L10sUltra/01.png" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230327165924_730cbfb44ac04a3b9ba17918097ec756.png"><br> <iframe width="860" frameborder="0" src="https://www.youtube.com/embed/SWo9316MQT8?autoplay=0&amp;mute=1" height="484"></iframe> <img data-origin-url="https://gi.esmplus.com/bebenkids/Dreame/L10sUltra/03.png" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230327165924_d6eb4d9214924f36af0350828b687d47.png"><br> <iframe width="860" frameborder="0" src="https://www.youtube.com/embed/6AFQiTOXnUE?autoplay=0&amp;mute=1" height="484"></iframe>&nbsp; <!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_860_922") --><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230417110640_e9301e0615114e3fa39741d272873035.png"><br> <img data-origin-url="https://gi.esmplus.com/bebenkids/Dreame/L10sUltra/06.gif" src="https://st.kakaocdn.net/shoppingstore/editor/20230327165926_11656b725cb4481b9879abe86cb1f8da.jpeg"><br> <img data-origin-url="https://gi.esmplus.com/bebenkids/Dreame/L10sUltra/07.gif" src="https://st.kakaocdn.net/shoppingstore/editor/20230327165927_d4e9d725651b4779bf99df473cbe4442.jpeg"><br> <img data-origin-url="https://gi.esmplus.com/bebenkids/Dreame/L10sUltra/08.gif" src="https://st.kakaocdn.net/shoppingstore/editor/20230327165928_a402d6a3a0234a97ba0355c1807a7745.jpeg"><br> <img data-origin-url="https://gi.esmplus.com/bebenkids/Dreame/L10sUltra/09.png" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230327165929_5c9a14decf46471e807378158212f4e5.png"><br> <img data-origin-url="https://gi.esmplus.com/bebenkids/Dreame/L10sUltra/10.gif" src="https://st.kakaocdn.net/shoppingstore/editor/20230327165932_d0fadedd09944aa2a4f7c01c5826f84d.jpeg"><br> <img data-origin-url="https://gi.esmplus.com/bebenkids/Dreame/L10sUltra/11.gif" src="https://st.kakaocdn.net/shoppingstore/editor/20230327165932_276ac5030d04439d82f2bf150740cce8.jpeg"><br> <img data-origin-url="https://gi.esmplus.com/bebenkids/Dreame/L10sUltra/12.png" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230327165933_60c59c18ecf04c57b5fa3cd3096c1040.png"><br> <img data-origin-url="https://gi.esmplus.com/bebenkids/Dreame/L10sUltra/13.png" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230327165934_e1e279c9d96b4785b04208bf74da1654.png"></p> \n  <p>&nbsp;</p> \n  <p>&nbsp;</p> \n  <p><!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_860_484") --><img src="https://st.kakaocdn.net/shoppingstore/editor/20230403182220_4d6cb74b6cb44f838cc71b7202c6bba0.jpeg"><!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_860_290") --><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230403182227_129c6191ed5445faad848e593ac11dc8.png"><br> <img data-origin-url="https://gi.esmplus.com/bebenkids/Dreame/L10sUltra/16.gif" src="https://st.kakaocdn.net/shoppingstore/editor/20230327165936_408868135405488e89cd7fb887d2495a.jpeg"><br> <img data-origin-url="https://gi.esmplus.com/bebenkids/Dreame/L10sUltra/17.png" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230327165937_0f22e120570d48d3adb55df044c6353e.png"><br> <img data-origin-url="https://gi.esmplus.com/bebenkids/Dreame/L10sUltra/18.gif" src="https://st.kakaocdn.net/shoppingstore/editor/20230327165938_07e3be3bfcf24a96ba20082ee756b829.jpeg"><br> <img data-origin-url="https://gi.esmplus.com/bebenkids/Dreame/L10sUltra/19.png" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230327165939_88231de6416f4ef395d04449daf90b4d.png"><br> <img data-origin-url="https://gi.esmplus.com/bebenkids/Dreame/L10sUltra/20.gif" src="https://st.kakaocdn.net/shoppingstore/editor/20230327165939_ef37d167bc654ed3a2bf183f47833b7e.jpeg"><br> <img data-origin-url="https://gi.esmplus.com/bebenkids/Dreame/L10sUltra/21.png" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230327165940_c8cbccf16c614d36b5869d8aab6e53e2.png"><br> <img data-origin-url="https://gi.esmplus.com/bebenkids/Dreame/L10sUltra/22.gif" src="https://st.kakaocdn.net/shoppingstore/editor/20230327165940_954fb41dc94a4964a6ecc6c54e3a271f.jpeg"><br> <img data-origin-url="https://gi.esmplus.com/bebenkids/Dreame/L10sUltra/23.png" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230327165942_9435bb81d80241d08d31174be28dceca.png"><br> <img data-origin-url="https://gi.esmplus.com/bebenkids/Dreame/L10sUltra/24.png" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230327165942_2dcd00349cd84a029a1709d9debab43f.png"><br> <img data-origin-url="https://gi.esmplus.com/bebenkids/Dreame/L10sUltra/25.gif" src="https://st.kakaocdn.net/shoppingstore/editor/20230327165942_8ff3bc44415b4d18ba8e507f2b194f77.jpeg"><br> <!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_860_4396") --><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230413114416_9e6e5fb5b6c140a7804197aa0e3c73e7.png"><br> <img data-origin-url="https://gi.esmplus.com/bebenkids/Dreame/L10sUltra/27.png" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230327165945_57b316eaa831496bbe44af09644ddac0.png"><br> <img data-origin-url="https://gi.esmplus.com/bebenkids/Dreame/L10sUltra/28.gif" src="https://st.kakaocdn.net/shoppingstore/editor/20230327165945_7d5baded9596452c82af0babaa6d36e4.jpeg"><br> <!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_860_14443") --><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230417131735_67717b480d584d64a58544c389e39907.png"><br> <img data-origin-url="https://gi.esmplus.com/bebenkids/Dreame/L10sUltra/30.png" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230327165947_90838e675c8c40bdba7f10f066b74214.png"></p> \n  <p><img data-origin-url="https://ai.esmplus.com/bebenkids1/Dreame/W10Pro/01.png" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230601120014_eff3275f6a8247bba2e2cdacf41a2691.png"><br> <img data-origin-url="https://ai.esmplus.com/bebenkids1/Dreame/W10Pro/03.png" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230601120014_3c4767d18b11481ea8202b058d2f854b.png"><br> <img data-origin-url="https://ai.esmplus.com/bebenkids1/Dreame/W10Pro/04.gif" src="https://st.kakaocdn.net/shoppingstore/editor/20230601120015_a8e6c38582a647f49e6e2bf16a2ab469.jpeg"><br> <img data-origin-url="https://ai.esmplus.com/bebenkids1/Dreame/W10Pro/05.gif" src="https://st.kakaocdn.net/shoppingstore/editor/20230601120015_aa97f063f3fa4c74b0e9a737495ea554.jpeg"><br> <img data-origin-url="https://ai.esmplus.com/bebenkids1/Dreame/W10Pro/06.png" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230601120016_506489dd45214713b5e9eadd281ec2a7.png"><br> <img data-origin-url="https://ai.esmplus.com/bebenkids1/Dreame/W10Pro/07.gif" src="https://st.kakaocdn.net/shoppingstore/editor/20230601120016_e0fc54b4f0bb44e9841b8264a318f55c.jpeg"><br> <img data-origin-url="https://ai.esmplus.com/bebenkids1/Dreame/W10Pro/08.gif" src="https://st.kakaocdn.net/shoppingstore/editor/20230601120017_43fb0e1da22a4b1491f2afac8c05d082.jpeg"><br> <img data-origin-url="https://ai.esmplus.com/bebenkids1/Dreame/W10Pro/09.png" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230601120019_117ad56843c64cc192e9a5335b5ffcbc.png"><br> <img data-origin-url="https://ai.esmplus.com/bebenkids1/Dreame/W10Pro/10.gif" src="https://st.kakaocdn.net/shoppingstore/editor/20230601120020_2f313525455f40948d245087740d7e75.jpeg"><br> <img data-origin-url="https://ai.esmplus.com/bebenkids1/Dreame/W10Pro/11-1.png" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230601120021_8c547fca2e4d4bdaa362d082a2d9cc66.png"><br> <img data-origin-url="https://ai.esmplus.com/bebenkids1/Dreame/W10Pro/12.gif" src="https://st.kakaocdn.net/shoppingstore/editor/20230601120022_d3460cecbe6d4f93a9599c5115de0007.jpeg"><br> <img data-origin-url="https://ai.esmplus.com/bebenkids1/Dreame/W10Pro/13.gif" src="https://st.kakaocdn.net/shoppingstore/editor/20230601120022_0b985cd2bc4a41468f04e36f2aa158be.jpeg"><br> <img data-origin-url="https://ai.esmplus.com/bebenkids1/Dreame/W10Pro/14.png" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230601120023_3c465dc5e0b745bcad62b938a7119cb8.png"><br> <img data-origin-url="https://ai.esmplus.com/bebenkids1/Dreame/W10Pro/15.png" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230601120024_4dbccf24ce4149548af00d195704849e.png"><br> <img data-origin-url="https://ai.esmplus.com/bebenkids1/Dreame/W10Pro/16.gif" src="https://st.kakaocdn.net/shoppingstore/editor/20230601120024_fead075f09414966bc3d68d46fd6accb.jpeg"><br> <img data-origin-url="https://ai.esmplus.com/bebenkids1/Dreame/W10Pro/17.gif" src="https://st.kakaocdn.net/shoppingstore/editor/20230601120024_b24c8ad3c4604399ab23e817de9f9370.jpeg"><br> <img data-origin-url="https://ai.esmplus.com/bebenkids1/Dreame/W10Pro/18.png" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230601120025_6400359803214d8e90a499483273283a.png"><br> <img data-origin-url="https://ai.esmplus.com/bebenkids1/Dreame/W10Pro/19.gif" src="https://st.kakaocdn.net/shoppingstore/editor/20230601120026_5815fb96a0cd4448a1633be333b64cb8.jpeg"><br> <img data-origin-url="https://ai.esmplus.com/bebenkids1/Dreame/W10Pro/20.gif" src="https://st.kakaocdn.net/shoppingstore/editor/20230601120027_d2aad934754b4ce2aaae9709d89cb122.jpeg"><br> <img data-origin-url="https://ai.esmplus.com/bebenkids1/Dreame/W10Pro/21.png" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230601120028_784f436b9de94a1baffe7233e1555294.png"><br> <img data-origin-url="https://ai.esmplus.com/bebenkids1/Dreame/W10Pro/22.gif" src="https://st.kakaocdn.net/shoppingstore/editor/20230601120029_5d1b67d5107c41d8ba74dab8bf47c572.jpeg"><br> <img data-origin-url="https://ai.esmplus.com/bebenkids1/Dreame/W10Pro/23.png" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230601120030_a866c83e2906481fa029bea9bb436422.png"><br> <img data-origin-url="https://ai.esmplus.com/bebenkids1/Dreame/W10Pro/24.gif" src="https://st.kakaocdn.net/shoppingstore/editor/20230601120030_89a9fd1afa034fc6ab01f7cc263e244c.jpeg"><br> <img data-origin-url="https://ai.esmplus.com/bebenkids1/Dreame/W10Pro/25.png" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230601120030_69c440d9459e4be4a44b360ab7cc5166.png"><br> <img data-origin-url="https://ai.esmplus.com/bebenkids1/Dreame/W10Pro/26.png" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230601120031_426d1b9db9d1407dadadb026dd4b68b5.png"></p>\n </body>\n</html>',
    instantOrder: false,
    benefits: [],
    delivery: {
      deliveryMethodType: 'DELIVERY',
      optionalDeliveries: [],
      deliveryFeeType: 'FREE',
      deliveryFeePaymentType: 'PREPAID',
      deliveryFee: 0,
      bundleGroupAvailable: false,
      isolatedAreaAdditionalFee: 20000,
      jejuAreaAdditionalFee: 20000,
      availableIsolatedArea: true,
    },
    taxDeduction: false,
    gift: { gift: '' },
    quantity: { minPurchase: 1, maxPurchase: 0, maxPurchaseOfBuyer: 0 },
    adultOnly: false,
    isLiquor: false,
    minorPurchasable: true,
    booked: { booked: false },
    notices: [],
    reviewUnexposed: false,
    favorite: false,
    reviewCreatable: false,
    store: {
      id: 112183,
      name: 'Dreame',
      domain: 'dreame',
      farmer: false,
      coverImage: 'https://st.kakaocdn.net/shoppingstore/default/cover/01.png',
      profileImage: 'https://st.kakaocdn.net/shoppingstore/store/20230213132314_f52520db302849e4ba3b1a632b2c8256.jpg',
      channelName: '드리미',
      channelUrl: 'http://pf.kakao.com/_xbEJDxj',
      subscribed: false,
      fresh: false,
      trackId: '',
    },
    category: { id: '100103102101', name: '로봇청소기' },
    price: { standardPrice: 1599000, discountedPrice: 1599000, discountRate: 0.0, minDiscountedPrice: 1199000, maxDiscountedPrice: 1599000, totalDiscountedPrice: 1599000 },
    events: [],
    review: {
      topReviews: [
        {
          id: '642fe6a3593995715991e3b1',
          content:
            '동생네가 쓰고 잇는걸보고\n어머니가 갖고 싶다하셔서 구매하엿습니다.\n\n매우 만족합니다.\n테스트겸 해봣는데 확실히 좋아요\n\n핸드폰으로 설정 및 자동처리, 여러부분 설정 된다는게 매우 만족하는 부분입니다.',
          productRating: 4,
          deliveryRating: 4,
          productStarRating: 4,
          deliveryStarRating: 4,
          best: true,
          writer: '강은주',
          imageUrl: 'https://st.kakaocdn.net/thumb/S70x70/?fname=https%3A%2F%2Fp.kakaocdn.net%2Fth%2Ftalkp%2FwnOgKdwCvp%2FQEo7GZanZUfMCuabbkDsy1%2Fxe2ojk_110x110_c.jpg&scode=shoppingstore',
        },
        {
          id: '642e8c9ddcba18452c6bdc76',
          content: '사용전이지만 너무 좋아요',
          productRating: 4,
          deliveryRating: 4,
          productStarRating: 4,
          deliveryStarRating: 4,
          best: true,
          writer: '도반***********',
          imageUrl: 'https://st.kakaocdn.net/thumb/S70x70/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fdefault%2Ffriends%2Fv2%2F9.png&scode=shoppingstore',
          backgroundColor: '#eec4c5',
        },
        {
          id: '642ea977acb81577781d01f1',
          content: '신세계네요 ㅎㅎ \n너무 좋아요',
          productRating: 4,
          deliveryRating: 4,
          productStarRating: 4,
          deliveryStarRating: 4,
          best: true,
          writer: '으넹*',
          imageUrl: 'https://st.kakaocdn.net/thumb/S70x70/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fdefault%2Ffriends%2Fv2%2F9.png&scode=shoppingstore',
          backgroundColor: '#eec4c5',
        },
      ],
      qnaCount: 61,
      reviewCount: 36,
      averageRating: 4,
      totalProductStarRating: 4.0,
      totalDeliveryStarRating: 4.0,
      productPositivePercentage: 100,
      deliveryPositivePercentage: 97,
      productStar1Percentage: 0,
      productStar2Percentage: 0,
      productStar3Percentage: 0,
      productStar4Percentage: 100,
    },
    banners: [
      {
        id: 9521,
        name: '6/1 베이비위크 2탄',
        firstImageUrl: 'https://st.kakaocdn.net/shoppingstore/home/product_detail_banner/20230525141223_d110f92222634f1ab8f280a0f9e7391f.png',
        landingType: 'URL',
        landingUrl: 'https://pcms.kakao.com/pcms/documents/d1cd80af-bd5b-48b4-be95-56f217a3c993?ad=0601_befe_2_detailbanner',
        ad: false,
        remainSeconds: 202372,
      },
    ],
    sellerProductPoint: {},
  },
  224152000: {
    name: '30년 전통맛집 강강술래 홈채움 양념LA갈비 500g*2팩(1kg) (미국산 초이스 등급)',
    image: {
      imageRatio: 'SQUARE',
      images: [
        'https://st.kakaocdn.net/thumb/P750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230302132916_75c07a03a1354067ad64bd550eada5ce.jpg',
        'https://st.kakaocdn.net/thumb/P750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230302132919_3ef958de3d46449a9a144e36e54f0c50.jpg',
        'https://st.kakaocdn.net/thumb/P750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230302132923_f4d9f68b9dac4d5e9ef008dcba16b2d7.jpg',
        'https://st.kakaocdn.net/thumb/P750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230302132926_6451657317ab4343a28e76e3fca04585.jpg',
        'https://st.kakaocdn.net/thumb/P750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230302132930_75ec1b1c6cbf446087cdc3fcd2a3575f.jpg',
      ],
      sharingImageUrl:
        'https://st.kakaocdn.net/thumb/C750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230302132916_75c07a03a1354067ad64bd550eada5ce.jpg&mode=watermark&wm_param1=image&wm_id=talkdeal',
    },
    status: 'ON_SALE',
    description:
      '<html>\n <head></head>\n <body>\n  <p>&nbsp;</p> \n  <p><!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_1000_1800") --><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230504170838_744b3e0249e344eba7ca056fdd70da1d.jpg"></p> \n  <p><img data-origin-url="https://sullai.godohosting.com/product/gif/102147_gif01.gif" src="https://st.kakaocdn.net/shoppingstore/editor/20230307154849_aeea6906c02641cb916c6fa43e430618.jpeg"><img data-origin-url="https://sullai.godohosting.com/notice/top_info02.jpg" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230307154851_2efff7de9c774330814743067a0eecb9.jpg"><img data-origin-url="https://sullai.godohosting.com/product/sku/102147_dt01.jpg" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230307154851_7019a6e5e603495bbee9af0c5f626132.jpg"><br> <img data-origin-url="https://sullai.godohosting.com/product/sku/102147_dt02.jpg" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230307154852_16b09ebec3fc49eea4812c08fb23957a.jpg"><br> <img data-origin-url="https://sullai.godohosting.com/product/sku/102147_dt03.jpg" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230307154852_ecca7edea38c438b955cb455db8e2880.jpg"><br> <img data-origin-url="https://sullai.godohosting.com/product/sku/102147_dt04.jpg" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230307154853_3bcd7ac36e8d4f6c8c1a52967f519078.jpg"><br> <img data-origin-url="https://sullai.godohosting.com/product/sku/102147_dt06.jpg" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230307154853_f7441fc55eff4af680ba953074752e6a.jpg"><br> <img data-origin-url="https://sullai.godohosting.com/product/sku/102147_dt07.jpg" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230307154854_4200f64f6ccc4a03af5d44889c063e37.jpg"><br> <img data-origin-url="https://sullai.godohosting.com/product/sku/102147_dt08.jpg" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230307154854_1e3614fda95b4a02b2ce3e81cab6e3ba.jpg"><br> <img data-origin-url="https://sullai.godohosting.com/product/sku/102147_dt09.jpg" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230307154855_8eb5df52dc1842cca087ed6ae9603cd2.jpg"><br> <img data-origin-url="https://sullai.godohosting.com/product/sku/102147_dt10.jpg" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230307154855_9f8338a6fb1b48058105a605c7c13554.jpg"><br> <img data-origin-url="https://sullai.godohosting.com/notice/HACCP_23.jpg" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230307154856_71f6fd6f4f7d4c1fa608d4c1ced62c0a.jpg"><br> <img data-origin-url="https://sullai.godohosting.com/notice/cs_01.jpg" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230307154856_da3048ebd6e5426ab3e3fb5c5a7d5d45.jpg"><br> <img data-origin-url="https://sullai.godohosting.com/notice/cs_02.jpg" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230307154856_454f2720aa2e45a1a299d2b003f13337.jpg"><br> <img data-origin-url="https://sullai.godohosting.com/notice/cs_03.jpg" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230307154858_2042274f8b3f408393ce53e6b2f339fc.jpg"><br> <img data-origin-url="https://sullai.godohosting.com/notice/bottom_info01.jpg" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230307154858_2fe90a06e2c8438fa37aa76cff35f94e.jpg"><br> <img data-origin-url="https://sullai.godohosting.com/notice/bottom_info02.jpg" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230307154859_18c7b538550d4d7080f603d5d2704524.jpg"></p>\n </body>\n</html>',
    instantOrder: false,
    talkDeal: { id: 3376211, status: 'ON_SALE', groupSize: 1, period: { from: '20230531170000', to: '20230603235959' }, ongoingRoomCount: 0, discountPrice: 56100, discountRate: 66.0 },
    benefits: [],
    delivery: {
      deliveryMethodType: 'DELIVERY',
      optionalDeliveries: [],
      deliveryFeeType: 'FREE',
      deliveryFeePaymentType: 'PREPAID',
      deliveryFee: 0,
      freeConditionalAmount: 50000,
      repeatQuantity: 0,
      bundleGroupAvailable: false,
      availableIsolatedArea: false,
    },
    originArea: { type: '혼합/기타', content: '상세설명참조', others: false },
    taxDeduction: false,
    gift: { gift: '' },
    quantity: { minPurchase: 1, maxPurchase: 0, maxPurchaseOfBuyer: 0 },
    adultOnly: false,
    isLiquor: false,
    minorPurchasable: true,
    booked: { booked: false },
    notices: [],
    reviewUnexposed: false,
    favorite: false,
    reviewCreatable: false,
    store: {
      id: 41930,
      name: '강강술래',
      domain: 'sullaimall',
      farmer: false,
      coverImage: 'https://st.kakaocdn.net/shoppingstore/store/20210514144909_e4607fc94c8340f59d13297dabd78206.png',
      profileImage: 'https://st.kakaocdn.net/shoppingstore/store/20200707132941_227bbf50623844608d4ee56c89018694.jpg',
      consultId: '@강강술래몰',
      channelName: '강강술래쇼핑몰',
      channelUrl: 'http://pf.kakao.com/_CEIDxb',
      subscribed: false,
      fresh: false,
      trackId: '',
    },
    category: { id: '102100124102', name: '족발/편육/바비큐' },
    price: { standardPrice: 84000, discountedPrice: 84000, discountRate: 0.0, minDiscountedPrice: 84000, maxDiscountedPrice: 95000, totalDiscountedPrice: 27900 },
    events: [],
    review: {
      topReviews: [
        {
          id: '6407f7e8f3a4144953387c14',
          content:
            '평소 양념LA갈비 광신도라 구매를 많이 해서 먹는데요 직접 양념 하긴 귀찮으니 제품에 힘을 빌리는 편이죠 ㅎㅎㅎ \n제품 포장 상태도 깔끔히 잘왔구요 다른 홈쇼핑 제품은 가격은 저렴한데 맛이 없는데 강강술래 제품은 고기 두께도 튼실하고 괜찮게 잘 먹었어요! 저 같은 경우 후라이팬 중불로 은은하게 타지 않게 정성을 다해 구워 먹거든요 정말 맛있네요!! 번창하세요 ~!',
          productRating: 4,
          deliveryRating: 4,
          productStarRating: 4,
          deliveryStarRating: 4,
          best: true,
          writer: '광*',
          imageUrl: 'https://st.kakaocdn.net/thumb/S70x70/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fdefault%2Ffriends%2Fv2%2F7.png&scode=shoppingstore',
          backgroundColor: '#f5e7d9',
        },
        {
          id: '64105196b14f2f31db225d52',
          content: '급하게  보내시느라  핏물을 안빼셨나봐요\n마니 찜찜했어요',
          productRating: 3,
          deliveryRating: 2,
          productStarRating: 3,
          deliveryStarRating: 2,
          best: true,
          writer: '지금****************',
          imageUrl: 'https://st.kakaocdn.net/thumb/S70x70/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fdefault%2Ffriends%2Fv2%2F10.png&scode=shoppingstore',
          backgroundColor: '#e7eded',
        },
        {
          id: '6406c822d7bf20604753d912',
          content: 'LA양념갈비 먹고싶어서 주문해봤어요\n배송도 빠르고 포장도 꼼꼼하네요!\n고기도 두툼하고 양념 맛있네요\n\n갈비 생각날때 또 주문할게요~~',
          productRating: 4,
          deliveryRating: 4,
          productStarRating: 4,
          deliveryStarRating: 4,
          best: true,
          writer: '박유*',
          imageUrl: 'https://st.kakaocdn.net/thumb/S70x70/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fdefault%2Ffriends%2Fv2%2F7.png&scode=shoppingstore',
          backgroundColor: '#d6d6d6',
        },
      ],
      qnaCount: 401,
      reviewCount: 534,
      averageRating: 3,
      totalProductStarRating: 3.5,
      totalDeliveryStarRating: 3.5,
      productPositivePercentage: 84,
      deliveryPositivePercentage: 87,
      productStar1Percentage: 7,
      productStar2Percentage: 8,
      productStar3Percentage: 14,
      productStar4Percentage: 70,
    },
    banners: [
      {
        id: 9521,
        name: '6/1 베이비위크 2탄',
        firstImageUrl: 'https://st.kakaocdn.net/shoppingstore/home/product_detail_banner/20230525141223_d110f92222634f1ab8f280a0f9e7391f.png',
        landingType: 'URL',
        landingUrl: 'https://pcms.kakao.com/pcms/documents/d1cd80af-bd5b-48b4-be95-56f217a3c993?ad=0601_befe_2_detailbanner',
        ad: false,
        remainSeconds: 202583,
      },
    ],
    sellerProductPoint: {},
  },
  65276142: {
    name: '한우물 두번구운주먹밥15개[구매 포인트증정+리뷰시 추가포인트증정]',
    image: {
      imageRatio: 'SQUARE',
      images: [
        'https://st.kakaocdn.net/thumb/P750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20220303141657_8be2d1c209124d849c70e0625a48e3d7.jpg',
        'https://st.kakaocdn.net/thumb/P750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20220907102556_1e3ccc9e9bba47b1b88bc3870b708dd3.jpg',
        'https://st.kakaocdn.net/thumb/P750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20220907102623_eb445612abc24419b9948bd54c07cb62.jpg',
        'https://st.kakaocdn.net/thumb/P750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230510124736_f8a646444fb94d0598ada44238b7aef2.jpg',
        'https://st.kakaocdn.net/thumb/P750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230510124751_486f7b1de5e346c590fdc4b978373e95.jpg',
      ],
      sharingImageUrl: 'https://st.kakaocdn.net/shoppingstore/product/20220303141657_8be2d1c209124d849c70e0625a48e3d7.jpg',
    },
    status: 'ON_SALE',
    description:
      '<html>\n <head></head>\n <body>\n  <div style="text-align:center"> \n   <p style="text-align: center;">&nbsp;</p> <!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_860_1300") -->\n   <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230411153252_b2dbc84bfde44ab4ac287fd284e77efd.jpg"> <!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_860_860") -->\n   <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230411153253_3baeec46a0bf4e5fbffd5c7a2bd703a2.jpg"> <!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_860_860") -->\n   <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230411153253_314b7839bf724b379a5dde38406b62b4.jpg"> <!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_860_1199") -->\n   <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230411153253_341874c1488945d38b9d1ca4b464e3ec.jpg"> <!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_860_1200") -->\n   <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230411153253_4bb17b74d6bf4f73a7e5167e6629b455.jpg"> <!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_860_1562") -->\n   <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230411153253_f521554a9e5b49189b71b9908a4da93c.jpg"> <!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_860_938") -->\n   <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230411153253_5054b38210c148f29a2eddad691fbe08.jpg"> <!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_900_900") -->\n   <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230411153254_922e50dbbb39445798694273543035a6.jpg"> <!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_860_1340") -->\n   <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230411153254_fa35a6649b7643ae88bb4646db16f24b.jpg"> <!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_860_1562") -->\n   <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230411153254_84428347d0ee40d7ada384012e28c058.jpg"> <!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_860_938") -->\n   <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230411153254_6badfd375bcd4f25893345c10e82f95e.jpg"> <!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_900_900") -->\n   <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230411153254_4fdcf8f74f68446bb9f409dfa4e4334d.jpg"> <!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_860_1340") -->\n   <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230411153254_a83a7532ab0c4b9bb64945aa82667a8f.jpg"> <!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_860_1562") -->\n   <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230411153255_0b7f93bf3d884efebab74103f23e30ce.jpg"> <!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_860_938") -->\n   <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230411153255_e874dd6624d648ea839ebe538a2bd0c7.jpg"> <!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_900_900") -->\n   <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230411153255_c0b0e4bcb5784f3aaee938ee5f2062f4.jpg"> <!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_860_1340") -->\n   <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230411153255_a63aa19e85fc40eeab024a8ee25a76c0.jpg"> <!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_860_1562") -->\n   <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230411153255_8c60378f9f1f4b27b04f473b6cc9f8e3.jpg"> <!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_860_938") -->\n   <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230411153256_74bf87f8b75949559de7eb6598ca5f37.jpg"> <!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_900_900") -->\n   <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230411153808_aaa9d9a7d3d54a1b895d1e63a6d25260.jpg"> <!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_860_1340") -->\n   <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230411153808_387442c9f49446c78f198344abda02df.jpg"> <!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_860_1562") -->\n   <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230411153808_792fe6ac60014b1693a46389fe15fef5.jpg"> <!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_860_938") -->\n   <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230411153808_a036408bf50c4629ac739ec12afce939.jpg"> <!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_900_900") -->\n   <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230411153808_d392059c7b9d4341a355087192a54663.jpg"> <!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_860_1340") -->\n   <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230411153809_6498eacdf09943c79d4557ff285a7cc8.jpg"> \n   <p>&nbsp;</p> \n  </div> \n  <div style="text-align:center">\n    &nbsp; \n  </div> \n  <div style="text-align:center">\n    &nbsp; \n  </div> \n  <div style="text-align:center"> <!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_607_812") -->\n   <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230411154141_1b20c38cbc9747889a86ae346d5d88fd.jpg"> \n  </div> \n  <div style="text-align:center">\n    &nbsp; \n  </div>\n </body>\n</html>',
    instantOrder: true,
    benefits: [],
    delivery: {
      deliveryMethodType: 'DELIVERY',
      optionalDeliveries: [],
      deliveryFeeType: 'FREE',
      deliveryFeePaymentType: 'PREPAID',
      deliveryFee: 0,
      bundleGroupAvailable: false,
      isolatedAreaAdditionalFee: 8000,
      jejuAreaAdditionalFee: 4000,
      availableIsolatedArea: true,
    },
    originArea: { type: '혼합/기타', content: '상세페이지 참조', others: false },
    taxDeduction: false,
    gift: { gift: '' },
    quantity: { minPurchase: 1, maxPurchase: 1000, maxPurchaseOfBuyer: 1000 },
    adultOnly: false,
    isLiquor: false,
    minorPurchasable: true,
    booked: { booked: false },
    notices: [
      {
        id: 63364,
        title: '쇼핑하고 포인트받아가세요~',
        wholeNotice: false,
        content: '<p><img class="__cu_imgsize_860_340" data-animated="false" src="https://st.kakaocdn.net/shoppingstore/editor/20230210125601_6d66f7df677145408d1f13a3fcf02d83.jpg" /></p>\n',
        createdAt: '20221114103532',
      },
    ],
    reviewUnexposed: false,
    favorite: false,
    reviewCreatable: false,
    store: {
      id: 1872,
      name: '치타마켓',
      domain: 'cheeta',
      farmer: false,
      coverImage: 'https://st.kakaocdn.net/shoppingstore/store/20210601134244_59ad56b1cb0b44058fce178ec3acf5c9.jpg',
      profileImage: 'https://st.kakaocdn.net/shoppingstore/store/20210601133902_85c7e037a67f4d8b9bdb0f371c77d02f.jpg',
      consultId: '@치타마켓',
      channelName: '치타마켓',
      channelUrl: 'http://pf.kakao.com/_xkxgmeM',
      subscribed: false,
      fresh: false,
      trackId: '5870414469548560227',
    },
    category: { id: '102100110100', name: '즉석밥' },
    price: { standardPrice: 24900, discountedPrice: 16900, discountRate: 32.0, minDiscountedPrice: 9900, maxDiscountedPrice: 16900, totalDiscountedPrice: 16900 },
    events: [],
    review: {
      topReviews: [
        {
          id: '6422b6a3353cd37aa924d5a9',
          content: '예정일보디 빠른배송 고맙습니다.\n포장도 아이스팩에 꼼꼼하게 잘 보내 주셨네요, 잘 먹겠습니다.',
          productRating: 4,
          deliveryRating: 4,
          productStarRating: 4,
          deliveryStarRating: 4,
          best: true,
          writer: '20*******',
          imageUrl: 'https://st.kakaocdn.net/thumb/S70x70/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fdefault%2Ffriends%2Fv2%2F5.png&scode=shoppingstore',
          backgroundColor: '#cbb7c3',
        },
        {
          id: '643a32f10fa44f480b893fc5',
          content:
            '일단 톡딜사상 가장 빠른 배송이었어요\n어제 저녁 5시넘어 결재했는데\n오늘낮12시도 되기전에 도착했어요\n\n한번 사볼까말까 망설이던 중에 톡딜에 올라와서 주문\n도착하자마자\n점심 식사로 먹었어요\n주말이라\n우동끓이고\n저랑 신랑은 김치치즈\n딸은 참치마요\n\n에어프라이어 에 하니 \n겉은 누룽지 느낌\n안은 촉촉 맛나넹ᆢ',
          productRating: 4,
          deliveryRating: 4,
          productStarRating: 4,
          deliveryStarRating: 4,
          best: true,
          writer: '김유*',
          imageUrl: 'https://st.kakaocdn.net/thumb/S70x70/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fdefault%2Ffriends%2Fv2%2F6.png&scode=shoppingstore',
          backgroundColor: '#cbb7c3',
        },
        {
          id: '641d89163021da5972ab13eb',
          content:
            '배송은 빠름 \n햇반으로 만든 오쿠~ 다 떨어져서 주문했어요.\n맛은 조금 이전에 먹었던 제품보다 밥맛은 떨어진다고 아들이 그래요. 근데 가격대비 괜찮습니다.\n포장도 잘 왔구 빠르게 도착했습니다.',
          productRating: 4,
          deliveryRating: 4,
          productStarRating: 4,
          deliveryStarRating: 4,
          best: true,
          writer: 'Ki**********',
          imageUrl: 'https://st.kakaocdn.net/thumb/S70x70/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fdefault%2Ffriends%2Fv2%2F8.png&scode=shoppingstore',
          backgroundColor: '#eec4c5',
        },
      ],
      qnaCount: 2186,
      reviewCount: 9155,
      averageRating: 4,
      totalProductStarRating: 4.0,
      totalDeliveryStarRating: 4.0,
      productPositivePercentage: 96,
      deliveryPositivePercentage: 95,
      productStar1Percentage: 2,
      productStar2Percentage: 2,
      productStar3Percentage: 12,
      productStar4Percentage: 84,
    },
    banners: [
      {
        id: 9521,
        name: '6/1 베이비위크 2탄',
        firstImageUrl: 'https://st.kakaocdn.net/shoppingstore/home/product_detail_banner/20230525141223_d110f92222634f1ab8f280a0f9e7391f.png',
        landingType: 'URL',
        landingUrl: 'https://pcms.kakao.com/pcms/documents/d1cd80af-bd5b-48b4-be95-56f217a3c993?ad=0601_befe_2_detailbanner',
        ad: false,
        remainSeconds: 203289,
      },
    ],
    sellerProductPoint: { sellerProductPurchasePointView: { unit: 'POINT', value: 100, point: 100 }, sellerProductReviewPointView: { value: 100, photoValue: 200, point: 300 } },
  },
  247087647: {
    name: '반스 스니커즈 20종 모음전',
    image: {
      imageRatio: 'SQUARE',
      images: ['https://st.kakaocdn.net/thumb/P750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230503113855_63af65cc961c4054855538dee4a38858.jpg'],
      sharingImageUrl: 'https://st.kakaocdn.net/shoppingstore/product/20230503113855_63af65cc961c4054855538dee4a38858.jpg',
    },
    status: 'ON_SALE',
    description:
      '<html>\n <head></head>\n <body>\n  <center> \n   <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230424175416_966dc6850ff14e7fa2f73e10af7d0fda.jpg" data-origin-url="http://images.istockmall.com/data2/top/vans_top.jpg"> \n   <center> \n    <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230424175419_11e288e7ec1645b4984ce528e3880355.jpg" data-origin-url="http://images.istockmall.com/data2/1team/kakaotalkdeal-230424.jpg"> \n    <center> \n     <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230424175420_f6b7ecaa6171426cbe304f96540695eb.jpg" data-origin-url="http://images.istockmall.com/data2/jun/11st/N1.jpg"> \n     <center> \n      <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230424175420_ea8fea7cfa7242e18f4aa066a800c4da.jpg" data-origin-url="http://images.istockmall.com/data2/1team/VN0A5KRD8DB1.jpg"> \n      <center> \n       <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230424175420_9144450b6da443729bc1d0e95f8b2e22.jpg" data-origin-url="http://images.istockmall.com/data2/jun/11st/N2.jpg"> \n       <center> \n        <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230424175420_078cff06cb95451fb06a277186a3e50a.jpg" data-origin-url="http://images.istockmall.com/data2/1team/VN0A54F14FV1.jpg"> \n        <center> \n         <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230424175421_913e0c50a71f4ca8b248a88086299945.jpg" data-origin-url="http://images.istockmall.com/data2/jun/11st/N3.jpg"> \n         <center> \n          <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230424175422_4f28e3526dd04dc88a26fb4aa26d4552.jpg" data-origin-url="http://images.istockmall.com/data2/1team/VN0A54F14FW1.jpg"> \n          <center> \n           <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230424175422_eec6c4d202ea44948cceb186fc89c172.jpg" data-origin-url="http://images.istockmall.com/data2/jun/11st/N4.jpg"> \n           <center> \n            <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230424175423_8062f602940d4c4293861c9bdb5a15d6.jpg" data-origin-url="http://images.istockmall.com/data2/1team/VN0A54F144B1.jpg"> \n            <center> \n             <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230424175423_dd99389b1a6047108c11b6b53e1ea3f4.jpg" data-origin-url="http://images.istockmall.com/data2/jun/11st/N5.jpg"> \n             <center> \n              <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230424175423_01a165dd1d364df5b58cc1cd652d6e16.jpg" data-origin-url="http://images.istockmall.com/data2/1team/VN0A33TB44B1.jpg"> \n              <center> \n               <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230424175424_b903d46b69764c6aaec4eec9529a773b.jpg" data-origin-url="http://images.istockmall.com/data2/jun/11st/N6.jpg"> \n               <center> \n                <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230424175424_4c032e1a91ac4e35bbb9e0d8b28f2c45.jpg" data-origin-url="http://images.istockmall.com/data2/1team/VN0A33TB3WJ1.jpg"> \n                <center> \n                 <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230424175425_d358fc5b259b4b819c428806edf6b581.jpg" data-origin-url="http://images.istockmall.com/data2/jun/11st/N7.jpg"> \n                 <center> \n                  <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230424175425_e0183d9a20874d048f3e0942352bad36.jpg" data-origin-url="http://images.istockmall.com/data2/1team/VN000XG88MZ1.jpg"> \n                  <center> \n                   <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230424175425_05e3ac72df67436dacb776156e2db9f3.jpg" data-origin-url="http://images.istockmall.com/data2/jun/11st/N8.jpg"> \n                   <center> \n                    <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230424175425_6c9fe1a6c34c45ac8d295ed90446c5cd.jpg" data-origin-url="http://images.istockmall.com/data2/1team/VN0A5KRD8D81.jpg"> \n                    <center> \n                     <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230424175426_9ab85fcd2c4e41ba89d66d87dcc1a6dc.jpg" data-origin-url="http://images.istockmall.com/data2/jun/11st/N9.jpg"> \n                     <center> \n                      <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230424175426_b677743f645a48d5a0a6053b0e7982f7.jpg" data-origin-url="http://images.istockmall.com/data2/1team/VN0A5KXA9GY1.jpg"> \n                      <center> \n                       <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230424175427_af0cb0df96aa4cb6bc4e48bb67856ec2.jpg" data-origin-url="http://images.istockmall.com/data2/jun/11st/N10.jpg"> \n                       <center> \n                        <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230424175427_20e8b9994c8740d9b5b367dc442eaea8.jpg" data-origin-url="http://images.istockmall.com/data2/1team/VN0A7Q2JBCK1.jpg"> \n                        <center> \n                         <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230424175427_2047a2ea122447188cd7cc0b87507336.jpg" data-origin-url="http://images.istockmall.com/data2/jun/11st/N11.jpg"> \n                         <center> \n                          <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230424175428_2564528734ca4befb1da0158cba3c505.jpg" data-origin-url="http://images.istockmall.com/data2/1team/VN0A54F6A6A1.jpg"> \n                          <center> \n                           <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230424175428_2d5282e3653f4d2da5545ad420ea2ba0.jpg" data-origin-url="http://images.istockmall.com/data2/jun/11st/N12.jpg"> \n                           <center> \n                            <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230424175428_4870c3f8dfcd42fb87c3873404d21946.jpg" data-origin-url="http://images.istockmall.com/data2/1team/VN0A54F6A6B1.jpg"> \n                            <center> \n                             <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230424175429_9322fef341254cc5b294d2a16b2fd382.jpg" data-origin-url="http://images.istockmall.com/data2/jun/11st/N13.jpg"> \n                             <center> \n                              <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230424175429_a0d8aace051446e684daffcb717a83bf.jpg" data-origin-url="http://images.istockmall.com/data2/1team/VN0A54F6A6C1.jpg"> \n                              <center> \n                              <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230424175429_8d12b7f70d7b477cabb9eba4ee9bcd7a.jpg" data-origin-url="http://images.istockmall.com/data2/jun/11st/N14.jpg"> \n                              <center> \n                              <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230424175430_a1485da086da4d1e897272928e76cf76.jpg" data-origin-url="http://images.istockmall.com/data2/1team/VN0A5JMI8DB1.jpg"> \n                              <center> \n                              <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230424175430_16fce1b9dac24122abeeca2434500cc7.jpg" data-origin-url="http://images.istockmall.com/data2/jun/11st/N15.jpg"> \n                              <center> \n                              <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230424175430_9b484448fe4948268a3ef7512cb85c4e.jpg" data-origin-url="http://images.istockmall.com/data2/1team/VN0A54F98F91.jpg"> \n                              <center> \n                              <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230424175431_7a4b8afff50242db976c4ba0ad45f3f5.jpg" data-origin-url="http://images.istockmall.com/data2/jun/11st/N16.jpg"> \n                              <center> \n                              <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230424175431_df7ac7390b574e2aa0d9ef046d9f3846.jpg" data-origin-url="http://images.istockmall.com/data2/1team/VN0A54F98FK1.jpg"> \n                              <center> \n                              <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230424175431_5b1a8606b9b44bffa61b39167cb24a4c.jpg" data-origin-url="http://images.istockmall.com/data2/jun/11st/N17.jpg"> \n                              <center> \n                              <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230424175431_c5858f6abb0144ca880a0c2cb7aa1778.jpg" data-origin-url="http://images.istockmall.com/data2/1team/VN0A5KX99GY1.jpg"> \n                              <center> \n                              <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230424175432_a7e76e5d40714b17b7de5ec5ce65fea5.jpg" data-origin-url="http://images.istockmall.com/data2/jun/11st/N18.jpg"> \n                              <center> \n                              <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230424175432_abe7fad2a15840049b0049d251260a08.jpg" data-origin-url="http://images.istockmall.com/data2/1team/VN0A5KX48EK1.jpg"> \n                              <center> \n                              <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230424175432_b67158c71352482d8654e8ba8ac5aceb.jpg" data-origin-url="http://images.istockmall.com/data2/jun/11st/N19.jpg"> \n                              <center> \n                              <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230424175433_0b1a55e683874c2980320c574ac16fc9.jpg" data-origin-url="http://images.istockmall.com/data2/1team/VN0A5I12A041.jpg"> \n                              <center> \n                              <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230424175433_03c97eb802f54d53b60a509bfb8986f3.jpg" data-origin-url="http://images.istockmall.com/data2/jun/11st/N20.jpg"> \n                              <center> \n                              <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230424175433_f257d343fbc94fdd92f73b12f3c5110a.jpg" data-origin-url="http://images.istockmall.com/data2/1team/VN0A54FBA5J1.jpg"> \n                              <center> \n                              <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230424175434_e0412556b1884598b4dc182dd943d4bf.jpg" data-origin-url="http://images.istockmall.com/data2/top/vans_notice.jpg"> \n                              <br> \n                              <br> \n                              <br> \n                              </center> \n                              </center> \n                              </center> \n                              </center> \n                              </center> \n                              </center> \n                              </center> \n                              </center> \n                              </center> \n                              </center> \n                              </center> \n                              </center> \n                              </center> \n                              </center> \n                              </center> \n                             </center> \n                            </center> \n                           </center> \n                          </center> \n                         </center> \n                        </center> \n                       </center> \n                      </center> \n                     </center> \n                    </center> \n                   </center> \n                  </center> \n                 </center> \n                </center> \n               </center> \n              </center> \n             </center> \n            </center> \n           </center> \n          </center> \n         </center> \n        </center> \n       </center> \n      </center> \n     </center> \n    </center> \n   </center> \n  </center>\n </body>\n</html>',
    instantOrder: false,
    talkDeal: {
      id: 3260683,
      status: 'AFTER_SALE',
      groupSize: 1,
      period: { from: '20230506170000', to: '20230509235959' },
      ongoingRoomCount: 0,
      discountPrice: 39100,
      discountRate: 49.0,
    },
    benefits: [],
    delivery: {
      deliveryMethodType: 'DELIVERY',
      optionalDeliveries: [],
      deliveryFeeType: 'FREE',
      deliveryFeePaymentType: 'PREPAID',
      deliveryFee: 0,
      freeConditionalAmount: 50000,
      bundleGroupAvailable: true,
      isolatedAreaAdditionalFee: 3000,
      jejuAreaAdditionalFee: 3000,
      availableIsolatedArea: true,
    },
    taxDeduction: false,
    gift: { gift: '' },
    quantity: { minPurchase: 1, maxPurchase: 0, maxPurchaseOfBuyer: 0 },
    adultOnly: false,
    isLiquor: false,
    minorPurchasable: true,
    booked: { booked: false },
    notices: [],
    reviewUnexposed: false,
    favorite: false,
    reviewCreatable: false,
    store: {
      id: 40714,
      name: '아이스탁몰',
      domain: 'istockmall',
      farmer: false,
      coverImage: 'https://st.kakaocdn.net/shoppingstore/store/20200617180735_af0796a7350e464d9e319a115c02a765.jpg',
      profileImage: 'https://st.kakaocdn.net/shoppingstore/store/20200515131237_23adae4cca2c42a0800ed3ed5e5cc168.jpeg',
      channelName: '아이스탁몰',
      channelUrl: 'http://pf.kakao.com/_zmKFj',
      subscribed: false,
      fresh: false,
      trackId: '1463847132807741383',
    },
    category: { id: '101108104101', name: '캐주얼운동화' },
    price: {
      standardPrice: 79000,
      discountedPrice: 79000,
      discountRate: 0.0,
      minDiscountedPrice: 69000,
      maxDiscountedPrice: 92000,
      totalDiscountedPrice: 79000,
    },
    events: [],
    review: {
      topReviews: [
        {
          id: '645a00c9889d6b08be01bab0',
          content: '실물 색상도 촌스럽지 않고 이뻐요~\n저렴하게 넘 잘샀어요~잘신을게요^^',
          productRating: 4,
          deliveryRating: 4,
          productStarRating: 4,
          deliveryStarRating: 4,
          best: true,
          writer: '김민*',
          imageUrl: 'https://st.kakaocdn.net/thumb/S70x70/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fdefault%2Ffriends%2Fv2%2F10.png&scode=shoppingstore',
          backgroundColor: '#f5e7d9',
        },
        {
          id: '645a0a49854d704cc92a27e0',
          content: '신발 딱 맞아오',
          productRating: 4,
          deliveryRating: 4,
          productStarRating: 4,
          deliveryStarRating: 4,
          best: true,
          writer: 'S*',
          imageUrl: 'https://st.kakaocdn.net/thumb/S70x70/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fdefault%2Ffriends%2Fv2%2F3.png&scode=shoppingstore',
          backgroundColor: '#cbb7c3',
        },
        {
          id: '645a18b37ec91e43ea05c07b',
          content: '색감이 생각보다 쨍하지만 이쁘네요!',
          productRating: 4,
          deliveryRating: 4,
          productStarRating: 4,
          deliveryStarRating: 4,
          best: true,
          writer: 'Re********',
          imageUrl: 'https://st.kakaocdn.net/thumb/S70x70/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fdefault%2Ffriends%2Fv2%2F8.png&scode=shoppingstore',
          backgroundColor: '#e7eded',
        },
      ],
      qnaCount: 61,
      reviewCount: 14,
      averageRating: 4,
      totalProductStarRating: 4.0,
      totalDeliveryStarRating: 4.0,
      productPositivePercentage: 100,
      deliveryPositivePercentage: 100,
      productStar1Percentage: 0,
      productStar2Percentage: 0,
      productStar3Percentage: 7,
      productStar4Percentage: 93,
    },
    banners: [],
    sellerProductPoint: {},
  },
  247868049: {
    name: '목우촌 한우 인삼갈비탕 700gX4개',
    image: {
      imageRatio: 'SQUARE',
      images: [
        'https://st.kakaocdn.net/thumb/P750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230427145426_080e14bb1d234597a2f468afde015a50.jpg',
        'https://st.kakaocdn.net/thumb/P750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230118134145_ffa52d5b870f41ffaf051aa75b03728b.jpg',
        'https://st.kakaocdn.net/thumb/P750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230221112325_a27fc2fc0ea14f5bbe65bc7018dde2d9.jpg',
        'https://st.kakaocdn.net/thumb/P750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230427135333_b030cb287070466e8ae2bb18fefac353.jpg',
        'https://st.kakaocdn.net/thumb/P750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230427135543_9583df9a08f64924bed3fa23ddf91871.jpg',
      ],
      sharingImageUrl: 'https://st.kakaocdn.net/shoppingstore/product/20230427145426_080e14bb1d234597a2f468afde015a50.jpg',
    },
    status: 'ON_SALE',
    description:
      '<html>\n <head></head>\n <body>\n  <p><img src="https://st.kakaocdn.net/shoppingstore/editor/20210514160720_b4e7bf3cc80f4e1a9d42419803cd0cb8.jpeg"><!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_900_971") --><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230510082042_3cff0871b68941d493bbaff88fdc732b.jpg"><!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_900_1943") --><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230502173145_ec3e4f2f7bb24836b34dd17cc69b0511.jpg"></p> \n  <p><!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_900_9418") --><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230427154051_3d568758f5274823be814293f498ecf6.jpg"><!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_900_10973") --><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230118134957_2c4d80fb6a414ce8903813d829fe344c.jpg"><!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_900_10973") --><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230118134334_602453a0473a48dcbbe59c885d05c308.png"></p> \n  <p><!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_900_10973") --><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230221112917_0c8398a2c28c450e973cd2ea40c46230.png"><!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_900_10973") --><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230427135705_ab9515f82af546458f15ad5c6521825c.png"><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20220426140617_da31e47d0ad14da2ac037615f4b21d9e.jpg"></p>\n </body>\n</html>',
    instantOrder: false,
    talkDeal: {
      id: 3305845,
      status: 'AFTER_SALE',
      groupSize: 1,
      period: { from: '20230508094528', to: '20230509235959' },
      ongoingRoomCount: 0,
      discountPrice: 31000,
      discountRate: 51.0,
    },
    benefits: [
      {
        description: '카카오페이 머니로 3만원 이상 결제 시 카카오페이 포인트 2천원 적립 (5/8~5/17, 일부 상품 대상 제외, 인당 1회)',
        landingUrl: 'https://store.kakao.com/mypage/notice/119',
        value: '',
      },
    ],
    delivery: {
      deliveryMethodType: 'DELIVERY',
      optionalDeliveries: [],
      deliveryFeeType: 'FREE',
      deliveryFeePaymentType: 'PREPAID',
      deliveryFee: 0,
      freeConditionalAmount: 40000,
      bundleGroupAvailable: true,
      availableIsolatedArea: false,
    },
    originArea: { type: '혼합/기타', content: '상세설명에 표시', others: false },
    taxDeduction: false,
    gift: { gift: '' },
    quantity: { minPurchase: 1, maxPurchase: 0, maxPurchaseOfBuyer: 0 },
    adultOnly: false,
    isLiquor: false,
    minorPurchasable: true,
    booked: { booked: false },
    notices: [
      {
        id: 53429,
        title: '구매전 확인 안내',
        wholeNotice: true,
        content: '<p><img data-animated="false" src="https://st.kakaocdn.net/shoppingstore/editor/20220701165331_036d9933e4184898919260a1fd1e5535.jpg" /></p>\n',
        createdAt: '20220608181059',
      },
    ],
    reviewUnexposed: false,
    favorite: false,
    reviewCreatable: false,
    store: {
      id: 69747,
      name: '목우촌',
      domain: 'moguchon',
      farmer: false,
      coverImage: 'https://st.kakaocdn.net/shoppingstore/store/20210517102210_95f070dc89984471980364f228502a29.jpg',
      profileImage: 'https://st.kakaocdn.net/shoppingstore/store/20220620195113_0e4200b7122945598f61132ce4e0ea0e.jpg',
      consultId: '@농협목우촌',
      channelName: '농협목우촌',
      channelUrl: 'http://pf.kakao.com/_CsnXj',
      subscribed: false,
      fresh: false,
      trackId: '1726756183548867528',
    },
    category: { id: '102100100112', name: '국/탕/찌개' },
    price: {
      standardPrice: 59900,
      discountedPrice: 59900,
      discountRate: 0.0,
      minDiscountedPrice: 44900,
      maxDiscountedPrice: 59900,
      totalDiscountedPrice: 59900,
    },
    events: [],
    review: {
      topReviews: [
        {
          id: '645a194afab12f7be05bd0b0',
          content: '진심 맛있어요 ~국물이 조미료 맛 않나고 깔끔하니 진하고 고기도 부드러워요 갈비탕 맛집보다 국물맛이 더 깔끔하고 맛다는 가족들 평이에요',
          productRating: 4,
          deliveryRating: 4,
          productStarRating: 4,
          deliveryStarRating: 4,
          best: true,
          writer: '임*',
          imageUrl: 'https://st.kakaocdn.net/thumb/S70x70/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fdefault%2Ffriends%2Fv2%2F3.png&scode=shoppingstore',
          backgroundColor: '#eec4c5',
        },
        {
          id: '6459d97cfab12f7be05bd05f',
          content: '목우촌은 사랑입니다~맛있게  잘  먹겠습니다 ~^^',
          productRating: 4,
          deliveryRating: 4,
          productStarRating: 4,
          deliveryStarRating: 4,
          best: true,
          writer: '박은****',
          imageUrl: 'https://st.kakaocdn.net/thumb/S70x70/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fdefault%2Ffriends%2Fv2%2F3.png&scode=shoppingstore',
          backgroundColor: '#f5e7d9',
        },
        {
          id: '6459fc3e46eead337f0c3684',
          content: '♡^^♡  구성이 아주 풍성하내요',
          productRating: 4,
          deliveryRating: 4,
          productStarRating: 4,
          deliveryStarRating: 4,
          best: true,
          writer: '야누*****',
          imageUrl: 'https://st.kakaocdn.net/thumb/S70x70/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fdefault%2Ffriends%2Fv2%2F3.png&scode=shoppingstore',
          backgroundColor: '#f5e7d9',
        },
      ],
      qnaCount: 39,
      reviewCount: 66,
      averageRating: 4,
      totalProductStarRating: 4.0,
      totalDeliveryStarRating: 4.0,
      productPositivePercentage: 92,
      deliveryPositivePercentage: 95,
      productStar1Percentage: 2,
      productStar2Percentage: 6,
      productStar3Percentage: 23,
      productStar4Percentage: 70,
    },
    banners: [],
    sellerProductPoint: {},
  },
  90836953: {
    name: '클리엔 R9 로봇청소기',
    image: {
      imageRatio: 'SQUARE',
      images: [
        'https://st.kakaocdn.net/thumb/P750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230503120952_8040d7bf834c4860b2bb74a01f990825.jpg',
        'https://st.kakaocdn.net/thumb/P750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230503120839_b53909b364b44297acc338fe2bf24033.jpg',
        'https://st.kakaocdn.net/thumb/P750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230503120902_6e8466aca6754fe1b8eb49fa94ba9ea1.jpg',
        'https://st.kakaocdn.net/thumb/P750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230503120143_0da15787b864487d8aa5f687a2759bcc.jpg',
        'https://st.kakaocdn.net/thumb/P750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20210427181225_38457225191347a68705ab52a3a5db82.jpg',
        'https://st.kakaocdn.net/thumb/P750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20210427181229_a378e31127a24c209cfde5db5c4a04f6.jpg',
      ],
      sharingImageUrl: 'https://st.kakaocdn.net/shoppingstore/product/20230503120952_8040d7bf834c4860b2bb74a01f990825.jpg',
    },
    status: 'ON_SALE',
    description:
      '<html>\n <head></head>\n <body>\n  <p class="MsoNormal" style="line-height: normal; word-break: keep-all; text-align: center;"><span lang="EN-US" style="font-size:12.0pt;font-family:굴림;mso-bidi-font-family:굴림;mso-font-kerning: 0pt"> \n    <blocking_o:p>\n      &nbsp; \n    </blocking_o:p> \n    <blocking_o:p> \n    </blocking_o:p></span></p> \n  <p class="MsoNormal" style="text-align: center;"><img data-origin-url="https://gi.esmplus.com/wellsing/2022/clien/coupang/220630/0A_notice.jpg" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230125104912_4d13d9df93ea42518d1290ecc1997fbc.jpg"><br> <br> <img data-origin-url="https://gi.esmplus.com/wellsing/2022/clien/coupang/220630/0C_delivery.jpg" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230125104912_d9041cf03063459ca3633969dc559a04.jpg"><br> <img data-origin-url="https://gi.esmplus.com/wellsing/2022/clien/coupang/220630/0D_soldout.jpg" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230125104912_b451c776eac045e4881ccf06d92bb9c9.jpg"><br> <img data-origin-url="https://gi.esmplus.com/wellsing/2022/clien/coupang/220630/1.jpg" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230125104913_6aaa24947ff640258a0c6a92650fe442.jpg"><br> <img data-origin-url="https://gi.esmplus.com/wellsing/2022/clien/11st/220630/0F_blank.jpg" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230125104913_88a9c5b3af3b4bfba21c77735ec75209.jpg"></p> \n  <p style="text-align: center;"><!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_860_3603") --><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230503094950_6edf067f3ffb4f86b9155f6939e76db4.jpg"><br> <br> <img data-origin-url="https://gi.esmplus.com/wellsing/2022/clien/coupang/220630/3_1.jpg" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230125104915_7a0fa451a01b471194359e48592f37c9.jpg"><br> <img data-origin-url="https://gi.esmplus.com/wellsing/2022/clien/11st/220630/4_2.gif" src="https://st.kakaocdn.net/shoppingstore/editor/20230125104915_df05a771e6104b1ab67d8952fb36c0a8.jpeg"><br> <img data-origin-url="https://gi.esmplus.com/wellsing/2022/clien/coupang/220630/221209_1.jpg" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230125104917_df78be1d243445928d306de9c429821a.jpg"><br> <img data-origin-url="https://gi.esmplus.com/wellsing/2022/clien/coupang/220630/221209_2.gif" src="https://st.kakaocdn.net/shoppingstore/editor/20230125104917_8f6af05b9d3e45aa8860c3e8c0ff40ce.jpeg"><br> <img data-origin-url="https://gi.esmplus.com/wellsing/2022/clien/coupang/220630/0F_blank2.jpg" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230125104918_2a9b346ceb7c4e5e8dbdd71c26af37a7.jpg"><br> <img data-origin-url="https://gi.esmplus.com/wellsing/2022/clien/11st/220630/7.jpg" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230125104918_dab282b632b54f16bc55d6884d8af835.jpg"><br> <img data-origin-url="https://gi.esmplus.com/wellsing/2022/clien/11st/220630/8.jpg" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230125104919_e8a97d16e91c4679909f36b8d1688286.jpg"><br> <img data-origin-url="https://gi.esmplus.com/wellsing/2022/clien/coupang/220630/6.jpg" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230125104919_30d66d55a7244ef081c2044b1e670da9.jpg"><br> <img data-origin-url="https://gi.esmplus.com/wellsing/2022/clien/coupang/220630/7.jpg" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230125104919_c8a603d39fca41f28567636acddac314.jpg"><br> <img data-origin-url="https://gi.esmplus.com/wellsing/2022/clien/coupang/220630/8_1.jpg" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230125104919_c7b97d1951674e8e8028945b3b8fc7b0.jpg"></p> \n  <center> \n   <p style="text-align: center;"><a><!-- Not Allowed Attribute Filtered ( alt="8-2-clien" border="0") --><img data-origin-url="https://i.ibb.co/RN9xkCr/8-2-clien.jpg" src="https://st.kakaocdn.net/shoppingstore/editor/20230125104920_b01dd98fb7494bfe994c667656caa630.jpg"></a></p> \n  </center> \n  <p style="text-align: center;"><img data-origin-url="https://gi.esmplus.com/wellsing/2022/clien/coupang/220630/8_3.jpg" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230125104924_02e77abd918a4688b076e1916aab2e9b.jpg"></p> \n  <center> \n   <p style="text-align: center;"><a><!-- Not Allowed Attribute Filtered ( alt="8-4-clien" border="0") --><img data-origin-url="https://i.ibb.co/hdrCLKP/8-4-clien.jpg" src="https://st.kakaocdn.net/shoppingstore/editor/20230125104924_88dc1bfcb5dd42e68a9da87ab5652e55.jpg"></a></p> \n  </center> \n  <p style="text-align: center;"><img data-origin-url="https://gi.esmplus.com/wellsing/2022/clien/coupang/220630/8_5.jpg" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230125104928_39deb740497748409842fe75b938a654.jpg"><br> <img data-origin-url="https://gi.esmplus.com/wellsing/2022/clien/coupang/220630/8_6.jpg" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230125104928_4a288f4b5f1a4035ac43870d64025004.jpg"><br> <img data-origin-url="https://gi.esmplus.com/wellsing/2022/clien/coupang/220630/8_7.jpg" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230125104928_d1a2e3ca63734d86bb0a61d8817fd1e5.jpg"><br> <img data-origin-url="https://gi.esmplus.com/wellsing/2022/clien/coupang/220630/9.jpg" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230125104929_1058c9f114874753a5e5ec757fe29219.jpg"><br> <img data-origin-url="https://gi.esmplus.com/wellsing/2022/clien/coupang/220630/10_1.jpg" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230125104929_7b7bd6678be44d3c93e764ff83c66bfe.jpg"></p> \n  <center> \n   <p style="text-align: center;"><a><!-- Not Allowed Attribute Filtered ( alt="10-2-clien" border="0") --><img data-origin-url="https://i.ibb.co/pw1Gwh4/10-2-clien.jpg" src="https://st.kakaocdn.net/shoppingstore/editor/20230125104930_de72d94e44034ddb8f9ab084cf08cd24.jpg"></a></p> \n  </center> \n  <p style="text-align: center;"><img data-origin-url="https://gi.esmplus.com/wellsing/2022/clien/coupang/220630/10_3.jpg" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230125104933_0e821900fe554583a1232ccf4a081047.jpg"></p> \n  <center> \n   <p style="text-align: center;"><a><!-- Not Allowed Attribute Filtered ( alt="10-4-clien" border="0") --><img data-origin-url="https://i.ibb.co/n6yRbD1/10-4-clien.jpg" src="https://st.kakaocdn.net/shoppingstore/editor/20230125104933_26d011af74c04b429c300f190bfa8b5f.jpg"></a></p> \n  </center> \n  <p style="text-align: center;"><img data-origin-url="https://gi.esmplus.com/wellsing/2022/clien/coupang/220630/10_5.jpg" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230125104938_0906182aa3c1422180dd62c3c0cd4f83.jpg"></p> \n  <center> \n   <p style="text-align: center;"><a><!-- Not Allowed Attribute Filtered ( alt="10-6-clien" border="0") --><img data-origin-url="https://i.ibb.co/qyFnNTQ/10-6-clien.jpg" src="https://st.kakaocdn.net/shoppingstore/editor/20230322165019_9e677204c5fc4a6e9b587a3e6fde52a7.jpg"></a></p> \n  </center> \n  <p style="text-align: center;"><img data-origin-url="https://gi.esmplus.com/wellsing/2022/clien/coupang/220630/10_7.jpg" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230125104946_373223caef764986b37f8099ce8ec392.jpg"></p> \n  <center> \n   <p style="text-align: center;"><a><!-- Not Allowed Attribute Filtered ( alt="10-8" border="0") --><img data-origin-url="https://i.ibb.co/prjcqjc/10-8.jpg" src="https://st.kakaocdn.net/shoppingstore/editor/20230125104947_9073338c091d4a76b39ae40df7725fe3.jpg"></a></p> \n  </center> \n  <p style="text-align: center;"><img data-origin-url="https://gi.esmplus.com/wellsing/2022/clien/coupang/220630/10_9.jpg" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230125104948_cd701a15d5f54fd794f8e9d8f6b5b85b.jpg"></p> \n  <center> \n   <p style="text-align: center;"><a><!-- Not Allowed Attribute Filtered ( alt="10-10" border="0") --><img data-origin-url="https://i.ibb.co/jZ5tV0D/10-10.jpg" src="https://st.kakaocdn.net/shoppingstore/editor/20230125104949_2714956d47cf40dea377c78767c2bb2a.jpg"></a></p> \n  </center> \n  <p style="text-align: center;"><img data-origin-url="https://gi.esmplus.com/wellsing/2022/clien/coupang/220630/10_11.jpg" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230125104953_de9782691b9b426fbbd9be47b7bf57e3.jpg"><br> <img data-origin-url="https://gi.esmplus.com/wellsing/2022/clien/coupang/220630/11_1.jpg" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230125104953_bd46e09294564bb8a7f3025f9860864f.jpg"></p> \n  <center> \n   <p style="text-align: center;"><a><!-- Not Allowed Attribute Filtered ( alt="11-2" border="0") --><img data-origin-url="https://i.ibb.co/HHhpgCC/11-2.jpg" src="https://st.kakaocdn.net/shoppingstore/editor/20230125104953_a68e6e4d279c4581865795614da70944.jpg"></a></p> \n  </center> \n  <p style="text-align: center;"><img data-origin-url="https://gi.esmplus.com/wellsing/2022/clien/coupang/220630/11_3.jpg" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230125104957_ba0143f0405d471a8857ecbe2f321f64.jpg"></p> \n  <center> \n   <p style="text-align: center;"><a><!-- Not Allowed Attribute Filtered ( alt="11-4" border="0") --><img data-origin-url="https://i.ibb.co/Y2Z2rYQ/11-4.jpg" src="https://st.kakaocdn.net/shoppingstore/editor/20230125104958_7158fec3c8874cd19d3bbc75715c5066.jpg"></a></p> \n  </center> \n  <p style="text-align: center;"><img data-origin-url="https://gi.esmplus.com/wellsing/2022/clien/coupang/220630/11_5.jpg" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230125105001_c9d1d531eeb04746b641ad4558cd0362.jpg"></p> \n  <center> \n   <p style="text-align: center;"><a><!-- Not Allowed Attribute Filtered ( alt="11-6" border="0") --><img data-origin-url="https://i.ibb.co/7GLHKz2/11-6.jpg" src="https://st.kakaocdn.net/shoppingstore/editor/20230125105001_91fa34334cca4b72973d14d3596d7e73.jpg"></a></p> \n  </center> \n  <p style="text-align: center;"><img data-origin-url="https://gi.esmplus.com/wellsing/2022/clien/coupang/220630/11_7.jpg" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230125105007_a175c1ebc7e64832bc786f06d3612c1d.jpg"><br> <img data-origin-url="https://gi.esmplus.com/wellsing/2022/clien/coupang/220630/12.jpg" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230125105007_c365110727e844cebbf7e746a6f6e5fe.jpg"><br> <img data-origin-url="https://gi.esmplus.com/wellsing/2022/clien/coupang/220630/13.jpg" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230125105008_9ab8d58b756b42fb8dafa49258a6a82d.jpg"><br> <img data-origin-url="https://gi.esmplus.com/wellsing/2022/clien/coupang/220630/0F_blank2.jpg" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230125105008_bf4c9ebbbedd44a78a688c705e22d8e6.jpg"><br> <br> <br> <img data-origin-url="https://gi.esmplus.com/wellsing/2022/clien/coupang/220630/0G_dot.jpg" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230125105009_435aadc2d1924f21b4dcc85b9ec0b824.jpg"><br> <img data-origin-url="https://gi.esmplus.com/wellsing/2022/clien/coupang/220630/spec.jpg" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230125105009_863bb908db8c40aa9e65382eabc4c1a5.jpg"><br> <img data-origin-url="https://gi.esmplus.com/wellsing/2022/clien/coupang/220630/0A_notice1.jpg" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230125105009_5bb5e9319cba41cca20ac17b09dacbca.jpg"></p>\n </body>\n</html>',
    instantOrder: false,
    talkDeal: {
      id: 3259801,
      status: 'AFTER_SALE',
      groupSize: 1,
      period: { from: '20230506170000', to: '20230509235959' },
      ongoingRoomCount: 0,
      discountPrice: 430000,
      discountRate: 53.0,
    },
    benefits: [
      {
        description: '카카오페이 머니로 3만원 이상 결제 시 카카오페이 포인트 2천원 적립 (5/8~5/17, 일부 상품 대상 제외, 인당 1회)',
        landingUrl: 'https://store.kakao.com/mypage/notice/119',
        value: '',
      },
    ],
    delivery: {
      deliveryMethodType: 'DELIVERY',
      optionalDeliveries: [],
      deliveryFeeType: 'FREE',
      deliveryFeePaymentType: 'PREPAID',
      deliveryFee: 0,
      freeConditionalAmount: 0,
      repeatQuantity: 0,
      bundleGroupAvailable: true,
      availableIsolatedArea: true,
    },
    taxDeduction: false,
    gift: { gift: '' },
    quantity: { minPurchase: 0, maxPurchase: 1, maxPurchaseOfBuyer: 999 },
    adultOnly: false,
    isLiquor: false,
    minorPurchasable: true,
    booked: { booked: false },
    notices: [],
    reviewUnexposed: false,
    favorite: false,
    reviewCreatable: false,
    store: {
      id: 66388,
      name: '클리엔',
      domain: 'clien',
      farmer: false,
      coverImage: 'https://st.kakaocdn.net/shoppingstore/default/cover/01.png',
      profileImage: 'https://st.kakaocdn.net/shoppingstore/store/20210405180300_b5ab0f7204284d0293497ce4f33c7882.jpeg',
      consultId: '@클리엔',
      channelName: '클리엔',
      channelUrl: 'http://pf.kakao.com/_xdhEvK',
      subscribed: false,
      fresh: false,
      trackId: '4015756886542694813',
    },
    category: { id: '100103102101', name: '로봇청소기' },
    price: {
      standardPrice: 799000,
      discountedPrice: 799000,
      discountRate: 0.0,
      minDiscountedPrice: 799000,
      maxDiscountedPrice: 829000,
      totalDiscountedPrice: 799000,
    },
    events: [],
    review: {
      topReviews: [
        {
          id: '642c2e3d5c62894fcdbfb2b7',
          content:
            '* 이 제품에 대한 세부정보를 알리고자 청소시작영상, 청소진행영상, 충전복귀영상을 나누어 찍어놨는데, 영상이 올라가지 않아 부득이 사진만 올려둡니다.\n\n\n0. 기존 제품 사용 간단 후기 + 구매동기\n로봇청소기는 5년 전 LG사 제품을 2년간 사용하다가 장모님댁에서 필요하다 하셔서 드리고(새제품을 사드리고 싶었으나, 그 당시 가격압박이;;), 2년 전에 샤오미 제품을 구매하여 사용하고 있습니다. 제가 구매한 샤오미 제품은 중저가형이었는데, 전반적으로 흡입력이 약하고 물청소가 잘 안 된다는 게 단점이었습니다. 게다가 배터리 성능 및 흡입력이 현저하게 떨어져, 1주일에 한 번은 유선 진공청소기로 청소를 해왔는데요. 지난 주 헬스PT를 받다가 허리 디스크 상태가 악화되어 고심 끝에 새제품으로 바꾸기로 결심하였습니다. \n\n사실, 클리엔은 3달 전에 친구로부터 추천받은 브랜드였는데요. 당시 그 친구는 R9 제품을 갖고 있었는데, 만족도가 매우 높다며 클리엔 제품을 강력추천하더군요. 그래서 클리엔 제품을 구매하기로 결정하였고, T24와 R9 두 제품 중 저울질을 거듭하다 결국 가격문제 때문에 R9 제품으로 구매하게 되었습니다. \n\n\n1. 배송\n톡딜 종료 후 하루만에 배송이 되었습니다. 전북 지역에 거주 중인데, 지방임을 감안해볼 때 배송은 상당히 빠르게 진행되는 것 같았습니다.\n\n2. 언박싱\n배송완료 문자를 받고, 설레는 마음으로 집에 일찍 귀가하였습니다. 배송중 제품이 상하지 않게끔 꼼꼼하게 포장해주신 흔적이 역력했습니다.\n\n박스를 뜯고 제품 구성품을 하나하나 살펴보았는데, 특허받았다는 분섬사 물걸레 패드도 넉넉히 들어 있었고, 물통, 먼지통, 2in1(물통+먼지통) 구성품 모두 장착하는 데 어려움이 없었습니다. 로봇청소기는 어르신들 선물로도 많이 한다고 하는데, 어르신들이 비교적 쉽게 제품 구성품을 장착하고 분해하실 것 같습니다.\n\n첫 청소를 위해 사이드브러시와 2in1을 장착하였습니다. 와이파이 연결도 시도했는데요. 제 착오로 인해 2번 정도 오류를 경험한 것 빼고는 큰 불편함 없이 잘 연결할 수 있었습니다.\n\n  * 와이파이 연결하실 때, 와이파이 5g 혹은 &#39;모바일 데이터&#39;에 자동연결되지 않도록 유의하셔야 합니다. 그것만 아니면 와이파이 연결이 매끄럽게 됩니다\n\n\n3. 청소 능력(소음 정도 포함)\n청소 능력은 가히 훌륭합니다. 개인적으로는 네 가지 부분이 매우 만족스러웠는데요.\n\n첫째, 청소모드\n이 제품은 앱을 통해서 Y형 청소모드, 지그재그 청소모드를 자유롭게 선택할 수 있는데요. 저는 성능 체크를 위해 두 가지 모드를 다 활용해봤습니다.\n\n지그재그 청소모드는 예전에 썼던 LG사와 샤오미사 제품의 기본모드에 해당되는데, 그 제품들보다 전반적으로 기민하게 움직이는 것으로 보였습니다. 센서 능력이 출중해서인지, 거실 및 바닥에 놓인 장애물들을 잘 인지하고 회피하더군요. \n\n개인적으로는 Y형 청소모드가 궁금했는데요. 이미지에서 확인되는 바, 지그재그 모드보다 훨씬 꼼꼼하게 청소한다는 느낌을 받았습니다. 특별한 일이 없는 한, 평소에는 Y형 청소모드로 설정하고 쓸 것 같습니다.\n\n둘째, 흡입력 자동 변환\n제가 놀랐던 것은 일반 거실 바닥에서는 1단계의 흡입력을 보이다가, 카펫으로 올라가면 자동으로 3단계의 흡입력으로 전환한다는 것이었습니다. 지그재그 모드, Y형 모드 모두에서 그런 성능을 보여줬는데요. 가정 내에 카펫이 있거나, 반려동물을 키우시는 분들에게는 특히 매력을 느낄 수 있을 만한 요소라고 보여집니다.\n\n셋째, 물걸레질 성능\n저는 2주에 한번씩 비쎌 스팀청소기를 활용하여 물걸레질을 해왔습니다. 스팀청소를 하신 분들은 아시겠지만, 청소를 마친 후 바닥은 정말 뽀송해지거든요. 솔직히 스팀청소만큼의 성능은 아니지만, 이 제품의 물걸레질 성능은 상당히 좋아보였습니다. 이게 제품 자체의 성능 때문인지, 아니면 특허받았다는 &#39;분섬사 물걸레 패드&#39;(설명서에 그렇게 써 있더군요) 때문인지는 모르겠습니다만, 체감상 스팀청소 했을 때의 그 뽀송함 정도의 80% 정도는 되는 듯했습니다. 아마도 이 제품 덕택에 2주에 한 번 정도 했던 스팀 청소를 한 두달에 한 번으로 줄일 수 있을 것 같습니다.\n\n넷째, 소음 정도\n소음측정기 어플을 다운받아 로봇청소기의 소음을 측정해보았는데요. 휴대폰 어플로 측정한 것이라 다소 정확성이 떨어질 수 있지만, 제가 측정한 평균값은 다음과 같았습니다.\n\n[흡입력 1단계]\n ㅡ 로봇청소기 바로 옆에서 측정한 값 : 58~65db\n ㅡ 로봇청소기 옆에 서서 측정한 값 : 51~55db\n\n[흡입력 3단계]\n ㅡ 로봇청소기 바로 옆에서 측정한 값 : 71~77db\n ㅡ 로봇청소기 옆에 서서 측정한 값 : 64~69db\n\n아파트 기준으로 놓고 볼 때, 흡입력 3단계는 저녁 시간에 돌리기에는 아래층 눈치가 보일 듯합니다. 그러나 1단계는 새벽 시간만 아니라면(새벽에는 너무 고요해서윗집 샤워하는 소리도 들린다는;;;), 아래층 눈치보지 않고 사용할 수 있을 것 같습니다.\n\n\n4. 마무리\n별점 5점 중에서 5점을 주고 싶을 정도로 만족스러운 제품입니다. 클리엔 앱 다운받아서 와이파이 연결할 때 버벅인 것(사실 이건 기계치에 가까운 내 탓이 큽니다ㅠ), 청소 중에 Y형 청소모드-지그재그 청소모드 변경할 경우, 청소가 중단되었다가 다시 시작한다는 것 등을 제외하고는 모든 면에서 만족스럽습니다. \n\n가성비 제품이라는 댓글도 보았는데, 저는 더 비싼 제품(제가 쓰던 LG, 샤오미 제품)보다 성능이 좋다는 느낌을 받았습니다. 물론 구매한 시점이 다르긴 하지만요.\n\n더 장시간 사용해보고 별문제가 없다면, 다음에도 클리엔 제품을 또 구매할 것 같습니다(그땐 클리엔 프리미엄 제품을 사야겠다는ㅎㅎ)\n\n* 참고로 클리엔 어플에 소모품 수명체크, 고장점검 서비스 등도 있었는데, 새제품이라 아직 사용은 못해봤어요. 추후 해당 서비스 이용시 장단점이 있으면 다시 후기 올리겠습니다.',
          productRating: 4,
          deliveryRating: 4,
          productStarRating: 4,
          deliveryStarRating: 4,
          best: true,
          writer: '이만*',
          imageUrl: 'https://st.kakaocdn.net/thumb/S70x70/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fdefault%2Ffriends%2Fv2%2F4.png&scode=shoppingstore',
          backgroundColor: '#cbb7c3',
        },
        {
          id: '642d9e89be867875cf13904c',
          content: '빠른배송 감사드립니다 \n삶의 만족도가 높다고해서 구매결정했습니다\n기대되는데 이른새벽이라 사용은 못해봤네요\n가격도 많이 만족합니다',
          productRating: 4,
          deliveryRating: 4,
          productStarRating: 4,
          deliveryStarRating: 4,
          best: true,
          writer: '여니****',
          imageUrl: 'https://st.kakaocdn.net/thumb/S70x70/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fdefault%2Ffriends%2Fv2%2F6.png&scode=shoppingstore',
          backgroundColor: '#cbb7c3',
        },
        {
          id: '642d40f6db02275731260875',
          content:
            '이렇게 포토 리뷰 남긴건 처음 입니다.\n\n우연히 카카오 톡 딜가를 보고 어라? 가격대비 너무 좋은거 아닌가 생각에 아무생각 없이 구매를 하고 잠들고 그다음날이 되어서 부모님께도 하나 사드리자 하고 하나 더 구매를 했습니다. \n\n처음 로봇청소기를 써보는데 이놈 참 혼자 사는 저에게 참 좋은 친구가 생긴거 같아 좋더군요\n\n좋은 친구가 생긴거 같아 오래오래 함께 하려고 합니다.\n일단 전반적으로 좋습니다 제가 청소는 좀 안하는 편인데 이녀석이 온 후 아침 저녁으로 하고 있고요 또한 만드신 분이 얼마나 고통을 감내 하고 만들었는지에 대한 기능을 보며 감탄 또 감탄을 하며 같이 보내고 있습니다.  대표님 상여급 많이 주셔야 합니다.. \n아쉬운 점은 아무래도 사람 만큼의 꼼꼼함이나 세기가 다른듯 하지만 다른분 리뷰 처럼 자주 하면 되지 않을까 하니 괜찮은거 같습니다. \n\n전 추천합니다 감사합니다.\n\n추신 @@ 저 이거 제아이디로 두개 샀는데 부모님께서는 리뷰이런걸 못하시는데 사은품까지 드리고 싶은데 센스있게 4개 보내주시면 좋겠습니닷.. ㅎㅎ \n그게 안되면 리뷰 하나더 작성하면 되는데.. 중복 참여가 불가능하다고 하니.. 어떻게 해야할지 답변 기다릵요!! 암튼 감사합니다',
          productRating: 4,
          deliveryRating: 4,
          productStarRating: 4,
          deliveryStarRating: 4,
          best: true,
          writer: '*',
          imageUrl: 'https://st.kakaocdn.net/thumb/S70x70/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fdefault%2Ffriends%2Fv2%2F9.png&scode=shoppingstore',
          backgroundColor: '#f5e7d9',
        },
      ],
      qnaCount: 1359,
      reviewCount: 2613,
      averageRating: 4,
      totalProductStarRating: 4.0,
      totalDeliveryStarRating: 4.0,
      productPositivePercentage: 100,
      deliveryPositivePercentage: 99,
      productStar1Percentage: 0,
      productStar2Percentage: 0,
      productStar3Percentage: 3,
      productStar4Percentage: 96,
    },
    banners: [],
    sellerProductPoint: {},
  },
  204308361: {
    name: '[우체국쇼핑]전북 정읍 국내산 귀리로 만든 귀리뻥튀기 왕큰봉지 2봉/4봉',
    image: {
      imageRatio: 'SQUARE',
      images: ['https://st.kakaocdn.net/thumb/P750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20221208143712_c032773e042e4b15aa5d9b8dde9b907c.jpg'],
      sharingImageUrl: 'https://st.kakaocdn.net/shoppingstore/product/20221208143712_c032773e042e4b15aa5d9b8dde9b907c.jpg',
    },
    status: 'ON_SALE',
    description:
      '<html>\n <head></head>\n <body>\n  <p><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20221208143616_c47257b9239741d882c8d5e65560aee4.jpg"><!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_860_14740") --><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230307093407_49c7dc6c43734ccab70bc67c383da3a2.jpg"></p>\n </body>\n</html>',
    instantOrder: false,
    talkDeal: {
      id: 3263901,
      status: 'AFTER_SALE',
      groupSize: 1,
      period: { from: '20230506170000', to: '20230509235959' },
      ongoingRoomCount: 0,
      discountPrice: 4000,
      discountRate: 31.0,
    },
    benefits: [
      {
        description: '카카오페이 머니로 3만원 이상 결제 시 카카오페이 포인트 2천원 적립 (5/8~5/17, 일부 상품 대상 제외, 인당 1회)',
        landingUrl: 'https://store.kakao.com/mypage/notice/119',
        value: '',
      },
    ],
    delivery: {
      deliveryMethodType: 'DELIVERY',
      optionalDeliveries: [],
      deliveryFeeType: 'FREE',
      deliveryFeePaymentType: 'PREPAID',
      deliveryFee: 0,
      bundleGroupAvailable: true,
      availableIsolatedArea: false,
    },
    originArea: { type: '혼합/기타', content: '상세설명에 표시', others: false },
    taxDeduction: false,
    gift: { gift: '' },
    quantity: { minPurchase: 1, maxPurchase: 0, maxPurchaseOfBuyer: 0 },
    adultOnly: false,
    isLiquor: false,
    minorPurchasable: true,
    booked: { booked: false },
    notices: [],
    reviewUnexposed: false,
    favorite: false,
    reviewCreatable: false,
    store: {
      id: 1987,
      name: '우체국쇼핑몰',
      domain: 'postkmall',
      farmer: true,
      coverImage: 'https://st.kakaocdn.net/shoppingstore/store/20210813142615_625856d5c34940d8b54d21048ea8839b.jpg',
      profileImage: 'https://st.kakaocdn.net/shoppingstore/store/20190625190413_5030441de54d40a6b0ab62f92d846298.jpg',
      channelName: '우체국쇼핑몰',
      channelUrl: 'http://pf.kakao.com/_kxlxepj',
      subscribed: false,
      fresh: false,
      trackId: '',
    },
    category: { id: '102109100', name: '과자/쿠키' },
    price: {
      standardPrice: 12900,
      discountedPrice: 12900,
      discountRate: 0.0,
      minDiscountedPrice: 12900,
      maxDiscountedPrice: 19900,
      totalDiscountedPrice: 12900,
    },
    events: [],
    review: {
      topReviews: [
        {
          id: '640eef0239c9564b853bf4c1',
          content:
            '바삭한 식감이 시중에서 사먹던 뻥튀기와는 \n확연히 달라요 \n더 고소하고 더 바삭하고 단맛이 거의 없는데 \n계속 땡기는 맛 ㅠ 넘 맛있어융 ㅎ \n뜯는 순간 150g 한봉지 순삭하는 .. \n누룽지같은 색상인데 진짜 누룽지 처럼 구수한맛도 있어요 ㅎ \nㅇㅏ 이거 또 사고 싶어요 \n딜을 기다립니다 ㅜ\n어르신들도 좋아할듯 ㅎ\n부모님집에 보내드려야겠어요 \n귀리함유양은 적고 밀가루도 들어갔지만 \n다른 좋은것들도 많이 들어가서 \n건강뻥튀기로 인정 \uD83D\uDC4D \n맛도 굿 \uD83D\uDC4D',
          productRating: 4,
          deliveryRating: 4,
          productStarRating: 4,
          deliveryStarRating: 4,
          best: true,
          writer: 'so*******',
          imageUrl: 'https://st.kakaocdn.net/thumb/S70x70/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fdefault%2Ffriends%2Fv2%2F6.png&scode=shoppingstore',
          backgroundColor: '#d6d6d6',
        },
        {
          id: '6408457a0aae331a06954ec5',
          content: '빠른배송으로 잘 받았습니다  이중포장이라 부서진거 별로없이 잘 받았네요 귀리뻥튀기라 궁금했는데 바삭한고소함으로 살찔염려없이 주전부리 최고 간식입니다 ㅎㅎ',
          productRating: 4,
          deliveryRating: 4,
          productStarRating: 4,
          deliveryStarRating: 4,
          best: true,
          writer: '차길*',
          imageUrl: 'https://st.kakaocdn.net/thumb/S70x70/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fdefault%2Ffriends%2Fv2%2F5.png&scode=shoppingstore',
          backgroundColor: '#e7eded',
        },
        {
          id: '6438b93c877cfd6a9e4e37e5',
          content:
            '정말 정말 최고입니다 친정엄마 간식으로 샀는데 몸에 좋은 귀리와 쌍화차로 만들어 건강에도 최최고 귀이의 꼬소한 맛과 상화탕의 은은한 단맛이 아주 아주 조화롭습니다 어르신 계신 집은 물론 아이들 간식으로 강추합니다  엄마가 너무 너무 맛있다고 좋아하십니다 대박나세요^^',
          productRating: 4,
          deliveryRating: 4,
          productStarRating: 4,
          deliveryStarRating: 4,
          best: true,
          writer: '이미*',
          imageUrl: 'https://st.kakaocdn.net/thumb/S70x70/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fdefault%2Ffriends%2Fv2%2F8.png&scode=shoppingstore',
          backgroundColor: '#eec4c5',
        },
      ],
      qnaCount: 245,
      reviewCount: 941,
      averageRating: 4,
      totalProductStarRating: 4.0,
      totalDeliveryStarRating: 4.0,
      productPositivePercentage: 98,
      deliveryPositivePercentage: 97,
      productStar1Percentage: 1,
      productStar2Percentage: 2,
      productStar3Percentage: 8,
      productStar4Percentage: 90,
    },
    banners: [],
    sellerProductPoint: {},
  },
  246324459: {
    name: '카밀 대용량 바디로션 1+1+미니 바디로션 1개 증정',
    image: {
      imageRatio: 'SQUARE',
      images: ['https://st.kakaocdn.net/thumb/P750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230421163754_65f354cc72cd4958a4593b64a086dd11.jpg'],
      sharingImageUrl: 'https://st.kakaocdn.net/shoppingstore/product/20230421163754_65f354cc72cd4958a4593b64a086dd11.jpg',
    },
    status: 'ON_SALE',
    description:
      '<html>\n <head></head>\n <body>\n  <p><!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_800_4042") --><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230504181657_2b6dec39f7524a73b4785fc1d4fc79a7.jpg"><!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_800_1510") --><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230504181653_5bbe6f2763ee4d7da0360996deaf867c.jpg"><!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_800_1512") --><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230504181710_4e02e371c3954c15beb1db88ebb4c7f5.jpg"></p> \n  <p>&nbsp;</p> \n  <p><!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_800_210") --><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230502135221_ff140f3aa197443a9ef351bfdfc64828.jpg">&nbsp;<img data-origin-url="https://glcomm.diskn.com/1SKg8nPcku" src="https://st.kakaocdn.net/shoppingstore/editor/20230421164411_0470ddf9a02f422e9f15a41046bd008e"></p> \n  <p><!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_800_2478") --><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230504181728_035c820653b241e08ee5316b6bf867dd.jpg"><!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_800_3996") --><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230504181927_70b6d272b87042489e78a099964488ed.jpg"></p> \n  <p><!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_800_1507") --><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230502135658_74a900e4c9df46be9b8d59742cf84118.jpg"></p> \n  <p><!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_800_1508") --><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230502135754_69e5f828e59a4cae9d83666edbd92456.jpg"></p> \n  <p><!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_800_566") --><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230502135659_6009b8d619c34beaafde967aac93eaa4.jpg"></p> \n  <p><!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_800_1202") --><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230502135900_dd01b4c6470f47c5bc903290fb3d019e.jpg"></p> \n  <p>&nbsp;</p> \n  <p><!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_800_1092") --><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230502135300_4273e71e77ee4a519ad040432d8ba1d9.jpg"></p> \n  <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<img data-origin-url="https://glcomm.diskn.com/1mlKd7WeXC" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230421164418_55d6072459d940e7bbb08c83f19edd09"> <img data-origin-url="https://glcomm.diskn.com/0n9UaY473s" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230421164418_41a0350410a74326acaa56cb6df830db"> <img data-origin-url="https://glcomm.diskn.com/37FNGhgqHO" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230421164419_58ab3891564d4272bf5f1ee14313a8c3"> <img data-origin-url="https://glcomm.diskn.com/37GiDZRwFW" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230421164419_2ac0cd3b529b4c76bf0ec277c310f451"></p>\n </body>\n</html>',
    instantOrder: false,
    talkDeal: {
      id: 3263867,
      status: 'AFTER_SALE',
      groupSize: 1,
      period: { from: '20230506170000', to: '20230509235959' },
      ongoingRoomCount: 0,
      discountPrice: 21800,
      discountRate: 62.0,
    },
    benefits: [
      {
        description: '카카오페이 머니로 3만원 이상 결제 시 카카오페이 포인트 2천원 적립 (5/8~5/17, 일부 상품 대상 제외, 인당 1회)',
        landingUrl: 'https://store.kakao.com/mypage/notice/119',
        value: '',
      },
    ],
    delivery: {
      deliveryMethodType: 'DELIVERY',
      optionalDeliveries: [],
      deliveryFeeType: 'FREE',
      deliveryFeePaymentType: 'PREPAID',
      deliveryFee: 0,
      bundleGroupAvailable: true,
      availableIsolatedArea: true,
    },
    taxDeduction: false,
    gift: { gift: '' },
    quantity: { minPurchase: 1, maxPurchase: 0, maxPurchaseOfBuyer: 0 },
    adultOnly: false,
    isLiquor: false,
    minorPurchasable: true,
    booked: { booked: false },
    notices: [],
    reviewUnexposed: false,
    favorite: false,
    reviewCreatable: false,
    store: {
      id: 58053,
      name: '지엘커뮤니케이션즈',
      domain: 'glcomm',
      farmer: false,
      coverImage: 'https://st.kakaocdn.net/shoppingstore/default/cover/06.png',
      profileImage: 'https://st.kakaocdn.net/shoppingstore/store/20210111095926_2c708d8f5fa3405aa6f3148a870b8480.jpeg',
      consultId: '@바디콜렉션',
      channelName: '바디콜렉션',
      channelUrl: 'http://pf.kakao.com/_kwxolK',
      subscribed: false,
      fresh: false,
      trackId: '',
    },
    category: { id: '101103100100101', name: '바디로션' },
    price: {
      standardPrice: 34700,
      discountedPrice: 34700,
      discountRate: 0.0,
      minDiscountedPrice: 34700,
      maxDiscountedPrice: 34700,
      totalDiscountedPrice: 34700,
    },
    events: [],
    review: {
      topReviews: [
        {
          id: '64587a1d03e3015e64236784',
          content: '가성비굿굿입니다',
          productRating: 4,
          deliveryRating: 4,
          productStarRating: 4,
          deliveryStarRating: 4,
          best: true,
          writer: '강명*',
          imageUrl: 'https://st.kakaocdn.net/thumb/S70x70/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fdefault%2Ffriends%2Fv2%2F1.png&scode=shoppingstore',
          backgroundColor: '#eec4c5',
        },
        {
          id: '6459c5acdfb8e85ed0600b19',
          content: '저렴한 가격에 잘 구매한 것 같아요 많이 파세요. ^^',
          productRating: 4,
          deliveryRating: 4,
          productStarRating: 4,
          deliveryStarRating: 4,
          best: true,
          writer: '백진*',
          imageUrl: 'https://st.kakaocdn.net/thumb/S70x70/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fdefault%2Ffriends%2Fv2%2F8.png&scode=shoppingstore',
          backgroundColor: '#cbb7c3',
        },
        {
          id: '6459da5706481f28e13e63a7',
          content: '배송 빨리왔네요  카밀 바디로션은 처음이라  잘 쓸께요',
          productRating: 4,
          deliveryRating: 4,
          productStarRating: 4,
          deliveryStarRating: 4,
          best: true,
          writer: '심선*',
          imageUrl: 'https://st.kakaocdn.net/thumb/S70x70/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fdefault%2Ffriends%2Fv2%2F7.png&scode=shoppingstore',
          backgroundColor: '#e7eded',
        },
      ],
      qnaCount: 14,
      reviewCount: 73,
      averageRating: 4,
      totalProductStarRating: 4.0,
      totalDeliveryStarRating: 4.0,
      productPositivePercentage: 99,
      deliveryPositivePercentage: 99,
      productStar1Percentage: 0,
      productStar2Percentage: 1,
      productStar3Percentage: 7,
      productStar4Percentage: 92,
    },
    banners: [],
    sellerProductPoint: {},
  },
  197627921: {
    name: '[카렉스] 시야확보주의! 레인스톰 하이브리드 와이퍼 2+2 (차량2대분)',
    image: {
      imageRatio: 'SQUARE',
      images: ['https://st.kakaocdn.net/thumb/P750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230502134519_cfbf8c4266eb4d34af8910b0141a8762.png'],
      sharingImageUrl: 'https://st.kakaocdn.net/shoppingstore/product/20230502134519_cfbf8c4266eb4d34af8910b0141a8762.png',
    },
    status: 'ON_SALE',
    description:
      '<html>\n <head></head>\n <body>\n  <center> \n   <img data-origin-url="http://gi.esmplus.com/carex4646/CAREX/180806_shop_d_rainstrom_wiper.jpg" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230306113227_2862cf184dce41a8949e75dc3dfd0e0a.jpg"> \n   <br> \n   <img data-origin-url="http://carex.co.kr/MALL/detail/2018/2_carex_customer.jpg" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230306113228_c065ebfbbc734fb59fce137403c4c3f3.jpg"> \n  </center>\n </body>\n</html>',
    instantOrder: false,
    benefits: [
      {
        description: '카카오페이 머니로 3만원 이상 결제 시 카카오페이 포인트 2천원 적립 (5/8~5/17, 일부 상품 대상 제외, 인당 1회)',
        landingUrl: 'https://store.kakao.com/mypage/notice/119',
        value: '',
      },
    ],
    delivery: {
      deliveryMethodType: 'DELIVERY',
      optionalDeliveries: [],
      deliveryFeeType: 'FREE',
      deliveryFeePaymentType: 'PREPAID',
      deliveryFee: 0,
      freeConditionalAmount: 30000,
      repeatQuantity: 0,
      bundleGroupAvailable: true,
      isolatedAreaAdditionalFee: 7000,
      jejuAreaAdditionalFee: 3000,
      availableIsolatedArea: true,
    },
    taxDeduction: false,
    gift: { gift: '' },
    quantity: { minPurchase: 1, maxPurchase: 0, maxPurchaseOfBuyer: 0 },
    adultOnly: false,
    isLiquor: false,
    minorPurchasable: true,
    booked: { booked: false },
    notices: [
      {
        id: 70804,
        title: '카카오톡문의하기',
        wholeNotice: true,
        content:
          '<p><img class="__cu_imgsize_1495_210" data-animated="false" src="https://st.kakaocdn.net/shoppingstore/editor/20230306113318_9383b26941f14763b74acd4c18a0c840.png" /><img class="__cu_imgsize_1500_978" data-animated="false" src="https://st.kakaocdn.net/shoppingstore/editor/20230306113323_7e4444e0fce6476b88eb2af8575b3b5f.png" /></p>\n',
        createdAt: '20230306113330',
      },
    ],
    reviewUnexposed: false,
    favorite: false,
    reviewCreatable: false,
    store: {
      id: 15139,
      name: '카렉스몰',
      domain: 'carex',
      farmer: false,
      coverImage: 'https://st.kakaocdn.net/shoppingstore/default/cover/08.png',
      profileImage: 'https://st.kakaocdn.net/shoppingstore/store/20230417160745_796ff505b7e74d6fb3dc806d508b3da6.jpg',
      consultId: '@carexmall',
      channelName: '카렉스',
      channelUrl: 'http://pf.kakao.com/_XDxgxmxj',
      subscribed: false,
      fresh: false,
      trackId: '',
    },
    category: { id: '103101116110', name: '와이퍼' },
    price: {
      standardPrice: 23600,
      discountedPrice: 11800,
      discountRate: 50.0,
      minDiscountedPrice: 11800,
      maxDiscountedPrice: 11800,
      totalDiscountedPrice: 11800,
    },
    events: [],
    review: {
      topReviews: [
        {
          id: '63f1aff93fe4300d8fbe0f43',
          content: '시야 깨끗해요. 자주바꾸는게 좋겠어요. 득템했네요.^^',
          productRating: 4,
          deliveryRating: 4,
          productStarRating: 4,
          deliveryStarRating: 4,
          best: true,
          writer: '조연*',
          imageUrl: 'https://st.kakaocdn.net/thumb/S70x70/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fdefault%2Ffriends%2Fv2%2F1.png&scode=shoppingstore',
          backgroundColor: '#d6d6d6',
        },
        {
          id: '63f844516810ca09681fbb49',
          content: '좋은제품 잘쓸께요 \n대박기원 합니다^^',
          productRating: 4,
          deliveryRating: 4,
          productStarRating: 4,
          deliveryStarRating: 4,
          best: true,
          writer: '아진*************',
          imageUrl: 'https://st.kakaocdn.net/thumb/S70x70/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fdefault%2Ffriends%2Fv2%2F9.png&scode=shoppingstore',
          backgroundColor: '#d6d6d6',
        },
        {
          id: '63f9a02065f18b5326b88268',
          content: '잘받았어요 빠르고 안전포장 되어 왔네요 잘닦였으면 좋겠어요 1+1이라 오래쓰고 좋습니다 감사합니다. 많이파세요!',
          productRating: 4,
          deliveryRating: 4,
          productStarRating: 4,
          deliveryStarRating: 4,
          best: true,
          writer: 'le*****',
          imageUrl: 'https://st.kakaocdn.net/thumb/S70x70/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fdefault%2Ffriends%2Fv2%2F9.png&scode=shoppingstore',
          backgroundColor: '#f5e7d9',
        },
      ],
      qnaCount: 153,
      reviewCount: 288,
      averageRating: 4,
      totalProductStarRating: 4.0,
      totalDeliveryStarRating: 4.0,
      productPositivePercentage: 98,
      deliveryPositivePercentage: 97,
      productStar1Percentage: 1,
      productStar2Percentage: 1,
      productStar3Percentage: 7,
      productStar4Percentage: 91,
    },
    banners: [],
    sellerProductPoint: { sellerProductReviewPointView: { value: 100, photoValue: 300, point: 400 } },
  },
  139319258: {
    name: '온더바디 슈퍼보타닉 비누 12개(쟈스민,오이라임) 외',
    image: {
      imageRatio: 'SQUARE',
      images: [
        'https://st.kakaocdn.net/thumb/P750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230504111125_f80ab8bb9b724e67b20d4c16b5dc3789.jpg',
        'https://st.kakaocdn.net/thumb/P750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230504111133_9ad14681e356445eb094e73dc2d335aa.jpg',
        'https://st.kakaocdn.net/thumb/P750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20220810184118_5e35eb618b8a4decbdf798026271c465.jpg',
      ],
      sharingImageUrl: 'https://st.kakaocdn.net/shoppingstore/product/20230504111125_f80ab8bb9b724e67b20d4c16b5dc3789.jpg',
    },
    status: 'CLOSE',
    description:
      '<html>\n <head></head>\n <body>\n  <p style="text-align:center"><!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_860_1452") --><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230504133635_a3c783a1bd8c4b4cb40c89a707abb0aa.jpg"><!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_860_2118") --><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230504133638_94d1d6262d2347ec9ff2cca4b75dc857.jpg"><img data-origin-url="https://lghnh1.diskn.com/1n72xlYzXa" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20220901111300_b4fc91d121f44fc6a0e8dafd0bd0847a"><!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_900_12245") --><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230504110111_c47a330cebe245a1a4c5abfe8d015267.jpg"><!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_700_6973") --><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230503163121_3fd5d6a5507e4cf199ffab6238e3bd93.jpg"></p> \n  <p>&nbsp;</p>\n </body>\n</html>',
    instantOrder: false,
    benefits: [
      {
        description: '카카오페이 머니로 3만원 이상 결제 시 카카오페이 포인트 2천원 적립 (5/8~5/17, 일부 상품 대상 제외, 인당 1회)',
        landingUrl: 'https://store.kakao.com/mypage/notice/119',
        value: '',
      },
    ],
    delivery: {
      deliveryMethodType: 'DELIVERY',
      optionalDeliveries: [],
      deliveryFeeType: 'FREE',
      deliveryFeePaymentType: 'PREPAID',
      deliveryFee: 0,
      bundleGroupAvailable: true,
      availableIsolatedArea: true,
    },
    taxDeduction: false,
    gift: { gift: '' },
    quantity: { minPurchase: 1, maxPurchase: 0, maxPurchaseOfBuyer: 0 },
    adultOnly: false,
    isLiquor: false,
    minorPurchasable: true,
    booked: { booked: false },
    notices: [],
    reviewUnexposed: false,
    favorite: false,
    reviewCreatable: false,
    store: {
      id: 2530,
      name: 'LG생활건강',
      domain: 'lgcare',
      farmer: false,
      coverImage: 'https://st.kakaocdn.net/shoppingstore/store/20190828094255_c592602e503f4b308f106c707d4f6ae2.jpg',
      profileImage: 'https://st.kakaocdn.net/shoppingstore/store/20180906172400_1455a346d67045d2a8e82e1b71145b1b.jpeg',
      channelName: 'LG생활건강 직영',
      channelUrl: 'http://pf.kakao.com/_xaKgxhj',
      subscribed: false,
      fresh: false,
      trackId: '568260606456383071',
    },
    category: { id: '101107107104', name: '클렌징 비누' },
    price: {
      standardPrice: 19800,
      discountedPrice: 19800,
      discountRate: 0.0,
      minDiscountedPrice: 19400,
      maxDiscountedPrice: 19800,
      totalDiscountedPrice: 19800,
    },
    events: [],
    review: {
      topReviews: [
        {
          id: '63f47b343b15cc083092055f',
          content: '첨 써보는데 향이좋네요 ᆢ만족해요\n다 쓰면재구매의사잇음요^^',
          productRating: 4,
          deliveryRating: 4,
          productStarRating: 4,
          deliveryStarRating: 4,
          best: true,
          writer: 'su****',
          imageUrl: 'https://st.kakaocdn.net/thumb/S70x70/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fdefault%2Ffriends%2Fv2%2F6.png&scode=shoppingstore',
          backgroundColor: '#f5e7d9',
        },
        {
          id: '63f6028d09279f3087502037',
          content: '배송은 많이 늦으니 급한사람은 구매를 생각해봐야할듯요. 저는 다행히 여유가 있어 괜찬긴 했지만요......거품은 아직 사용전이라 모르겠네요.향은 좋아요',
          productRating: 4,
          deliveryRating: 2,
          productStarRating: 4,
          deliveryStarRating: 2,
          best: true,
          writer: '*',
          imageUrl: 'https://st.kakaocdn.net/thumb/S70x70/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fdefault%2Ffriends%2Fv2%2F4.png&scode=shoppingstore',
          backgroundColor: '#d6d6d6',
        },
        {
          id: '63f72fb1e248b75394cb54c3',
          content: '좋은가격에 구매합니다.타시제품이 너무 미끄러워서 리뷰가 좋길래 사용해보려고요.',
          productRating: 4,
          deliveryRating: 4,
          productStarRating: 4,
          deliveryStarRating: 4,
          best: true,
          writer: '이쁜***',
          imageUrl: 'https://st.kakaocdn.net/thumb/S70x70/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fdefault%2Ffriends%2Fv2%2F4.png&scode=shoppingstore',
          backgroundColor: '#cbb7c3',
        },
      ],
      qnaCount: 36,
      reviewCount: 692,
      averageRating: 4,
      totalProductStarRating: 4.0,
      totalDeliveryStarRating: 4.0,
      productPositivePercentage: 99,
      deliveryPositivePercentage: 99,
      productStar1Percentage: 0,
      productStar2Percentage: 1,
      productStar3Percentage: 7,
      productStar4Percentage: 92,
    },
    banners: [],
    sellerProductPoint: {},
  },
  68626964: {
    name: '[퍼실 300ml 2개 증정] 헨켈 섬유유연제 버넬 0.9L 6개',
    image: {
      imageRatio: 'SQUARE',
      images: [
        'https://st.kakaocdn.net/thumb/P750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230427144204_ac2dd3c737b940f291b0065d98e89d6a.jpg',
        'https://st.kakaocdn.net/thumb/P750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230310101424_18225c209d474cbdba8cad3f899fe416.jpg',
      ],
      sharingImageUrl: 'https://st.kakaocdn.net/shoppingstore/product/20230427144204_ac2dd3c737b940f291b0065d98e89d6a.jpg',
    },
    status: 'ON_SALE',
    description:
      '<html>\n <head></head>\n <body>\n  <p align="center"><!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_770_10591") --><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230405115329_3dc038b9adeb43d78532632e22f7fcc1.jpg"><!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_890_12870") --><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230405115329_9de5d023693e4c49b709f39266772ea8.jpg"></p> \n  <p align="center"><!-- Not Allowed Attribute Filtered ( alt="") --><img data-origin-url="https://echansol.co.kr/main_img/customercenter.jpg" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230105105210_4d6d532240b24decbe1332b84543ce06.jpg"></p>\n </body>\n</html>',
    instantOrder: false,
    talkDeal: {
      id: 3270267,
      status: 'AFTER_SALE',
      groupSize: 1,
      period: { from: '20230506170000', to: '20230509235959' },
      ongoingRoomCount: 0,
      discountPrice: 24500,
      discountRate: 59.0,
    },
    benefits: [
      {
        description: '카카오페이 머니로 3만원 이상 결제 시 카카오페이 포인트 2천원 적립 (5/8~5/17, 일부 상품 대상 제외, 인당 1회)',
        landingUrl: 'https://store.kakao.com/mypage/notice/119',
        value: '',
      },
    ],
    delivery: {
      deliveryMethodType: 'DELIVERY',
      optionalDeliveries: [],
      deliveryFeeType: 'FREE',
      deliveryFeePaymentType: 'PREPAID',
      deliveryFee: 0,
      bundleGroupAvailable: true,
      isolatedAreaAdditionalFee: 6000,
      jejuAreaAdditionalFee: 4000,
      availableIsolatedArea: true,
    },
    taxDeduction: false,
    gift: { gift: '' },
    quantity: { minPurchase: 0, maxPurchase: 1000, maxPurchaseOfBuyer: 1000 },
    adultOnly: false,
    isLiquor: false,
    minorPurchasable: true,
    booked: { booked: false },
    notices: [],
    reviewUnexposed: false,
    favorite: false,
    reviewCreatable: false,
    store: {
      id: 1634,
      name: '헨켈온라인공식몰',
      domain: 'henkel',
      farmer: false,
      coverImage: 'https://st.kakaocdn.net/shoppingstore/default/cover/02.png',
      profileImage: 'https://st.kakaocdn.net/shoppingstore/store/20180608105211_d2911174025541ae8dffd07245b7f3c1.jpeg',
      channelName: '헨켈홈케어공식몰',
      channelUrl: 'http://pf.kakao.com/_qtLvxj',
      subscribed: false,
      fresh: false,
      trackId: '7247716872349566931',
    },
    category: { id: '104103103101', name: '섬유유연제' },
    price: {
      standardPrice: 41400,
      discountedPrice: 41400,
      discountRate: 0.0,
      minDiscountedPrice: 41400,
      maxDiscountedPrice: 43400,
      totalDiscountedPrice: 41400,
    },
    events: [],
    review: {
      topReviews: [
        {
          id: '641030ad48dad82cd0fdf08f',
          content:
            '생각보다 엄청 커요 향기도 좋고요 \n프레쉬 모닝은 제가 좋아하는 향 이네요\n스프링 라벤더 항이 진하고 좋아요^^\n와일드 로즈 장미 향이 정말  진하게 나요 \n드럼용 액체 두개 서비스까지 완전 좋으네요 \n감사히 잘 사용하겠습니다.',
          productRating: 4,
          deliveryRating: 4,
          productStarRating: 4,
          deliveryStarRating: 4,
          best: true,
          writer: '\uD83D\uDC95******',
          imageUrl: 'https://st.kakaocdn.net/thumb/S70x70/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fdefault%2Ffriends%2Fv2%2F5.png&scode=shoppingstore',
          backgroundColor: '#f5e7d9',
        },
        {
          id: '641041751f759704400cb162',
          content: '엄청오래쓸거같아요\n싼 가격에 득템했네요\n세제까지 서비스로 주시고\n감사합니다',
          productRating: 4,
          deliveryRating: 4,
          productStarRating: 4,
          deliveryStarRating: 4,
          best: true,
          writer: '*',
          imageUrl: 'https://st.kakaocdn.net/thumb/S70x70/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fdefault%2Ffriends%2Fv2%2F8.png&scode=shoppingstore',
          backgroundColor: '#f5e7d9',
        },
        {
          id: '6416580e43fcb81d54d46d5d',
          content: '대량이라 마음편하게 오래오래 쓸수 있을것 같아요\n항기도 오래가고 은은해서 부담스럽지 않고 주변에도 나눠주고 써야겠어요',
          productRating: 4,
          deliveryRating: 4,
          productStarRating: 4,
          deliveryStarRating: 4,
          best: true,
          writer: '\uD83D\uDC9C*******',
          imageUrl: 'https://st.kakaocdn.net/thumb/S70x70/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fdefault%2Ffriends%2Fv2%2F4.png&scode=shoppingstore',
          backgroundColor: '#e7eded',
        },
      ],
      qnaCount: 330,
      reviewCount: 1923,
      averageRating: 4,
      totalProductStarRating: 4.0,
      totalDeliveryStarRating: 4.0,
      productPositivePercentage: 98,
      deliveryPositivePercentage: 95,
      productStar1Percentage: 1,
      productStar2Percentage: 1,
      productStar3Percentage: 6,
      productStar4Percentage: 92,
    },
    banners: [],
    sellerProductPoint: {},
  },
  56992838: {
    name: '"동안피부비결" 이탈리아산 저분자 피쉬콜라겐 1통 90포 3개월분',
    image: {
      imageRatio: 'SQUARE',
      images: [
        'https://st.kakaocdn.net/thumb/P750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230510093359_61137173d9cd46ceadb5bf72986a93d3.jpg',
        'https://st.kakaocdn.net/thumb/P750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230210170855_df667fc96bc34a67b2f5562e1a437613.jpg',
        'https://st.kakaocdn.net/thumb/P750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230210170904_597eccaa1a48442389e4b0f4cd6a1150.jpg',
        'https://st.kakaocdn.net/thumb/P750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230503151325_a302fb3e04784ada9eb8554c54e9d315.jpg',
        'https://st.kakaocdn.net/thumb/P750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230503151340_7609f03365f3492696a5a56be6f15d44.jpg',
        'https://st.kakaocdn.net/thumb/P750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230503151350_3bc13e32cf474690a555e02af012537a.jpg',
      ],
      sharingImageUrl: 'https://st.kakaocdn.net/shoppingstore/product/20230510093359_61137173d9cd46ceadb5bf72986a93d3.jpg',
    },
    status: 'ON_SALE',
    description:
      '<html>\n <head></head>\n <body>\n  <center> <!-- Not Allowed Attribute Filtered ( border="0") -->\n   <img data-origin-url="https://hs005223.speedgabia.com/cacao/detail/zzim.jpg" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230220103612_fc7c59c455af487181fce68a66e95a7d.jpg"> \n   <div class="cu-video"> \n    <div class="cu-video-aspect-ratio"> <iframe frameborder="0" src="https://www.youtube.com/embed/t6bJ0u-UIMI"></iframe> \n    </div> \n   </div> \n   <br> \n   <br> \n   <br> \n   <center> <span style="font-size:14px;"><strong><span style="color:#1abc9c;">메디트리 저분자 콜라겐</span></strong> 무엇이 특별할까요?<br> <br> ✓믿을 수 있는 <strong><span style="color:#ffffff;"><span style="background-color:#9b59b6;">이탈리아산</span></span></strong> 콜라겐<br> ✓어린(생선) 콜라겐으로 <span style="color:#ffffff;"><strong><span style="background-color:#e74c3c;">흡수율 UP!&nbsp;</span></strong></span><br> ✓<strong><span style="color:#ffffff;"><span style="background-color:#1abc9c;">이너뷰티 필수 원료</span></span></strong>인 비타민C와 히알루론산까지</span> \n    <br> \n    <br> <span style="font-size:18px;"><span style="color:#8e44ad;"><strong><u>1통에 90포</u></strong></span>로 가성비까지 꽉 잡은<br> 메디트리 저분자 콜라겐으로</span> \n   </center> \n   <center> <span style="font-size:18px;"><span style="color:#2c3e50;">오늘부터 관리 시작해보세요 :D</span></span> \n   </center> \n   <center> \n    <br> &nbsp; \n   </center> <!-- Not Allowed Attribute Filtered ( border="0") -->\n   <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230510093222_c6f914736fa34ef39e38eddc23f907c5.jpg" data-origin-url="https://hs005223.speedgabia.com/synergyint/spec/meditree_collagen.jpg"> <!-- Not Allowed Attribute Filtered ( border="0") -->\n   <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230510093224_1931644655ef47a2aaa9c69d5c32acc3.jpg" data-origin-url="https://hs005223.speedgabia.com/cacao/detail/hooSpring.jpg"> <!-- Not Allowed Attribute Filtered ( border="0") -->\n   <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230510093225_ec6158aeedc545d5a1dde4afe49df21c.jpg" data-origin-url="https://hs005223.speedgabia.com/jong/drinking_scent.jpg"> <!-- Not Allowed Attribute Filtered ( border="0") -->\n   <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230510093226_f8f39b04f3494b53872802782bd22fd2.jpg" data-origin-url="https://hs005223.speedgabia.com/synergyint/jongk_garsinia_860.jpg"> <!-- Not Allowed Attribute Filtered ( border="0") -->\n   <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230510093227_9880b134fca24ea38b493303305fb65a.jpg" data-origin-url="http://hs005223.speedgabia.com/synergyint/meditree/COENZYMEQ11_860.jpg.jpg"> <!-- Not Allowed Attribute Filtered ( border="0") -->\n   <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230510093228_276648deb9b34dca89e4d3c0b23ddb18.jpg" data-origin-url="https://hs005223.speedgabia.com/synergyint/38enzyme_860.jpg"> <!-- Not Allowed Attribute Filtered ( border="0") -->\n   <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230510093229_3a0628b0ef064f81907fa06427d06b93.jpg" data-origin-url="https://hs005223.speedgabia.com/cacao/detail/vitaminC.jpg"> <!-- Not Allowed Attribute Filtered ( border="0") -->\n   <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230510093229_7a0cf60cbee641b1ac11bc7c268da833.jpg" data-origin-url="https://hs005223.speedgabia.com/cacao/detail/boswellia.jpg"> <!-- Not Allowed Attribute Filtered ( border="0") -->\n   <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230510093231_d4edfa6883ff4c66aadf7690e371534d.jpg" data-origin-url="https://hs005223.speedgabia.com/cacao/detail/Omega3-1100.jpg"> <!-- Not Allowed Attribute Filtered ( border="0") -->\n   <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230510093232_63189671128b46ccb9900ab7fa33f6c3.jpg" data-origin-url="http://hs005223.speedgabia.com/synergyint/meditree/lactoprobio17.jpg"> <!-- Not Allowed Attribute Filtered ( border="0") -->\n   <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230510093236_97ea7b26f6854c2eab5790d5a2acbd20.jpg" data-origin-url="https://hs005223.speedgabia.com/synergyint/gilyukjingold_860.jpg"> <!-- Not Allowed Attribute Filtered ( border="0") -->\n   <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230510093237_75ecd229cd3a4c989f1449fd7bc57669.jpg" data-origin-url="https://hs005223.speedgabia.com/synergyint/kwandong_860.jpg"> <!-- Not Allowed Attribute Filtered ( border="0") -->\n   <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230510093238_5022be51f2ff45e38a85f3df9c524512.png" data-origin-url="https://hs005223.speedgabia.com/cacao/detail/foot.png"> \n  </center>\n </body>\n</html>',
    instantOrder: false,
    benefits: [
      {
        description: '카카오페이 머니로 3만원 이상 결제 시 카카오페이 포인트 2천원 적립 (5/8~5/17, 일부 상품 대상 제외, 인당 1회)',
        landingUrl: 'https://store.kakao.com/mypage/notice/119',
        value: '',
      },
    ],
    delivery: {
      deliveryMethodType: 'DELIVERY',
      optionalDeliveries: [],
      deliveryFeeType: 'FREE',
      deliveryFeePaymentType: 'PREPAID',
      deliveryFee: 0,
      bundleGroupAvailable: true,
      isolatedAreaAdditionalFee: 7000,
      jejuAreaAdditionalFee: 3000,
      availableIsolatedArea: true,
    },
    originArea: { type: '혼합/기타', content: '상세페이지 참조', others: false },
    taxDeduction: false,
    gift: { gift: '' },
    quantity: { minPurchase: 1, maxPurchase: 0, maxPurchaseOfBuyer: 0 },
    adultOnly: false,
    isLiquor: false,
    minorPurchasable: true,
    booked: { booked: false },
    notices: [],
    reviewUnexposed: false,
    favorite: false,
    reviewCreatable: false,
    store: {
      id: 24251,
      name: '메디트리 공식스토어',
      domain: 'meditreestore',
      farmer: false,
      coverImage: 'https://st.kakaocdn.net/shoppingstore/store/20210901144649_1835c5d472f94ddaaa2035daa71a0b4d.jpg',
      profileImage: 'https://st.kakaocdn.net/shoppingstore/store/20210818133516_a533c7d96a154236a6771613e501fa83.jpg',
      consultId: '@메디트리_',
      channelName: '메디트리',
      channelUrl: 'http://pf.kakao.com/_xfxatpC',
      subscribed: false,
      fresh: false,
      trackId: '7782782849913303346',
    },
    category: { id: '102105105101', name: '콜라겐/코큐텐' },
    price: {
      standardPrice: 37000,
      discountedPrice: 21800,
      discountRate: 41.0,
      minDiscountedPrice: 9900,
      maxDiscountedPrice: 58800,
      totalDiscountedPrice: 21800,
    },
    events: [],
    review: {
      topReviews: [
        {
          id: '63edc09e52301a6c9f4627b7',
          content: '배송도빠르고 개별포장이라 맘에들어요',
          productRating: 4,
          deliveryRating: 4,
          productStarRating: 4,
          deliveryStarRating: 4,
          best: true,
          writer: 'w-*',
          imageUrl: 'https://st.kakaocdn.net/thumb/S70x70/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fdefault%2Ffriends%2Fv2%2F8.png&scode=shoppingstore',
          backgroundColor: '#cbb7c3',
        },
        {
          id: '63ef81613b15cc083092039a',
          content:
            '겨울철에 부쩍 피부가 건조해지는게 느껴져서 이젠 피부 관리차 콜라겐 먹어보려고 구매했어요 ! \n무려 3개월분인데 가격도 저렴해서 완전 득템이예용 ㅎ \n하루 한포씩 먹고있는데 분말타입이라서 먹기도 좋구요 \n저분자피쉬콜라겐이 흡수가 더 잘된다고 해서 꾸준히 먹어보려고요',
          productRating: 4,
          deliveryRating: 4,
          productStarRating: 4,
          deliveryStarRating: 4,
          best: true,
          writer: '권도*',
          imageUrl: 'https://st.kakaocdn.net/thumb/S70x70/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fdefault%2Ffriends%2Fv2%2F4.png&scode=shoppingstore',
          backgroundColor: '#cbb7c3',
        },
        {
          id: '63ed9be9fc4759603099dc53',
          content: '건강하게 선물했습니당ㅎㅎ',
          productRating: 4,
          deliveryRating: 4,
          productStarRating: 4,
          deliveryStarRating: 4,
          best: true,
          writer: '희*',
          imageUrl: 'https://st.kakaocdn.net/thumb/S70x70/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fdefault%2Ffriends%2Fv2%2F9.png&scode=shoppingstore',
          backgroundColor: '#e7eded',
        },
      ],
      qnaCount: 23,
      reviewCount: 653,
      averageRating: 4,
      totalProductStarRating: 4.0,
      totalDeliveryStarRating: 4.0,
      productPositivePercentage: 100,
      deliveryPositivePercentage: 100,
      productStar1Percentage: 0,
      productStar2Percentage: 0,
      productStar3Percentage: 3,
      productStar4Percentage: 96,
    },
    banners: [],
    sellerProductPoint: {},
  },
  237319333: {
    name: '구~수한 청국장 150g x 4팩 무료배송 국내산 100% 전통식품인증 /AR',
    image: {
      imageRatio: 'SQUARE',
      images: [
        'https://st.kakaocdn.net/thumb/P750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230327115215_322815ce44ee4591b25012a2c43faddd.jpg',
        'https://st.kakaocdn.net/thumb/P750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230327115240_3382a8a0fe624b4595b69eb9e1a95d0f.jpg',
        'https://st.kakaocdn.net/thumb/P750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230327115248_6e94a25290eb49d18462bb5c9489cbd1.jpg',
      ],
      sharingImageUrl: 'https://st.kakaocdn.net/shoppingstore/product/20230327115215_322815ce44ee4591b25012a2c43faddd.jpg',
    },
    status: 'ON_SALE',
    description:
      '<html>\n <head></head>\n <body>\n  <p><img data-origin-url="https://ai.esmplus.com/thesingsing/IMAGE/AR/M_AR001/M_AR001_01_M.gif" src="https://st.kakaocdn.net/shoppingstore/editor/20230327115452_65aab6eb64ec48b389491e67cf79142f.jpeg"><img data-origin-url="https://ai.esmplus.com/thesingsing/IMAGE/AR/M_AR001/M_AR001_02_M.gif" src="https://st.kakaocdn.net/shoppingstore/editor/20230327115453_eb22ebceef3d4bc2bda11bba95a81283.jpeg"><img data-origin-url="https://ai.esmplus.com/thesingsing/IMAGE/AR/M_AR001/M_AR001_03.jpg" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230327115454_47c62de092a34955be272997be8dbd3a.jpg"></p> \n  <p><img data-origin-url="https://ai.esmplus.com/thesingsing/IMAGE/AR/M_AR001/M_AR001_04.jpg" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230327115454_d22ce29cef7946e7ac70d72b19364b56.jpg"><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230508150027_6b97bd4710f243fda8199cdbc4df6b9a.jpg"><br> <img data-origin-url="https://ai.esmplus.com/thesingsing/IMAGE/AR/M_AR001/M_AR001_06.jpg" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230327115455_f66cc98fdc774526be86769213ce8b1e.jpg"><br> <img data-origin-url="https://ai.esmplus.com/thesingsing/IMAGE/AR/M_AR001/M_AR001_07.jpg" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230327115455_78256d4c83f940e9a6200a3cff2f7843.jpg"><br> <img data-origin-url="https://ai.esmplus.com/thesingsing/IMAGE/AR/M_AR001/M_AR001_08_M.gif" src="https://st.kakaocdn.net/shoppingstore/editor/20230327115455_b9dece2dd6ea485993e1b31230bc87f9.jpeg"><br> <img data-origin-url="https://ai.esmplus.com/thesingsing/IMAGE/AR/M_AR001/M_AR001_09.jpg" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230327115456_1ef83c017d7b4f3c9c6f7b5d9f250d73.jpg"><br> <img data-origin-url="https://ai.esmplus.com/thesingsing/IMAGE/AR/M_AR001/M_AR001_10.jpg" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230327115457_f8c7d4a98a634a0485e16abbef210ce2.jpg"><br> <img data-origin-url="https://ai.esmplus.com/thesingsing/IMAGE/AR/M_AR001/M_AR001_11.jpg" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230327115457_e525985533c9404eaec5051f740d93c4.jpg"><br> <img data-origin-url="https://ai.esmplus.com/thesingsing/IMAGE/AR/M_AR001/M_AR001_12.jpg" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230327115457_d41d1868d0d040b69a3877c48ab28b47.jpg"> <img data-origin-url="http://ai.esmplus.com/thesingsing/AS/AS.jpg" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230327115457_b3b0992930a2485aaffd1300b4821a81.jpg"></p> \n  <p>&nbsp;</p>\n </body>\n</html>',
    instantOrder: false,
    talkDeal: {
      id: 3269060,
      status: 'AFTER_SALE',
      groupSize: 1,
      period: { from: '20230506170000', to: '20230509235959' },
      ongoingRoomCount: 0,
      discountPrice: 5500,
      discountRate: 36.0,
    },
    benefits: [
      {
        description: '카카오페이 머니로 3만원 이상 결제 시 카카오페이 포인트 2천원 적립 (5/8~5/17, 일부 상품 대상 제외, 인당 1회)',
        landingUrl: 'https://store.kakao.com/mypage/notice/119',
        value: '',
      },
    ],
    delivery: {
      deliveryMethodType: 'DELIVERY',
      optionalDeliveries: [],
      deliveryFeeType: 'FREE',
      deliveryFeePaymentType: 'PREPAID',
      deliveryFee: 0,
      bundleGroupAvailable: false,
      availableIsolatedArea: false,
    },
    originArea: { type: '국내산', content: '', others: false },
    taxDeduction: false,
    gift: { gift: '' },
    quantity: { minPurchase: 1, maxPurchase: 0, maxPurchaseOfBuyer: 0 },
    adultOnly: false,
    isLiquor: false,
    minorPurchasable: true,
    booked: { booked: false },
    notices: [
      {
        id: 40223,
        title: '필독! 공지사항',
        wholeNotice: true,
        content: '<p><img data-animated="false" src="https://st.kakaocdn.net/shoppingstore/editor/20211021124626_bb4780f4619d4c19a366004435729e8f.jpg" /></p>\n',
        createdAt: '20211021124633',
      },
    ],
    reviewUnexposed: false,
    favorite: false,
    reviewCreatable: false,
    store: {
      id: 65639,
      name: '더싱싱몰',
      domain: 'thesingsingmall',
      farmer: true,
      coverImage: 'https://st.kakaocdn.net/shoppingstore/store/20210803172040_240fd67270af43e8b166d611a81873eb.jpg',
      profileImage: 'https://st.kakaocdn.net/shoppingstore/store/20221220105751_e1fa8df8ef8d484882a0ce41ca96c55c.png',
      consultId: '@더싱싱몰',
      channelName: '더싱싱몰',
      channelUrl: 'http://pf.kakao.com/_xlCxlgK',
      subscribed: false,
      fresh: false,
      trackId: '',
    },
    category: { id: '102100103106', name: '청국장' },
    price: {
      standardPrice: 15000,
      discountedPrice: 15000,
      discountRate: 0.0,
      minDiscountedPrice: 15000,
      maxDiscountedPrice: 15000,
      totalDiscountedPrice: 15000,
    },
    events: [],
    review: {
      topReviews: [
        {
          id: '64378de2877cfd6a9e4e3735',
          content: '두번째구매해요. 너무맛있어요.',
          productRating: 4,
          deliveryRating: 4,
          productStarRating: 4,
          deliveryStarRating: 4,
          best: true,
          writer: 'A형여자',
          imageUrl: 'https://st.kakaocdn.net/thumb/S70x70/?fname=https%3A%2F%2Fp.kakaocdn.net%2Fth%2Ftalkp%2FwnUgdtWH6e%2Fnc5jBbKkfhE5K5Yr4srLbk%2F4t65i1_110x110_c.jpg&scode=shoppingstore',
        },
        {
          id: '6437686b877cfd6a9e4e3721',
          content: '배송빠르고 처음 구매한건데 맛있어요~\n큐브모양으로 왔는데 귀여워요',
          productRating: 4,
          deliveryRating: 4,
          productStarRating: 4,
          deliveryStarRating: 4,
          best: true,
          writer: '\uD83D*',
          imageUrl: 'https://st.kakaocdn.net/thumb/S70x70/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fdefault%2Ffriends%2Fv2%2F6.png&scode=shoppingstore',
          backgroundColor: '#eec4c5',
        },
        {
          id: '643ca48b521d1e497d45435e',
          content: '배송도 좋고 맛있어요.',
          productRating: 3,
          deliveryRating: 3,
          productStarRating: 3,
          deliveryStarRating: 3,
          best: true,
          writer: '김부*',
          imageUrl: 'https://st.kakaocdn.net/thumb/S70x70/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fdefault%2Ffriends%2Fv2%2F2.png&scode=shoppingstore',
          backgroundColor: '#cbb7c3',
        },
      ],
      qnaCount: 33,
      reviewCount: 95,
      averageRating: 4,
      totalProductStarRating: 4.0,
      totalDeliveryStarRating: 4.0,
      productPositivePercentage: 98,
      deliveryPositivePercentage: 94,
      productStar1Percentage: 0,
      productStar2Percentage: 2,
      productStar3Percentage: 9,
      productStar4Percentage: 88,
    },
    banners: [],
    sellerProductPoint: {},
  },
  53209039: {
    name: '[EPA+DHA 1,000mg/1일] GNM rTG 알티지오메가3 60캡슐 2박스/비타민E',
    image: {
      imageRatio: 'SQUARE',
      images: ['https://st.kakaocdn.net/thumb/P750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230202131209_904b492441844cfb8db1e7eaa323ae0c.jpg'],
      sharingImageUrl: 'https://st.kakaocdn.net/shoppingstore/product/20230202131209_904b492441844cfb8db1e7eaa323ae0c.jpg',
    },
    status: 'ON_SALE',
    description:
      '<html>\n <head></head>\n <body>\n  <div class="cu-video"> \n   <div class="cu-video-aspect-ratio"> <iframe frameborder="0" src="https://www.youtube.com/embed/HYyEmET4heM"></iframe> \n   </div> \n   <center> <!-- Not Allowed Attribute Filtered ( border="0") -->\n    <img data-origin-url="http://gnmlife.speedgabia.com/details/notice_860.jpg" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20221202171412_d7c7555931524a3695253e2802bad560.jpg"> \n    <br> <!-- Not Allowed Attribute Filtered ( border="0") -->\n    <img data-origin-url="http://gnmlife.speedgabia.com/details/event_banner.jpg" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20221202171412_be197550a06f4139873150a622f0a331.jpg"> \n    <br> <!-- Not Allowed Attribute Filtered ( border="0") -->\n    <img data-origin-url="http://gnmlife.speedgabia.com/details/860_rtg_cosmax_tvcf.jpg" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20221202171412_6877a0c36d00466e97170e7abb9b0a4a.jpg"> \n    <br> <!-- Not Allowed Attribute Filtered ( border="0") -->\n    <img data-origin-url="https://gnmlife.speedgabia.com/details/860_rtg_cosmax.jpg" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20221223183259_f9b4635dfe454cce993c9970135b239f.jpg"> \n   </center> \n  </div>\n </body>\n</html>',
    instantOrder: false,
    benefits: [
      {
        description: '카카오페이 머니로 3만원 이상 결제 시 카카오페이 포인트 2천원 적립 (5/8~5/17, 일부 상품 대상 제외, 인당 1회)',
        landingUrl: 'https://store.kakao.com/mypage/notice/119',
        value: '',
      },
    ],
    delivery: {
      deliveryMethodType: 'DELIVERY',
      optionalDeliveries: [],
      deliveryFeeType: 'FREE',
      deliveryFeePaymentType: 'PREPAID',
      deliveryFee: 0,
      bundleGroupAvailable: true,
      isolatedAreaAdditionalFee: 5000,
      jejuAreaAdditionalFee: 3000,
      availableIsolatedArea: true,
    },
    originArea: { type: '혼합/기타', content: '상세페이지참조', others: false },
    taxDeduction: false,
    gift: { gift: '' },
    quantity: { minPurchase: 1, maxPurchase: 0, maxPurchaseOfBuyer: 0 },
    adultOnly: false,
    isLiquor: false,
    minorPurchasable: true,
    booked: { booked: false },
    notices: [],
    reviewUnexposed: false,
    favorite: false,
    reviewCreatable: false,
    store: {
      id: 2310,
      name: 'GNM자연의품격',
      domain: 'gnmlife',
      farmer: false,
      coverImage: 'https://st.kakaocdn.net/shoppingstore/store/20210810162358_4b186db057de45818d78aa0670871364.jpg',
      profileImage: 'https://st.kakaocdn.net/shoppingstore/store/20230201112144_b50c843620714ac3924102cd5bb2ef0d.jpg',
      consultId: '@gnmlife',
      channelName: 'GNM자연의품격',
      channelUrl: 'http://pf.kakao.com/_JrnZxl',
      subscribed: false,
      fresh: false,
      trackId: '143797823758159857',
    },
    category: { id: '102105105100', name: '오메가3/스쿠알렌' },
    price: {
      standardPrice: 26900,
      discountedPrice: 26900,
      discountRate: 0.0,
      minDiscountedPrice: 26900,
      maxDiscountedPrice: 48900,
      totalDiscountedPrice: 26900,
    },
    events: [],
    review: {
      topReviews: [
        {
          id: '63e4f89e697bd50d31466cbb',
          content: '좋은제품 저렴하게 구입해서 좋아요',
          productRating: 4,
          deliveryRating: 4,
          productStarRating: 4,
          deliveryStarRating: 4,
          best: true,
          writer: 'Le*********',
          imageUrl: 'https://st.kakaocdn.net/thumb/S70x70/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fdefault%2Ffriends%2Fv2%2F10.png&scode=shoppingstore',
          backgroundColor: '#e7eded',
        },
        {
          id: '63e58d07dd61c675ac051cec',
          content: '싸게잘삿네요',
          productRating: 4,
          deliveryRating: 4,
          productStarRating: 4,
          deliveryStarRating: 4,
          best: true,
          writer: '고영*',
          imageUrl: 'https://st.kakaocdn.net/thumb/S70x70/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fdefault%2Ffriends%2Fv2%2F1.png&scode=shoppingstore',
          backgroundColor: '#eec4c5',
        },
        {
          id: '63e5c101ee23c253b4cccf75',
          content: '늘 먹던건데 톡딜에 저렴하게 나왔기래 쟁여놓습니다~',
          productRating: 4,
          deliveryRating: 4,
          productStarRating: 4,
          deliveryStarRating: 4,
          best: true,
          writer: '♡ *******',
          imageUrl: 'https://st.kakaocdn.net/thumb/S70x70/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fdefault%2Ffriends%2Fv2%2F6.png&scode=shoppingstore',
          backgroundColor: '#f5e7d9',
        },
      ],
      qnaCount: 156,
      reviewCount: 1148,
      averageRating: 4,
      totalProductStarRating: 4.0,
      totalDeliveryStarRating: 4.0,
      productPositivePercentage: 99,
      deliveryPositivePercentage: 99,
      productStar1Percentage: 0,
      productStar2Percentage: 0,
      productStar3Percentage: 7,
      productStar4Percentage: 92,
    },
    banners: [],
    sellerProductPoint: {},
  },
  247834660: {
    name: '성주 정품 못난이 꿀참외 3kg 5kg',
    image: {
      imageRatio: 'SQUARE',
      images: [
        'https://st.kakaocdn.net/thumb/P750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230404102418_e19e69467678468b8c042bb7c28c77cd.jpg',
        'https://st.kakaocdn.net/thumb/P750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230404102422_d32ca047e8534be283c2effb423e2a24.jpg',
      ],
      sharingImageUrl:
        'https://st.kakaocdn.net/thumb/C750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230404102418_e19e69467678468b8c042bb7c28c77cd.jpg&mode=watermark&wm_param1=image&wm_id=talkdeal',
    },
    status: 'ON_SALE',
    description:
      '<html>\n <head></head>\n <body>\n  <p><!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_860_6572") --><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230426110305_5d4c5be9ce404b288e96100e79568af4.jpg"><!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_860_8074") --><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230426110305_3fdd9795b2c14d74bf84c97d92f5e1f8.jpg"><!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_860_7761") --><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230426110305_21ce4d89a2e44e528821228210858ea8.jpg"></p> \n  <p><!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_860_9283") --><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230427112725_6b8a63f36c9c433fbe7146668a55d5ac.jpg"></p> \n  <p><!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_860_10579") --><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230503183140_e4e74c1a42234ff782c1196adfca7221.jpg"></p> \n  <p><!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_860_1383") --><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230329143205_f01f5c89791a4979b59c2ff2f876ec6a.jpg"><!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_860_2105") --><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230329143205_a4058a11474a468ab0d95bd06e2f5802.jpg"></p>\n </body>\n</html>',
    instantOrder: false,
    talkDeal: {
      id: 3269379,
      status: 'ON_SALE',
      groupSize: 1,
      period: { from: '20230507090000', to: '20230510235959' },
      ongoingRoomCount: 0,
      discountPrice: 19000,
      discountRate: 51.0,
    },
    benefits: [
      {
        description: '카카오페이 머니로 3만원 이상 결제 시 카카오페이 포인트 2천원 적립 (5/8~5/17, 일부 상품 대상 제외, 인당 1회)',
        landingUrl: 'https://store.kakao.com/mypage/notice/119',
        value: '',
      },
    ],
    delivery: {
      deliveryMethodType: 'DELIVERY',
      optionalDeliveries: [],
      deliveryFeeType: 'FREE',
      deliveryFeePaymentType: 'PREPAID',
      deliveryFee: 0,
      repeatQuantity: 1,
      bundleGroupAvailable: false,
      availableIsolatedArea: false,
    },
    originArea: { type: '국내산', content: '경상북도 성주군', others: false },
    taxDeduction: false,
    gift: { gift: '' },
    quantity: { minPurchase: 1, maxPurchase: 0, maxPurchaseOfBuyer: 0 },
    adultOnly: false,
    isLiquor: false,
    minorPurchasable: true,
    booked: { booked: false },
    notices: [
      {
        id: 73151,
        title: '5월 배송 휴무',
        wholeNotice: true,
        content: '<p><img class="__cu_imgsize_720_540" data-animated="false" src="https://st.kakaocdn.net/shoppingstore/editor/20230502151947_7f8092d9dff44decb27ef6703d456efc.jpg" /></p>\n',
        createdAt: '20230504182919',
      },
    ],
    reviewUnexposed: false,
    favorite: false,
    reviewCreatable: false,
    store: {
      id: 67458,
      name: '한경어게인',
      domain: 'hankyeong',
      farmer: false,
      coverImage: 'https://st.kakaocdn.net/shoppingstore/default/cover/01.png',
      profileImage: 'https://st.kakaocdn.net/shoppingstore/store/20210415132701_e4c2a1966d84401893077cb9ea5737e1.jpeg',
      consultId: '@농민들과함께',
      channelName: '농민들과함께',
      channelUrl: 'http://pf.kakao.com/_ukiUb',
      subscribed: false,
      fresh: false,
      trackId: '',
    },
    category: { id: '102104103105100', name: '참외' },
    price: {
      standardPrice: 36900,
      discountedPrice: 36900,
      discountRate: 0.0,
      minDiscountedPrice: 31900,
      maxDiscountedPrice: 48900,
      totalDiscountedPrice: 17900,
    },
    events: [],
    review: {
      topReviews: [
        {
          id: '64531d1372a9483b32072135',
          content: '과일은 눈으로 보고 사먹자는 신념으로 살았는데 저렴하게 기대않고 주문했는데 완전 대박이네요..맛은 덤으로 따라오네요 맛나게 먹을께요^^',
          productRating: 4,
          deliveryRating: 4,
          productStarRating: 4,
          deliveryStarRating: 4,
          best: true,
          writer: '박동*',
          imageUrl: 'https://st.kakaocdn.net/thumb/S70x70/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fdefault%2Ffriends%2Fv2%2F10.png&scode=shoppingstore',
          backgroundColor: '#e7eded',
        },
        {
          id: '64535d4772a9483b3207215c',
          content:
            '못생긴게 더 맛있다는 말이 딱이에요!\n상품은 못생겼지만 달고 아삭하니 너무 맛잇었어요\n조카 생일상에 이쁜 참외 올리고 많이 못생긴상품은 바로 깍아서 먹었어요\n칼로리가 낮은편에 비해 포만감이 좋아 다이어트에도 좋아요\n맛잇게 먹고 다이어트까지~! 일석이조에요!!',
          productRating: 4,
          deliveryRating: 4,
          productStarRating: 4,
          deliveryStarRating: 4,
          best: true,
          writer: '❤*',
          imageUrl: 'https://st.kakaocdn.net/thumb/S70x70/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fdefault%2Ffriends%2Fv2%2F3.png&scode=shoppingstore',
          backgroundColor: '#eec4c5',
        },
        {
          id: '6454cd2706481f28e13e6270',
          content: '사이즈도 좋고 손상된거 없이 배송왔어요.\n아삭하고 속두 꽉차고 달달해요.',
          productRating: 4,
          deliveryRating: 4,
          productStarRating: 4,
          deliveryStarRating: 4,
          best: true,
          writer: 'h*',
          imageUrl: 'https://st.kakaocdn.net/thumb/S70x70/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fdefault%2Ffriends%2Fv2%2F1.png&scode=shoppingstore',
          backgroundColor: '#d6d6d6',
        },
      ],
      qnaCount: 74,
      reviewCount: 368,
      averageRating: 3,
      totalProductStarRating: 3.5,
      totalDeliveryStarRating: 4.0,
      productPositivePercentage: 83,
      deliveryPositivePercentage: 94,
      productStar1Percentage: 8,
      productStar2Percentage: 8,
      productStar3Percentage: 12,
      productStar4Percentage: 72,
    },
    banners: [],
    sellerProductPoint: {},
  },
  64498390: {
    name: '[지프] 무료배송 (공용) 인기상품  18종택1',
    image: {
      imageRatio: 'SQUARE',
      images: [
        'https://st.kakaocdn.net/thumb/P750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230503143644_2f143599dc6145e28657214e0ff92268.png',
        'https://st.kakaocdn.net/thumb/P750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230409172159_aa8e14b1c02b44f0abfd1b640a70ff0f.png',
      ],
      sharingImageUrl: 'https://st.kakaocdn.net/shoppingstore/product/20230503143644_2f143599dc6145e28657214e0ff92268.png',
    },
    status: 'ON_SALE',
    description:
      '<html>\n <head></head>\n <body>\n  <p style="text-align: center;"><!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_3670_1677") --><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230505011502_47811f711d5c4da4a661dba4f3b7c444.png"></p> \n  <p style="text-align: center;">&nbsp;</p> \n  <p style="text-align: center;"><span style="color:#c0392b;"><strong><span style="font-size:24px;">"♥찜" </span></strong></span><strong><span style="font-size:14px;">을 눌러주세요</span></strong></p> \n  <p style="text-align: center;"><span style="font-size:14px;"><strong>다음행사시 알림이 울립니다.</strong></span></p> \n  <p>&nbsp;</p> \n  <p><!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_1000_842") --><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230505020409_3adc274f174e4a3b8dbb7ef1b1542b42.png"></p> \n  <p>&nbsp;</p> \n  <p>&nbsp;</p> \n  <p style="text-align:center"><span style="font-family:나눔고딕,NanumGothic"><strong><span style="font-size:18px">초등학생부터 성인까지 입는</span></strong></span></p> \n  <p style="text-align:center"><span style="font-family:나눔고딕,NanumGothic"><strong><span style="font-size:18px">(공용)</span></strong></span></p> \n  <p style="text-align:center"><span style="font-family:나눔고딕,NanumGothic"><strong><span style="font-size:18px">인기아이템</span></strong></span></p> \n  <p style="text-align:center"><span style="color:#2980b9;"><span style="font-size:24px"><span style="font-family:나눔고딕,NanumGothic"><strong>&lt;18종 택1&gt;</strong></span></span></span></p> \n  <p style="text-align:center">&nbsp;</p> \n  <p style="text-align:center"><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20220127124516_1bf61a21868b4c69ad38d570391a1a6b.png"></p> \n  <p style="text-align: center;">&nbsp;</p> \n  <p>&nbsp;</p> \n  <p>&nbsp;</p> \n  <p><!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_3410_390") --><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230414043854_a28f04d2e1db49b78286788a488be73b.png"></p> \n  <p style="text-align:center">&nbsp;</p> \n  <p><!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_680_10280") --><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230506154902_4b1c98d17e0a4e62936a06dad5b89029.jpg"></p> \n  <p><!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_680_7991") --><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230506154902_97b43fb7fd3a4808b6d7ca9928154c73.jpg"></p> \n  <p><!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_680_7021") --><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230506154902_2c3f039944e64e24bfa5e772d41fe907.jpg"></p> \n  <p><!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_680_7692") --><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230506154902_61ddb693432a427ebcc612f00c901058.jpg"></p> \n  <p><!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_680_7680") --><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230506154903_d8eaea61b2d94b31979703d1243f997b.jpg"></p> \n  <p><!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_680_10199") --><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230506154903_70839bf52cd74eb880de2265527cd0b0.jpg"></p> \n  <p><!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_433_5261") --><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230503021601_c345982c63cb4de0b649ed7699420399.jpg"></p> \n  <p><!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_433_5629") --><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230503021601_e29838b1c72f463d9f4c2b36434fa840.jpg"></p> \n  <p>&nbsp;</p> \n  <p><!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_432_8041") --><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230506163234_b98d278deda5487d86e6c58bdf6fe7d2.jpg"></p> \n  <p><!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_433_5021") --><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230506164609_96d0aadc5b384b40b1ec50d5096edc94.jpg"></p> \n  <p><!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_433_7516") --><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230506153911_1929738a01fb489eb6e7b1fdc65a8d43.jpg"></p> \n  <p><!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_433_7279") --><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230506153816_a1f131185d9b482c9df1c4c6200e0ea1.jpg"></p> \n  <p>&nbsp;</p> \n  <p><!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_680_9627") --><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230505013806_cfc8ccfa26cd482cb77c18bafdf1f746.jpg"></p> \n  <p><!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_680_8870") --><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230503021624_4c06785eb79a4310ae0545152d1f1501.jpg"></p> \n  <p><!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_680_9748") --><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230503021624_ea100887472a417dbd05086f6b9ba989.jpg"></p> \n  <p><!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_433_3832") --><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230503021624_1c9e971c4f1e41259702a2fd60357e16.jpg"></p> \n  <p><!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_680_10721") --><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230503021625_c66a9f5c36f04536933421fca47cb804.jpg"></p> \n  <p><!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_432_2931") --><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230503021625_acbe7b1f0fe84fdf9f9451b62c2f3514.jpg"></p> \n  <p style="text-align:center"><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20210929165811_7d9b39bff6a346d1b18463e1a6538f81.png"></p> \n  <p><strong><span style="color:#2980b9"><span style="font-size:18px">Q.출고</span></span></strong></p> \n  <p><strong><span style="font-size:14px">A. 매장과 동시판매 상품으로<br> 일부컬러,사이즈가 판매되어&nbsp;상품수급으로<br> <span style="color:#e74c3c">3~4일 지연될수있는점</span>&nbsp;양해부탁드려요~</span></strong></p> \n  <p><strong><span style="color:#2980b9"><span style="font-size:18px">Q.변경</span></span></strong></p> \n  <p><strong><span style="font-size:14px">A.&nbsp;주문후 &lt;주소변경 및 사이즈변경&gt;이 어렵습니다<br> 번거로우시더라도 취소후 재주문 부탁드립니다.</span></strong></p> \n  <p><strong><span style="color:#2980b9"><span style="font-size:18px">Q.배송</span></span></strong></p> \n  <p><strong><span style="font-size:14px">A.&nbsp;시스템상 </span><span style="font-size:18px"><span style="color:#e74c3c">합포장 불가</span></span><span style="font-size:14px"> 개별배송 됩니다.<br> 출고일로부터 (평일2~3일,주말3~5일) 소요되며<br> 택배사 혹은 배송지역에따라&nbsp;지연될수 있습니다.</span></strong><br> &nbsp;</p> \n  <p><span style="font-size:18px"><span style="color:#000000"><strong><span style="background-color:#f1c40f">&nbsp;배송조회▶&nbsp;</span></strong></span><strong><span style="background-color:#f1c40f">CJ대한통운택배 1588-1255&nbsp;</span></strong></span></p> \n  <p>&nbsp;</p> \n  <p><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20220127130807_439dbd37714b4e26910ed3db6d5dd23d.jpg"></p> \n  <div style="text-align:center"> \n   <div style="text-align:center"> \n    <div> \n     <p><span style="color:#c0392b"><strong>*반품 방지탭이 해제된 상품은 반품이 불가합니다.</strong></span></p> \n     <p><span style="color:#c0392b"><strong>*사진은 컴퓨터 모니터 해상도에 따라</strong></span></p> \n     <p><span style="color:#c0392b"><strong>실물과 차이가 있을수있으며 이점은 교환및환불&nbsp;</strong></span></p> \n     <p><span style="color:#c0392b"><strong>사유가 안되므로 이점 유의하시기바랍니다.</strong></span></p> \n     <p><span style="color:#2980b9"><span style="font-size:14px"><strong><span style="background-color:#ffffff">*사진 및 배너이미지는 무단배포를 금합니다.</span></strong></span></span></p> \n     <p>&nbsp;</p> \n    </div> \n    <hr> \n    <p><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20210112223034_cedd7bfa8ebe44bd98bd8646081eeb8a.jpg"></p> \n   </div> \n  </div> \n  <div style="text-align:start"> \n   <div style="text-align:center">\n     &nbsp; \n   </div> \n  </div> \n  <div style="text-align:start"> \n   <div style="text-align:center"> \n    <p><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20210112223034_a5d96dfdd6b0413da604814bf628fa49.jpg"></p> \n    <p><!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_1898_1525") --><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20221223004511_cd57e3ccce12427dba2c429304b0db39.png"></p> \n   </div> \n  </div>\n </body>\n</html>',
    instantOrder: false,
    talkDeal: {
      id: 3268959,
      status: 'AFTER_SALE',
      groupSize: 1,
      period: { from: '20230506170000', to: '20230509235959' },
      ongoingRoomCount: 0,
      discountPrice: 16300,
      discountRate: 46.0,
    },
    benefits: [
      {
        description: '카카오페이 머니로 3만원 이상 결제 시 카카오페이 포인트 2천원 적립 (5/8~5/17, 일부 상품 대상 제외, 인당 1회)',
        landingUrl: 'https://store.kakao.com/mypage/notice/119',
        value: '',
      },
    ],
    delivery: {
      deliveryMethodType: 'DELIVERY',
      optionalDeliveries: [],
      deliveryFeeType: 'FREE',
      deliveryFeePaymentType: 'PREPAID',
      deliveryFee: 0,
      freeConditionalAmount: 30000,
      bundleGroupAvailable: true,
      availableIsolatedArea: true,
    },
    taxDeduction: false,
    gift: { gift: '' },
    quantity: { minPurchase: 1, maxPurchase: 0, maxPurchaseOfBuyer: 0 },
    adultOnly: false,
    isLiquor: false,
    minorPurchasable: true,
    booked: { booked: false },
    notices: [],
    reviewUnexposed: false,
    favorite: false,
    reviewCreatable: false,
    store: {
      id: 35979,
      name: '현대백화점 판교점',
      domain: 'hdpangyo',
      farmer: false,
      coverImage: 'https://st.kakaocdn.net/shoppingstore/default/cover/02.png',
      profileImage: 'https://st.kakaocdn.net/shoppingstore/store/20200616115712_a14275635cb04f32a8ee2d1e6dad879f.jpg',
      channelName: '현대백화점 판교점',
      channelUrl: 'http://pf.kakao.com/_VrMku',
      subscribed: false,
      fresh: false,
      trackId: '',
    },
    category: { id: '101104101100', name: '남성 라운드넥 티셔츠' },
    price: {
      standardPrice: 35000,
      discountedPrice: 35000,
      discountRate: 0.0,
      minDiscountedPrice: 35000,
      maxDiscountedPrice: 68000,
      totalDiscountedPrice: 35000,
    },
    events: [],
    review: {
      topReviews: [
        {
          id: '63ed6c399ef1723a7501198a',
          content: '쓰고보니까 새마을 운동 모자같아서 ㅜ\n어떻게 잘 써 볼게요 ㅎ\n저렴한 가격에 잘 샀어요',
          productRating: 4,
          deliveryRating: 4,
          productStarRating: 4,
          deliveryStarRating: 4,
          best: true,
          writer: '이은*',
          imageUrl: 'https://st.kakaocdn.net/thumb/S70x70/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fdefault%2Ffriends%2Fv2%2F1.png&scode=shoppingstore',
          backgroundColor: '#e7eded',
        },
        {
          id: '63f31e768ea9dc623ed8f8d0',
          content: '모자가 예뻐요^^창이 길어서더 좋네요',
          productRating: 4,
          deliveryRating: 4,
          productStarRating: 4,
          deliveryStarRating: 4,
          best: true,
          writer: '문미숙',
          imageUrl: 'https://st.kakaocdn.net/thumb/S70x70/?fname=https%3A%2F%2Fp.kakaocdn.net%2Fth%2Ftalkp%2FwnWsOSLHye%2F0AzS7zjiSDenvGqGOVgd30%2Fwxp53l_110x110_c.jpg&scode=shoppingstore',
        },
        {
          id: '63ecf8c369e3bf1c9388625a',
          content: '정사이즈라는데 좀 크네요\n옷은 맘에 들어요.\n목이 짧은 분은 비추^^',
          productRating: 4,
          deliveryRating: 4,
          productStarRating: 4,
          deliveryStarRating: 4,
          best: true,
          writer: '잘될*****',
          imageUrl: 'https://st.kakaocdn.net/thumb/S70x70/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fdefault%2Ffriends%2Fv2%2F9.png&scode=shoppingstore',
          backgroundColor: '#e7eded',
        },
      ],
      qnaCount: 1390,
      reviewCount: 1332,
      averageRating: 4,
      totalProductStarRating: 4.0,
      totalDeliveryStarRating: 4.0,
      productPositivePercentage: 96,
      deliveryPositivePercentage: 95,
      productStar1Percentage: 2,
      productStar2Percentage: 2,
      productStar3Percentage: 18,
      productStar4Percentage: 78,
    },
    banners: [],
    sellerProductPoint: {},
  },
  24832184: {
    name: '[여름철 필수템]쉬크 인튜이션 기획팩 (제모기+날4입) + 프리미엄 눈썹칼 4개 외',
    image: {
      imageRatio: 'SQUARE',
      images: [
        'https://st.kakaocdn.net/thumb/P750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230426163721_d244541209b946f79176190af94b5f79.jpg',
        'https://st.kakaocdn.net/thumb/P750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230426163726_22f87645de164e2b96b43a13bc15f16a.jpg',
        'https://st.kakaocdn.net/thumb/P750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230426173343_995265f8ef804b2d94f4dfb3e9036f8e.jpg',
        'https://st.kakaocdn.net/thumb/P750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230426173346_40798a41add14b368113e4ffdd967a39.jpg',
      ],
      sharingImageUrl: 'https://st.kakaocdn.net/shoppingstore/product/20230426163721_d244541209b946f79176190af94b5f79.jpg',
    },
    status: 'CLOSE',
    description:
      '<html>\n <head></head>\n <body>\n  <p><!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_860_1452") --><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230503172925_c7e4131b7bd54a3eb0fa5e0fc88cbe63.jpg"><!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_860_2542") --><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230503172928_d4527033cf8b4029ab73b3352d05b7e3.jpg"><img data-origin-url="https://lghnh1.diskn.com/y7GWCyhzra" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230324153457_d4c0005fd91246678e394a3bc559687d"><!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_780_13899") --><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230506175301_298c81a97e7741228d270a1629048330.jpg"><!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_860_10650") --><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230324154845_261439e8d418489a8b7ba492a27cb093.jpg"><!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_860_10680") --><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230324154910_355cde46d8bd4bc892a20830092c3768.jpg"><!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_758_13044") --><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230324154510_f853d1f031d24d4589894f807a50f900.jpg"><img data-origin-url="https://lghnh1.diskn.com/G7GWCi0jiU" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230324153458_7847cdcc6c5546bea3c04249ff56152d"><img data-origin-url="https://lghnh1.diskn.com/p7GWCioVCu" src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230324153458_3bd1a8364f4b45cc930522574fd287d9"><!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_750_12150") --><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230405113402_3c27fe6133944a35a4d0d3a9a70c28d9.jpg"><!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_780_9498") --><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230224161645_89c553e2b01a4854a57d2d471442be99.jpg"><!-- Not Allowed Attribute Filtered ( class="__cu_imgsize_750_12240") --><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230404132738_b727bc25830a43e89bd2dc5d923118ba.jpg"></p>\n </body>\n</html>',
    instantOrder: false,
    benefits: [
      {
        description: '카카오페이 머니로 3만원 이상 결제 시 카카오페이 포인트 2천원 적립 (5/8~5/17, 일부 상품 대상 제외, 인당 1회)',
        landingUrl: 'https://store.kakao.com/mypage/notice/119',
        value: '',
      },
    ],
    delivery: {
      deliveryMethodType: 'DELIVERY',
      optionalDeliveries: [],
      deliveryFeeType: 'FREE',
      deliveryFeePaymentType: 'PREPAID',
      deliveryFee: 0,
      bundleGroupAvailable: true,
      availableIsolatedArea: true,
    },
    taxDeduction: false,
    gift: { gift: '' },
    quantity: { minPurchase: 1, maxPurchase: 0, maxPurchaseOfBuyer: 0 },
    adultOnly: false,
    isLiquor: false,
    minorPurchasable: true,
    booked: { booked: false },
    notices: [],
    reviewUnexposed: false,
    favorite: false,
    reviewCreatable: false,
    store: {
      id: 2530,
      name: 'LG생활건강',
      domain: 'lgcare',
      farmer: false,
      coverImage: 'https://st.kakaocdn.net/shoppingstore/store/20190828094255_c592602e503f4b308f106c707d4f6ae2.jpg',
      profileImage: 'https://st.kakaocdn.net/shoppingstore/store/20180906172400_1455a346d67045d2a8e82e1b71145b1b.jpeg',
      channelName: 'LG생활건강 직영',
      channelUrl: 'http://pf.kakao.com/_xaKgxhj',
      subscribed: false,
      fresh: false,
      trackId: '568260606456383071',
    },
    category: { id: '101103100104', name: '제모제' },
    price: {
      standardPrice: 29900,
      discountedPrice: 29900,
      discountRate: 0.0,
      minDiscountedPrice: 23000,
      maxDiscountedPrice: 35900,
      totalDiscountedPrice: 29900,
    },
    events: [],
    review: {
      topReviews: [
        {
          id: '6458f3dcdfb8e85ed0600af0',
          content: '사용전입니다. 잘 사용해볼게요!',
          productRating: 4,
          deliveryRating: 4,
          productStarRating: 4,
          deliveryStarRating: 4,
          best: true,
          writer: '김*',
          imageUrl: 'https://st.kakaocdn.net/thumb/S70x70/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fdefault%2Ffriends%2Fv2%2F8.png&scode=shoppingstore',
          backgroundColor: '#e7eded',
        },
        {
          id: '6458b3d054637d08ca9e1583',
          content: '싸게잘샀어요~~ 배송도 완전빨라요~',
          productRating: 4,
          deliveryRating: 4,
          productStarRating: 4,
          deliveryStarRating: 4,
          best: true,
          writer: '아이*',
          imageUrl: 'https://st.kakaocdn.net/thumb/S70x70/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fdefault%2Ffriends%2Fv2%2F10.png&scode=shoppingstore',
          backgroundColor: '#cbb7c3',
        },
        {
          id: '645908e97da2d8147682a3e9',
          content: '좋은 상품을 착한 가격에 구매했네요 ^^',
          productRating: 4,
          deliveryRating: 4,
          productStarRating: 4,
          deliveryStarRating: 4,
          best: true,
          writer: '샤*',
          imageUrl: 'https://st.kakaocdn.net/thumb/S70x70/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fdefault%2Ffriends%2Fv2%2F1.png&scode=shoppingstore',
          backgroundColor: '#e7eded',
        },
      ],
      qnaCount: 5,
      reviewCount: 23,
      averageRating: 4,
      totalProductStarRating: 4.0,
      totalDeliveryStarRating: 4.0,
      productPositivePercentage: 100,
      deliveryPositivePercentage: 100,
      productStar1Percentage: 0,
      productStar2Percentage: 0,
      productStar3Percentage: 4,
      productStar4Percentage: 96,
    },
    banners: [],
    sellerProductPoint: {},
  },
  164308681: {
    name: '오리온 인기스낵 4+3+3 포카칩,스윙칩,눈을감자,무뚝뚝',
    image: {
      imageRatio: 'SQUARE',
      images: ['https://st.kakaocdn.net/thumb/P750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230502144610_adb744ff5cb449af9422c905dca1931a.jpg'],
      sharingImageUrl: 'https://st.kakaocdn.net/shoppingstore/product/20230502144610_adb744ff5cb449af9422c905dca1931a.jpg',
    },
    status: 'ON_SALE',
    description:
      '<html>\n <head></head>\n <body>\n  <center> \n   <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230502145345_2295e9fecb3246c6b4d7f56fca19114e.jpg" data-origin-url="https://gi.esmplus.com/allorion/main_1.jpg"> \n   <br> \n   <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230502145345_601e5ec670fb4eefaf34bdefa2311f2c.jpg" data-origin-url="https://gi.esmplus.com/allorion/date.jpg"> \n   <br> \n   <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230502145345_ceea7b5ca1284dc88112366071e71ab6.jpg" data-origin-url="https://ai.esmplus.com/all2015/themall/kakao/orion/event/talk_deal/230502/intro.jpg"> \n   <br> \n   <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230502145346_201e138068604a06ad30ac1a12e28fcc.jpg" data-origin-url="https://ai.esmplus.com/all2015/themall/kakao/orion/event/talk_deal/230502/op.jpg"> \n   <br> \n   <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230502145346_84e56895def34c80a7e692c5e2dc9801.jpg" data-origin-url="https://gi.esmplus.com/allorion/biscuit/tonk/choco/everyones_tonk/1/op_1.jpg"> \n   <br> \n   <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230502145347_1427cff22b80475ea8ab536d6b02850b.jpg" data-origin-url="https://gi.esmplus.com/allorion/set/seollem_yubal/1/list_1.jpg"> \n   <br> \n   <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230502145347_c0b6cb1cfd4c4c439477e3323db798d4.jpg" data-origin-url="https://gi.esmplus.com/allorion/set/radu_songe_set/songe/1/op.jpg"> \n   <br> \n   <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230502145347_930168a999294182858e74a7310ae266.jpg" data-origin-url="https://gi.esmplus.com/allorion/set/radu_songe_set/radu/1/op.jpg"> \n   <br> \n   <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230502145347_702c75a6ae43497db587dde87fdf2cf3.jpg" data-origin-url="https://gi.esmplus.com/allorion/set/play_snack/play_snack_list_1.jpg"> \n   <br> \n   <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230502145348_7f7a0244be7847b68ae1a10fb850b140.jpg" data-origin-url="https://gi.esmplus.com/allorion/set/dalkom_seolab/1/op_1.jpg"> \n   <br> \n   <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230502145348_51712c98f8f74c4e91921e607b3f75f5.jpg" data-origin-url="https://ai.esmplus.com/all2015/themall/kakao/orion/event/talk_deal/230502/info/info_01.jpg"> \n   <br> \n   <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230502145349_a651dd5616944a76857dd8847da32af3.jpg" data-origin-url="https://ai.esmplus.com/all2015/themall/kakao/orion/event/talk_deal/230502/info/info_02.jpg"> \n   <br> \n   <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230502145349_77237aa8bef54ec38a50e6d38e50f58e.jpg" data-origin-url="https://ai.esmplus.com/all2015/themall/kakao/orion/event/talk_deal/230502/info/info_03.jpg"> \n   <br> \n   <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230502145349_b6bfb13aa1ed4aee8c75abe1d84ff277.jpg" data-origin-url="https://ai.esmplus.com/all2015/themall/kakao/orion/event/talk_deal/230502/info/info_04.jpg"> \n   <br> \n   <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230502145350_bbceda7140c34c4193b08ddb567151bd.jpg" data-origin-url="https://ai.esmplus.com/all2015/themall/kakao/orion/event/talk_deal/230502/info/info_05.jpg"> \n   <br> \n   <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230502145351_beb95d225c2446cd892c734afa00a45d.jpg" data-origin-url="https://ai.esmplus.com/all2015/themall/kakao/orion/event/talk_deal/230502/info/info_06.jpg"> \n   <br> \n   <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230502145351_7dde43a3010a4b4d917ee7e51f8abb44.jpg" data-origin-url="https://gi.esmplus.com/allorion/delivery.jpg"> \n   <br> \n  </center>\n </body>\n</html>',
    instantOrder: false,
    talkDeal: {
      id: 3269400,
      status: 'AFTER_SALE',
      groupSize: 1,
      period: { from: '20230506170000', to: '20230509235959' },
      ongoingRoomCount: 0,
      discountPrice: 5000,
      discountRate: 33.0,
    },
    benefits: [
      {
        description: '카카오페이 머니로 3만원 이상 결제 시 카카오페이 포인트 2천원 적립 (5/8~5/17, 일부 상품 대상 제외, 인당 1회)',
        landingUrl: 'https://store.kakao.com/mypage/notice/119',
        value: '',
      },
    ],
    delivery: {
      deliveryMethodType: 'DELIVERY',
      optionalDeliveries: [],
      deliveryFeeType: 'FREE',
      deliveryFeePaymentType: 'PREPAID',
      deliveryFee: 0,
      freeConditionalAmount: 0,
      repeatQuantity: 10,
      bundleGroupAvailable: false,
      isolatedAreaAdditionalFee: 6000,
      jejuAreaAdditionalFee: 3000,
      availableIsolatedArea: true,
    },
    originArea: { type: '혼합/기타', content: '기타국가', others: false },
    taxDeduction: false,
    gift: { gift: '' },
    quantity: { minPurchase: 0, maxPurchase: 999, maxPurchaseOfBuyer: 999 },
    adultOnly: false,
    isLiquor: false,
    minorPurchasable: true,
    booked: { booked: false },
    notices: [
      {
        id: 72462,
        title: '5월배송일정',
        wholeNotice: true,
        content: '<p><img class="__cu_imgsize_860_1176" data-animated="false" src="https://st.kakaocdn.net/shoppingstore/editor/20230428085151_5a6e0c0c35d04d0993949ee4c6b55dff.jpg" /></p>\n',
        createdAt: '20230428085200',
      },
    ],
    reviewUnexposed: false,
    favorite: false,
    reviewCreatable: false,
    store: {
      id: 15894,
      name: '오리온공식판매점',
      domain: 'orionstore',
      farmer: false,
      coverImage: 'https://st.kakaocdn.net/shoppingstore/default/cover/02.png',
      profileImage: 'https://st.kakaocdn.net/shoppingstore/store/20230302165639_3039f3be72884378b2bbe2c413e295ae.jpg',
      channelName: '오리온 공식 판매점',
      channelUrl: 'http://pf.kakao.com/_ZVVrxb',
      subscribed: false,
      fresh: false,
      trackId: '',
    },
    category: { id: '102109100', name: '과자/쿠키' },
    price: {
      standardPrice: 15000,
      discountedPrice: 15000,
      discountRate: 0.0,
      minDiscountedPrice: 15000,
      maxDiscountedPrice: 21500,
      totalDiscountedPrice: 15000,
    },
    events: [],
    review: {
      topReviews: [
        {
          id: '6401f2bb3161845154b651c2',
          content: '무뚝뚝한 고구마칩이4봉이나 있는 구성인데 저렴하네? 했더니 양이 찌깐한거였네요... ㅎㅎ 마트랑 비교했을때 그리 저렴한건지는 모르겠지만 맛있으니 만족~♡',
          productRating: 4,
          deliveryRating: 4,
          productStarRating: 4,
          deliveryStarRating: 4,
          best: true,
          writer: 'ch***',
          imageUrl: 'https://st.kakaocdn.net/thumb/S70x70/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fdefault%2Ffriends%2Fv2%2F5.png&scode=shoppingstore',
          backgroundColor: '#f5e7d9',
        },
        {
          id: '6406e85924b83f6a39078628',
          content: '스윙칩 4\n갈릭 스윙칩 4\n치킨팝 2\n과자 10개 9900원 정말 짱이네용!!\n도착일: 23.03.07.\n유통기한: 23.07.20.',
          productRating: 4,
          deliveryRating: 4,
          productStarRating: 4,
          deliveryStarRating: 4,
          best: true,
          writer: '유예*',
          imageUrl: 'https://st.kakaocdn.net/thumb/S70x70/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fdefault%2Ffriends%2Fv2%2F5.png&scode=shoppingstore',
          backgroundColor: '#e7eded',
        },
        {
          id: '640310ee65d5580350b72984',
          content:
            '볶음고추장맛 스윙칩을 자주 먹어요. 갈릭디핑소스랑 각각 4개씩, 그리고 치킨팝 2개 받았습니다. 볶음고추장맛 때문에 주문했는데, 갈릭디핑소스도 나쁘지 않네요. 치킨팝은 닭강정 맛이라는데, 좀 뜯기가 겁나네요. 요즘 편의점에서 과자 한봉지에 1700~1800원 정도 하는데, 반값 정도에 구매해서 아주 만족합니다. 소비기한도 7~8월이라 나름 넉넉하고, 요즘같이 과자가 비싼 시절에 군것질 좋아한다면 이렇게 좋은 가격에 구매해 보면 좋을 거 같아요.',
          productRating: 4,
          deliveryRating: 4,
          productStarRating: 4,
          deliveryStarRating: 4,
          best: true,
          writer: 'Hy********',
          imageUrl: 'https://st.kakaocdn.net/thumb/S70x70/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fdefault%2Ffriends%2Fv2%2F2.png&scode=shoppingstore',
          backgroundColor: '#f5e7d9',
        },
      ],
      qnaCount: 343,
      reviewCount: 1476,
      averageRating: 4,
      totalProductStarRating: 4.0,
      totalDeliveryStarRating: 4.0,
      productPositivePercentage: 99,
      deliveryPositivePercentage: 96,
      productStar1Percentage: 1,
      productStar2Percentage: 1,
      productStar3Percentage: 4,
      productStar4Percentage: 95,
    },
    banners: [],
    sellerProductPoint: {},
  },
  227497376: {
    name: '[코코블랑] 23 여름신상 반팔니트 9900원 외 100종 최대할인',
    image: {
      imageRatio: 'SQUARE',
      images: [
        'https://st.kakaocdn.net/thumb/P750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230503154913_4d9c5a4dda024f7a92c71168866f788b.jpg',
        'https://st.kakaocdn.net/thumb/P750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230503154918_467e5fa38f954f3ea106921d3947da95.jpg',
      ],
      sharingImageUrl: 'https://st.kakaocdn.net/shoppingstore/product/20230503154913_4d9c5a4dda024f7a92c71168866f788b.jpg',
    },
    status: 'ON_SALE',
    description:
      '<html>\n <head></head>\n <body>\n  <center> <!-- Not Allowed Attribute Filtered ( oncontextmenu="return false" ondragdtart="return false" onselectstart="return false") -->\n   <img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230503154929_56982ac40e884118af8ae7b4197a2871.jpg" data-origin-url="https://ai.esmplus.com/cocoblanc1/20230506_kakao/A_1.jpg"> \n   <center> \n    <table border="0" cellspacing="0" cellpadding="0"> \n     <tbody> \n      <tr> \n       <td><a href="https://ai.esmplus.com/cocoblanc1/20230506_kakao/D1-/D_1.html"><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230503154929_b261973f1c3a4e1680d3faef0614ac8d.jpg" data-origin-url="https://ai.esmplus.com/cocoblanc1/20230506_kakao/B1-/B_1.jpg"></a></td> \n      </tr> \n      <tr> \n       <td><a href="https://ai.esmplus.com/cocoblanc1/20230506_kakao/D1-/D_2.html"><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230503154930_e9c7064d7fbf4311929d65d33b2a51da.jpg" data-origin-url="https://ai.esmplus.com/cocoblanc1/20230506_kakao/B1-/B_2.jpg"></a></td> \n      </tr> \n      <tr> \n       <td><a href="https://ai.esmplus.com/cocoblanc1/20230506_kakao/D1-/D_3.html"><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230503154930_f4f07c31f9814cb0aab917e659414679.jpg" data-origin-url="https://ai.esmplus.com/cocoblanc1/20230506_kakao/B1-/B_3.jpg"></a></td> \n      </tr> \n      <tr> \n       <td><a href="https://ai.esmplus.com/cocoblanc1/20230506_kakao/D1-/D_4.html"><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230503154932_4dcf0e87a8c745d0abcde1fe88ccd1e7.jpg" data-origin-url="https://ai.esmplus.com/cocoblanc1/20230506_kakao/B1-/B_4.jpg"></a></td> \n      </tr> \n      <tr> \n       <td><a href="https://ai.esmplus.com/cocoblanc1/20230506_kakao/D1-/D_5.html"><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230503154933_9b07cf3616d44fa1a0e32578a286648f.jpg" data-origin-url="https://ai.esmplus.com/cocoblanc1/20230506_kakao/B1-/B_5.jpg"></a></td> \n      </tr> \n      <tr> \n       <td><a href="https://ai.esmplus.com/cocoblanc1/20230506_kakao/D1-/D_6.html"><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230503154934_d7486af9a77a40dbad291ebec5d907b7.jpg" data-origin-url="https://ai.esmplus.com/cocoblanc1/20230506_kakao/B1-/B_6.jpg"></a></td> \n      </tr> \n      <tr> \n       <td><a href="https://ai.esmplus.com/cocoblanc1/20230506_kakao/D1-/D_7.html"><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230503154934_293b5f6ea9d846f68e3a5ce8310f73a0.jpg" data-origin-url="https://ai.esmplus.com/cocoblanc1/20230506_kakao/B1-/B_7.jpg"></a></td> \n      </tr> \n      <tr> \n       <td><a href="https://ai.esmplus.com/cocoblanc1/20230506_kakao/D1-/D_8.html"><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230503154935_1efe32bde8f344529f6b9ac6bf4ae0a1.jpg" data-origin-url="https://ai.esmplus.com/cocoblanc1/20230506_kakao/B1-/B_8.jpg"></a></td> \n      </tr> \n      <tr> \n       <td><a href="https://ai.esmplus.com/cocoblanc1/20230506_kakao/D1-/D_9.html"><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230503154935_b56dd82b192846d994db8ef036955134.jpg" data-origin-url="https://ai.esmplus.com/cocoblanc1/20230506_kakao/B1-/B_9.jpg"></a></td> \n      </tr> \n      <tr> \n       <td><a href="https://ai.esmplus.com/cocoblanc1/20230506_kakao/D1-/D_10.html"><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230503154936_7e025bfca4934e1ebf8f4aabbf498b58.jpg" data-origin-url="https://ai.esmplus.com/cocoblanc1/20230506_kakao/B1-/B_10.jpg"></a></td> \n      </tr> \n      <tr> \n       <td><a href="https://ai.esmplus.com/cocoblanc1/20230506_kakao/D1-/D_11.html"><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230503154937_0c8b0cc08b84476d94d6df7ca550e89f.jpg" data-origin-url="https://ai.esmplus.com/cocoblanc1/20230506_kakao/B1-/B_11.jpg"></a></td> \n      </tr> \n      <tr> \n       <td><a href="https://ai.esmplus.com/cocoblanc1/20230506_kakao/D1-/D_12.html"><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230503154938_8cdedca0791c41d5bc02c4a61bb5f930.jpg" data-origin-url="https://ai.esmplus.com/cocoblanc1/20230506_kakao/B1-/B_12.jpg"></a></td> \n      </tr> \n      <tr> \n       <td><a href="https://ai.esmplus.com/cocoblanc1/20230506_kakao/D1-/D_13.html"><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230503154939_f17f12ad0af243c6b21198bbc5c9bb5a.jpg" data-origin-url="https://ai.esmplus.com/cocoblanc1/20230506_kakao/B1-/B_13.jpg"></a></td> \n      </tr> \n      <tr> \n       <td><a href="https://ai.esmplus.com/cocoblanc1/20230506_kakao/D1-/D_14.html"><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230503154940_b6a1a71d4b864d58b01b64579e35a067.jpg" data-origin-url="https://ai.esmplus.com/cocoblanc1/20230506_kakao/B1-/B_14.jpg"></a></td> \n      </tr> \n      <tr> \n       <td><a href="https://ai.esmplus.com/cocoblanc1/20230506_kakao/D1-/D_15.html"><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230503154940_6d90cd9bf55e4aa49c8e3b6e9f9316f6.jpg" data-origin-url="https://ai.esmplus.com/cocoblanc1/20230506_kakao/B1-/B_15.jpg"></a></td> \n      </tr> \n      <tr> \n       <td><a href="https://ai.esmplus.com/cocoblanc1/20230506_kakao/D1-/D_16.html"><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230503154944_c081ea8c1a204dc3b75e3bd93ff6e426.jpg" data-origin-url="https://ai.esmplus.com/cocoblanc1/20230506_kakao/B1-/B_16.jpg"></a></td> \n      </tr> \n      <tr> \n       <td><a href="https://ai.esmplus.com/cocoblanc1/20230506_kakao/D1-/D_17.html"><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230503154944_09a6df1856854c4b9d334680a2604dac.jpg" data-origin-url="https://ai.esmplus.com/cocoblanc1/20230506_kakao/B1-/B_17.jpg"></a></td> \n      </tr> \n      <tr> \n       <td><a href="https://ai.esmplus.com/cocoblanc1/20230506_kakao/D1-/D_18.html"><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230503154944_5344f8bedce84e10b0e0c60a22a289fa.jpg" data-origin-url="https://ai.esmplus.com/cocoblanc1/20230506_kakao/B1-/B_18.jpg"></a></td> \n      </tr> \n      <tr> \n       <td><a href="https://ai.esmplus.com/cocoblanc1/20230506_kakao/D1-/D_19.html"><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230503154945_61da8bd4b03847bea67c2203e06316cd.jpg" data-origin-url="https://ai.esmplus.com/cocoblanc1/20230506_kakao/B1-/B_19.jpg"></a></td> \n      </tr> \n      <tr> \n       <td><a href="https://ai.esmplus.com/cocoblanc1/20230506_kakao/D1-/D_20.html"><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230503154945_a4b9c9ae93d94553ab2a38ae0e5af430.jpg" data-origin-url="https://ai.esmplus.com/cocoblanc1/20230506_kakao/B1-/B_20.jpg"></a></td> \n      </tr> \n      <tr> \n       <td><a href="https://ai.esmplus.com/cocoblanc1/20230506_kakao/D1-/D_21.html"><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230503154945_800435beb0714bce80a422ae6f3bc477.jpg" data-origin-url="https://ai.esmplus.com/cocoblanc1/20230506_kakao/B1-/B_21.jpg"></a></td> \n      </tr> \n      <tr> \n       <td><a href="https://ai.esmplus.com/cocoblanc1/20230506_kakao/D1-/D_22.html"><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230503154946_b441e3f6a19640559cd4d719c16620d9.jpg" data-origin-url="https://ai.esmplus.com/cocoblanc1/20230506_kakao/B1-/B_22.jpg"></a></td> \n      </tr> \n      <tr> \n       <td><a href="https://ai.esmplus.com/cocoblanc1/20230506_kakao/D1-/D_23.html"><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230503154947_d20c3c2413aa4474b3ff8d5bdce55038.jpg" data-origin-url="https://ai.esmplus.com/cocoblanc1/20230506_kakao/B1-/B_23.jpg"></a></td> \n      </tr> \n      <tr> \n       <td><a href="https://ai.esmplus.com/cocoblanc1/20230506_kakao/D1-/D_24.html"><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230503154947_cd09d8716fe6416f9c664b90104a0ac7.jpg" data-origin-url="https://ai.esmplus.com/cocoblanc1/20230506_kakao/B1-/B_24.jpg"></a></td> \n      </tr> \n      <tr> \n       <td><a href="https://ai.esmplus.com/cocoblanc1/20230506_kakao/D1-/D_25.html"><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230503154948_67efbe9a536c493d89447d7bfea5b227.jpg" data-origin-url="https://ai.esmplus.com/cocoblanc1/20230506_kakao/B1-/B_25.jpg"></a></td> \n      </tr> \n      <tr> \n       <td><a href="https://ai.esmplus.com/cocoblanc1/20230506_kakao/D1-/D_26.html"><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230503154948_9f5941a299a64b6faca981b000e180cb.jpg" data-origin-url="https://ai.esmplus.com/cocoblanc1/20230506_kakao/B1-/B_26.jpg"></a></td> \n      </tr> \n      <tr> \n       <td><a href="https://ai.esmplus.com/cocoblanc1/20230506_kakao/D1-/D_27.html"><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230503154949_2ebdc51bc6d74f0a88b06b7659a5f412.jpg" data-origin-url="https://ai.esmplus.com/cocoblanc1/20230506_kakao/B1-/B_27.jpg"></a></td> \n      </tr> \n      <tr> \n       <td><a href="https://ai.esmplus.com/cocoblanc1/20230506_kakao/D1-/D_28.html"><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230503154949_4682843a746d4c109455dcee7477a3df.jpg" data-origin-url="https://ai.esmplus.com/cocoblanc1/20230506_kakao/B1-/B_28.jpg"></a></td> \n      </tr> \n      <tr> \n       <td><a href="https://ai.esmplus.com/cocoblanc1/20230506_kakao/D1-/D_29.html"><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230503154950_cc303afae921425a986b19e647cad799.jpg" data-origin-url="https://ai.esmplus.com/cocoblanc1/20230506_kakao/B1-/B_29.jpg"></a></td> \n      </tr> \n      <tr> \n       <td><a href="https://ai.esmplus.com/cocoblanc1/20230506_kakao/D1-/D_30.html"><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230503154950_fc943dc35bda4c279bb15360343432fb.jpg" data-origin-url="https://ai.esmplus.com/cocoblanc1/20230506_kakao/B1-/B_30.jpg"></a></td> \n      </tr> \n      <tr> \n       <td><a href="https://ai.esmplus.com/cocoblanc1/20230506_kakao/D1-/D_31.html"><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230503154950_279b6f6f5f7f48e7979f091eb54e3583.jpg" data-origin-url="https://ai.esmplus.com/cocoblanc1/20230506_kakao/B1-/B_31.jpg"></a></td> \n      </tr> \n      <tr> \n       <td><a href="https://ai.esmplus.com/cocoblanc1/20230506_kakao/D1-/D_32.html"><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230503154951_2a70cdc65fd5476cafa07a041ca9286b.jpg" data-origin-url="https://ai.esmplus.com/cocoblanc1/20230506_kakao/B1-/B_32.jpg"></a></td> \n      </tr> \n      <tr> \n       <td><a href="https://ai.esmplus.com/cocoblanc1/20230506_kakao/D1-/D_33.html"><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230503154951_fa85eea221284fa191808bfe75696879.jpg" data-origin-url="https://ai.esmplus.com/cocoblanc1/20230506_kakao/B1-/B_33.jpg"></a></td> \n      </tr> \n      <tr> \n       <td><a href="https://ai.esmplus.com/cocoblanc1/20230506_kakao/D1-/D_34.html"><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230503154952_806da5b6a2a241bebc8e4385255281f7.jpg" data-origin-url="https://ai.esmplus.com/cocoblanc1/20230506_kakao/B1-/B_34.jpg"></a></td> \n      </tr> \n      <tr> \n       <td><a href="https://ai.esmplus.com/cocoblanc1/20230506_kakao/D1-/D_35.html"><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230503154952_5665173d7e164880bb7ace1219f56280.jpg" data-origin-url="https://ai.esmplus.com/cocoblanc1/20230506_kakao/B1-/B_35.jpg"></a></td> \n      </tr> \n      <tr> \n       <td><a href="https://ai.esmplus.com/cocoblanc1/20230506_kakao/D1-/D_36.html"><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230503154953_27ed1286c2e5490fbe808aced2ffb10f.jpg" data-origin-url="https://ai.esmplus.com/cocoblanc1/20230506_kakao/B1-/B_36.jpg"></a></td> \n      </tr> \n      <tr> \n       <td><a href="https://ai.esmplus.com/cocoblanc1/20230506_kakao/D1-/D_37.html"><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230503154954_e616bb1831474b9996d59d786bcee24a.jpg" data-origin-url="https://ai.esmplus.com/cocoblanc1/20230506_kakao/B1-/B_37.jpg"></a></td> \n      </tr> \n      <tr> \n       <td><a href="https://ai.esmplus.com/cocoblanc1/20230506_kakao/D1-/D_38.html"><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230503154955_5a50754532664f58bf2f04714d108d2a.jpg" data-origin-url="https://ai.esmplus.com/cocoblanc1/20230506_kakao/B1-/B_38.jpg"></a></td> \n      </tr> \n      <tr> \n       <td><a href="https://ai.esmplus.com/cocoblanc1/20230506_kakao/D1-/D_39.html"><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230503154955_87450bfdd2dc43bbbefeee3fab93d4e5.jpg" data-origin-url="https://ai.esmplus.com/cocoblanc1/20230506_kakao/B1-/B_39.jpg"></a></td> \n      </tr> \n      <tr> \n       <td><a href="https://ai.esmplus.com/cocoblanc1/20230506_kakao/D1-/D_40.html"><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230503154956_3d408605960a417e97cb402719d9b9d1.jpg" data-origin-url="https://ai.esmplus.com/cocoblanc1/20230506_kakao/B1-/B_40.jpg"></a></td> \n      </tr> \n      <tr> \n       <td><a href="https://ai.esmplus.com/cocoblanc1/20230506_kakao/D1-/D_41.html"><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230503154956_88967de2f6e9401997c91d2df0d8be7d.jpg" data-origin-url="https://ai.esmplus.com/cocoblanc1/20230506_kakao/B1-/B_41.jpg"></a></td> \n      </tr> \n      <tr> \n       <td><a href="https://ai.esmplus.com/cocoblanc1/20230506_kakao/D1-/D_42.html"><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230503154957_693e605454694389921c21f1ddc6c3cc.jpg" data-origin-url="https://ai.esmplus.com/cocoblanc1/20230506_kakao/B1-/B_42.jpg"></a></td> \n      </tr> \n      <tr> \n       <td><a href="https://ai.esmplus.com/cocoblanc1/20230506_kakao/D1-/D_43.html"><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230503154958_0c28d42c12dc4fef8b617ae210fafce4.jpg" data-origin-url="https://ai.esmplus.com/cocoblanc1/20230506_kakao/B1-/B_43.jpg"></a></td> \n      </tr> \n      <tr> \n       <td><a href="https://ai.esmplus.com/cocoblanc1/20230506_kakao/D1-/D_44.html"><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230503154958_ea6771bb4f2c4ec39d2a1ebceb9868fd.jpg" data-origin-url="https://ai.esmplus.com/cocoblanc1/20230506_kakao/B1-/B_44.jpg"></a></td> \n      </tr> \n      <tr> \n       <td><a href="https://ai.esmplus.com/cocoblanc1/20230506_kakao/D1-/D_45.html"><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230503154958_de8a26eebae5486dafe63c46e47acfeb.jpg" data-origin-url="https://ai.esmplus.com/cocoblanc1/20230506_kakao/B1-/B_45.jpg"></a></td> \n      </tr> \n      <tr> \n       <td><a href="https://ai.esmplus.com/cocoblanc1/20230506_kakao/D1-/D_46.html"><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230503154959_d9bf33a013734484856a88328e7fd204.jpg" data-origin-url="https://ai.esmplus.com/cocoblanc1/20230506_kakao/B1-/B_46.jpg"></a></td> \n      </tr> \n      <tr> \n       <td><a href="https://ai.esmplus.com/cocoblanc1/20230506_kakao/D1-/D_47.html"><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230503154959_a7a238a2b2f6409e9fd36bd39c99aef9.jpg" data-origin-url="https://ai.esmplus.com/cocoblanc1/20230506_kakao/B1-/B_47.jpg"></a></td> \n      </tr> \n      <tr> \n       <td><a href="https://ai.esmplus.com/cocoblanc1/20230506_kakao/D1-/D_48.html"><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230503155000_48b520811add4f689c9bd11b6ca873f9.jpg" data-origin-url="https://ai.esmplus.com/cocoblanc1/20230506_kakao/B1-/B_48.jpg"></a></td> \n      </tr> \n      <tr> \n       <td><a href="https://ai.esmplus.com/cocoblanc1/20230506_kakao/D1-/D_49.html"><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230503155000_ff316c04b7aa4e9590c4a63aa6be9dd9.jpg" data-origin-url="https://ai.esmplus.com/cocoblanc1/20230506_kakao/B1-/B_49.jpg"></a></td> \n      </tr> \n      <tr> \n       <td><a href="https://ai.esmplus.com/cocoblanc1/20230506_kakao/D1-/D_50.html"><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230503155000_7bf6022d58ad46fcb5e6378277c4528b.jpg" data-origin-url="https://ai.esmplus.com/cocoblanc1/20230506_kakao/B1-/B_50.jpg"></a></td> \n      </tr> \n      <tr> \n       <td><a href="https://ai.esmplus.com/cocoblanc1/20230506_kakao/D1-/D_51.html"><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230503155001_6df415877a1d477eb9b0991786f8ab2a.jpg" data-origin-url="https://ai.esmplus.com/cocoblanc1/20230506_kakao/B1-/B_51.jpg"></a></td> \n      </tr> \n      <tr> \n       <td><a href="https://ai.esmplus.com/cocoblanc1/20230506_kakao/D1-/D_52.html"><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230503155002_f96a4d138d7043d897fd17a02fae6bd7.jpg" data-origin-url="https://ai.esmplus.com/cocoblanc1/20230506_kakao/B1-/B_52.jpg"></a></td> \n      </tr> \n      <tr> \n       <td><a href="https://ai.esmplus.com/cocoblanc1/20230506_kakao/D1-/D_53.html"><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230503155002_3ef7a4d1692c42f0b3b7d34fbf798e95.jpg" data-origin-url="https://ai.esmplus.com/cocoblanc1/20230506_kakao/B1-/B_53.jpg"></a></td> \n      </tr> \n      <tr> \n       <td><a href="https://ai.esmplus.com/cocoblanc1/20230506_kakao/D1-/D_54.html"><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230503155003_076ec459ffff4c029b60de00b9a79d60.jpg" data-origin-url="https://ai.esmplus.com/cocoblanc1/20230506_kakao/B1-/B_54.jpg"></a></td> \n      </tr> \n      <tr> \n       <td><a href="https://ai.esmplus.com/cocoblanc1/20230506_kakao/D1-/D_55.html"><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230503155003_a78b05211ad24b4ca03b9a387f307a77.jpg" data-origin-url="https://ai.esmplus.com/cocoblanc1/20230506_kakao/B1-/B_55.jpg"></a></td> \n      </tr> \n      <tr> \n       <td><a href="https://ai.esmplus.com/cocoblanc1/20230506_kakao/D1-/D_56.html"><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230503155003_669396fb48c94a38924a3482730eca0c.jpg" data-origin-url="https://ai.esmplus.com/cocoblanc1/20230506_kakao/B1-/B_56.jpg"></a></td> \n      </tr> \n      <tr> \n       <td><a href="https://ai.esmplus.com/cocoblanc1/20230506_kakao/D1-/D_57.html"><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230503155004_a7d757a556ee4cabb0c648cf54fdf478.jpg" data-origin-url="https://ai.esmplus.com/cocoblanc1/20230506_kakao/B1-/B_57.jpg"></a></td> \n      </tr> \n      <tr> \n       <td><a href="https://ai.esmplus.com/cocoblanc1/20230506_kakao/D1-/D_58.html"><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230503155004_056f08f28c7447808e5909be3f94bf81.jpg" data-origin-url="https://ai.esmplus.com/cocoblanc1/20230506_kakao/B1-/B_58.jpg"></a></td> \n      </tr> \n      <tr> \n       <td><a href="https://ai.esmplus.com/cocoblanc1/20230506_kakao/D1-/D_59.html"><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230503155005_dd913778cea84dad82d3f569132c249f.jpg" data-origin-url="https://ai.esmplus.com/cocoblanc1/20230506_kakao/B1-/B_59.jpg"></a></td> \n      </tr> \n      <tr> \n       <td><a href="https://ai.esmplus.com/cocoblanc1/20230506_kakao/D1-/D_60.html"><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230503155005_fe5ed89452374730a1db4c4df4d00545.jpg" data-origin-url="https://ai.esmplus.com/cocoblanc1/20230506_kakao/B1-/B_60.jpg"></a></td> \n      </tr> \n      <tr> \n       <td><a href="https://ai.esmplus.com/cocoblanc1/20230506_kakao/D1-/D_61.html"><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230503155006_b59112db17c14c499919d3523e3304a6.jpg" data-origin-url="https://ai.esmplus.com/cocoblanc1/20230506_kakao/B1-/B_61.jpg"></a></td> \n      </tr> \n      <tr> \n       <td><a href="https://ai.esmplus.com/cocoblanc1/20230506_kakao/D1-/D_62.html"><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230503155007_1f6b81ee91dc4df98822c3526f04906f.jpg" data-origin-url="https://ai.esmplus.com/cocoblanc1/20230506_kakao/B1-/B_62.jpg"></a></td> \n      </tr> \n      <tr> \n       <td><a href="https://ai.esmplus.com/cocoblanc1/20230506_kakao/D1-/D_63.html"><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230503155007_3d52e3e677ae46b799dc96ab815dad96.jpg" data-origin-url="https://ai.esmplus.com/cocoblanc1/20230506_kakao/B1-/B_63.jpg"></a></td> \n      </tr> \n      <tr> \n       <td><a href="https://ai.esmplus.com/cocoblanc1/20230506_kakao/D1-/D_64.html"><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230503155008_d390702a8b53430e8b7a6465997d711b.jpg" data-origin-url="https://ai.esmplus.com/cocoblanc1/20230506_kakao/B1-/B_64.jpg"></a></td> \n      </tr> \n      <tr> \n       <td><a href="https://ai.esmplus.com/cocoblanc1/20230506_kakao/D1-/D_65.html"><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230503155009_f2d720a4caa84096bef5f66460b861be.jpg" data-origin-url="https://ai.esmplus.com/cocoblanc1/20230506_kakao/B1-/B_65.jpg"></a></td> \n      </tr> \n      <tr> \n       <td><a href="https://ai.esmplus.com/cocoblanc1/20230506_kakao/D1-/D_66.html"><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230503155010_2d2b7d9cf09c4624a111186fa59dcad5.jpg" data-origin-url="https://ai.esmplus.com/cocoblanc1/20230506_kakao/B1-/B_66.jpg"></a></td> \n      </tr> \n      <tr> \n       <td><a href="https://ai.esmplus.com/cocoblanc1/20230506_kakao/D1-/D_67.html"><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230503155010_a82c6a86bf464ba8bf16e0d76d87cdf3.jpg" data-origin-url="https://ai.esmplus.com/cocoblanc1/20230506_kakao/B1-/B_67.jpg"></a></td> \n      </tr> \n      <tr> \n       <td><a href="https://ai.esmplus.com/cocoblanc1/20230506_kakao/D1-/D_68.html"><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230503155011_59f81f5dbdf04224b547572ac5962619.jpg" data-origin-url="https://ai.esmplus.com/cocoblanc1/20230506_kakao/B1-/B_68.jpg"></a></td> \n      </tr> \n      <tr> \n       <td><a href="https://ai.esmplus.com/cocoblanc1/20230506_kakao/D1-/D_69.html"><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230503155011_cfaec17b398b4213a367fb32bf322c2e.jpg" data-origin-url="https://ai.esmplus.com/cocoblanc1/20230506_kakao/B1-/B_69.jpg"></a></td> \n      </tr> \n      <tr> \n       <td><a href="https://ai.esmplus.com/cocoblanc1/20230506_kakao/D1-/D_70.html"><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230503155011_dd22e6c45fa442a39edcc9cd793f1262.jpg" data-origin-url="https://ai.esmplus.com/cocoblanc1/20230506_kakao/B1-/B_70.jpg"></a></td> \n      </tr> \n      <tr> \n       <td><a href="https://ai.esmplus.com/cocoblanc1/20230506_kakao/D1-/D_71.html"><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230503155012_1e73fec58a084e4182706283193e1682.jpg" data-origin-url="https://ai.esmplus.com/cocoblanc1/20230506_kakao/B1-/B_71.jpg"></a></td> \n      </tr> \n      <tr> \n       <td><a href="https://ai.esmplus.com/cocoblanc1/20230506_kakao/D1-/D_72.html"><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230503155013_c71fd8c064804339ba1229b74844935a.jpg" data-origin-url="https://ai.esmplus.com/cocoblanc1/20230506_kakao/B1-/B_72.jpg"></a></td> \n      </tr> \n      <tr> \n       <td><a href="https://ai.esmplus.com/cocoblanc1/20230506_kakao/D1-/D_73.html"><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230503155013_9304b281262c451ba97a96d66ad8cf13.jpg" data-origin-url="https://ai.esmplus.com/cocoblanc1/20230506_kakao/B1-/B_73.jpg"></a></td> \n      </tr> \n      <tr> \n       <td><a href="https://ai.esmplus.com/cocoblanc1/20230506_kakao/D1-/D_74.html"><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230503155013_495abbb41ae84e359fa534f89017aebd.jpg" data-origin-url="https://ai.esmplus.com/cocoblanc1/20230506_kakao/B1-/B_74.jpg"></a></td> \n      </tr> \n      <tr> \n       <td><a href="https://ai.esmplus.com/cocoblanc1/20230506_kakao/D1-/D_75.html"><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230503155014_a41d83b9251f47cb9b6b826bf80ac5af.jpg" data-origin-url="https://ai.esmplus.com/cocoblanc1/20230506_kakao/B1-/B_75.jpg"></a></td> \n      </tr> \n      <tr> \n       <td><a href="https://ai.esmplus.com/cocoblanc1/20230506_kakao/D1-/D_76.html"><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230503155015_1973e5bcd988457e86ee25a62684703f.jpg" data-origin-url="https://ai.esmplus.com/cocoblanc1/20230506_kakao/B1-/B_76.jpg"></a></td> \n      </tr> \n      <tr> \n       <td><a href="https://ai.esmplus.com/cocoblanc1/20230506_kakao/D1-/D_77.html"><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230503155015_ecf85dff3864456b8f1cae2e787c5fa0.jpg" data-origin-url="https://ai.esmplus.com/cocoblanc1/20230506_kakao/B1-/B_77.jpg"></a></td> \n      </tr> \n      <tr> \n       <td><a href="https://ai.esmplus.com/cocoblanc1/20230506_kakao/D1-/D_78.html"><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230503155015_c0ac7d7a501a473ab1aff737132f742e.jpg" data-origin-url="https://ai.esmplus.com/cocoblanc1/20230506_kakao/B1-/B_78.jpg"></a></td> \n      </tr> \n      <tr> \n       <td><a href="https://ai.esmplus.com/cocoblanc1/20230506_kakao/D1-/D_79.html"><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230503155016_47d808a517484ce1a0fc1becc3a3e08e.jpg" data-origin-url="https://ai.esmplus.com/cocoblanc1/20230506_kakao/B1-/B_79.jpg"></a></td> \n      </tr> \n      <tr> \n       <td><a href="https://ai.esmplus.com/cocoblanc1/20230506_kakao/D1-/D_80.html"><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230503155017_73b9d20fa13b47bb80dd280448cae1ea.jpg" data-origin-url="https://ai.esmplus.com/cocoblanc1/20230506_kakao/B1-/B_80.jpg"></a></td> \n      </tr> \n      <tr> \n       <td><a href="https://ai.esmplus.com/cocoblanc1/20230506_kakao/D1-/D_81.html"><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230503155017_63d841bdf29746f090c7c443b964d52f.jpg" data-origin-url="https://ai.esmplus.com/cocoblanc1/20230506_kakao/B1-/B_81.jpg"></a></td> \n      </tr> \n      <tr> \n       <td><a href="https://ai.esmplus.com/cocoblanc1/20230506_kakao/D1-/D_82.html"><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230503155018_dfb9f63436944029bfa1638f2fc285e0.jpg" data-origin-url="https://ai.esmplus.com/cocoblanc1/20230506_kakao/B1-/B_82.jpg"></a></td> \n      </tr> \n      <tr> \n       <td><a href="https://ai.esmplus.com/cocoblanc1/20230506_kakao/D1-/D_83.html"><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230503155019_eb35bc58c90a4ff890d67ed8396946af.jpg" data-origin-url="https://ai.esmplus.com/cocoblanc1/20230506_kakao/B1-/B_83.jpg"></a></td> \n      </tr> \n      <tr> \n       <td><a href="https://ai.esmplus.com/cocoblanc1/20230506_kakao/D1-/D_84.html"><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230503155019_9afa39d4d93e48fe8d64c9b709ab8a2a.jpg" data-origin-url="https://ai.esmplus.com/cocoblanc1/20230506_kakao/B1-/B_84.jpg"></a></td> \n      </tr> \n      <tr> \n       <td><a href="https://ai.esmplus.com/cocoblanc1/20230506_kakao/D1-/D_85.html"><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230503155020_d0bf32f7dd0047f2bc27bdd43510ad72.jpg" data-origin-url="https://ai.esmplus.com/cocoblanc1/20230506_kakao/B1-/B_85.jpg"></a></td> \n      </tr> \n      <tr> \n       <td><a href="https://ai.esmplus.com/cocoblanc1/20230506_kakao/D1-/D_86.html"><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230503155020_cc605905f7984433841541934c6d2091.jpg" data-origin-url="https://ai.esmplus.com/cocoblanc1/20230506_kakao/B1-/B_86.jpg"></a></td> \n      </tr> \n      <tr> \n       <td><a href="https://ai.esmplus.com/cocoblanc1/20230506_kakao/D1-/D_87.html"><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230503155021_cdbff40ea4414079ac110bfa0c3b5d78.jpg" data-origin-url="https://ai.esmplus.com/cocoblanc1/20230506_kakao/B1-/B_87.jpg"></a></td> \n      </tr> \n      <tr> \n       <td><a href="https://ai.esmplus.com/cocoblanc1/20230506_kakao/D1-/D_88.html"><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230503155021_46ecdafa25284f709870e72775a01707.jpg" data-origin-url="https://ai.esmplus.com/cocoblanc1/20230506_kakao/B1-/B_88.jpg"></a></td> \n      </tr> \n      <tr> \n       <td><a href="https://ai.esmplus.com/cocoblanc1/20230506_kakao/D1-/D_89.html"><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230503155022_706af739b9b840c3ab4024403073b9c1.jpg" data-origin-url="https://ai.esmplus.com/cocoblanc1/20230506_kakao/B1-/B_89.jpg"></a></td> \n      </tr> \n      <tr> \n       <td><a href="https://ai.esmplus.com/cocoblanc1/20230506_kakao/D1-/D_90.html"><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230503155022_b4d13759e43c4973abb69860f52ffb1e.jpg" data-origin-url="https://ai.esmplus.com/cocoblanc1/20230506_kakao/B1-/B_90.jpg"></a></td> \n      </tr> \n      <tr> \n       <td><a href="https://ai.esmplus.com/cocoblanc1/20230506_kakao/D1-/D_91.html"><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230503155023_8c63b70e18a34850884660f6393114f1.jpg" data-origin-url="https://ai.esmplus.com/cocoblanc1/20230506_kakao/B1-/B_91.jpg"></a></td> \n      </tr> \n      <tr> \n       <td><a href="https://ai.esmplus.com/cocoblanc1/20230506_kakao/D1-/D_92.html"><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230503155024_e70385b887fc4929b062b4ba36e0d279.jpg" data-origin-url="https://ai.esmplus.com/cocoblanc1/20230506_kakao/B1-/B_92.jpg"></a></td> \n      </tr> \n      <tr> \n       <td><a href="https://ai.esmplus.com/cocoblanc1/20230506_kakao/D1-/D_93.html"><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230503155024_2700ca53c49d4215a7234d06b68a210d.jpg" data-origin-url="https://ai.esmplus.com/cocoblanc1/20230506_kakao/B1-/B_93.jpg"></a></td> \n      </tr> \n      <tr> \n       <td><a href="https://ai.esmplus.com/cocoblanc1/20230506_kakao/D1-/D_94.html"><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230503155025_400b5211ae704a2ea5bcf7d1dd9f640e.jpg" data-origin-url="https://ai.esmplus.com/cocoblanc1/20230506_kakao/B1-/B_94.jpg"></a></td> \n      </tr> \n      <tr> \n       <td><a href="https://ai.esmplus.com/cocoblanc1/20230506_kakao/D1-/D_95.html"><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230503155025_819f8460bd6d42f49ae0e597322d7e82.jpg" data-origin-url="https://ai.esmplus.com/cocoblanc1/20230506_kakao/B1-/B_95.jpg"></a></td> \n      </tr> \n      <tr> \n       <td><a href="https://ai.esmplus.com/cocoblanc1/20230506_kakao/D1-/D_96.html"><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230503155026_d4db9ee160bf4a76a617ddb79aa14a32.jpg" data-origin-url="https://ai.esmplus.com/cocoblanc1/20230506_kakao/B1-/B_96.jpg"></a></td> \n      </tr> \n      <tr> \n       <td><a href="https://ai.esmplus.com/cocoblanc1/20230506_kakao/D1-/D_97.html"><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230503155026_c29393c826194bcc95fd21611af90124.jpg" data-origin-url="https://ai.esmplus.com/cocoblanc1/20230506_kakao/B1-/B_97.jpg"></a></td> \n      </tr> \n      <tr> \n       <td><a href="https://ai.esmplus.com/cocoblanc1/20230506_kakao/D1-/D_98.html"><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230503155026_11953d84312649a5b4188559eebf4942.jpg" data-origin-url="https://ai.esmplus.com/cocoblanc1/20230506_kakao/B1-/B_98.jpg"></a></td> \n      </tr> \n      <tr> \n       <td><a href="https://ai.esmplus.com/cocoblanc1/20230506_kakao/D1-/D_99.html"><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230503155027_81b69ea4ed60448db99b58bb9e7f1b8a.jpg" data-origin-url="https://ai.esmplus.com/cocoblanc1/20230506_kakao/B1-/B_99.jpg"></a></td> \n      </tr> \n      <tr> \n       <td><a href="https://ai.esmplus.com/cocoblanc1/20230506_kakao/D1-/D_100.html"><img src="https://st.kakaocdn.net/thumb/R890x0/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Feditor%2F20230503155027_ab199e695bcb4efe9c61ba3b9b1b70b6.jpg" data-origin-url="https://ai.esmplus.com/cocoblanc1/20230506_kakao/B1-/B_100.jpg"></a></td> \n      </tr> \n     </tbody> \n    </table> \n   </center> \n  </center>\n </body>\n</html>',
    instantOrder: false,
    talkDeal: {
      id: 3269265,
      status: 'AFTER_SALE',
      groupSize: 1,
      period: { from: '20230506170000', to: '20230509235959' },
      ongoingRoomCount: 0,
      discountPrice: 40000,
      discountRate: 80.0,
    },
    benefits: [
      {
        description: '카카오페이 머니로 3만원 이상 결제 시 카카오페이 포인트 2천원 적립 (5/8~5/17, 일부 상품 대상 제외, 인당 1회)',
        landingUrl: 'https://store.kakao.com/mypage/notice/119',
        value: '',
      },
    ],
    delivery: {
      deliveryMethodType: 'DELIVERY',
      optionalDeliveries: [],
      deliveryFeeType: 'FREE',
      deliveryFeePaymentType: 'PREPAID',
      deliveryFee: 0,
      freeConditionalAmount: 0,
      repeatQuantity: 0,
      bundleGroupAvailable: true,
      isolatedAreaAdditionalFee: 2000,
      jejuAreaAdditionalFee: 1500,
      availableIsolatedArea: true,
    },
    taxDeduction: false,
    gift: { gift: '' },
    quantity: { minPurchase: 0, maxPurchase: 1000, maxPurchaseOfBuyer: 1000 },
    adultOnly: false,
    isLiquor: false,
    minorPurchasable: true,
    booked: { booked: false },
    notices: [],
    reviewUnexposed: false,
    favorite: false,
    reviewCreatable: false,
    store: {
      id: 62459,
      name: '코코블랑',
      domain: 'cocoblanc',
      farmer: false,
      coverImage: 'https://st.kakaocdn.net/shoppingstore/store/20210905163825_24d22db7ebb742bdb7e11d287fee7120.jpg',
      profileImage: 'https://st.kakaocdn.net/shoppingstore/store/20221219133214_ba607a89cb2a4aedadb13d74678325a3.jpg',
      consultId: '@cocoblanc1',
      channelName: '코코블랑 여성의류',
      channelUrl: 'http://pf.kakao.com/_xogDpxb',
      subscribed: false,
      fresh: false,
      trackId: '',
    },
    category: { id: '101102102104', name: '여성 브이넥 니트' },
    price: {
      standardPrice: 49900,
      discountedPrice: 49900,
      discountRate: 0.0,
      minDiscountedPrice: 46900,
      maxDiscountedPrice: 75900,
      totalDiscountedPrice: 49900,
    },
    events: [],
    review: {
      topReviews: [
        {
          id: '645a2dae71fa2914bb14ef1c',
          content: '맘에 들어서 다른색도 바로주문\n배송도 빨라요',
          productRating: 4,
          deliveryRating: 4,
          productStarRating: 4,
          deliveryStarRating: 4,
          best: true,
          writer: '*',
          imageUrl: 'https://st.kakaocdn.net/thumb/S70x70/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fdefault%2Ffriends%2Fv2%2F10.png&scode=shoppingstore',
          backgroundColor: '#d6d6d6',
        },
        {
          id: '645adad1a6a9652688b4bce3',
          content: '옷은 이뻐요 근데 뒤쪽이 생각보다 짧은듯 합니다',
          productRating: 4,
          deliveryRating: 4,
          productStarRating: 4,
          deliveryStarRating: 4,
          best: true,
          writer: '바다******',
          imageUrl: 'https://st.kakaocdn.net/thumb/S70x70/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fdefault%2Ffriends%2Fv2%2F4.png&scode=shoppingstore',
          backgroundColor: '#d6d6d6',
        },
        {
          id: '645b3e6b9b7a6440894ebacf',
          content: '편하고 이뻐요 강추합니다',
          productRating: 4,
          deliveryRating: 4,
          productStarRating: 4,
          deliveryStarRating: 4,
          best: true,
          writer: '박재*',
          imageUrl: 'https://st.kakaocdn.net/thumb/S70x70/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fdefault%2Ffriends%2Fv2%2F5.png&scode=shoppingstore',
          backgroundColor: '#e7eded',
        },
      ],
      qnaCount: 74,
      reviewCount: 15,
      averageRating: 4,
      totalProductStarRating: 4.0,
      totalDeliveryStarRating: 4.0,
      productPositivePercentage: 100,
      deliveryPositivePercentage: 100,
      productStar1Percentage: 0,
      productStar2Percentage: 0,
      productStar3Percentage: 7,
      productStar4Percentage: 93,
    },
    banners: [],
    sellerProductPoint: {},
  },
};

const product = {
  data: {
    food: [
      [
        {
          productId: 247868049,
          productName: '목우촌 한우 인삼갈비탕 700gX4개+한우 사골곰탕 4개 증정',
          productImage: 'https://st.kakaocdn.net/thumb/C375x375.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230427145426_080e14bb1d234597a2f468afde015a50.jpg',
          productImageOrigin: 'https://st.kakaocdn.net/shoppingstore/product/20230427145426_080e14bb1d234597a2f468afde015a50.jpg',
          originalPrice: 59900,
          discountedPrice: 59900,
          discountRate: 0,
          groupDiscountDisplayable: true,
          groupDiscountStatus: 'ON_SALE',
          groupDiscountedPrice: 28900,
          groupDiscountWillClosed: false,
          groupDiscountUserCount: 2357,
          groupDiscountStartAt: 1683360000000,
          groupDiscountEndAt: 1683644399000,
          alarmDisplaying: false,
          groupDiscountRemainSeconds: 198597,
          storeId: 69747,
          storeName: '목우촌',
          storeDomain: 'moguchon',
          storeProfileImage: 'https://st.kakaocdn.net/thumb/B350x350cw/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fstore%2F20220620195113_0e4200b7122945598f61132ce4e0ea0e.jpg',
          new: false,
          linkPath: '/detail/?productId=247868049',
          storeLinkPath: '/moguchon?area=mainp',
          plusFriendSubscriberExclusive: false,
          farmer: false,
          deliveryFeeType: 'FREE',
          freeDelivery: true,
          imageRatio: 'SQUARE',
          displayedSaleStatus: 'ON_SALE',
          categoryId: '102100100112',
          categoryName: '국/탕/찌개',
          hasAdditionalOptionPrice: false,
          groupDiscountPeriod: { from: '20230506170000', to: '20230509235959' },
          profiles: [
            'https://st.kakaocdn.net/shoppingstore/random/profile_493.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_420.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_366.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_498.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_18.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_171.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_246.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_267.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_109.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_73.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_210.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_546.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_372.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_228.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_202.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_350.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_100.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_435.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_236.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_229.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_448.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_346.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_295.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_14.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_389.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_205.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_490.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_548.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_23.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_198.png',
          ],
          totalSaleCount: 2839,
          trackId: '1726756183548867528',
          contentId: 1469,
          contentDisplayPeriod: { from: '20230506170000', to: '20230509235959' },
          type: 'BIG_CARD',
          landingUrl: 'https://store.kakao.com/moguchon/products/247868049?_=1683445801259&area=mainp',
          mainCopy: '목우촌 한우 인삼 갈비탕 700g 4개+사골곰탕 4개',
          label: '',
          imageUrl:
            'https://st.kakaocdn.net/thumb/C750x422.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fhome%2Fgroup_discount_product%2F20230503140323_8c2159beb21249ad81360a6aaae1ac54.png',
          imageUrlOrigin: 'https://st.kakaocdn.net/shoppingstore/home/group_discount_product/20230503140323_8c2159beb21249ad81360a6aaae1ac54.png',
          sharingImageUrl:
            'https://st.kakaocdn.net/thumb/C750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230427145426_080e14bb1d234597a2f468afde015a50.jpg&mode=watermark&wm_param1=image&wm_id=talkdeal',
          logoImageUrl: '',
          contentRemainDays: 2,
          remainDays: 2,
          contentOpenDt: '20230506',
          contentCloseDt: '20230509',
          likeProductCount: 581,
          isLiked: false,
          score: 6.81173e7,
        },
        {
          productId: 204308361,
          productName: '[우체국쇼핑]전북 정읍 국내산 귀리로 만든 귀리뻥튀기 왕큰봉지 2봉/4봉',
          productImage: 'https://st.kakaocdn.net/thumb/C375x375.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20221208143712_c032773e042e4b15aa5d9b8dde9b907c.jpg',
          productImageOrigin: 'https://st.kakaocdn.net/shoppingstore/product/20221208143712_c032773e042e4b15aa5d9b8dde9b907c.jpg',
          originalPrice: 12900,
          discountedPrice: 12900,
          discountRate: 0,
          groupDiscountDisplayable: true,
          groupDiscountStatus: 'ON_SALE',
          groupDiscountedPrice: 8900,
          groupDiscountWillClosed: false,
          groupDiscountUserCount: 3358,
          groupDiscountStartAt: 1683360000000,
          groupDiscountEndAt: 1683644399000,
          alarmDisplaying: false,
          groupDiscountRemainSeconds: 198597,
          storeId: 1987,
          storeName: '우체국쇼핑몰',
          storeDomain: 'postkmall',
          storeProfileImage: 'https://st.kakaocdn.net/thumb/B350x350cw/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fstore%2F20190625190413_5030441de54d40a6b0ab62f92d846298.jpg',
          new: false,
          linkPath: '/detail/?productId=204308361',
          storeLinkPath: '/postkmall?area=mainp',
          plusFriendSubscriberExclusive: false,
          farmer: true,
          deliveryFeeType: 'FREE',
          freeDelivery: true,
          reviewCount: 699,
          productPositivePercentage: 98,
          imageRatio: 'SQUARE',
          displayedSaleStatus: 'ON_SALE',
          categoryId: '102109100',
          categoryName: '과자/쿠키',
          hasAdditionalOptionPrice: true,
          groupDiscountPeriod: { from: '20230506170000', to: '20230509235959' },
          profiles: [
            'https://st.kakaocdn.net/shoppingstore/random/profile_192.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_310.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_357.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_446.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_98.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_78.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_277.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_390.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_418.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_161.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_73.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_304.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_508.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_169.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_449.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_164.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_431.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_376.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_67.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_368.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_316.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_554.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_134.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_541.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_57.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_7.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_41.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_97.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_412.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_464.png',
          ],
          totalSaleCount: 11420,
          trackId: '',
          contentId: 1469,
          contentDisplayPeriod: { from: '20230506170000', to: '20230509235959' },
          type: 'BIG_CARD',
          landingUrl: 'https://store.kakao.com/postkmall/products/204308361?_=1683445801259&area=mainp',
          mainCopy: '전북 정읍 귀리 뻥튀기 150g 2봉. 바삭 고소한 맛',
          label: '',
          imageUrl:
            'https://st.kakaocdn.net/thumb/C750x422.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fhome%2Fgroup_discount_product%2F20230503140218_cb2298038357478799f81f25032142d6.png',
          imageUrlOrigin: 'https://st.kakaocdn.net/shoppingstore/home/group_discount_product/20230503140218_cb2298038357478799f81f25032142d6.png',
          sharingImageUrl:
            'https://st.kakaocdn.net/thumb/C750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20221208143712_c032773e042e4b15aa5d9b8dde9b907c.jpg&mode=watermark&wm_param1=image&wm_id=talkdeal',
          logoImageUrl: '',
          contentRemainDays: 2,
          remainDays: 2,
          contentOpenDt: '20230506',
          contentCloseDt: '20230509',
          likeProductCount: 2973,
          isLiked: false,
          score: 2.98862e7,
        },
        {
          productId: 56992838,
          productName: '[사은품증정 EVENT] "동안피부비결" 이탈리아산 저분자 피쉬콜라겐 1통 90포 3개월분',
          productImage: 'https://st.kakaocdn.net/thumb/C375x375.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230503153945_f1ae09f97809426b91bcc7efc3a721c7.jpg',
          productImageOrigin: 'https://st.kakaocdn.net/shoppingstore/product/20230503153945_f1ae09f97809426b91bcc7efc3a721c7.jpg',
          originalPrice: 37000,
          discountedPrice: 37000,
          discountRate: 0,
          groupDiscountDisplayable: true,
          groupDiscountStatus: 'ON_SALE',
          groupDiscountedPrice: 16600,
          groupDiscountWillClosed: false,
          groupDiscountUserCount: 658,
          groupDiscountStartAt: 1683360000000,
          groupDiscountEndAt: 1683644399000,
          alarmDisplaying: false,
          groupDiscountRemainSeconds: 198597,
          storeId: 24251,
          storeName: '메디트리 공식스토어',
          storeDomain: 'meditreestore',
          storeProfileImage: 'https://st.kakaocdn.net/thumb/B350x350cw/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fstore%2F20210818133516_a533c7d96a154236a6771613e501fa83.jpg',
          new: false,
          linkPath: '/detail/?productId=56992838',
          storeLinkPath: '/meditreestore?area=mainp',
          plusFriendSubscriberExclusive: false,
          farmer: false,
          deliveryFeeType: 'FREE',
          freeDelivery: true,
          reviewCount: 606,
          productPositivePercentage: 100,
          imageRatio: 'SQUARE',
          displayedSaleStatus: 'ON_SALE',
          categoryId: '102105105101',
          categoryName: '콜라겐/코큐텐',
          hasAdditionalOptionPrice: true,
          groupDiscountPeriod: { from: '20230506170000', to: '20230509235959' },
          profiles: [
            'https://st.kakaocdn.net/shoppingstore/random/profile_420.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_294.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_115.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_26.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_217.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_110.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_549.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_340.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_513.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_48.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_463.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_174.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_30.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_440.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_179.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_537.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_507.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_538.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_266.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_461.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_71.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_243.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_434.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_429.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_79.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_388.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_421.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_384.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_306.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_239.png',
          ],
          totalSaleCount: 3978,
          trackId: '7782782849913303346',
          contentId: 1469,
          contentDisplayPeriod: { from: '20230506170000', to: '20230509235959' },
          type: 'BIG_CARD',
          landingUrl: 'https://store.kakao.com/meditreestore/products/56992838?_=1683445801260&area=mainp',
          mainCopy: '메디트리 저분자 피쉬콜라겐 3개월분+비타C젤리 증정',
          label: '',
          imageUrl:
            'https://st.kakaocdn.net/thumb/C750x422.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fhome%2Fgroup_discount_product%2F20230503140439_632eab26bb3e4f759ddd0ccc1db34f3f.png',
          imageUrlOrigin: 'https://st.kakaocdn.net/shoppingstore/home/group_discount_product/20230503140439_632eab26bb3e4f759ddd0ccc1db34f3f.png',
          sharingImageUrl:
            'https://st.kakaocdn.net/thumb/C750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230503153945_f1ae09f97809426b91bcc7efc3a721c7.jpg&mode=watermark&wm_param1=image&wm_id=talkdeal',
          logoImageUrl: '',
          contentRemainDays: 2,
          remainDays: 2,
          contentOpenDt: '20230506',
          contentCloseDt: '20230509',
          likeProductCount: 957,
          isLiked: false,
          score: 1.09228e7,
        },
        {
          productId: 237319333,
          productName: '구~수한 청국장 150g x 4팩 무료배송 국내산 100% 전통식품인증 /AR',
          productImage: 'https://st.kakaocdn.net/thumb/C375x375.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230327115215_322815ce44ee4591b25012a2c43faddd.jpg',
          productImageOrigin: 'https://st.kakaocdn.net/shoppingstore/product/20230327115215_322815ce44ee4591b25012a2c43faddd.jpg',
          originalPrice: 15000,
          discountedPrice: 15000,
          discountRate: 0,
          groupDiscountDisplayable: true,
          groupDiscountStatus: 'ON_SALE',
          groupDiscountedPrice: 9500,
          groupDiscountWillClosed: false,
          groupDiscountUserCount: 1129,
          groupDiscountStartAt: 1683360000000,
          groupDiscountEndAt: 1683644399000,
          alarmDisplaying: false,
          groupDiscountRemainSeconds: 198597,
          storeId: 65639,
          storeName: '더싱싱몰',
          storeDomain: 'thesingsingmall',
          storeProfileImage: 'https://st.kakaocdn.net/thumb/B350x350cw/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fstore%2F20221220105751_e1fa8df8ef8d484882a0ce41ca96c55c.png',
          new: false,
          linkPath: '/detail/?productId=237319333',
          storeLinkPath: '/thesingsingmall?area=mainp',
          plusFriendSubscriberExclusive: false,
          farmer: true,
          deliveryFeeType: 'FREE',
          freeDelivery: true,
          reviewCount: 10,
          productPositivePercentage: 100,
          imageRatio: 'SQUARE',
          displayedSaleStatus: 'ON_SALE',
          categoryId: '102100103106',
          categoryName: '청국장',
          hasAdditionalOptionPrice: false,
          groupDiscountPeriod: { from: '20230506170000', to: '20230509235959' },
          profiles: [
            'https://st.kakaocdn.net/shoppingstore/random/profile_468.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_493.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_366.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_42.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_167.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_522.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_370.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_411.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_144.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_22.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_114.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_402.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_101.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_59.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_300.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_334.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_105.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_283.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_317.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_45.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_431.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_229.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_143.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_199.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_367.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_112.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_375.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_116.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_189.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_23.png',
          ],
          totalSaleCount: 1399,
          trackId: '',
          contentId: 1469,
          contentDisplayPeriod: { from: '20230506170000', to: '20230509235959' },
          type: 'BIG_CARD',
          landingUrl: 'https://store.kakao.com/thesingsingmall/products/237319333?_=1683445801259&area=mainp',
          mainCopy: '100% 국내산 청국장 150g 4팩, 전통식품 인증',
          label: '',
          imageUrl:
            'https://st.kakaocdn.net/thumb/C750x422.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fhome%2Fgroup_discount_product%2F20230503140245_a3d0af4aa80d428192c568843aa907ee.png',
          imageUrlOrigin: 'https://st.kakaocdn.net/shoppingstore/home/group_discount_product/20230503140245_a3d0af4aa80d428192c568843aa907ee.png',
          sharingImageUrl:
            'https://st.kakaocdn.net/thumb/C750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230327115215_322815ce44ee4591b25012a2c43faddd.jpg&mode=watermark&wm_param1=image&wm_id=talkdeal',
          logoImageUrl: '',
          contentRemainDays: 2,
          remainDays: 2,
          contentOpenDt: '20230506',
          contentCloseDt: '20230509',
          likeProductCount: 479,
          isLiked: false,
          score: 1.07255e7,
        },
        {
          productId: 53209039,
          productName: '[EPA+DHA 1,000mg/1일] GNM rTG 알티지오메가3 60캡슐 2박스/비타민E',
          productImage: 'https://st.kakaocdn.net/thumb/C375x375.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230202131209_904b492441844cfb8db1e7eaa323ae0c.jpg',
          productImageOrigin: 'https://st.kakaocdn.net/shoppingstore/product/20230202131209_904b492441844cfb8db1e7eaa323ae0c.jpg',
          originalPrice: 26900,
          discountedPrice: 26900,
          discountRate: 0,
          groupDiscountDisplayable: true,
          groupDiscountStatus: 'ON_SALE',
          groupDiscountedPrice: 18900,
          groupDiscountWillClosed: false,
          groupDiscountUserCount: 563,
          groupDiscountStartAt: 1683360000000,
          groupDiscountEndAt: 1683644399000,
          alarmDisplaying: false,
          groupDiscountRemainSeconds: 198597,
          storeId: 2310,
          storeName: 'GNM자연의품격',
          storeDomain: 'gnmlife',
          storeProfileImage: 'https://st.kakaocdn.net/thumb/B350x350cw/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fstore%2F20230201112144_b50c843620714ac3924102cd5bb2ef0d.jpg',
          new: false,
          linkPath: '/detail/?productId=53209039',
          storeLinkPath: '/gnmlife?area=mainp',
          plusFriendSubscriberExclusive: false,
          farmer: false,
          deliveryFeeType: 'FREE',
          freeDelivery: true,
          reviewCount: 1115,
          productPositivePercentage: 99,
          imageRatio: 'SQUARE',
          displayedSaleStatus: 'ON_SALE',
          categoryId: '102105105100',
          categoryName: '오메가3/스쿠알렌',
          hasAdditionalOptionPrice: true,
          groupDiscountPeriod: { from: '20230506170000', to: '20230509235959' },
          profiles: [
            'https://st.kakaocdn.net/shoppingstore/random/profile_218.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_13.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_454.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_268.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_136.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_530.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_515.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_52.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_29.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_507.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_250.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_121.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_270.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_363.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_9.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_147.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_465.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_44.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_316.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_266.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_346.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_119.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_252.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_337.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_125.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_523.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_129.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_248.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_341.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_477.png',
          ],
          totalSaleCount: 16382,
          trackId: '143797823758159857',
          contentId: 1469,
          contentDisplayPeriod: { from: '20230506170000', to: '20230509235959' },
          type: 'BIG_CARD',
          landingUrl: 'https://store.kakao.com/gnmlife/products/53209039?_=1683445801260&area=mainp',
          mainCopy: 'GNM 알티지 오메가3 식물성캡슐 60정 2박스',
          label: '',
          imageUrl:
            'https://st.kakaocdn.net/thumb/C750x422.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fhome%2Fgroup_discount_product%2F20230503140446_974f09c4704a40988ba9bc9f86e8a3bb.png',
          imageUrlOrigin: 'https://st.kakaocdn.net/shoppingstore/home/group_discount_product/20230503140446_974f09c4704a40988ba9bc9f86e8a3bb.png',
          sharingImageUrl:
            'https://st.kakaocdn.net/thumb/C750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230202131209_904b492441844cfb8db1e7eaa323ae0c.jpg&mode=watermark&wm_param1=image&wm_id=talkdeal',
          logoImageUrl: '',
          contentRemainDays: 2,
          remainDays: 2,
          contentOpenDt: '20230506',
          contentCloseDt: '20230509',
          likeProductCount: 1306,
          isLiked: false,
          score: 1.06407e7,
        },
        {
          productId: 247834660,
          productName: '성주 정품 못난이 꿀참외 3kg 5kg',
          productImage: 'https://st.kakaocdn.net/thumb/C375x375.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230404102418_e19e69467678468b8c042bb7c28c77cd.jpg',
          productImageOrigin: 'https://st.kakaocdn.net/shoppingstore/product/20230404102418_e19e69467678468b8c042bb7c28c77cd.jpg',
          originalPrice: 36900,
          discountedPrice: 36900,
          discountRate: 0,
          groupDiscountDisplayable: true,
          groupDiscountStatus: 'ON_SALE',
          groupDiscountedPrice: 17900,
          groupDiscountWillClosed: false,
          groupDiscountUserCount: 591,
          groupDiscountStartAt: 1683417600000,
          groupDiscountEndAt: 1683730799000,
          alarmDisplaying: false,
          groupDiscountRemainSeconds: 284997,
          storeId: 67458,
          storeName: '한경어게인',
          storeDomain: 'hankyeong',
          storeProfileImage: 'https://st.kakaocdn.net/thumb/B350x350cw/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fstore%2F20210415132701_e4c2a1966d84401893077cb9ea5737e1.jpeg',
          new: false,
          linkPath: '/detail/?productId=247834660',
          storeLinkPath: '/hankyeong?area=mainp',
          plusFriendSubscriberExclusive: false,
          farmer: false,
          deliveryFeeType: 'FREE',
          freeDelivery: true,
          productPositivePercentage: 100,
          imageRatio: 'SQUARE',
          displayedSaleStatus: 'ON_SALE',
          categoryId: '102104103105100',
          categoryName: '참외',
          hasAdditionalOptionPrice: true,
          groupDiscountPeriod: { from: '20230507090000', to: '20230510235959' },
          profiles: [
            'https://st.kakaocdn.net/shoppingstore/random/profile_420.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_162.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_115.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_217.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_55.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_409.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_197.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_344.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_551.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_445.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_219.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_497.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_259.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_326.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_479.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_399.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_60.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_474.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_533.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_406.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_338.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_394.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_376.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_491.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_309.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_367.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_150.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_19.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_142.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_393.png',
          ],
          totalSaleCount: 623,
          trackId: '',
          contentId: 1469,
          contentDisplayPeriod: { from: '20230506170000', to: '20230509235959' },
          type: 'BIG_CARD',
          landingUrl: 'https://store.kakao.com/hankyeong/products/247834660?_=1683445801262&area=mainp',
          mainCopy: '성주 못난이 꿀참외 5kg. 아삭아삭 달달한 과육',
          label: '',
          imageUrl:
            'https://st.kakaocdn.net/thumb/C750x422.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fhome%2Fgroup_discount_product%2F20230507093138_c70272f5d72f49df803eb575c14914e9.png',
          imageUrlOrigin: 'https://st.kakaocdn.net/shoppingstore/home/group_discount_product/20230507093138_c70272f5d72f49df803eb575c14914e9.png',
          sharingImageUrl:
            'https://st.kakaocdn.net/thumb/C750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230404102418_e19e69467678468b8c042bb7c28c77cd.jpg&mode=watermark&wm_param1=image&wm_id=talkdeal',
          logoImageUrl: '',
          contentRemainDays: 2,
          remainDays: 3,
          contentOpenDt: '20230506',
          contentCloseDt: '20230509',
          likeProductCount: 83,
          isLiked: false,
          score: 1.05789e7,
        },
        {
          productId: 164308681,
          productName: '오리온 인기스낵 4+3+3 포카칩,스윙칩,눈을감자,무뚝뚝',
          productImage: 'https://st.kakaocdn.net/thumb/C375x375.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230502144610_adb744ff5cb449af9422c905dca1931a.jpg',
          productImageOrigin: 'https://st.kakaocdn.net/shoppingstore/product/20230502144610_adb744ff5cb449af9422c905dca1931a.jpg',
          originalPrice: 15000,
          discountedPrice: 15000,
          discountRate: 0,
          groupDiscountDisplayable: true,
          groupDiscountStatus: 'ON_SALE',
          groupDiscountedPrice: 10000,
          groupDiscountWillClosed: false,
          groupDiscountUserCount: 952,
          groupDiscountStartAt: 1683360000000,
          groupDiscountEndAt: 1683644399000,
          alarmDisplaying: false,
          groupDiscountRemainSeconds: 198597,
          storeId: 15894,
          storeName: '오리온공식판매점',
          storeDomain: 'orionstore',
          storeProfileImage: 'https://st.kakaocdn.net/thumb/B350x350cw/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fstore%2F20230302165639_3039f3be72884378b2bbe2c413e295ae.jpg',
          new: false,
          linkPath: '/detail/?productId=164308681',
          storeLinkPath: '/orionstore?area=mainp',
          plusFriendSubscriberExclusive: false,
          farmer: false,
          deliveryFeeType: 'FREE',
          freeDelivery: true,
          reviewCount: 1411,
          productPositivePercentage: 99,
          imageRatio: 'SQUARE',
          displayedSaleStatus: 'ON_SALE',
          categoryId: '102109100',
          categoryName: '과자/쿠키',
          hasAdditionalOptionPrice: true,
          groupDiscountPeriod: { from: '20230506170000', to: '20230509235959' },
          profiles: [
            'https://st.kakaocdn.net/shoppingstore/random/profile_468.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_17.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_500.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_63.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_188.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_450.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_246.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_203.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_289.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_29.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_322.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_284.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_378.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_471.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_148.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_462.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_210.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_508.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_253.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_181.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_9.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_67.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_303.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_367.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_523.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_416.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_213.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_2.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_464.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_88.png',
          ],
          totalSaleCount: 25835,
          trackId: '',
          contentId: 1469,
          contentDisplayPeriod: { from: '20230506170000', to: '20230509235959' },
          type: 'BIG_CARD',
          landingUrl: 'https://store.kakao.com/orionstore/products/164308681?_=1683445801259&area=mainp',
          mainCopy: '오리온 인기스낵 10개 골라담기! 오땅/스윙칩 외',
          label: '앵콜톡딜',
          imageUrl:
            'https://st.kakaocdn.net/thumb/C750x422.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fhome%2Fgroup_discount_product%2F20230503140314_a1bbb993e1514e9d807c7288b0ba7100.png',
          imageUrlOrigin: 'https://st.kakaocdn.net/shoppingstore/home/group_discount_product/20230503140314_a1bbb993e1514e9d807c7288b0ba7100.png',
          sharingImageUrl:
            'https://st.kakaocdn.net/thumb/C750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230502144610_adb744ff5cb449af9422c905dca1931a.jpg&mode=watermark&wm_param1=image&wm_id=talkdeal',
          logoImageUrl: '',
          contentRemainDays: 2,
          remainDays: 2,
          contentOpenDt: '20230506',
          contentCloseDt: '20230509',
          likeProductCount: 4092,
          isLiked: false,
          score: 9520000.0,
        },
      ],
    ],
    live: [
      [
        {
          productId: 246324459,
          productName: '카밀 대용량 바디로션 1+1+미니 바디로션 1개 증정',
          productImage: 'https://st.kakaocdn.net/thumb/C375x375.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230421163754_65f354cc72cd4958a4593b64a086dd11.jpg',
          productImageOrigin: 'https://st.kakaocdn.net/shoppingstore/product/20230421163754_65f354cc72cd4958a4593b64a086dd11.jpg',
          originalPrice: 34700,
          discountedPrice: 34700,
          discountRate: 0,
          groupDiscountDisplayable: true,
          groupDiscountStatus: 'ON_SALE',
          groupDiscountedPrice: 12900,
          groupDiscountWillClosed: false,
          groupDiscountUserCount: 1571,
          groupDiscountStartAt: 1683360000000,
          groupDiscountEndAt: 1683644399000,
          alarmDisplaying: false,
          groupDiscountRemainSeconds: 198597,
          storeId: 58053,
          storeName: '지엘커뮤니케이션즈',
          storeDomain: 'glcomm',
          storeProfileImage: 'https://st.kakaocdn.net/thumb/B350x350cw/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fstore%2F20210111095926_2c708d8f5fa3405aa6f3148a870b8480.jpeg',
          new: false,
          linkPath: '/detail/?productId=246324459',
          storeLinkPath: '/glcomm?area=mainp',
          plusFriendSubscriberExclusive: false,
          farmer: false,
          deliveryFeeType: 'FREE',
          freeDelivery: true,
          imageRatio: 'SQUARE',
          displayedSaleStatus: 'ON_SALE',
          categoryId: '101103100100101',
          categoryName: '바디로션',
          hasAdditionalOptionPrice: false,
          groupDiscountPeriod: { from: '20230506170000', to: '20230509235959' },
          profiles: [
            'https://st.kakaocdn.net/shoppingstore/random/profile_336.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_366.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_353.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_94.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_80.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_373.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_427.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_263.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_343.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_330.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_83.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_253.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_288.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_377.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_350.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_296.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_363.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_177.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_478.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_407.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_27.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_539.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_11.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_337.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_57.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_208.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_531.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_129.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_97.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_306.png',
          ],
          totalSaleCount: 1641,
          trackId: '',
          contentId: 1469,
          contentDisplayPeriod: { from: '20230506170000', to: '20230509235959' },
          type: 'BIG_CARD',
          landingUrl: 'https://store.kakao.com/glcomm/products/246324459?_=1683445801261&area=mainp',
          mainCopy: '카밀 바디로션 500ml 1+1+50ml 추가 증정',
          label: '',
          imageUrl:
            'https://st.kakaocdn.net/thumb/C750x422.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fhome%2Fgroup_discount_product%2F20230503140542_1dcb6a9906b14d11b0338e53510cccbc.png',
          imageUrlOrigin: 'https://st.kakaocdn.net/shoppingstore/home/group_discount_product/20230503140542_1dcb6a9906b14d11b0338e53510cccbc.png',
          sharingImageUrl:
            'https://st.kakaocdn.net/thumb/C750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230421163754_65f354cc72cd4958a4593b64a086dd11.jpg&mode=watermark&wm_param1=image&wm_id=talkdeal',
          logoImageUrl: '',
          contentRemainDays: 2,
          remainDays: 2,
          contentOpenDt: '20230506',
          contentCloseDt: '20230509',
          likeProductCount: 814,
          isLiked: false,
          score: 2.02659e7,
        },
        {
          productId: 197627921,
          productName: '[카렉스] 시야확보주의! 레인스톰 하이브리드 와이퍼 2+2 (차량2대분)',
          productImage: 'https://st.kakaocdn.net/thumb/C375x375.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230502134519_cfbf8c4266eb4d34af8910b0141a8762.png',
          productImageOrigin: 'https://st.kakaocdn.net/shoppingstore/product/20230502134519_cfbf8c4266eb4d34af8910b0141a8762.png',
          originalPrice: 23600,
          discountedPrice: 23600,
          discountRate: 0,
          groupDiscountDisplayable: true,
          groupDiscountStatus: 'ON_SALE',
          groupDiscountedPrice: 9900,
          groupDiscountWillClosed: false,
          groupDiscountUserCount: 1777,
          groupDiscountStartAt: 1683360000000,
          groupDiscountEndAt: 1683644399000,
          alarmDisplaying: false,
          groupDiscountRemainSeconds: 198597,
          storeId: 15139,
          storeName: '카렉스몰',
          storeDomain: 'carex',
          storeProfileImage: 'https://st.kakaocdn.net/thumb/B350x350cw/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fstore%2F20230417160745_796ff505b7e74d6fb3dc806d508b3da6.jpg',
          new: false,
          linkPath: '/detail/?productId=197627921',
          storeLinkPath: '/carex?area=mainp',
          plusFriendSubscriberExclusive: false,
          farmer: false,
          deliveryFeeType: 'FREE',
          freeDelivery: true,
          reviewCount: 233,
          productPositivePercentage: 99,
          imageRatio: 'SQUARE',
          displayedSaleStatus: 'ON_SALE',
          categoryId: '103101116110',
          categoryName: '와이퍼',
          hasAdditionalOptionPrice: false,
          groupDiscountPeriod: { from: '20230506170000', to: '20230509235959' },
          profiles: [
            'https://st.kakaocdn.net/shoppingstore/random/profile_552.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_446.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_340.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_277.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_76.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_290.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_432.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_475.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_157.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_497.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_293.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_427.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_529.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_211.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_250.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_401.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_194.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_508.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_288.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_325.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_428.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_448.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_214.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_502.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_295.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_257.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_62.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_129.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_315.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_473.png',
          ],
          totalSaleCount: 5249,
          trackId: '',
          contentId: 1469,
          contentDisplayPeriod: { from: '20230506170000', to: '20230509235959' },
          type: 'BIG_CARD',
          landingUrl: 'https://store.kakao.com/carex/products/197627921?_=1683445801257&area=mainp',
          mainCopy: '카렉스 하이브리드 와이퍼 2+2. 뛰어난 고성능 와이퍼',
          label: '',
          imageUrl:
            'https://st.kakaocdn.net/thumb/C750x422.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fhome%2Fgroup_discount_product%2F20230503140044_18e765e4e03a497ab939d6ec49122a6b.png',
          imageUrlOrigin: 'https://st.kakaocdn.net/shoppingstore/home/group_discount_product/20230503140044_18e765e4e03a497ab939d6ec49122a6b.png',
          sharingImageUrl:
            'https://st.kakaocdn.net/thumb/C750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230502134519_cfbf8c4266eb4d34af8910b0141a8762.png&mode=watermark&wm_param1=image&wm_id=talkdeal',
          logoImageUrl: '',
          contentRemainDays: 2,
          remainDays: 2,
          contentOpenDt: '20230506',
          contentCloseDt: '20230509',
          likeProductCount: 1084,
          isLiked: false,
          score: 1.75923e7,
        },
        {
          productId: 139319258,
          productName: '온더바디 슈퍼보타닉 비누 12개(쟈스민,오이라임) 외',
          productImage: 'https://st.kakaocdn.net/thumb/C375x375.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230504111125_f80ab8bb9b724e67b20d4c16b5dc3789.jpg',
          productImageOrigin: 'https://st.kakaocdn.net/shoppingstore/product/20230504111125_f80ab8bb9b724e67b20d4c16b5dc3789.jpg',
          originalPrice: 19800,
          discountedPrice: 19800,
          discountRate: 0,
          groupDiscountDisplayable: true,
          groupDiscountStatus: 'ON_SALE',
          groupDiscountedPrice: 9900,
          groupDiscountWillClosed: false,
          groupDiscountUserCount: 1300,
          groupDiscountStartAt: 1683360000000,
          groupDiscountEndAt: 1683644399000,
          alarmDisplaying: false,
          groupDiscountRemainSeconds: 198597,
          storeId: 2530,
          storeName: 'LG생활건강',
          storeDomain: 'lgcare',
          storeProfileImage: 'https://st.kakaocdn.net/thumb/B350x350cw/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fstore%2F20180906172400_1455a346d67045d2a8e82e1b71145b1b.jpeg',
          new: false,
          linkPath: '/detail/?productId=139319258',
          storeLinkPath: '/lgcare?area=mainp',
          plusFriendSubscriberExclusive: false,
          farmer: false,
          deliveryFeeType: 'FREE',
          freeDelivery: true,
          reviewCount: 606,
          productPositivePercentage: 99,
          imageRatio: 'SQUARE',
          displayedSaleStatus: 'ON_SALE',
          categoryId: '101107107104',
          categoryName: '클렌징 비누',
          hasAdditionalOptionPrice: false,
          groupDiscountPeriod: { from: '20230506170000', to: '20230509235959' },
          profiles: [
            'https://st.kakaocdn.net/shoppingstore/random/profile_357.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_218.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_13.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_255.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_238.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_212.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_95.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_187.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_402.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_149.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_300.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_467.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_82.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_166.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_219.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_25.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_105.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_304.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_503.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_58.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_100.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_482.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_236.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_368.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_398.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_389.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_243.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_32.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_332.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_88.png',
          ],
          totalSaleCount: 9825,
          trackId: '568260606456383071',
          contentId: 1469,
          contentDisplayPeriod: { from: '20230506170000', to: '20230509235959' },
          type: 'BIG_CARD',
          landingUrl: 'https://store.kakao.com/lgcare/products/139319258?_=1683445801261&area=mainp',
          mainCopy: '온더바디 슈퍼보타닉 비누 12개, 자스민/오이라임',
          label: '',
          imageUrl:
            'https://st.kakaocdn.net/thumb/C750x422.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fhome%2Fgroup_discount_product%2F20230503140535_dc210d7a6de649288e5d7af08abea4fc.png',
          imageUrlOrigin: 'https://st.kakaocdn.net/shoppingstore/home/group_discount_product/20230503140535_dc210d7a6de649288e5d7af08abea4fc.png',
          sharingImageUrl:
            'https://st.kakaocdn.net/thumb/C750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230504111125_f80ab8bb9b724e67b20d4c16b5dc3789.jpg&mode=watermark&wm_param1=image&wm_id=talkdeal',
          logoImageUrl: '',
          contentRemainDays: 2,
          remainDays: 2,
          contentOpenDt: '20230506',
          contentCloseDt: '20230509',
          likeProductCount: 1796,
          isLiked: false,
          score: 1.287e7,
        },
        {
          productId: 68626964,
          productName: '[퍼실 300ml 2개 증정] 헨켈 섬유유연제 버넬 0.9L 6개',
          productImage: 'https://st.kakaocdn.net/thumb/C375x375.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230427144204_ac2dd3c737b940f291b0065d98e89d6a.jpg',
          productImageOrigin: 'https://st.kakaocdn.net/shoppingstore/product/20230427144204_ac2dd3c737b940f291b0065d98e89d6a.jpg',
          originalPrice: 41400,
          discountedPrice: 41400,
          discountRate: 0,
          groupDiscountDisplayable: true,
          groupDiscountStatus: 'ON_SALE',
          groupDiscountedPrice: 16900,
          groupDiscountWillClosed: false,
          groupDiscountUserCount: 693,
          groupDiscountStartAt: 1683360000000,
          groupDiscountEndAt: 1683644399000,
          alarmDisplaying: false,
          groupDiscountRemainSeconds: 198597,
          storeId: 1634,
          storeName: '헨켈온라인공식몰',
          storeDomain: 'henkel',
          storeProfileImage: 'https://st.kakaocdn.net/thumb/B350x350cw/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fstore%2F20180608105211_d2911174025541ae8dffd07245b7f3c1.jpeg',
          new: false,
          linkPath: '/detail/?productId=68626964',
          storeLinkPath: '/henkel?area=mainp',
          plusFriendSubscriberExclusive: false,
          farmer: false,
          deliveryFeeType: 'FREE',
          freeDelivery: true,
          reviewCount: 1890,
          productPositivePercentage: 98,
          imageRatio: 'SQUARE',
          displayedSaleStatus: 'ON_SALE',
          categoryId: '104103103101',
          categoryName: '섬유유연제',
          hasAdditionalOptionPrice: true,
          groupDiscountPeriod: { from: '20230506170000', to: '20230509235959' },
          profiles: [
            'https://st.kakaocdn.net/shoppingstore/random/profile_234.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_361.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_353.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_485.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_285.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_417.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_81.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_357.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_63.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_145.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_65.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_405.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_135.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_237.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_4.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_118.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_410.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_283.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_156.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_288.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_113.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_232.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_398.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_74.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_71.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_208.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_416.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_429.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_505.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_438.png',
          ],
          totalSaleCount: 25200,
          trackId: '7247716872349566931',
          contentId: 1469,
          contentDisplayPeriod: { from: '20230506170000', to: '20230509235959' },
          type: 'BIG_CARD',
          landingUrl: 'https://store.kakao.com/henkel/products/68626964?_=1683445801258&area=mainp',
          mainCopy: '헨켈 고농축 섬유유연제 버넬 0.9L 6개+퍼실 증정',
          label: '',
          imageUrl:
            'https://st.kakaocdn.net/thumb/C750x422.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fhome%2Fgroup_discount_product%2F20230503140122_ce4908bacb4d4a84a9b951af5866d3cc.png',
          imageUrlOrigin: 'https://st.kakaocdn.net/shoppingstore/home/group_discount_product/20230503140122_ce4908bacb4d4a84a9b951af5866d3cc.png',
          sharingImageUrl:
            'https://st.kakaocdn.net/thumb/C750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230427144204_ac2dd3c737b940f291b0065d98e89d6a.jpg&mode=watermark&wm_param1=image&wm_id=talkdeal',
          logoImageUrl: '',
          contentRemainDays: 2,
          remainDays: 2,
          contentOpenDt: '20230506',
          contentCloseDt: '20230509',
          likeProductCount: 2008,
          isLiked: false,
          score: 1.17117e7,
        },
      ],
    ],
    digital: [
      [
        {
          productId: 90836953,
          productName: '[오늘 구매시 백화점 상품권 증정!! / 눈물의 재고 정리 특가] 클리엔 R9 로봇청소기',
          productImage: 'https://st.kakaocdn.net/thumb/C375x375.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230503120952_8040d7bf834c4860b2bb74a01f990825.jpg',
          productImageOrigin: 'https://st.kakaocdn.net/shoppingstore/product/20230503120952_8040d7bf834c4860b2bb74a01f990825.jpg',
          originalPrice: 799000,
          discountedPrice: 799000,
          discountRate: 0,
          groupDiscountDisplayable: true,
          groupDiscountStatus: 'ON_SALE',
          groupDiscountedPrice: 369000,
          groupDiscountWillClosed: false,
          groupDiscountUserCount: 134,
          groupDiscountStartAt: 1683360000000,
          groupDiscountEndAt: 1683644399000,
          alarmDisplaying: false,
          groupDiscountRemainSeconds: 198597,
          storeId: 66388,
          storeName: '클리엔',
          storeDomain: 'clien',
          storeProfileImage: 'https://st.kakaocdn.net/thumb/B350x350cw/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fstore%2F20210405180300_b5ab0f7204284d0293497ce4f33c7882.jpeg',
          new: false,
          linkPath: '/detail/?productId=90836953',
          storeLinkPath: '/clien?area=mainp',
          plusFriendSubscriberExclusive: false,
          farmer: false,
          deliveryFeeType: 'FREE',
          freeDelivery: true,
          reviewCount: 2579,
          productPositivePercentage: 100,
          imageRatio: 'SQUARE',
          displayedSaleStatus: 'ON_SALE',
          categoryId: '100103102101',
          categoryName: '로봇청소기',
          hasAdditionalOptionPrice: true,
          groupDiscountPeriod: { from: '20230506170000', to: '20230509235959' },
          profiles: [
            'https://st.kakaocdn.net/shoppingstore/random/profile_221.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_485.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_69.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_123.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_459.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_500.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_340.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_301.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_329.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_99.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_25.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_507.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_105.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_210.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_91.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_66.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_8.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_292.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_448.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_163.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_84.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_469.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_111.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_97.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_79.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_421.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_544.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_265.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_36.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_438.png',
          ],
          totalSaleCount: 6722,
          trackId: '4015756886542694813',
          contentId: 1469,
          contentDisplayPeriod: { from: '20230506170000', to: '20230509235959' },
          type: 'BIG_CARD',
          landingUrl: 'https://store.kakao.com/clien/products/90836953?_=1683445801257&area=mainp',
          mainCopy: '클리엔 로봇청소기 R9. 진공청소와 물걸레를 한번에',
          label: '',
          imageUrl:
            'https://st.kakaocdn.net/thumb/C750x422.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fhome%2Fgroup_discount_product%2F20230503140010_3225abb6924e43df8e69a0233db29c96.png',
          imageUrlOrigin: 'https://st.kakaocdn.net/shoppingstore/home/group_discount_product/20230503140010_3225abb6924e43df8e69a0233db29c96.png',
          sharingImageUrl:
            'https://st.kakaocdn.net/thumb/C750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230503120952_8040d7bf834c4860b2bb74a01f990825.jpg&mode=watermark&wm_param1=image&wm_id=talkdeal',
          logoImageUrl: '',
          contentRemainDays: 2,
          remainDays: 2,
          contentOpenDt: '20230506',
          contentCloseDt: '20230509',
          likeProductCount: 2597,
          isLiked: false,
          score: 4.9446e7,
        },
      ],
    ],
    passion: [
      [
        {
          productId: 247087647,
          productName: '반스 스니커즈 20종 모음전',
          productImage: 'https://st.kakaocdn.net/thumb/C375x375.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230503113855_63af65cc961c4054855538dee4a38858.jpg',
          productImageOrigin: 'https://st.kakaocdn.net/shoppingstore/product/20230503113855_63af65cc961c4054855538dee4a38858.jpg',
          originalPrice: 79000,
          discountedPrice: 79000,
          discountRate: 0,
          groupDiscountDisplayable: true,
          groupDiscountStatus: 'ON_SALE',
          groupDiscountedPrice: 39900,
          groupDiscountWillClosed: false,
          groupDiscountUserCount: 2006,
          groupDiscountStartAt: 1683360000000,
          groupDiscountEndAt: 1683644399000,
          alarmDisplaying: false,
          groupDiscountRemainSeconds: 198597,
          storeId: 40714,
          storeName: '아이스탁몰',
          storeDomain: 'istockmall',
          storeProfileImage: 'https://st.kakaocdn.net/thumb/B350x350cw/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fstore%2F20200515131237_23adae4cca2c42a0800ed3ed5e5cc168.jpeg',
          new: false,
          linkPath: '/detail/?productId=247087647',
          storeLinkPath: '/istockmall?area=mainp',
          plusFriendSubscriberExclusive: false,
          farmer: false,
          deliveryFeeType: 'FREE',
          freeDelivery: true,
          imageRatio: 'SQUARE',
          displayedSaleStatus: 'ON_SALE',
          categoryId: '101108104101',
          categoryName: '캐주얼운동화',
          hasAdditionalOptionPrice: true,
          groupDiscountPeriod: { from: '20230506170000', to: '20230509235959' },
          profiles: [
            'https://st.kakaocdn.net/shoppingstore/random/profile_403.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_535.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_154.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_136.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_301.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_108.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_335.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_29.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_466.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_529.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_395.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_210.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_342.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_533.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_538.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_350.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_431.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_406.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_178.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_113.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_457.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_351.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_236.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_87.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_381.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_486.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_260.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_282.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_404.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_92.png',
          ],
          totalSaleCount: 2437,
          trackId: '1463847132807741383',
          contentId: 1469,
          contentDisplayPeriod: { from: '20230506170000', to: '20230509235959' },
          type: 'BIG_CARD',
          landingUrl: 'https://store.kakao.com/istockmall/products/247087647?_=1683445801258&area=mainp',
          mainCopy: '반스 데일리 스니커즈/슬립온 20종 스타일',
          label: '',
          imageUrl:
            'https://st.kakaocdn.net/thumb/C750x422.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fhome%2Fgroup_discount_product%2F20230503162549_c6ad232a4b4444aeaa63d3315db214e3.jpeg',
          imageUrlOrigin: 'https://st.kakaocdn.net/shoppingstore/home/group_discount_product/20230503162549_c6ad232a4b4444aeaa63d3315db214e3.jpeg',
          sharingImageUrl:
            'https://st.kakaocdn.net/thumb/C750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230503113855_63af65cc961c4054855538dee4a38858.jpg&mode=watermark&wm_param1=image&wm_id=talkdeal',
          logoImageUrl: '',
          contentRemainDays: 2,
          remainDays: 2,
          contentOpenDt: '20230506',
          contentCloseDt: '20230509',
          likeProductCount: 1870,
          isLiked: false,
          score: 8.00394e7,
        },
        {
          productId: 64498390,
          productName: '[지프] 무료배송 (공용) 인기상품  18종택1',
          productImage: 'https://st.kakaocdn.net/thumb/C375x375.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230503143644_2f143599dc6145e28657214e0ff92268.png',
          productImageOrigin: 'https://st.kakaocdn.net/shoppingstore/product/20230503143644_2f143599dc6145e28657214e0ff92268.png',
          originalPrice: 35000,
          discountedPrice: 35000,
          discountRate: 0,
          groupDiscountDisplayable: true,
          groupDiscountStatus: 'ON_SALE',
          groupDiscountedPrice: 18700,
          groupDiscountWillClosed: false,
          groupDiscountUserCount: 550,
          groupDiscountStartAt: 1683360000000,
          groupDiscountEndAt: 1683644399000,
          alarmDisplaying: false,
          groupDiscountRemainSeconds: 198597,
          storeId: 35979,
          storeName: '현대백화점 판교점',
          storeDomain: 'hdpangyo',
          storeProfileImage: 'https://st.kakaocdn.net/thumb/B350x350cw/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fstore%2F20200616115712_a14275635cb04f32a8ee2d1e6dad879f.jpg',
          new: false,
          linkPath: '/detail/?productId=64498390',
          storeLinkPath: '/hdpangyo?area=mainp',
          plusFriendSubscriberExclusive: false,
          farmer: false,
          deliveryFeeType: 'FREE',
          freeDelivery: true,
          reviewCount: 1326,
          productPositivePercentage: 96,
          imageRatio: 'SQUARE',
          displayedSaleStatus: 'ON_SALE',
          categoryId: '101104101100',
          categoryName: '남성 라운드넥 티셔츠',
          hasAdditionalOptionPrice: true,
          groupDiscountPeriod: { from: '20230506170000', to: '20230509235959' },
          profiles: [
            'https://st.kakaocdn.net/shoppingstore/random/profile_403.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_17.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_115.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_192.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_379.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_69.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_489.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_340.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_141.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_63.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_158.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_145.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_534.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_360.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_59.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_492.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_127.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_122.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_330.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_431.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_270.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_206.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_262.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_550.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_275.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_222.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_7.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_244.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_434.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_447.png',
          ],
          totalSaleCount: 28246,
          trackId: '',
          contentId: 1469,
          contentDisplayPeriod: { from: '20230506170000', to: '20230509235959' },
          type: 'BIG_CARD',
          landingUrl: 'https://store.kakao.com/hdpangyo/products/64498390?_=1683445801260&area=mainp',
          mainCopy: '지프 남녀공용 인기 캐주얼 의류 18종 스타일',
          label: '앵콜톡딜',
          imageUrl:
            'https://st.kakaocdn.net/thumb/C750x422.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fhome%2Fgroup_discount_product%2F20230503140501_85abfaa530f54c28b9f209028dbbb5fc.png',
          imageUrlOrigin: 'https://st.kakaocdn.net/shoppingstore/home/group_discount_product/20230503140501_85abfaa530f54c28b9f209028dbbb5fc.png',
          sharingImageUrl:
            'https://st.kakaocdn.net/thumb/C750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230503143644_2f143599dc6145e28657214e0ff92268.png&mode=watermark&wm_param1=image&wm_id=talkdeal',
          logoImageUrl: '',
          contentRemainDays: 2,
          remainDays: 2,
          contentOpenDt: '20230506',
          contentCloseDt: '20230509',
          likeProductCount: 4565,
          isLiked: false,
          score: 1.0285e7,
        },
        {
          productId: 227497376,
          productName: '[코코블랑] 23 여름신상 반팔니트 9900원 외 100종 최대할인',
          productImage: 'https://st.kakaocdn.net/thumb/C375x375.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230503154913_4d9c5a4dda024f7a92c71168866f788b.jpg',
          productImageOrigin: 'https://st.kakaocdn.net/shoppingstore/product/20230503154913_4d9c5a4dda024f7a92c71168866f788b.jpg',
          originalPrice: 49900,
          discountedPrice: 49900,
          discountRate: 0,
          groupDiscountDisplayable: true,
          groupDiscountStatus: 'ON_SALE',
          groupDiscountedPrice: 9900,
          groupDiscountWillClosed: false,
          groupDiscountUserCount: 958,
          groupDiscountStartAt: 1683360000000,
          groupDiscountEndAt: 1683644399000,
          alarmDisplaying: false,
          groupDiscountRemainSeconds: 198597,
          storeId: 62459,
          storeName: '코코블랑',
          storeDomain: 'cocoblanc',
          storeProfileImage: 'https://st.kakaocdn.net/thumb/B350x350cw/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fstore%2F20221219133214_ba607a89cb2a4aedadb13d74678325a3.jpg',
          new: false,
          linkPath: '/detail/?productId=227497376',
          storeLinkPath: '/cocoblanc?area=mainp',
          plusFriendSubscriberExclusive: false,
          farmer: false,
          deliveryFeeType: 'FREE',
          freeDelivery: true,
          imageRatio: 'SQUARE',
          displayedSaleStatus: 'ON_SALE',
          categoryId: '101102102104',
          categoryName: '여성 브이넥 니트',
          hasAdditionalOptionPrice: true,
          groupDiscountPeriod: { from: '20230506170000', to: '20230509235959' },
          profiles: [
            'https://st.kakaocdn.net/shoppingstore/random/profile_102.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_328.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_192.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_442.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_55.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_357.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_370.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_327.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_500.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_305.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_515.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_90.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_86.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_334.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_47.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_183.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_342.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_487.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_181.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_350.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_28.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_236.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_31.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_266.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_190.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_248.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_371.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_133.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_198.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_36.png',
          ],
          totalSaleCount: 2443,
          trackId: '',
          contentId: 1469,
          contentDisplayPeriod: { from: '20230506170000', to: '20230509235959' },
          type: 'BIG_CARD',
          landingUrl: 'https://store.kakao.com/cocoblanc/products/227497376?_=1683445801261&area=mainp',
          mainCopy: '코코블랑 브이넥 반팔 니트 외 데일리룩 99종 스타일',
          label: '',
          imageUrl:
            'https://st.kakaocdn.net/thumb/C750x422.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fhome%2Fgroup_discount_product%2F20230503140516_0260e927c462473bbb40491d5b5c97b0.png',
          imageUrlOrigin: 'https://st.kakaocdn.net/shoppingstore/home/group_discount_product/20230503140516_0260e927c462473bbb40491d5b5c97b0.png',
          sharingImageUrl:
            'https://st.kakaocdn.net/thumb/C750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230503154913_4d9c5a4dda024f7a92c71168866f788b.jpg&mode=watermark&wm_param1=image&wm_id=talkdeal',
          logoImageUrl: '',
          contentRemainDays: 2,
          remainDays: 2,
          contentOpenDt: '20230506',
          contentCloseDt: '20230509',
          likeProductCount: 792,
          isLiked: false,
          score: 9484200.0,
        },
      ],
    ],
    products: [
      [
        {
          productId: 247087647,
          productName: '반스 스니커즈 20종 모음전',
          productImage: 'https://st.kakaocdn.net/thumb/C375x375.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230503113855_63af65cc961c4054855538dee4a38858.jpg',
          productImageOrigin: 'https://st.kakaocdn.net/shoppingstore/product/20230503113855_63af65cc961c4054855538dee4a38858.jpg',
          originalPrice: 79000,
          discountedPrice: 79000,
          discountRate: 0,
          groupDiscountDisplayable: true,
          groupDiscountStatus: 'ON_SALE',
          groupDiscountedPrice: 39900,
          groupDiscountWillClosed: false,
          groupDiscountUserCount: 2006,
          groupDiscountStartAt: 1683360000000,
          groupDiscountEndAt: 1683644399000,
          alarmDisplaying: false,
          groupDiscountRemainSeconds: 198597,
          storeId: 40714,
          storeName: '아이스탁몰',
          storeDomain: 'istockmall',
          storeProfileImage: 'https://st.kakaocdn.net/thumb/B350x350cw/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fstore%2F20200515131237_23adae4cca2c42a0800ed3ed5e5cc168.jpeg',
          new: false,
          linkPath: '/detail/?productId=247087647',
          storeLinkPath: '/istockmall?area=mainp',
          plusFriendSubscriberExclusive: false,
          farmer: false,
          deliveryFeeType: 'FREE',
          freeDelivery: true,
          imageRatio: 'SQUARE',
          displayedSaleStatus: 'ON_SALE',
          categoryId: '101108104101',
          categoryName: '캐주얼운동화',
          hasAdditionalOptionPrice: true,
          groupDiscountPeriod: { from: '20230506170000', to: '20230509235959' },
          profiles: [
            'https://st.kakaocdn.net/shoppingstore/random/profile_403.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_535.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_154.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_136.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_301.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_108.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_335.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_29.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_466.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_529.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_395.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_210.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_342.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_533.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_538.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_350.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_431.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_406.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_178.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_113.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_457.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_351.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_236.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_87.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_381.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_486.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_260.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_282.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_404.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_92.png',
          ],
          totalSaleCount: 2437,
          trackId: '1463847132807741383',
          contentId: 1469,
          contentDisplayPeriod: { from: '20230506170000', to: '20230509235959' },
          type: 'BIG_CARD',
          landingUrl: 'https://store.kakao.com/istockmall/products/247087647?_=1683445801258&area=mainp',
          mainCopy: '반스 데일리 스니커즈/슬립온 20종 스타일',
          label: '',
          imageUrl:
            'https://st.kakaocdn.net/thumb/C750x422.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fhome%2Fgroup_discount_product%2F20230503162549_c6ad232a4b4444aeaa63d3315db214e3.jpeg',
          imageUrlOrigin: 'https://st.kakaocdn.net/shoppingstore/home/group_discount_product/20230503162549_c6ad232a4b4444aeaa63d3315db214e3.jpeg',
          sharingImageUrl:
            'https://st.kakaocdn.net/thumb/C750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230503113855_63af65cc961c4054855538dee4a38858.jpg&mode=watermark&wm_param1=image&wm_id=talkdeal',
          logoImageUrl: '',
          contentRemainDays: 2,
          remainDays: 2,
          contentOpenDt: '20230506',
          contentCloseDt: '20230509',
          likeProductCount: 1870,
          isLiked: false,
          score: 8.00394e7,
        },
        {
          productId: 247868049,
          productName: '목우촌 한우 인삼갈비탕 700gX4개+한우 사골곰탕 4개 증정',
          productImage: 'https://st.kakaocdn.net/thumb/C375x375.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230427145426_080e14bb1d234597a2f468afde015a50.jpg',
          productImageOrigin: 'https://st.kakaocdn.net/shoppingstore/product/20230427145426_080e14bb1d234597a2f468afde015a50.jpg',
          originalPrice: 59900,
          discountedPrice: 59900,
          discountRate: 0,
          groupDiscountDisplayable: true,
          groupDiscountStatus: 'ON_SALE',
          groupDiscountedPrice: 28900,
          groupDiscountWillClosed: false,
          groupDiscountUserCount: 2357,
          groupDiscountStartAt: 1683360000000,
          groupDiscountEndAt: 1683644399000,
          alarmDisplaying: false,
          groupDiscountRemainSeconds: 198597,
          storeId: 69747,
          storeName: '목우촌',
          storeDomain: 'moguchon',
          storeProfileImage: 'https://st.kakaocdn.net/thumb/B350x350cw/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fstore%2F20220620195113_0e4200b7122945598f61132ce4e0ea0e.jpg',
          new: false,
          linkPath: '/detail/?productId=247868049',
          storeLinkPath: '/moguchon?area=mainp',
          plusFriendSubscriberExclusive: false,
          farmer: false,
          deliveryFeeType: 'FREE',
          freeDelivery: true,
          imageRatio: 'SQUARE',
          displayedSaleStatus: 'ON_SALE',
          categoryId: '102100100112',
          categoryName: '국/탕/찌개',
          hasAdditionalOptionPrice: false,
          groupDiscountPeriod: { from: '20230506170000', to: '20230509235959' },
          profiles: [
            'https://st.kakaocdn.net/shoppingstore/random/profile_493.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_420.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_366.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_498.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_18.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_171.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_246.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_267.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_109.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_73.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_210.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_546.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_372.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_228.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_202.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_350.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_100.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_435.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_236.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_229.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_448.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_346.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_295.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_14.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_389.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_205.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_490.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_548.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_23.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_198.png',
          ],
          totalSaleCount: 2839,
          trackId: '1726756183548867528',
          contentId: 1469,
          contentDisplayPeriod: { from: '20230506170000', to: '20230509235959' },
          type: 'BIG_CARD',
          landingUrl: 'https://store.kakao.com/moguchon/products/247868049?_=1683445801259&area=mainp',
          mainCopy: '목우촌 한우 인삼 갈비탕 700g 4개+사골곰탕 4개',
          label: '',
          imageUrl:
            'https://st.kakaocdn.net/thumb/C750x422.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fhome%2Fgroup_discount_product%2F20230503140323_8c2159beb21249ad81360a6aaae1ac54.png',
          imageUrlOrigin: 'https://st.kakaocdn.net/shoppingstore/home/group_discount_product/20230503140323_8c2159beb21249ad81360a6aaae1ac54.png',
          sharingImageUrl:
            'https://st.kakaocdn.net/thumb/C750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230427145426_080e14bb1d234597a2f468afde015a50.jpg&mode=watermark&wm_param1=image&wm_id=talkdeal',
          logoImageUrl: '',
          contentRemainDays: 2,
          remainDays: 2,
          contentOpenDt: '20230506',
          contentCloseDt: '20230509',
          likeProductCount: 581,
          isLiked: false,
          score: 6.81173e7,
        },
        {
          productId: 90836953,
          productName: '[오늘 구매시 백화점 상품권 증정!! / 눈물의 재고 정리 특가] 클리엔 R9 로봇청소기',
          productImage: 'https://st.kakaocdn.net/thumb/C375x375.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230503120952_8040d7bf834c4860b2bb74a01f990825.jpg',
          productImageOrigin: 'https://st.kakaocdn.net/shoppingstore/product/20230503120952_8040d7bf834c4860b2bb74a01f990825.jpg',
          originalPrice: 799000,
          discountedPrice: 799000,
          discountRate: 0,
          groupDiscountDisplayable: true,
          groupDiscountStatus: 'ON_SALE',
          groupDiscountedPrice: 369000,
          groupDiscountWillClosed: false,
          groupDiscountUserCount: 134,
          groupDiscountStartAt: 1683360000000,
          groupDiscountEndAt: 1683644399000,
          alarmDisplaying: false,
          groupDiscountRemainSeconds: 198597,
          storeId: 66388,
          storeName: '클리엔',
          storeDomain: 'clien',
          storeProfileImage: 'https://st.kakaocdn.net/thumb/B350x350cw/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fstore%2F20210405180300_b5ab0f7204284d0293497ce4f33c7882.jpeg',
          new: false,
          linkPath: '/detail/?productId=90836953',
          storeLinkPath: '/clien?area=mainp',
          plusFriendSubscriberExclusive: false,
          farmer: false,
          deliveryFeeType: 'FREE',
          freeDelivery: true,
          reviewCount: 2579,
          productPositivePercentage: 100,
          imageRatio: 'SQUARE',
          displayedSaleStatus: 'ON_SALE',
          categoryId: '100103102101',
          categoryName: '로봇청소기',
          hasAdditionalOptionPrice: true,
          groupDiscountPeriod: { from: '20230506170000', to: '20230509235959' },
          profiles: [
            'https://st.kakaocdn.net/shoppingstore/random/profile_221.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_485.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_69.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_123.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_459.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_500.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_340.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_301.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_329.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_99.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_25.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_507.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_105.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_210.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_91.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_66.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_8.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_292.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_448.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_163.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_84.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_469.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_111.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_97.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_79.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_421.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_544.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_265.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_36.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_438.png',
          ],
          totalSaleCount: 6722,
          trackId: '4015756886542694813',
          contentId: 1469,
          contentDisplayPeriod: { from: '20230506170000', to: '20230509235959' },
          type: 'BIG_CARD',
          landingUrl: 'https://store.kakao.com/clien/products/90836953?_=1683445801257&area=mainp',
          mainCopy: '클리엔 로봇청소기 R9. 진공청소와 물걸레를 한번에',
          label: '',
          imageUrl:
            'https://st.kakaocdn.net/thumb/C750x422.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fhome%2Fgroup_discount_product%2F20230503140010_3225abb6924e43df8e69a0233db29c96.png',
          imageUrlOrigin: 'https://st.kakaocdn.net/shoppingstore/home/group_discount_product/20230503140010_3225abb6924e43df8e69a0233db29c96.png',
          sharingImageUrl:
            'https://st.kakaocdn.net/thumb/C750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230503120952_8040d7bf834c4860b2bb74a01f990825.jpg&mode=watermark&wm_param1=image&wm_id=talkdeal',
          logoImageUrl: '',
          contentRemainDays: 2,
          remainDays: 2,
          contentOpenDt: '20230506',
          contentCloseDt: '20230509',
          likeProductCount: 2597,
          isLiked: false,
          score: 4.9446e7,
        },
        {
          productId: 204308361,
          productName: '[우체국쇼핑]전북 정읍 국내산 귀리로 만든 귀리뻥튀기 왕큰봉지 2봉/4봉',
          productImage: 'https://st.kakaocdn.net/thumb/C375x375.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20221208143712_c032773e042e4b15aa5d9b8dde9b907c.jpg',
          productImageOrigin: 'https://st.kakaocdn.net/shoppingstore/product/20221208143712_c032773e042e4b15aa5d9b8dde9b907c.jpg',
          originalPrice: 12900,
          discountedPrice: 12900,
          discountRate: 0,
          groupDiscountDisplayable: true,
          groupDiscountStatus: 'ON_SALE',
          groupDiscountedPrice: 8900,
          groupDiscountWillClosed: false,
          groupDiscountUserCount: 3358,
          groupDiscountStartAt: 1683360000000,
          groupDiscountEndAt: 1683644399000,
          alarmDisplaying: false,
          groupDiscountRemainSeconds: 198597,
          storeId: 1987,
          storeName: '우체국쇼핑몰',
          storeDomain: 'postkmall',
          storeProfileImage: 'https://st.kakaocdn.net/thumb/B350x350cw/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fstore%2F20190625190413_5030441de54d40a6b0ab62f92d846298.jpg',
          new: false,
          linkPath: '/detail/?productId=204308361',
          storeLinkPath: '/postkmall?area=mainp',
          plusFriendSubscriberExclusive: false,
          farmer: true,
          deliveryFeeType: 'FREE',
          freeDelivery: true,
          reviewCount: 699,
          productPositivePercentage: 98,
          imageRatio: 'SQUARE',
          displayedSaleStatus: 'ON_SALE',
          categoryId: '102109100',
          categoryName: '과자/쿠키',
          hasAdditionalOptionPrice: true,
          groupDiscountPeriod: { from: '20230506170000', to: '20230509235959' },
          profiles: [
            'https://st.kakaocdn.net/shoppingstore/random/profile_192.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_310.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_357.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_446.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_98.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_78.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_277.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_390.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_418.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_161.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_73.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_304.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_508.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_169.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_449.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_164.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_431.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_376.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_67.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_368.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_316.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_554.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_134.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_541.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_57.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_7.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_41.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_97.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_412.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_464.png',
          ],
          totalSaleCount: 11420,
          trackId: '',
          contentId: 1469,
          contentDisplayPeriod: { from: '20230506170000', to: '20230509235959' },
          type: 'BIG_CARD',
          landingUrl: 'https://store.kakao.com/postkmall/products/204308361?_=1683445801259&area=mainp',
          mainCopy: '전북 정읍 귀리 뻥튀기 150g 2봉. 바삭 고소한 맛',
          label: '',
          imageUrl:
            'https://st.kakaocdn.net/thumb/C750x422.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fhome%2Fgroup_discount_product%2F20230503140218_cb2298038357478799f81f25032142d6.png',
          imageUrlOrigin: 'https://st.kakaocdn.net/shoppingstore/home/group_discount_product/20230503140218_cb2298038357478799f81f25032142d6.png',
          sharingImageUrl:
            'https://st.kakaocdn.net/thumb/C750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20221208143712_c032773e042e4b15aa5d9b8dde9b907c.jpg&mode=watermark&wm_param1=image&wm_id=talkdeal',
          logoImageUrl: '',
          contentRemainDays: 2,
          remainDays: 2,
          contentOpenDt: '20230506',
          contentCloseDt: '20230509',
          likeProductCount: 2973,
          isLiked: false,
          score: 2.98862e7,
        },
        {
          productId: 246324459,
          productName: '카밀 대용량 바디로션 1+1+미니 바디로션 1개 증정',
          productImage: 'https://st.kakaocdn.net/thumb/C375x375.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230421163754_65f354cc72cd4958a4593b64a086dd11.jpg',
          productImageOrigin: 'https://st.kakaocdn.net/shoppingstore/product/20230421163754_65f354cc72cd4958a4593b64a086dd11.jpg',
          originalPrice: 34700,
          discountedPrice: 34700,
          discountRate: 0,
          groupDiscountDisplayable: true,
          groupDiscountStatus: 'ON_SALE',
          groupDiscountedPrice: 12900,
          groupDiscountWillClosed: false,
          groupDiscountUserCount: 1571,
          groupDiscountStartAt: 1683360000000,
          groupDiscountEndAt: 1683644399000,
          alarmDisplaying: false,
          groupDiscountRemainSeconds: 198597,
          storeId: 58053,
          storeName: '지엘커뮤니케이션즈',
          storeDomain: 'glcomm',
          storeProfileImage: 'https://st.kakaocdn.net/thumb/B350x350cw/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fstore%2F20210111095926_2c708d8f5fa3405aa6f3148a870b8480.jpeg',
          new: false,
          linkPath: '/detail/?productId=246324459',
          storeLinkPath: '/glcomm?area=mainp',
          plusFriendSubscriberExclusive: false,
          farmer: false,
          deliveryFeeType: 'FREE',
          freeDelivery: true,
          imageRatio: 'SQUARE',
          displayedSaleStatus: 'ON_SALE',
          categoryId: '101103100100101',
          categoryName: '바디로션',
          hasAdditionalOptionPrice: false,
          groupDiscountPeriod: { from: '20230506170000', to: '20230509235959' },
          profiles: [
            'https://st.kakaocdn.net/shoppingstore/random/profile_336.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_366.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_353.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_94.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_80.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_373.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_427.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_263.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_343.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_330.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_83.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_253.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_288.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_377.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_350.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_296.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_363.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_177.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_478.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_407.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_27.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_539.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_11.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_337.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_57.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_208.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_531.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_129.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_97.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_306.png',
          ],
          totalSaleCount: 1641,
          trackId: '',
          contentId: 1469,
          contentDisplayPeriod: { from: '20230506170000', to: '20230509235959' },
          type: 'BIG_CARD',
          landingUrl: 'https://store.kakao.com/glcomm/products/246324459?_=1683445801261&area=mainp',
          mainCopy: '카밀 바디로션 500ml 1+1+50ml 추가 증정',
          label: '',
          imageUrl:
            'https://st.kakaocdn.net/thumb/C750x422.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fhome%2Fgroup_discount_product%2F20230503140542_1dcb6a9906b14d11b0338e53510cccbc.png',
          imageUrlOrigin: 'https://st.kakaocdn.net/shoppingstore/home/group_discount_product/20230503140542_1dcb6a9906b14d11b0338e53510cccbc.png',
          sharingImageUrl:
            'https://st.kakaocdn.net/thumb/C750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230421163754_65f354cc72cd4958a4593b64a086dd11.jpg&mode=watermark&wm_param1=image&wm_id=talkdeal',
          logoImageUrl: '',
          contentRemainDays: 2,
          remainDays: 2,
          contentOpenDt: '20230506',
          contentCloseDt: '20230509',
          likeProductCount: 814,
          isLiked: false,
          score: 2.02659e7,
        },
        {
          productId: 197627921,
          productName: '[카렉스] 시야확보주의! 레인스톰 하이브리드 와이퍼 2+2 (차량2대분)',
          productImage: 'https://st.kakaocdn.net/thumb/C375x375.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230502134519_cfbf8c4266eb4d34af8910b0141a8762.png',
          productImageOrigin: 'https://st.kakaocdn.net/shoppingstore/product/20230502134519_cfbf8c4266eb4d34af8910b0141a8762.png',
          originalPrice: 23600,
          discountedPrice: 23600,
          discountRate: 0,
          groupDiscountDisplayable: true,
          groupDiscountStatus: 'ON_SALE',
          groupDiscountedPrice: 9900,
          groupDiscountWillClosed: false,
          groupDiscountUserCount: 1777,
          groupDiscountStartAt: 1683360000000,
          groupDiscountEndAt: 1683644399000,
          alarmDisplaying: false,
          groupDiscountRemainSeconds: 198597,
          storeId: 15139,
          storeName: '카렉스몰',
          storeDomain: 'carex',
          storeProfileImage: 'https://st.kakaocdn.net/thumb/B350x350cw/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fstore%2F20230417160745_796ff505b7e74d6fb3dc806d508b3da6.jpg',
          new: false,
          linkPath: '/detail/?productId=197627921',
          storeLinkPath: '/carex?area=mainp',
          plusFriendSubscriberExclusive: false,
          farmer: false,
          deliveryFeeType: 'FREE',
          freeDelivery: true,
          reviewCount: 233,
          productPositivePercentage: 99,
          imageRatio: 'SQUARE',
          displayedSaleStatus: 'ON_SALE',
          categoryId: '103101116110',
          categoryName: '와이퍼',
          hasAdditionalOptionPrice: false,
          groupDiscountPeriod: { from: '20230506170000', to: '20230509235959' },
          profiles: [
            'https://st.kakaocdn.net/shoppingstore/random/profile_552.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_446.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_340.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_277.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_76.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_290.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_432.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_475.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_157.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_497.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_293.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_427.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_529.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_211.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_250.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_401.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_194.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_508.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_288.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_325.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_428.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_448.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_214.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_502.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_295.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_257.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_62.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_129.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_315.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_473.png',
          ],
          totalSaleCount: 5249,
          trackId: '',
          contentId: 1469,
          contentDisplayPeriod: { from: '20230506170000', to: '20230509235959' },
          type: 'BIG_CARD',
          landingUrl: 'https://store.kakao.com/carex/products/197627921?_=1683445801257&area=mainp',
          mainCopy: '카렉스 하이브리드 와이퍼 2+2. 뛰어난 고성능 와이퍼',
          label: '',
          imageUrl:
            'https://st.kakaocdn.net/thumb/C750x422.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fhome%2Fgroup_discount_product%2F20230503140044_18e765e4e03a497ab939d6ec49122a6b.png',
          imageUrlOrigin: 'https://st.kakaocdn.net/shoppingstore/home/group_discount_product/20230503140044_18e765e4e03a497ab939d6ec49122a6b.png',
          sharingImageUrl:
            'https://st.kakaocdn.net/thumb/C750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230502134519_cfbf8c4266eb4d34af8910b0141a8762.png&mode=watermark&wm_param1=image&wm_id=talkdeal',
          logoImageUrl: '',
          contentRemainDays: 2,
          remainDays: 2,
          contentOpenDt: '20230506',
          contentCloseDt: '20230509',
          likeProductCount: 1084,
          isLiked: false,
          score: 1.75923e7,
        },
        {
          productId: 139319258,
          productName: '온더바디 슈퍼보타닉 비누 12개(쟈스민,오이라임) 외',
          productImage: 'https://st.kakaocdn.net/thumb/C375x375.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230504111125_f80ab8bb9b724e67b20d4c16b5dc3789.jpg',
          productImageOrigin: 'https://st.kakaocdn.net/shoppingstore/product/20230504111125_f80ab8bb9b724e67b20d4c16b5dc3789.jpg',
          originalPrice: 19800,
          discountedPrice: 19800,
          discountRate: 0,
          groupDiscountDisplayable: true,
          groupDiscountStatus: 'ON_SALE',
          groupDiscountedPrice: 9900,
          groupDiscountWillClosed: false,
          groupDiscountUserCount: 1300,
          groupDiscountStartAt: 1683360000000,
          groupDiscountEndAt: 1683644399000,
          alarmDisplaying: false,
          groupDiscountRemainSeconds: 198597,
          storeId: 2530,
          storeName: 'LG생활건강',
          storeDomain: 'lgcare',
          storeProfileImage: 'https://st.kakaocdn.net/thumb/B350x350cw/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fstore%2F20180906172400_1455a346d67045d2a8e82e1b71145b1b.jpeg',
          new: false,
          linkPath: '/detail/?productId=139319258',
          storeLinkPath: '/lgcare?area=mainp',
          plusFriendSubscriberExclusive: false,
          farmer: false,
          deliveryFeeType: 'FREE',
          freeDelivery: true,
          reviewCount: 606,
          productPositivePercentage: 99,
          imageRatio: 'SQUARE',
          displayedSaleStatus: 'ON_SALE',
          categoryId: '101107107104',
          categoryName: '클렌징 비누',
          hasAdditionalOptionPrice: false,
          groupDiscountPeriod: { from: '20230506170000', to: '20230509235959' },
          profiles: [
            'https://st.kakaocdn.net/shoppingstore/random/profile_357.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_218.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_13.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_255.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_238.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_212.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_95.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_187.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_402.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_149.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_300.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_467.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_82.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_166.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_219.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_25.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_105.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_304.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_503.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_58.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_100.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_482.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_236.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_368.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_398.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_389.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_243.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_32.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_332.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_88.png',
          ],
          totalSaleCount: 9825,
          trackId: '568260606456383071',
          contentId: 1469,
          contentDisplayPeriod: { from: '20230506170000', to: '20230509235959' },
          type: 'BIG_CARD',
          landingUrl: 'https://store.kakao.com/lgcare/products/139319258?_=1683445801261&area=mainp',
          mainCopy: '온더바디 슈퍼보타닉 비누 12개, 자스민/오이라임',
          label: '',
          imageUrl:
            'https://st.kakaocdn.net/thumb/C750x422.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fhome%2Fgroup_discount_product%2F20230503140535_dc210d7a6de649288e5d7af08abea4fc.png',
          imageUrlOrigin: 'https://st.kakaocdn.net/shoppingstore/home/group_discount_product/20230503140535_dc210d7a6de649288e5d7af08abea4fc.png',
          sharingImageUrl:
            'https://st.kakaocdn.net/thumb/C750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230504111125_f80ab8bb9b724e67b20d4c16b5dc3789.jpg&mode=watermark&wm_param1=image&wm_id=talkdeal',
          logoImageUrl: '',
          contentRemainDays: 2,
          remainDays: 2,
          contentOpenDt: '20230506',
          contentCloseDt: '20230509',
          likeProductCount: 1796,
          isLiked: false,
          score: 1.287e7,
        },
        {
          productId: 68626964,
          productName: '[퍼실 300ml 2개 증정] 헨켈 섬유유연제 버넬 0.9L 6개',
          productImage: 'https://st.kakaocdn.net/thumb/C375x375.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230427144204_ac2dd3c737b940f291b0065d98e89d6a.jpg',
          productImageOrigin: 'https://st.kakaocdn.net/shoppingstore/product/20230427144204_ac2dd3c737b940f291b0065d98e89d6a.jpg',
          originalPrice: 41400,
          discountedPrice: 41400,
          discountRate: 0,
          groupDiscountDisplayable: true,
          groupDiscountStatus: 'ON_SALE',
          groupDiscountedPrice: 16900,
          groupDiscountWillClosed: false,
          groupDiscountUserCount: 693,
          groupDiscountStartAt: 1683360000000,
          groupDiscountEndAt: 1683644399000,
          alarmDisplaying: false,
          groupDiscountRemainSeconds: 198597,
          storeId: 1634,
          storeName: '헨켈온라인공식몰',
          storeDomain: 'henkel',
          storeProfileImage: 'https://st.kakaocdn.net/thumb/B350x350cw/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fstore%2F20180608105211_d2911174025541ae8dffd07245b7f3c1.jpeg',
          new: false,
          linkPath: '/detail/?productId=68626964',
          storeLinkPath: '/henkel?area=mainp',
          plusFriendSubscriberExclusive: false,
          farmer: false,
          deliveryFeeType: 'FREE',
          freeDelivery: true,
          reviewCount: 1890,
          productPositivePercentage: 98,
          imageRatio: 'SQUARE',
          displayedSaleStatus: 'ON_SALE',
          categoryId: '104103103101',
          categoryName: '섬유유연제',
          hasAdditionalOptionPrice: true,
          groupDiscountPeriod: { from: '20230506170000', to: '20230509235959' },
          profiles: [
            'https://st.kakaocdn.net/shoppingstore/random/profile_234.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_361.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_353.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_485.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_285.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_417.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_81.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_357.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_63.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_145.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_65.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_405.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_135.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_237.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_4.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_118.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_410.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_283.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_156.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_288.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_113.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_232.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_398.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_74.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_71.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_208.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_416.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_429.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_505.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_438.png',
          ],
          totalSaleCount: 25200,
          trackId: '7247716872349566931',
          contentId: 1469,
          contentDisplayPeriod: { from: '20230506170000', to: '20230509235959' },
          type: 'BIG_CARD',
          landingUrl: 'https://store.kakao.com/henkel/products/68626964?_=1683445801258&area=mainp',
          mainCopy: '헨켈 고농축 섬유유연제 버넬 0.9L 6개+퍼실 증정',
          label: '',
          imageUrl:
            'https://st.kakaocdn.net/thumb/C750x422.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fhome%2Fgroup_discount_product%2F20230503140122_ce4908bacb4d4a84a9b951af5866d3cc.png',
          imageUrlOrigin: 'https://st.kakaocdn.net/shoppingstore/home/group_discount_product/20230503140122_ce4908bacb4d4a84a9b951af5866d3cc.png',
          sharingImageUrl:
            'https://st.kakaocdn.net/thumb/C750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230427144204_ac2dd3c737b940f291b0065d98e89d6a.jpg&mode=watermark&wm_param1=image&wm_id=talkdeal',
          logoImageUrl: '',
          contentRemainDays: 2,
          remainDays: 2,
          contentOpenDt: '20230506',
          contentCloseDt: '20230509',
          likeProductCount: 2008,
          isLiked: false,
          score: 1.17117e7,
        },
        {
          productId: 56992838,
          productName: '[사은품증정 EVENT] "동안피부비결" 이탈리아산 저분자 피쉬콜라겐 1통 90포 3개월분',
          productImage: 'https://st.kakaocdn.net/thumb/C375x375.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230503153945_f1ae09f97809426b91bcc7efc3a721c7.jpg',
          productImageOrigin: 'https://st.kakaocdn.net/shoppingstore/product/20230503153945_f1ae09f97809426b91bcc7efc3a721c7.jpg',
          originalPrice: 37000,
          discountedPrice: 37000,
          discountRate: 0,
          groupDiscountDisplayable: true,
          groupDiscountStatus: 'ON_SALE',
          groupDiscountedPrice: 16600,
          groupDiscountWillClosed: false,
          groupDiscountUserCount: 658,
          groupDiscountStartAt: 1683360000000,
          groupDiscountEndAt: 1683644399000,
          alarmDisplaying: false,
          groupDiscountRemainSeconds: 198597,
          storeId: 24251,
          storeName: '메디트리 공식스토어',
          storeDomain: 'meditreestore',
          storeProfileImage: 'https://st.kakaocdn.net/thumb/B350x350cw/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fstore%2F20210818133516_a533c7d96a154236a6771613e501fa83.jpg',
          new: false,
          linkPath: '/detail/?productId=56992838',
          storeLinkPath: '/meditreestore?area=mainp',
          plusFriendSubscriberExclusive: false,
          farmer: false,
          deliveryFeeType: 'FREE',
          freeDelivery: true,
          reviewCount: 606,
          productPositivePercentage: 100,
          imageRatio: 'SQUARE',
          displayedSaleStatus: 'ON_SALE',
          categoryId: '102105105101',
          categoryName: '콜라겐/코큐텐',
          hasAdditionalOptionPrice: true,
          groupDiscountPeriod: { from: '20230506170000', to: '20230509235959' },
          profiles: [
            'https://st.kakaocdn.net/shoppingstore/random/profile_420.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_294.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_115.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_26.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_217.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_110.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_549.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_340.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_513.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_48.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_463.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_174.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_30.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_440.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_179.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_537.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_507.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_538.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_266.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_461.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_71.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_243.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_434.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_429.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_79.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_388.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_421.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_384.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_306.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_239.png',
          ],
          totalSaleCount: 3978,
          trackId: '7782782849913303346',
          contentId: 1469,
          contentDisplayPeriod: { from: '20230506170000', to: '20230509235959' },
          type: 'BIG_CARD',
          landingUrl: 'https://store.kakao.com/meditreestore/products/56992838?_=1683445801260&area=mainp',
          mainCopy: '메디트리 저분자 피쉬콜라겐 3개월분+비타C젤리 증정',
          label: '',
          imageUrl:
            'https://st.kakaocdn.net/thumb/C750x422.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fhome%2Fgroup_discount_product%2F20230503140439_632eab26bb3e4f759ddd0ccc1db34f3f.png',
          imageUrlOrigin: 'https://st.kakaocdn.net/shoppingstore/home/group_discount_product/20230503140439_632eab26bb3e4f759ddd0ccc1db34f3f.png',
          sharingImageUrl:
            'https://st.kakaocdn.net/thumb/C750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230503153945_f1ae09f97809426b91bcc7efc3a721c7.jpg&mode=watermark&wm_param1=image&wm_id=talkdeal',
          logoImageUrl: '',
          contentRemainDays: 2,
          remainDays: 2,
          contentOpenDt: '20230506',
          contentCloseDt: '20230509',
          likeProductCount: 957,
          isLiked: false,
          score: 1.09228e7,
        },
        {
          productId: 237319333,
          productName: '구~수한 청국장 150g x 4팩 무료배송 국내산 100% 전통식품인증 /AR',
          productImage: 'https://st.kakaocdn.net/thumb/C375x375.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230327115215_322815ce44ee4591b25012a2c43faddd.jpg',
          productImageOrigin: 'https://st.kakaocdn.net/shoppingstore/product/20230327115215_322815ce44ee4591b25012a2c43faddd.jpg',
          originalPrice: 15000,
          discountedPrice: 15000,
          discountRate: 0,
          groupDiscountDisplayable: true,
          groupDiscountStatus: 'ON_SALE',
          groupDiscountedPrice: 9500,
          groupDiscountWillClosed: false,
          groupDiscountUserCount: 1129,
          groupDiscountStartAt: 1683360000000,
          groupDiscountEndAt: 1683644399000,
          alarmDisplaying: false,
          groupDiscountRemainSeconds: 198597,
          storeId: 65639,
          storeName: '더싱싱몰',
          storeDomain: 'thesingsingmall',
          storeProfileImage: 'https://st.kakaocdn.net/thumb/B350x350cw/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fstore%2F20221220105751_e1fa8df8ef8d484882a0ce41ca96c55c.png',
          new: false,
          linkPath: '/detail/?productId=237319333',
          storeLinkPath: '/thesingsingmall?area=mainp',
          plusFriendSubscriberExclusive: false,
          farmer: true,
          deliveryFeeType: 'FREE',
          freeDelivery: true,
          reviewCount: 10,
          productPositivePercentage: 100,
          imageRatio: 'SQUARE',
          displayedSaleStatus: 'ON_SALE',
          categoryId: '102100103106',
          categoryName: '청국장',
          hasAdditionalOptionPrice: false,
          groupDiscountPeriod: { from: '20230506170000', to: '20230509235959' },
          profiles: [
            'https://st.kakaocdn.net/shoppingstore/random/profile_468.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_493.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_366.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_42.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_167.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_522.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_370.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_411.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_144.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_22.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_114.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_402.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_101.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_59.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_300.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_334.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_105.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_283.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_317.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_45.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_431.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_229.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_143.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_199.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_367.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_112.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_375.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_116.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_189.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_23.png',
          ],
          totalSaleCount: 1399,
          trackId: '',
          contentId: 1469,
          contentDisplayPeriod: { from: '20230506170000', to: '20230509235959' },
          type: 'BIG_CARD',
          landingUrl: 'https://store.kakao.com/thesingsingmall/products/237319333?_=1683445801259&area=mainp',
          mainCopy: '100% 국내산 청국장 150g 4팩, 전통식품 인증',
          label: '',
          imageUrl:
            'https://st.kakaocdn.net/thumb/C750x422.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fhome%2Fgroup_discount_product%2F20230503140245_a3d0af4aa80d428192c568843aa907ee.png',
          imageUrlOrigin: 'https://st.kakaocdn.net/shoppingstore/home/group_discount_product/20230503140245_a3d0af4aa80d428192c568843aa907ee.png',
          sharingImageUrl:
            'https://st.kakaocdn.net/thumb/C750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230327115215_322815ce44ee4591b25012a2c43faddd.jpg&mode=watermark&wm_param1=image&wm_id=talkdeal',
          logoImageUrl: '',
          contentRemainDays: 2,
          remainDays: 2,
          contentOpenDt: '20230506',
          contentCloseDt: '20230509',
          likeProductCount: 479,
          isLiked: false,
          score: 1.07255e7,
        },
        {
          productId: 53209039,
          productName: '[EPA+DHA 1,000mg/1일] GNM rTG 알티지오메가3 60캡슐 2박스/비타민E',
          productImage: 'https://st.kakaocdn.net/thumb/C375x375.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230202131209_904b492441844cfb8db1e7eaa323ae0c.jpg',
          productImageOrigin: 'https://st.kakaocdn.net/shoppingstore/product/20230202131209_904b492441844cfb8db1e7eaa323ae0c.jpg',
          originalPrice: 26900,
          discountedPrice: 26900,
          discountRate: 0,
          groupDiscountDisplayable: true,
          groupDiscountStatus: 'ON_SALE',
          groupDiscountedPrice: 18900,
          groupDiscountWillClosed: false,
          groupDiscountUserCount: 563,
          groupDiscountStartAt: 1683360000000,
          groupDiscountEndAt: 1683644399000,
          alarmDisplaying: false,
          groupDiscountRemainSeconds: 198597,
          storeId: 2310,
          storeName: 'GNM자연의품격',
          storeDomain: 'gnmlife',
          storeProfileImage: 'https://st.kakaocdn.net/thumb/B350x350cw/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fstore%2F20230201112144_b50c843620714ac3924102cd5bb2ef0d.jpg',
          new: false,
          linkPath: '/detail/?productId=53209039',
          storeLinkPath: '/gnmlife?area=mainp',
          plusFriendSubscriberExclusive: false,
          farmer: false,
          deliveryFeeType: 'FREE',
          freeDelivery: true,
          reviewCount: 1115,
          productPositivePercentage: 99,
          imageRatio: 'SQUARE',
          displayedSaleStatus: 'ON_SALE',
          categoryId: '102105105100',
          categoryName: '오메가3/스쿠알렌',
          hasAdditionalOptionPrice: true,
          groupDiscountPeriod: { from: '20230506170000', to: '20230509235959' },
          profiles: [
            'https://st.kakaocdn.net/shoppingstore/random/profile_218.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_13.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_454.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_268.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_136.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_530.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_515.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_52.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_29.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_507.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_250.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_121.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_270.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_363.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_9.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_147.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_465.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_44.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_316.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_266.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_346.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_119.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_252.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_337.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_125.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_523.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_129.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_248.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_341.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_477.png',
          ],
          totalSaleCount: 16382,
          trackId: '143797823758159857',
          contentId: 1469,
          contentDisplayPeriod: { from: '20230506170000', to: '20230509235959' },
          type: 'BIG_CARD',
          landingUrl: 'https://store.kakao.com/gnmlife/products/53209039?_=1683445801260&area=mainp',
          mainCopy: 'GNM 알티지 오메가3 식물성캡슐 60정 2박스',
          label: '',
          imageUrl:
            'https://st.kakaocdn.net/thumb/C750x422.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fhome%2Fgroup_discount_product%2F20230503140446_974f09c4704a40988ba9bc9f86e8a3bb.png',
          imageUrlOrigin: 'https://st.kakaocdn.net/shoppingstore/home/group_discount_product/20230503140446_974f09c4704a40988ba9bc9f86e8a3bb.png',
          sharingImageUrl:
            'https://st.kakaocdn.net/thumb/C750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230202131209_904b492441844cfb8db1e7eaa323ae0c.jpg&mode=watermark&wm_param1=image&wm_id=talkdeal',
          logoImageUrl: '',
          contentRemainDays: 2,
          remainDays: 2,
          contentOpenDt: '20230506',
          contentCloseDt: '20230509',
          likeProductCount: 1306,
          isLiked: false,
          score: 1.06407e7,
        },
        {
          productId: 247834660,
          productName: '성주 정품 못난이 꿀참외 3kg 5kg',
          productImage: 'https://st.kakaocdn.net/thumb/C375x375.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230404102418_e19e69467678468b8c042bb7c28c77cd.jpg',
          productImageOrigin: 'https://st.kakaocdn.net/shoppingstore/product/20230404102418_e19e69467678468b8c042bb7c28c77cd.jpg',
          originalPrice: 36900,
          discountedPrice: 36900,
          discountRate: 0,
          groupDiscountDisplayable: true,
          groupDiscountStatus: 'ON_SALE',
          groupDiscountedPrice: 17900,
          groupDiscountWillClosed: false,
          groupDiscountUserCount: 591,
          groupDiscountStartAt: 1683417600000,
          groupDiscountEndAt: 1683730799000,
          alarmDisplaying: false,
          groupDiscountRemainSeconds: 284997,
          storeId: 67458,
          storeName: '한경어게인',
          storeDomain: 'hankyeong',
          storeProfileImage: 'https://st.kakaocdn.net/thumb/B350x350cw/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fstore%2F20210415132701_e4c2a1966d84401893077cb9ea5737e1.jpeg',
          new: false,
          linkPath: '/detail/?productId=247834660',
          storeLinkPath: '/hankyeong?area=mainp',
          plusFriendSubscriberExclusive: false,
          farmer: false,
          deliveryFeeType: 'FREE',
          freeDelivery: true,
          productPositivePercentage: 100,
          imageRatio: 'SQUARE',
          displayedSaleStatus: 'ON_SALE',
          categoryId: '102104103105100',
          categoryName: '참외',
          hasAdditionalOptionPrice: true,
          groupDiscountPeriod: { from: '20230507090000', to: '20230510235959' },
          profiles: [
            'https://st.kakaocdn.net/shoppingstore/random/profile_420.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_162.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_115.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_217.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_55.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_409.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_197.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_344.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_551.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_445.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_219.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_497.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_259.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_326.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_479.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_399.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_60.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_474.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_533.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_406.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_338.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_394.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_376.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_491.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_309.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_367.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_150.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_19.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_142.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_393.png',
          ],
          totalSaleCount: 623,
          trackId: '',
          contentId: 1469,
          contentDisplayPeriod: { from: '20230506170000', to: '20230509235959' },
          type: 'BIG_CARD',
          landingUrl: 'https://store.kakao.com/hankyeong/products/247834660?_=1683445801262&area=mainp',
          mainCopy: '성주 못난이 꿀참외 5kg. 아삭아삭 달달한 과육',
          label: '',
          imageUrl:
            'https://st.kakaocdn.net/thumb/C750x422.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fhome%2Fgroup_discount_product%2F20230507093138_c70272f5d72f49df803eb575c14914e9.png',
          imageUrlOrigin: 'https://st.kakaocdn.net/shoppingstore/home/group_discount_product/20230507093138_c70272f5d72f49df803eb575c14914e9.png',
          sharingImageUrl:
            'https://st.kakaocdn.net/thumb/C750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230404102418_e19e69467678468b8c042bb7c28c77cd.jpg&mode=watermark&wm_param1=image&wm_id=talkdeal',
          logoImageUrl: '',
          contentRemainDays: 2,
          remainDays: 3,
          contentOpenDt: '20230506',
          contentCloseDt: '20230509',
          likeProductCount: 83,
          isLiked: false,
          score: 1.05789e7,
        },
        {
          productId: 64498390,
          productName: '[지프] 무료배송 (공용) 인기상품  18종택1',
          productImage: 'https://st.kakaocdn.net/thumb/C375x375.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230503143644_2f143599dc6145e28657214e0ff92268.png',
          productImageOrigin: 'https://st.kakaocdn.net/shoppingstore/product/20230503143644_2f143599dc6145e28657214e0ff92268.png',
          originalPrice: 35000,
          discountedPrice: 35000,
          discountRate: 0,
          groupDiscountDisplayable: true,
          groupDiscountStatus: 'ON_SALE',
          groupDiscountedPrice: 18700,
          groupDiscountWillClosed: false,
          groupDiscountUserCount: 550,
          groupDiscountStartAt: 1683360000000,
          groupDiscountEndAt: 1683644399000,
          alarmDisplaying: false,
          groupDiscountRemainSeconds: 198597,
          storeId: 35979,
          storeName: '현대백화점 판교점',
          storeDomain: 'hdpangyo',
          storeProfileImage: 'https://st.kakaocdn.net/thumb/B350x350cw/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fstore%2F20200616115712_a14275635cb04f32a8ee2d1e6dad879f.jpg',
          new: false,
          linkPath: '/detail/?productId=64498390',
          storeLinkPath: '/hdpangyo?area=mainp',
          plusFriendSubscriberExclusive: false,
          farmer: false,
          deliveryFeeType: 'FREE',
          freeDelivery: true,
          reviewCount: 1326,
          productPositivePercentage: 96,
          imageRatio: 'SQUARE',
          displayedSaleStatus: 'ON_SALE',
          categoryId: '101104101100',
          categoryName: '남성 라운드넥 티셔츠',
          hasAdditionalOptionPrice: true,
          groupDiscountPeriod: { from: '20230506170000', to: '20230509235959' },
          profiles: [
            'https://st.kakaocdn.net/shoppingstore/random/profile_403.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_17.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_115.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_192.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_379.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_69.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_489.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_340.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_141.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_63.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_158.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_145.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_534.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_360.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_59.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_492.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_127.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_122.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_330.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_431.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_270.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_206.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_262.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_550.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_275.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_222.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_7.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_244.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_434.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_447.png',
          ],
          totalSaleCount: 28246,
          trackId: '',
          contentId: 1469,
          contentDisplayPeriod: { from: '20230506170000', to: '20230509235959' },
          type: 'BIG_CARD',
          landingUrl: 'https://store.kakao.com/hdpangyo/products/64498390?_=1683445801260&area=mainp',
          mainCopy: '지프 남녀공용 인기 캐주얼 의류 18종 스타일',
          label: '앵콜톡딜',
          imageUrl:
            'https://st.kakaocdn.net/thumb/C750x422.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fhome%2Fgroup_discount_product%2F20230503140501_85abfaa530f54c28b9f209028dbbb5fc.png',
          imageUrlOrigin: 'https://st.kakaocdn.net/shoppingstore/home/group_discount_product/20230503140501_85abfaa530f54c28b9f209028dbbb5fc.png',
          sharingImageUrl:
            'https://st.kakaocdn.net/thumb/C750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230503143644_2f143599dc6145e28657214e0ff92268.png&mode=watermark&wm_param1=image&wm_id=talkdeal',
          logoImageUrl: '',
          contentRemainDays: 2,
          remainDays: 2,
          contentOpenDt: '20230506',
          contentCloseDt: '20230509',
          likeProductCount: 4565,
          isLiked: false,
          score: 1.0285e7,
        },
        {
          productId: 24832184,
          productName: '[여름철 필수템]쉬크 인튜이션 기획팩 (제모기+날4입) + 프리미엄 눈썹칼 4개 외',
          productImage: 'https://st.kakaocdn.net/thumb/C375x375.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230426163721_d244541209b946f79176190af94b5f79.jpg',
          productImageOrigin: 'https://st.kakaocdn.net/shoppingstore/product/20230426163721_d244541209b946f79176190af94b5f79.jpg',
          originalPrice: 29900,
          discountedPrice: 29900,
          discountRate: 0,
          groupDiscountDisplayable: true,
          groupDiscountStatus: 'ON_SALE',
          groupDiscountedPrice: 16900,
          groupDiscountWillClosed: false,
          groupDiscountUserCount: 608,
          groupDiscountStartAt: 1683360000000,
          groupDiscountEndAt: 1683644399000,
          alarmDisplaying: false,
          groupDiscountRemainSeconds: 198597,
          storeId: 2530,
          storeName: 'LG생활건강',
          storeDomain: 'lgcare',
          storeProfileImage: 'https://st.kakaocdn.net/thumb/B350x350cw/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fstore%2F20180906172400_1455a346d67045d2a8e82e1b71145b1b.jpeg',
          new: false,
          linkPath: '/detail/?productId=24832184',
          storeLinkPath: '/lgcare?area=mainp',
          plusFriendSubscriberExclusive: false,
          farmer: false,
          deliveryFeeType: 'FREE',
          freeDelivery: true,
          imageRatio: 'SQUARE',
          displayedSaleStatus: 'ON_SALE',
          categoryId: '101103100104',
          categoryName: '제모제',
          hasAdditionalOptionPrice: true,
          groupDiscountPeriod: { from: '20230506170000', to: '20230509235959' },
          profiles: [
            'https://st.kakaocdn.net/shoppingstore/random/profile_468.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_247.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_217.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_94.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_218.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_476.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_158.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_277.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_20.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_475.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_360.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_528.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_59.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_348.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_440.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_191.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_183.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_224.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_368.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_461.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_303.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_74.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_481.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_456.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_540.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_451.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_150.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_243.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_464.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_36.png',
          ],
          totalSaleCount: 676,
          trackId: '568260606456383071',
          contentId: 1469,
          contentDisplayPeriod: { from: '20230506170000', to: '20230509235959' },
          type: 'BIG_CARD',
          landingUrl: 'https://store.kakao.com/lgcare/products/24832184?_=1683445801261&area=mainp',
          mainCopy: '쉬크 인튜이션 제모기+날 4입+눈썹칼 4개 증정',
          label: '',
          imageUrl:
            'https://st.kakaocdn.net/thumb/C750x422.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fhome%2Fgroup_discount_product%2F20230503140549_94e95d2553be49f88f28fa08d9579ae0.png',
          imageUrlOrigin: 'https://st.kakaocdn.net/shoppingstore/home/group_discount_product/20230503140549_94e95d2553be49f88f28fa08d9579ae0.png',
          sharingImageUrl:
            'https://st.kakaocdn.net/thumb/C750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230426163721_d244541209b946f79176190af94b5f79.jpg&mode=watermark&wm_param1=image&wm_id=talkdeal',
          logoImageUrl: '',
          contentRemainDays: 2,
          remainDays: 2,
          contentOpenDt: '20230506',
          contentCloseDt: '20230509',
          likeProductCount: 664,
          isLiked: false,
          score: 1.02752e7,
        },
        {
          productId: 164308681,
          productName: '오리온 인기스낵 4+3+3 포카칩,스윙칩,눈을감자,무뚝뚝',
          productImage: 'https://st.kakaocdn.net/thumb/C375x375.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230502144610_adb744ff5cb449af9422c905dca1931a.jpg',
          productImageOrigin: 'https://st.kakaocdn.net/shoppingstore/product/20230502144610_adb744ff5cb449af9422c905dca1931a.jpg',
          originalPrice: 15000,
          discountedPrice: 15000,
          discountRate: 0,
          groupDiscountDisplayable: true,
          groupDiscountStatus: 'ON_SALE',
          groupDiscountedPrice: 10000,
          groupDiscountWillClosed: false,
          groupDiscountUserCount: 952,
          groupDiscountStartAt: 1683360000000,
          groupDiscountEndAt: 1683644399000,
          alarmDisplaying: false,
          groupDiscountRemainSeconds: 198597,
          storeId: 15894,
          storeName: '오리온공식판매점',
          storeDomain: 'orionstore',
          storeProfileImage: 'https://st.kakaocdn.net/thumb/B350x350cw/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fstore%2F20230302165639_3039f3be72884378b2bbe2c413e295ae.jpg',
          new: false,
          linkPath: '/detail/?productId=164308681',
          storeLinkPath: '/orionstore?area=mainp',
          plusFriendSubscriberExclusive: false,
          farmer: false,
          deliveryFeeType: 'FREE',
          freeDelivery: true,
          reviewCount: 1411,
          productPositivePercentage: 99,
          imageRatio: 'SQUARE',
          displayedSaleStatus: 'ON_SALE',
          categoryId: '102109100',
          categoryName: '과자/쿠키',
          hasAdditionalOptionPrice: true,
          groupDiscountPeriod: { from: '20230506170000', to: '20230509235959' },
          profiles: [
            'https://st.kakaocdn.net/shoppingstore/random/profile_468.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_17.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_500.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_63.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_188.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_450.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_246.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_203.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_289.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_29.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_322.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_284.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_378.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_471.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_148.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_462.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_210.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_508.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_253.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_181.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_9.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_67.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_303.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_367.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_523.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_416.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_213.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_2.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_464.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_88.png',
          ],
          totalSaleCount: 25835,
          trackId: '',
          contentId: 1469,
          contentDisplayPeriod: { from: '20230506170000', to: '20230509235959' },
          type: 'BIG_CARD',
          landingUrl: 'https://store.kakao.com/orionstore/products/164308681?_=1683445801259&area=mainp',
          mainCopy: '오리온 인기스낵 10개 골라담기! 오땅/스윙칩 외',
          label: '앵콜톡딜',
          imageUrl:
            'https://st.kakaocdn.net/thumb/C750x422.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fhome%2Fgroup_discount_product%2F20230503140314_a1bbb993e1514e9d807c7288b0ba7100.png',
          imageUrlOrigin: 'https://st.kakaocdn.net/shoppingstore/home/group_discount_product/20230503140314_a1bbb993e1514e9d807c7288b0ba7100.png',
          sharingImageUrl:
            'https://st.kakaocdn.net/thumb/C750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230502144610_adb744ff5cb449af9422c905dca1931a.jpg&mode=watermark&wm_param1=image&wm_id=talkdeal',
          logoImageUrl: '',
          contentRemainDays: 2,
          remainDays: 2,
          contentOpenDt: '20230506',
          contentCloseDt: '20230509',
          likeProductCount: 4092,
          isLiked: false,
          score: 9520000.0,
        },
        {
          productId: 227497376,
          productName: '[코코블랑] 23 여름신상 반팔니트 9900원 외 100종 최대할인',
          productImage: 'https://st.kakaocdn.net/thumb/C375x375.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230503154913_4d9c5a4dda024f7a92c71168866f788b.jpg',
          productImageOrigin: 'https://st.kakaocdn.net/shoppingstore/product/20230503154913_4d9c5a4dda024f7a92c71168866f788b.jpg',
          originalPrice: 49900,
          discountedPrice: 49900,
          discountRate: 0,
          groupDiscountDisplayable: true,
          groupDiscountStatus: 'ON_SALE',
          groupDiscountedPrice: 9900,
          groupDiscountWillClosed: false,
          groupDiscountUserCount: 958,
          groupDiscountStartAt: 1683360000000,
          groupDiscountEndAt: 1683644399000,
          alarmDisplaying: false,
          groupDiscountRemainSeconds: 198597,
          storeId: 62459,
          storeName: '코코블랑',
          storeDomain: 'cocoblanc',
          storeProfileImage: 'https://st.kakaocdn.net/thumb/B350x350cw/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fstore%2F20221219133214_ba607a89cb2a4aedadb13d74678325a3.jpg',
          new: false,
          linkPath: '/detail/?productId=227497376',
          storeLinkPath: '/cocoblanc?area=mainp',
          plusFriendSubscriberExclusive: false,
          farmer: false,
          deliveryFeeType: 'FREE',
          freeDelivery: true,
          imageRatio: 'SQUARE',
          displayedSaleStatus: 'ON_SALE',
          categoryId: '101102102104',
          categoryName: '여성 브이넥 니트',
          hasAdditionalOptionPrice: true,
          groupDiscountPeriod: { from: '20230506170000', to: '20230509235959' },
          profiles: [
            'https://st.kakaocdn.net/shoppingstore/random/profile_102.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_328.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_192.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_442.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_55.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_357.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_370.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_327.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_500.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_305.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_515.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_90.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_86.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_334.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_47.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_183.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_342.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_487.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_181.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_350.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_28.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_236.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_31.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_266.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_190.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_248.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_371.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_133.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_198.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_36.png',
          ],
          totalSaleCount: 2443,
          trackId: '',
          contentId: 1469,
          contentDisplayPeriod: { from: '20230506170000', to: '20230509235959' },
          type: 'BIG_CARD',
          landingUrl: 'https://store.kakao.com/cocoblanc/products/227497376?_=1683445801261&area=mainp',
          mainCopy: '코코블랑 브이넥 반팔 니트 외 데일리룩 99종 스타일',
          label: '',
          imageUrl:
            'https://st.kakaocdn.net/thumb/C750x422.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fhome%2Fgroup_discount_product%2F20230503140516_0260e927c462473bbb40491d5b5c97b0.png',
          imageUrlOrigin: 'https://st.kakaocdn.net/shoppingstore/home/group_discount_product/20230503140516_0260e927c462473bbb40491d5b5c97b0.png',
          sharingImageUrl:
            'https://st.kakaocdn.net/thumb/C750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230503154913_4d9c5a4dda024f7a92c71168866f788b.jpg&mode=watermark&wm_param1=image&wm_id=talkdeal',
          logoImageUrl: '',
          contentRemainDays: 2,
          remainDays: 2,
          contentOpenDt: '20230506',
          contentCloseDt: '20230509',
          likeProductCount: 792,
          isLiked: false,
          score: 9484200.0,
        },
      ],
      [
        {
          productId: 247087647,
          productName: '반스 스니커즈 20종 모음전',
          productImage: 'https://st.kakaocdn.net/thumb/C375x375.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230503113855_63af65cc961c4054855538dee4a38858.jpg',
          productImageOrigin: 'https://st.kakaocdn.net/shoppingstore/product/20230503113855_63af65cc961c4054855538dee4a38858.jpg',
          originalPrice: 79000,
          discountedPrice: 79000,
          discountRate: 0,
          groupDiscountDisplayable: true,
          groupDiscountStatus: 'ON_SALE',
          groupDiscountedPrice: 39900,
          groupDiscountWillClosed: false,
          groupDiscountUserCount: 2006,
          groupDiscountStartAt: 1683360000000,
          groupDiscountEndAt: 1683644399000,
          alarmDisplaying: false,
          groupDiscountRemainSeconds: 198597,
          storeId: 40714,
          storeName: '아이스탁몰',
          storeDomain: 'istockmall',
          storeProfileImage: 'https://st.kakaocdn.net/thumb/B350x350cw/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fstore%2F20200515131237_23adae4cca2c42a0800ed3ed5e5cc168.jpeg',
          new: false,
          linkPath: '/detail/?productId=247087647',
          storeLinkPath: '/istockmall?area=mainp',
          plusFriendSubscriberExclusive: false,
          farmer: false,
          deliveryFeeType: 'FREE',
          freeDelivery: true,
          imageRatio: 'SQUARE',
          displayedSaleStatus: 'ON_SALE',
          categoryId: '101108104101',
          categoryName: '캐주얼운동화',
          hasAdditionalOptionPrice: true,
          groupDiscountPeriod: { from: '20230506170000', to: '20230509235959' },
          profiles: [
            'https://st.kakaocdn.net/shoppingstore/random/profile_403.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_535.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_154.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_136.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_301.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_108.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_335.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_29.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_466.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_529.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_395.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_210.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_342.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_533.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_538.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_350.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_431.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_406.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_178.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_113.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_457.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_351.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_236.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_87.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_381.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_486.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_260.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_282.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_404.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_92.png',
          ],
          totalSaleCount: 2437,
          trackId: '1463847132807741383',
          contentId: 1469,
          contentDisplayPeriod: { from: '20230506170000', to: '20230509235959' },
          type: 'BIG_CARD',
          landingUrl: 'https://store.kakao.com/istockmall/products/247087647?_=1683445801258&area=mainp',
          mainCopy: '반스 데일리 스니커즈/슬립온 20종 스타일',
          label: '',
          imageUrl:
            'https://st.kakaocdn.net/thumb/C750x422.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fhome%2Fgroup_discount_product%2F20230503162549_c6ad232a4b4444aeaa63d3315db214e3.jpeg',
          imageUrlOrigin: 'https://st.kakaocdn.net/shoppingstore/home/group_discount_product/20230503162549_c6ad232a4b4444aeaa63d3315db214e3.jpeg',
          sharingImageUrl:
            'https://st.kakaocdn.net/thumb/C750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230503113855_63af65cc961c4054855538dee4a38858.jpg&mode=watermark&wm_param1=image&wm_id=talkdeal',
          logoImageUrl: '',
          contentRemainDays: 2,
          remainDays: 2,
          contentOpenDt: '20230506',
          contentCloseDt: '20230509',
          likeProductCount: 1870,
          isLiked: false,
          score: 8.00394e7,
        },
        {
          productId: 247868049,
          productName: '목우촌 한우 인삼갈비탕 700gX4개+한우 사골곰탕 4개 증정',
          productImage: 'https://st.kakaocdn.net/thumb/C375x375.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230427145426_080e14bb1d234597a2f468afde015a50.jpg',
          productImageOrigin: 'https://st.kakaocdn.net/shoppingstore/product/20230427145426_080e14bb1d234597a2f468afde015a50.jpg',
          originalPrice: 59900,
          discountedPrice: 59900,
          discountRate: 0,
          groupDiscountDisplayable: true,
          groupDiscountStatus: 'ON_SALE',
          groupDiscountedPrice: 28900,
          groupDiscountWillClosed: false,
          groupDiscountUserCount: 2357,
          groupDiscountStartAt: 1683360000000,
          groupDiscountEndAt: 1683644399000,
          alarmDisplaying: false,
          groupDiscountRemainSeconds: 198597,
          storeId: 69747,
          storeName: '목우촌',
          storeDomain: 'moguchon',
          storeProfileImage: 'https://st.kakaocdn.net/thumb/B350x350cw/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fstore%2F20220620195113_0e4200b7122945598f61132ce4e0ea0e.jpg',
          new: false,
          linkPath: '/detail/?productId=247868049',
          storeLinkPath: '/moguchon?area=mainp',
          plusFriendSubscriberExclusive: false,
          farmer: false,
          deliveryFeeType: 'FREE',
          freeDelivery: true,
          imageRatio: 'SQUARE',
          displayedSaleStatus: 'ON_SALE',
          categoryId: '102100100112',
          categoryName: '국/탕/찌개',
          hasAdditionalOptionPrice: false,
          groupDiscountPeriod: { from: '20230506170000', to: '20230509235959' },
          profiles: [
            'https://st.kakaocdn.net/shoppingstore/random/profile_493.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_420.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_366.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_498.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_18.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_171.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_246.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_267.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_109.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_73.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_210.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_546.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_372.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_228.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_202.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_350.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_100.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_435.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_236.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_229.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_448.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_346.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_295.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_14.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_389.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_205.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_490.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_548.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_23.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_198.png',
          ],
          totalSaleCount: 2839,
          trackId: '1726756183548867528',
          contentId: 1469,
          contentDisplayPeriod: { from: '20230506170000', to: '20230509235959' },
          type: 'BIG_CARD',
          landingUrl: 'https://store.kakao.com/moguchon/products/247868049?_=1683445801259&area=mainp',
          mainCopy: '목우촌 한우 인삼 갈비탕 700g 4개+사골곰탕 4개',
          label: '',
          imageUrl:
            'https://st.kakaocdn.net/thumb/C750x422.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fhome%2Fgroup_discount_product%2F20230503140323_8c2159beb21249ad81360a6aaae1ac54.png',
          imageUrlOrigin: 'https://st.kakaocdn.net/shoppingstore/home/group_discount_product/20230503140323_8c2159beb21249ad81360a6aaae1ac54.png',
          sharingImageUrl:
            'https://st.kakaocdn.net/thumb/C750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230427145426_080e14bb1d234597a2f468afde015a50.jpg&mode=watermark&wm_param1=image&wm_id=talkdeal',
          logoImageUrl: '',
          contentRemainDays: 2,
          remainDays: 2,
          contentOpenDt: '20230506',
          contentCloseDt: '20230509',
          likeProductCount: 581,
          isLiked: false,
          score: 6.81173e7,
        },
        {
          productId: 90836953,
          productName: '[오늘 구매시 백화점 상품권 증정!! / 눈물의 재고 정리 특가] 클리엔 R9 로봇청소기',
          productImage: 'https://st.kakaocdn.net/thumb/C375x375.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230503120952_8040d7bf834c4860b2bb74a01f990825.jpg',
          productImageOrigin: 'https://st.kakaocdn.net/shoppingstore/product/20230503120952_8040d7bf834c4860b2bb74a01f990825.jpg',
          originalPrice: 799000,
          discountedPrice: 799000,
          discountRate: 0,
          groupDiscountDisplayable: true,
          groupDiscountStatus: 'ON_SALE',
          groupDiscountedPrice: 369000,
          groupDiscountWillClosed: false,
          groupDiscountUserCount: 134,
          groupDiscountStartAt: 1683360000000,
          groupDiscountEndAt: 1683644399000,
          alarmDisplaying: false,
          groupDiscountRemainSeconds: 198597,
          storeId: 66388,
          storeName: '클리엔',
          storeDomain: 'clien',
          storeProfileImage: 'https://st.kakaocdn.net/thumb/B350x350cw/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fstore%2F20210405180300_b5ab0f7204284d0293497ce4f33c7882.jpeg',
          new: false,
          linkPath: '/detail/?productId=90836953',
          storeLinkPath: '/clien?area=mainp',
          plusFriendSubscriberExclusive: false,
          farmer: false,
          deliveryFeeType: 'FREE',
          freeDelivery: true,
          reviewCount: 2579,
          productPositivePercentage: 100,
          imageRatio: 'SQUARE',
          displayedSaleStatus: 'ON_SALE',
          categoryId: '100103102101',
          categoryName: '로봇청소기',
          hasAdditionalOptionPrice: true,
          groupDiscountPeriod: { from: '20230506170000', to: '20230509235959' },
          profiles: [
            'https://st.kakaocdn.net/shoppingstore/random/profile_221.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_485.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_69.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_123.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_459.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_500.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_340.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_301.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_329.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_99.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_25.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_507.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_105.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_210.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_91.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_66.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_8.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_292.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_448.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_163.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_84.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_469.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_111.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_97.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_79.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_421.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_544.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_265.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_36.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_438.png',
          ],
          totalSaleCount: 6722,
          trackId: '4015756886542694813',
          contentId: 1469,
          contentDisplayPeriod: { from: '20230506170000', to: '20230509235959' },
          type: 'BIG_CARD',
          landingUrl: 'https://store.kakao.com/clien/products/90836953?_=1683445801257&area=mainp',
          mainCopy: '클리엔 로봇청소기 R9. 진공청소와 물걸레를 한번에',
          label: '',
          imageUrl:
            'https://st.kakaocdn.net/thumb/C750x422.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fhome%2Fgroup_discount_product%2F20230503140010_3225abb6924e43df8e69a0233db29c96.png',
          imageUrlOrigin: 'https://st.kakaocdn.net/shoppingstore/home/group_discount_product/20230503140010_3225abb6924e43df8e69a0233db29c96.png',
          sharingImageUrl:
            'https://st.kakaocdn.net/thumb/C750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230503120952_8040d7bf834c4860b2bb74a01f990825.jpg&mode=watermark&wm_param1=image&wm_id=talkdeal',
          logoImageUrl: '',
          contentRemainDays: 2,
          remainDays: 2,
          contentOpenDt: '20230506',
          contentCloseDt: '20230509',
          likeProductCount: 2597,
          isLiked: false,
          score: 4.9446e7,
        },
        {
          productId: 204308361,
          productName: '[우체국쇼핑]전북 정읍 국내산 귀리로 만든 귀리뻥튀기 왕큰봉지 2봉/4봉',
          productImage: 'https://st.kakaocdn.net/thumb/C375x375.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20221208143712_c032773e042e4b15aa5d9b8dde9b907c.jpg',
          productImageOrigin: 'https://st.kakaocdn.net/shoppingstore/product/20221208143712_c032773e042e4b15aa5d9b8dde9b907c.jpg',
          originalPrice: 12900,
          discountedPrice: 12900,
          discountRate: 0,
          groupDiscountDisplayable: true,
          groupDiscountStatus: 'ON_SALE',
          groupDiscountedPrice: 8900,
          groupDiscountWillClosed: false,
          groupDiscountUserCount: 3358,
          groupDiscountStartAt: 1683360000000,
          groupDiscountEndAt: 1683644399000,
          alarmDisplaying: false,
          groupDiscountRemainSeconds: 198597,
          storeId: 1987,
          storeName: '우체국쇼핑몰',
          storeDomain: 'postkmall',
          storeProfileImage: 'https://st.kakaocdn.net/thumb/B350x350cw/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fstore%2F20190625190413_5030441de54d40a6b0ab62f92d846298.jpg',
          new: false,
          linkPath: '/detail/?productId=204308361',
          storeLinkPath: '/postkmall?area=mainp',
          plusFriendSubscriberExclusive: false,
          farmer: true,
          deliveryFeeType: 'FREE',
          freeDelivery: true,
          reviewCount: 699,
          productPositivePercentage: 98,
          imageRatio: 'SQUARE',
          displayedSaleStatus: 'ON_SALE',
          categoryId: '102109100',
          categoryName: '과자/쿠키',
          hasAdditionalOptionPrice: true,
          groupDiscountPeriod: { from: '20230506170000', to: '20230509235959' },
          profiles: [
            'https://st.kakaocdn.net/shoppingstore/random/profile_192.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_310.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_357.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_446.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_98.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_78.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_277.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_390.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_418.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_161.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_73.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_304.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_508.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_169.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_449.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_164.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_431.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_376.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_67.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_368.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_316.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_554.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_134.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_541.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_57.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_7.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_41.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_97.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_412.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_464.png',
          ],
          totalSaleCount: 11420,
          trackId: '',
          contentId: 1469,
          contentDisplayPeriod: { from: '20230506170000', to: '20230509235959' },
          type: 'BIG_CARD',
          landingUrl: 'https://store.kakao.com/postkmall/products/204308361?_=1683445801259&area=mainp',
          mainCopy: '전북 정읍 귀리 뻥튀기 150g 2봉. 바삭 고소한 맛',
          label: '',
          imageUrl:
            'https://st.kakaocdn.net/thumb/C750x422.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fhome%2Fgroup_discount_product%2F20230503140218_cb2298038357478799f81f25032142d6.png',
          imageUrlOrigin: 'https://st.kakaocdn.net/shoppingstore/home/group_discount_product/20230503140218_cb2298038357478799f81f25032142d6.png',
          sharingImageUrl:
            'https://st.kakaocdn.net/thumb/C750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20221208143712_c032773e042e4b15aa5d9b8dde9b907c.jpg&mode=watermark&wm_param1=image&wm_id=talkdeal',
          logoImageUrl: '',
          contentRemainDays: 2,
          remainDays: 2,
          contentOpenDt: '20230506',
          contentCloseDt: '20230509',
          likeProductCount: 2973,
          isLiked: false,
          score: 2.98862e7,
        },
        {
          productId: 246324459,
          productName: '카밀 대용량 바디로션 1+1+미니 바디로션 1개 증정',
          productImage: 'https://st.kakaocdn.net/thumb/C375x375.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230421163754_65f354cc72cd4958a4593b64a086dd11.jpg',
          productImageOrigin: 'https://st.kakaocdn.net/shoppingstore/product/20230421163754_65f354cc72cd4958a4593b64a086dd11.jpg',
          originalPrice: 34700,
          discountedPrice: 34700,
          discountRate: 0,
          groupDiscountDisplayable: true,
          groupDiscountStatus: 'ON_SALE',
          groupDiscountedPrice: 12900,
          groupDiscountWillClosed: false,
          groupDiscountUserCount: 1571,
          groupDiscountStartAt: 1683360000000,
          groupDiscountEndAt: 1683644399000,
          alarmDisplaying: false,
          groupDiscountRemainSeconds: 198597,
          storeId: 58053,
          storeName: '지엘커뮤니케이션즈',
          storeDomain: 'glcomm',
          storeProfileImage: 'https://st.kakaocdn.net/thumb/B350x350cw/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fstore%2F20210111095926_2c708d8f5fa3405aa6f3148a870b8480.jpeg',
          new: false,
          linkPath: '/detail/?productId=246324459',
          storeLinkPath: '/glcomm?area=mainp',
          plusFriendSubscriberExclusive: false,
          farmer: false,
          deliveryFeeType: 'FREE',
          freeDelivery: true,
          imageRatio: 'SQUARE',
          displayedSaleStatus: 'ON_SALE',
          categoryId: '101103100100101',
          categoryName: '바디로션',
          hasAdditionalOptionPrice: false,
          groupDiscountPeriod: { from: '20230506170000', to: '20230509235959' },
          profiles: [
            'https://st.kakaocdn.net/shoppingstore/random/profile_336.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_366.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_353.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_94.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_80.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_373.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_427.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_263.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_343.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_330.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_83.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_253.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_288.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_377.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_350.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_296.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_363.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_177.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_478.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_407.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_27.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_539.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_11.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_337.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_57.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_208.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_531.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_129.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_97.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_306.png',
          ],
          totalSaleCount: 1641,
          trackId: '',
          contentId: 1469,
          contentDisplayPeriod: { from: '20230506170000', to: '20230509235959' },
          type: 'BIG_CARD',
          landingUrl: 'https://store.kakao.com/glcomm/products/246324459?_=1683445801261&area=mainp',
          mainCopy: '카밀 바디로션 500ml 1+1+50ml 추가 증정',
          label: '',
          imageUrl:
            'https://st.kakaocdn.net/thumb/C750x422.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fhome%2Fgroup_discount_product%2F20230503140542_1dcb6a9906b14d11b0338e53510cccbc.png',
          imageUrlOrigin: 'https://st.kakaocdn.net/shoppingstore/home/group_discount_product/20230503140542_1dcb6a9906b14d11b0338e53510cccbc.png',
          sharingImageUrl:
            'https://st.kakaocdn.net/thumb/C750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230421163754_65f354cc72cd4958a4593b64a086dd11.jpg&mode=watermark&wm_param1=image&wm_id=talkdeal',
          logoImageUrl: '',
          contentRemainDays: 2,
          remainDays: 2,
          contentOpenDt: '20230506',
          contentCloseDt: '20230509',
          likeProductCount: 814,
          isLiked: false,
          score: 2.02659e7,
        },
        {
          productId: 197627921,
          productName: '[카렉스] 시야확보주의! 레인스톰 하이브리드 와이퍼 2+2 (차량2대분)',
          productImage: 'https://st.kakaocdn.net/thumb/C375x375.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230502134519_cfbf8c4266eb4d34af8910b0141a8762.png',
          productImageOrigin: 'https://st.kakaocdn.net/shoppingstore/product/20230502134519_cfbf8c4266eb4d34af8910b0141a8762.png',
          originalPrice: 23600,
          discountedPrice: 23600,
          discountRate: 0,
          groupDiscountDisplayable: true,
          groupDiscountStatus: 'ON_SALE',
          groupDiscountedPrice: 9900,
          groupDiscountWillClosed: false,
          groupDiscountUserCount: 1777,
          groupDiscountStartAt: 1683360000000,
          groupDiscountEndAt: 1683644399000,
          alarmDisplaying: false,
          groupDiscountRemainSeconds: 198597,
          storeId: 15139,
          storeName: '카렉스몰',
          storeDomain: 'carex',
          storeProfileImage: 'https://st.kakaocdn.net/thumb/B350x350cw/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fstore%2F20230417160745_796ff505b7e74d6fb3dc806d508b3da6.jpg',
          new: false,
          linkPath: '/detail/?productId=197627921',
          storeLinkPath: '/carex?area=mainp',
          plusFriendSubscriberExclusive: false,
          farmer: false,
          deliveryFeeType: 'FREE',
          freeDelivery: true,
          reviewCount: 233,
          productPositivePercentage: 99,
          imageRatio: 'SQUARE',
          displayedSaleStatus: 'ON_SALE',
          categoryId: '103101116110',
          categoryName: '와이퍼',
          hasAdditionalOptionPrice: false,
          groupDiscountPeriod: { from: '20230506170000', to: '20230509235959' },
          profiles: [
            'https://st.kakaocdn.net/shoppingstore/random/profile_552.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_446.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_340.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_277.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_76.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_290.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_432.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_475.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_157.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_497.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_293.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_427.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_529.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_211.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_250.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_401.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_194.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_508.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_288.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_325.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_428.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_448.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_214.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_502.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_295.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_257.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_62.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_129.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_315.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_473.png',
          ],
          totalSaleCount: 5249,
          trackId: '',
          contentId: 1469,
          contentDisplayPeriod: { from: '20230506170000', to: '20230509235959' },
          type: 'BIG_CARD',
          landingUrl: 'https://store.kakao.com/carex/products/197627921?_=1683445801257&area=mainp',
          mainCopy: '카렉스 하이브리드 와이퍼 2+2. 뛰어난 고성능 와이퍼',
          label: '',
          imageUrl:
            'https://st.kakaocdn.net/thumb/C750x422.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fhome%2Fgroup_discount_product%2F20230503140044_18e765e4e03a497ab939d6ec49122a6b.png',
          imageUrlOrigin: 'https://st.kakaocdn.net/shoppingstore/home/group_discount_product/20230503140044_18e765e4e03a497ab939d6ec49122a6b.png',
          sharingImageUrl:
            'https://st.kakaocdn.net/thumb/C750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230502134519_cfbf8c4266eb4d34af8910b0141a8762.png&mode=watermark&wm_param1=image&wm_id=talkdeal',
          logoImageUrl: '',
          contentRemainDays: 2,
          remainDays: 2,
          contentOpenDt: '20230506',
          contentCloseDt: '20230509',
          likeProductCount: 1084,
          isLiked: false,
          score: 1.75923e7,
        },
        {
          productId: 139319258,
          productName: '온더바디 슈퍼보타닉 비누 12개(쟈스민,오이라임) 외',
          productImage: 'https://st.kakaocdn.net/thumb/C375x375.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230504111125_f80ab8bb9b724e67b20d4c16b5dc3789.jpg',
          productImageOrigin: 'https://st.kakaocdn.net/shoppingstore/product/20230504111125_f80ab8bb9b724e67b20d4c16b5dc3789.jpg',
          originalPrice: 19800,
          discountedPrice: 19800,
          discountRate: 0,
          groupDiscountDisplayable: true,
          groupDiscountStatus: 'ON_SALE',
          groupDiscountedPrice: 9900,
          groupDiscountWillClosed: false,
          groupDiscountUserCount: 1300,
          groupDiscountStartAt: 1683360000000,
          groupDiscountEndAt: 1683644399000,
          alarmDisplaying: false,
          groupDiscountRemainSeconds: 198597,
          storeId: 2530,
          storeName: 'LG생활건강',
          storeDomain: 'lgcare',
          storeProfileImage: 'https://st.kakaocdn.net/thumb/B350x350cw/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fstore%2F20180906172400_1455a346d67045d2a8e82e1b71145b1b.jpeg',
          new: false,
          linkPath: '/detail/?productId=139319258',
          storeLinkPath: '/lgcare?area=mainp',
          plusFriendSubscriberExclusive: false,
          farmer: false,
          deliveryFeeType: 'FREE',
          freeDelivery: true,
          reviewCount: 606,
          productPositivePercentage: 99,
          imageRatio: 'SQUARE',
          displayedSaleStatus: 'ON_SALE',
          categoryId: '101107107104',
          categoryName: '클렌징 비누',
          hasAdditionalOptionPrice: false,
          groupDiscountPeriod: { from: '20230506170000', to: '20230509235959' },
          profiles: [
            'https://st.kakaocdn.net/shoppingstore/random/profile_357.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_218.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_13.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_255.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_238.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_212.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_95.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_187.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_402.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_149.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_300.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_467.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_82.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_166.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_219.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_25.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_105.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_304.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_503.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_58.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_100.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_482.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_236.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_368.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_398.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_389.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_243.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_32.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_332.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_88.png',
          ],
          totalSaleCount: 9825,
          trackId: '568260606456383071',
          contentId: 1469,
          contentDisplayPeriod: { from: '20230506170000', to: '20230509235959' },
          type: 'BIG_CARD',
          landingUrl: 'https://store.kakao.com/lgcare/products/139319258?_=1683445801261&area=mainp',
          mainCopy: '온더바디 슈퍼보타닉 비누 12개, 자스민/오이라임',
          label: '',
          imageUrl:
            'https://st.kakaocdn.net/thumb/C750x422.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fhome%2Fgroup_discount_product%2F20230503140535_dc210d7a6de649288e5d7af08abea4fc.png',
          imageUrlOrigin: 'https://st.kakaocdn.net/shoppingstore/home/group_discount_product/20230503140535_dc210d7a6de649288e5d7af08abea4fc.png',
          sharingImageUrl:
            'https://st.kakaocdn.net/thumb/C750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230504111125_f80ab8bb9b724e67b20d4c16b5dc3789.jpg&mode=watermark&wm_param1=image&wm_id=talkdeal',
          logoImageUrl: '',
          contentRemainDays: 2,
          remainDays: 2,
          contentOpenDt: '20230506',
          contentCloseDt: '20230509',
          likeProductCount: 1796,
          isLiked: false,
          score: 1.287e7,
        },
        {
          productId: 68626964,
          productName: '[퍼실 300ml 2개 증정] 헨켈 섬유유연제 버넬 0.9L 6개',
          productImage: 'https://st.kakaocdn.net/thumb/C375x375.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230427144204_ac2dd3c737b940f291b0065d98e89d6a.jpg',
          productImageOrigin: 'https://st.kakaocdn.net/shoppingstore/product/20230427144204_ac2dd3c737b940f291b0065d98e89d6a.jpg',
          originalPrice: 41400,
          discountedPrice: 41400,
          discountRate: 0,
          groupDiscountDisplayable: true,
          groupDiscountStatus: 'ON_SALE',
          groupDiscountedPrice: 16900,
          groupDiscountWillClosed: false,
          groupDiscountUserCount: 693,
          groupDiscountStartAt: 1683360000000,
          groupDiscountEndAt: 1683644399000,
          alarmDisplaying: false,
          groupDiscountRemainSeconds: 198597,
          storeId: 1634,
          storeName: '헨켈온라인공식몰',
          storeDomain: 'henkel',
          storeProfileImage: 'https://st.kakaocdn.net/thumb/B350x350cw/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fstore%2F20180608105211_d2911174025541ae8dffd07245b7f3c1.jpeg',
          new: false,
          linkPath: '/detail/?productId=68626964',
          storeLinkPath: '/henkel?area=mainp',
          plusFriendSubscriberExclusive: false,
          farmer: false,
          deliveryFeeType: 'FREE',
          freeDelivery: true,
          reviewCount: 1890,
          productPositivePercentage: 98,
          imageRatio: 'SQUARE',
          displayedSaleStatus: 'ON_SALE',
          categoryId: '104103103101',
          categoryName: '섬유유연제',
          hasAdditionalOptionPrice: true,
          groupDiscountPeriod: { from: '20230506170000', to: '20230509235959' },
          profiles: [
            'https://st.kakaocdn.net/shoppingstore/random/profile_234.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_361.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_353.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_485.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_285.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_417.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_81.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_357.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_63.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_145.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_65.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_405.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_135.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_237.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_4.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_118.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_410.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_283.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_156.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_288.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_113.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_232.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_398.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_74.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_71.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_208.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_416.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_429.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_505.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_438.png',
          ],
          totalSaleCount: 25200,
          trackId: '7247716872349566931',
          contentId: 1469,
          contentDisplayPeriod: { from: '20230506170000', to: '20230509235959' },
          type: 'BIG_CARD',
          landingUrl: 'https://store.kakao.com/henkel/products/68626964?_=1683445801258&area=mainp',
          mainCopy: '헨켈 고농축 섬유유연제 버넬 0.9L 6개+퍼실 증정',
          label: '',
          imageUrl:
            'https://st.kakaocdn.net/thumb/C750x422.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fhome%2Fgroup_discount_product%2F20230503140122_ce4908bacb4d4a84a9b951af5866d3cc.png',
          imageUrlOrigin: 'https://st.kakaocdn.net/shoppingstore/home/group_discount_product/20230503140122_ce4908bacb4d4a84a9b951af5866d3cc.png',
          sharingImageUrl:
            'https://st.kakaocdn.net/thumb/C750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230427144204_ac2dd3c737b940f291b0065d98e89d6a.jpg&mode=watermark&wm_param1=image&wm_id=talkdeal',
          logoImageUrl: '',
          contentRemainDays: 2,
          remainDays: 2,
          contentOpenDt: '20230506',
          contentCloseDt: '20230509',
          likeProductCount: 2008,
          isLiked: false,
          score: 1.17117e7,
        },
        {
          productId: 56992838,
          productName: '[사은품증정 EVENT] "동안피부비결" 이탈리아산 저분자 피쉬콜라겐 1통 90포 3개월분',
          productImage: 'https://st.kakaocdn.net/thumb/C375x375.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230503153945_f1ae09f97809426b91bcc7efc3a721c7.jpg',
          productImageOrigin: 'https://st.kakaocdn.net/shoppingstore/product/20230503153945_f1ae09f97809426b91bcc7efc3a721c7.jpg',
          originalPrice: 37000,
          discountedPrice: 37000,
          discountRate: 0,
          groupDiscountDisplayable: true,
          groupDiscountStatus: 'ON_SALE',
          groupDiscountedPrice: 16600,
          groupDiscountWillClosed: false,
          groupDiscountUserCount: 658,
          groupDiscountStartAt: 1683360000000,
          groupDiscountEndAt: 1683644399000,
          alarmDisplaying: false,
          groupDiscountRemainSeconds: 198597,
          storeId: 24251,
          storeName: '메디트리 공식스토어',
          storeDomain: 'meditreestore',
          storeProfileImage: 'https://st.kakaocdn.net/thumb/B350x350cw/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fstore%2F20210818133516_a533c7d96a154236a6771613e501fa83.jpg',
          new: false,
          linkPath: '/detail/?productId=56992838',
          storeLinkPath: '/meditreestore?area=mainp',
          plusFriendSubscriberExclusive: false,
          farmer: false,
          deliveryFeeType: 'FREE',
          freeDelivery: true,
          reviewCount: 606,
          productPositivePercentage: 100,
          imageRatio: 'SQUARE',
          displayedSaleStatus: 'ON_SALE',
          categoryId: '102105105101',
          categoryName: '콜라겐/코큐텐',
          hasAdditionalOptionPrice: true,
          groupDiscountPeriod: { from: '20230506170000', to: '20230509235959' },
          profiles: [
            'https://st.kakaocdn.net/shoppingstore/random/profile_420.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_294.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_115.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_26.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_217.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_110.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_549.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_340.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_513.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_48.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_463.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_174.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_30.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_440.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_179.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_537.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_507.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_538.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_266.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_461.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_71.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_243.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_434.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_429.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_79.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_388.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_421.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_384.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_306.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_239.png',
          ],
          totalSaleCount: 3978,
          trackId: '7782782849913303346',
          contentId: 1469,
          contentDisplayPeriod: { from: '20230506170000', to: '20230509235959' },
          type: 'BIG_CARD',
          landingUrl: 'https://store.kakao.com/meditreestore/products/56992838?_=1683445801260&area=mainp',
          mainCopy: '메디트리 저분자 피쉬콜라겐 3개월분+비타C젤리 증정',
          label: '',
          imageUrl:
            'https://st.kakaocdn.net/thumb/C750x422.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fhome%2Fgroup_discount_product%2F20230503140439_632eab26bb3e4f759ddd0ccc1db34f3f.png',
          imageUrlOrigin: 'https://st.kakaocdn.net/shoppingstore/home/group_discount_product/20230503140439_632eab26bb3e4f759ddd0ccc1db34f3f.png',
          sharingImageUrl:
            'https://st.kakaocdn.net/thumb/C750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230503153945_f1ae09f97809426b91bcc7efc3a721c7.jpg&mode=watermark&wm_param1=image&wm_id=talkdeal',
          logoImageUrl: '',
          contentRemainDays: 2,
          remainDays: 2,
          contentOpenDt: '20230506',
          contentCloseDt: '20230509',
          likeProductCount: 957,
          isLiked: false,
          score: 1.09228e7,
        },
        {
          productId: 237319333,
          productName: '구~수한 청국장 150g x 4팩 무료배송 국내산 100% 전통식품인증 /AR',
          productImage: 'https://st.kakaocdn.net/thumb/C375x375.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230327115215_322815ce44ee4591b25012a2c43faddd.jpg',
          productImageOrigin: 'https://st.kakaocdn.net/shoppingstore/product/20230327115215_322815ce44ee4591b25012a2c43faddd.jpg',
          originalPrice: 15000,
          discountedPrice: 15000,
          discountRate: 0,
          groupDiscountDisplayable: true,
          groupDiscountStatus: 'ON_SALE',
          groupDiscountedPrice: 9500,
          groupDiscountWillClosed: false,
          groupDiscountUserCount: 1129,
          groupDiscountStartAt: 1683360000000,
          groupDiscountEndAt: 1683644399000,
          alarmDisplaying: false,
          groupDiscountRemainSeconds: 198597,
          storeId: 65639,
          storeName: '더싱싱몰',
          storeDomain: 'thesingsingmall',
          storeProfileImage: 'https://st.kakaocdn.net/thumb/B350x350cw/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fstore%2F20221220105751_e1fa8df8ef8d484882a0ce41ca96c55c.png',
          new: false,
          linkPath: '/detail/?productId=237319333',
          storeLinkPath: '/thesingsingmall?area=mainp',
          plusFriendSubscriberExclusive: false,
          farmer: true,
          deliveryFeeType: 'FREE',
          freeDelivery: true,
          reviewCount: 10,
          productPositivePercentage: 100,
          imageRatio: 'SQUARE',
          displayedSaleStatus: 'ON_SALE',
          categoryId: '102100103106',
          categoryName: '청국장',
          hasAdditionalOptionPrice: false,
          groupDiscountPeriod: { from: '20230506170000', to: '20230509235959' },
          profiles: [
            'https://st.kakaocdn.net/shoppingstore/random/profile_468.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_493.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_366.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_42.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_167.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_522.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_370.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_411.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_144.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_22.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_114.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_402.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_101.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_59.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_300.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_334.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_105.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_283.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_317.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_45.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_431.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_229.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_143.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_199.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_367.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_112.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_375.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_116.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_189.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_23.png',
          ],
          totalSaleCount: 1399,
          trackId: '',
          contentId: 1469,
          contentDisplayPeriod: { from: '20230506170000', to: '20230509235959' },
          type: 'BIG_CARD',
          landingUrl: 'https://store.kakao.com/thesingsingmall/products/237319333?_=1683445801259&area=mainp',
          mainCopy: '100% 국내산 청국장 150g 4팩, 전통식품 인증',
          label: '',
          imageUrl:
            'https://st.kakaocdn.net/thumb/C750x422.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fhome%2Fgroup_discount_product%2F20230503140245_a3d0af4aa80d428192c568843aa907ee.png',
          imageUrlOrigin: 'https://st.kakaocdn.net/shoppingstore/home/group_discount_product/20230503140245_a3d0af4aa80d428192c568843aa907ee.png',
          sharingImageUrl:
            'https://st.kakaocdn.net/thumb/C750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230327115215_322815ce44ee4591b25012a2c43faddd.jpg&mode=watermark&wm_param1=image&wm_id=talkdeal',
          logoImageUrl: '',
          contentRemainDays: 2,
          remainDays: 2,
          contentOpenDt: '20230506',
          contentCloseDt: '20230509',
          likeProductCount: 479,
          isLiked: false,
          score: 1.07255e7,
        },
        {
          productId: 53209039,
          productName: '[EPA+DHA 1,000mg/1일] GNM rTG 알티지오메가3 60캡슐 2박스/비타민E',
          productImage: 'https://st.kakaocdn.net/thumb/C375x375.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230202131209_904b492441844cfb8db1e7eaa323ae0c.jpg',
          productImageOrigin: 'https://st.kakaocdn.net/shoppingstore/product/20230202131209_904b492441844cfb8db1e7eaa323ae0c.jpg',
          originalPrice: 26900,
          discountedPrice: 26900,
          discountRate: 0,
          groupDiscountDisplayable: true,
          groupDiscountStatus: 'ON_SALE',
          groupDiscountedPrice: 18900,
          groupDiscountWillClosed: false,
          groupDiscountUserCount: 563,
          groupDiscountStartAt: 1683360000000,
          groupDiscountEndAt: 1683644399000,
          alarmDisplaying: false,
          groupDiscountRemainSeconds: 198597,
          storeId: 2310,
          storeName: 'GNM자연의품격',
          storeDomain: 'gnmlife',
          storeProfileImage: 'https://st.kakaocdn.net/thumb/B350x350cw/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fstore%2F20230201112144_b50c843620714ac3924102cd5bb2ef0d.jpg',
          new: false,
          linkPath: '/detail/?productId=53209039',
          storeLinkPath: '/gnmlife?area=mainp',
          plusFriendSubscriberExclusive: false,
          farmer: false,
          deliveryFeeType: 'FREE',
          freeDelivery: true,
          reviewCount: 1115,
          productPositivePercentage: 99,
          imageRatio: 'SQUARE',
          displayedSaleStatus: 'ON_SALE',
          categoryId: '102105105100',
          categoryName: '오메가3/스쿠알렌',
          hasAdditionalOptionPrice: true,
          groupDiscountPeriod: { from: '20230506170000', to: '20230509235959' },
          profiles: [
            'https://st.kakaocdn.net/shoppingstore/random/profile_218.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_13.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_454.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_268.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_136.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_530.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_515.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_52.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_29.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_507.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_250.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_121.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_270.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_363.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_9.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_147.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_465.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_44.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_316.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_266.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_346.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_119.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_252.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_337.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_125.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_523.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_129.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_248.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_341.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_477.png',
          ],
          totalSaleCount: 16382,
          trackId: '143797823758159857',
          contentId: 1469,
          contentDisplayPeriod: { from: '20230506170000', to: '20230509235959' },
          type: 'BIG_CARD',
          landingUrl: 'https://store.kakao.com/gnmlife/products/53209039?_=1683445801260&area=mainp',
          mainCopy: 'GNM 알티지 오메가3 식물성캡슐 60정 2박스',
          label: '',
          imageUrl:
            'https://st.kakaocdn.net/thumb/C750x422.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fhome%2Fgroup_discount_product%2F20230503140446_974f09c4704a40988ba9bc9f86e8a3bb.png',
          imageUrlOrigin: 'https://st.kakaocdn.net/shoppingstore/home/group_discount_product/20230503140446_974f09c4704a40988ba9bc9f86e8a3bb.png',
          sharingImageUrl:
            'https://st.kakaocdn.net/thumb/C750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230202131209_904b492441844cfb8db1e7eaa323ae0c.jpg&mode=watermark&wm_param1=image&wm_id=talkdeal',
          logoImageUrl: '',
          contentRemainDays: 2,
          remainDays: 2,
          contentOpenDt: '20230506',
          contentCloseDt: '20230509',
          likeProductCount: 1306,
          isLiked: false,
          score: 1.06407e7,
        },
        {
          productId: 247834660,
          productName: '성주 정품 못난이 꿀참외 3kg 5kg',
          productImage: 'https://st.kakaocdn.net/thumb/C375x375.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230404102418_e19e69467678468b8c042bb7c28c77cd.jpg',
          productImageOrigin: 'https://st.kakaocdn.net/shoppingstore/product/20230404102418_e19e69467678468b8c042bb7c28c77cd.jpg',
          originalPrice: 36900,
          discountedPrice: 36900,
          discountRate: 0,
          groupDiscountDisplayable: true,
          groupDiscountStatus: 'ON_SALE',
          groupDiscountedPrice: 17900,
          groupDiscountWillClosed: false,
          groupDiscountUserCount: 591,
          groupDiscountStartAt: 1683417600000,
          groupDiscountEndAt: 1683730799000,
          alarmDisplaying: false,
          groupDiscountRemainSeconds: 284997,
          storeId: 67458,
          storeName: '한경어게인',
          storeDomain: 'hankyeong',
          storeProfileImage: 'https://st.kakaocdn.net/thumb/B350x350cw/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fstore%2F20210415132701_e4c2a1966d84401893077cb9ea5737e1.jpeg',
          new: false,
          linkPath: '/detail/?productId=247834660',
          storeLinkPath: '/hankyeong?area=mainp',
          plusFriendSubscriberExclusive: false,
          farmer: false,
          deliveryFeeType: 'FREE',
          freeDelivery: true,
          productPositivePercentage: 100,
          imageRatio: 'SQUARE',
          displayedSaleStatus: 'ON_SALE',
          categoryId: '102104103105100',
          categoryName: '참외',
          hasAdditionalOptionPrice: true,
          groupDiscountPeriod: { from: '20230507090000', to: '20230510235959' },
          profiles: [
            'https://st.kakaocdn.net/shoppingstore/random/profile_420.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_162.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_115.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_217.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_55.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_409.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_197.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_344.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_551.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_445.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_219.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_497.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_259.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_326.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_479.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_399.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_60.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_474.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_533.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_406.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_338.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_394.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_376.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_491.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_309.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_367.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_150.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_19.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_142.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_393.png',
          ],
          totalSaleCount: 623,
          trackId: '',
          contentId: 1469,
          contentDisplayPeriod: { from: '20230506170000', to: '20230509235959' },
          type: 'BIG_CARD',
          landingUrl: 'https://store.kakao.com/hankyeong/products/247834660?_=1683445801262&area=mainp',
          mainCopy: '성주 못난이 꿀참외 5kg. 아삭아삭 달달한 과육',
          label: '',
          imageUrl:
            'https://st.kakaocdn.net/thumb/C750x422.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fhome%2Fgroup_discount_product%2F20230507093138_c70272f5d72f49df803eb575c14914e9.png',
          imageUrlOrigin: 'https://st.kakaocdn.net/shoppingstore/home/group_discount_product/20230507093138_c70272f5d72f49df803eb575c14914e9.png',
          sharingImageUrl:
            'https://st.kakaocdn.net/thumb/C750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230404102418_e19e69467678468b8c042bb7c28c77cd.jpg&mode=watermark&wm_param1=image&wm_id=talkdeal',
          logoImageUrl: '',
          contentRemainDays: 2,
          remainDays: 3,
          contentOpenDt: '20230506',
          contentCloseDt: '20230509',
          likeProductCount: 83,
          isLiked: false,
          score: 1.05789e7,
        },
        {
          productId: 64498390,
          productName: '[지프] 무료배송 (공용) 인기상품  18종택1',
          productImage: 'https://st.kakaocdn.net/thumb/C375x375.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230503143644_2f143599dc6145e28657214e0ff92268.png',
          productImageOrigin: 'https://st.kakaocdn.net/shoppingstore/product/20230503143644_2f143599dc6145e28657214e0ff92268.png',
          originalPrice: 35000,
          discountedPrice: 35000,
          discountRate: 0,
          groupDiscountDisplayable: true,
          groupDiscountStatus: 'ON_SALE',
          groupDiscountedPrice: 18700,
          groupDiscountWillClosed: false,
          groupDiscountUserCount: 550,
          groupDiscountStartAt: 1683360000000,
          groupDiscountEndAt: 1683644399000,
          alarmDisplaying: false,
          groupDiscountRemainSeconds: 198597,
          storeId: 35979,
          storeName: '현대백화점 판교점',
          storeDomain: 'hdpangyo',
          storeProfileImage: 'https://st.kakaocdn.net/thumb/B350x350cw/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fstore%2F20200616115712_a14275635cb04f32a8ee2d1e6dad879f.jpg',
          new: false,
          linkPath: '/detail/?productId=64498390',
          storeLinkPath: '/hdpangyo?area=mainp',
          plusFriendSubscriberExclusive: false,
          farmer: false,
          deliveryFeeType: 'FREE',
          freeDelivery: true,
          reviewCount: 1326,
          productPositivePercentage: 96,
          imageRatio: 'SQUARE',
          displayedSaleStatus: 'ON_SALE',
          categoryId: '101104101100',
          categoryName: '남성 라운드넥 티셔츠',
          hasAdditionalOptionPrice: true,
          groupDiscountPeriod: { from: '20230506170000', to: '20230509235959' },
          profiles: [
            'https://st.kakaocdn.net/shoppingstore/random/profile_403.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_17.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_115.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_192.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_379.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_69.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_489.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_340.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_141.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_63.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_158.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_145.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_534.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_360.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_59.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_492.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_127.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_122.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_330.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_431.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_270.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_206.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_262.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_550.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_275.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_222.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_7.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_244.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_434.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_447.png',
          ],
          totalSaleCount: 28246,
          trackId: '',
          contentId: 1469,
          contentDisplayPeriod: { from: '20230506170000', to: '20230509235959' },
          type: 'BIG_CARD',
          landingUrl: 'https://store.kakao.com/hdpangyo/products/64498390?_=1683445801260&area=mainp',
          mainCopy: '지프 남녀공용 인기 캐주얼 의류 18종 스타일',
          label: '앵콜톡딜',
          imageUrl:
            'https://st.kakaocdn.net/thumb/C750x422.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fhome%2Fgroup_discount_product%2F20230503140501_85abfaa530f54c28b9f209028dbbb5fc.png',
          imageUrlOrigin: 'https://st.kakaocdn.net/shoppingstore/home/group_discount_product/20230503140501_85abfaa530f54c28b9f209028dbbb5fc.png',
          sharingImageUrl:
            'https://st.kakaocdn.net/thumb/C750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230503143644_2f143599dc6145e28657214e0ff92268.png&mode=watermark&wm_param1=image&wm_id=talkdeal',
          logoImageUrl: '',
          contentRemainDays: 2,
          remainDays: 2,
          contentOpenDt: '20230506',
          contentCloseDt: '20230509',
          likeProductCount: 4565,
          isLiked: false,
          score: 1.0285e7,
        },
        {
          productId: 24832184,
          productName: '[여름철 필수템]쉬크 인튜이션 기획팩 (제모기+날4입) + 프리미엄 눈썹칼 4개 외',
          productImage: 'https://st.kakaocdn.net/thumb/C375x375.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230426163721_d244541209b946f79176190af94b5f79.jpg',
          productImageOrigin: 'https://st.kakaocdn.net/shoppingstore/product/20230426163721_d244541209b946f79176190af94b5f79.jpg',
          originalPrice: 29900,
          discountedPrice: 29900,
          discountRate: 0,
          groupDiscountDisplayable: true,
          groupDiscountStatus: 'ON_SALE',
          groupDiscountedPrice: 16900,
          groupDiscountWillClosed: false,
          groupDiscountUserCount: 608,
          groupDiscountStartAt: 1683360000000,
          groupDiscountEndAt: 1683644399000,
          alarmDisplaying: false,
          groupDiscountRemainSeconds: 198597,
          storeId: 2530,
          storeName: 'LG생활건강',
          storeDomain: 'lgcare',
          storeProfileImage: 'https://st.kakaocdn.net/thumb/B350x350cw/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fstore%2F20180906172400_1455a346d67045d2a8e82e1b71145b1b.jpeg',
          new: false,
          linkPath: '/detail/?productId=24832184',
          storeLinkPath: '/lgcare?area=mainp',
          plusFriendSubscriberExclusive: false,
          farmer: false,
          deliveryFeeType: 'FREE',
          freeDelivery: true,
          imageRatio: 'SQUARE',
          displayedSaleStatus: 'ON_SALE',
          categoryId: '101103100104',
          categoryName: '제모제',
          hasAdditionalOptionPrice: true,
          groupDiscountPeriod: { from: '20230506170000', to: '20230509235959' },
          profiles: [
            'https://st.kakaocdn.net/shoppingstore/random/profile_468.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_247.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_217.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_94.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_218.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_476.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_158.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_277.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_20.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_475.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_360.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_528.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_59.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_348.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_440.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_191.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_183.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_224.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_368.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_461.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_303.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_74.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_481.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_456.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_540.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_451.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_150.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_243.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_464.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_36.png',
          ],
          totalSaleCount: 676,
          trackId: '568260606456383071',
          contentId: 1469,
          contentDisplayPeriod: { from: '20230506170000', to: '20230509235959' },
          type: 'BIG_CARD',
          landingUrl: 'https://store.kakao.com/lgcare/products/24832184?_=1683445801261&area=mainp',
          mainCopy: '쉬크 인튜이션 제모기+날 4입+눈썹칼 4개 증정',
          label: '',
          imageUrl:
            'https://st.kakaocdn.net/thumb/C750x422.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fhome%2Fgroup_discount_product%2F20230503140549_94e95d2553be49f88f28fa08d9579ae0.png',
          imageUrlOrigin: 'https://st.kakaocdn.net/shoppingstore/home/group_discount_product/20230503140549_94e95d2553be49f88f28fa08d9579ae0.png',
          sharingImageUrl:
            'https://st.kakaocdn.net/thumb/C750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230426163721_d244541209b946f79176190af94b5f79.jpg&mode=watermark&wm_param1=image&wm_id=talkdeal',
          logoImageUrl: '',
          contentRemainDays: 2,
          remainDays: 2,
          contentOpenDt: '20230506',
          contentCloseDt: '20230509',
          likeProductCount: 664,
          isLiked: false,
          score: 1.02752e7,
        },
        {
          productId: 164308681,
          productName: '오리온 인기스낵 4+3+3 포카칩,스윙칩,눈을감자,무뚝뚝',
          productImage: 'https://st.kakaocdn.net/thumb/C375x375.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230502144610_adb744ff5cb449af9422c905dca1931a.jpg',
          productImageOrigin: 'https://st.kakaocdn.net/shoppingstore/product/20230502144610_adb744ff5cb449af9422c905dca1931a.jpg',
          originalPrice: 15000,
          discountedPrice: 15000,
          discountRate: 0,
          groupDiscountDisplayable: true,
          groupDiscountStatus: 'ON_SALE',
          groupDiscountedPrice: 10000,
          groupDiscountWillClosed: false,
          groupDiscountUserCount: 952,
          groupDiscountStartAt: 1683360000000,
          groupDiscountEndAt: 1683644399000,
          alarmDisplaying: false,
          groupDiscountRemainSeconds: 198597,
          storeId: 15894,
          storeName: '오리온공식판매점',
          storeDomain: 'orionstore',
          storeProfileImage: 'https://st.kakaocdn.net/thumb/B350x350cw/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fstore%2F20230302165639_3039f3be72884378b2bbe2c413e295ae.jpg',
          new: false,
          linkPath: '/detail/?productId=164308681',
          storeLinkPath: '/orionstore?area=mainp',
          plusFriendSubscriberExclusive: false,
          farmer: false,
          deliveryFeeType: 'FREE',
          freeDelivery: true,
          reviewCount: 1411,
          productPositivePercentage: 99,
          imageRatio: 'SQUARE',
          displayedSaleStatus: 'ON_SALE',
          categoryId: '102109100',
          categoryName: '과자/쿠키',
          hasAdditionalOptionPrice: true,
          groupDiscountPeriod: { from: '20230506170000', to: '20230509235959' },
          profiles: [
            'https://st.kakaocdn.net/shoppingstore/random/profile_468.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_17.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_500.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_63.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_188.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_450.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_246.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_203.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_289.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_29.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_322.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_284.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_378.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_471.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_148.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_462.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_210.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_508.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_253.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_181.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_9.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_67.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_303.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_367.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_523.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_416.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_213.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_2.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_464.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_88.png',
          ],
          totalSaleCount: 25835,
          trackId: '',
          contentId: 1469,
          contentDisplayPeriod: { from: '20230506170000', to: '20230509235959' },
          type: 'BIG_CARD',
          landingUrl: 'https://store.kakao.com/orionstore/products/164308681?_=1683445801259&area=mainp',
          mainCopy: '오리온 인기스낵 10개 골라담기! 오땅/스윙칩 외',
          label: '앵콜톡딜',
          imageUrl:
            'https://st.kakaocdn.net/thumb/C750x422.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fhome%2Fgroup_discount_product%2F20230503140314_a1bbb993e1514e9d807c7288b0ba7100.png',
          imageUrlOrigin: 'https://st.kakaocdn.net/shoppingstore/home/group_discount_product/20230503140314_a1bbb993e1514e9d807c7288b0ba7100.png',
          sharingImageUrl:
            'https://st.kakaocdn.net/thumb/C750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230502144610_adb744ff5cb449af9422c905dca1931a.jpg&mode=watermark&wm_param1=image&wm_id=talkdeal',
          logoImageUrl: '',
          contentRemainDays: 2,
          remainDays: 2,
          contentOpenDt: '20230506',
          contentCloseDt: '20230509',
          likeProductCount: 4092,
          isLiked: false,
          score: 9520000.0,
        },
        {
          productId: 227497376,
          productName: '[코코블랑] 23 여름신상 반팔니트 9900원 외 100종 최대할인',
          productImage: 'https://st.kakaocdn.net/thumb/C375x375.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230503154913_4d9c5a4dda024f7a92c71168866f788b.jpg',
          productImageOrigin: 'https://st.kakaocdn.net/shoppingstore/product/20230503154913_4d9c5a4dda024f7a92c71168866f788b.jpg',
          originalPrice: 49900,
          discountedPrice: 49900,
          discountRate: 0,
          groupDiscountDisplayable: true,
          groupDiscountStatus: 'ON_SALE',
          groupDiscountedPrice: 9900,
          groupDiscountWillClosed: false,
          groupDiscountUserCount: 958,
          groupDiscountStartAt: 1683360000000,
          groupDiscountEndAt: 1683644399000,
          alarmDisplaying: false,
          groupDiscountRemainSeconds: 198597,
          storeId: 62459,
          storeName: '코코블랑',
          storeDomain: 'cocoblanc',
          storeProfileImage: 'https://st.kakaocdn.net/thumb/B350x350cw/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fstore%2F20221219133214_ba607a89cb2a4aedadb13d74678325a3.jpg',
          new: false,
          linkPath: '/detail/?productId=227497376',
          storeLinkPath: '/cocoblanc?area=mainp',
          plusFriendSubscriberExclusive: false,
          farmer: false,
          deliveryFeeType: 'FREE',
          freeDelivery: true,
          imageRatio: 'SQUARE',
          displayedSaleStatus: 'ON_SALE',
          categoryId: '101102102104',
          categoryName: '여성 브이넥 니트',
          hasAdditionalOptionPrice: true,
          groupDiscountPeriod: { from: '20230506170000', to: '20230509235959' },
          profiles: [
            'https://st.kakaocdn.net/shoppingstore/random/profile_102.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_328.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_192.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_442.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_55.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_357.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_370.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_327.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_500.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_305.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_515.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_90.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_86.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_334.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_47.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_183.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_342.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_487.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_181.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_350.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_28.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_236.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_31.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_266.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_190.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_248.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_371.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_133.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_198.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_36.png',
          ],
          totalSaleCount: 2443,
          trackId: '',
          contentId: 1469,
          contentDisplayPeriod: { from: '20230506170000', to: '20230509235959' },
          type: 'BIG_CARD',
          landingUrl: 'https://store.kakao.com/cocoblanc/products/227497376?_=1683445801261&area=mainp',
          mainCopy: '코코블랑 브이넥 반팔 니트 외 데일리룩 99종 스타일',
          label: '',
          imageUrl:
            'https://st.kakaocdn.net/thumb/C750x422.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fhome%2Fgroup_discount_product%2F20230503140516_0260e927c462473bbb40491d5b5c97b0.png',
          imageUrlOrigin: 'https://st.kakaocdn.net/shoppingstore/home/group_discount_product/20230503140516_0260e927c462473bbb40491d5b5c97b0.png',
          sharingImageUrl:
            'https://st.kakaocdn.net/thumb/C750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230503154913_4d9c5a4dda024f7a92c71168866f788b.jpg&mode=watermark&wm_param1=image&wm_id=talkdeal',
          logoImageUrl: '',
          contentRemainDays: 2,
          remainDays: 2,
          contentOpenDt: '20230506',
          contentCloseDt: '20230509',
          likeProductCount: 792,
          isLiked: false,
          score: 9484200.0,
        },
      ],
      [
        {
          productId: 247087647,
          productName: '반스 스니커즈 20종 모음전',
          productImage: 'https://st.kakaocdn.net/thumb/C375x375.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230503113855_63af65cc961c4054855538dee4a38858.jpg',
          productImageOrigin: 'https://st.kakaocdn.net/shoppingstore/product/20230503113855_63af65cc961c4054855538dee4a38858.jpg',
          originalPrice: 79000,
          discountedPrice: 79000,
          discountRate: 0,
          groupDiscountDisplayable: true,
          groupDiscountStatus: 'ON_SALE',
          groupDiscountedPrice: 39900,
          groupDiscountWillClosed: false,
          groupDiscountUserCount: 2006,
          groupDiscountStartAt: 1683360000000,
          groupDiscountEndAt: 1683644399000,
          alarmDisplaying: false,
          groupDiscountRemainSeconds: 198597,
          storeId: 40714,
          storeName: '아이스탁몰',
          storeDomain: 'istockmall',
          storeProfileImage: 'https://st.kakaocdn.net/thumb/B350x350cw/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fstore%2F20200515131237_23adae4cca2c42a0800ed3ed5e5cc168.jpeg',
          new: false,
          linkPath: '/detail/?productId=247087647',
          storeLinkPath: '/istockmall?area=mainp',
          plusFriendSubscriberExclusive: false,
          farmer: false,
          deliveryFeeType: 'FREE',
          freeDelivery: true,
          imageRatio: 'SQUARE',
          displayedSaleStatus: 'ON_SALE',
          categoryId: '101108104101',
          categoryName: '캐주얼운동화',
          hasAdditionalOptionPrice: true,
          groupDiscountPeriod: { from: '20230506170000', to: '20230509235959' },
          profiles: [
            'https://st.kakaocdn.net/shoppingstore/random/profile_403.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_535.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_154.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_136.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_301.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_108.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_335.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_29.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_466.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_529.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_395.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_210.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_342.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_533.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_538.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_350.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_431.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_406.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_178.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_113.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_457.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_351.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_236.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_87.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_381.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_486.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_260.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_282.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_404.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_92.png',
          ],
          totalSaleCount: 2437,
          trackId: '1463847132807741383',
          contentId: 1469,
          contentDisplayPeriod: { from: '20230506170000', to: '20230509235959' },
          type: 'BIG_CARD',
          landingUrl: 'https://store.kakao.com/istockmall/products/247087647?_=1683445801258&area=mainp',
          mainCopy: '반스 데일리 스니커즈/슬립온 20종 스타일',
          label: '',
          imageUrl:
            'https://st.kakaocdn.net/thumb/C750x422.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fhome%2Fgroup_discount_product%2F20230503162549_c6ad232a4b4444aeaa63d3315db214e3.jpeg',
          imageUrlOrigin: 'https://st.kakaocdn.net/shoppingstore/home/group_discount_product/20230503162549_c6ad232a4b4444aeaa63d3315db214e3.jpeg',
          sharingImageUrl:
            'https://st.kakaocdn.net/thumb/C750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230503113855_63af65cc961c4054855538dee4a38858.jpg&mode=watermark&wm_param1=image&wm_id=talkdeal',
          logoImageUrl: '',
          contentRemainDays: 2,
          remainDays: 2,
          contentOpenDt: '20230506',
          contentCloseDt: '20230509',
          likeProductCount: 1870,
          isLiked: false,
          score: 8.00394e7,
        },
        {
          productId: 247868049,
          productName: '목우촌 한우 인삼갈비탕 700gX4개+한우 사골곰탕 4개 증정',
          productImage: 'https://st.kakaocdn.net/thumb/C375x375.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230427145426_080e14bb1d234597a2f468afde015a50.jpg',
          productImageOrigin: 'https://st.kakaocdn.net/shoppingstore/product/20230427145426_080e14bb1d234597a2f468afde015a50.jpg',
          originalPrice: 59900,
          discountedPrice: 59900,
          discountRate: 0,
          groupDiscountDisplayable: true,
          groupDiscountStatus: 'ON_SALE',
          groupDiscountedPrice: 28900,
          groupDiscountWillClosed: false,
          groupDiscountUserCount: 2357,
          groupDiscountStartAt: 1683360000000,
          groupDiscountEndAt: 1683644399000,
          alarmDisplaying: false,
          groupDiscountRemainSeconds: 198597,
          storeId: 69747,
          storeName: '목우촌',
          storeDomain: 'moguchon',
          storeProfileImage: 'https://st.kakaocdn.net/thumb/B350x350cw/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fstore%2F20220620195113_0e4200b7122945598f61132ce4e0ea0e.jpg',
          new: false,
          linkPath: '/detail/?productId=247868049',
          storeLinkPath: '/moguchon?area=mainp',
          plusFriendSubscriberExclusive: false,
          farmer: false,
          deliveryFeeType: 'FREE',
          freeDelivery: true,
          imageRatio: 'SQUARE',
          displayedSaleStatus: 'ON_SALE',
          categoryId: '102100100112',
          categoryName: '국/탕/찌개',
          hasAdditionalOptionPrice: false,
          groupDiscountPeriod: { from: '20230506170000', to: '20230509235959' },
          profiles: [
            'https://st.kakaocdn.net/shoppingstore/random/profile_493.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_420.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_366.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_498.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_18.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_171.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_246.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_267.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_109.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_73.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_210.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_546.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_372.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_228.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_202.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_350.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_100.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_435.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_236.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_229.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_448.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_346.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_295.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_14.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_389.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_205.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_490.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_548.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_23.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_198.png',
          ],
          totalSaleCount: 2839,
          trackId: '1726756183548867528',
          contentId: 1469,
          contentDisplayPeriod: { from: '20230506170000', to: '20230509235959' },
          type: 'BIG_CARD',
          landingUrl: 'https://store.kakao.com/moguchon/products/247868049?_=1683445801259&area=mainp',
          mainCopy: '목우촌 한우 인삼 갈비탕 700g 4개+사골곰탕 4개',
          label: '',
          imageUrl:
            'https://st.kakaocdn.net/thumb/C750x422.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fhome%2Fgroup_discount_product%2F20230503140323_8c2159beb21249ad81360a6aaae1ac54.png',
          imageUrlOrigin: 'https://st.kakaocdn.net/shoppingstore/home/group_discount_product/20230503140323_8c2159beb21249ad81360a6aaae1ac54.png',
          sharingImageUrl:
            'https://st.kakaocdn.net/thumb/C750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230427145426_080e14bb1d234597a2f468afde015a50.jpg&mode=watermark&wm_param1=image&wm_id=talkdeal',
          logoImageUrl: '',
          contentRemainDays: 2,
          remainDays: 2,
          contentOpenDt: '20230506',
          contentCloseDt: '20230509',
          likeProductCount: 581,
          isLiked: false,
          score: 6.81173e7,
        },
        {
          productId: 90836953,
          productName: '[오늘 구매시 백화점 상품권 증정!! / 눈물의 재고 정리 특가] 클리엔 R9 로봇청소기',
          productImage: 'https://st.kakaocdn.net/thumb/C375x375.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230503120952_8040d7bf834c4860b2bb74a01f990825.jpg',
          productImageOrigin: 'https://st.kakaocdn.net/shoppingstore/product/20230503120952_8040d7bf834c4860b2bb74a01f990825.jpg',
          originalPrice: 799000,
          discountedPrice: 799000,
          discountRate: 0,
          groupDiscountDisplayable: true,
          groupDiscountStatus: 'ON_SALE',
          groupDiscountedPrice: 369000,
          groupDiscountWillClosed: false,
          groupDiscountUserCount: 134,
          groupDiscountStartAt: 1683360000000,
          groupDiscountEndAt: 1683644399000,
          alarmDisplaying: false,
          groupDiscountRemainSeconds: 198597,
          storeId: 66388,
          storeName: '클리엔',
          storeDomain: 'clien',
          storeProfileImage: 'https://st.kakaocdn.net/thumb/B350x350cw/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fstore%2F20210405180300_b5ab0f7204284d0293497ce4f33c7882.jpeg',
          new: false,
          linkPath: '/detail/?productId=90836953',
          storeLinkPath: '/clien?area=mainp',
          plusFriendSubscriberExclusive: false,
          farmer: false,
          deliveryFeeType: 'FREE',
          freeDelivery: true,
          reviewCount: 2579,
          productPositivePercentage: 100,
          imageRatio: 'SQUARE',
          displayedSaleStatus: 'ON_SALE',
          categoryId: '100103102101',
          categoryName: '로봇청소기',
          hasAdditionalOptionPrice: true,
          groupDiscountPeriod: { from: '20230506170000', to: '20230509235959' },
          profiles: [
            'https://st.kakaocdn.net/shoppingstore/random/profile_221.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_485.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_69.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_123.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_459.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_500.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_340.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_301.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_329.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_99.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_25.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_507.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_105.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_210.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_91.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_66.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_8.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_292.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_448.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_163.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_84.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_469.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_111.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_97.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_79.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_421.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_544.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_265.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_36.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_438.png',
          ],
          totalSaleCount: 6722,
          trackId: '4015756886542694813',
          contentId: 1469,
          contentDisplayPeriod: { from: '20230506170000', to: '20230509235959' },
          type: 'BIG_CARD',
          landingUrl: 'https://store.kakao.com/clien/products/90836953?_=1683445801257&area=mainp',
          mainCopy: '클리엔 로봇청소기 R9. 진공청소와 물걸레를 한번에',
          label: '',
          imageUrl:
            'https://st.kakaocdn.net/thumb/C750x422.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fhome%2Fgroup_discount_product%2F20230503140010_3225abb6924e43df8e69a0233db29c96.png',
          imageUrlOrigin: 'https://st.kakaocdn.net/shoppingstore/home/group_discount_product/20230503140010_3225abb6924e43df8e69a0233db29c96.png',
          sharingImageUrl:
            'https://st.kakaocdn.net/thumb/C750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230503120952_8040d7bf834c4860b2bb74a01f990825.jpg&mode=watermark&wm_param1=image&wm_id=talkdeal',
          logoImageUrl: '',
          contentRemainDays: 2,
          remainDays: 2,
          contentOpenDt: '20230506',
          contentCloseDt: '20230509',
          likeProductCount: 2597,
          isLiked: false,
          score: 4.9446e7,
        },
        {
          productId: 204308361,
          productName: '[우체국쇼핑]전북 정읍 국내산 귀리로 만든 귀리뻥튀기 왕큰봉지 2봉/4봉',
          productImage: 'https://st.kakaocdn.net/thumb/C375x375.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20221208143712_c032773e042e4b15aa5d9b8dde9b907c.jpg',
          productImageOrigin: 'https://st.kakaocdn.net/shoppingstore/product/20221208143712_c032773e042e4b15aa5d9b8dde9b907c.jpg',
          originalPrice: 12900,
          discountedPrice: 12900,
          discountRate: 0,
          groupDiscountDisplayable: true,
          groupDiscountStatus: 'ON_SALE',
          groupDiscountedPrice: 8900,
          groupDiscountWillClosed: false,
          groupDiscountUserCount: 3358,
          groupDiscountStartAt: 1683360000000,
          groupDiscountEndAt: 1683644399000,
          alarmDisplaying: false,
          groupDiscountRemainSeconds: 198597,
          storeId: 1987,
          storeName: '우체국쇼핑몰',
          storeDomain: 'postkmall',
          storeProfileImage: 'https://st.kakaocdn.net/thumb/B350x350cw/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fstore%2F20190625190413_5030441de54d40a6b0ab62f92d846298.jpg',
          new: false,
          linkPath: '/detail/?productId=204308361',
          storeLinkPath: '/postkmall?area=mainp',
          plusFriendSubscriberExclusive: false,
          farmer: true,
          deliveryFeeType: 'FREE',
          freeDelivery: true,
          reviewCount: 699,
          productPositivePercentage: 98,
          imageRatio: 'SQUARE',
          displayedSaleStatus: 'ON_SALE',
          categoryId: '102109100',
          categoryName: '과자/쿠키',
          hasAdditionalOptionPrice: true,
          groupDiscountPeriod: { from: '20230506170000', to: '20230509235959' },
          profiles: [
            'https://st.kakaocdn.net/shoppingstore/random/profile_192.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_310.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_357.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_446.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_98.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_78.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_277.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_390.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_418.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_161.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_73.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_304.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_508.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_169.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_449.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_164.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_431.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_376.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_67.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_368.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_316.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_554.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_134.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_541.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_57.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_7.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_41.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_97.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_412.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_464.png',
          ],
          totalSaleCount: 11420,
          trackId: '',
          contentId: 1469,
          contentDisplayPeriod: { from: '20230506170000', to: '20230509235959' },
          type: 'BIG_CARD',
          landingUrl: 'https://store.kakao.com/postkmall/products/204308361?_=1683445801259&area=mainp',
          mainCopy: '전북 정읍 귀리 뻥튀기 150g 2봉. 바삭 고소한 맛',
          label: '',
          imageUrl:
            'https://st.kakaocdn.net/thumb/C750x422.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fhome%2Fgroup_discount_product%2F20230503140218_cb2298038357478799f81f25032142d6.png',
          imageUrlOrigin: 'https://st.kakaocdn.net/shoppingstore/home/group_discount_product/20230503140218_cb2298038357478799f81f25032142d6.png',
          sharingImageUrl:
            'https://st.kakaocdn.net/thumb/C750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20221208143712_c032773e042e4b15aa5d9b8dde9b907c.jpg&mode=watermark&wm_param1=image&wm_id=talkdeal',
          logoImageUrl: '',
          contentRemainDays: 2,
          remainDays: 2,
          contentOpenDt: '20230506',
          contentCloseDt: '20230509',
          likeProductCount: 2973,
          isLiked: false,
          score: 2.98862e7,
        },
        {
          productId: 246324459,
          productName: '카밀 대용량 바디로션 1+1+미니 바디로션 1개 증정',
          productImage: 'https://st.kakaocdn.net/thumb/C375x375.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230421163754_65f354cc72cd4958a4593b64a086dd11.jpg',
          productImageOrigin: 'https://st.kakaocdn.net/shoppingstore/product/20230421163754_65f354cc72cd4958a4593b64a086dd11.jpg',
          originalPrice: 34700,
          discountedPrice: 34700,
          discountRate: 0,
          groupDiscountDisplayable: true,
          groupDiscountStatus: 'ON_SALE',
          groupDiscountedPrice: 12900,
          groupDiscountWillClosed: false,
          groupDiscountUserCount: 1571,
          groupDiscountStartAt: 1683360000000,
          groupDiscountEndAt: 1683644399000,
          alarmDisplaying: false,
          groupDiscountRemainSeconds: 198597,
          storeId: 58053,
          storeName: '지엘커뮤니케이션즈',
          storeDomain: 'glcomm',
          storeProfileImage: 'https://st.kakaocdn.net/thumb/B350x350cw/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fstore%2F20210111095926_2c708d8f5fa3405aa6f3148a870b8480.jpeg',
          new: false,
          linkPath: '/detail/?productId=246324459',
          storeLinkPath: '/glcomm?area=mainp',
          plusFriendSubscriberExclusive: false,
          farmer: false,
          deliveryFeeType: 'FREE',
          freeDelivery: true,
          imageRatio: 'SQUARE',
          displayedSaleStatus: 'ON_SALE',
          categoryId: '101103100100101',
          categoryName: '바디로션',
          hasAdditionalOptionPrice: false,
          groupDiscountPeriod: { from: '20230506170000', to: '20230509235959' },
          profiles: [
            'https://st.kakaocdn.net/shoppingstore/random/profile_336.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_366.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_353.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_94.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_80.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_373.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_427.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_263.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_343.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_330.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_83.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_253.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_288.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_377.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_350.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_296.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_363.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_177.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_478.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_407.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_27.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_539.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_11.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_337.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_57.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_208.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_531.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_129.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_97.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_306.png',
          ],
          totalSaleCount: 1641,
          trackId: '',
          contentId: 1469,
          contentDisplayPeriod: { from: '20230506170000', to: '20230509235959' },
          type: 'BIG_CARD',
          landingUrl: 'https://store.kakao.com/glcomm/products/246324459?_=1683445801261&area=mainp',
          mainCopy: '카밀 바디로션 500ml 1+1+50ml 추가 증정',
          label: '',
          imageUrl:
            'https://st.kakaocdn.net/thumb/C750x422.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fhome%2Fgroup_discount_product%2F20230503140542_1dcb6a9906b14d11b0338e53510cccbc.png',
          imageUrlOrigin: 'https://st.kakaocdn.net/shoppingstore/home/group_discount_product/20230503140542_1dcb6a9906b14d11b0338e53510cccbc.png',
          sharingImageUrl:
            'https://st.kakaocdn.net/thumb/C750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230421163754_65f354cc72cd4958a4593b64a086dd11.jpg&mode=watermark&wm_param1=image&wm_id=talkdeal',
          logoImageUrl: '',
          contentRemainDays: 2,
          remainDays: 2,
          contentOpenDt: '20230506',
          contentCloseDt: '20230509',
          likeProductCount: 814,
          isLiked: false,
          score: 2.02659e7,
        },
        {
          productId: 197627921,
          productName: '[카렉스] 시야확보주의! 레인스톰 하이브리드 와이퍼 2+2 (차량2대분)',
          productImage: 'https://st.kakaocdn.net/thumb/C375x375.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230502134519_cfbf8c4266eb4d34af8910b0141a8762.png',
          productImageOrigin: 'https://st.kakaocdn.net/shoppingstore/product/20230502134519_cfbf8c4266eb4d34af8910b0141a8762.png',
          originalPrice: 23600,
          discountedPrice: 23600,
          discountRate: 0,
          groupDiscountDisplayable: true,
          groupDiscountStatus: 'ON_SALE',
          groupDiscountedPrice: 9900,
          groupDiscountWillClosed: false,
          groupDiscountUserCount: 1777,
          groupDiscountStartAt: 1683360000000,
          groupDiscountEndAt: 1683644399000,
          alarmDisplaying: false,
          groupDiscountRemainSeconds: 198597,
          storeId: 15139,
          storeName: '카렉스몰',
          storeDomain: 'carex',
          storeProfileImage: 'https://st.kakaocdn.net/thumb/B350x350cw/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fstore%2F20230417160745_796ff505b7e74d6fb3dc806d508b3da6.jpg',
          new: false,
          linkPath: '/detail/?productId=197627921',
          storeLinkPath: '/carex?area=mainp',
          plusFriendSubscriberExclusive: false,
          farmer: false,
          deliveryFeeType: 'FREE',
          freeDelivery: true,
          reviewCount: 233,
          productPositivePercentage: 99,
          imageRatio: 'SQUARE',
          displayedSaleStatus: 'ON_SALE',
          categoryId: '103101116110',
          categoryName: '와이퍼',
          hasAdditionalOptionPrice: false,
          groupDiscountPeriod: { from: '20230506170000', to: '20230509235959' },
          profiles: [
            'https://st.kakaocdn.net/shoppingstore/random/profile_552.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_446.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_340.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_277.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_76.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_290.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_432.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_475.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_157.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_497.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_293.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_427.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_529.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_211.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_250.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_401.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_194.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_508.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_288.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_325.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_428.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_448.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_214.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_502.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_295.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_257.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_62.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_129.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_315.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_473.png',
          ],
          totalSaleCount: 5249,
          trackId: '',
          contentId: 1469,
          contentDisplayPeriod: { from: '20230506170000', to: '20230509235959' },
          type: 'BIG_CARD',
          landingUrl: 'https://store.kakao.com/carex/products/197627921?_=1683445801257&area=mainp',
          mainCopy: '카렉스 하이브리드 와이퍼 2+2. 뛰어난 고성능 와이퍼',
          label: '',
          imageUrl:
            'https://st.kakaocdn.net/thumb/C750x422.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fhome%2Fgroup_discount_product%2F20230503140044_18e765e4e03a497ab939d6ec49122a6b.png',
          imageUrlOrigin: 'https://st.kakaocdn.net/shoppingstore/home/group_discount_product/20230503140044_18e765e4e03a497ab939d6ec49122a6b.png',
          sharingImageUrl:
            'https://st.kakaocdn.net/thumb/C750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230502134519_cfbf8c4266eb4d34af8910b0141a8762.png&mode=watermark&wm_param1=image&wm_id=talkdeal',
          logoImageUrl: '',
          contentRemainDays: 2,
          remainDays: 2,
          contentOpenDt: '20230506',
          contentCloseDt: '20230509',
          likeProductCount: 1084,
          isLiked: false,
          score: 1.75923e7,
        },
        {
          productId: 139319258,
          productName: '온더바디 슈퍼보타닉 비누 12개(쟈스민,오이라임) 외',
          productImage: 'https://st.kakaocdn.net/thumb/C375x375.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230504111125_f80ab8bb9b724e67b20d4c16b5dc3789.jpg',
          productImageOrigin: 'https://st.kakaocdn.net/shoppingstore/product/20230504111125_f80ab8bb9b724e67b20d4c16b5dc3789.jpg',
          originalPrice: 19800,
          discountedPrice: 19800,
          discountRate: 0,
          groupDiscountDisplayable: true,
          groupDiscountStatus: 'ON_SALE',
          groupDiscountedPrice: 9900,
          groupDiscountWillClosed: false,
          groupDiscountUserCount: 1300,
          groupDiscountStartAt: 1683360000000,
          groupDiscountEndAt: 1683644399000,
          alarmDisplaying: false,
          groupDiscountRemainSeconds: 198597,
          storeId: 2530,
          storeName: 'LG생활건강',
          storeDomain: 'lgcare',
          storeProfileImage: 'https://st.kakaocdn.net/thumb/B350x350cw/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fstore%2F20180906172400_1455a346d67045d2a8e82e1b71145b1b.jpeg',
          new: false,
          linkPath: '/detail/?productId=139319258',
          storeLinkPath: '/lgcare?area=mainp',
          plusFriendSubscriberExclusive: false,
          farmer: false,
          deliveryFeeType: 'FREE',
          freeDelivery: true,
          reviewCount: 606,
          productPositivePercentage: 99,
          imageRatio: 'SQUARE',
          displayedSaleStatus: 'ON_SALE',
          categoryId: '101107107104',
          categoryName: '클렌징 비누',
          hasAdditionalOptionPrice: false,
          groupDiscountPeriod: { from: '20230506170000', to: '20230509235959' },
          profiles: [
            'https://st.kakaocdn.net/shoppingstore/random/profile_357.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_218.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_13.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_255.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_238.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_212.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_95.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_187.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_402.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_149.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_300.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_467.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_82.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_166.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_219.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_25.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_105.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_304.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_503.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_58.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_100.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_482.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_236.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_368.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_398.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_389.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_243.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_32.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_332.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_88.png',
          ],
          totalSaleCount: 9825,
          trackId: '568260606456383071',
          contentId: 1469,
          contentDisplayPeriod: { from: '20230506170000', to: '20230509235959' },
          type: 'BIG_CARD',
          landingUrl: 'https://store.kakao.com/lgcare/products/139319258?_=1683445801261&area=mainp',
          mainCopy: '온더바디 슈퍼보타닉 비누 12개, 자스민/오이라임',
          label: '',
          imageUrl:
            'https://st.kakaocdn.net/thumb/C750x422.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fhome%2Fgroup_discount_product%2F20230503140535_dc210d7a6de649288e5d7af08abea4fc.png',
          imageUrlOrigin: 'https://st.kakaocdn.net/shoppingstore/home/group_discount_product/20230503140535_dc210d7a6de649288e5d7af08abea4fc.png',
          sharingImageUrl:
            'https://st.kakaocdn.net/thumb/C750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230504111125_f80ab8bb9b724e67b20d4c16b5dc3789.jpg&mode=watermark&wm_param1=image&wm_id=talkdeal',
          logoImageUrl: '',
          contentRemainDays: 2,
          remainDays: 2,
          contentOpenDt: '20230506',
          contentCloseDt: '20230509',
          likeProductCount: 1796,
          isLiked: false,
          score: 1.287e7,
        },
        {
          productId: 68626964,
          productName: '[퍼실 300ml 2개 증정] 헨켈 섬유유연제 버넬 0.9L 6개',
          productImage: 'https://st.kakaocdn.net/thumb/C375x375.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230427144204_ac2dd3c737b940f291b0065d98e89d6a.jpg',
          productImageOrigin: 'https://st.kakaocdn.net/shoppingstore/product/20230427144204_ac2dd3c737b940f291b0065d98e89d6a.jpg',
          originalPrice: 41400,
          discountedPrice: 41400,
          discountRate: 0,
          groupDiscountDisplayable: true,
          groupDiscountStatus: 'ON_SALE',
          groupDiscountedPrice: 16900,
          groupDiscountWillClosed: false,
          groupDiscountUserCount: 693,
          groupDiscountStartAt: 1683360000000,
          groupDiscountEndAt: 1683644399000,
          alarmDisplaying: false,
          groupDiscountRemainSeconds: 198597,
          storeId: 1634,
          storeName: '헨켈온라인공식몰',
          storeDomain: 'henkel',
          storeProfileImage: 'https://st.kakaocdn.net/thumb/B350x350cw/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fstore%2F20180608105211_d2911174025541ae8dffd07245b7f3c1.jpeg',
          new: false,
          linkPath: '/detail/?productId=68626964',
          storeLinkPath: '/henkel?area=mainp',
          plusFriendSubscriberExclusive: false,
          farmer: false,
          deliveryFeeType: 'FREE',
          freeDelivery: true,
          reviewCount: 1890,
          productPositivePercentage: 98,
          imageRatio: 'SQUARE',
          displayedSaleStatus: 'ON_SALE',
          categoryId: '104103103101',
          categoryName: '섬유유연제',
          hasAdditionalOptionPrice: true,
          groupDiscountPeriod: { from: '20230506170000', to: '20230509235959' },
          profiles: [
            'https://st.kakaocdn.net/shoppingstore/random/profile_234.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_361.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_353.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_485.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_285.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_417.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_81.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_357.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_63.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_145.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_65.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_405.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_135.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_237.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_4.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_118.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_410.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_283.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_156.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_288.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_113.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_232.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_398.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_74.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_71.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_208.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_416.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_429.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_505.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_438.png',
          ],
          totalSaleCount: 25200,
          trackId: '7247716872349566931',
          contentId: 1469,
          contentDisplayPeriod: { from: '20230506170000', to: '20230509235959' },
          type: 'BIG_CARD',
          landingUrl: 'https://store.kakao.com/henkel/products/68626964?_=1683445801258&area=mainp',
          mainCopy: '헨켈 고농축 섬유유연제 버넬 0.9L 6개+퍼실 증정',
          label: '',
          imageUrl:
            'https://st.kakaocdn.net/thumb/C750x422.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fhome%2Fgroup_discount_product%2F20230503140122_ce4908bacb4d4a84a9b951af5866d3cc.png',
          imageUrlOrigin: 'https://st.kakaocdn.net/shoppingstore/home/group_discount_product/20230503140122_ce4908bacb4d4a84a9b951af5866d3cc.png',
          sharingImageUrl:
            'https://st.kakaocdn.net/thumb/C750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230427144204_ac2dd3c737b940f291b0065d98e89d6a.jpg&mode=watermark&wm_param1=image&wm_id=talkdeal',
          logoImageUrl: '',
          contentRemainDays: 2,
          remainDays: 2,
          contentOpenDt: '20230506',
          contentCloseDt: '20230509',
          likeProductCount: 2008,
          isLiked: false,
          score: 1.17117e7,
        },
        {
          productId: 56992838,
          productName: '[사은품증정 EVENT] "동안피부비결" 이탈리아산 저분자 피쉬콜라겐 1통 90포 3개월분',
          productImage: 'https://st.kakaocdn.net/thumb/C375x375.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230503153945_f1ae09f97809426b91bcc7efc3a721c7.jpg',
          productImageOrigin: 'https://st.kakaocdn.net/shoppingstore/product/20230503153945_f1ae09f97809426b91bcc7efc3a721c7.jpg',
          originalPrice: 37000,
          discountedPrice: 37000,
          discountRate: 0,
          groupDiscountDisplayable: true,
          groupDiscountStatus: 'ON_SALE',
          groupDiscountedPrice: 16600,
          groupDiscountWillClosed: false,
          groupDiscountUserCount: 658,
          groupDiscountStartAt: 1683360000000,
          groupDiscountEndAt: 1683644399000,
          alarmDisplaying: false,
          groupDiscountRemainSeconds: 198597,
          storeId: 24251,
          storeName: '메디트리 공식스토어',
          storeDomain: 'meditreestore',
          storeProfileImage: 'https://st.kakaocdn.net/thumb/B350x350cw/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fstore%2F20210818133516_a533c7d96a154236a6771613e501fa83.jpg',
          new: false,
          linkPath: '/detail/?productId=56992838',
          storeLinkPath: '/meditreestore?area=mainp',
          plusFriendSubscriberExclusive: false,
          farmer: false,
          deliveryFeeType: 'FREE',
          freeDelivery: true,
          reviewCount: 606,
          productPositivePercentage: 100,
          imageRatio: 'SQUARE',
          displayedSaleStatus: 'ON_SALE',
          categoryId: '102105105101',
          categoryName: '콜라겐/코큐텐',
          hasAdditionalOptionPrice: true,
          groupDiscountPeriod: { from: '20230506170000', to: '20230509235959' },
          profiles: [
            'https://st.kakaocdn.net/shoppingstore/random/profile_420.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_294.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_115.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_26.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_217.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_110.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_549.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_340.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_513.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_48.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_463.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_174.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_30.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_440.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_179.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_537.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_507.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_538.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_266.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_461.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_71.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_243.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_434.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_429.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_79.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_388.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_421.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_384.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_306.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_239.png',
          ],
          totalSaleCount: 3978,
          trackId: '7782782849913303346',
          contentId: 1469,
          contentDisplayPeriod: { from: '20230506170000', to: '20230509235959' },
          type: 'BIG_CARD',
          landingUrl: 'https://store.kakao.com/meditreestore/products/56992838?_=1683445801260&area=mainp',
          mainCopy: '메디트리 저분자 피쉬콜라겐 3개월분+비타C젤리 증정',
          label: '',
          imageUrl:
            'https://st.kakaocdn.net/thumb/C750x422.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fhome%2Fgroup_discount_product%2F20230503140439_632eab26bb3e4f759ddd0ccc1db34f3f.png',
          imageUrlOrigin: 'https://st.kakaocdn.net/shoppingstore/home/group_discount_product/20230503140439_632eab26bb3e4f759ddd0ccc1db34f3f.png',
          sharingImageUrl:
            'https://st.kakaocdn.net/thumb/C750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230503153945_f1ae09f97809426b91bcc7efc3a721c7.jpg&mode=watermark&wm_param1=image&wm_id=talkdeal',
          logoImageUrl: '',
          contentRemainDays: 2,
          remainDays: 2,
          contentOpenDt: '20230506',
          contentCloseDt: '20230509',
          likeProductCount: 957,
          isLiked: false,
          score: 1.09228e7,
        },
        {
          productId: 237319333,
          productName: '구~수한 청국장 150g x 4팩 무료배송 국내산 100% 전통식품인증 /AR',
          productImage: 'https://st.kakaocdn.net/thumb/C375x375.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230327115215_322815ce44ee4591b25012a2c43faddd.jpg',
          productImageOrigin: 'https://st.kakaocdn.net/shoppingstore/product/20230327115215_322815ce44ee4591b25012a2c43faddd.jpg',
          originalPrice: 15000,
          discountedPrice: 15000,
          discountRate: 0,
          groupDiscountDisplayable: true,
          groupDiscountStatus: 'ON_SALE',
          groupDiscountedPrice: 9500,
          groupDiscountWillClosed: false,
          groupDiscountUserCount: 1129,
          groupDiscountStartAt: 1683360000000,
          groupDiscountEndAt: 1683644399000,
          alarmDisplaying: false,
          groupDiscountRemainSeconds: 198597,
          storeId: 65639,
          storeName: '더싱싱몰',
          storeDomain: 'thesingsingmall',
          storeProfileImage: 'https://st.kakaocdn.net/thumb/B350x350cw/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fstore%2F20221220105751_e1fa8df8ef8d484882a0ce41ca96c55c.png',
          new: false,
          linkPath: '/detail/?productId=237319333',
          storeLinkPath: '/thesingsingmall?area=mainp',
          plusFriendSubscriberExclusive: false,
          farmer: true,
          deliveryFeeType: 'FREE',
          freeDelivery: true,
          reviewCount: 10,
          productPositivePercentage: 100,
          imageRatio: 'SQUARE',
          displayedSaleStatus: 'ON_SALE',
          categoryId: '102100103106',
          categoryName: '청국장',
          hasAdditionalOptionPrice: false,
          groupDiscountPeriod: { from: '20230506170000', to: '20230509235959' },
          profiles: [
            'https://st.kakaocdn.net/shoppingstore/random/profile_468.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_493.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_366.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_42.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_167.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_522.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_370.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_411.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_144.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_22.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_114.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_402.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_101.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_59.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_300.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_334.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_105.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_283.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_317.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_45.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_431.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_229.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_143.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_199.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_367.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_112.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_375.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_116.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_189.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_23.png',
          ],
          totalSaleCount: 1399,
          trackId: '',
          contentId: 1469,
          contentDisplayPeriod: { from: '20230506170000', to: '20230509235959' },
          type: 'BIG_CARD',
          landingUrl: 'https://store.kakao.com/thesingsingmall/products/237319333?_=1683445801259&area=mainp',
          mainCopy: '100% 국내산 청국장 150g 4팩, 전통식품 인증',
          label: '',
          imageUrl:
            'https://st.kakaocdn.net/thumb/C750x422.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fhome%2Fgroup_discount_product%2F20230503140245_a3d0af4aa80d428192c568843aa907ee.png',
          imageUrlOrigin: 'https://st.kakaocdn.net/shoppingstore/home/group_discount_product/20230503140245_a3d0af4aa80d428192c568843aa907ee.png',
          sharingImageUrl:
            'https://st.kakaocdn.net/thumb/C750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230327115215_322815ce44ee4591b25012a2c43faddd.jpg&mode=watermark&wm_param1=image&wm_id=talkdeal',
          logoImageUrl: '',
          contentRemainDays: 2,
          remainDays: 2,
          contentOpenDt: '20230506',
          contentCloseDt: '20230509',
          likeProductCount: 479,
          isLiked: false,
          score: 1.07255e7,
        },
        {
          productId: 53209039,
          productName: '[EPA+DHA 1,000mg/1일] GNM rTG 알티지오메가3 60캡슐 2박스/비타민E',
          productImage: 'https://st.kakaocdn.net/thumb/C375x375.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230202131209_904b492441844cfb8db1e7eaa323ae0c.jpg',
          productImageOrigin: 'https://st.kakaocdn.net/shoppingstore/product/20230202131209_904b492441844cfb8db1e7eaa323ae0c.jpg',
          originalPrice: 26900,
          discountedPrice: 26900,
          discountRate: 0,
          groupDiscountDisplayable: true,
          groupDiscountStatus: 'ON_SALE',
          groupDiscountedPrice: 18900,
          groupDiscountWillClosed: false,
          groupDiscountUserCount: 563,
          groupDiscountStartAt: 1683360000000,
          groupDiscountEndAt: 1683644399000,
          alarmDisplaying: false,
          groupDiscountRemainSeconds: 198597,
          storeId: 2310,
          storeName: 'GNM자연의품격',
          storeDomain: 'gnmlife',
          storeProfileImage: 'https://st.kakaocdn.net/thumb/B350x350cw/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fstore%2F20230201112144_b50c843620714ac3924102cd5bb2ef0d.jpg',
          new: false,
          linkPath: '/detail/?productId=53209039',
          storeLinkPath: '/gnmlife?area=mainp',
          plusFriendSubscriberExclusive: false,
          farmer: false,
          deliveryFeeType: 'FREE',
          freeDelivery: true,
          reviewCount: 1115,
          productPositivePercentage: 99,
          imageRatio: 'SQUARE',
          displayedSaleStatus: 'ON_SALE',
          categoryId: '102105105100',
          categoryName: '오메가3/스쿠알렌',
          hasAdditionalOptionPrice: true,
          groupDiscountPeriod: { from: '20230506170000', to: '20230509235959' },
          profiles: [
            'https://st.kakaocdn.net/shoppingstore/random/profile_218.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_13.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_454.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_268.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_136.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_530.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_515.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_52.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_29.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_507.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_250.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_121.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_270.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_363.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_9.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_147.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_465.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_44.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_316.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_266.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_346.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_119.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_252.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_337.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_125.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_523.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_129.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_248.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_341.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_477.png',
          ],
          totalSaleCount: 16382,
          trackId: '143797823758159857',
          contentId: 1469,
          contentDisplayPeriod: { from: '20230506170000', to: '20230509235959' },
          type: 'BIG_CARD',
          landingUrl: 'https://store.kakao.com/gnmlife/products/53209039?_=1683445801260&area=mainp',
          mainCopy: 'GNM 알티지 오메가3 식물성캡슐 60정 2박스',
          label: '',
          imageUrl:
            'https://st.kakaocdn.net/thumb/C750x422.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fhome%2Fgroup_discount_product%2F20230503140446_974f09c4704a40988ba9bc9f86e8a3bb.png',
          imageUrlOrigin: 'https://st.kakaocdn.net/shoppingstore/home/group_discount_product/20230503140446_974f09c4704a40988ba9bc9f86e8a3bb.png',
          sharingImageUrl:
            'https://st.kakaocdn.net/thumb/C750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230202131209_904b492441844cfb8db1e7eaa323ae0c.jpg&mode=watermark&wm_param1=image&wm_id=talkdeal',
          logoImageUrl: '',
          contentRemainDays: 2,
          remainDays: 2,
          contentOpenDt: '20230506',
          contentCloseDt: '20230509',
          likeProductCount: 1306,
          isLiked: false,
          score: 1.06407e7,
        },
        {
          productId: 247834660,
          productName: '성주 정품 못난이 꿀참외 3kg 5kg',
          productImage: 'https://st.kakaocdn.net/thumb/C375x375.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230404102418_e19e69467678468b8c042bb7c28c77cd.jpg',
          productImageOrigin: 'https://st.kakaocdn.net/shoppingstore/product/20230404102418_e19e69467678468b8c042bb7c28c77cd.jpg',
          originalPrice: 36900,
          discountedPrice: 36900,
          discountRate: 0,
          groupDiscountDisplayable: true,
          groupDiscountStatus: 'ON_SALE',
          groupDiscountedPrice: 17900,
          groupDiscountWillClosed: false,
          groupDiscountUserCount: 591,
          groupDiscountStartAt: 1683417600000,
          groupDiscountEndAt: 1683730799000,
          alarmDisplaying: false,
          groupDiscountRemainSeconds: 284997,
          storeId: 67458,
          storeName: '한경어게인',
          storeDomain: 'hankyeong',
          storeProfileImage: 'https://st.kakaocdn.net/thumb/B350x350cw/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fstore%2F20210415132701_e4c2a1966d84401893077cb9ea5737e1.jpeg',
          new: false,
          linkPath: '/detail/?productId=247834660',
          storeLinkPath: '/hankyeong?area=mainp',
          plusFriendSubscriberExclusive: false,
          farmer: false,
          deliveryFeeType: 'FREE',
          freeDelivery: true,
          productPositivePercentage: 100,
          imageRatio: 'SQUARE',
          displayedSaleStatus: 'ON_SALE',
          categoryId: '102104103105100',
          categoryName: '참외',
          hasAdditionalOptionPrice: true,
          groupDiscountPeriod: { from: '20230507090000', to: '20230510235959' },
          profiles: [
            'https://st.kakaocdn.net/shoppingstore/random/profile_420.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_162.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_115.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_217.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_55.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_409.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_197.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_344.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_551.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_445.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_219.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_497.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_259.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_326.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_479.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_399.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_60.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_474.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_533.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_406.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_338.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_394.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_376.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_491.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_309.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_367.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_150.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_19.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_142.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_393.png',
          ],
          totalSaleCount: 623,
          trackId: '',
          contentId: 1469,
          contentDisplayPeriod: { from: '20230506170000', to: '20230509235959' },
          type: 'BIG_CARD',
          landingUrl: 'https://store.kakao.com/hankyeong/products/247834660?_=1683445801262&area=mainp',
          mainCopy: '성주 못난이 꿀참외 5kg. 아삭아삭 달달한 과육',
          label: '',
          imageUrl:
            'https://st.kakaocdn.net/thumb/C750x422.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fhome%2Fgroup_discount_product%2F20230507093138_c70272f5d72f49df803eb575c14914e9.png',
          imageUrlOrigin: 'https://st.kakaocdn.net/shoppingstore/home/group_discount_product/20230507093138_c70272f5d72f49df803eb575c14914e9.png',
          sharingImageUrl:
            'https://st.kakaocdn.net/thumb/C750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230404102418_e19e69467678468b8c042bb7c28c77cd.jpg&mode=watermark&wm_param1=image&wm_id=talkdeal',
          logoImageUrl: '',
          contentRemainDays: 2,
          remainDays: 3,
          contentOpenDt: '20230506',
          contentCloseDt: '20230509',
          likeProductCount: 83,
          isLiked: false,
          score: 1.05789e7,
        },
        {
          productId: 64498390,
          productName: '[지프] 무료배송 (공용) 인기상품  18종택1',
          productImage: 'https://st.kakaocdn.net/thumb/C375x375.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230503143644_2f143599dc6145e28657214e0ff92268.png',
          productImageOrigin: 'https://st.kakaocdn.net/shoppingstore/product/20230503143644_2f143599dc6145e28657214e0ff92268.png',
          originalPrice: 35000,
          discountedPrice: 35000,
          discountRate: 0,
          groupDiscountDisplayable: true,
          groupDiscountStatus: 'ON_SALE',
          groupDiscountedPrice: 18700,
          groupDiscountWillClosed: false,
          groupDiscountUserCount: 550,
          groupDiscountStartAt: 1683360000000,
          groupDiscountEndAt: 1683644399000,
          alarmDisplaying: false,
          groupDiscountRemainSeconds: 198597,
          storeId: 35979,
          storeName: '현대백화점 판교점',
          storeDomain: 'hdpangyo',
          storeProfileImage: 'https://st.kakaocdn.net/thumb/B350x350cw/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fstore%2F20200616115712_a14275635cb04f32a8ee2d1e6dad879f.jpg',
          new: false,
          linkPath: '/detail/?productId=64498390',
          storeLinkPath: '/hdpangyo?area=mainp',
          plusFriendSubscriberExclusive: false,
          farmer: false,
          deliveryFeeType: 'FREE',
          freeDelivery: true,
          reviewCount: 1326,
          productPositivePercentage: 96,
          imageRatio: 'SQUARE',
          displayedSaleStatus: 'ON_SALE',
          categoryId: '101104101100',
          categoryName: '남성 라운드넥 티셔츠',
          hasAdditionalOptionPrice: true,
          groupDiscountPeriod: { from: '20230506170000', to: '20230509235959' },
          profiles: [
            'https://st.kakaocdn.net/shoppingstore/random/profile_403.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_17.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_115.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_192.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_379.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_69.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_489.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_340.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_141.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_63.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_158.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_145.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_534.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_360.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_59.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_492.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_127.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_122.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_330.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_431.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_270.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_206.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_262.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_550.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_275.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_222.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_7.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_244.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_434.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_447.png',
          ],
          totalSaleCount: 28246,
          trackId: '',
          contentId: 1469,
          contentDisplayPeriod: { from: '20230506170000', to: '20230509235959' },
          type: 'BIG_CARD',
          landingUrl: 'https://store.kakao.com/hdpangyo/products/64498390?_=1683445801260&area=mainp',
          mainCopy: '지프 남녀공용 인기 캐주얼 의류 18종 스타일',
          label: '앵콜톡딜',
          imageUrl:
            'https://st.kakaocdn.net/thumb/C750x422.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fhome%2Fgroup_discount_product%2F20230503140501_85abfaa530f54c28b9f209028dbbb5fc.png',
          imageUrlOrigin: 'https://st.kakaocdn.net/shoppingstore/home/group_discount_product/20230503140501_85abfaa530f54c28b9f209028dbbb5fc.png',
          sharingImageUrl:
            'https://st.kakaocdn.net/thumb/C750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230503143644_2f143599dc6145e28657214e0ff92268.png&mode=watermark&wm_param1=image&wm_id=talkdeal',
          logoImageUrl: '',
          contentRemainDays: 2,
          remainDays: 2,
          contentOpenDt: '20230506',
          contentCloseDt: '20230509',
          likeProductCount: 4565,
          isLiked: false,
          score: 1.0285e7,
        },
        {
          productId: 24832184,
          productName: '[여름철 필수템]쉬크 인튜이션 기획팩 (제모기+날4입) + 프리미엄 눈썹칼 4개 외',
          productImage: 'https://st.kakaocdn.net/thumb/C375x375.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230426163721_d244541209b946f79176190af94b5f79.jpg',
          productImageOrigin: 'https://st.kakaocdn.net/shoppingstore/product/20230426163721_d244541209b946f79176190af94b5f79.jpg',
          originalPrice: 29900,
          discountedPrice: 29900,
          discountRate: 0,
          groupDiscountDisplayable: true,
          groupDiscountStatus: 'ON_SALE',
          groupDiscountedPrice: 16900,
          groupDiscountWillClosed: false,
          groupDiscountUserCount: 608,
          groupDiscountStartAt: 1683360000000,
          groupDiscountEndAt: 1683644399000,
          alarmDisplaying: false,
          groupDiscountRemainSeconds: 198597,
          storeId: 2530,
          storeName: 'LG생활건강',
          storeDomain: 'lgcare',
          storeProfileImage: 'https://st.kakaocdn.net/thumb/B350x350cw/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fstore%2F20180906172400_1455a346d67045d2a8e82e1b71145b1b.jpeg',
          new: false,
          linkPath: '/detail/?productId=24832184',
          storeLinkPath: '/lgcare?area=mainp',
          plusFriendSubscriberExclusive: false,
          farmer: false,
          deliveryFeeType: 'FREE',
          freeDelivery: true,
          imageRatio: 'SQUARE',
          displayedSaleStatus: 'ON_SALE',
          categoryId: '101103100104',
          categoryName: '제모제',
          hasAdditionalOptionPrice: true,
          groupDiscountPeriod: { from: '20230506170000', to: '20230509235959' },
          profiles: [
            'https://st.kakaocdn.net/shoppingstore/random/profile_468.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_247.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_217.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_94.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_218.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_476.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_158.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_277.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_20.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_475.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_360.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_528.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_59.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_348.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_440.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_191.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_183.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_224.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_368.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_461.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_303.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_74.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_481.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_456.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_540.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_451.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_150.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_243.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_464.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_36.png',
          ],
          totalSaleCount: 676,
          trackId: '568260606456383071',
          contentId: 1469,
          contentDisplayPeriod: { from: '20230506170000', to: '20230509235959' },
          type: 'BIG_CARD',
          landingUrl: 'https://store.kakao.com/lgcare/products/24832184?_=1683445801261&area=mainp',
          mainCopy: '쉬크 인튜이션 제모기+날 4입+눈썹칼 4개 증정',
          label: '',
          imageUrl:
            'https://st.kakaocdn.net/thumb/C750x422.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fhome%2Fgroup_discount_product%2F20230503140549_94e95d2553be49f88f28fa08d9579ae0.png',
          imageUrlOrigin: 'https://st.kakaocdn.net/shoppingstore/home/group_discount_product/20230503140549_94e95d2553be49f88f28fa08d9579ae0.png',
          sharingImageUrl:
            'https://st.kakaocdn.net/thumb/C750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230426163721_d244541209b946f79176190af94b5f79.jpg&mode=watermark&wm_param1=image&wm_id=talkdeal',
          logoImageUrl: '',
          contentRemainDays: 2,
          remainDays: 2,
          contentOpenDt: '20230506',
          contentCloseDt: '20230509',
          likeProductCount: 664,
          isLiked: false,
          score: 1.02752e7,
        },
        {
          productId: 164308681,
          productName: '오리온 인기스낵 4+3+3 포카칩,스윙칩,눈을감자,무뚝뚝',
          productImage: 'https://st.kakaocdn.net/thumb/C375x375.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230502144610_adb744ff5cb449af9422c905dca1931a.jpg',
          productImageOrigin: 'https://st.kakaocdn.net/shoppingstore/product/20230502144610_adb744ff5cb449af9422c905dca1931a.jpg',
          originalPrice: 15000,
          discountedPrice: 15000,
          discountRate: 0,
          groupDiscountDisplayable: true,
          groupDiscountStatus: 'ON_SALE',
          groupDiscountedPrice: 10000,
          groupDiscountWillClosed: false,
          groupDiscountUserCount: 952,
          groupDiscountStartAt: 1683360000000,
          groupDiscountEndAt: 1683644399000,
          alarmDisplaying: false,
          groupDiscountRemainSeconds: 198597,
          storeId: 15894,
          storeName: '오리온공식판매점',
          storeDomain: 'orionstore',
          storeProfileImage: 'https://st.kakaocdn.net/thumb/B350x350cw/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fstore%2F20230302165639_3039f3be72884378b2bbe2c413e295ae.jpg',
          new: false,
          linkPath: '/detail/?productId=164308681',
          storeLinkPath: '/orionstore?area=mainp',
          plusFriendSubscriberExclusive: false,
          farmer: false,
          deliveryFeeType: 'FREE',
          freeDelivery: true,
          reviewCount: 1411,
          productPositivePercentage: 99,
          imageRatio: 'SQUARE',
          displayedSaleStatus: 'ON_SALE',
          categoryId: '102109100',
          categoryName: '과자/쿠키',
          hasAdditionalOptionPrice: true,
          groupDiscountPeriod: { from: '20230506170000', to: '20230509235959' },
          profiles: [
            'https://st.kakaocdn.net/shoppingstore/random/profile_468.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_17.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_500.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_63.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_188.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_450.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_246.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_203.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_289.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_29.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_322.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_284.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_378.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_471.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_148.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_462.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_210.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_508.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_253.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_181.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_9.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_67.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_303.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_367.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_523.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_416.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_213.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_2.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_464.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_88.png',
          ],
          totalSaleCount: 25835,
          trackId: '',
          contentId: 1469,
          contentDisplayPeriod: { from: '20230506170000', to: '20230509235959' },
          type: 'BIG_CARD',
          landingUrl: 'https://store.kakao.com/orionstore/products/164308681?_=1683445801259&area=mainp',
          mainCopy: '오리온 인기스낵 10개 골라담기! 오땅/스윙칩 외',
          label: '앵콜톡딜',
          imageUrl:
            'https://st.kakaocdn.net/thumb/C750x422.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fhome%2Fgroup_discount_product%2F20230503140314_a1bbb993e1514e9d807c7288b0ba7100.png',
          imageUrlOrigin: 'https://st.kakaocdn.net/shoppingstore/home/group_discount_product/20230503140314_a1bbb993e1514e9d807c7288b0ba7100.png',
          sharingImageUrl:
            'https://st.kakaocdn.net/thumb/C750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230502144610_adb744ff5cb449af9422c905dca1931a.jpg&mode=watermark&wm_param1=image&wm_id=talkdeal',
          logoImageUrl: '',
          contentRemainDays: 2,
          remainDays: 2,
          contentOpenDt: '20230506',
          contentCloseDt: '20230509',
          likeProductCount: 4092,
          isLiked: false,
          score: 9520000.0,
        },
        {
          productId: 227497376,
          productName: '[코코블랑] 23 여름신상 반팔니트 9900원 외 100종 최대할인',
          productImage: 'https://st.kakaocdn.net/thumb/C375x375.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230503154913_4d9c5a4dda024f7a92c71168866f788b.jpg',
          productImageOrigin: 'https://st.kakaocdn.net/shoppingstore/product/20230503154913_4d9c5a4dda024f7a92c71168866f788b.jpg',
          originalPrice: 49900,
          discountedPrice: 49900,
          discountRate: 0,
          groupDiscountDisplayable: true,
          groupDiscountStatus: 'ON_SALE',
          groupDiscountedPrice: 9900,
          groupDiscountWillClosed: false,
          groupDiscountUserCount: 958,
          groupDiscountStartAt: 1683360000000,
          groupDiscountEndAt: 1683644399000,
          alarmDisplaying: false,
          groupDiscountRemainSeconds: 198597,
          storeId: 62459,
          storeName: '코코블랑',
          storeDomain: 'cocoblanc',
          storeProfileImage: 'https://st.kakaocdn.net/thumb/B350x350cw/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fstore%2F20221219133214_ba607a89cb2a4aedadb13d74678325a3.jpg',
          new: false,
          linkPath: '/detail/?productId=227497376',
          storeLinkPath: '/cocoblanc?area=mainp',
          plusFriendSubscriberExclusive: false,
          farmer: false,
          deliveryFeeType: 'FREE',
          freeDelivery: true,
          imageRatio: 'SQUARE',
          displayedSaleStatus: 'ON_SALE',
          categoryId: '101102102104',
          categoryName: '여성 브이넥 니트',
          hasAdditionalOptionPrice: true,
          groupDiscountPeriod: { from: '20230506170000', to: '20230509235959' },
          profiles: [
            'https://st.kakaocdn.net/shoppingstore/random/profile_102.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_328.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_192.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_442.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_55.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_357.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_370.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_327.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_500.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_305.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_515.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_90.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_86.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_334.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_47.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_183.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_342.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_487.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_181.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_350.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_28.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_236.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_31.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_266.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_190.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_248.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_371.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_133.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_198.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_36.png',
          ],
          totalSaleCount: 2443,
          trackId: '',
          contentId: 1469,
          contentDisplayPeriod: { from: '20230506170000', to: '20230509235959' },
          type: 'BIG_CARD',
          landingUrl: 'https://store.kakao.com/cocoblanc/products/227497376?_=1683445801261&area=mainp',
          mainCopy: '코코블랑 브이넥 반팔 니트 외 데일리룩 99종 스타일',
          label: '',
          imageUrl:
            'https://st.kakaocdn.net/thumb/C750x422.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fhome%2Fgroup_discount_product%2F20230503140516_0260e927c462473bbb40491d5b5c97b0.png',
          imageUrlOrigin: 'https://st.kakaocdn.net/shoppingstore/home/group_discount_product/20230503140516_0260e927c462473bbb40491d5b5c97b0.png',
          sharingImageUrl:
            'https://st.kakaocdn.net/thumb/C750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230503154913_4d9c5a4dda024f7a92c71168866f788b.jpg&mode=watermark&wm_param1=image&wm_id=talkdeal',
          logoImageUrl: '',
          contentRemainDays: 2,
          remainDays: 2,
          contentOpenDt: '20230506',
          contentCloseDt: '20230509',
          likeProductCount: 792,
          isLiked: false,
          score: 9484200.0,
        },
      ],
      [
        {
          productId: 247087647,
          productName: '반스 스니커즈 20종 모음전',
          productImage: 'https://st.kakaocdn.net/thumb/C375x375.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230503113855_63af65cc961c4054855538dee4a38858.jpg',
          productImageOrigin: 'https://st.kakaocdn.net/shoppingstore/product/20230503113855_63af65cc961c4054855538dee4a38858.jpg',
          originalPrice: 79000,
          discountedPrice: 79000,
          discountRate: 0,
          groupDiscountDisplayable: true,
          groupDiscountStatus: 'ON_SALE',
          groupDiscountedPrice: 39900,
          groupDiscountWillClosed: false,
          groupDiscountUserCount: 2006,
          groupDiscountStartAt: 1683360000000,
          groupDiscountEndAt: 1683644399000,
          alarmDisplaying: false,
          groupDiscountRemainSeconds: 198597,
          storeId: 40714,
          storeName: '아이스탁몰',
          storeDomain: 'istockmall',
          storeProfileImage: 'https://st.kakaocdn.net/thumb/B350x350cw/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fstore%2F20200515131237_23adae4cca2c42a0800ed3ed5e5cc168.jpeg',
          new: false,
          linkPath: '/detail/?productId=247087647',
          storeLinkPath: '/istockmall?area=mainp',
          plusFriendSubscriberExclusive: false,
          farmer: false,
          deliveryFeeType: 'FREE',
          freeDelivery: true,
          imageRatio: 'SQUARE',
          displayedSaleStatus: 'ON_SALE',
          categoryId: '101108104101',
          categoryName: '캐주얼운동화',
          hasAdditionalOptionPrice: true,
          groupDiscountPeriod: { from: '20230506170000', to: '20230509235959' },
          profiles: [
            'https://st.kakaocdn.net/shoppingstore/random/profile_403.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_535.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_154.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_136.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_301.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_108.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_335.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_29.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_466.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_529.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_395.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_210.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_342.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_533.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_538.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_350.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_431.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_406.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_178.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_113.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_457.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_351.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_236.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_87.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_381.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_486.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_260.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_282.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_404.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_92.png',
          ],
          totalSaleCount: 2437,
          trackId: '1463847132807741383',
          contentId: 1469,
          contentDisplayPeriod: { from: '20230506170000', to: '20230509235959' },
          type: 'BIG_CARD',
          landingUrl: 'https://store.kakao.com/istockmall/products/247087647?_=1683445801258&area=mainp',
          mainCopy: '반스 데일리 스니커즈/슬립온 20종 스타일',
          label: '',
          imageUrl:
            'https://st.kakaocdn.net/thumb/C750x422.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fhome%2Fgroup_discount_product%2F20230503162549_c6ad232a4b4444aeaa63d3315db214e3.jpeg',
          imageUrlOrigin: 'https://st.kakaocdn.net/shoppingstore/home/group_discount_product/20230503162549_c6ad232a4b4444aeaa63d3315db214e3.jpeg',
          sharingImageUrl:
            'https://st.kakaocdn.net/thumb/C750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230503113855_63af65cc961c4054855538dee4a38858.jpg&mode=watermark&wm_param1=image&wm_id=talkdeal',
          logoImageUrl: '',
          contentRemainDays: 2,
          remainDays: 2,
          contentOpenDt: '20230506',
          contentCloseDt: '20230509',
          likeProductCount: 1870,
          isLiked: false,
          score: 8.00394e7,
        },
        {
          productId: 247868049,
          productName: '목우촌 한우 인삼갈비탕 700gX4개+한우 사골곰탕 4개 증정',
          productImage: 'https://st.kakaocdn.net/thumb/C375x375.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230427145426_080e14bb1d234597a2f468afde015a50.jpg',
          productImageOrigin: 'https://st.kakaocdn.net/shoppingstore/product/20230427145426_080e14bb1d234597a2f468afde015a50.jpg',
          originalPrice: 59900,
          discountedPrice: 59900,
          discountRate: 0,
          groupDiscountDisplayable: true,
          groupDiscountStatus: 'ON_SALE',
          groupDiscountedPrice: 28900,
          groupDiscountWillClosed: false,
          groupDiscountUserCount: 2357,
          groupDiscountStartAt: 1683360000000,
          groupDiscountEndAt: 1683644399000,
          alarmDisplaying: false,
          groupDiscountRemainSeconds: 198597,
          storeId: 69747,
          storeName: '목우촌',
          storeDomain: 'moguchon',
          storeProfileImage: 'https://st.kakaocdn.net/thumb/B350x350cw/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fstore%2F20220620195113_0e4200b7122945598f61132ce4e0ea0e.jpg',
          new: false,
          linkPath: '/detail/?productId=247868049',
          storeLinkPath: '/moguchon?area=mainp',
          plusFriendSubscriberExclusive: false,
          farmer: false,
          deliveryFeeType: 'FREE',
          freeDelivery: true,
          imageRatio: 'SQUARE',
          displayedSaleStatus: 'ON_SALE',
          categoryId: '102100100112',
          categoryName: '국/탕/찌개',
          hasAdditionalOptionPrice: false,
          groupDiscountPeriod: { from: '20230506170000', to: '20230509235959' },
          profiles: [
            'https://st.kakaocdn.net/shoppingstore/random/profile_493.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_420.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_366.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_498.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_18.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_171.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_246.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_267.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_109.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_73.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_210.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_546.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_372.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_228.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_202.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_350.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_100.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_435.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_236.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_229.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_448.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_346.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_295.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_14.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_389.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_205.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_490.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_548.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_23.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_198.png',
          ],
          totalSaleCount: 2839,
          trackId: '1726756183548867528',
          contentId: 1469,
          contentDisplayPeriod: { from: '20230506170000', to: '20230509235959' },
          type: 'BIG_CARD',
          landingUrl: 'https://store.kakao.com/moguchon/products/247868049?_=1683445801259&area=mainp',
          mainCopy: '목우촌 한우 인삼 갈비탕 700g 4개+사골곰탕 4개',
          label: '',
          imageUrl:
            'https://st.kakaocdn.net/thumb/C750x422.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fhome%2Fgroup_discount_product%2F20230503140323_8c2159beb21249ad81360a6aaae1ac54.png',
          imageUrlOrigin: 'https://st.kakaocdn.net/shoppingstore/home/group_discount_product/20230503140323_8c2159beb21249ad81360a6aaae1ac54.png',
          sharingImageUrl:
            'https://st.kakaocdn.net/thumb/C750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230427145426_080e14bb1d234597a2f468afde015a50.jpg&mode=watermark&wm_param1=image&wm_id=talkdeal',
          logoImageUrl: '',
          contentRemainDays: 2,
          remainDays: 2,
          contentOpenDt: '20230506',
          contentCloseDt: '20230509',
          likeProductCount: 581,
          isLiked: false,
          score: 6.81173e7,
        },
        {
          productId: 90836953,
          productName: '[오늘 구매시 백화점 상품권 증정!! / 눈물의 재고 정리 특가] 클리엔 R9 로봇청소기',
          productImage: 'https://st.kakaocdn.net/thumb/C375x375.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230503120952_8040d7bf834c4860b2bb74a01f990825.jpg',
          productImageOrigin: 'https://st.kakaocdn.net/shoppingstore/product/20230503120952_8040d7bf834c4860b2bb74a01f990825.jpg',
          originalPrice: 799000,
          discountedPrice: 799000,
          discountRate: 0,
          groupDiscountDisplayable: true,
          groupDiscountStatus: 'ON_SALE',
          groupDiscountedPrice: 369000,
          groupDiscountWillClosed: false,
          groupDiscountUserCount: 134,
          groupDiscountStartAt: 1683360000000,
          groupDiscountEndAt: 1683644399000,
          alarmDisplaying: false,
          groupDiscountRemainSeconds: 198597,
          storeId: 66388,
          storeName: '클리엔',
          storeDomain: 'clien',
          storeProfileImage: 'https://st.kakaocdn.net/thumb/B350x350cw/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fstore%2F20210405180300_b5ab0f7204284d0293497ce4f33c7882.jpeg',
          new: false,
          linkPath: '/detail/?productId=90836953',
          storeLinkPath: '/clien?area=mainp',
          plusFriendSubscriberExclusive: false,
          farmer: false,
          deliveryFeeType: 'FREE',
          freeDelivery: true,
          reviewCount: 2579,
          productPositivePercentage: 100,
          imageRatio: 'SQUARE',
          displayedSaleStatus: 'ON_SALE',
          categoryId: '100103102101',
          categoryName: '로봇청소기',
          hasAdditionalOptionPrice: true,
          groupDiscountPeriod: { from: '20230506170000', to: '20230509235959' },
          profiles: [
            'https://st.kakaocdn.net/shoppingstore/random/profile_221.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_485.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_69.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_123.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_459.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_500.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_340.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_301.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_329.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_99.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_25.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_507.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_105.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_210.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_91.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_66.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_8.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_292.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_448.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_163.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_84.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_469.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_111.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_97.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_79.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_421.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_544.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_265.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_36.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_438.png',
          ],
          totalSaleCount: 6722,
          trackId: '4015756886542694813',
          contentId: 1469,
          contentDisplayPeriod: { from: '20230506170000', to: '20230509235959' },
          type: 'BIG_CARD',
          landingUrl: 'https://store.kakao.com/clien/products/90836953?_=1683445801257&area=mainp',
          mainCopy: '클리엔 로봇청소기 R9. 진공청소와 물걸레를 한번에',
          label: '',
          imageUrl:
            'https://st.kakaocdn.net/thumb/C750x422.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fhome%2Fgroup_discount_product%2F20230503140010_3225abb6924e43df8e69a0233db29c96.png',
          imageUrlOrigin: 'https://st.kakaocdn.net/shoppingstore/home/group_discount_product/20230503140010_3225abb6924e43df8e69a0233db29c96.png',
          sharingImageUrl:
            'https://st.kakaocdn.net/thumb/C750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230503120952_8040d7bf834c4860b2bb74a01f990825.jpg&mode=watermark&wm_param1=image&wm_id=talkdeal',
          logoImageUrl: '',
          contentRemainDays: 2,
          remainDays: 2,
          contentOpenDt: '20230506',
          contentCloseDt: '20230509',
          likeProductCount: 2597,
          isLiked: false,
          score: 4.9446e7,
        },
        {
          productId: 204308361,
          productName: '[우체국쇼핑]전북 정읍 국내산 귀리로 만든 귀리뻥튀기 왕큰봉지 2봉/4봉',
          productImage: 'https://st.kakaocdn.net/thumb/C375x375.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20221208143712_c032773e042e4b15aa5d9b8dde9b907c.jpg',
          productImageOrigin: 'https://st.kakaocdn.net/shoppingstore/product/20221208143712_c032773e042e4b15aa5d9b8dde9b907c.jpg',
          originalPrice: 12900,
          discountedPrice: 12900,
          discountRate: 0,
          groupDiscountDisplayable: true,
          groupDiscountStatus: 'ON_SALE',
          groupDiscountedPrice: 8900,
          groupDiscountWillClosed: false,
          groupDiscountUserCount: 3358,
          groupDiscountStartAt: 1683360000000,
          groupDiscountEndAt: 1683644399000,
          alarmDisplaying: false,
          groupDiscountRemainSeconds: 198597,
          storeId: 1987,
          storeName: '우체국쇼핑몰',
          storeDomain: 'postkmall',
          storeProfileImage: 'https://st.kakaocdn.net/thumb/B350x350cw/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fstore%2F20190625190413_5030441de54d40a6b0ab62f92d846298.jpg',
          new: false,
          linkPath: '/detail/?productId=204308361',
          storeLinkPath: '/postkmall?area=mainp',
          plusFriendSubscriberExclusive: false,
          farmer: true,
          deliveryFeeType: 'FREE',
          freeDelivery: true,
          reviewCount: 699,
          productPositivePercentage: 98,
          imageRatio: 'SQUARE',
          displayedSaleStatus: 'ON_SALE',
          categoryId: '102109100',
          categoryName: '과자/쿠키',
          hasAdditionalOptionPrice: true,
          groupDiscountPeriod: { from: '20230506170000', to: '20230509235959' },
          profiles: [
            'https://st.kakaocdn.net/shoppingstore/random/profile_192.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_310.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_357.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_446.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_98.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_78.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_277.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_390.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_418.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_161.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_73.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_304.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_508.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_169.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_449.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_164.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_431.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_376.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_67.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_368.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_316.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_554.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_134.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_541.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_57.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_7.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_41.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_97.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_412.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_464.png',
          ],
          totalSaleCount: 11420,
          trackId: '',
          contentId: 1469,
          contentDisplayPeriod: { from: '20230506170000', to: '20230509235959' },
          type: 'BIG_CARD',
          landingUrl: 'https://store.kakao.com/postkmall/products/204308361?_=1683445801259&area=mainp',
          mainCopy: '전북 정읍 귀리 뻥튀기 150g 2봉. 바삭 고소한 맛',
          label: '',
          imageUrl:
            'https://st.kakaocdn.net/thumb/C750x422.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fhome%2Fgroup_discount_product%2F20230503140218_cb2298038357478799f81f25032142d6.png',
          imageUrlOrigin: 'https://st.kakaocdn.net/shoppingstore/home/group_discount_product/20230503140218_cb2298038357478799f81f25032142d6.png',
          sharingImageUrl:
            'https://st.kakaocdn.net/thumb/C750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20221208143712_c032773e042e4b15aa5d9b8dde9b907c.jpg&mode=watermark&wm_param1=image&wm_id=talkdeal',
          logoImageUrl: '',
          contentRemainDays: 2,
          remainDays: 2,
          contentOpenDt: '20230506',
          contentCloseDt: '20230509',
          likeProductCount: 2973,
          isLiked: false,
          score: 2.98862e7,
        },
        {
          productId: 246324459,
          productName: '카밀 대용량 바디로션 1+1+미니 바디로션 1개 증정',
          productImage: 'https://st.kakaocdn.net/thumb/C375x375.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230421163754_65f354cc72cd4958a4593b64a086dd11.jpg',
          productImageOrigin: 'https://st.kakaocdn.net/shoppingstore/product/20230421163754_65f354cc72cd4958a4593b64a086dd11.jpg',
          originalPrice: 34700,
          discountedPrice: 34700,
          discountRate: 0,
          groupDiscountDisplayable: true,
          groupDiscountStatus: 'ON_SALE',
          groupDiscountedPrice: 12900,
          groupDiscountWillClosed: false,
          groupDiscountUserCount: 1571,
          groupDiscountStartAt: 1683360000000,
          groupDiscountEndAt: 1683644399000,
          alarmDisplaying: false,
          groupDiscountRemainSeconds: 198597,
          storeId: 58053,
          storeName: '지엘커뮤니케이션즈',
          storeDomain: 'glcomm',
          storeProfileImage: 'https://st.kakaocdn.net/thumb/B350x350cw/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fstore%2F20210111095926_2c708d8f5fa3405aa6f3148a870b8480.jpeg',
          new: false,
          linkPath: '/detail/?productId=246324459',
          storeLinkPath: '/glcomm?area=mainp',
          plusFriendSubscriberExclusive: false,
          farmer: false,
          deliveryFeeType: 'FREE',
          freeDelivery: true,
          imageRatio: 'SQUARE',
          displayedSaleStatus: 'ON_SALE',
          categoryId: '101103100100101',
          categoryName: '바디로션',
          hasAdditionalOptionPrice: false,
          groupDiscountPeriod: { from: '20230506170000', to: '20230509235959' },
          profiles: [
            'https://st.kakaocdn.net/shoppingstore/random/profile_336.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_366.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_353.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_94.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_80.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_373.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_427.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_263.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_343.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_330.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_83.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_253.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_288.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_377.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_350.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_296.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_363.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_177.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_478.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_407.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_27.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_539.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_11.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_337.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_57.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_208.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_531.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_129.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_97.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_306.png',
          ],
          totalSaleCount: 1641,
          trackId: '',
          contentId: 1469,
          contentDisplayPeriod: { from: '20230506170000', to: '20230509235959' },
          type: 'BIG_CARD',
          landingUrl: 'https://store.kakao.com/glcomm/products/246324459?_=1683445801261&area=mainp',
          mainCopy: '카밀 바디로션 500ml 1+1+50ml 추가 증정',
          label: '',
          imageUrl:
            'https://st.kakaocdn.net/thumb/C750x422.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fhome%2Fgroup_discount_product%2F20230503140542_1dcb6a9906b14d11b0338e53510cccbc.png',
          imageUrlOrigin: 'https://st.kakaocdn.net/shoppingstore/home/group_discount_product/20230503140542_1dcb6a9906b14d11b0338e53510cccbc.png',
          sharingImageUrl:
            'https://st.kakaocdn.net/thumb/C750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230421163754_65f354cc72cd4958a4593b64a086dd11.jpg&mode=watermark&wm_param1=image&wm_id=talkdeal',
          logoImageUrl: '',
          contentRemainDays: 2,
          remainDays: 2,
          contentOpenDt: '20230506',
          contentCloseDt: '20230509',
          likeProductCount: 814,
          isLiked: false,
          score: 2.02659e7,
        },
        {
          productId: 197627921,
          productName: '[카렉스] 시야확보주의! 레인스톰 하이브리드 와이퍼 2+2 (차량2대분)',
          productImage: 'https://st.kakaocdn.net/thumb/C375x375.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230502134519_cfbf8c4266eb4d34af8910b0141a8762.png',
          productImageOrigin: 'https://st.kakaocdn.net/shoppingstore/product/20230502134519_cfbf8c4266eb4d34af8910b0141a8762.png',
          originalPrice: 23600,
          discountedPrice: 23600,
          discountRate: 0,
          groupDiscountDisplayable: true,
          groupDiscountStatus: 'ON_SALE',
          groupDiscountedPrice: 9900,
          groupDiscountWillClosed: false,
          groupDiscountUserCount: 1777,
          groupDiscountStartAt: 1683360000000,
          groupDiscountEndAt: 1683644399000,
          alarmDisplaying: false,
          groupDiscountRemainSeconds: 198597,
          storeId: 15139,
          storeName: '카렉스몰',
          storeDomain: 'carex',
          storeProfileImage: 'https://st.kakaocdn.net/thumb/B350x350cw/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fstore%2F20230417160745_796ff505b7e74d6fb3dc806d508b3da6.jpg',
          new: false,
          linkPath: '/detail/?productId=197627921',
          storeLinkPath: '/carex?area=mainp',
          plusFriendSubscriberExclusive: false,
          farmer: false,
          deliveryFeeType: 'FREE',
          freeDelivery: true,
          reviewCount: 233,
          productPositivePercentage: 99,
          imageRatio: 'SQUARE',
          displayedSaleStatus: 'ON_SALE',
          categoryId: '103101116110',
          categoryName: '와이퍼',
          hasAdditionalOptionPrice: false,
          groupDiscountPeriod: { from: '20230506170000', to: '20230509235959' },
          profiles: [
            'https://st.kakaocdn.net/shoppingstore/random/profile_552.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_446.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_340.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_277.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_76.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_290.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_432.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_475.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_157.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_497.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_293.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_427.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_529.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_211.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_250.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_401.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_194.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_508.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_288.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_325.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_428.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_448.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_214.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_502.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_295.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_257.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_62.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_129.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_315.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_473.png',
          ],
          totalSaleCount: 5249,
          trackId: '',
          contentId: 1469,
          contentDisplayPeriod: { from: '20230506170000', to: '20230509235959' },
          type: 'BIG_CARD',
          landingUrl: 'https://store.kakao.com/carex/products/197627921?_=1683445801257&area=mainp',
          mainCopy: '카렉스 하이브리드 와이퍼 2+2. 뛰어난 고성능 와이퍼',
          label: '',
          imageUrl:
            'https://st.kakaocdn.net/thumb/C750x422.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fhome%2Fgroup_discount_product%2F20230503140044_18e765e4e03a497ab939d6ec49122a6b.png',
          imageUrlOrigin: 'https://st.kakaocdn.net/shoppingstore/home/group_discount_product/20230503140044_18e765e4e03a497ab939d6ec49122a6b.png',
          sharingImageUrl:
            'https://st.kakaocdn.net/thumb/C750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230502134519_cfbf8c4266eb4d34af8910b0141a8762.png&mode=watermark&wm_param1=image&wm_id=talkdeal',
          logoImageUrl: '',
          contentRemainDays: 2,
          remainDays: 2,
          contentOpenDt: '20230506',
          contentCloseDt: '20230509',
          likeProductCount: 1084,
          isLiked: false,
          score: 1.75923e7,
        },
        {
          productId: 139319258,
          productName: '온더바디 슈퍼보타닉 비누 12개(쟈스민,오이라임) 외',
          productImage: 'https://st.kakaocdn.net/thumb/C375x375.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230504111125_f80ab8bb9b724e67b20d4c16b5dc3789.jpg',
          productImageOrigin: 'https://st.kakaocdn.net/shoppingstore/product/20230504111125_f80ab8bb9b724e67b20d4c16b5dc3789.jpg',
          originalPrice: 19800,
          discountedPrice: 19800,
          discountRate: 0,
          groupDiscountDisplayable: true,
          groupDiscountStatus: 'ON_SALE',
          groupDiscountedPrice: 9900,
          groupDiscountWillClosed: false,
          groupDiscountUserCount: 1300,
          groupDiscountStartAt: 1683360000000,
          groupDiscountEndAt: 1683644399000,
          alarmDisplaying: false,
          groupDiscountRemainSeconds: 198597,
          storeId: 2530,
          storeName: 'LG생활건강',
          storeDomain: 'lgcare',
          storeProfileImage: 'https://st.kakaocdn.net/thumb/B350x350cw/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fstore%2F20180906172400_1455a346d67045d2a8e82e1b71145b1b.jpeg',
          new: false,
          linkPath: '/detail/?productId=139319258',
          storeLinkPath: '/lgcare?area=mainp',
          plusFriendSubscriberExclusive: false,
          farmer: false,
          deliveryFeeType: 'FREE',
          freeDelivery: true,
          reviewCount: 606,
          productPositivePercentage: 99,
          imageRatio: 'SQUARE',
          displayedSaleStatus: 'ON_SALE',
          categoryId: '101107107104',
          categoryName: '클렌징 비누',
          hasAdditionalOptionPrice: false,
          groupDiscountPeriod: { from: '20230506170000', to: '20230509235959' },
          profiles: [
            'https://st.kakaocdn.net/shoppingstore/random/profile_357.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_218.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_13.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_255.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_238.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_212.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_95.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_187.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_402.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_149.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_300.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_467.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_82.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_166.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_219.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_25.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_105.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_304.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_503.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_58.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_100.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_482.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_236.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_368.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_398.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_389.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_243.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_32.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_332.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_88.png',
          ],
          totalSaleCount: 9825,
          trackId: '568260606456383071',
          contentId: 1469,
          contentDisplayPeriod: { from: '20230506170000', to: '20230509235959' },
          type: 'BIG_CARD',
          landingUrl: 'https://store.kakao.com/lgcare/products/139319258?_=1683445801261&area=mainp',
          mainCopy: '온더바디 슈퍼보타닉 비누 12개, 자스민/오이라임',
          label: '',
          imageUrl:
            'https://st.kakaocdn.net/thumb/C750x422.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fhome%2Fgroup_discount_product%2F20230503140535_dc210d7a6de649288e5d7af08abea4fc.png',
          imageUrlOrigin: 'https://st.kakaocdn.net/shoppingstore/home/group_discount_product/20230503140535_dc210d7a6de649288e5d7af08abea4fc.png',
          sharingImageUrl:
            'https://st.kakaocdn.net/thumb/C750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230504111125_f80ab8bb9b724e67b20d4c16b5dc3789.jpg&mode=watermark&wm_param1=image&wm_id=talkdeal',
          logoImageUrl: '',
          contentRemainDays: 2,
          remainDays: 2,
          contentOpenDt: '20230506',
          contentCloseDt: '20230509',
          likeProductCount: 1796,
          isLiked: false,
          score: 1.287e7,
        },
        {
          productId: 68626964,
          productName: '[퍼실 300ml 2개 증정] 헨켈 섬유유연제 버넬 0.9L 6개',
          productImage: 'https://st.kakaocdn.net/thumb/C375x375.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230427144204_ac2dd3c737b940f291b0065d98e89d6a.jpg',
          productImageOrigin: 'https://st.kakaocdn.net/shoppingstore/product/20230427144204_ac2dd3c737b940f291b0065d98e89d6a.jpg',
          originalPrice: 41400,
          discountedPrice: 41400,
          discountRate: 0,
          groupDiscountDisplayable: true,
          groupDiscountStatus: 'ON_SALE',
          groupDiscountedPrice: 16900,
          groupDiscountWillClosed: false,
          groupDiscountUserCount: 693,
          groupDiscountStartAt: 1683360000000,
          groupDiscountEndAt: 1683644399000,
          alarmDisplaying: false,
          groupDiscountRemainSeconds: 198597,
          storeId: 1634,
          storeName: '헨켈온라인공식몰',
          storeDomain: 'henkel',
          storeProfileImage: 'https://st.kakaocdn.net/thumb/B350x350cw/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fstore%2F20180608105211_d2911174025541ae8dffd07245b7f3c1.jpeg',
          new: false,
          linkPath: '/detail/?productId=68626964',
          storeLinkPath: '/henkel?area=mainp',
          plusFriendSubscriberExclusive: false,
          farmer: false,
          deliveryFeeType: 'FREE',
          freeDelivery: true,
          reviewCount: 1890,
          productPositivePercentage: 98,
          imageRatio: 'SQUARE',
          displayedSaleStatus: 'ON_SALE',
          categoryId: '104103103101',
          categoryName: '섬유유연제',
          hasAdditionalOptionPrice: true,
          groupDiscountPeriod: { from: '20230506170000', to: '20230509235959' },
          profiles: [
            'https://st.kakaocdn.net/shoppingstore/random/profile_234.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_361.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_353.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_485.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_285.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_417.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_81.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_357.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_63.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_145.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_65.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_405.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_135.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_237.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_4.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_118.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_410.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_283.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_156.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_288.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_113.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_232.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_398.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_74.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_71.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_208.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_416.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_429.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_505.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_438.png',
          ],
          totalSaleCount: 25200,
          trackId: '7247716872349566931',
          contentId: 1469,
          contentDisplayPeriod: { from: '20230506170000', to: '20230509235959' },
          type: 'BIG_CARD',
          landingUrl: 'https://store.kakao.com/henkel/products/68626964?_=1683445801258&area=mainp',
          mainCopy: '헨켈 고농축 섬유유연제 버넬 0.9L 6개+퍼실 증정',
          label: '',
          imageUrl:
            'https://st.kakaocdn.net/thumb/C750x422.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fhome%2Fgroup_discount_product%2F20230503140122_ce4908bacb4d4a84a9b951af5866d3cc.png',
          imageUrlOrigin: 'https://st.kakaocdn.net/shoppingstore/home/group_discount_product/20230503140122_ce4908bacb4d4a84a9b951af5866d3cc.png',
          sharingImageUrl:
            'https://st.kakaocdn.net/thumb/C750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230427144204_ac2dd3c737b940f291b0065d98e89d6a.jpg&mode=watermark&wm_param1=image&wm_id=talkdeal',
          logoImageUrl: '',
          contentRemainDays: 2,
          remainDays: 2,
          contentOpenDt: '20230506',
          contentCloseDt: '20230509',
          likeProductCount: 2008,
          isLiked: false,
          score: 1.17117e7,
        },
        {
          productId: 56992838,
          productName: '[사은품증정 EVENT] "동안피부비결" 이탈리아산 저분자 피쉬콜라겐 1통 90포 3개월분',
          productImage: 'https://st.kakaocdn.net/thumb/C375x375.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230503153945_f1ae09f97809426b91bcc7efc3a721c7.jpg',
          productImageOrigin: 'https://st.kakaocdn.net/shoppingstore/product/20230503153945_f1ae09f97809426b91bcc7efc3a721c7.jpg',
          originalPrice: 37000,
          discountedPrice: 37000,
          discountRate: 0,
          groupDiscountDisplayable: true,
          groupDiscountStatus: 'ON_SALE',
          groupDiscountedPrice: 16600,
          groupDiscountWillClosed: false,
          groupDiscountUserCount: 658,
          groupDiscountStartAt: 1683360000000,
          groupDiscountEndAt: 1683644399000,
          alarmDisplaying: false,
          groupDiscountRemainSeconds: 198597,
          storeId: 24251,
          storeName: '메디트리 공식스토어',
          storeDomain: 'meditreestore',
          storeProfileImage: 'https://st.kakaocdn.net/thumb/B350x350cw/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fstore%2F20210818133516_a533c7d96a154236a6771613e501fa83.jpg',
          new: false,
          linkPath: '/detail/?productId=56992838',
          storeLinkPath: '/meditreestore?area=mainp',
          plusFriendSubscriberExclusive: false,
          farmer: false,
          deliveryFeeType: 'FREE',
          freeDelivery: true,
          reviewCount: 606,
          productPositivePercentage: 100,
          imageRatio: 'SQUARE',
          displayedSaleStatus: 'ON_SALE',
          categoryId: '102105105101',
          categoryName: '콜라겐/코큐텐',
          hasAdditionalOptionPrice: true,
          groupDiscountPeriod: { from: '20230506170000', to: '20230509235959' },
          profiles: [
            'https://st.kakaocdn.net/shoppingstore/random/profile_420.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_294.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_115.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_26.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_217.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_110.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_549.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_340.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_513.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_48.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_463.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_174.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_30.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_440.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_179.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_537.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_507.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_538.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_266.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_461.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_71.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_243.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_434.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_429.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_79.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_388.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_421.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_384.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_306.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_239.png',
          ],
          totalSaleCount: 3978,
          trackId: '7782782849913303346',
          contentId: 1469,
          contentDisplayPeriod: { from: '20230506170000', to: '20230509235959' },
          type: 'BIG_CARD',
          landingUrl: 'https://store.kakao.com/meditreestore/products/56992838?_=1683445801260&area=mainp',
          mainCopy: '메디트리 저분자 피쉬콜라겐 3개월분+비타C젤리 증정',
          label: '',
          imageUrl:
            'https://st.kakaocdn.net/thumb/C750x422.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fhome%2Fgroup_discount_product%2F20230503140439_632eab26bb3e4f759ddd0ccc1db34f3f.png',
          imageUrlOrigin: 'https://st.kakaocdn.net/shoppingstore/home/group_discount_product/20230503140439_632eab26bb3e4f759ddd0ccc1db34f3f.png',
          sharingImageUrl:
            'https://st.kakaocdn.net/thumb/C750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230503153945_f1ae09f97809426b91bcc7efc3a721c7.jpg&mode=watermark&wm_param1=image&wm_id=talkdeal',
          logoImageUrl: '',
          contentRemainDays: 2,
          remainDays: 2,
          contentOpenDt: '20230506',
          contentCloseDt: '20230509',
          likeProductCount: 957,
          isLiked: false,
          score: 1.09228e7,
        },
        {
          productId: 237319333,
          productName: '구~수한 청국장 150g x 4팩 무료배송 국내산 100% 전통식품인증 /AR',
          productImage: 'https://st.kakaocdn.net/thumb/C375x375.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230327115215_322815ce44ee4591b25012a2c43faddd.jpg',
          productImageOrigin: 'https://st.kakaocdn.net/shoppingstore/product/20230327115215_322815ce44ee4591b25012a2c43faddd.jpg',
          originalPrice: 15000,
          discountedPrice: 15000,
          discountRate: 0,
          groupDiscountDisplayable: true,
          groupDiscountStatus: 'ON_SALE',
          groupDiscountedPrice: 9500,
          groupDiscountWillClosed: false,
          groupDiscountUserCount: 1129,
          groupDiscountStartAt: 1683360000000,
          groupDiscountEndAt: 1683644399000,
          alarmDisplaying: false,
          groupDiscountRemainSeconds: 198597,
          storeId: 65639,
          storeName: '더싱싱몰',
          storeDomain: 'thesingsingmall',
          storeProfileImage: 'https://st.kakaocdn.net/thumb/B350x350cw/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fstore%2F20221220105751_e1fa8df8ef8d484882a0ce41ca96c55c.png',
          new: false,
          linkPath: '/detail/?productId=237319333',
          storeLinkPath: '/thesingsingmall?area=mainp',
          plusFriendSubscriberExclusive: false,
          farmer: true,
          deliveryFeeType: 'FREE',
          freeDelivery: true,
          reviewCount: 10,
          productPositivePercentage: 100,
          imageRatio: 'SQUARE',
          displayedSaleStatus: 'ON_SALE',
          categoryId: '102100103106',
          categoryName: '청국장',
          hasAdditionalOptionPrice: false,
          groupDiscountPeriod: { from: '20230506170000', to: '20230509235959' },
          profiles: [
            'https://st.kakaocdn.net/shoppingstore/random/profile_468.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_493.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_366.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_42.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_167.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_522.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_370.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_411.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_144.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_22.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_114.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_402.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_101.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_59.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_300.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_334.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_105.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_283.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_317.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_45.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_431.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_229.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_143.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_199.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_367.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_112.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_375.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_116.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_189.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_23.png',
          ],
          totalSaleCount: 1399,
          trackId: '',
          contentId: 1469,
          contentDisplayPeriod: { from: '20230506170000', to: '20230509235959' },
          type: 'BIG_CARD',
          landingUrl: 'https://store.kakao.com/thesingsingmall/products/237319333?_=1683445801259&area=mainp',
          mainCopy: '100% 국내산 청국장 150g 4팩, 전통식품 인증',
          label: '',
          imageUrl:
            'https://st.kakaocdn.net/thumb/C750x422.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fhome%2Fgroup_discount_product%2F20230503140245_a3d0af4aa80d428192c568843aa907ee.png',
          imageUrlOrigin: 'https://st.kakaocdn.net/shoppingstore/home/group_discount_product/20230503140245_a3d0af4aa80d428192c568843aa907ee.png',
          sharingImageUrl:
            'https://st.kakaocdn.net/thumb/C750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230327115215_322815ce44ee4591b25012a2c43faddd.jpg&mode=watermark&wm_param1=image&wm_id=talkdeal',
          logoImageUrl: '',
          contentRemainDays: 2,
          remainDays: 2,
          contentOpenDt: '20230506',
          contentCloseDt: '20230509',
          likeProductCount: 479,
          isLiked: false,
          score: 1.07255e7,
        },
        {
          productId: 53209039,
          productName: '[EPA+DHA 1,000mg/1일] GNM rTG 알티지오메가3 60캡슐 2박스/비타민E',
          productImage: 'https://st.kakaocdn.net/thumb/C375x375.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230202131209_904b492441844cfb8db1e7eaa323ae0c.jpg',
          productImageOrigin: 'https://st.kakaocdn.net/shoppingstore/product/20230202131209_904b492441844cfb8db1e7eaa323ae0c.jpg',
          originalPrice: 26900,
          discountedPrice: 26900,
          discountRate: 0,
          groupDiscountDisplayable: true,
          groupDiscountStatus: 'ON_SALE',
          groupDiscountedPrice: 18900,
          groupDiscountWillClosed: false,
          groupDiscountUserCount: 563,
          groupDiscountStartAt: 1683360000000,
          groupDiscountEndAt: 1683644399000,
          alarmDisplaying: false,
          groupDiscountRemainSeconds: 198597,
          storeId: 2310,
          storeName: 'GNM자연의품격',
          storeDomain: 'gnmlife',
          storeProfileImage: 'https://st.kakaocdn.net/thumb/B350x350cw/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fstore%2F20230201112144_b50c843620714ac3924102cd5bb2ef0d.jpg',
          new: false,
          linkPath: '/detail/?productId=53209039',
          storeLinkPath: '/gnmlife?area=mainp',
          plusFriendSubscriberExclusive: false,
          farmer: false,
          deliveryFeeType: 'FREE',
          freeDelivery: true,
          reviewCount: 1115,
          productPositivePercentage: 99,
          imageRatio: 'SQUARE',
          displayedSaleStatus: 'ON_SALE',
          categoryId: '102105105100',
          categoryName: '오메가3/스쿠알렌',
          hasAdditionalOptionPrice: true,
          groupDiscountPeriod: { from: '20230506170000', to: '20230509235959' },
          profiles: [
            'https://st.kakaocdn.net/shoppingstore/random/profile_218.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_13.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_454.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_268.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_136.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_530.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_515.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_52.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_29.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_507.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_250.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_121.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_270.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_363.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_9.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_147.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_465.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_44.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_316.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_266.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_346.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_119.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_252.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_337.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_125.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_523.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_129.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_248.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_341.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_477.png',
          ],
          totalSaleCount: 16382,
          trackId: '143797823758159857',
          contentId: 1469,
          contentDisplayPeriod: { from: '20230506170000', to: '20230509235959' },
          type: 'BIG_CARD',
          landingUrl: 'https://store.kakao.com/gnmlife/products/53209039?_=1683445801260&area=mainp',
          mainCopy: 'GNM 알티지 오메가3 식물성캡슐 60정 2박스',
          label: '',
          imageUrl:
            'https://st.kakaocdn.net/thumb/C750x422.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fhome%2Fgroup_discount_product%2F20230503140446_974f09c4704a40988ba9bc9f86e8a3bb.png',
          imageUrlOrigin: 'https://st.kakaocdn.net/shoppingstore/home/group_discount_product/20230503140446_974f09c4704a40988ba9bc9f86e8a3bb.png',
          sharingImageUrl:
            'https://st.kakaocdn.net/thumb/C750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230202131209_904b492441844cfb8db1e7eaa323ae0c.jpg&mode=watermark&wm_param1=image&wm_id=talkdeal',
          logoImageUrl: '',
          contentRemainDays: 2,
          remainDays: 2,
          contentOpenDt: '20230506',
          contentCloseDt: '20230509',
          likeProductCount: 1306,
          isLiked: false,
          score: 1.06407e7,
        },
        {
          productId: 247834660,
          productName: '성주 정품 못난이 꿀참외 3kg 5kg',
          productImage: 'https://st.kakaocdn.net/thumb/C375x375.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230404102418_e19e69467678468b8c042bb7c28c77cd.jpg',
          productImageOrigin: 'https://st.kakaocdn.net/shoppingstore/product/20230404102418_e19e69467678468b8c042bb7c28c77cd.jpg',
          originalPrice: 36900,
          discountedPrice: 36900,
          discountRate: 0,
          groupDiscountDisplayable: true,
          groupDiscountStatus: 'ON_SALE',
          groupDiscountedPrice: 17900,
          groupDiscountWillClosed: false,
          groupDiscountUserCount: 591,
          groupDiscountStartAt: 1683417600000,
          groupDiscountEndAt: 1683730799000,
          alarmDisplaying: false,
          groupDiscountRemainSeconds: 284997,
          storeId: 67458,
          storeName: '한경어게인',
          storeDomain: 'hankyeong',
          storeProfileImage: 'https://st.kakaocdn.net/thumb/B350x350cw/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fstore%2F20210415132701_e4c2a1966d84401893077cb9ea5737e1.jpeg',
          new: false,
          linkPath: '/detail/?productId=247834660',
          storeLinkPath: '/hankyeong?area=mainp',
          plusFriendSubscriberExclusive: false,
          farmer: false,
          deliveryFeeType: 'FREE',
          freeDelivery: true,
          productPositivePercentage: 100,
          imageRatio: 'SQUARE',
          displayedSaleStatus: 'ON_SALE',
          categoryId: '102104103105100',
          categoryName: '참외',
          hasAdditionalOptionPrice: true,
          groupDiscountPeriod: { from: '20230507090000', to: '20230510235959' },
          profiles: [
            'https://st.kakaocdn.net/shoppingstore/random/profile_420.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_162.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_115.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_217.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_55.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_409.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_197.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_344.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_551.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_445.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_219.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_497.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_259.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_326.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_479.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_399.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_60.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_474.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_533.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_406.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_338.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_394.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_376.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_491.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_309.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_367.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_150.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_19.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_142.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_393.png',
          ],
          totalSaleCount: 623,
          trackId: '',
          contentId: 1469,
          contentDisplayPeriod: { from: '20230506170000', to: '20230509235959' },
          type: 'BIG_CARD',
          landingUrl: 'https://store.kakao.com/hankyeong/products/247834660?_=1683445801262&area=mainp',
          mainCopy: '성주 못난이 꿀참외 5kg. 아삭아삭 달달한 과육',
          label: '',
          imageUrl:
            'https://st.kakaocdn.net/thumb/C750x422.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fhome%2Fgroup_discount_product%2F20230507093138_c70272f5d72f49df803eb575c14914e9.png',
          imageUrlOrigin: 'https://st.kakaocdn.net/shoppingstore/home/group_discount_product/20230507093138_c70272f5d72f49df803eb575c14914e9.png',
          sharingImageUrl:
            'https://st.kakaocdn.net/thumb/C750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230404102418_e19e69467678468b8c042bb7c28c77cd.jpg&mode=watermark&wm_param1=image&wm_id=talkdeal',
          logoImageUrl: '',
          contentRemainDays: 2,
          remainDays: 3,
          contentOpenDt: '20230506',
          contentCloseDt: '20230509',
          likeProductCount: 83,
          isLiked: false,
          score: 1.05789e7,
        },
        {
          productId: 64498390,
          productName: '[지프] 무료배송 (공용) 인기상품  18종택1',
          productImage: 'https://st.kakaocdn.net/thumb/C375x375.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230503143644_2f143599dc6145e28657214e0ff92268.png',
          productImageOrigin: 'https://st.kakaocdn.net/shoppingstore/product/20230503143644_2f143599dc6145e28657214e0ff92268.png',
          originalPrice: 35000,
          discountedPrice: 35000,
          discountRate: 0,
          groupDiscountDisplayable: true,
          groupDiscountStatus: 'ON_SALE',
          groupDiscountedPrice: 18700,
          groupDiscountWillClosed: false,
          groupDiscountUserCount: 550,
          groupDiscountStartAt: 1683360000000,
          groupDiscountEndAt: 1683644399000,
          alarmDisplaying: false,
          groupDiscountRemainSeconds: 198597,
          storeId: 35979,
          storeName: '현대백화점 판교점',
          storeDomain: 'hdpangyo',
          storeProfileImage: 'https://st.kakaocdn.net/thumb/B350x350cw/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fstore%2F20200616115712_a14275635cb04f32a8ee2d1e6dad879f.jpg',
          new: false,
          linkPath: '/detail/?productId=64498390',
          storeLinkPath: '/hdpangyo?area=mainp',
          plusFriendSubscriberExclusive: false,
          farmer: false,
          deliveryFeeType: 'FREE',
          freeDelivery: true,
          reviewCount: 1326,
          productPositivePercentage: 96,
          imageRatio: 'SQUARE',
          displayedSaleStatus: 'ON_SALE',
          categoryId: '101104101100',
          categoryName: '남성 라운드넥 티셔츠',
          hasAdditionalOptionPrice: true,
          groupDiscountPeriod: { from: '20230506170000', to: '20230509235959' },
          profiles: [
            'https://st.kakaocdn.net/shoppingstore/random/profile_403.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_17.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_115.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_192.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_379.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_69.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_489.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_340.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_141.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_63.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_158.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_145.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_534.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_360.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_59.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_492.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_127.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_122.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_330.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_431.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_270.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_206.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_262.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_550.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_275.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_222.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_7.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_244.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_434.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_447.png',
          ],
          totalSaleCount: 28246,
          trackId: '',
          contentId: 1469,
          contentDisplayPeriod: { from: '20230506170000', to: '20230509235959' },
          type: 'BIG_CARD',
          landingUrl: 'https://store.kakao.com/hdpangyo/products/64498390?_=1683445801260&area=mainp',
          mainCopy: '지프 남녀공용 인기 캐주얼 의류 18종 스타일',
          label: '앵콜톡딜',
          imageUrl:
            'https://st.kakaocdn.net/thumb/C750x422.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fhome%2Fgroup_discount_product%2F20230503140501_85abfaa530f54c28b9f209028dbbb5fc.png',
          imageUrlOrigin: 'https://st.kakaocdn.net/shoppingstore/home/group_discount_product/20230503140501_85abfaa530f54c28b9f209028dbbb5fc.png',
          sharingImageUrl:
            'https://st.kakaocdn.net/thumb/C750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230503143644_2f143599dc6145e28657214e0ff92268.png&mode=watermark&wm_param1=image&wm_id=talkdeal',
          logoImageUrl: '',
          contentRemainDays: 2,
          remainDays: 2,
          contentOpenDt: '20230506',
          contentCloseDt: '20230509',
          likeProductCount: 4565,
          isLiked: false,
          score: 1.0285e7,
        },
        {
          productId: 24832184,
          productName: '[여름철 필수템]쉬크 인튜이션 기획팩 (제모기+날4입) + 프리미엄 눈썹칼 4개 외',
          productImage: 'https://st.kakaocdn.net/thumb/C375x375.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230426163721_d244541209b946f79176190af94b5f79.jpg',
          productImageOrigin: 'https://st.kakaocdn.net/shoppingstore/product/20230426163721_d244541209b946f79176190af94b5f79.jpg',
          originalPrice: 29900,
          discountedPrice: 29900,
          discountRate: 0,
          groupDiscountDisplayable: true,
          groupDiscountStatus: 'ON_SALE',
          groupDiscountedPrice: 16900,
          groupDiscountWillClosed: false,
          groupDiscountUserCount: 608,
          groupDiscountStartAt: 1683360000000,
          groupDiscountEndAt: 1683644399000,
          alarmDisplaying: false,
          groupDiscountRemainSeconds: 198597,
          storeId: 2530,
          storeName: 'LG생활건강',
          storeDomain: 'lgcare',
          storeProfileImage: 'https://st.kakaocdn.net/thumb/B350x350cw/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fstore%2F20180906172400_1455a346d67045d2a8e82e1b71145b1b.jpeg',
          new: false,
          linkPath: '/detail/?productId=24832184',
          storeLinkPath: '/lgcare?area=mainp',
          plusFriendSubscriberExclusive: false,
          farmer: false,
          deliveryFeeType: 'FREE',
          freeDelivery: true,
          imageRatio: 'SQUARE',
          displayedSaleStatus: 'ON_SALE',
          categoryId: '101103100104',
          categoryName: '제모제',
          hasAdditionalOptionPrice: true,
          groupDiscountPeriod: { from: '20230506170000', to: '20230509235959' },
          profiles: [
            'https://st.kakaocdn.net/shoppingstore/random/profile_468.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_247.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_217.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_94.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_218.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_476.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_158.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_277.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_20.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_475.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_360.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_528.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_59.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_348.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_440.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_191.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_183.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_224.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_368.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_461.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_303.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_74.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_481.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_456.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_540.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_451.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_150.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_243.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_464.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_36.png',
          ],
          totalSaleCount: 676,
          trackId: '568260606456383071',
          contentId: 1469,
          contentDisplayPeriod: { from: '20230506170000', to: '20230509235959' },
          type: 'BIG_CARD',
          landingUrl: 'https://store.kakao.com/lgcare/products/24832184?_=1683445801261&area=mainp',
          mainCopy: '쉬크 인튜이션 제모기+날 4입+눈썹칼 4개 증정',
          label: '',
          imageUrl:
            'https://st.kakaocdn.net/thumb/C750x422.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fhome%2Fgroup_discount_product%2F20230503140549_94e95d2553be49f88f28fa08d9579ae0.png',
          imageUrlOrigin: 'https://st.kakaocdn.net/shoppingstore/home/group_discount_product/20230503140549_94e95d2553be49f88f28fa08d9579ae0.png',
          sharingImageUrl:
            'https://st.kakaocdn.net/thumb/C750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230426163721_d244541209b946f79176190af94b5f79.jpg&mode=watermark&wm_param1=image&wm_id=talkdeal',
          logoImageUrl: '',
          contentRemainDays: 2,
          remainDays: 2,
          contentOpenDt: '20230506',
          contentCloseDt: '20230509',
          likeProductCount: 664,
          isLiked: false,
          score: 1.02752e7,
        },
        {
          productId: 164308681,
          productName: '오리온 인기스낵 4+3+3 포카칩,스윙칩,눈을감자,무뚝뚝',
          productImage: 'https://st.kakaocdn.net/thumb/C375x375.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230502144610_adb744ff5cb449af9422c905dca1931a.jpg',
          productImageOrigin: 'https://st.kakaocdn.net/shoppingstore/product/20230502144610_adb744ff5cb449af9422c905dca1931a.jpg',
          originalPrice: 15000,
          discountedPrice: 15000,
          discountRate: 0,
          groupDiscountDisplayable: true,
          groupDiscountStatus: 'ON_SALE',
          groupDiscountedPrice: 10000,
          groupDiscountWillClosed: false,
          groupDiscountUserCount: 952,
          groupDiscountStartAt: 1683360000000,
          groupDiscountEndAt: 1683644399000,
          alarmDisplaying: false,
          groupDiscountRemainSeconds: 198597,
          storeId: 15894,
          storeName: '오리온공식판매점',
          storeDomain: 'orionstore',
          storeProfileImage: 'https://st.kakaocdn.net/thumb/B350x350cw/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fstore%2F20230302165639_3039f3be72884378b2bbe2c413e295ae.jpg',
          new: false,
          linkPath: '/detail/?productId=164308681',
          storeLinkPath: '/orionstore?area=mainp',
          plusFriendSubscriberExclusive: false,
          farmer: false,
          deliveryFeeType: 'FREE',
          freeDelivery: true,
          reviewCount: 1411,
          productPositivePercentage: 99,
          imageRatio: 'SQUARE',
          displayedSaleStatus: 'ON_SALE',
          categoryId: '102109100',
          categoryName: '과자/쿠키',
          hasAdditionalOptionPrice: true,
          groupDiscountPeriod: { from: '20230506170000', to: '20230509235959' },
          profiles: [
            'https://st.kakaocdn.net/shoppingstore/random/profile_468.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_17.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_500.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_63.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_188.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_450.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_246.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_203.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_289.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_29.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_322.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_284.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_378.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_471.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_148.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_462.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_210.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_508.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_253.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_181.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_9.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_67.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_303.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_367.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_523.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_416.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_213.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_2.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_464.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_88.png',
          ],
          totalSaleCount: 25835,
          trackId: '',
          contentId: 1469,
          contentDisplayPeriod: { from: '20230506170000', to: '20230509235959' },
          type: 'BIG_CARD',
          landingUrl: 'https://store.kakao.com/orionstore/products/164308681?_=1683445801259&area=mainp',
          mainCopy: '오리온 인기스낵 10개 골라담기! 오땅/스윙칩 외',
          label: '앵콜톡딜',
          imageUrl:
            'https://st.kakaocdn.net/thumb/C750x422.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fhome%2Fgroup_discount_product%2F20230503140314_a1bbb993e1514e9d807c7288b0ba7100.png',
          imageUrlOrigin: 'https://st.kakaocdn.net/shoppingstore/home/group_discount_product/20230503140314_a1bbb993e1514e9d807c7288b0ba7100.png',
          sharingImageUrl:
            'https://st.kakaocdn.net/thumb/C750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230502144610_adb744ff5cb449af9422c905dca1931a.jpg&mode=watermark&wm_param1=image&wm_id=talkdeal',
          logoImageUrl: '',
          contentRemainDays: 2,
          remainDays: 2,
          contentOpenDt: '20230506',
          contentCloseDt: '20230509',
          likeProductCount: 4092,
          isLiked: false,
          score: 9520000.0,
        },
        {
          productId: 227497376,
          productName: '[코코블랑] 23 여름신상 반팔니트 9900원 외 100종 최대할인',
          productImage: 'https://st.kakaocdn.net/thumb/C375x375.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230503154913_4d9c5a4dda024f7a92c71168866f788b.jpg',
          productImageOrigin: 'https://st.kakaocdn.net/shoppingstore/product/20230503154913_4d9c5a4dda024f7a92c71168866f788b.jpg',
          originalPrice: 49900,
          discountedPrice: 49900,
          discountRate: 0,
          groupDiscountDisplayable: true,
          groupDiscountStatus: 'ON_SALE',
          groupDiscountedPrice: 9900,
          groupDiscountWillClosed: false,
          groupDiscountUserCount: 958,
          groupDiscountStartAt: 1683360000000,
          groupDiscountEndAt: 1683644399000,
          alarmDisplaying: false,
          groupDiscountRemainSeconds: 198597,
          storeId: 62459,
          storeName: '코코블랑',
          storeDomain: 'cocoblanc',
          storeProfileImage: 'https://st.kakaocdn.net/thumb/B350x350cw/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fstore%2F20221219133214_ba607a89cb2a4aedadb13d74678325a3.jpg',
          new: false,
          linkPath: '/detail/?productId=227497376',
          storeLinkPath: '/cocoblanc?area=mainp',
          plusFriendSubscriberExclusive: false,
          farmer: false,
          deliveryFeeType: 'FREE',
          freeDelivery: true,
          imageRatio: 'SQUARE',
          displayedSaleStatus: 'ON_SALE',
          categoryId: '101102102104',
          categoryName: '여성 브이넥 니트',
          hasAdditionalOptionPrice: true,
          groupDiscountPeriod: { from: '20230506170000', to: '20230509235959' },
          profiles: [
            'https://st.kakaocdn.net/shoppingstore/random/profile_102.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_328.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_192.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_442.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_55.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_357.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_370.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_327.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_500.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_305.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_515.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_90.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_86.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_334.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_47.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_183.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_342.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_487.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_181.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_350.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_28.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_236.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_31.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_266.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_190.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_248.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_371.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_133.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_198.png',
            'https://st.kakaocdn.net/shoppingstore/random/profile_36.png',
          ],
          totalSaleCount: 2443,
          trackId: '',
          contentId: 1469,
          contentDisplayPeriod: { from: '20230506170000', to: '20230509235959' },
          type: 'BIG_CARD',
          landingUrl: 'https://store.kakao.com/cocoblanc/products/227497376?_=1683445801261&area=mainp',
          mainCopy: '코코블랑 브이넥 반팔 니트 외 데일리룩 99종 스타일',
          label: '',
          imageUrl:
            'https://st.kakaocdn.net/thumb/C750x422.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fhome%2Fgroup_discount_product%2F20230503140516_0260e927c462473bbb40491d5b5c97b0.png',
          imageUrlOrigin: 'https://st.kakaocdn.net/shoppingstore/home/group_discount_product/20230503140516_0260e927c462473bbb40491d5b5c97b0.png',
          sharingImageUrl:
            'https://st.kakaocdn.net/thumb/C750x750/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fproduct%2F20230503154913_4d9c5a4dda024f7a92c71168866f788b.jpg&mode=watermark&wm_param1=image&wm_id=talkdeal',
          logoImageUrl: '',
          contentRemainDays: 2,
          remainDays: 2,
          contentOpenDt: '20230506',
          contentCloseDt: '20230509',
          likeProductCount: 792,
          isLiked: false,
          score: 9484200.0,
        },
      ],
    ],
  },
};
// 추천 쇼핑몰{recommendStores}/ 후기증명 BEst 톡딜/광고상품{SpecialCard}
const specialCard = {
  id: 9580,
  name: '6/1 가공_허닭',
  firstImageUrl: 'https://st.kakaocdn.net/thumb/C750x422.fjpg/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fhome%2Fspecial_card%2F20230531094602_480d01ef49dd4fc19f75a113e4a10a65.png',
  landingType: 'URL',
  landingUrl: '/detail/?productId=67210447',
  specialCardTitle: '가공식품 왕중왕전',
  specialCardDescription: '촉촉하고 깔끔한 맛!\n허닭 닭가슴살 21종 세트',
  specialCardSlot1: '21900',
  specialCardSlot2: '43800',
  specialCardPrimaryColor: '#FFF59E',
  specialCardSecondaryColor: '#FFFFFF',
  specialCardBackgroundColor: '#6B392B',
  remainSeconds: 2102,
  copyColor: 'false',
  copyExpose: true,
  ad: false,
  displayPeriod: { from: '20230601170000', to: '20230602165959' },
};

const recommedStores = {
  data: [
    {
      id: 945,
      name: '동원공식샵',
      imageUrl: 'https://st.kakaocdn.net/thumb/C400x400/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fstore%2F20180523163324_175ca45a846143cc92f266072df05781.jpg',
      landingUrl: 'https://store.kakao.com/dongwonfnb?area=sbsb',
    },
    {
      id: 2385,
      name: '코지마 안마의자',
      imageUrl: 'https://st.kakaocdn.net/thumb/C400x400/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fstore%2F20180823130402_50fab33ea115419194ea94727258395b.jpeg',
      landingUrl: 'https://store.kakao.com/cozyma?area=sbsb',
    },
    {
      id: 200,
      name: '원더브라',
      imageUrl: 'https://st.kakaocdn.net/thumb/C400x400/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fstore%2F20171120132348_11ab035dad93460b88a359870997eda1.jpg',
      landingUrl: 'https://store.kakao.com/wonderbra?area=sbsb',
    },
    {
      id: 623,
      name: '종근당건강',
      imageUrl: 'https://st.kakaocdn.net/thumb/C400x400/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fstore%2F20180221172351_2d21981933cf42259bf970fce3322eb4.jpeg',
      landingUrl: 'https://store.kakao.com/ckdhc?area=sbsb',
    },
    {
      id: 110932,
      name: '브람스안마의자',
      imageUrl: 'https://st.kakaocdn.net/thumb/C400x400/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fstore%2F20230126141000_51442db11a9b40daabd366d59c3f73e2.png',
      landingUrl: 'https://store.kakao.com/brams?area=sbsb',
    },
    {
      id: 2530,
      name: 'LG생활건강',
      imageUrl: 'https://st.kakaocdn.net/thumb/C400x400/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fstore%2F20180906172400_1455a346d67045d2a8e82e1b71145b1b.jpeg',
      landingUrl: 'https://store.kakao.com/lgcare?area=sbsb',
    },
    {
      id: 911,
      name: '롯데웰푸드 공식 스토어',
      imageUrl: 'https://st.kakaocdn.net/thumb/C400x400/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fstore%2F20230404142601_36bd4bc66a614952b27b599408ee53f0.jpg',
      landingUrl: 'https://store.kakao.com/dithings?area=sbsb',
    },
    {
      id: 69700,
      name: '프로티원',
      imageUrl: 'https://st.kakaocdn.net/thumb/C400x400/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fstore%2F20210512122529_1b06544f031f4cd2ad142bc4c678a200.jpeg',
      landingUrl: 'https://store.kakao.com/proteeone?area=sbsb',
    },
    {
      id: 65151,
      name: '고려은단헬스케어',
      imageUrl: 'https://st.kakaocdn.net/thumb/C400x400/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fstore%2F20210805181001_aefe748e7cd747b0890284329d5763b6.jpg',
      landingUrl: 'https://store.kakao.com/eundanhc?area=sbsb',
    },
    {
      id: 81394,
      name: 'The미식',
      imageUrl: 'https://st.kakaocdn.net/thumb/C400x400/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fstore%2F20211015105138_b074b3b328e14482b243d972567bd189.png',
      landingUrl: 'https://store.kakao.com/themishik?area=sbsb',
    },
  ],
};
const reviewBestTalkeDeals = {
  data: [
    {
      productId: 65276142,
      productName: '한우물 구운주먹밥 15개. 참치마요/소불고기/닭갈비 외',
      productImage: 'https://st.kakaocdn.net/shoppingstore/product/20220303141657_8be2d1c209124d849c70e0625a48e3d7.jpg',
      productImageOrigin: 'https://st.kakaocdn.net/shoppingstore/product/20220303141657_8be2d1c209124d849c70e0625a48e3d7.jpg',
      originalPrice: 24900,
      discountedPrice: 16900,
      discountRate: 32,
      alarmDisplaying: false,
      storeId: 1872,
      storeName: '치타마켓',
      storeDomain: 'cheeta',
      storeProfileImage: 'https://st.kakaocdn.net/thumb/B350x350cw/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fstore%2F20210601133902_85c7e037a67f4d8b9bdb0f371c77d02f.jpg',
      new: false,
      linkPath: '/cheeta/products/65276142?_=1682919001447&area=gdtr',
      storeLinkPath: '/cheeta?area=gdtr',
      plusFriendSubscriberExclusive: false,
      farmer: false,
      deliveryFeeType: 'FREE',
      freeDelivery: true,
      reviewCount: 8935,
      productPositivePercentage: 96,
      reviewContent:
        '주먹밥이 거기서 거기일꺼라고 기대안하고 주문했는데 우선 치즈가 정말 두껍게 많이 들어가 있어서 놀랬어요 내용물에 씹는맛이 느껴질정도로 잘 다져넣었다고 느껴지고요 편의점 삼각김밥의 밥은 심심하고 내용물은 자극적인 그런 맛이 아닌 발란스가 너무 잘맞은 맛이였습니다 또구매의사 100% 있습니다 ^^',
      imageRatio: 'SQUARE',
      displayedSaleStatus: 'ON_SALE',
      categoryId: '102100110100',
      categoryName: '즉석밥',
      hasAdditionalOptionPrice: false,
      profiles: [],
      totalSaleCount: 118323,
      trackId: '5870414469548560227',
      userCount: 5411,
      alarm: false,
    },
    {
      productId: 224152000,
      productName: '강강술래 홈채움 양념 LA갈비 1kg. 정갈한 풍미',
      productImage: 'https://st.kakaocdn.net/shoppingstore/product/20230302132916_75c07a03a1354067ad64bd550eada5ce.jpg',
      productImageOrigin: 'https://st.kakaocdn.net/shoppingstore/product/20230302132916_75c07a03a1354067ad64bd550eada5ce.jpg',
      originalPrice: 84000,
      discountedPrice: 84000,
      discountRate: 0,
      alarmDisplaying: false,
      storeId: 41930,
      storeName: '강강술래',
      storeDomain: 'sullaimall',
      storeProfileImage: 'https://st.kakaocdn.net/thumb/B350x350cw/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fstore%2F20200707132941_227bbf50623844608d4ee56c89018694.jpg',
      new: false,
      linkPath: '/sullaimall/products/224152000?_=1682919001447&area=gdtr',
      storeLinkPath: '/sullaimall?area=gdtr',
      plusFriendSubscriberExclusive: false,
      farmer: false,
      deliveryFeeType: 'FREE',
      freeDelivery: true,
      reviewCount: 506,
      productPositivePercentage: 84,
      reviewContent: '너무맛있어요~가족들과 맛있게 먹었네요!',
      imageRatio: 'SQUARE',
      displayedSaleStatus: 'ON_SALE',
      categoryId: '102100124102',
      categoryName: '족발/편육/바비큐',
      hasAdditionalOptionPrice: true,
      profiles: [],
      totalSaleCount: 10757,
      trackId: '',
      userCount: 6002,
      alarm: false,
    },
    {
      productId: 227445595,
      productName: '드리미 올인원 로봇청소기. 강한 흡입력, 압력 물걸레질',
      productImage: 'https://st.kakaocdn.net/shoppingstore/product/20230419132002_fe7e0c322fe94293ae3a8a321cfd0f05.png',
      productImageOrigin: 'https://st.kakaocdn.net/shoppingstore/product/20230419132002_fe7e0c322fe94293ae3a8a321cfd0f05.png',
      originalPrice: 1599000,
      discountedPrice: 1599000,
      discountRate: 0,
      alarmDisplaying: false,
      storeId: 112183,
      storeName: 'Dreame',
      storeDomain: 'dreame',
      storeProfileImage: 'https://st.kakaocdn.net/thumb/B350x350cw/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fstore%2F20230213132314_f52520db302849e4ba3b1a632b2c8256.jpg',
      new: false,
      linkPath: '/dreame/products/227445595?_=1682919001447&area=gdtr',
      storeLinkPath: '/dreame?area=gdtr',
      plusFriendSubscriberExclusive: false,
      farmer: false,
      deliveryFeeType: 'FREE',
      freeDelivery: true,
      reviewCount: 27,
      productPositivePercentage: 100,
      reviewContent: '디자인도 깔끔하고 예뻐서 마음에 들어요:)\n저희집 이모님입니다ㅋㅋ',
      imageRatio: 'SQUARE',
      displayedSaleStatus: 'ON_SALE',
      categoryId: '100103102101',
      categoryName: '로봇청소기',
      hasAdditionalOptionPrice: false,
      profiles: [],
      totalSaleCount: 140,
      stockQuantity: 946,
      trackId: '',
      userCount: 54,
      alarm: false,
    },
    {
      productId: 135379379,
      productName: '벤하임 올클린 스탠드형 스팀 물걸레 청소기',
      productImage: 'https://st.kakaocdn.net/shoppingstore/product/20220715153105_9cb4ce67ca594d5f8dcdda1cb4745121.jpg',
      productImageOrigin: 'https://st.kakaocdn.net/shoppingstore/product/20220715153105_9cb4ce67ca594d5f8dcdda1cb4745121.jpg',
      originalPrice: 99000,
      discountedPrice: 99000,
      discountRate: 0,
      alarmDisplaying: false,
      storeId: 27814,
      storeName: '유니크시티',
      storeDomain: 'uniquecity',
      storeProfileImage: 'https://st.kakaocdn.net/thumb/B350x350cw/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fstore%2F20191024142804_145f3c8b0e2647158e7584086dc6b15e.png',
      new: false,
      linkPath: '/uniquecity/products/135379379?_=1682919001447&area=gdtr',
      storeLinkPath: '/uniquecity?area=gdtr',
      plusFriendSubscriberExclusive: false,
      farmer: false,
      deliveryFeeType: 'FREE',
      freeDelivery: true,
      reviewCount: 2104,
      productPositivePercentage: 95,
      reviewContent: '톡딜가에  너무  잘 샀습니다  사용해보니 맘에 쏙 들ㅈ어서 너무  좋아',
      imageRatio: 'SQUARE',
      displayedSaleStatus: 'ON_SALE',
      categoryId: '100103102100',
      categoryName: '스팀청소기',
      hasAdditionalOptionPrice: false,
      profiles: [],
      totalSaleCount: 30644,
      trackId: '',
      userCount: 4042,
      alarm: false,
    },
    {
      productId: 219911677,
      productName: '빈타이 포타 쌀국수 30팩. 베트남 60년 전통식',
      productImage: 'https://st.kakaocdn.net/shoppingstore/product/20230416120036_47474e55d8354b099d42130d8721d689.jpg',
      productImageOrigin: 'https://st.kakaocdn.net/shoppingstore/product/20230416120036_47474e55d8354b099d42130d8721d689.jpg',
      originalPrice: 33900,
      discountedPrice: 33900,
      discountRate: 0,
      alarmDisplaying: false,
      storeId: 41936,
      storeName: '더싱싱',
      storeDomain: 'thesingsing',
      storeProfileImage: 'https://st.kakaocdn.net/thumb/B350x350cw/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fstore%2F20221220110011_d87c77b652b94a4fa5ba25ea621c54e2.png',
      new: false,
      linkPath: '/thesingsing/products/219911677?_=1682919001447&area=gdtr',
      storeLinkPath: '/thesingsing?area=gdtr',
      plusFriendSubscriberExclusive: false,
      farmer: false,
      deliveryFeeType: 'FREE',
      freeDelivery: true,
      reviewCount: 555,
      productPositivePercentage: 98,
      reviewContent: '국물도 담백하니 좋고 면도 괜찮아요',
      imageRatio: 'SQUARE',
      displayedSaleStatus: 'ON_SALE',
      categoryId: '102100110110',
      categoryName: '간편/즉석요리',
      hasAdditionalOptionPrice: false,
      profiles: [],
      totalSaleCount: 6589,
      trackId: '',
      userCount: 1971,
      alarm: false,
    },
    {
      productId: 213097302,
      productName: '하림 프레쉬업 닭볶음용 600g 4팩 외 닭가슴살/근위',
      productImage: 'https://st.kakaocdn.net/shoppingstore/product/20230411135046_847cc224e2db4ea2b9b65ca0bd4ac26b.jpg',
      productImageOrigin: 'https://st.kakaocdn.net/shoppingstore/product/20230411135046_847cc224e2db4ea2b9b65ca0bd4ac26b.jpg',
      originalPrice: 26000,
      discountedPrice: 26000,
      discountRate: 0,
      alarmDisplaying: false,
      storeId: 35173,
      storeName: '주식회사 하림',
      storeDomain: 'halimall',
      storeProfileImage: 'https://st.kakaocdn.net/thumb/B350x350cw/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fstore%2F20210127100010_bfd50fe46f59495f965d1b3468164fac.jpg',
      new: false,
      linkPath: '/halimall/products/213097302?_=1682919001447&area=gdtr',
      storeLinkPath: '/halimall?area=gdtr',
      plusFriendSubscriberExclusive: false,
      farmer: false,
      deliveryFeeType: 'FREE',
      freeDelivery: true,
      reviewCount: 436,
      productPositivePercentage: 97,
      reviewContent: '화식으로도 만들어 먹이고, 카레에도\n닭가슴살 넣어서 먹었네요. 부드럽고 좋아요',
      imageRatio: 'SQUARE',
      displayedSaleStatus: 'ON_SALE',
      categoryId: '102104106103',
      categoryName: '생닭/부분육',
      hasAdditionalOptionPrice: true,
      profiles: [],
      totalSaleCount: 5330,
      trackId: '',
      userCount: 2429,
      alarm: false,
    },
    {
      productId: 58175263,
      productName: 'CJ 비비고 생선구이 5팩. 삼치/고등어/갈치 외',
      productImage: 'https://st.kakaocdn.net/shoppingstore/product/20230414090517_d2ef1cf3b85e44898be52545cb93e70e.png',
      productImageOrigin: 'https://st.kakaocdn.net/shoppingstore/product/20230414090517_d2ef1cf3b85e44898be52545cb93e70e.png',
      originalPrice: 22400,
      discountedPrice: 22400,
      discountRate: 0,
      alarmDisplaying: false,
      storeId: 1110,
      storeName: 'CJ제일제당 공식 스토어',
      storeDomain: 'cheiljedang',
      storeProfileImage: 'https://st.kakaocdn.net/thumb/B350x350cw/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fstore%2F20180430113102_b1c0a1a51b2c456191aa759e781d0f9f.png',
      new: false,
      linkPath: '/cheiljedang/products/58175263?_=1682919001447&area=gdtr',
      storeLinkPath: '/cheiljedang?area=gdtr',
      plusFriendSubscriberExclusive: false,
      farmer: false,
      deliveryFeeType: 'FREE',
      freeDelivery: true,
      reviewCount: 2797,
      productPositivePercentage: 95,
      reviewContent: '뼈없이 구워서 파셔서 생선 냄새없이  먹고싶을때 간단하게 먹을수있어서..\n 재구매의사 있습니다',
      imageRatio: 'SQUARE',
      displayedSaleStatus: 'ON_SALE',
      categoryId: '102100100100',
      categoryName: '냉장조리식품',
      hasAdditionalOptionPrice: true,
      profiles: [],
      totalSaleCount: 39840,
      trackId: '3472729087454890410',
      userCount: 2571,
      alarm: false,
    },
    {
      productId: 177036828,
      productName: '다이어트 안먹은걸로 30포. 체지방/콜레스테롤 관리',
      productImage: 'https://st.kakaocdn.net/shoppingstore/product/20230308144935_94a7aaea7a8c4609a2ccc306ecbc947c.jpg',
      productImageOrigin: 'https://st.kakaocdn.net/shoppingstore/product/20230308144935_94a7aaea7a8c4609a2ccc306ecbc947c.jpg',
      originalPrice: 129600,
      discountedPrice: 22800,
      discountRate: 82,
      alarmDisplaying: false,
      storeId: 2542,
      storeName: 'TCG헬스케어',
      storeDomain: 'sichimidduk',
      storeProfileImage: 'https://st.kakaocdn.net/thumb/B350x350cw/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fstore%2F20230203173744_6678291cff7444ccace5c302c6cefe70.png',
      new: false,
      linkPath: '/sichimidduk/products/177036828?_=1682919001447&area=gdtr',
      storeLinkPath: '/sichimidduk?area=gdtr',
      plusFriendSubscriberExclusive: false,
      farmer: false,
      deliveryFeeType: 'FREE',
      freeDelivery: true,
      reviewCount: 268,
      productPositivePercentage: 96,
      reviewContent: '식이섬유 먹고 배변활동  펀안해 졌어 편해요',
      imageRatio: 'SQUARE',
      displayedSaleStatus: 'ON_SALE',
      categoryId: '102105105107',
      categoryName: '기타 건강기능식품',
      hasAdditionalOptionPrice: true,
      profiles: [],
      totalSaleCount: 3915,
      trackId: '',
      userCount: 821,
      alarm: false,
    },
    {
      productId: 119114007,
      productName: '하동관 하동가곰탕600g 5팩. 80년 전통의맛 그대로',
      productImage: 'https://st.kakaocdn.net/shoppingstore/product/20230414105700_e03617e5108a4248aa0a2bcf751d2888.jpg',
      productImageOrigin: 'https://st.kakaocdn.net/shoppingstore/product/20230414105700_e03617e5108a4248aa0a2bcf751d2888.jpg',
      originalPrice: 43900,
      discountedPrice: 29900,
      discountRate: 31,
      alarmDisplaying: false,
      storeId: 27254,
      storeName: '마더킴',
      storeDomain: 'motherkim',
      storeProfileImage: 'https://st.kakaocdn.net/thumb/B350x350cw/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fstore%2F20210603171403_5baf345f719e4ee9aa59e2a3a86de125.jpg',
      new: false,
      linkPath: '/motherkim/products/119114007?_=1682919001447&area=gdtr',
      storeLinkPath: '/motherkim?area=gdtr',
      plusFriendSubscriberExclusive: false,
      farmer: false,
      deliveryFeeType: 'FREE',
      freeDelivery: true,
      reviewCount: 1500,
      productPositivePercentage: 95,
      reviewContent: '맛나요 좋아요',
      imageRatio: 'SQUARE',
      displayedSaleStatus: 'ON_SALE',
      categoryId: '102100110102',
      categoryName: '즉석국',
      hasAdditionalOptionPrice: true,
      profiles: [],
      totalSaleCount: 21948,
      trackId: '',
      userCount: 3604,
      alarm: false,
    },
    {
      productId: 240879562,
      productName: '수제 통삼겹 김치찜 600g 2팩. 넉넉하고 푸짐한 양',
      productImage: 'https://st.kakaocdn.net/shoppingstore/product/20230405155221_417a659fc90d4daa9a15eaf44dd44747.jpg',
      productImageOrigin: 'https://st.kakaocdn.net/shoppingstore/product/20230405155221_417a659fc90d4daa9a15eaf44dd44747.jpg',
      originalPrice: 20900,
      discountedPrice: 20900,
      discountRate: 0,
      alarmDisplaying: false,
      storeId: 53256,
      storeName: '욜로부로',
      storeDomain: 'yoloburo',
      storeProfileImage: 'https://st.kakaocdn.net/thumb/B350x350cw/?fname=https%3A%2F%2Fst.kakaocdn.net%2Fshoppingstore%2Fstore%2F20201106105314_d0d309354033405498343cfcc8f00a25.jpeg',
      new: false,
      linkPath: '/yoloburo/products/240879562?_=1682919001447&area=gdtr',
      storeLinkPath: '/yoloburo?area=gdtr',
      plusFriendSubscriberExclusive: false,
      farmer: false,
      deliveryFeeType: 'FREE',
      freeDelivery: true,
      reviewCount: 257,
      productPositivePercentage: 94,
      reviewContent: '배송 실수로 음식임에도 불구하고\n배송이 너무 오래 걸렸어요\n하지만 맛은 좋았습니다\n김치찜 본연의 맛에 충실했고 고기도 맛있습니다\n재구매의사 있어요',
      imageRatio: 'SQUARE',
      displayedSaleStatus: 'ON_SALE',
      categoryId: '102100100112',
      categoryName: '국/탕/찌개',
      hasAdditionalOptionPrice: true,
      profiles: [],
      totalSaleCount: 2959,
      trackId: '',
      userCount: 2833,
      alarm: false,
    },
  ],
};

const hotKeyword = {
  hotShoppingKeywords: [
    {
      shoppingKeywordId: 1906,
      hotKeyword: true,
      keywordName: '반스 스니커즈',
      landingUrl: '/detail/?productId=247087647',
    },
    {
      shoppingKeywordId: 1904,
      hotKeyword: true,
      keywordName: '목우촌',
      landingUrl: '/detail/?productId=247868049',
    },
    {
      shoppingKeywordId: 1903,
      hotKeyword: true,
      keywordName: '오메가3',
      landingUrl: '/detail/?productId=53209039',
    },
  ],
  commonShoppingKeywords: [
    {
      shoppingKeywordId: 1911,
      hotKeyword: false,
      keywordName: '청국장',
      landingUrl: '/detail/?productId=237319333',
    },
    {
      shoppingKeywordId: 1908,
      hotKeyword: false,
      keywordName: '꿀참외',
      landingUrl: '/detail/?productId=247834660',
    },
    {
      shoppingKeywordId: 1907,
      hotKeyword: false,
      keywordName: '지프',
      landingUrl: '/detail/?productId=64498390',
    },
    {
      shoppingKeywordId: 1900,
      hotKeyword: false,
      keywordName: '로봇청소기',
      landingUrl: '/detail/?productId=90836953',
    },
    {
      shoppingKeywordId: 1898,
      hotKeyword: false,
      keywordName: '고성능 와이퍼',
      landingUrl: '/detail/?productId=197627921',
    },
    {
      shoppingKeywordId: 1897,
      hotKeyword: false,
      keywordName: '오리온 인기스낵',
      landingUrl: '/detail/?productId=164308681',
    },
  ],
};

export { mainBanners, product, categoryGroups, reviewBestTalkeDeals, recommedStores, specialCard, hotKeyword, productDetail, productOptions };
